export const wayfinderData = {
  "36530071": {
    "id": "item_4062",
    "Last Name": "Higgins",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530095": {
    "id": "item_1925",
    "Last Name": "Dean",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530099": {
    "id": "item_16674",
    "Last Name": "Laguna",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530110": {
    "id": "item_3853",
    "Last Name": "Quigley",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530114": {
    "id": "item_3863",
    "Last Name": "Atkinson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530123": {
    "id": "item_12828",
    "Last Name": "Solar",
    "First Name": "Martha Ruby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530128": {
    "id": "item_29498",
    "Last Name": "Aparicio",
    "First Name": "Alfredo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530130": {
    "id": "item_3888",
    "Last Name": "Nguyen",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530131": {
    "id": "item_3892",
    "Last Name": "Lalwani",
    "First Name": "Dev",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530135": {
    "id": "item_14850",
    "Last Name": "Tsimnadis",
    "First Name": "Gaia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530145": {
    "id": "item_3927",
    "Last Name": "Edwards",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530146": {
    "id": "item_4090",
    "Last Name": "Ashcroft",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530151": {
    "id": "item_4100",
    "Last Name": "Chow",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530153": {
    "id": "item_15002",
    "Last Name": "Paff",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530156": {
    "id": "item_27701",
    "Last Name": "Mitchell",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530158": {
    "id": "item_15164",
    "Last Name": "Moore",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530161": {
    "id": "item_213",
    "Last Name": "Low",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530171": {
    "id": "item_2407",
    "Last Name": "Thompson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530182": {
    "id": "item_2394",
    "Last Name": "Johns",
    "First Name": "Zach",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530186": {
    "id": "item_171",
    "Last Name": "Singh",
    "First Name": "Rajinder",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530190": {
    "id": "item_342",
    "Last Name": "Pappas",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530191": {
    "id": "item_4377",
    "Last Name": "Clark",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530192": {
    "id": "item_212",
    "Last Name": "Headley",
    "First Name": "Harley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530203": {
    "id": "item_2266",
    "Last Name": "Smith",
    "First Name": "Abbey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530206": {
    "id": "item_15640",
    "Last Name": "Malin",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530212": {
    "id": "item_15665",
    "Last Name": "Gerlach",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530214": {
    "id": "item_4244",
    "Last Name": "Mclean",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530217": {
    "id": "item_4637",
    "Last Name": "skepper",
    "First Name": "cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530218": {
    "id": "item_365",
    "Last Name": "Chen",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530222": {
    "id": "item_4487",
    "Last Name": "Kwon",
    "First Name": "Donna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530223": {
    "id": "item_15661",
    "Last Name": "Heng",
    "First Name": "Micheaal Mao Ji",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530225": {
    "id": "item_4522",
    "Last Name": "Hill",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530228": {
    "id": "item_15633",
    "Last Name": "Chaff",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530230": {
    "id": "item_29811",
    "Last Name": "Fox",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530231": {
    "id": "item_2425",
    "Last Name": "McGrath",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530235": {
    "id": "item_13010",
    "Last Name": "O'Flynn",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530243": {
    "id": "item_2350",
    "Last Name": "Mort",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530249": {
    "id": "item_15398",
    "Last Name": "Cooper",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530254": {
    "id": "item_2180",
    "Last Name": "Cohen",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530257": {
    "id": "item_27696",
    "Last Name": "Sugihardjo",
    "First Name": "Sugihardjo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530260": {
    "id": "item_3960",
    "Last Name": "Panta",
    "First Name": "Adhish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530272": {
    "id": "item_3852",
    "Last Name": "Wellfare",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530273": {
    "id": "item_29735",
    "Last Name": "Dmello",
    "First Name": "Jared",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530275": {
    "id": "item_47",
    "Last Name": "Byrne",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530281": {
    "id": "item_15755",
    "Last Name": "Jobberns",
    "First Name": "Erica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530287": {
    "id": "item_14976",
    "Last Name": "Riley",
    "First Name": "Ed",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530288": {
    "id": "item_14928",
    "Last Name": "Daly",
    "First Name": "Eoin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530290": {
    "id": "item_2035",
    "Last Name": "McDonnell",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530294": {
    "id": "item_12948",
    "Last Name": "Matthies",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530295": {
    "id": "item_27636",
    "Last Name": "Callery",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530300": {
    "id": "item_1965",
    "Last Name": "Button",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530302": {
    "id": "item_15041",
    "Last Name": "Brooke",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530303": {
    "id": "item_15880",
    "Last Name": "Sipple",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530304": {
    "id": "item_2028",
    "Last Name": "Grahame",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530305": {
    "id": "item_2451",
    "Last Name": "Nieuwenhuis",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530311": {
    "id": "item_126",
    "Last Name": "Oladapo",
    "First Name": "Tobi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530312": {
    "id": "item_14824",
    "Last Name": "Wakeford",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530313": {
    "id": "item_3979",
    "Last Name": "Wainwright",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530318": {
    "id": "item_84",
    "Last Name": "Loon",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530326": {
    "id": "item_2045",
    "Last Name": "Stace",
    "First Name": "Sara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530329": {
    "id": "item_4032",
    "Last Name": "Marshall",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530330": {
    "id": "item_15086",
    "Last Name": "Butler",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530332": {
    "id": "item_2054",
    "Last Name": "Richardson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530337": {
    "id": "item_492",
    "Last Name": "Martinu",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530339": {
    "id": "item_2071",
    "Last Name": "Siu",
    "First Name": "Bernie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530343": {
    "id": "item_15115",
    "Last Name": "Fisher",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530349": {
    "id": "item_15685",
    "Last Name": "Cooling",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530355": {
    "id": "item_15285",
    "Last Name": "Verney",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530360": {
    "id": "item_2131",
    "Last Name": "Zeal",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530364": {
    "id": "item_508",
    "Last Name": "Moran",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530365": {
    "id": "item_4151",
    "Last Name": "Green",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530370": {
    "id": "item_4675",
    "Last Name": "Harling",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530373": {
    "id": "item_15235",
    "Last Name": "Kinghorn",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530375": {
    "id": "item_4493",
    "Last Name": "Grimshaw",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530379": {
    "id": "item_15778",
    "Last Name": "Braddon",
    "First Name": "Ann",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530383": {
    "id": "item_2121",
    "Last Name": "Wilson",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530392": {
    "id": "item_15276",
    "Last Name": "Lamb",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530396": {
    "id": "item_27745",
    "Last Name": "Dizon",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530403": {
    "id": "item_4264",
    "Last Name": "Mistri",
    "First Name": "Nishal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530405": {
    "id": "item_15790",
    "Last Name": "Archer",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530406": {
    "id": "item_16673",
    "Last Name": "Zhang",
    "First Name": "Jifan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530413": {
    "id": "item_15482",
    "Last Name": "Queiroz",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530416": {
    "id": "item_27812",
    "Last Name": "Dickie",
    "First Name": "Kayla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530418": {
    "id": "item_2356",
    "Last Name": "IP",
    "First Name": "BENJAMIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530421": {
    "id": "item_4459",
    "Last Name": "Zhang",
    "First Name": "ShunYao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530426": {
    "id": "item_15591",
    "Last Name": "WATANANGURA",
    "First Name": "JASON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530429": {
    "id": "item_4582",
    "Last Name": "Taylor",
    "First Name": "Harley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530431": {
    "id": "item_2218",
    "Last Name": "Lapid",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530437": {
    "id": "item_2382",
    "Last Name": "Jones",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530440": {
    "id": "item_2345",
    "Last Name": "Nguyen",
    "First Name": "Ken",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530444": {
    "id": "item_2364",
    "Last Name": "Chen",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530445": {
    "id": "item_2258",
    "Last Name": "Hocking",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530448": {
    "id": "item_4576",
    "Last Name": "Lam",
    "First Name": "Tsz Kiu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530449": {
    "id": "item_422",
    "Last Name": "Dous",
    "First Name": "Danyal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530451": {
    "id": "item_420",
    "Last Name": "Colebatch",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530457": {
    "id": "item_418",
    "Last Name": "Maibenko",
    "First Name": "Ihor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530458": {
    "id": "item_433",
    "Last Name": "Rotenberg",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530459": {
    "id": "item_2327",
    "Last Name": "Percy",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530461": {
    "id": "item_15907",
    "Last Name": "Brooks",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530463": {
    "id": "item_424",
    "Last Name": "Hunter",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530464": {
    "id": "item_421",
    "Last Name": "Farrelly",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530465": {
    "id": "item_4495",
    "Last Name": "KARIM",
    "First Name": "MICKY",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530467": {
    "id": "item_29781",
    "Last Name": "Pike",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530470": {
    "id": "item_423",
    "Last Name": "Gow",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530471": {
    "id": "item_13016",
    "Last Name": "Bywaters",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530481": {
    "id": "item_13008",
    "Last Name": "Mamo",
    "First Name": "Zachariah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530487": {
    "id": "item_15788",
    "Last Name": "Buhagiar",
    "First Name": "Rick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530508": {
    "id": "item_27826",
    "Last Name": "Riley",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530509": {
    "id": "item_419",
    "Last Name": "Cowling",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530511": {
    "id": "item_29778",
    "Last Name": "BRICKMAN",
    "First Name": "KATHERINE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530513": {
    "id": "item_16672",
    "Last Name": "Korbel",
    "First Name": "Kym",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530524": {
    "id": "item_13012",
    "Last Name": "Kowalick",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530529": {
    "id": "item_417",
    "Last Name": "Stadnik",
    "First Name": "Alice",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530533": {
    "id": "item_445",
    "Last Name": "Yan",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530534": {
    "id": "item_444",
    "Last Name": "Bui",
    "First Name": "Quang Cuong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530537": {
    "id": "item_27835",
    "Last Name": "Haavisto",
    "First Name": "Benny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530540": {
    "id": "item_2379",
    "Last Name": "Campbell",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530543": {
    "id": "item_16664",
    "Last Name": "Le",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530545": {
    "id": "item_15785",
    "Last Name": "Spotswood",
    "First Name": "Lutana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530549": {
    "id": "item_15786",
    "Last Name": "Manion",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530553": {
    "id": "item_4545",
    "Last Name": "taylor",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530554": {
    "id": "item_15747",
    "Last Name": "lee",
    "First Name": "sunny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530556": {
    "id": "item_4546",
    "Last Name": "Rooney",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530558": {
    "id": "item_2360",
    "Last Name": "Murphy",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530563": {
    "id": "item_16667",
    "Last Name": "AU",
    "First Name": "GREGORY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530565": {
    "id": "item_16666",
    "Last Name": "Rossendell",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530566": {
    "id": "item_27892",
    "Last Name": "Chapman",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530567": {
    "id": "item_4541",
    "Last Name": "Hwang",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530568": {
    "id": "item_2338",
    "Last Name": "Dunn",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530570": {
    "id": "item_29776",
    "Last Name": "Cubillos",
    "First Name": "Diana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530571": {
    "id": "item_15737",
    "Last Name": "LIANG",
    "First Name": "luJing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530575": {
    "id": "item_15741",
    "Last Name": "Murugesan",
    "First Name": "Ashokkumar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530579": {
    "id": "item_15906",
    "Last Name": "Clement",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530587": {
    "id": "item_4535",
    "Last Name": "Gerard",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530588": {
    "id": "item_16665",
    "Last Name": "Sipple",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530589": {
    "id": "item_15740",
    "Last Name": "Oliveira",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530593": {
    "id": "item_27828",
    "Last Name": "Van Acquoy",
    "First Name": "Monique",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530594": {
    "id": "item_15775",
    "Last Name": "HE",
    "First Name": "Qiyang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530604": {
    "id": "item_506",
    "Last Name": "Davis",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530607": {
    "id": "item_2056",
    "Last Name": "Enea",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530614": {
    "id": "item_4051",
    "Last Name": "Wu",
    "First Name": "Zhengke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530618": {
    "id": "item_15783",
    "Last Name": "Whitehead",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530620": {
    "id": "item_4538",
    "Last Name": "McGraw",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530622": {
    "id": "item_15781",
    "Last Name": "Hudiono",
    "First Name": "Novia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530625": {
    "id": "item_4689",
    "Last Name": "Morrissey",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530632": {
    "id": "item_15721",
    "Last Name": "Basistei",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530633": {
    "id": "item_29775",
    "Last Name": "Shashindran",
    "First Name": "Mahesh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530634": {
    "id": "item_15780",
    "Last Name": "OÕMalley",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530635": {
    "id": "item_15725",
    "Last Name": "Zapanta",
    "First Name": "Reden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530636": {
    "id": "item_13001",
    "Last Name": "Sutanto",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530639": {
    "id": "item_4533",
    "Last Name": "Shepherd",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530651": {
    "id": "item_15729",
    "Last Name": "Kuo",
    "First Name": "Roger",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530653": {
    "id": "item_15728",
    "Last Name": "Lazarus",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530666": {
    "id": "item_15719",
    "Last Name": "Wong",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530671": {
    "id": "item_4575",
    "Last Name": "Ohlmus",
    "First Name": "Dale",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530674": {
    "id": "item_16663",
    "Last Name": "Cosgrove",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530676": {
    "id": "item_412",
    "Last Name": "Lo",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530678": {
    "id": "item_13000",
    "Last Name": "Seol",
    "First Name": "Yuwan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530679": {
    "id": "item_4527",
    "Last Name": "Jiang",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530680": {
    "id": "item_15659",
    "Last Name": "Singh",
    "First Name": "Karam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530687": {
    "id": "item_29786",
    "Last Name": "Damasco",
    "First Name": "Catalino",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530688": {
    "id": "item_2377",
    "Last Name": "Brooker",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530691": {
    "id": "item_15711",
    "Last Name": "Huh",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530693": {
    "id": "item_4529",
    "Last Name": "Hwang",
    "First Name": "Euh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530694": {
    "id": "item_405",
    "Last Name": "Keane",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530699": {
    "id": "item_393",
    "Last Name": "Reynolds",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530700": {
    "id": "item_406",
    "Last Name": "Rigney",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530703": {
    "id": "item_2341",
    "Last Name": "Thomas",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530705": {
    "id": "item_15713",
    "Last Name": "Kumar",
    "First Name": "Naveen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530707": {
    "id": "item_409",
    "Last Name": "Mulcahy",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530708": {
    "id": "item_438",
    "Last Name": "Bai",
    "First Name": "Lin Jie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530709": {
    "id": "item_4526",
    "Last Name": "Corsini",
    "First Name": "Dana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530718": {
    "id": "item_2335",
    "Last Name": "Lim Lo Suy",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530724": {
    "id": "item_400",
    "Last Name": "Breen",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530727": {
    "id": "item_402",
    "Last Name": "Beale",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530736": {
    "id": "item_27824",
    "Last Name": "Xerri",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530737": {
    "id": "item_15709",
    "Last Name": "Stevens",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530738": {
    "id": "item_29768",
    "Last Name": "Macrae",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530742": {
    "id": "item_15706",
    "Last Name": "Dorjgotov",
    "First Name": "Oyungerel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530743": {
    "id": "item_15102",
    "Last Name": "Ding",
    "First Name": "Jidong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530744": {
    "id": "item_505",
    "Last Name": "Christofersen",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530745": {
    "id": "item_4516",
    "Last Name": "Roy",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530746": {
    "id": "item_437",
    "Last Name": "Erasmus",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530747": {
    "id": "item_4574",
    "Last Name": "Cantwell",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530755": {
    "id": "item_15705",
    "Last Name": "Rizzuto",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530759": {
    "id": "item_15703",
    "Last Name": "Klajman",
    "First Name": "Surinya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530761": {
    "id": "item_399",
    "Last Name": "Jollye",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530762": {
    "id": "item_4521",
    "Last Name": "Whitehead",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530764": {
    "id": "item_392",
    "Last Name": "Redman",
    "First Name": "Tayne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530768": {
    "id": "item_15701",
    "Last Name": "moussan",
    "First Name": "caroline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530770": {
    "id": "item_2334",
    "Last Name": "Sterjovski",
    "First Name": "Bozin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530776": {
    "id": "item_427",
    "Last Name": "Zhu",
    "First Name": "Feng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530777": {
    "id": "item_15774",
    "Last Name": "Konisberry",
    "First Name": "Zahra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530783": {
    "id": "item_15697",
    "Last Name": "Pope",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530791": {
    "id": "item_4565",
    "Last Name": "Guan",
    "First Name": "Tong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530798": {
    "id": "item_4514",
    "Last Name": "Grima",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530800": {
    "id": "item_2333",
    "Last Name": "Glover",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530801": {
    "id": "item_15771",
    "Last Name": "Lucas",
    "First Name": "Daisy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530809": {
    "id": "item_4511",
    "Last Name": "Tuakore",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530812": {
    "id": "item_27843",
    "Last Name": "Massari",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530814": {
    "id": "item_29832",
    "Last Name": "Scioscia",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530815": {
    "id": "item_15773",
    "Last Name": "Baker",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530816": {
    "id": "item_432",
    "Last Name": "Lukic",
    "First Name": "Anton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530817": {
    "id": "item_434",
    "Last Name": "Valenzuela",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530820": {
    "id": "item_2330",
    "Last Name": "Bullman",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530822": {
    "id": "item_27845",
    "Last Name": "Choi",
    "First Name": "Claff",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530841": {
    "id": "item_396",
    "Last Name": "Lesmana",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530846": {
    "id": "item_12986",
    "Last Name": "Burnett",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530847": {
    "id": "item_4049",
    "Last Name": "Patel",
    "First Name": "Rosanna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530849": {
    "id": "item_15762",
    "Last Name": "Kansas",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530855": {
    "id": "item_15760",
    "Last Name": "McILWAIN",
    "First Name": "ANDREW",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530860": {
    "id": "item_15684",
    "Last Name": "Coope-Dempster",
    "First Name": "Abi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530865": {
    "id": "item_15768",
    "Last Name": "Lam",
    "First Name": "Kin San",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530866": {
    "id": "item_27820",
    "Last Name": "Chan",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530867": {
    "id": "item_27841",
    "Last Name": "Trigg",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530871": {
    "id": "item_15692",
    "Last Name": "Pedda Ganganna Gari",
    "First Name": "Jaya prakash reddy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530878": {
    "id": "item_15686",
    "Last Name": "Li",
    "First Name": "Xiaoxuan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530880": {
    "id": "item_2373",
    "Last Name": "Batoon",
    "First Name": "Naldrin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530882": {
    "id": "item_15689",
    "Last Name": "Lee",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530883": {
    "id": "item_27816",
    "Last Name": "Carpio",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530887": {
    "id": "item_390",
    "Last Name": "Newton",
    "First Name": "Bex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530890": {
    "id": "item_2328",
    "Last Name": "Cardenas",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530891": {
    "id": "item_29754",
    "Last Name": "Chitty",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530892": {
    "id": "item_2371",
    "Last Name": "Oconnor",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530893": {
    "id": "item_4504",
    "Last Name": "Zeppieri",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530898": {
    "id": "item_15662",
    "Last Name": "Reece",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530899": {
    "id": "item_384",
    "Last Name": "Spears",
    "First Name": "Sachiko",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530911": {
    "id": "item_29784",
    "Last Name": "Klein",
    "First Name": "Evelyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530918": {
    "id": "item_29761",
    "Last Name": "Lowe",
    "First Name": "Colleen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530921": {
    "id": "item_15681",
    "Last Name": "Xu",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530923": {
    "id": "item_12989",
    "Last Name": "Leighton",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530924": {
    "id": "item_15683",
    "Last Name": "Andreasen",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530927": {
    "id": "item_139",
    "Last Name": "Toohey",
    "First Name": "Adrienne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530928": {
    "id": "item_12991",
    "Last Name": "Lian",
    "First Name": "Jotham",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530930": {
    "id": "item_27818",
    "Last Name": "Watson",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530933": {
    "id": "item_4497",
    "Last Name": "Giles",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530934": {
    "id": "item_15680",
    "Last Name": "Tang",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530935": {
    "id": "item_29757",
    "Last Name": "Woods",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530936": {
    "id": "item_4503",
    "Last Name": "Zheng",
    "First Name": "Lingge",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530938": {
    "id": "item_15759",
    "Last Name": "Dernee",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530941": {
    "id": "item_15101",
    "Last Name": "Zimmer",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530942": {
    "id": "item_15677",
    "Last Name": "stevens",
    "First Name": "Myles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530943": {
    "id": "item_2321",
    "Last Name": "Hicks",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530946": {
    "id": "item_29758",
    "Last Name": "Zhang",
    "First Name": "Lijun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530947": {
    "id": "item_15674",
    "Last Name": "Mahfouz",
    "First Name": "Fawaz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530948": {
    "id": "item_428",
    "Last Name": "Carter",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530951": {
    "id": "item_27811",
    "Last Name": "Mejia",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530955": {
    "id": "item_4688",
    "Last Name": "Maher",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530956": {
    "id": "item_29831",
    "Last Name": "Gray",
    "First Name": "Kerrie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530961": {
    "id": "item_4559",
    "Last Name": "Khan",
    "First Name": "Rash",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530964": {
    "id": "item_15757",
    "Last Name": "Sweeney",
    "First Name": "Caleb",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530966": {
    "id": "item_386",
    "Last Name": "Estoque",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530969": {
    "id": "item_16661",
    "Last Name": "Primmer",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530971": {
    "id": "item_2315",
    "Last Name": "Hunter",
    "First Name": "Lexie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530982": {
    "id": "item_377",
    "Last Name": "Buchwald",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530983": {
    "id": "item_4552",
    "Last Name": "Kelaart",
    "First Name": "Kalon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530989": {
    "id": "item_371",
    "Last Name": "Niklison",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530991": {
    "id": "item_504",
    "Last Name": "Wynn",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530997": {
    "id": "item_4482",
    "Last Name": "MARANIELLO",
    "First Name": "LIVIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531001": {
    "id": "item_2316",
    "Last Name": "van Veen",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531002": {
    "id": "item_2366",
    "Last Name": "Bejcek",
    "First Name": "Jan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531004": {
    "id": "item_15624",
    "Last Name": "Kraihan",
    "First Name": "Chanoksuda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531007": {
    "id": "item_15668",
    "Last Name": "Lagat",
    "First Name": "Christian Pons",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531008": {
    "id": "item_15754",
    "Last Name": "Hockey",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531012": {
    "id": "item_382",
    "Last Name": "Rubio",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531018": {
    "id": "item_2319",
    "Last Name": "da Silva Knob",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531019": {
    "id": "item_27810",
    "Last Name": "Clulow",
    "First Name": "Roger",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531021": {
    "id": "item_15756",
    "Last Name": "Coltrona",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531026": {
    "id": "item_12985",
    "Last Name": "Kelly",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531030": {
    "id": "item_15667",
    "Last Name": "Saxon",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531033": {
    "id": "item_426",
    "Last Name": "Sun",
    "First Name": "Bo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531035": {
    "id": "item_16662",
    "Last Name": "Kurtzer",
    "First Name": "Narelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531036": {
    "id": "item_4475",
    "Last Name": "Moore",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531038": {
    "id": "item_4483",
    "Last Name": "Colla",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531049": {
    "id": "item_2367",
    "Last Name": "Sibenaler",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531054": {
    "id": "item_15660",
    "Last Name": "Liu",
    "First Name": "Jiyuan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531055": {
    "id": "item_374",
    "Last Name": "Plummer",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531058": {
    "id": "item_4687",
    "Last Name": "OÕShea",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531059": {
    "id": "item_15655",
    "Last Name": "Gholami",
    "First Name": "Massoud",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531062": {
    "id": "item_12984",
    "Last Name": "STEEL",
    "First Name": "SAM",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531066": {
    "id": "item_29753",
    "Last Name": "CHEN",
    "First Name": "TING-TSE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531071": {
    "id": "item_2365",
    "Last Name": "Stark",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531084": {
    "id": "item_29747",
    "Last Name": "Li",
    "First Name": "Gaoyu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531086": {
    "id": "item_4472",
    "Last Name": "DU",
    "First Name": "YUQING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531087": {
    "id": "item_372",
    "Last Name": "Quinless",
    "First Name": "Rory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531089": {
    "id": "item_2312",
    "Last Name": "Skelton",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531092": {
    "id": "item_4476",
    "Last Name": "Guo",
    "First Name": "Lulin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531093": {
    "id": "item_2448",
    "Last Name": "Duda",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531095": {
    "id": "item_15098",
    "Last Name": "Xiu",
    "First Name": "Xia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531099": {
    "id": "item_2362",
    "Last Name": "Liu",
    "First Name": "Jian Wei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531105": {
    "id": "item_15656",
    "Last Name": "Protheroe",
    "First Name": "Carron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531111": {
    "id": "item_16660",
    "Last Name": "Chan",
    "First Name": "Angelica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531113": {
    "id": "item_502",
    "Last Name": "Carlson",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531118": {
    "id": "item_4686",
    "Last Name": "Roth",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531119": {
    "id": "item_503",
    "Last Name": "Roche",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531123": {
    "id": "item_15652",
    "Last Name": "MAINHARDT",
    "First Name": "MARIA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531125": {
    "id": "item_366",
    "Last Name": "Drew",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531129": {
    "id": "item_368",
    "Last Name": "Clark",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531138": {
    "id": "item_29749",
    "Last Name": "Zhao",
    "First Name": "Meng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531143": {
    "id": "item_29748",
    "Last Name": "Martin",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531144": {
    "id": "item_12980",
    "Last Name": "Bastow",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531149": {
    "id": "item_15627",
    "Last Name": "Kobayashi",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531150": {
    "id": "item_4685",
    "Last Name": "Sykes",
    "First Name": "Leon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531152": {
    "id": "item_12977",
    "Last Name": "Tudjman",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531154": {
    "id": "item_27795",
    "Last Name": "Legaspi",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531168": {
    "id": "item_501",
    "Last Name": "Blunden",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531174": {
    "id": "item_15751",
    "Last Name": "Colonna",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531176": {
    "id": "item_29830",
    "Last Name": "Polo",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531179": {
    "id": "item_15750",
    "Last Name": "Davidson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531180": {
    "id": "item_12974",
    "Last Name": "Muro",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531182": {
    "id": "item_4684",
    "Last Name": "Fittler",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531185": {
    "id": "item_15642",
    "Last Name": "McCaffrey",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531192": {
    "id": "item_15636",
    "Last Name": "Waga",
    "First Name": "Mahoko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531196": {
    "id": "item_4549",
    "Last Name": "Qiang",
    "First Name": "Li",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531200": {
    "id": "item_15643",
    "Last Name": "Yalden",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531203": {
    "id": "item_29746",
    "Last Name": "Singh",
    "First Name": "Ivneet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531204": {
    "id": "item_2304",
    "Last Name": "Kha",
    "First Name": "Dang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531205": {
    "id": "item_29838",
    "Last Name": "Reynolds",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531208": {
    "id": "item_15639",
    "Last Name": "Harris",
    "First Name": "Peggy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531211": {
    "id": "item_363",
    "Last Name": "Leung",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531216": {
    "id": "item_15637",
    "Last Name": "Savio",
    "First Name": "Sol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531218": {
    "id": "item_2447",
    "Last Name": "Heaney",
    "First Name": "Eloise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531220": {
    "id": "item_361",
    "Last Name": "Tostevin",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531224": {
    "id": "item_16659",
    "Last Name": "Nocente",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531227": {
    "id": "item_2303",
    "Last Name": "Yang",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531228": {
    "id": "item_4466",
    "Last Name": "Mathas",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531231": {
    "id": "item_15749",
    "Last Name": "Mcconnell",
    "First Name": "Dominique",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531233": {
    "id": "item_4683",
    "Last Name": "McPherson",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531237": {
    "id": "item_4548",
    "Last Name": "Gonzaga",
    "First Name": "Ryan Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531242": {
    "id": "item_2361",
    "Last Name": "Smith",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531245": {
    "id": "item_359",
    "Last Name": "Chesworth",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531246": {
    "id": "item_15630",
    "Last Name": "Linde",
    "First Name": "Talia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531247": {
    "id": "item_4550",
    "Last Name": "Pretzler",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531249": {
    "id": "item_2299",
    "Last Name": "Kaplan",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531252": {
    "id": "item_360",
    "Last Name": "Fogale",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531253": {
    "id": "item_2450",
    "Last Name": "Bubb",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531254": {
    "id": "item_15626",
    "Last Name": "Chan",
    "First Name": "Humphrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531256": {
    "id": "item_500",
    "Last Name": "Chilvers",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531266": {
    "id": "item_2292",
    "Last Name": "Van der Zel",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531270": {
    "id": "item_4453",
    "Last Name": "Feliciano",
    "First Name": "Luiscarlo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531272": {
    "id": "item_16671",
    "Last Name": "Tancred",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531274": {
    "id": "item_15743",
    "Last Name": "Latina",
    "First Name": "Liberty",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531275": {
    "id": "item_499",
    "Last Name": "Young",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531277": {
    "id": "item_27677",
    "Last Name": "Mander",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531284": {
    "id": "item_27833",
    "Last Name": "Dickie",
    "First Name": "Kez",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531299": {
    "id": "item_12973",
    "Last Name": "Craig",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531302": {
    "id": "item_15746",
    "Last Name": "L Barrientos",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531304": {
    "id": "item_15623",
    "Last Name": "Burke",
    "First Name": "Clara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531307": {
    "id": "item_4394",
    "Last Name": "Mitra",
    "First Name": "Viraj",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531310": {
    "id": "item_2446",
    "Last Name": "Turner",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531315": {
    "id": "item_15614",
    "Last Name": "Nguyen",
    "First Name": "Minh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531325": {
    "id": "item_15619",
    "Last Name": "Tesoriero",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531336": {
    "id": "item_15611",
    "Last Name": "Peisley",
    "First Name": "Barry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531340": {
    "id": "item_2285",
    "Last Name": "Condœn",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531341": {
    "id": "item_355",
    "Last Name": "McCann",
    "First Name": "Joey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531348": {
    "id": "item_4446",
    "Last Name": "Sridhar",
    "First Name": "Nikhil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531349": {
    "id": "item_4445",
    "Last Name": "Zhu",
    "First Name": "Minjie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531352": {
    "id": "item_4444",
    "Last Name": "Cuneo",
    "First Name": "Riordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531354": {
    "id": "item_2289",
    "Last Name": "Walsh",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531362": {
    "id": "item_2358",
    "Last Name": "McCormack",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531366": {
    "id": "item_16732",
    "Last Name": "Tran",
    "First Name": "Le Tri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531368": {
    "id": "item_4447",
    "Last Name": "Brogden",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531371": {
    "id": "item_416",
    "Last Name": "Shevchenko",
    "First Name": "Mariia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531372": {
    "id": "item_4046",
    "Last Name": "Suksudaj",
    "First Name": "Parin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531374": {
    "id": "item_4443",
    "Last Name": "Kung",
    "First Name": "Beverly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531376": {
    "id": "item_2052",
    "Last Name": "Pankhurst",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531385": {
    "id": "item_2287",
    "Last Name": "Jayamanne",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531394": {
    "id": "item_27796",
    "Last Name": "Ajaj",
    "First Name": "Nazlia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531397": {
    "id": "item_15594",
    "Last Name": "Jeremy",
    "First Name": "Louis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531398": {
    "id": "item_15600",
    "Last Name": "Bulloch",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531399": {
    "id": "item_2284",
    "Last Name": "Fisher",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531401": {
    "id": "item_15606",
    "Last Name": "Reilly",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531404": {
    "id": "item_27793",
    "Last Name": "Deacon",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531407": {
    "id": "item_352",
    "Last Name": "Mineo",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531409": {
    "id": "item_15578",
    "Last Name": "Cheng",
    "First Name": "Christina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531414": {
    "id": "item_4436",
    "Last Name": "Bird",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531417": {
    "id": "item_4478",
    "Last Name": "Cutting",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531418": {
    "id": "item_27831",
    "Last Name": "Konisberry",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531419": {
    "id": "item_4438",
    "Last Name": "Driscoll",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531422": {
    "id": "item_4439",
    "Last Name": "Southerton",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531424": {
    "id": "item_15096",
    "Last Name": "Blotner",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531427": {
    "id": "item_351",
    "Last Name": "Finn",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531431": {
    "id": "item_4435",
    "Last Name": "Rands",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531441": {
    "id": "item_15603",
    "Last Name": "Kehler",
    "First Name": "Cheyanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531444": {
    "id": "item_27791",
    "Last Name": "Hughes",
    "First Name": "Mayuri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531445": {
    "id": "item_2257",
    "Last Name": "Byrne",
    "First Name": "Siobhan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531447": {
    "id": "item_4427",
    "Last Name": "Hawli",
    "First Name": "Hussein",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531448": {
    "id": "item_4395",
    "Last Name": "Tait",
    "First Name": "Fin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531450": {
    "id": "item_4544",
    "Last Name": "McEwan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531454": {
    "id": "item_15588",
    "Last Name": "Hulls",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531460": {
    "id": "item_15590",
    "Last Name": "De La Mare",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531462": {
    "id": "item_4540",
    "Last Name": "Harkins",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531465": {
    "id": "item_27829",
    "Last Name": "Farrugia",
    "First Name": "Candice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531467": {
    "id": "item_29837",
    "Last Name": "Wang",
    "First Name": "Yongxin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531468": {
    "id": "item_4431",
    "Last Name": "Nabong",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531471": {
    "id": "item_29741",
    "Last Name": "TRUONG",
    "First Name": "MINH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531477": {
    "id": "item_15738",
    "Last Name": "Su",
    "First Name": "Shaohua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531480": {
    "id": "item_350",
    "Last Name": "Hole",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531484": {
    "id": "item_13007",
    "Last Name": "Ong",
    "First Name": "Kheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531485": {
    "id": "item_4432",
    "Last Name": "Vasilas",
    "First Name": "Hiroko",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531486": {
    "id": "item_4429",
    "Last Name": "Wainer",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531490": {
    "id": "item_27789",
    "Last Name": "Lopez",
    "First Name": "Lorelee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531492": {
    "id": "item_4434",
    "Last Name": "Bruckert",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531495": {
    "id": "item_2279",
    "Last Name": "Webb",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531502": {
    "id": "item_13006",
    "Last Name": "Martin",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531507": {
    "id": "item_15589",
    "Last Name": "Alvaro",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531508": {
    "id": "item_15584",
    "Last Name": "Gan",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531513": {
    "id": "item_4428",
    "Last Name": "Oconnor",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531515": {
    "id": "item_4426",
    "Last Name": "Ledesma",
    "First Name": "Krystle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531516": {
    "id": "item_415",
    "Last Name": "Jittrong",
    "First Name": "Anirout",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531519": {
    "id": "item_12969",
    "Last Name": "Tran",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531522": {
    "id": "item_15585",
    "Last Name": "Le Hanie",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531525": {
    "id": "item_4419",
    "Last Name": "Cancio",
    "First Name": "Miguel Lorenzo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531526": {
    "id": "item_2278",
    "Last Name": "Gibbons",
    "First Name": "Elijah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531533": {
    "id": "item_15586",
    "Last Name": "Smith",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531534": {
    "id": "item_2276",
    "Last Name": "QIU",
    "First Name": "ZHONGCHHU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531539": {
    "id": "item_4044",
    "Last Name": "Leong",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531544": {
    "id": "item_4418",
    "Last Name": "Davies",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531546": {
    "id": "item_12967",
    "Last Name": "Fasullo",
    "First Name": "Annette",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531553": {
    "id": "item_4420",
    "Last Name": "Dawood",
    "First Name": "Allen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531563": {
    "id": "item_15579",
    "Last Name": "Mitchell",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531565": {
    "id": "item_4416",
    "Last Name": "GUPTA",
    "First Name": "Amit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531579": {
    "id": "item_15576",
    "Last Name": "Dreverman",
    "First Name": "Jon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531583": {
    "id": "item_12965",
    "Last Name": "Tan",
    "First Name": "Ren Xuan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531595": {
    "id": "item_15575",
    "Last Name": "Baysic",
    "First Name": "Venice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531605": {
    "id": "item_341",
    "Last Name": "Ngo",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531607": {
    "id": "item_4534",
    "Last Name": "Khatree",
    "First Name": "Raeesa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531612": {
    "id": "item_2445",
    "Last Name": "Adams",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531615": {
    "id": "item_2274",
    "Last Name": "Li",
    "First Name": "Wing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531620": {
    "id": "item_15561",
    "Last Name": "Tanpian",
    "First Name": "Lilian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531621": {
    "id": "item_2351",
    "Last Name": "Napier",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531624": {
    "id": "item_2352",
    "Last Name": "Luo",
    "First Name": "Min",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531632": {
    "id": "item_27788",
    "Last Name": "Roxas",
    "First Name": "Ana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531634": {
    "id": "item_15572",
    "Last Name": "Liu",
    "First Name": "Chao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531638": {
    "id": "item_4408",
    "Last Name": "Wang",
    "First Name": "Xiaona",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531639": {
    "id": "item_15569",
    "Last Name": "Bennett",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531640": {
    "id": "item_4410",
    "Last Name": "Shi",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531641": {
    "id": "item_15091",
    "Last Name": "Waller",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531644": {
    "id": "item_2271",
    "Last Name": "Young",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531654": {
    "id": "item_4682",
    "Last Name": "Dunn",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531655": {
    "id": "item_335",
    "Last Name": "Heavener",
    "First Name": "Norman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531659": {
    "id": "item_2253",
    "Last Name": "Friend",
    "First Name": "Rowan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531661": {
    "id": "item_15565",
    "Last Name": "Xing",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531662": {
    "id": "item_338",
    "Last Name": "Tregonning",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531668": {
    "id": "item_15566",
    "Last Name": "Condon",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531674": {
    "id": "item_27675",
    "Last Name": "Yusepeng JR",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531676": {
    "id": "item_334",
    "Last Name": "Edwards",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531689": {
    "id": "item_15563",
    "Last Name": "Boychuk",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531692": {
    "id": "item_2256",
    "Last Name": "Garner",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531695": {
    "id": "item_2265",
    "Last Name": "Cox",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531696": {
    "id": "item_4402",
    "Last Name": "Scheibling",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531698": {
    "id": "item_414",
    "Last Name": "Trinca",
    "First Name": "Erin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531703": {
    "id": "item_27785",
    "Last Name": "Lansdowne",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531712": {
    "id": "item_15560",
    "Last Name": "Hu",
    "First Name": "Yifan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531713": {
    "id": "item_13005",
    "Last Name": "TSANG",
    "First Name": "KAI HUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531716": {
    "id": "item_4388",
    "Last Name": "Culpin",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531717": {
    "id": "item_4392",
    "Last Name": "Hannigan",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531723": {
    "id": "item_2349",
    "Last Name": "Walker",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531725": {
    "id": "item_326",
    "Last Name": "Ap",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531726": {
    "id": "item_2262",
    "Last Name": "Lee",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531727": {
    "id": "item_15733",
    "Last Name": "Petersen",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531733": {
    "id": "item_15556",
    "Last Name": "Robertson",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531738": {
    "id": "item_4397",
    "Last Name": "Toose",
    "First Name": "Nic",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531739": {
    "id": "item_136",
    "Last Name": "Kowdley",
    "First Name": "Neel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531741": {
    "id": "item_2259",
    "Last Name": "Casper-Richardson",
    "First Name": "Drew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531742": {
    "id": "item_2261",
    "Last Name": "Bradbury",
    "First Name": "Augustus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531746": {
    "id": "item_4681",
    "Last Name": "Cooper",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531757": {
    "id": "item_4393",
    "Last Name": "O'Brien",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531762": {
    "id": "item_29829",
    "Last Name": "Dwyer",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531763": {
    "id": "item_4389",
    "Last Name": "Hawkins",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531767": {
    "id": "item_327",
    "Last Name": "Hyde",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531768": {
    "id": "item_15549",
    "Last Name": "Liao",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531769": {
    "id": "item_2254",
    "Last Name": "Santoro",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531770": {
    "id": "item_2348",
    "Last Name": "Tung",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531771": {
    "id": "item_15554",
    "Last Name": "Chen",
    "First Name": "Coralie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531774": {
    "id": "item_15547",
    "Last Name": "De Sisto",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531777": {
    "id": "item_15536",
    "Last Name": "Sanchez Solorzano",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531787": {
    "id": "item_15540",
    "Last Name": "Shimizu",
    "First Name": "Tatsuro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531798": {
    "id": "item_15543",
    "Last Name": "Luu",
    "First Name": "Vivien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531800": {
    "id": "item_324",
    "Last Name": "Smith",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531801": {
    "id": "item_15544",
    "Last Name": "Hedger",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531821": {
    "id": "item_15537",
    "Last Name": "Krungkaew",
    "First Name": "Ray",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531823": {
    "id": "item_29734",
    "Last Name": "Yip",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531824": {
    "id": "item_2246",
    "Last Name": "Fraser",
    "First Name": "Niall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531825": {
    "id": "item_16658",
    "Last Name": "Foggo",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531827": {
    "id": "item_13003",
    "Last Name": "Bacolod",
    "First Name": "Imee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531832": {
    "id": "item_323",
    "Last Name": "Dunbar",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531833": {
    "id": "item_16657",
    "Last Name": "Wyatt",
    "First Name": "Marguerite",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531836": {
    "id": "item_4532",
    "Last Name": "ELLAHIYOUN",
    "First Name": "FARHOOD",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531846": {
    "id": "item_321",
    "Last Name": "Songniam",
    "First Name": "Narakorn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531851": {
    "id": "item_13037",
    "Last Name": "Bourke",
    "First Name": "Llayton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531852": {
    "id": "item_15731",
    "Last Name": "Wilson",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531860": {
    "id": "item_15535",
    "Last Name": "Zhang",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531861": {
    "id": "item_15730",
    "Last Name": "Kunc",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531863": {
    "id": "item_2245",
    "Last Name": "Boast",
    "First Name": "Aiden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531865": {
    "id": "item_12960",
    "Last Name": "Siddiqi",
    "First Name": "Saud",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531878": {
    "id": "item_4531",
    "Last Name": "AKIL",
    "First Name": "HAZEM",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531880": {
    "id": "item_29732",
    "Last Name": "Kastelan",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531887": {
    "id": "item_411",
    "Last Name": "Coulson",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531889": {
    "id": "item_2346",
    "Last Name": "Mu–oz Pabon",
    "First Name": "Yolanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531890": {
    "id": "item_27780",
    "Last Name": "Lansdowne",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531896": {
    "id": "item_12958",
    "Last Name": "Mendoza",
    "First Name": "Roumel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531899": {
    "id": "item_15534",
    "Last Name": "Nowland",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531901": {
    "id": "item_15525",
    "Last Name": "Wang",
    "First Name": "Xiaochun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531902": {
    "id": "item_2347",
    "Last Name": "Sheehan",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531907": {
    "id": "item_320",
    "Last Name": "Cardoso das chagas",
    "First Name": "Fillipy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531910": {
    "id": "item_15529",
    "Last Name": "Hua",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531912": {
    "id": "item_2243",
    "Last Name": "Tassi",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531916": {
    "id": "item_15530",
    "Last Name": "Price",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531917": {
    "id": "item_15521",
    "Last Name": "Tran",
    "First Name": "An",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531924": {
    "id": "item_4379",
    "Last Name": "Gannon",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531925": {
    "id": "item_15727",
    "Last Name": "Taylor",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531931": {
    "id": "item_319",
    "Last Name": "Willis",
    "First Name": "Gordon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531934": {
    "id": "item_317",
    "Last Name": "Vardy",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531935": {
    "id": "item_318",
    "Last Name": "Mingay",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531939": {
    "id": "item_4380",
    "Last Name": "Salac",
    "First Name": "Salvador",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531954": {
    "id": "item_15909",
    "Last Name": "LEUNG",
    "First Name": "Wai Cheung Gary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531958": {
    "id": "item_16656",
    "Last Name": "McClement",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531964": {
    "id": "item_15522",
    "Last Name": "Nash",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531966": {
    "id": "item_2444",
    "Last Name": "Allworth",
    "First Name": "Izzy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531972": {
    "id": "item_2344",
    "Last Name": "Quah",
    "First Name": "Wui Keat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531973": {
    "id": "item_4371",
    "Last Name": "Chandra",
    "First Name": "Edy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531977": {
    "id": "item_29726",
    "Last Name": "Franco",
    "First Name": "Gui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531981": {
    "id": "item_410",
    "Last Name": "Lescai",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531991": {
    "id": "item_2241",
    "Last Name": "Brecknell",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531992": {
    "id": "item_15509",
    "Last Name": "Vincent",
    "First Name": "Benn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531995": {
    "id": "item_16655",
    "Last Name": "Carroll",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531996": {
    "id": "item_2443",
    "Last Name": "Gilbertson",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531999": {
    "id": "item_29727",
    "Last Name": "Chen",
    "First Name": "Hua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532002": {
    "id": "item_314",
    "Last Name": "Pasquier",
    "First Name": "Benoit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532003": {
    "id": "item_310",
    "Last Name": "Johnston",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532006": {
    "id": "item_15510",
    "Last Name": "Davis",
    "First Name": "Henry-John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532007": {
    "id": "item_12956",
    "Last Name": "McCafferty",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532008": {
    "id": "item_15505",
    "Last Name": "Cai",
    "First Name": "Shen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532009": {
    "id": "item_27778",
    "Last Name": "Turcato",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532010": {
    "id": "item_15087",
    "Last Name": "Maravilla",
    "First Name": "Mary Lyncel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532018": {
    "id": "item_15724",
    "Last Name": "Muir",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532025": {
    "id": "item_4368",
    "Last Name": "Sharman",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532030": {
    "id": "item_4366",
    "Last Name": "McKenna",
    "First Name": "Robert-HUgh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532035": {
    "id": "item_4364",
    "Last Name": "Lapedus",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532041": {
    "id": "item_15723",
    "Last Name": "McIvor",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532044": {
    "id": "item_4362",
    "Last Name": "Ronquilo",
    "First Name": "Randell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532046": {
    "id": "item_29721",
    "Last Name": "Constantine",
    "First Name": "Bill",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532049": {
    "id": "item_12952",
    "Last Name": "Sheppard",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532050": {
    "id": "item_27777",
    "Last Name": "Banks",
    "First Name": "Elise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532051": {
    "id": "item_27674",
    "Last Name": "Navarrete",
    "First Name": "John Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532067": {
    "id": "item_407",
    "Last Name": "Bailey",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532070": {
    "id": "item_2442",
    "Last Name": "Hill",
    "First Name": "Yvonne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532073": {
    "id": "item_12954",
    "Last Name": "Cooke",
    "First Name": "Blair",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532078": {
    "id": "item_12955",
    "Last Name": "Van den Mooter",
    "First Name": "Justine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532084": {
    "id": "item_15502",
    "Last Name": "Williamson",
    "First Name": "Riley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532085": {
    "id": "item_408",
    "Last Name": "Baldi",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532086": {
    "id": "item_4528",
    "Last Name": "SAVIERI",
    "First Name": "JOHANES",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532092": {
    "id": "item_2238",
    "Last Name": "Howard",
    "First Name": "Mikaela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532093": {
    "id": "item_15722",
    "Last Name": "Samowitz",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532101": {
    "id": "item_15500",
    "Last Name": "Mwamba",
    "First Name": "Mwamba",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532102": {
    "id": "item_4359",
    "Last Name": "Bugbird",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532107": {
    "id": "item_12883",
    "Last Name": "Gill",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532123": {
    "id": "item_27886",
    "Last Name": "Frazer",
    "First Name": "Lynette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532128": {
    "id": "item_2441",
    "Last Name": "Knaus",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532139": {
    "id": "item_29771",
    "Last Name": "Ison",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532141": {
    "id": "item_2342",
    "Last Name": "Blair",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532144": {
    "id": "item_4351",
    "Last Name": "Cheng",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532147": {
    "id": "item_4680",
    "Last Name": "Hughes",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532148": {
    "id": "item_27885",
    "Last Name": "Gilbert",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532150": {
    "id": "item_2343",
    "Last Name": "Nanfra",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532155": {
    "id": "item_2233",
    "Last Name": "Li",
    "First Name": "Yao-Tai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532159": {
    "id": "item_15718",
    "Last Name": "Neimanis",
    "First Name": "Greta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532161": {
    "id": "item_15492",
    "Last Name": "Eun",
    "First Name": "Sangtae",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532162": {
    "id": "item_403",
    "Last Name": "Vorisek",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532163": {
    "id": "item_15490",
    "Last Name": "He",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532165": {
    "id": "item_2235",
    "Last Name": "Decharneux",
    "First Name": "Erwin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532170": {
    "id": "item_15714",
    "Last Name": "Fong",
    "First Name": "Wai On Eddy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532175": {
    "id": "item_15716",
    "Last Name": "Knowles",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532179": {
    "id": "item_2231",
    "Last Name": "Manassen",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532182": {
    "id": "item_15489",
    "Last Name": "Howard",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532190": {
    "id": "item_4525",
    "Last Name": "Timmis",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532196": {
    "id": "item_15485",
    "Last Name": "Chau",
    "First Name": "Doug",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532206": {
    "id": "item_4349",
    "Last Name": "Stitt",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532207": {
    "id": "item_27671",
    "Last Name": "Leemen",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532218": {
    "id": "item_27672",
    "Last Name": "TAKASHI",
    "First Name": "MAEDA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532223": {
    "id": "item_15487",
    "Last Name": "Levy",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532227": {
    "id": "item_2339",
    "Last Name": "Arasain",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532229": {
    "id": "item_15486",
    "Last Name": "Shang",
    "First Name": "Yun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532231": {
    "id": "item_2229",
    "Last Name": "Beaton",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532237": {
    "id": "item_15480",
    "Last Name": "Chen",
    "First Name": "Danhong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532241": {
    "id": "item_29770",
    "Last Name": "Hall",
    "First Name": "Bevan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532244": {
    "id": "item_15712",
    "Last Name": "Knights",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532247": {
    "id": "item_4342",
    "Last Name": "Shaxson",
    "First Name": "Bruen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532250": {
    "id": "item_4343",
    "Last Name": "Seymour",
    "First Name": "Guy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532251": {
    "id": "item_307",
    "Last Name": "Wood",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532256": {
    "id": "item_4523",
    "Last Name": "Beaton",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532262": {
    "id": "item_306",
    "Last Name": "Hughes",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532271": {
    "id": "item_2337",
    "Last Name": "Joffe",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532277": {
    "id": "item_15083",
    "Last Name": "Nguyen",
    "First Name": "Anh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532281": {
    "id": "item_15082",
    "Last Name": "Laksmono",
    "First Name": "Navy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532283": {
    "id": "item_27767",
    "Last Name": "Hargrave",
    "First Name": "Elyse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532285": {
    "id": "item_27764",
    "Last Name": "Caleiro Ogata",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532293": {
    "id": "item_4341",
    "Last Name": "Bouma",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532304": {
    "id": "item_27766",
    "Last Name": "Gillingham",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532311": {
    "id": "item_29590",
    "Last Name": "Hashim",
    "First Name": "Shaari",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532318": {
    "id": "item_305",
    "Last Name": "Clifton",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532319": {
    "id": "item_2226",
    "Last Name": "Kenneally",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532325": {
    "id": "item_4339",
    "Last Name": "Shah",
    "First Name": "Sohil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532343": {
    "id": "item_27765",
    "Last Name": "Davies",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532351": {
    "id": "item_2225",
    "Last Name": "Leigh",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532358": {
    "id": "item_15080",
    "Last Name": "Armando",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532366": {
    "id": "item_4337",
    "Last Name": "Nielsen",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532369": {
    "id": "item_15473",
    "Last Name": "Quinn",
    "First Name": "Connor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532374": {
    "id": "item_15475",
    "Last Name": "Kelly",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532379": {
    "id": "item_27884",
    "Last Name": "Stapleton",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532384": {
    "id": "item_12997",
    "Last Name": "Los",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532385": {
    "id": "item_4334",
    "Last Name": "Ballesty",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532387": {
    "id": "item_15079",
    "Last Name": "Yu",
    "First Name": "JooHo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532399": {
    "id": "item_15472",
    "Last Name": "Wearne",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532400": {
    "id": "item_12943",
    "Last Name": "Ranieri",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532402": {
    "id": "item_4679",
    "Last Name": "Tapson",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532405": {
    "id": "item_15464",
    "Last Name": "Xenos",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532409": {
    "id": "item_4331",
    "Last Name": "Mides",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532413": {
    "id": "item_301",
    "Last Name": "Zaw",
    "First Name": "Khan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532418": {
    "id": "item_4332",
    "Last Name": "Steenson",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532425": {
    "id": "item_15468",
    "Last Name": "Daly",
    "First Name": "Mackenzie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532426": {
    "id": "item_300",
    "Last Name": "Guo",
    "First Name": "Yu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532429": {
    "id": "item_2336",
    "Last Name": "Swanton",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532430": {
    "id": "item_27761",
    "Last Name": "CONNOLLY",
    "First Name": "Benedict",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532432": {
    "id": "item_15456",
    "Last Name": "Columbres",
    "First Name": "Frazad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532437": {
    "id": "item_4330",
    "Last Name": "Oreggia",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532438": {
    "id": "item_15459",
    "Last Name": "Vishram",
    "First Name": "Sachin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532440": {
    "id": "item_15469",
    "Last Name": "Tracey",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532443": {
    "id": "item_29769",
    "Last Name": "Brugliera",
    "First Name": "Carla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532445": {
    "id": "item_15451",
    "Last Name": "Zhu",
    "First Name": "Winnie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532449": {
    "id": "item_15465",
    "Last Name": "Russell",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532450": {
    "id": "item_2223",
    "Last Name": "Joseph",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532451": {
    "id": "item_4519",
    "Last Name": "Yang",
    "First Name": "Jae-Jong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532453": {
    "id": "item_498",
    "Last Name": "Smith",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532455": {
    "id": "item_15462",
    "Last Name": "Lee",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532456": {
    "id": "item_15078",
    "Last Name": "Ng",
    "First Name": "Chi Kin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532471": {
    "id": "item_15461",
    "Last Name": "Reid",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532473": {
    "id": "item_4323",
    "Last Name": "Barwell",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532478": {
    "id": "item_15458",
    "Last Name": "Schack-Evans",
    "First Name": "Ken",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532482": {
    "id": "item_29712",
    "Last Name": "Zammit",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532487": {
    "id": "item_12996",
    "Last Name": "Scicluna",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532488": {
    "id": "item_27760",
    "Last Name": "Moon",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532496": {
    "id": "item_15455",
    "Last Name": "Sheahan",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532513": {
    "id": "item_29709",
    "Last Name": "sundararaj",
    "First Name": "Karthikraja",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532518": {
    "id": "item_15453",
    "Last Name": "Hoek",
    "First Name": "Rosalie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532532": {
    "id": "item_15704",
    "Last Name": "Greiss",
    "First Name": "Rami",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532534": {
    "id": "item_2216",
    "Last Name": "Stevenson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532540": {
    "id": "item_27750",
    "Last Name": "Pandya",
    "First Name": "Ankit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532554": {
    "id": "item_4678",
    "Last Name": "Hanrahan",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532556": {
    "id": "item_15447",
    "Last Name": "Elliott",
    "First Name": "Caine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532558": {
    "id": "item_12936",
    "Last Name": "Monzon",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532569": {
    "id": "item_29708",
    "Last Name": "Smith",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532573": {
    "id": "item_15702",
    "Last Name": "Mitchell",
    "First Name": "Glee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532582": {
    "id": "item_15445",
    "Last Name": "Ganski",
    "First Name": "Josephine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532584": {
    "id": "item_4035",
    "Last Name": "Ketkeaw",
    "First Name": "Joompote",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532586": {
    "id": "item_291",
    "Last Name": "Zhao",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532593": {
    "id": "item_29589",
    "Last Name": "Slabaugh",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532594": {
    "id": "item_292",
    "Last Name": "Tran",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532595": {
    "id": "item_15444",
    "Last Name": "Patel",
    "First Name": "Veeral",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532597": {
    "id": "item_15440",
    "Last Name": "Taylor",
    "First Name": "Rees",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532599": {
    "id": "item_15443",
    "Last Name": "McNabb",
    "First Name": "Arran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532600": {
    "id": "item_15438",
    "Last Name": "Forssman",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532603": {
    "id": "item_4316",
    "Last Name": "Baker",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532611": {
    "id": "item_293",
    "Last Name": "Wong",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532617": {
    "id": "item_15436",
    "Last Name": "Mitchell",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532619": {
    "id": "item_15434",
    "Last Name": "Shields",
    "First Name": "Bill",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532622": {
    "id": "item_15435",
    "Last Name": "Yeung",
    "First Name": "Chun Hon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532635": {
    "id": "item_12995",
    "Last Name": "Dinata",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532639": {
    "id": "item_398",
    "Last Name": "Foster",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532657": {
    "id": "item_4311",
    "Last Name": "David Howell",
    "First Name": "David Howell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532660": {
    "id": "item_29707",
    "Last Name": "LAWS",
    "First Name": "DEAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532664": {
    "id": "item_288",
    "Last Name": "Williams",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532670": {
    "id": "item_4307",
    "Last Name": "West",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532676": {
    "id": "item_29706",
    "Last Name": "Tran",
    "First Name": "Ewan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532677": {
    "id": "item_2210",
    "Last Name": "Ram",
    "First Name": "Vikram",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532679": {
    "id": "item_15428",
    "Last Name": "Bell",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532695": {
    "id": "item_290",
    "Last Name": "Webb",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532710": {
    "id": "item_497",
    "Last Name": "Morley",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532713": {
    "id": "item_4301",
    "Last Name": "Mand",
    "First Name": "Harjot",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532714": {
    "id": "item_29588",
    "Last Name": "basuki",
    "First Name": "anung anindita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532716": {
    "id": "item_12933",
    "Last Name": "Mestre",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532717": {
    "id": "item_287",
    "Last Name": "Lau",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532718": {
    "id": "item_12994",
    "Last Name": "Doorgapershad",
    "First Name": "Ashok",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532719": {
    "id": "item_4309",
    "Last Name": "Weng",
    "First Name": "Xiaoan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532720": {
    "id": "item_15430",
    "Last Name": "Lam",
    "First Name": "Huy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532724": {
    "id": "item_2199",
    "Last Name": "Cody",
    "First Name": "Ken",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532725": {
    "id": "item_15696",
    "Last Name": "Davis",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532729": {
    "id": "item_4306",
    "Last Name": "Ursino",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532736": {
    "id": "item_15699",
    "Last Name": "Fox",
    "First Name": "Kaajal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532737": {
    "id": "item_29702",
    "Last Name": "Sitaraman",
    "First Name": "Tarun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532744": {
    "id": "item_282",
    "Last Name": "Ryan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532746": {
    "id": "item_15420",
    "Last Name": "Hidvegi",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532748": {
    "id": "item_29701",
    "Last Name": "Giron",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532750": {
    "id": "item_29828",
    "Last Name": "O'Mahony",
    "First Name": "Maddy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532765": {
    "id": "item_29765",
    "Last Name": "Beggs",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532768": {
    "id": "item_2208",
    "Last Name": "Lin",
    "First Name": "Wilson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532778": {
    "id": "item_15416",
    "Last Name": "Meeve",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532780": {
    "id": "item_15418",
    "Last Name": "Trinh",
    "First Name": "An",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532783": {
    "id": "item_4300",
    "Last Name": "Sotelo",
    "First Name": "Manuel Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532789": {
    "id": "item_13036",
    "Last Name": "Sansom",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532793": {
    "id": "item_4298",
    "Last Name": "Medeiros",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532796": {
    "id": "item_2331",
    "Last Name": "Duncan",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532804": {
    "id": "item_2204",
    "Last Name": "Taylor",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532811": {
    "id": "item_4302",
    "Last Name": "Adno",
    "First Name": "Mandy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532814": {
    "id": "item_496",
    "Last Name": "Maddern",
    "First Name": "Gil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532815": {
    "id": "item_2200",
    "Last Name": "Kannoth",
    "First Name": "Siju",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532818": {
    "id": "item_15411",
    "Last Name": "Lee",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532819": {
    "id": "item_4299",
    "Last Name": "Corston",
    "First Name": "Warren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532822": {
    "id": "item_15417",
    "Last Name": "Kumar",
    "First Name": "Parmeet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532823": {
    "id": "item_12930",
    "Last Name": "Croker",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532829": {
    "id": "item_4296",
    "Last Name": "Walker",
    "First Name": "Tyrone",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532830": {
    "id": "item_27753",
    "Last Name": "Blair",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532848": {
    "id": "item_16654",
    "Last Name": "O'CONNELL",
    "First Name": "DESMOND",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532866": {
    "id": "item_4513",
    "Last Name": "Morrison",
    "First Name": "Ingrid",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532871": {
    "id": "item_27883",
    "Last Name": "Lewis",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532874": {
    "id": "item_15413",
    "Last Name": "McCarthy",
    "First Name": "Charlise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532880": {
    "id": "item_15412",
    "Last Name": "Cook",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532892": {
    "id": "item_4295",
    "Last Name": "Green",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532912": {
    "id": "item_394",
    "Last Name": "D'silva",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532915": {
    "id": "item_12929",
    "Last Name": "Armstrong",
    "First Name": "Joss",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532921": {
    "id": "item_12928",
    "Last Name": "Lee",
    "First Name": "Woosun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532926": {
    "id": "item_27749",
    "Last Name": "Hopkins",
    "First Name": "Philippa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532927": {
    "id": "item_4033",
    "Last Name": "Lacuna",
    "First Name": "Mariem",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532931": {
    "id": "item_274",
    "Last Name": "Donagh",
    "First Name": "Padraig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532944": {
    "id": "item_2192",
    "Last Name": "Horand",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532960": {
    "id": "item_271",
    "Last Name": "Gore",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532963": {
    "id": "item_15404",
    "Last Name": "Foster",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532965": {
    "id": "item_15395",
    "Last Name": "Sudjiman",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532967": {
    "id": "item_27882",
    "Last Name": "Grabham",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532969": {
    "id": "item_272",
    "Last Name": "Sims",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532970": {
    "id": "item_15403",
    "Last Name": "Cowell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532980": {
    "id": "item_4284",
    "Last Name": "Goodman",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532985": {
    "id": "item_16653",
    "Last Name": "Gribble",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532988": {
    "id": "item_16651",
    "Last Name": "Roberts",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532993": {
    "id": "item_12927",
    "Last Name": "Fitton",
    "First Name": "Marc",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533001": {
    "id": "item_16652",
    "Last Name": "Corr",
    "First Name": "Tahnee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533002": {
    "id": "item_27822",
    "Last Name": "Dziego",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533006": {
    "id": "item_2329",
    "Last Name": "Ross",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533008": {
    "id": "item_4286",
    "Last Name": "Turner",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533012": {
    "id": "item_4285",
    "Last Name": "Gould",
    "First Name": "Rochelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533019": {
    "id": "item_4509",
    "Last Name": "YANG",
    "First Name": "HAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533029": {
    "id": "item_134",
    "Last Name": "Willmers",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533032": {
    "id": "item_4282",
    "Last Name": "Kong",
    "First Name": "Ming Yeung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533036": {
    "id": "item_4280",
    "Last Name": "Snyman",
    "First Name": "Wynand",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533072": {
    "id": "item_29826",
    "Last Name": "Oloyede",
    "First Name": "Sunday",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533073": {
    "id": "item_15392",
    "Last Name": "Vella",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533086": {
    "id": "item_4274",
    "Last Name": "PHANITH",
    "First Name": "Kiat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533092": {
    "id": "item_2186",
    "Last Name": "Chai",
    "First Name": "Kim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533100": {
    "id": "item_15690",
    "Last Name": "Khan",
    "First Name": "Muneeb Habib",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533109": {
    "id": "item_27747",
    "Last Name": "Scheepstra",
    "First Name": "Iona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533120": {
    "id": "item_4271",
    "Last Name": "Baxter",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533126": {
    "id": "item_4508",
    "Last Name": "Luong",
    "First Name": "Guy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533129": {
    "id": "item_15687",
    "Last Name": "Hunt",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533145": {
    "id": "item_15688",
    "Last Name": "Del Moral",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533148": {
    "id": "item_29827",
    "Last Name": "Guy",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533150": {
    "id": "item_260",
    "Last Name": "Donovan",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533152": {
    "id": "item_2185",
    "Last Name": "Douglas",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533155": {
    "id": "item_4269",
    "Last Name": "Oba",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533162": {
    "id": "item_250",
    "Last Name": "Sypkens",
    "First Name": "Dewald",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533301": {
    "id": "item_29836",
    "Last Name": "Sachdev",
    "First Name": "Nisha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533364": {
    "id": "item_12992",
    "Last Name": "Brown",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533411": {
    "id": "item_261",
    "Last Name": "Rogerson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533504": {
    "id": "item_29695",
    "Last Name": "Markiewicz",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533606": {
    "id": "item_4266",
    "Last Name": "choi",
    "First Name": "Kyungyoung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533786": {
    "id": "item_2183",
    "Last Name": "Dobrin",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533803": {
    "id": "item_29690",
    "Last Name": "Zhang",
    "First Name": "Zhen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533877": {
    "id": "item_259",
    "Last Name": "Twort",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533890": {
    "id": "item_248",
    "Last Name": "Ghanivand",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533955": {
    "id": "item_133",
    "Last Name": "Leung",
    "First Name": "Ying Kit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533994": {
    "id": "item_4267",
    "Last Name": "Unsworth",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534041": {
    "id": "item_2182",
    "Last Name": "Wood",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534083": {
    "id": "item_2181",
    "Last Name": "Leerasuntudkul",
    "First Name": "Warut",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534355": {
    "id": "item_15382",
    "Last Name": "Song",
    "First Name": "Jiayuan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534699": {
    "id": "item_2324",
    "Last Name": "Foo",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534750": {
    "id": "item_253",
    "Last Name": "Lancaster",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534764": {
    "id": "item_4265",
    "Last Name": "Donohoe",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534924": {
    "id": "item_249",
    "Last Name": "Turner",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535387": {
    "id": "item_15380",
    "Last Name": "Cooke",
    "First Name": "Rowan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535424": {
    "id": "item_15378",
    "Last Name": "Zhang",
    "First Name": "Dacheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535443": {
    "id": "item_4259",
    "Last Name": "Chiba",
    "First Name": "Masanori",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535524": {
    "id": "item_4261",
    "Last Name": "Nantes",
    "First Name": "Cassi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535559": {
    "id": "item_27819",
    "Last Name": "hoare",
    "First Name": "sacha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535887": {
    "id": "item_15682",
    "Last Name": "Yuide",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535910": {
    "id": "item_391",
    "Last Name": "Toohey",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536113": {
    "id": "item_15679",
    "Last Name": "Stephenson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536301": {
    "id": "item_29825",
    "Last Name": "Waddingham",
    "First Name": "Piper",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536497": {
    "id": "item_27744",
    "Last Name": "Doney",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536521": {
    "id": "item_4505",
    "Last Name": "Wightman",
    "First Name": "Andrei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536982": {
    "id": "item_15374",
    "Last Name": "Parkin",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537341": {
    "id": "item_4246",
    "Last Name": "Abood",
    "First Name": "Seth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537352": {
    "id": "item_29762",
    "Last Name": "wang",
    "First Name": "weihao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537528": {
    "id": "item_29688",
    "Last Name": "Wang",
    "First Name": "Fan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537825": {
    "id": "item_15373",
    "Last Name": "Le Roux",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538001": {
    "id": "item_4501",
    "Last Name": "Potts",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538013": {
    "id": "item_4248",
    "Last Name": "Xie",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538036": {
    "id": "item_4250",
    "Last Name": "Leung",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538044": {
    "id": "item_2176",
    "Last Name": "Thomson",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538066": {
    "id": "item_16650",
    "Last Name": "Maher",
    "First Name": "Braden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538176": {
    "id": "item_389",
    "Last Name": "Bedoya",
    "First Name": "Clara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538179": {
    "id": "item_2044",
    "Last Name": "Li",
    "First Name": "Ming",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538189": {
    "id": "item_388",
    "Last Name": "To",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538196": {
    "id": "item_27817",
    "Last Name": "Hoare",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538215": {
    "id": "item_245",
    "Last Name": "Powell",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538221": {
    "id": "item_4238",
    "Last Name": "Quinn",
    "First Name": "Garth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538226": {
    "id": "item_2173",
    "Last Name": "Verriour",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538241": {
    "id": "item_4243",
    "Last Name": "Bewick",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538252": {
    "id": "item_15366",
    "Last Name": "Duncan",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538253": {
    "id": "item_2166",
    "Last Name": "Kuo",
    "First Name": "Dora",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538261": {
    "id": "item_4232",
    "Last Name": "Middlemass",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538265": {
    "id": "item_4234",
    "Last Name": "Carson",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538278": {
    "id": "item_29685",
    "Last Name": "Gan",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538284": {
    "id": "item_4230",
    "Last Name": "Francis",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538288": {
    "id": "item_387",
    "Last Name": "vanHamond",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538296": {
    "id": "item_131",
    "Last Name": "Okuyama",
    "First Name": "Yozo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538311": {
    "id": "item_15676",
    "Last Name": "Walshe",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538315": {
    "id": "item_238",
    "Last Name": "Shpilev",
    "First Name": "Pavel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538325": {
    "id": "item_495",
    "Last Name": "Powell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538329": {
    "id": "item_27668",
    "Last Name": "Smit",
    "First Name": "Sania",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538331": {
    "id": "item_12923",
    "Last Name": "Duncan",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538332": {
    "id": "item_27815",
    "Last Name": "Cutler",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538333": {
    "id": "item_15363",
    "Last Name": "Hannah",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538335": {
    "id": "item_4677",
    "Last Name": "Cahill",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538340": {
    "id": "item_29681",
    "Last Name": "Bennett",
    "First Name": "Cathy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538367": {
    "id": "item_29759",
    "Last Name": "Nario",
    "First Name": "Jomella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538372": {
    "id": "item_2043",
    "Last Name": "Chu",
    "First Name": "Yuen hing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538377": {
    "id": "item_29824",
    "Last Name": "Waddingham",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538378": {
    "id": "item_236",
    "Last Name": "Bacon",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538382": {
    "id": "item_15071",
    "Last Name": "Lee",
    "First Name": "Yong Jin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538386": {
    "id": "item_15672",
    "Last Name": "Feng",
    "First Name": "Huili",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538396": {
    "id": "item_29679",
    "Last Name": "Ong",
    "First Name": "Han Wei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538405": {
    "id": "item_4226",
    "Last Name": "Wang",
    "First Name": "Kelvin Le",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538411": {
    "id": "item_2320",
    "Last Name": "Carey",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538417": {
    "id": "item_234",
    "Last Name": "De Los Santos",
    "First Name": "Juan Carlos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538419": {
    "id": "item_12922",
    "Last Name": "McLean",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538422": {
    "id": "item_29672",
    "Last Name": "Panos",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538430": {
    "id": "item_4496",
    "Last Name": "Rudevics",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538463": {
    "id": "item_15353",
    "Last Name": "Daniels",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538471": {
    "id": "item_4494",
    "Last Name": "Price",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538475": {
    "id": "item_12988",
    "Last Name": "Batman",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538489": {
    "id": "item_4222",
    "Last Name": "Ray",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538667": {
    "id": "item_15345",
    "Last Name": "Zhang",
    "First Name": "Jun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538688": {
    "id": "item_4218",
    "Last Name": "Berry",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538697": {
    "id": "item_15348",
    "Last Name": "ballard",
    "First Name": "dominic",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538744": {
    "id": "item_2160",
    "Last Name": "Purcell",
    "First Name": "Eoin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538802": {
    "id": "item_4221",
    "Last Name": "McEvoy",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36539285": {
    "id": "item_15346",
    "Last Name": "Quill",
    "First Name": "Fergal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36539575": {
    "id": "item_129",
    "Last Name": "Igberaese",
    "First Name": "Ehikioya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36539778": {
    "id": "item_4217",
    "Last Name": "Law",
    "First Name": "Kendrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36539827": {
    "id": "item_27881",
    "Last Name": "Hickey",
    "First Name": "Lea-Anne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36539891": {
    "id": "item_15344",
    "Last Name": "Diviney",
    "First Name": "Fintan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540025": {
    "id": "item_4213",
    "Last Name": "Azarias dos Reis",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540027": {
    "id": "item_15343",
    "Last Name": "O'Donnell",
    "First Name": "Jacqui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540037": {
    "id": "item_2158",
    "Last Name": "Shiel",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540044": {
    "id": "item_4214",
    "Last Name": "Aditama",
    "First Name": "Yudha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540053": {
    "id": "item_15340",
    "Last Name": "Duong",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540054": {
    "id": "item_2157",
    "Last Name": "Spencer",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540056": {
    "id": "item_29670",
    "Last Name": "Som",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540057": {
    "id": "item_4676",
    "Last Name": "Peach",
    "First Name": "Karen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540064": {
    "id": "item_15905",
    "Last Name": "Boyd",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540071": {
    "id": "item_15338",
    "Last Name": "Tan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540081": {
    "id": "item_29835",
    "Last Name": "McSweeney",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540086": {
    "id": "item_15337",
    "Last Name": "Barber",
    "First Name": "Holly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540099": {
    "id": "item_4210",
    "Last Name": "Ozenc",
    "First Name": "Cem",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540104": {
    "id": "item_12920",
    "Last Name": "Russell",
    "First Name": "Dion",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540105": {
    "id": "item_15326",
    "Last Name": "Hung",
    "First Name": "Jerry Tin Lok",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540108": {
    "id": "item_15670",
    "Last Name": "Gu",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540110": {
    "id": "item_228",
    "Last Name": "Iarussi",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540113": {
    "id": "item_4208",
    "Last Name": "Moss",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540115": {
    "id": "item_226",
    "Last Name": "Heaney",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540121": {
    "id": "item_4207",
    "Last Name": "Devine",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540125": {
    "id": "item_15068",
    "Last Name": "Li",
    "First Name": "Jung-Shian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540136": {
    "id": "item_2155",
    "Last Name": "Hammond",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540167": {
    "id": "item_381",
    "Last Name": "Kent-Brown",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540205": {
    "id": "item_15669",
    "Last Name": "Barnes",
    "First Name": "Nadine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540408": {
    "id": "item_15329",
    "Last Name": "Pickova",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540514": {
    "id": "item_4489",
    "Last Name": "Kang",
    "First Name": "Jin-Seung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540586": {
    "id": "item_4674",
    "Last Name": "Peach",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540665": {
    "id": "item_494",
    "Last Name": "Agnew",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540833": {
    "id": "item_27733",
    "Last Name": "Livne",
    "First Name": "Tyrah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540890": {
    "id": "item_4027",
    "Last Name": "Ruppel",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36541037": {
    "id": "item_29756",
    "Last Name": "pamintuan",
    "First Name": "ian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36541356": {
    "id": "item_15322",
    "Last Name": "Pablo",
    "First Name": "Rodolfo Jr",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36541361": {
    "id": "item_2440",
    "Last Name": "Hutchinson",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36541870": {
    "id": "item_4203",
    "Last Name": "Arshad",
    "First Name": "Furqan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36541971": {
    "id": "item_15323",
    "Last Name": "Rumjahn",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36542131": {
    "id": "item_15067",
    "Last Name": "Chan",
    "First Name": "Jia Litt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36542327": {
    "id": "item_16731",
    "Last Name": "Du",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36543137": {
    "id": "item_27732",
    "Last Name": "Hatzidimitriou",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36543208": {
    "id": "item_4488",
    "Last Name": "Lloyd",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544131": {
    "id": "item_29668",
    "Last Name": "Tenggara",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544135": {
    "id": "item_4486",
    "Last Name": "Millar",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544252": {
    "id": "item_222",
    "Last Name": "Sakim",
    "First Name": "Mounir",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544453": {
    "id": "item_12918",
    "Last Name": "Goodrick",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544540": {
    "id": "item_15320",
    "Last Name": "Tsang",
    "First Name": "Siu Ki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544576": {
    "id": "item_380",
    "Last Name": "Barkle",
    "First Name": "Carly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544673": {
    "id": "item_2318",
    "Last Name": "Whyte",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544766": {
    "id": "item_379",
    "Last Name": "Folmer",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544790": {
    "id": "item_15666",
    "Last Name": "Folmer",
    "First Name": "Amber",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544911": {
    "id": "item_27731",
    "Last Name": "Royall",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544980": {
    "id": "item_4484",
    "Last Name": "Grinham",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545127": {
    "id": "item_4673",
    "Last Name": "Forbes",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545196": {
    "id": "item_29666",
    "Last Name": "Gunawan",
    "First Name": "Johan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545281": {
    "id": "item_378",
    "Last Name": "Axelsen",
    "First Name": "Taryn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545343": {
    "id": "item_15318",
    "Last Name": "Vengadasalam",
    "First Name": "Ganesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546059": {
    "id": "item_4194",
    "Last Name": "Budod",
    "First Name": "Baldomero JR",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546206": {
    "id": "item_15315",
    "Last Name": "Mulia",
    "First Name": "Yusrin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546331": {
    "id": "item_29834",
    "Last Name": "Syahfaril",
    "First Name": "Dylan Uno",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546480": {
    "id": "item_4199",
    "Last Name": "Nerney",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546962": {
    "id": "item_15314",
    "Last Name": "Kumar",
    "First Name": "Alok",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547069": {
    "id": "item_375",
    "Last Name": "Mactier",
    "First Name": "Jock",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547170": {
    "id": "item_16649",
    "Last Name": "Pauley",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547183": {
    "id": "item_15063",
    "Last Name": "Wood",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547186": {
    "id": "item_27809",
    "Last Name": "Digman",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547196": {
    "id": "item_12916",
    "Last Name": "Cuaton",
    "First Name": "Ruan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547197": {
    "id": "item_15310",
    "Last Name": "Haran",
    "First Name": "Sivakumar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547201": {
    "id": "item_2040",
    "Last Name": "LEE",
    "First Name": "SEUNGHO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547214": {
    "id": "item_29663",
    "Last Name": "Hicks",
    "First Name": "Roslyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547220": {
    "id": "item_2038",
    "Last Name": "TIEN",
    "First Name": "HUNG KUEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547222": {
    "id": "item_27728",
    "Last Name": "Fizell",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547228": {
    "id": "item_15313",
    "Last Name": "Paterson",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547234": {
    "id": "item_16648",
    "Last Name": "Cheung",
    "First Name": "Ron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547239": {
    "id": "item_218",
    "Last Name": "Kenny",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547249": {
    "id": "item_2313",
    "Last Name": "Qiu",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547256": {
    "id": "item_29659",
    "Last Name": "Vandarve",
    "First Name": "Belle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547262": {
    "id": "item_29660",
    "Last Name": "Mangunsong",
    "First Name": "Bella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547269": {
    "id": "item_15308",
    "Last Name": "Chapman",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547322": {
    "id": "item_15060",
    "Last Name": "RUI",
    "First Name": "Shenyue",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547323": {
    "id": "item_27808",
    "Last Name": "Vijay",
    "First Name": "Karthik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547328": {
    "id": "item_4187",
    "Last Name": "Masters",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547370": {
    "id": "item_217",
    "Last Name": "Trethowan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547390": {
    "id": "item_15304",
    "Last Name": "Chen",
    "First Name": "Fengjie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547393": {
    "id": "item_29658",
    "Last Name": "Vashist",
    "First Name": "Divesh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547423": {
    "id": "item_214",
    "Last Name": "Feng",
    "First Name": "Wen Zhe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547427": {
    "id": "item_2439",
    "Last Name": "Hunt",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547433": {
    "id": "item_15306",
    "Last Name": "Cameron",
    "First Name": "Serena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547440": {
    "id": "item_215",
    "Last Name": "Stanley",
    "First Name": "Tully",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547472": {
    "id": "item_4186",
    "Last Name": "Moon",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547684": {
    "id": "item_4480",
    "Last Name": "Sanchez Blandon",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547923": {
    "id": "item_29657",
    "Last Name": "Boyd",
    "First Name": "Janice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36548321": {
    "id": "item_2139",
    "Last Name": "Crystal",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36548360": {
    "id": "item_4179",
    "Last Name": "Levett",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36548422": {
    "id": "item_29755",
    "Last Name": "Stepko",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36548726": {
    "id": "item_2138",
    "Last Name": "Downer",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36548938": {
    "id": "item_15300",
    "Last Name": "Di Marco",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36548962": {
    "id": "item_15658",
    "Last Name": "Bumatay",
    "First Name": "Ferdinand William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549053": {
    "id": "item_2136",
    "Last Name": "McGuire",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549072": {
    "id": "item_27807",
    "Last Name": "Digman",
    "First Name": "Diomedes",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549076": {
    "id": "item_2135",
    "Last Name": "Lim",
    "First Name": "Hoa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549079": {
    "id": "item_2137",
    "Last Name": "Hercok",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549096": {
    "id": "item_4672",
    "Last Name": "Kaponay",
    "First Name": "Reka",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549106": {
    "id": "item_15295",
    "Last Name": "King",
    "First Name": "Sonny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549112": {
    "id": "item_2438",
    "Last Name": "Durston",
    "First Name": "Kris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549118": {
    "id": "item_210",
    "Last Name": "Turnbull",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549119": {
    "id": "item_15297",
    "Last Name": "Mai",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549122": {
    "id": "item_507",
    "Last Name": "Pham",
    "First Name": "Gibson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549128": {
    "id": "item_4176",
    "Last Name": "Chan",
    "First Name": "Tak Lam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549130": {
    "id": "item_4477",
    "Last Name": "Handreck",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549146": {
    "id": "item_15294",
    "Last Name": "Gallagher",
    "First Name": "Molly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549147": {
    "id": "item_2036",
    "Last Name": "Todd",
    "First Name": "Chas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549164": {
    "id": "item_15292",
    "Last Name": "Fitzgerald",
    "First Name": "Connor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549212": {
    "id": "item_15291",
    "Last Name": "Rahmat",
    "First Name": "Sukiman Fakta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550613": {
    "id": "item_15289",
    "Last Name": "huseyin",
    "First Name": "melissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550698": {
    "id": "item_15290",
    "Last Name": "Kant",
    "First Name": "Raveena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550768": {
    "id": "item_4024",
    "Last Name": "McGregor",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550819": {
    "id": "item_15056",
    "Last Name": "Chew",
    "First Name": "Chiaw Han",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550858": {
    "id": "item_27724",
    "Last Name": "Cupitt",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550966": {
    "id": "item_15287",
    "Last Name": "O'Reilly",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36551138": {
    "id": "item_15058",
    "Last Name": "Langridge",
    "First Name": "Conrad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36551342": {
    "id": "item_4166",
    "Last Name": "Barrett",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36551645": {
    "id": "item_206",
    "Last Name": "Morris",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36551769": {
    "id": "item_205",
    "Last Name": "Jervis",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36551794": {
    "id": "item_15054",
    "Last Name": "Lim",
    "First Name": "Hiang Ngee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36552018": {
    "id": "item_12912",
    "Last Name": "Bell",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36552345": {
    "id": "item_4167",
    "Last Name": "Ginzburg",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36552674": {
    "id": "item_12982",
    "Last Name": "Lee",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36552723": {
    "id": "item_15055",
    "Last Name": "Alvarez",
    "First Name": "Albritz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36553231": {
    "id": "item_15904",
    "Last Name": "Patron",
    "First Name": "Ron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36554206": {
    "id": "item_4163",
    "Last Name": "Amistoso",
    "First Name": "Anton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36554306": {
    "id": "item_4165",
    "Last Name": "Harcombe",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36554450": {
    "id": "item_29752",
    "Last Name": "Marvues",
    "First Name": "Magnus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36554655": {
    "id": "item_29648",
    "Last Name": "Zhang",
    "First Name": "Jingyi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36554802": {
    "id": "item_15278",
    "Last Name": "O'Neill",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36554998": {
    "id": "item_200",
    "Last Name": "Nemec",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555015": {
    "id": "item_2311",
    "Last Name": "De Leon",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555290": {
    "id": "item_27667",
    "Last Name": "Guo",
    "First Name": "Peng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555719": {
    "id": "item_4474",
    "Last Name": "Talocod",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555747": {
    "id": "item_4162",
    "Last Name": "Shakourzadeh",
    "First Name": "Mehrdad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555774": {
    "id": "item_15654",
    "Last Name": "Ferres",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555782": {
    "id": "item_2125",
    "Last Name": "Chen",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555794": {
    "id": "item_15274",
    "Last Name": "Davison",
    "First Name": "Jo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555800": {
    "id": "item_2124",
    "Last Name": "Stewart",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555804": {
    "id": "item_4473",
    "Last Name": "Chang",
    "First Name": "Chong Chin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555812": {
    "id": "item_16670",
    "Last Name": "Chung",
    "First Name": "Ivor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555813": {
    "id": "item_15273",
    "Last Name": "Jeong",
    "First Name": "Moon Sik",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555822": {
    "id": "item_4470",
    "Last Name": "Rivera",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555823": {
    "id": "item_15271",
    "Last Name": "Martorana",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555830": {
    "id": "item_370",
    "Last Name": "Jackson",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555847": {
    "id": "item_4159",
    "Last Name": "Lee",
    "First Name": "Nathan Minki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555852": {
    "id": "item_29751",
    "Last Name": "Ling",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555862": {
    "id": "item_2122",
    "Last Name": "TYULYAKOV",
    "First Name": "VALENTIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555894": {
    "id": "item_27665",
    "Last Name": "Tran",
    "First Name": "Khanh-Tien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555907": {
    "id": "item_27721",
    "Last Name": "Toh",
    "First Name": "Miao ling",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555908": {
    "id": "item_4152",
    "Last Name": "Pearman-Sultana",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555910": {
    "id": "item_4157",
    "Last Name": "Baddock",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555934": {
    "id": "item_29823",
    "Last Name": "Adams",
    "First Name": "Carol",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555935": {
    "id": "item_27805",
    "Last Name": "o'donnell",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555938": {
    "id": "item_193",
    "Last Name": "Hood",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555944": {
    "id": "item_27720",
    "Last Name": "Jarvis",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555968": {
    "id": "item_192",
    "Last Name": "Quigley",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555974": {
    "id": "item_12909",
    "Last Name": "GC",
    "First Name": "Dinesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555976": {
    "id": "item_12981",
    "Last Name": "Wursthorn",
    "First Name": "Regina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555995": {
    "id": "item_4154",
    "Last Name": "Mamou",
    "First Name": "Ramcin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555998": {
    "id": "item_124",
    "Last Name": "Sternberga",
    "First Name": "Sintija",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556029": {
    "id": "item_2030",
    "Last Name": "Zhang",
    "First Name": "Zesong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556137": {
    "id": "item_27804",
    "Last Name": "Simpson",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556149": {
    "id": "item_27719",
    "Last Name": "Chau",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556176": {
    "id": "item_15269",
    "Last Name": "Zhang",
    "First Name": "Chenxi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556599": {
    "id": "item_15049",
    "Last Name": "Lee",
    "First Name": "Mark lester",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556608": {
    "id": "item_4150",
    "Last Name": "Hatlee",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556636": {
    "id": "item_15266",
    "Last Name": "Singh",
    "First Name": "Amit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36558796": {
    "id": "item_2310",
    "Last Name": "Yim",
    "First Name": "Chi Sang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36559305": {
    "id": "item_12979",
    "Last Name": "Koh",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560074": {
    "id": "item_4671",
    "Last Name": "Drain",
    "First Name": "MairŽad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560336": {
    "id": "item_15650",
    "Last Name": "McGuigan",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560619": {
    "id": "item_189",
    "Last Name": "Murillo Ortiz",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560649": {
    "id": "item_123",
    "Last Name": "Nordigarden",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560651": {
    "id": "item_15260",
    "Last Name": "MU",
    "First Name": "LI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560667": {
    "id": "item_4148",
    "Last Name": "Tietz",
    "First Name": "Ole",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560994": {
    "id": "item_364",
    "Last Name": "Manuel",
    "First Name": "Javana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561055": {
    "id": "item_15903",
    "Last Name": "Janos",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561203": {
    "id": "item_2437",
    "Last Name": "Murphy",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561223": {
    "id": "item_12976",
    "Last Name": "Dalla Rosa",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561237": {
    "id": "item_2309",
    "Last Name": "Hughes",
    "First Name": "Deanna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561265": {
    "id": "item_15256",
    "Last Name": "Ma",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561486": {
    "id": "item_2029",
    "Last Name": "Thongtong",
    "First Name": "Penake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561533": {
    "id": "item_29640",
    "Last Name": "Boydon",
    "First Name": "Ferdinand",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562145": {
    "id": "item_29638",
    "Last Name": "Campbell",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562369": {
    "id": "item_15251",
    "Last Name": "Luttrell",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562455": {
    "id": "item_186",
    "Last Name": "Zoccoli",
    "First Name": "Salvatore",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562634": {
    "id": "item_12908",
    "Last Name": "Pitts",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562636": {
    "id": "item_493",
    "Last Name": "Fillingham",
    "First Name": "Kane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562647": {
    "id": "item_2308",
    "Last Name": "Udawattage",
    "First Name": "Don",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562653": {
    "id": "item_4468",
    "Last Name": "Burrows",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562662": {
    "id": "item_15249",
    "Last Name": "Boland",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562675": {
    "id": "item_15248",
    "Last Name": "Forde",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562678": {
    "id": "item_4670",
    "Last Name": "AMAT",
    "First Name": "DANIEL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562679": {
    "id": "item_27664",
    "Last Name": "Dela Rama",
    "First Name": "Janeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562688": {
    "id": "item_2306",
    "Last Name": "Christopher",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562696": {
    "id": "item_15644",
    "Last Name": "Finnimore",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562702": {
    "id": "item_15246",
    "Last Name": "Cheah",
    "First Name": "Carolynn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562718": {
    "id": "item_4018",
    "Last Name": "SUGIANTO",
    "First Name": "RACHMAT",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562726": {
    "id": "item_27714",
    "Last Name": "Vale",
    "First Name": "Enrydave",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562729": {
    "id": "item_4467",
    "Last Name": "Schillaci",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562743": {
    "id": "item_15244",
    "Last Name": "Vater",
    "First Name": "Niklas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562746": {
    "id": "item_15245",
    "Last Name": "Ford",
    "First Name": "Lynda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562754": {
    "id": "item_15243",
    "Last Name": "Rothwell",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562780": {
    "id": "item_15237",
    "Last Name": "Sathorn",
    "First Name": "Sillawat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562791": {
    "id": "item_27803",
    "Last Name": "Ritchie",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562797": {
    "id": "item_15240",
    "Last Name": "Ishak",
    "First Name": "Andry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562812": {
    "id": "item_15238",
    "Last Name": "Ho",
    "First Name": "Phong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562821": {
    "id": "item_12975",
    "Last Name": "LE VAN",
    "First Name": "CUONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36563391": {
    "id": "item_4134",
    "Last Name": "Luna",
    "First Name": "Denver Clark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36563503": {
    "id": "item_27710",
    "Last Name": "Cervantes",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36563699": {
    "id": "item_29585",
    "Last Name": "Yuen",
    "First Name": "Kit Man",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36564505": {
    "id": "item_4132",
    "Last Name": "Kerr",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36565336": {
    "id": "item_2436",
    "Last Name": "Wardley",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36565529": {
    "id": "item_15232",
    "Last Name": "Andrew",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36565630": {
    "id": "item_4131",
    "Last Name": "Lilley",
    "First Name": "Rowan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36565909": {
    "id": "item_182",
    "Last Name": "Ucchino",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36566005": {
    "id": "item_27708",
    "Last Name": "Chang",
    "First Name": "Fang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36566639": {
    "id": "item_15228",
    "Last Name": "Laxamana",
    "First Name": "Jareth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36566840": {
    "id": "item_4128",
    "Last Name": "Chen",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36566991": {
    "id": "item_12875",
    "Last Name": "Tang",
    "First Name": "Hui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36567155": {
    "id": "item_4122",
    "Last Name": "Johnson",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36567394": {
    "id": "item_4126",
    "Last Name": "Gaston",
    "First Name": "John Carlos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36567940": {
    "id": "item_2111",
    "Last Name": "Yacoub",
    "First Name": "Hany",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36567998": {
    "id": "item_4124",
    "Last Name": "Bistram",
    "First Name": "Caelan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568002": {
    "id": "item_4125",
    "Last Name": "Tompsett",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568014": {
    "id": "item_2108",
    "Last Name": "Devnani",
    "First Name": "Tarun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568033": {
    "id": "item_4465",
    "Last Name": "Clark",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568100": {
    "id": "item_27662",
    "Last Name": "Nursatrio",
    "First Name": "Arief",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568660": {
    "id": "item_180",
    "Last Name": "Ovenstone",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568670": {
    "id": "item_15215",
    "Last Name": "Buckley",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568672": {
    "id": "item_179",
    "Last Name": "Sewell",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569075": {
    "id": "item_4464",
    "Last Name": "Dighton",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569322": {
    "id": "item_2107",
    "Last Name": "Crozier",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569329": {
    "id": "item_4462",
    "Last Name": "Shiu",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569335": {
    "id": "item_15039",
    "Last Name": "Dang",
    "First Name": "Binh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569338": {
    "id": "item_15213",
    "Last Name": "Fung",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569363": {
    "id": "item_173",
    "Last Name": "Wang",
    "First Name": "Xianghui",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569372": {
    "id": "item_2106",
    "Last Name": "Dixon",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569380": {
    "id": "item_4669",
    "Last Name": "Golledge",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569390": {
    "id": "item_27706",
    "Last Name": "Hadadi",
    "First Name": "Guru",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569398": {
    "id": "item_29833",
    "Last Name": "Derham",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569440": {
    "id": "item_15209",
    "Last Name": "Presl",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569479": {
    "id": "item_2301",
    "Last Name": "Gray",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569624": {
    "id": "item_27880",
    "Last Name": "Davis",
    "First Name": "Lizzie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569806": {
    "id": "item_29628",
    "Last Name": "Nocon",
    "First Name": "Manuel Jr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570091": {
    "id": "item_12901",
    "Last Name": "Lee",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570101": {
    "id": "item_2104",
    "Last Name": "Reisen",
    "First Name": "Larry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570143": {
    "id": "item_15207",
    "Last Name": "Lu",
    "First Name": "Sai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570175": {
    "id": "item_29745",
    "Last Name": "Ko",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570590": {
    "id": "item_29584",
    "Last Name": "Reyes",
    "First Name": "Graciello",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570674": {
    "id": "item_15206",
    "Last Name": "Marett",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570693": {
    "id": "item_27800",
    "Last Name": "Ko",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36571411": {
    "id": "item_27912",
    "Last Name": "LEE",
    "First Name": "MONICA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36571760": {
    "id": "item_15204",
    "Last Name": "Neo",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36571859": {
    "id": "item_15199",
    "Last Name": "Dahiya",
    "First Name": "Ajay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36571951": {
    "id": "item_29744",
    "Last Name": "Varma",
    "First Name": "Lakshmi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572266": {
    "id": "item_15634",
    "Last Name": "Thornton",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572361": {
    "id": "item_15631",
    "Last Name": "Barwick",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572460": {
    "id": "item_2296",
    "Last Name": "Nyenuh",
    "First Name": "Kay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572632": {
    "id": "item_15201",
    "Last Name": "Lind",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572711": {
    "id": "item_2297",
    "Last Name": "Hodgson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572871": {
    "id": "item_4460",
    "Last Name": "Richards",
    "First Name": "Junior",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572881": {
    "id": "item_27661",
    "Last Name": "KE",
    "First Name": "LIHONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573482": {
    "id": "item_15192",
    "Last Name": "Cottell",
    "First Name": "Sheree",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573571": {
    "id": "item_170",
    "Last Name": "Ku",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573681": {
    "id": "item_2102",
    "Last Name": "Kwon",
    "First Name": "Jooho",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573702": {
    "id": "item_4668",
    "Last Name": "Macintyre",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573711": {
    "id": "item_27704",
    "Last Name": "Saad",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573720": {
    "id": "item_27703",
    "Last Name": "vien",
    "First Name": "michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36574065": {
    "id": "item_2294",
    "Last Name": "Wickham",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36574422": {
    "id": "item_15194",
    "Last Name": "Dumduz",
    "First Name": "Ilter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36574640": {
    "id": "item_2096",
    "Last Name": "O'Brien",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36574663": {
    "id": "item_27702",
    "Last Name": "Schep",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575224": {
    "id": "item_2097",
    "Last Name": "Leary",
    "First Name": "Garth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575621": {
    "id": "item_4106",
    "Last Name": "Gerlach",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575933": {
    "id": "item_15902",
    "Last Name": "Harris",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575950": {
    "id": "item_4667",
    "Last Name": "Milles",
    "First Name": "Pete",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575954": {
    "id": "item_2094",
    "Last Name": "Betteridge",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575959": {
    "id": "item_15187",
    "Last Name": "Roberts",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575961": {
    "id": "item_15037",
    "Last Name": "Samiono",
    "First Name": "Risky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575965": {
    "id": "item_15629",
    "Last Name": "Digby",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575977": {
    "id": "item_15628",
    "Last Name": "Lee",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575993": {
    "id": "item_29580",
    "Last Name": "Cooper",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575994": {
    "id": "item_27799",
    "Last Name": "Poole",
    "First Name": "Bev",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575997": {
    "id": "item_15036",
    "Last Name": "RACHMATTULLOH",
    "First Name": "ARIEF",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575998": {
    "id": "item_15901",
    "Last Name": "Dowman",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576001": {
    "id": "item_4456",
    "Last Name": "Zhang",
    "First Name": "Yu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576020": {
    "id": "item_2293",
    "Last Name": "McIntyre",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576031": {
    "id": "item_358",
    "Last Name": "Madsen",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576039": {
    "id": "item_15035",
    "Last Name": "TuÕakoi",
    "First Name": "Rhegan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576044": {
    "id": "item_4666",
    "Last Name": "Muhammad",
    "First Name": "Abu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576053": {
    "id": "item_118",
    "Last Name": "TAN",
    "First Name": "RENJUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576057": {
    "id": "item_2092",
    "Last Name": "Almeida Machado",
    "First Name": "Alysson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576064": {
    "id": "item_4454",
    "Last Name": "Conn",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576084": {
    "id": "item_4102",
    "Last Name": "Leva",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576111": {
    "id": "item_4498",
    "Last Name": "Jones",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576123": {
    "id": "item_12895",
    "Last Name": "PUIG CARDUS",
    "First Name": "MARC",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576142": {
    "id": "item_4099",
    "Last Name": "Ahn",
    "First Name": "Jungah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576144": {
    "id": "item_15185",
    "Last Name": "Dutton",
    "First Name": "Phebe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576156": {
    "id": "item_165",
    "Last Name": "Smith",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576162": {
    "id": "item_357",
    "Last Name": "McTaggart",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576172": {
    "id": "item_4097",
    "Last Name": "Pelligra",
    "First Name": "Taran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576181": {
    "id": "item_27798",
    "Last Name": "Bin sabran",
    "First Name": "Mohd sahir",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576184": {
    "id": "item_15181",
    "Last Name": "Skoloudova",
    "First Name": "Martina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576214": {
    "id": "item_27659",
    "Last Name": "Lopez",
    "First Name": "Mary Rose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576233": {
    "id": "item_29623",
    "Last Name": "MERRILEES",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576237": {
    "id": "item_15178",
    "Last Name": "Jones",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576242": {
    "id": "item_15620",
    "Last Name": "Robinson",
    "First Name": "Sonia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576245": {
    "id": "item_4452",
    "Last Name": "Kearns",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576254": {
    "id": "item_29620",
    "Last Name": "Ly",
    "First Name": "Quoc",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576273": {
    "id": "item_29622",
    "Last Name": "Kasai",
    "First Name": "Hiroko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576291": {
    "id": "item_15034",
    "Last Name": "Payne",
    "First Name": "Milan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576318": {
    "id": "item_2087",
    "Last Name": "Tsai",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576320": {
    "id": "item_27797",
    "Last Name": "Reyes",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576323": {
    "id": "item_4451",
    "Last Name": "Duncan",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576345": {
    "id": "item_15174",
    "Last Name": "Grieve",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576378": {
    "id": "item_2291",
    "Last Name": "p",
    "First Name": "vivienne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576389": {
    "id": "item_15900",
    "Last Name": "Burgess",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576397": {
    "id": "item_15172",
    "Last Name": "Mak",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576412": {
    "id": "item_15171",
    "Last Name": "Bathurst",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576441": {
    "id": "item_164",
    "Last Name": "Cernev",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576445": {
    "id": "item_162",
    "Last Name": "Michelin",
    "First Name": "Arnaud",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576503": {
    "id": "item_15032",
    "Last Name": "Hendrawan",
    "First Name": "Kartika",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576505": {
    "id": "item_15616",
    "Last Name": "Kidd",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576511": {
    "id": "item_2085",
    "Last Name": "Bermingham",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576512": {
    "id": "item_15166",
    "Last Name": "Barszczewski",
    "First Name": "Pawel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576530": {
    "id": "item_2435",
    "Last Name": "Twohill",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576537": {
    "id": "item_4448",
    "Last Name": "Muncan",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576553": {
    "id": "item_161",
    "Last Name": "Murphy",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576581": {
    "id": "item_15165",
    "Last Name": "Kwong",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576587": {
    "id": "item_4091",
    "Last Name": "Shand",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576609": {
    "id": "item_29615",
    "Last Name": "Rainey",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576618": {
    "id": "item_2288",
    "Last Name": "Zeng",
    "First Name": "Guoming",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576622": {
    "id": "item_12872",
    "Last Name": "Lai",
    "First Name": "Chi Keung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576708": {
    "id": "item_2286",
    "Last Name": "Bloom",
    "First Name": "Suki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576714": {
    "id": "item_4088",
    "Last Name": "Papandrea",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576716": {
    "id": "item_2077",
    "Last Name": "Valdez",
    "First Name": "Grace",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576718": {
    "id": "item_15159",
    "Last Name": "Browning",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576724": {
    "id": "item_158",
    "Last Name": "Tyler",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576742": {
    "id": "item_4086",
    "Last Name": "Cameron",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576755": {
    "id": "item_27693",
    "Last Name": "Crook",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576779": {
    "id": "item_4665",
    "Last Name": "Edwards",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576784": {
    "id": "item_354",
    "Last Name": "Young",
    "First Name": "Devin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576796": {
    "id": "item_29611",
    "Last Name": "Montgomery",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576798": {
    "id": "item_4085",
    "Last Name": "Nilsson",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576814": {
    "id": "item_15612",
    "Last Name": "Beavis",
    "First Name": "Delwyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576836": {
    "id": "item_115",
    "Last Name": "Becerril",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576856": {
    "id": "item_15610",
    "Last Name": "Barker",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576905": {
    "id": "item_15155",
    "Last Name": "Merriman",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576907": {
    "id": "item_15153",
    "Last Name": "Fu",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576911": {
    "id": "item_27691",
    "Last Name": "Darren",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576918": {
    "id": "item_155",
    "Last Name": "Skilton",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576941": {
    "id": "item_29579",
    "Last Name": "AVILA",
    "First Name": "MARK GREGORY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576945": {
    "id": "item_2074",
    "Last Name": "Smyrk",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576959": {
    "id": "item_27658",
    "Last Name": "Pham",
    "First Name": "Phuong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576973": {
    "id": "item_29609",
    "Last Name": "Amaral",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576975": {
    "id": "item_27690",
    "Last Name": "Armstrong",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576985": {
    "id": "item_2073",
    "Last Name": "Liu",
    "First Name": "Jianwei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577016": {
    "id": "item_353",
    "Last Name": "Holiday",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577026": {
    "id": "item_15150",
    "Last Name": "Shah",
    "First Name": "Kallol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577029": {
    "id": "item_2072",
    "Last Name": "Martines",
    "First Name": "Alessandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577030": {
    "id": "item_27891",
    "Last Name": "Morgan",
    "First Name": "Frankie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577032": {
    "id": "item_4441",
    "Last Name": "Morales",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577040": {
    "id": "item_153",
    "Last Name": "McNamara",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577060": {
    "id": "item_15147",
    "Last Name": "SWEENEY",
    "First Name": "GAVIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577101": {
    "id": "item_12893",
    "Last Name": "Howard",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577102": {
    "id": "item_15029",
    "Last Name": "Suratno",
    "First Name": "Suratno",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577119": {
    "id": "item_2283",
    "Last Name": "LEE",
    "First Name": "HYUN A",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577134": {
    "id": "item_15141",
    "Last Name": "Wilson",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577162": {
    "id": "item_15608",
    "Last Name": "Lum",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577172": {
    "id": "item_4007",
    "Last Name": "Ghassemi",
    "First Name": "Afshin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577173": {
    "id": "item_152",
    "Last Name": "Bacho",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577189": {
    "id": "item_27686",
    "Last Name": "Zheng",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577212": {
    "id": "item_15605",
    "Last Name": "Robinson",
    "First Name": "Haydn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577214": {
    "id": "item_2068",
    "Last Name": "Shallvey",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577277": {
    "id": "item_15601",
    "Last Name": "Beech",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577291": {
    "id": "item_15139",
    "Last Name": "Thamrin",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577292": {
    "id": "item_15599",
    "Last Name": "Liu",
    "First Name": "Jia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577313": {
    "id": "item_4078",
    "Last Name": "Jirgensons",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577327": {
    "id": "item_15138",
    "Last Name": "Martin",
    "First Name": "Yzabelle Lian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577334": {
    "id": "item_149",
    "Last Name": "Webster",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577338": {
    "id": "item_2066",
    "Last Name": "McSherry",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577369": {
    "id": "item_2065",
    "Last Name": "Elmi",
    "First Name": "Mohammadreza",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577378": {
    "id": "item_4664",
    "Last Name": "Auton",
    "First Name": "Travis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577381": {
    "id": "item_2064",
    "Last Name": "Calavassy",
    "First Name": "Bernie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577397": {
    "id": "item_4005",
    "Last Name": "Daza",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577398": {
    "id": "item_27684",
    "Last Name": "Parsotam",
    "First Name": "Hetal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577415": {
    "id": "item_2281",
    "Last Name": "WANG",
    "First Name": "HAIYUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577416": {
    "id": "item_15597",
    "Last Name": "Kaippilly Ebrahimkutty",
    "First Name": "Anil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577419": {
    "id": "item_2023",
    "Last Name": "FOO",
    "First Name": "KIA GIE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577421": {
    "id": "item_15593",
    "Last Name": "Fenech",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577428": {
    "id": "item_15026",
    "Last Name": "Pieters",
    "First Name": "Jabez",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577430": {
    "id": "item_2280",
    "Last Name": "De La Rosa",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577434": {
    "id": "item_4437",
    "Last Name": "Hockings",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577454": {
    "id": "item_2063",
    "Last Name": "Smith",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577477": {
    "id": "item_29606",
    "Last Name": "Chen",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577495": {
    "id": "item_15595",
    "Last Name": "Robinson",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577499": {
    "id": "item_15133",
    "Last Name": "Bui",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577513": {
    "id": "item_15129",
    "Last Name": "Treseder",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577526": {
    "id": "item_12971",
    "Last Name": "OÕNeill",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577532": {
    "id": "item_15025",
    "Last Name": "chen",
    "First Name": "hao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577549": {
    "id": "item_4073",
    "Last Name": "Duke",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577553": {
    "id": "item_15127",
    "Last Name": "Onte",
    "First Name": "Brendelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577554": {
    "id": "item_4433",
    "Last Name": "Bowman",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577558": {
    "id": "item_4071",
    "Last Name": "Xie",
    "First Name": "Guolin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577561": {
    "id": "item_349",
    "Last Name": "Ko",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577565": {
    "id": "item_146",
    "Last Name": "Smith",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577566": {
    "id": "item_2062",
    "Last Name": "Webster",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577577": {
    "id": "item_15124",
    "Last Name": "Auppachatai",
    "First Name": "Tittaya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577600": {
    "id": "item_4070",
    "Last Name": "Orchard",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577601": {
    "id": "item_145",
    "Last Name": "Sisson",
    "First Name": "Finn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577633": {
    "id": "item_15122",
    "Last Name": "Ly",
    "First Name": "Pearl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577638": {
    "id": "item_15121",
    "Last Name": "Jurado",
    "First Name": "Jose",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577654": {
    "id": "item_27792",
    "Last Name": "Anderson",
    "First Name": "Colin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577667": {
    "id": "item_2434",
    "Last Name": "Jagoe",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577686": {
    "id": "item_12890",
    "Last Name": "Barden",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577689": {
    "id": "item_4066",
    "Last Name": "Smith",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577698": {
    "id": "item_29605",
    "Last Name": "Kennedy",
    "First Name": "Phil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577703": {
    "id": "item_29604",
    "Last Name": "Shirtley",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577711": {
    "id": "item_4663",
    "Last Name": "Jeanes",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577722": {
    "id": "item_15116",
    "Last Name": "O'Sullivan",
    "First Name": "Allan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577727": {
    "id": "item_4063",
    "Last Name": "Tan",
    "First Name": "Winston",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577773": {
    "id": "item_29740",
    "Last Name": "Munoz",
    "First Name": "Kissairis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577795": {
    "id": "item_15112",
    "Last Name": "Dickfos",
    "First Name": "Rhiannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577811": {
    "id": "item_2061",
    "Last Name": "Kuechler",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577843": {
    "id": "item_2060",
    "Last Name": "Hegarty",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577873": {
    "id": "item_15587",
    "Last Name": "Nguyen",
    "First Name": "Huy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577890": {
    "id": "item_4056",
    "Last Name": "Hickey",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577899": {
    "id": "item_15110",
    "Last Name": "Down",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577913": {
    "id": "item_4055",
    "Last Name": "Xu",
    "First Name": "Yan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577915": {
    "id": "item_12868",
    "Last Name": "Di–o",
    "First Name": "Danilo IV",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577930": {
    "id": "item_27679",
    "Last Name": "Robertson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577939": {
    "id": "item_2020",
    "Last Name": "Romano",
    "First Name": "Maria D",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577944": {
    "id": "item_27680",
    "Last Name": "Lugod",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577945": {
    "id": "item_15109",
    "Last Name": "Cano",
    "First Name": "Garvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577954": {
    "id": "item_12867",
    "Last Name": "Lui",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577995": {
    "id": "item_15108",
    "Last Name": "So",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578007": {
    "id": "item_347",
    "Last Name": "Luo",
    "First Name": "Yu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578012": {
    "id": "item_15107",
    "Last Name": "Putra",
    "First Name": "Derrie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578028": {
    "id": "item_111",
    "Last Name": "Piyavechviratana",
    "First Name": "Kunchit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578040": {
    "id": "item_13035",
    "Last Name": "Munn",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578066": {
    "id": "item_2055",
    "Last Name": "Bulan",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578082": {
    "id": "item_4425",
    "Last Name": "De Marchi",
    "First Name": "Kirk",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578084": {
    "id": "item_15583",
    "Last Name": "Shapiro",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578085": {
    "id": "item_15580",
    "Last Name": "Domondon",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578092": {
    "id": "item_27678",
    "Last Name": "Han",
    "First Name": "Yu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578108": {
    "id": "item_15020",
    "Last Name": "Mahmoud",
    "First Name": "Hemadi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578113": {
    "id": "item_12968",
    "Last Name": "Lee",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578127": {
    "id": "item_4424",
    "Last Name": "Sakavarapu",
    "First Name": "Murali",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578132": {
    "id": "item_15582",
    "Last Name": "Ifurung",
    "First Name": "Gregorio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578145": {
    "id": "item_15581",
    "Last Name": "Shelton",
    "First Name": "Bradd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578147": {
    "id": "item_15103",
    "Last Name": "White",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578154": {
    "id": "item_15104",
    "Last Name": "So",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578156": {
    "id": "item_4421",
    "Last Name": "Shane",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578189": {
    "id": "item_27654",
    "Last Name": "Wei",
    "First Name": "Zhou",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578208": {
    "id": "item_15018",
    "Last Name": "HONG",
    "First Name": "GUAT SHIAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578209": {
    "id": "item_29598",
    "Last Name": "Marabut",
    "First Name": "Ritchie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578223": {
    "id": "item_109",
    "Last Name": "DENG",
    "First Name": "CHUNHUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578236": {
    "id": "item_2017",
    "Last Name": "Hao",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578260": {
    "id": "item_29599",
    "Last Name": "Manjunath",
    "First Name": "Raghavendra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578261": {
    "id": "item_27655",
    "Last Name": "Roper Jr",
    "First Name": "Ranford",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578302": {
    "id": "item_15100",
    "Last Name": "Garnett",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578305": {
    "id": "item_29738",
    "Last Name": "Stephenson",
    "First Name": "Lahni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578311": {
    "id": "item_2449",
    "Last Name": "Smith",
    "First Name": "Janet",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578360": {
    "id": "item_138",
    "Last Name": "Robinson",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578381": {
    "id": "item_137",
    "Last Name": "Zaid",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578406": {
    "id": "item_2015",
    "Last Name": "YOT",
    "First Name": "Jocelyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578430": {
    "id": "item_15014",
    "Last Name": "Oh",
    "First Name": "Edward Thye Soong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578439": {
    "id": "item_12866",
    "Last Name": "ZHANG",
    "First Name": "HONGFANG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578440": {
    "id": "item_29595",
    "Last Name": "Guico",
    "First Name": "Josua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578484": {
    "id": "item_4045",
    "Last Name": "Turner",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578531": {
    "id": "item_15093",
    "Last Name": "De Cian",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578539": {
    "id": "item_4042",
    "Last Name": "Hyslop",
    "First Name": "Malcolm",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578540": {
    "id": "item_27676",
    "Last Name": "Xu",
    "First Name": "Cathy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578544": {
    "id": "item_15012",
    "Last Name": "Seng",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578546": {
    "id": "item_15090",
    "Last Name": "Jeon",
    "First Name": "Jae Hyoung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578554": {
    "id": "item_107",
    "Last Name": "Liu",
    "First Name": "Tingyong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578567": {
    "id": "item_2051",
    "Last Name": "Murphy",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578665": {
    "id": "item_2050",
    "Last Name": "Xu",
    "First Name": "Chang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578705": {
    "id": "item_343",
    "Last Name": "Bonandrini",
    "First Name": "Warren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578711": {
    "id": "item_108",
    "Last Name": "Wang",
    "First Name": "Yiqing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578713": {
    "id": "item_12885",
    "Last Name": "Attri",
    "First Name": "Aviraj",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578718": {
    "id": "item_4662",
    "Last Name": "Carlson",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578734": {
    "id": "item_2049",
    "Last Name": "Trainor",
    "First Name": "Eavan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578735": {
    "id": "item_4039",
    "Last Name": "Staude",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578738": {
    "id": "item_29591",
    "Last Name": "Marsh",
    "First Name": "Shaina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578822": {
    "id": "item_15010",
    "Last Name": "Oh",
    "First Name": "Chung Man Jacqueline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578856": {
    "id": "item_15081",
    "Last Name": "Millward",
    "First Name": "Alanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578874": {
    "id": "item_12882",
    "Last Name": "Vella",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578906": {
    "id": "item_27669",
    "Last Name": "Lum",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578934": {
    "id": "item_27879",
    "Last Name": "yilmaz",
    "First Name": "nahit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578936": {
    "id": "item_15009",
    "Last Name": "Russell",
    "First Name": "Cherry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578944": {
    "id": "item_15008",
    "Last Name": "Gesulga",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578948": {
    "id": "item_135",
    "Last Name": "Godsk",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578953": {
    "id": "item_27653",
    "Last Name": "MIAH",
    "First Name": "MD AL AMIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578962": {
    "id": "item_2047",
    "Last Name": "Lam",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578979": {
    "id": "item_2046",
    "Last Name": "Tan",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579028": {
    "id": "item_4417",
    "Last Name": "Butler",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579046": {
    "id": "item_2272",
    "Last Name": "Lam",
    "First Name": "Wai Hung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579084": {
    "id": "item_15899",
    "Last Name": "Juvika",
    "First Name": "Juvika",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579085": {
    "id": "item_15074",
    "Last Name": "Singh",
    "First Name": "Harjeet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579092": {
    "id": "item_4413",
    "Last Name": "Mafurutu",
    "First Name": "Leonard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579096": {
    "id": "item_15005",
    "Last Name": "Houtaa",
    "First Name": "Sungkar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579112": {
    "id": "item_15007",
    "Last Name": "Kasau",
    "First Name": "Fadlun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579119": {
    "id": "item_15571",
    "Last Name": "Gumina",
    "First Name": "Carmelo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579138": {
    "id": "item_3989",
    "Last Name": "Hwang",
    "First Name": "Jong Min",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579149": {
    "id": "item_340",
    "Last Name": "Simpson",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579157": {
    "id": "item_15073",
    "Last Name": "Ekanayake",
    "First Name": "Sanka",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579175": {
    "id": "item_4031",
    "Last Name": "Andrews",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579180": {
    "id": "item_15004",
    "Last Name": "Gao",
    "First Name": "YUAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579252": {
    "id": "item_15898",
    "Last Name": "Physick",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579260": {
    "id": "item_12879",
    "Last Name": "Zhang",
    "First Name": "Jinwang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579281": {
    "id": "item_2269",
    "Last Name": "Cross",
    "First Name": "Zac",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579311": {
    "id": "item_15567",
    "Last Name": "Vella",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579321": {
    "id": "item_15070",
    "Last Name": "Dodds",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579327": {
    "id": "item_15069",
    "Last Name": "Huynh",
    "First Name": "Hy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579344": {
    "id": "item_130",
    "Last Name": "Mullan",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579396": {
    "id": "item_337",
    "Last Name": "Reyes",
    "First Name": "Rudmark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579398": {
    "id": "item_12865",
    "Last Name": "Go",
    "First Name": "Siegfried",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579405": {
    "id": "item_27878",
    "Last Name": "Bowen",
    "First Name": "Lesley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579442": {
    "id": "item_127",
    "Last Name": "Davoren",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579449": {
    "id": "item_15897",
    "Last Name": "Peel-Yates",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579457": {
    "id": "item_4026",
    "Last Name": "Rufila",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579459": {
    "id": "item_125",
    "Last Name": "Sterk",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579495": {
    "id": "item_15066",
    "Last Name": "Imbao",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579503": {
    "id": "item_336",
    "Last Name": "Perrott",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579511": {
    "id": "item_29573",
    "Last Name": "Cordova",
    "First Name": "Gian Karlo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579586": {
    "id": "item_15061",
    "Last Name": "Lyle",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579588": {
    "id": "item_2268",
    "Last Name": "CHENG",
    "First Name": "JINXIA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579614": {
    "id": "item_2267",
    "Last Name": "Patil",
    "First Name": "Suchir",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579677": {
    "id": "item_27651",
    "Last Name": "Vining",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579687": {
    "id": "item_491",
    "Last Name": "Bourke",
    "First Name": "Pat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579691": {
    "id": "item_15059",
    "Last Name": "Meadows",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579699": {
    "id": "item_15896",
    "Last Name": "Cox",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579705": {
    "id": "item_15001",
    "Last Name": "Yuwono",
    "First Name": "Titus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579723": {
    "id": "item_4409",
    "Last Name": "Chapman",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579727": {
    "id": "item_4023",
    "Last Name": "Canning",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579729": {
    "id": "item_4022",
    "Last Name": "Hirschhorn",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579730": {
    "id": "item_2033",
    "Last Name": "Fuda",
    "First Name": "Dale",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579733": {
    "id": "item_2034",
    "Last Name": "Hammami",
    "First Name": "Aiham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579741": {
    "id": "item_27666",
    "Last Name": "Yoong",
    "First Name": "Yong Kit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579742": {
    "id": "item_15564",
    "Last Name": "Lopes Reis",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579765": {
    "id": "item_4021",
    "Last Name": "Bertoni",
    "First Name": "Federico",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579789": {
    "id": "item_15051",
    "Last Name": "Wong",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579793": {
    "id": "item_15052",
    "Last Name": "Li",
    "First Name": "Ricco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579794": {
    "id": "item_29572",
    "Last Name": "Tindall",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579808": {
    "id": "item_29571",
    "Last Name": "Camat",
    "First Name": "Astrid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579858": {
    "id": "item_4019",
    "Last Name": "Boxall",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579859": {
    "id": "item_4406",
    "Last Name": "Fiore",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579868": {
    "id": "item_15050",
    "Last Name": "Byrne",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579873": {
    "id": "item_15047",
    "Last Name": "Nakagawa",
    "First Name": "Yuji",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579878": {
    "id": "item_15562",
    "Last Name": "Wong",
    "First Name": "Owen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579908": {
    "id": "item_333",
    "Last Name": "Frewin",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579916": {
    "id": "item_12964",
    "Last Name": "Quinn",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579917": {
    "id": "item_15046",
    "Last Name": "Davies",
    "First Name": "Judd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579928": {
    "id": "item_27663",
    "Last Name": "Cooper",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579933": {
    "id": "item_4403",
    "Last Name": "Gale",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579941": {
    "id": "item_15045",
    "Last Name": "Griffith",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579945": {
    "id": "item_15043",
    "Last Name": "Neylan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579955": {
    "id": "item_2264",
    "Last Name": "Liew",
    "First Name": "Shan Mou",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579957": {
    "id": "item_122",
    "Last Name": "Donohoe",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579970": {
    "id": "item_12874",
    "Last Name": "Park",
    "First Name": "Laurence",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579974": {
    "id": "item_121",
    "Last Name": "Madaan",
    "First Name": "Ojas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579981": {
    "id": "item_3980",
    "Last Name": "Uychiat",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579984": {
    "id": "item_120",
    "Last Name": "Boxshall",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579990": {
    "id": "item_15040",
    "Last Name": "Fay",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580028": {
    "id": "item_14997",
    "Last Name": "Alvarez",
    "First Name": "Aleeza Denise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580038": {
    "id": "item_27877",
    "Last Name": "MacKenzie",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580063": {
    "id": "item_119",
    "Last Name": "Baltussen",
    "First Name": "Thom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580065": {
    "id": "item_15895",
    "Last Name": "Fitzgerald",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580086": {
    "id": "item_104",
    "Last Name": "zhang",
    "First Name": "lili",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580087": {
    "id": "item_29583",
    "Last Name": "Caldito",
    "First Name": "Mikko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580095": {
    "id": "item_29582",
    "Last Name": "Hu",
    "First Name": "Jiadan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580127": {
    "id": "item_27660",
    "Last Name": "OReilly",
    "First Name": "Sheila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580137": {
    "id": "item_15038",
    "Last Name": "Mcwilliams",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580139": {
    "id": "item_14996",
    "Last Name": "Ario",
    "First Name": "Arresto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580158": {
    "id": "item_4013",
    "Last Name": "Lewis",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580162": {
    "id": "item_27876",
    "Last Name": "Gay",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580177": {
    "id": "item_14995",
    "Last Name": "MOUSSAN",
    "First Name": "STEPHANE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580191": {
    "id": "item_117",
    "Last Name": "Rose",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580195": {
    "id": "item_4012",
    "Last Name": "Rust",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580210": {
    "id": "item_4400",
    "Last Name": "Jones",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580221": {
    "id": "item_14993",
    "Last Name": "Santiago",
    "First Name": "Jose Paulo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580223": {
    "id": "item_4011",
    "Last Name": "Russell",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580232": {
    "id": "item_15030",
    "Last Name": "Floyd",
    "First Name": "Carina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580237": {
    "id": "item_27647",
    "Last Name": "Ho",
    "First Name": "Sui Hong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580253": {
    "id": "item_490",
    "Last Name": "Wickham",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580257": {
    "id": "item_2433",
    "Last Name": "Clifford",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580277": {
    "id": "item_3978",
    "Last Name": "Tsai",
    "First Name": "Kuangyi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580279": {
    "id": "item_27786",
    "Last Name": "David",
    "First Name": "Ho",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580295": {
    "id": "item_12871",
    "Last Name": "Carlos",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580302": {
    "id": "item_2010",
    "Last Name": "Liu",
    "First Name": "Chunhua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580320": {
    "id": "item_114",
    "Last Name": "Kendall",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580324": {
    "id": "item_2009",
    "Last Name": "Pumipuntu",
    "First Name": "Frank",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580333": {
    "id": "item_4009",
    "Last Name": "Holden",
    "First Name": "Terry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580336": {
    "id": "item_12870",
    "Last Name": "Ma",
    "First Name": "Rui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580343": {
    "id": "item_29577",
    "Last Name": "Sudario",
    "First Name": "Edward Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580348": {
    "id": "item_4008",
    "Last Name": "Yu",
    "First Name": "Tin Yiu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580355": {
    "id": "item_29576",
    "Last Name": "Savage",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580360": {
    "id": "item_27657",
    "Last Name": "harvey",
    "First Name": "brandon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580392": {
    "id": "item_15028",
    "Last Name": "Adams",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580424": {
    "id": "item_4661",
    "Last Name": "Bush",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580451": {
    "id": "item_15559",
    "Last Name": "Pitchforth",
    "First Name": "Nikolai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580458": {
    "id": "item_113",
    "Last Name": "Collins",
    "First Name": "Myles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580470": {
    "id": "item_15027",
    "Last Name": "Rub",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580489": {
    "id": "item_14990",
    "Last Name": "Deng",
    "First Name": "Molian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580519": {
    "id": "item_4001",
    "Last Name": "Sadie",
    "First Name": "Fred",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580537": {
    "id": "item_4000",
    "Last Name": "Yu",
    "First Name": "Kwok Wing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580538": {
    "id": "item_15894",
    "Last Name": "Wood",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580552": {
    "id": "item_27890",
    "Last Name": "Garvan",
    "First Name": "Kerene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580554": {
    "id": "item_27656",
    "Last Name": "Warnant",
    "First Name": "Pascale",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580555": {
    "id": "item_12869",
    "Last Name": "Paton",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580579": {
    "id": "item_2021",
    "Last Name": "Hasenauer",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580599": {
    "id": "item_15022",
    "Last Name": "Paras",
    "First Name": "Ives",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580605": {
    "id": "item_2019",
    "Last Name": "Celik",
    "First Name": "Taha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580607": {
    "id": "item_100",
    "Last Name": "YANG",
    "First Name": "YONGPING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580618": {
    "id": "item_3996",
    "Last Name": "Ymana",
    "First Name": "Nikko",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580633": {
    "id": "item_15019",
    "Last Name": "Toussaint",
    "First Name": "Laurent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580652": {
    "id": "item_2008",
    "Last Name": "Stegeman",
    "First Name": "Coen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580657": {
    "id": "item_12963",
    "Last Name": "Forner",
    "First Name": "Marta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580664": {
    "id": "item_3993",
    "Last Name": "Chan",
    "First Name": "Shermayne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580671": {
    "id": "item_15017",
    "Last Name": "Bartley",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580706": {
    "id": "item_15555",
    "Last Name": "Rattray",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580744": {
    "id": "item_2014",
    "Last Name": "Lalic",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580754": {
    "id": "item_2013",
    "Last Name": "Lee",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580781": {
    "id": "item_3992",
    "Last Name": "Collett",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580793": {
    "id": "item_15011",
    "Last Name": "Neupane",
    "First Name": "Narendra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580823": {
    "id": "item_3990",
    "Last Name": "Shenoy",
    "First Name": "Govinda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580893": {
    "id": "item_15006",
    "Last Name": "Watanabe",
    "First Name": "Shigenobu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580901": {
    "id": "item_12962",
    "Last Name": "Donovan",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580909": {
    "id": "item_29822",
    "Last Name": "Dawson",
    "First Name": "Trish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580944": {
    "id": "item_15550",
    "Last Name": "TRINH",
    "First Name": "BENJAMIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580950": {
    "id": "item_106",
    "Last Name": "White",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580960": {
    "id": "item_15893",
    "Last Name": "Morley",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580962": {
    "id": "item_15000",
    "Last Name": "Prasertsuksom",
    "First Name": "Pornchai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580966": {
    "id": "item_29574",
    "Last Name": "WONG",
    "First Name": "Karen-anne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580975": {
    "id": "item_3985",
    "Last Name": "Gulati",
    "First Name": "Abhinov",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581018": {
    "id": "item_3983",
    "Last Name": "Pederson",
    "First Name": "Cole",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581028": {
    "id": "item_2255",
    "Last Name": "Bushby",
    "First Name": "Sonia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581054": {
    "id": "item_12864",
    "Last Name": "Cuddihy",
    "First Name": "Lucinda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581066": {
    "id": "item_3981",
    "Last Name": "Susanto",
    "First Name": "Andi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581076": {
    "id": "item_27650",
    "Last Name": "Daughton",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581093": {
    "id": "item_489",
    "Last Name": "Davies",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581105": {
    "id": "item_14998",
    "Last Name": "Williams",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581126": {
    "id": "item_103",
    "Last Name": "Lo",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581133": {
    "id": "item_14994",
    "Last Name": "Rhodes",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581134": {
    "id": "item_15892",
    "Last Name": "Ribeiro Vieira",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581136": {
    "id": "item_488",
    "Last Name": "De souza",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581140": {
    "id": "item_2011",
    "Last Name": "Briggs",
    "First Name": "Justine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581154": {
    "id": "item_27646",
    "Last Name": "Mann",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581157": {
    "id": "item_14992",
    "Last Name": "Contreras Martinez",
    "First Name": "Angel Jonatan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581173": {
    "id": "item_101",
    "Last Name": "Akashi",
    "First Name": "Akiko",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581178": {
    "id": "item_15546",
    "Last Name": "van Aswegen",
    "First Name": "Hendrik",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581181": {
    "id": "item_487",
    "Last Name": "Palmer",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581196": {
    "id": "item_2432",
    "Last Name": "Sayer",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581199": {
    "id": "item_27645",
    "Last Name": "Funase",
    "First Name": "Shuji",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581204": {
    "id": "item_14989",
    "Last Name": "Barnier",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581239": {
    "id": "item_2006",
    "Last Name": "Norton",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581247": {
    "id": "item_14987",
    "Last Name": "Gannon",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581249": {
    "id": "item_3975",
    "Last Name": "Zhang",
    "First Name": "Jingzhou",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581263": {
    "id": "item_14985",
    "Last Name": "Byrne",
    "First Name": "Padraig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581283": {
    "id": "item_13034",
    "Last Name": "Barron",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581288": {
    "id": "item_2005",
    "Last Name": "Kim",
    "First Name": "DongHwan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581301": {
    "id": "item_3973",
    "Last Name": "Tor",
    "First Name": "Kurtis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581314": {
    "id": "item_12861",
    "Last Name": "Verduin",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581335": {
    "id": "item_14982",
    "Last Name": "Cabacungan",
    "First Name": "Edmar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581348": {
    "id": "item_3972",
    "Last Name": "Stapleton",
    "First Name": "Lee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581352": {
    "id": "item_4390",
    "Last Name": "Hiller",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581361": {
    "id": "item_2251",
    "Last Name": "Qu",
    "First Name": "Bing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581373": {
    "id": "item_2252",
    "Last Name": "Schneider",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581379": {
    "id": "item_12862",
    "Last Name": "Capel",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581380": {
    "id": "item_27644",
    "Last Name": "Pritchard",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581389": {
    "id": "item_325",
    "Last Name": "Mulligan",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581397": {
    "id": "item_14979",
    "Last Name": "Xie",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581411": {
    "id": "item_27643",
    "Last Name": "Karki",
    "First Name": "Anant Raj",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581431": {
    "id": "item_97",
    "Last Name": "Casson",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581445": {
    "id": "item_2249",
    "Last Name": "Krakowiak",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581452": {
    "id": "item_15891",
    "Last Name": "Tortorici",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581460": {
    "id": "item_27642",
    "Last Name": "Abrahams",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581464": {
    "id": "item_12859",
    "Last Name": "Malig",
    "First Name": "Raymund",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581468": {
    "id": "item_4660",
    "Last Name": "Mcguiness",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581475": {
    "id": "item_14984",
    "Last Name": "Samiadji",
    "First Name": "Gunawan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581506": {
    "id": "item_96",
    "Last Name": "Reynolds",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581518": {
    "id": "item_27640",
    "Last Name": "Bailey",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581521": {
    "id": "item_2003",
    "Last Name": "Martino",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581526": {
    "id": "item_29568",
    "Last Name": "Simpson",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581534": {
    "id": "item_95",
    "Last Name": "Walker",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581543": {
    "id": "item_27782",
    "Last Name": "Clark",
    "First Name": "Alli",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581550": {
    "id": "item_2248",
    "Last Name": "Fanucci",
    "First Name": "Leonard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581582": {
    "id": "item_27639",
    "Last Name": "Arbis",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581587": {
    "id": "item_2431",
    "Last Name": "Birsanu",
    "First Name": "Marius",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581594": {
    "id": "item_14970",
    "Last Name": "Karami",
    "First Name": "Erfan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581647": {
    "id": "item_3969",
    "Last Name": "Mccleary",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581660": {
    "id": "item_4659",
    "Last Name": "Mudie",
    "First Name": "Iain",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581664": {
    "id": "item_27875",
    "Last Name": "Morris",
    "First Name": "Charlene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581665": {
    "id": "item_3968",
    "Last Name": "Goodsir",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581681": {
    "id": "item_15538",
    "Last Name": "de Jesus",
    "First Name": "Bea Alexie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581693": {
    "id": "item_3967",
    "Last Name": "Doheny",
    "First Name": "Orl",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581694": {
    "id": "item_3965",
    "Last Name": "Buckley",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581713": {
    "id": "item_4385",
    "Last Name": "Dickie",
    "First Name": "Leroy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581715": {
    "id": "item_91",
    "Last Name": "Franklin",
    "First Name": "Jo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581719": {
    "id": "item_29563",
    "Last Name": "Peart",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581725": {
    "id": "item_4386",
    "Last Name": "Nancolas",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581745": {
    "id": "item_14964",
    "Last Name": "Smith",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581771": {
    "id": "item_12857",
    "Last Name": "Smith",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581774": {
    "id": "item_3963",
    "Last Name": "Huang",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581782": {
    "id": "item_27874",
    "Last Name": "Patterson",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581798": {
    "id": "item_15890",
    "Last Name": "Sanderson",
    "First Name": "Rachele",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581803": {
    "id": "item_3961",
    "Last Name": "SHI",
    "First Name": "WEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581809": {
    "id": "item_27635",
    "Last Name": "Sheridan",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581824": {
    "id": "item_4658",
    "Last Name": "Ceroni",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581826": {
    "id": "item_14961",
    "Last Name": "Watts",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581833": {
    "id": "item_4384",
    "Last Name": "Zhao",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581837": {
    "id": "item_12855",
    "Last Name": "Bruce",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581839": {
    "id": "item_1998",
    "Last Name": "Fryirs",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581844": {
    "id": "item_29561",
    "Last Name": "Beckett",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581851": {
    "id": "item_14958",
    "Last Name": "Franklin",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581859": {
    "id": "item_27781",
    "Last Name": "Campbell",
    "First Name": "Cathy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581860": {
    "id": "item_87",
    "Last Name": "Doyle",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581905": {
    "id": "item_86",
    "Last Name": "Sakiyama",
    "First Name": "Yoshinori",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581909": {
    "id": "item_14954",
    "Last Name": "Lennon",
    "First Name": "Molly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581919": {
    "id": "item_15532",
    "Last Name": "Maskell",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581923": {
    "id": "item_4383",
    "Last Name": "Luke",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581924": {
    "id": "item_4382",
    "Last Name": "Scarborough",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581925": {
    "id": "item_29560",
    "Last Name": "VALENTON",
    "First Name": "PAUL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581928": {
    "id": "item_29821",
    "Last Name": "Juan",
    "First Name": "Paulo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581943": {
    "id": "item_85",
    "Last Name": "Sun",
    "First Name": "Pingyang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581949": {
    "id": "item_2244",
    "Last Name": "Brownlie",
    "First Name": "Kai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581952": {
    "id": "item_14950",
    "Last Name": "Hou",
    "First Name": "Yongpeng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581953": {
    "id": "item_14948",
    "Last Name": "Solo",
    "First Name": "Han",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581954": {
    "id": "item_15531",
    "Last Name": "Grantham",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581983": {
    "id": "item_15528",
    "Last Name": "CHANDRA",
    "First Name": "Sandeep",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582003": {
    "id": "item_15527",
    "Last Name": "Wall",
    "First Name": "Edith Clare",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582004": {
    "id": "item_27873",
    "Last Name": "McCorriston",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582010": {
    "id": "item_29729",
    "Last Name": "Shameem",
    "First Name": "Tarafder",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582012": {
    "id": "item_29557",
    "Last Name": "Tang",
    "First Name": "Wanyu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582017": {
    "id": "item_2430",
    "Last Name": "OÕNeile",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582021": {
    "id": "item_15889",
    "Last Name": "Ibrahim",
    "First Name": "Ibrahim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582026": {
    "id": "item_12853",
    "Last Name": "Santoya",
    "First Name": "Amos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582036": {
    "id": "item_27632",
    "Last Name": "Mudie",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582054": {
    "id": "item_15524",
    "Last Name": "hopper",
    "First Name": "steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582059": {
    "id": "item_1997",
    "Last Name": "Bekker",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582064": {
    "id": "item_3958",
    "Last Name": "West",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582068": {
    "id": "item_1995",
    "Last Name": "Whiteford",
    "First Name": "Rohan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582081": {
    "id": "item_81",
    "Last Name": "Van der Velde",
    "First Name": "Leonard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582084": {
    "id": "item_27630",
    "Last Name": "Kang",
    "First Name": "Norman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582103": {
    "id": "item_29820",
    "Last Name": "Thambar",
    "First Name": "Samara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582126": {
    "id": "item_29819",
    "Last Name": "Francis",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582133": {
    "id": "item_2004",
    "Last Name": "Rogers",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582146": {
    "id": "item_3953",
    "Last Name": "Olson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582162": {
    "id": "item_27641",
    "Last Name": "Roennow",
    "First Name": "Tor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582165": {
    "id": "item_27628",
    "Last Name": "GRAHAM",
    "First Name": "HOPE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582167": {
    "id": "item_12852",
    "Last Name": "LOGGENBERG",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582169": {
    "id": "item_4375",
    "Last Name": "Tsien",
    "First Name": "Imogen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582173": {
    "id": "item_1992",
    "Last Name": "Luc",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582174": {
    "id": "item_1993",
    "Last Name": "Wagner",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582176": {
    "id": "item_4657",
    "Last Name": "Tunnard",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582181": {
    "id": "item_14946",
    "Last Name": "Boswell",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582191": {
    "id": "item_14944",
    "Last Name": "Cohen",
    "First Name": "Jade",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582210": {
    "id": "item_1991",
    "Last Name": "Trewhella",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582220": {
    "id": "item_1990",
    "Last Name": "Byrne",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582231": {
    "id": "item_14941",
    "Last Name": "Zhao",
    "First Name": "Lujia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582235": {
    "id": "item_12851",
    "Last Name": "Gamble",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582239": {
    "id": "item_4656",
    "Last Name": "Bolt",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582247": {
    "id": "item_14938",
    "Last Name": "Hulme",
    "First Name": "Spencer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582250": {
    "id": "item_1989",
    "Last Name": "James",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582251": {
    "id": "item_12850",
    "Last Name": "Rak",
    "First Name": "Derek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582252": {
    "id": "item_3948",
    "Last Name": "Gemberg",
    "First Name": "Alexey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582254": {
    "id": "item_14934",
    "Last Name": "Cai",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582257": {
    "id": "item_14933",
    "Last Name": "Baker",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582265": {
    "id": "item_3947",
    "Last Name": "Collett",
    "First Name": "Monica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582275": {
    "id": "item_15888",
    "Last Name": "Burchill",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582276": {
    "id": "item_15887",
    "Last Name": "Macaulay",
    "First Name": "Cath",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582280": {
    "id": "item_486",
    "Last Name": "Howen",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582282": {
    "id": "item_1988",
    "Last Name": "James",
    "First Name": "Bart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582289": {
    "id": "item_80",
    "Last Name": "Karpes",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582295": {
    "id": "item_1985",
    "Last Name": "Rich",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582305": {
    "id": "item_29728",
    "Last Name": "Flukes",
    "First Name": "Penny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582318": {
    "id": "item_3946",
    "Last Name": "Jamadagni",
    "First Name": "Ani",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582320": {
    "id": "item_316",
    "Last Name": "Lung",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582324": {
    "id": "item_4374",
    "Last Name": "Gementiza",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582327": {
    "id": "item_78",
    "Last Name": "Heng",
    "First Name": "Ronnie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582341": {
    "id": "item_14927",
    "Last Name": "Serretta",
    "First Name": "Dave",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582359": {
    "id": "item_3943",
    "Last Name": "Lockhart",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582361": {
    "id": "item_3942",
    "Last Name": "Coleman",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582379": {
    "id": "item_15520",
    "Last Name": "O'Neill",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582395": {
    "id": "item_4655",
    "Last Name": "Rama",
    "First Name": "Shervin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582400": {
    "id": "item_15519",
    "Last Name": "Gottliebsen",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582402": {
    "id": "item_14922",
    "Last Name": "Weidmann",
    "First Name": "Ingo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582405": {
    "id": "item_2002",
    "Last Name": "Pope",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582424": {
    "id": "item_27617",
    "Last Name": "Edwards",
    "First Name": "Nikkita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582434": {
    "id": "item_15518",
    "Last Name": "Marshall",
    "First Name": "Bryn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582439": {
    "id": "item_12847",
    "Last Name": "Cox",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582440": {
    "id": "item_15516",
    "Last Name": "Fatima",
    "First Name": "Sana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582455": {
    "id": "item_3939",
    "Last Name": "Mack",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582456": {
    "id": "item_15515",
    "Last Name": "Donnelly",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582477": {
    "id": "item_15514",
    "Last Name": "Curry",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582482": {
    "id": "item_15886",
    "Last Name": "OÕConnell",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582487": {
    "id": "item_4370",
    "Last Name": "Bigarelli",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582490": {
    "id": "item_485",
    "Last Name": "Pareja",
    "First Name": "Denver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582492": {
    "id": "item_15513",
    "Last Name": "Pickford",
    "First Name": "Bronwen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582500": {
    "id": "item_4367",
    "Last Name": "Barnes",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582514": {
    "id": "item_29725",
    "Last Name": "Li",
    "First Name": "Ji",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582516": {
    "id": "item_3938",
    "Last Name": "Parker",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582532": {
    "id": "item_14972",
    "Last Name": "Winatapradja",
    "First Name": "Jana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582542": {
    "id": "item_484",
    "Last Name": "HINDMARCH",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582543": {
    "id": "item_3936",
    "Last Name": "Robinson",
    "First Name": "Tipene",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582563": {
    "id": "item_29566",
    "Last Name": "Shahira",
    "First Name": "Intan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582571": {
    "id": "item_27615",
    "Last Name": "Go",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582572": {
    "id": "item_2240",
    "Last Name": "Yan",
    "First Name": "Wenyi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582577": {
    "id": "item_1978",
    "Last Name": "Goncalves",
    "First Name": "Raul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582582": {
    "id": "item_29539",
    "Last Name": "Stevenson",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582584": {
    "id": "item_72",
    "Last Name": "Cheng",
    "First Name": "Ken",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582593": {
    "id": "item_1977",
    "Last Name": "Kim",
    "First Name": "Sydney",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582601": {
    "id": "item_14908",
    "Last Name": "Woodford",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582615": {
    "id": "item_3933",
    "Last Name": "Duque",
    "First Name": "Marc Wendolf",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582621": {
    "id": "item_29565",
    "Last Name": "Stevenson",
    "First Name": "Sian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582632": {
    "id": "item_27614",
    "Last Name": "Fantini",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582636": {
    "id": "item_313",
    "Last Name": "Glover",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582656": {
    "id": "item_15511",
    "Last Name": "Rider",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582669": {
    "id": "item_70",
    "Last Name": "ZHENG",
    "First Name": "SHENGNAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582680": {
    "id": "item_29537",
    "Last Name": "Lawrence",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582681": {
    "id": "item_29538",
    "Last Name": "Lambino",
    "First Name": "Rio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582685": {
    "id": "item_14968",
    "Last Name": "Wricke",
    "First Name": "Achim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582686": {
    "id": "item_27872",
    "Last Name": "Hayes",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582692": {
    "id": "item_27613",
    "Last Name": "Chapman",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582701": {
    "id": "item_14903",
    "Last Name": "Valerio",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582707": {
    "id": "item_12858",
    "Last Name": "Del Rosario",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582709": {
    "id": "item_69",
    "Last Name": "Budd",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582710": {
    "id": "item_12846",
    "Last Name": "Fong",
    "First Name": "Vince",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582711": {
    "id": "item_14901",
    "Last Name": "Blanch",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582720": {
    "id": "item_3925",
    "Last Name": "Slavkovsky",
    "First Name": "Vik",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582721": {
    "id": "item_29535",
    "Last Name": "Tudman",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582744": {
    "id": "item_3924",
    "Last Name": "McKenzie",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582762": {
    "id": "item_312",
    "Last Name": "Kim",
    "First Name": "Byung Pil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582774": {
    "id": "item_15508",
    "Last Name": "Green",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582780": {
    "id": "item_29564",
    "Last Name": "Darmasusila",
    "First Name": "I Made Gede",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582785": {
    "id": "item_15507",
    "Last Name": "Gale",
    "First Name": "Bruni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582790": {
    "id": "item_4363",
    "Last Name": "Kwok",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582793": {
    "id": "item_14900",
    "Last Name": "Howard",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582794": {
    "id": "item_15504",
    "Last Name": "Piao",
    "First Name": "Guige",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582795": {
    "id": "item_27610",
    "Last Name": "Ford",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582801": {
    "id": "item_12953",
    "Last Name": "Green",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582817": {
    "id": "item_29534",
    "Last Name": "younus",
    "First Name": "suffat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582820": {
    "id": "item_3920",
    "Last Name": "Marques Balula",
    "First Name": "Leonardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582823": {
    "id": "item_1967",
    "Last Name": "Wen",
    "First Name": "Wen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582824": {
    "id": "item_1968",
    "Last Name": "Guilfoyle",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582825": {
    "id": "item_14896",
    "Last Name": "Webb",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582828": {
    "id": "item_14967",
    "Last Name": "zhang",
    "First Name": "sainan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582836": {
    "id": "item_67",
    "Last Name": "Conlin",
    "First Name": "Owen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582843": {
    "id": "item_93",
    "Last Name": "Chaisathaporn",
    "First Name": "Paweena",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582858": {
    "id": "item_66",
    "Last Name": "Zaglas",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582872": {
    "id": "item_1966",
    "Last Name": "Kelly",
    "First Name": "Niall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582891": {
    "id": "item_3966",
    "Last Name": "Huang",
    "First Name": "Chin Ya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582899": {
    "id": "item_63",
    "Last Name": "Low",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582902": {
    "id": "item_14890",
    "Last Name": "Cammack",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582903": {
    "id": "item_3918",
    "Last Name": "Dowdell",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582904": {
    "id": "item_62",
    "Last Name": "Wood",
    "First Name": "Blair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582939": {
    "id": "item_14888",
    "Last Name": "Panchal",
    "First Name": "Mandar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582950": {
    "id": "item_14885",
    "Last Name": "Capito",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582966": {
    "id": "item_15501",
    "Last Name": "Carra",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582973": {
    "id": "item_3964",
    "Last Name": "Liu",
    "First Name": "Jung Chou",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582974": {
    "id": "item_15499",
    "Last Name": "Hewish",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582984": {
    "id": "item_4356",
    "Last Name": "Lee",
    "First Name": "Marshall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582988": {
    "id": "item_15498",
    "Last Name": "Ng",
    "First Name": "Yee Vien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582993": {
    "id": "item_12843",
    "Last Name": "Padilla Jr",
    "First Name": "Magellan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582997": {
    "id": "item_15497",
    "Last Name": "Creagh",
    "First Name": "Brydie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583004": {
    "id": "item_29530",
    "Last Name": "Carter",
    "First Name": "Lyndall",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583007": {
    "id": "item_27774",
    "Last Name": "Banpel",
    "First Name": "Jay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583009": {
    "id": "item_12842",
    "Last Name": "McRae",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583014": {
    "id": "item_29529",
    "Last Name": "Baxter",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583015": {
    "id": "item_12841",
    "Last Name": "Eason",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583017": {
    "id": "item_4354",
    "Last Name": "Randall",
    "First Name": "Heather",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583022": {
    "id": "item_1962",
    "Last Name": "Parker",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583023": {
    "id": "item_29528",
    "Last Name": "BAXTER",
    "First Name": "MARK",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583033": {
    "id": "item_3910",
    "Last Name": "Casier",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583046": {
    "id": "item_14880",
    "Last Name": "Pacey",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583048": {
    "id": "item_4352",
    "Last Name": "Hay",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583051": {
    "id": "item_483",
    "Last Name": "Kennett",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583065": {
    "id": "item_12840",
    "Last Name": "Jaimes Garcia",
    "First Name": "Franklin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583071": {
    "id": "item_2234",
    "Last Name": "Kolesnik",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583087": {
    "id": "item_3908",
    "Last Name": "Torbica",
    "First Name": "Michael Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583088": {
    "id": "item_3907",
    "Last Name": "Lowe",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583090": {
    "id": "item_482",
    "Last Name": "Schubert",
    "First Name": "Murray",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583097": {
    "id": "item_3906",
    "Last Name": "Martin",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583100": {
    "id": "item_4350",
    "Last Name": "Rowsell",
    "First Name": "Clayton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583108": {
    "id": "item_12839",
    "Last Name": "To",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583111": {
    "id": "item_1957",
    "Last Name": "Barsby",
    "First Name": "Elliott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583118": {
    "id": "item_2232",
    "Last Name": "Hughes",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583130": {
    "id": "item_481",
    "Last Name": "Grist",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583134": {
    "id": "item_3905",
    "Last Name": "George",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583137": {
    "id": "item_14872",
    "Last Name": "Bell",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583140": {
    "id": "item_4654",
    "Last Name": "Grist",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583142": {
    "id": "item_14868",
    "Last Name": "Azizi",
    "First Name": "Alissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583166": {
    "id": "item_4653",
    "Last Name": "Grange",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583178": {
    "id": "item_1956",
    "Last Name": "Lewis",
    "First Name": "Rod",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583181": {
    "id": "item_12950",
    "Last Name": "Andrews",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583197": {
    "id": "item_14865",
    "Last Name": "Yang",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583207": {
    "id": "item_15885",
    "Last Name": "Moon",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583218": {
    "id": "item_14965",
    "Last Name": "Marlina",
    "First Name": "Suci",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583222": {
    "id": "item_308",
    "Last Name": "Tshongo",
    "First Name": "Zawadi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583226": {
    "id": "item_55",
    "Last Name": "Johnson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583228": {
    "id": "item_12836",
    "Last Name": "Strmecki",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583237": {
    "id": "item_14861",
    "Last Name": "Madaba",
    "First Name": "Bothwell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583240": {
    "id": "item_480",
    "Last Name": "Johnston",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583241": {
    "id": "item_14860",
    "Last Name": "Lindqvist",
    "First Name": "Mikko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583243": {
    "id": "item_14862",
    "Last Name": "Prabhuswamy",
    "First Name": "Mukesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583252": {
    "id": "item_15883",
    "Last Name": "Samarakoon",
    "First Name": "Pavith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583268": {
    "id": "item_12949",
    "Last Name": "Andrews",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583270": {
    "id": "item_29716",
    "Last Name": "CHAN",
    "First Name": "CHUN HONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583275": {
    "id": "item_15884",
    "Last Name": "talib",
    "First Name": "Hafiz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583285": {
    "id": "item_29715",
    "Last Name": "Lawson",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583294": {
    "id": "item_14963",
    "Last Name": "Soh",
    "First Name": "Katherleen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583310": {
    "id": "item_479",
    "Last Name": "Steedman",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583311": {
    "id": "item_12835",
    "Last Name": "Joseph",
    "First Name": "Sandhya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583312": {
    "id": "item_14855",
    "Last Name": "Morrison",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583319": {
    "id": "item_4652",
    "Last Name": "Elder",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583327": {
    "id": "item_3895",
    "Last Name": "Iredale",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583333": {
    "id": "item_15481",
    "Last Name": "Frois",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583335": {
    "id": "item_27871",
    "Last Name": "Campbell",
    "First Name": "Allison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583337": {
    "id": "item_15479",
    "Last Name": "NEIMANIS",
    "First Name": "PETER",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583348": {
    "id": "item_14851",
    "Last Name": "Le",
    "First Name": "Vu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583349": {
    "id": "item_2228",
    "Last Name": "Hope",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583358": {
    "id": "item_50",
    "Last Name": "Rademan",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583359": {
    "id": "item_12947",
    "Last Name": "Haydon",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583362": {
    "id": "item_16646",
    "Last Name": "Hoban",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583377": {
    "id": "item_90",
    "Last Name": "Yue",
    "First Name": "Junxian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583378": {
    "id": "item_29714",
    "Last Name": "Stubbs",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583386": {
    "id": "item_14849",
    "Last Name": "Booth",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583392": {
    "id": "item_12834",
    "Last Name": "Tappenden",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583397": {
    "id": "item_29818",
    "Last Name": "Chen",
    "First Name": "Vally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583400": {
    "id": "item_14846",
    "Last Name": "Garvan",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583404": {
    "id": "item_14845",
    "Last Name": "Molinares",
    "First Name": "Sol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583412": {
    "id": "item_2227",
    "Last Name": "Fynmore",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583419": {
    "id": "item_14844",
    "Last Name": "Zhu",
    "First Name": "Jiajia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583422": {
    "id": "item_29562",
    "Last Name": "Zanella",
    "First Name": "Bruno",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583428": {
    "id": "item_4338",
    "Last Name": "Gaviria Romero",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583437": {
    "id": "item_3891",
    "Last Name": "Watts",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583454": {
    "id": "item_3890",
    "Last Name": "Gill",
    "First Name": "Roger",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583460": {
    "id": "item_15476",
    "Last Name": "White",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583461": {
    "id": "item_14843",
    "Last Name": "Ikeda",
    "First Name": "Ritsuko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583465": {
    "id": "item_15474",
    "Last Name": "Angka",
    "First Name": "Franciscus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583489": {
    "id": "item_14838",
    "Last Name": "Phu",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583492": {
    "id": "item_14842",
    "Last Name": "Salaun",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583494": {
    "id": "item_1951",
    "Last Name": "Hudson",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583499": {
    "id": "item_27598",
    "Last Name": "Altmiks",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583506": {
    "id": "item_14839",
    "Last Name": "Ma",
    "First Name": "Kris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583511": {
    "id": "item_29713",
    "Last Name": "Sabatino-See Kee",
    "First Name": "Kobe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583513": {
    "id": "item_42",
    "Last Name": "Huang",
    "First Name": "Haomin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583527": {
    "id": "item_3887",
    "Last Name": "Thomson",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583529": {
    "id": "item_304",
    "Last Name": "Araujo",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583532": {
    "id": "item_14835",
    "Last Name": "Sherlock",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583535": {
    "id": "item_3886",
    "Last Name": "Lipman",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583537": {
    "id": "item_4333",
    "Last Name": "Gomez Colorado",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583539": {
    "id": "item_41",
    "Last Name": "Cooke",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583542": {
    "id": "item_29518",
    "Last Name": "Zhu",
    "First Name": "Sha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583547": {
    "id": "item_478",
    "Last Name": "Parkin",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583548": {
    "id": "item_12944",
    "Last Name": "Ambikairajah",
    "First Name": "Ananthan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583550": {
    "id": "item_89",
    "Last Name": "Stewart",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583569": {
    "id": "item_14833",
    "Last Name": "Lee",
    "First Name": "Jung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583576": {
    "id": "item_27595",
    "Last Name": "Hardman",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583580": {
    "id": "item_14831",
    "Last Name": "Mace",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583592": {
    "id": "item_15882",
    "Last Name": "Loyd",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583602": {
    "id": "item_39",
    "Last Name": "Butler",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583609": {
    "id": "item_27763",
    "Last Name": "lambert",
    "First Name": "cathie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583613": {
    "id": "item_12830",
    "Last Name": "Sun",
    "First Name": "Sheehan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583623": {
    "id": "item_14828",
    "Last Name": "Fung",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583625": {
    "id": "item_14826",
    "Last Name": "Richards",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583640": {
    "id": "item_3881",
    "Last Name": "Hay",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583665": {
    "id": "item_3879",
    "Last Name": "Medlicott",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583671": {
    "id": "item_12941",
    "Last Name": "Cope",
    "First Name": "Janine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583673": {
    "id": "item_27889",
    "Last Name": "Kelly",
    "First Name": "Siobhan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583675": {
    "id": "item_14825",
    "Last Name": "Liu",
    "First Name": "Zhi Yu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583679": {
    "id": "item_34",
    "Last Name": "Roseby",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583689": {
    "id": "item_27762",
    "Last Name": "Dick",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583698": {
    "id": "item_477",
    "Last Name": "Carli",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583715": {
    "id": "item_15463",
    "Last Name": "Crane",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583740": {
    "id": "item_12939",
    "Last Name": "Piva",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583748": {
    "id": "item_3878",
    "Last Name": "Linao",
    "First Name": "Mario Hansel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583770": {
    "id": "item_14960",
    "Last Name": "Lau Siau Ing",
    "First Name": "Timmy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583771": {
    "id": "item_15881",
    "Last Name": "Smith",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583773": {
    "id": "item_13033",
    "Last Name": "Pittman",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583774": {
    "id": "item_27870",
    "Last Name": "Manurung",
    "First Name": "Yossi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583775": {
    "id": "item_4651",
    "Last Name": "Stanborough",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583781": {
    "id": "item_16645",
    "Last Name": "Duguid",
    "First Name": "Cale",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583790": {
    "id": "item_2222",
    "Last Name": "Campbell",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583792": {
    "id": "item_4327",
    "Last Name": "Kronberg",
    "First Name": "Bo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583793": {
    "id": "item_15457",
    "Last Name": "Sibanda",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583798": {
    "id": "item_32",
    "Last Name": "OÕDonoghue",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583799": {
    "id": "item_14819",
    "Last Name": "Wang",
    "First Name": "Jacky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583802": {
    "id": "item_14820",
    "Last Name": "McKaig",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583808": {
    "id": "item_14817",
    "Last Name": "Papa",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583811": {
    "id": "item_1944",
    "Last Name": "Mei",
    "First Name": "Wei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583812": {
    "id": "item_14816",
    "Last Name": "Drummond",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583815": {
    "id": "item_3875",
    "Last Name": "Waters",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583825": {
    "id": "item_29711",
    "Last Name": "Wheaton",
    "First Name": "Neil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583833": {
    "id": "item_3271",
    "Last Name": "Smith",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583862": {
    "id": "item_14814",
    "Last Name": "Dervish",
    "First Name": "Huseyin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583871": {
    "id": "item_14812",
    "Last Name": "Fowlds",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583876": {
    "id": "item_30",
    "Last Name": "Christodoulou",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583883": {
    "id": "item_14811",
    "Last Name": "Prior",
    "First Name": "Christina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583884": {
    "id": "item_27592",
    "Last Name": "Nallainathan",
    "First Name": "Dineish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583894": {
    "id": "item_14809",
    "Last Name": "Kelly",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583909": {
    "id": "item_14957",
    "Last Name": "Kim",
    "First Name": "Howook",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583925": {
    "id": "item_28",
    "Last Name": "Tran",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583930": {
    "id": "item_14805",
    "Last Name": "Liang",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583943": {
    "id": "item_13032",
    "Last Name": "Vyse",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583961": {
    "id": "item_3873",
    "Last Name": "Park",
    "First Name": "Jinsoo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583962": {
    "id": "item_14804",
    "Last Name": "Yuen",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583963": {
    "id": "item_4322",
    "Last Name": "TANG",
    "First Name": "JUI-CHUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583970": {
    "id": "item_2220",
    "Last Name": "Church",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583993": {
    "id": "item_15452",
    "Last Name": "Chen",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583996": {
    "id": "item_14802",
    "Last Name": "Vuong",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584001": {
    "id": "item_14801",
    "Last Name": "Lin",
    "First Name": "Zibo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584016": {
    "id": "item_14955",
    "Last Name": "Boulard",
    "First Name": "Francois",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584020": {
    "id": "item_27759",
    "Last Name": "Church",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584023": {
    "id": "item_3871",
    "Last Name": "Wong",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584024": {
    "id": "item_298",
    "Last Name": "Ranger",
    "First Name": "Erin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584027": {
    "id": "item_15448",
    "Last Name": "Lumley",
    "First Name": "Adon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584060": {
    "id": "item_2217",
    "Last Name": "Le",
    "First Name": "Nhan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584078": {
    "id": "item_3870",
    "Last Name": "Hopper",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584097": {
    "id": "item_14799",
    "Last Name": "Byatt",
    "First Name": "Evan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584108": {
    "id": "item_1940",
    "Last Name": "Ren",
    "First Name": "Jiakai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584135": {
    "id": "item_15446",
    "Last Name": "Blacker",
    "First Name": "Madison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584139": {
    "id": "item_3868",
    "Last Name": "Fung",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584149": {
    "id": "item_3866",
    "Last Name": "Deguara",
    "First Name": "Joey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584150": {
    "id": "item_29504",
    "Last Name": "Leong",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584152": {
    "id": "item_25",
    "Last Name": "Chen",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584162": {
    "id": "item_14795",
    "Last Name": "Hoey",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584167": {
    "id": "item_24",
    "Last Name": "Duczmal",
    "First Name": "Lily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584223": {
    "id": "item_29503",
    "Last Name": "Tran",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584232": {
    "id": "item_14788",
    "Last Name": "Sarraf",
    "First Name": "Anmol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584244": {
    "id": "item_12827",
    "Last Name": "Goodlace",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584247": {
    "id": "item_29502",
    "Last Name": "Roumieh",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584249": {
    "id": "item_14953",
    "Last Name": "Hon",
    "First Name": "Yeen Heng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584312": {
    "id": "item_14951",
    "Last Name": "Khuong",
    "First Name": "Tran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584323": {
    "id": "item_2215",
    "Last Name": "Decelis",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584348": {
    "id": "item_296",
    "Last Name": "Gladysz",
    "First Name": "Bartosz",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584353": {
    "id": "item_15441",
    "Last Name": "Khuu",
    "First Name": "Wilson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584410": {
    "id": "item_295",
    "Last Name": "Mason",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584418": {
    "id": "item_15439",
    "Last Name": "Lising",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584462": {
    "id": "item_1939",
    "Last Name": "QIU",
    "First Name": "Zhijiang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584478": {
    "id": "item_12854",
    "Last Name": "MORI",
    "First Name": "HARUKI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584480": {
    "id": "item_27588",
    "Last Name": "Clifton",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584482": {
    "id": "item_27758",
    "Last Name": "Lee",
    "First Name": "Juwon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584506": {
    "id": "item_12826",
    "Last Name": "Sang",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584516": {
    "id": "item_1938",
    "Last Name": "Yeung",
    "First Name": "Priscilla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584574": {
    "id": "item_29817",
    "Last Name": "Tremont",
    "First Name": "Dinusha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584576": {
    "id": "item_15437",
    "Last Name": "Wong",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584580": {
    "id": "item_14783",
    "Last Name": "Josselsohn",
    "First Name": "Chantal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584629": {
    "id": "item_27586",
    "Last Name": "Sinn",
    "First Name": "Florence",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584706": {
    "id": "item_3959",
    "Last Name": "LIU",
    "First Name": "CHENG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584733": {
    "id": "item_19",
    "Last Name": "Zou",
    "First Name": "Qingyang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584793": {
    "id": "item_27633",
    "Last Name": "Meltzer",
    "First Name": "LeeAnn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584802": {
    "id": "item_82",
    "Last Name": "TANG",
    "First Name": "TAT WENG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584864": {
    "id": "item_4690",
    "Last Name": "Shen",
    "First Name": "Zheyuan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584865": {
    "id": "item_2429",
    "Last Name": "Polglase",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584882": {
    "id": "item_29554",
    "Last Name": "Oscuro",
    "First Name": "Paulo Angelo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584957": {
    "id": "item_4650",
    "Last Name": "Ross",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584982": {
    "id": "item_14779",
    "Last Name": "Kopcikas",
    "First Name": "Koppo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585021": {
    "id": "item_27585",
    "Last Name": "Wood",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585046": {
    "id": "item_1996",
    "Last Name": "CHEN",
    "First Name": "JIUN-HUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585076": {
    "id": "item_4313",
    "Last Name": "Knight",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585126": {
    "id": "item_3856",
    "Last Name": "Ly",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585276": {
    "id": "item_27631",
    "Last Name": "Pun",
    "First Name": "Yee Man",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585370": {
    "id": "item_4312",
    "Last Name": "Waugh",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585601": {
    "id": "item_3955",
    "Last Name": "Lai",
    "First Name": "Hong Man Aloysius",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585796": {
    "id": "item_14947",
    "Last Name": "TAKAHASHI",
    "First Name": "KENICHIRO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585827": {
    "id": "item_27629",
    "Last Name": "Castillo",
    "First Name": "Moie Vincent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585853": {
    "id": "item_29549",
    "Last Name": "Yeung",
    "First Name": "Yuk Har",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585889": {
    "id": "item_14777",
    "Last Name": "Lane",
    "First Name": "Shannen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585899": {
    "id": "item_3855",
    "Last Name": "Tsui",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585994": {
    "id": "item_27627",
    "Last Name": "FAUZAN",
    "First Name": "YUSRON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586248": {
    "id": "item_29496",
    "Last Name": "Redden",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586407": {
    "id": "item_27626",
    "Last Name": "Chapman",
    "First Name": "George Albert William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586433": {
    "id": "item_3952",
    "Last Name": "Tsang",
    "First Name": "Ho Ming",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586684": {
    "id": "item_3854",
    "Last Name": "Yu",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586685": {
    "id": "item_27625",
    "Last Name": "Scepanovic",
    "First Name": "Vucic",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586704": {
    "id": "item_12935",
    "Last Name": "Jelley",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586752": {
    "id": "item_14942",
    "Last Name": "Bong",
    "First Name": "Vivi Vona",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36587073": {
    "id": "item_14939",
    "Last Name": "Anggraini",
    "First Name": "Dwi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36587122": {
    "id": "item_14937",
    "Last Name": "RENDO",
    "First Name": "Patrap Budiono",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36587423": {
    "id": "item_12934",
    "Last Name": "Vo",
    "First Name": "Duc",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36587459": {
    "id": "item_27623",
    "Last Name": "Ko",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36587479": {
    "id": "item_27622",
    "Last Name": "Goh",
    "First Name": "JJ",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36588722": {
    "id": "item_14773",
    "Last Name": "Sharma",
    "First Name": "Aadi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36591237": {
    "id": "item_1986",
    "Last Name": "Hyang",
    "First Name": "HyunGu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36591294": {
    "id": "item_27621",
    "Last Name": "MANTON",
    "First Name": "Ron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36591376": {
    "id": "item_79",
    "Last Name": "Finelli",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592040": {
    "id": "item_4310",
    "Last Name": "Munro",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592050": {
    "id": "item_3850",
    "Last Name": "MacCallum",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592073": {
    "id": "item_14932",
    "Last Name": "Bauch",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592246": {
    "id": "item_27620",
    "Last Name": "McNeill Jr.",
    "First Name": "Cornell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592449": {
    "id": "item_14931",
    "Last Name": "Adamski",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592502": {
    "id": "item_14771",
    "Last Name": "Baker",
    "First Name": "Bjorn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592875": {
    "id": "item_12849",
    "Last Name": "Gately",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592929": {
    "id": "item_29816",
    "Last Name": "Coombs",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593038": {
    "id": "item_15879",
    "Last Name": "Weston",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593101": {
    "id": "item_4649",
    "Last Name": "Charlton",
    "First Name": "Glen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593253": {
    "id": "item_289",
    "Last Name": "Searle",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593354": {
    "id": "item_27581",
    "Last Name": "Benkenstein",
    "First Name": "Brett",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593364": {
    "id": "item_3848",
    "Last Name": "Ahmad",
    "First Name": "Sijal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593372": {
    "id": "item_1930",
    "Last Name": "Van Den Borne",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593417": {
    "id": "item_4745",
    "Last Name": "Good",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593567": {
    "id": "item_14",
    "Last Name": "Mintorn",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593627": {
    "id": "item_3847",
    "Last Name": "Kendall",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593770": {
    "id": "item_4308",
    "Last Name": "Guo",
    "First Name": "Jia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594061": {
    "id": "item_29705",
    "Last Name": "Curl",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594088": {
    "id": "item_15878",
    "Last Name": "Kelley",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594213": {
    "id": "item_15431",
    "Last Name": "Edney",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594266": {
    "id": "item_3945",
    "Last Name": "Kelly",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594307": {
    "id": "item_29703",
    "Last Name": "Curl",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594343": {
    "id": "item_3846",
    "Last Name": "Wong",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594396": {
    "id": "item_27579",
    "Last Name": "Massy-Greene",
    "First Name": "Randal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594528": {
    "id": "item_27869",
    "Last Name": "Rummins",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594535": {
    "id": "item_3844",
    "Last Name": "Wood",
    "First Name": "Jo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594603": {
    "id": "item_3842",
    "Last Name": "Forsyth",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594731": {
    "id": "item_2209",
    "Last Name": "Gault",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594831": {
    "id": "item_2428",
    "Last Name": "Webb",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594857": {
    "id": "item_15877",
    "Last Name": "Rodrigues",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594869": {
    "id": "item_12932",
    "Last Name": "Grewal",
    "First Name": "Rashnith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594877": {
    "id": "item_285",
    "Last Name": "Lewis",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594919": {
    "id": "item_29489",
    "Last Name": "Huang",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594935": {
    "id": "item_14763",
    "Last Name": "Scott",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594979": {
    "id": "item_3841",
    "Last Name": "DÕEsposito",
    "First Name": "Ercole",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595020": {
    "id": "item_12820",
    "Last Name": "SAN LUIS",
    "First Name": "GEOFFREY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595078": {
    "id": "item_12931",
    "Last Name": "Regalo",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595089": {
    "id": "item_4305",
    "Last Name": "Bailey",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595129": {
    "id": "item_29546",
    "Last Name": "Cheevers",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595208": {
    "id": "item_283",
    "Last Name": "Koutsaplis",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595237": {
    "id": "item_15424",
    "Last Name": "Sobron",
    "First Name": "Rishi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595377": {
    "id": "item_14754",
    "Last Name": "Grove",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595387": {
    "id": "item_14752",
    "Last Name": "O'Sullivan",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595388": {
    "id": "item_11",
    "Last Name": "Krishna Swami",
    "First Name": "Anirudh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595397": {
    "id": "item_12819",
    "Last Name": "Samson",
    "First Name": "Julius",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595404": {
    "id": "item_15422",
    "Last Name": "O'Sullivan",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595418": {
    "id": "item_10",
    "Last Name": "Pettman",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595436": {
    "id": "item_14751",
    "Last Name": "Aguilar",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595471": {
    "id": "item_14750",
    "Last Name": "Moorfield",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595474": {
    "id": "item_3838",
    "Last Name": "Lal",
    "First Name": "Shahil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595475": {
    "id": "item_27754",
    "Last Name": "Tran",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595491": {
    "id": "item_15421",
    "Last Name": "Hulett",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595513": {
    "id": "item_2427",
    "Last Name": "Mcmillan",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595719": {
    "id": "item_14748",
    "Last Name": "Lu",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595722": {
    "id": "item_4304",
    "Last Name": "Ramsay",
    "First Name": "Helen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595751": {
    "id": "item_2205",
    "Last Name": "Lu",
    "First Name": "Qunfeng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595781": {
    "id": "item_14747",
    "Last Name": "Reyes",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595828": {
    "id": "item_27572",
    "Last Name": "Bakker-Meyers",
    "First Name": "Milly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595849": {
    "id": "item_3837",
    "Last Name": "Galarza",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595861": {
    "id": "item_3835",
    "Last Name": "Garrard",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595898": {
    "id": "item_14745",
    "Last Name": "Lawrence",
    "First Name": "Jared",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595983": {
    "id": "item_14743",
    "Last Name": "Wali",
    "First Name": "Munesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596046": {
    "id": "item_14924",
    "Last Name": "YU",
    "First Name": "ZHOU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596109": {
    "id": "item_29486",
    "Last Name": "Llarena",
    "First Name": "Flerida",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596111": {
    "id": "item_2202",
    "Last Name": "Ghattamaneni",
    "First Name": "Naga Koteswara Rao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596115": {
    "id": "item_2203",
    "Last Name": "Tangitau",
    "First Name": "Joshjua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596150": {
    "id": "item_14742",
    "Last Name": "Rayner",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596168": {
    "id": "item_4648",
    "Last Name": "Brown",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596192": {
    "id": "item_3832",
    "Last Name": "Hogan",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596200": {
    "id": "item_3829",
    "Last Name": "Flores",
    "First Name": "Ana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596209": {
    "id": "item_6",
    "Last Name": "Barrenger",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596278": {
    "id": "item_4297",
    "Last Name": "Tan",
    "First Name": "Tao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596355": {
    "id": "item_15876",
    "Last Name": "Solomon",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596424": {
    "id": "item_14741",
    "Last Name": "Murray",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596427": {
    "id": "item_4",
    "Last Name": "Liwag",
    "First Name": "Claridge",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596481": {
    "id": "item_3",
    "Last Name": "Abdullah",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596504": {
    "id": "item_14739",
    "Last Name": "Favero",
    "First Name": "Louis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596537": {
    "id": "item_14738",
    "Last Name": "Leeding",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596576": {
    "id": "item_15853",
    "Last Name": "Carty",
    "First Name": "Danelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596582": {
    "id": "item_27752",
    "Last Name": "Ram’rez Santos",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596596": {
    "id": "item_15852",
    "Last Name": "hu",
    "First Name": "yulong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596629": {
    "id": "item_29809",
    "Last Name": "Narenthiran",
    "First Name": "Arul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596643": {
    "id": "item_4635",
    "Last Name": "Tsang",
    "First Name": "Anne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596673": {
    "id": "item_4633",
    "Last Name": "Simon",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596688": {
    "id": "item_4632",
    "Last Name": "Bushrod",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596726": {
    "id": "item_2198",
    "Last Name": "White",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596728": {
    "id": "item_15415",
    "Last Name": "Gowans",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596735": {
    "id": "item_4631",
    "Last Name": "Bass",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596747": {
    "id": "item_2197",
    "Last Name": "Schwerdt",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596793": {
    "id": "item_15850",
    "Last Name": "Kang",
    "First Name": "Augustine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596908": {
    "id": "item_2196",
    "Last Name": "Cozzuol",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596959": {
    "id": "item_4630",
    "Last Name": "Chan",
    "First Name": "Angela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597060": {
    "id": "item_13027",
    "Last Name": "Warner",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597072": {
    "id": "item_15847",
    "Last Name": "Chang",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597091": {
    "id": "item_277",
    "Last Name": "Goodger",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597108": {
    "id": "item_27751",
    "Last Name": "White",
    "First Name": "Colleen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597163": {
    "id": "item_15410",
    "Last Name": "McGuire",
    "First Name": "Eilidh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597196": {
    "id": "item_15846",
    "Last Name": "Mau",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597239": {
    "id": "item_15845",
    "Last Name": "Revell",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597268": {
    "id": "item_3941",
    "Last Name": "Craik",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597324": {
    "id": "item_4647",
    "Last Name": "Boswell",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597343": {
    "id": "item_2419",
    "Last Name": "Dragicevic",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597445": {
    "id": "item_2194",
    "Last Name": "Luu",
    "First Name": "Tin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597463": {
    "id": "item_15409",
    "Last Name": "Arcenal",
    "First Name": "Perbel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597498": {
    "id": "item_15408",
    "Last Name": "Smith",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597586": {
    "id": "item_29805",
    "Last Name": "Ohtsuka",
    "First Name": "Yasushi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597595": {
    "id": "item_2416",
    "Last Name": "McRae",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597609": {
    "id": "item_4626",
    "Last Name": "Giltinan",
    "First Name": "Emmanuelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597635": {
    "id": "item_2417",
    "Last Name": "Prihutomo",
    "First Name": "Andri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597721": {
    "id": "item_29804",
    "Last Name": "Tago",
    "First Name": "Shinichi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597746": {
    "id": "item_467",
    "Last Name": "Schilling",
    "First Name": "Chance",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597762": {
    "id": "item_4294",
    "Last Name": "Ou",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597781": {
    "id": "item_2193",
    "Last Name": "Dineen",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597787": {
    "id": "item_4293",
    "Last Name": "Taverne",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597902": {
    "id": "item_15875",
    "Last Name": "McPhee",
    "First Name": "Brock",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598061": {
    "id": "item_4646",
    "Last Name": "Foster",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598077": {
    "id": "item_4622",
    "Last Name": "Watts",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598115": {
    "id": "item_4645",
    "Last Name": "Harte",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598123": {
    "id": "item_4621",
    "Last Name": "Edwards",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598150": {
    "id": "item_15839",
    "Last Name": "Walter",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598272": {
    "id": "item_15838",
    "Last Name": "Karp",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598292": {
    "id": "item_2411",
    "Last Name": "Mentzines",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598305": {
    "id": "item_4290",
    "Last Name": "Cameron",
    "First Name": "Nadine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598446": {
    "id": "item_15837",
    "Last Name": "Moyle",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598483": {
    "id": "item_4616",
    "Last Name": "Briscoe",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598502": {
    "id": "item_4615",
    "Last Name": "Le",
    "First Name": "Tiger",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598514": {
    "id": "item_4644",
    "Last Name": "Truman",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598581": {
    "id": "item_14923",
    "Last Name": "James",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598593": {
    "id": "item_4288",
    "Last Name": "Jackson",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598616": {
    "id": "item_15405",
    "Last Name": "Jiao",
    "First Name": "Angel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598627": {
    "id": "item_273",
    "Last Name": "Wetmore",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598671": {
    "id": "item_29802",
    "Last Name": "Hk",
    "First Name": "Sav",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598676": {
    "id": "item_15836",
    "Last Name": "Rincon",
    "First Name": "Damian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598817": {
    "id": "item_2408",
    "Last Name": "Rowden",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598824": {
    "id": "item_4611",
    "Last Name": "Koe",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598871": {
    "id": "item_27619",
    "Last Name": "Davenport",
    "First Name": "Janine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598896": {
    "id": "item_2191",
    "Last Name": "Kirk",
    "First Name": "Hadleigh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598965": {
    "id": "item_15402",
    "Last Name": "Flanigan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598970": {
    "id": "item_4287",
    "Last Name": "Bourchier",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598981": {
    "id": "item_29815",
    "Last Name": "Loveridge",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599003": {
    "id": "item_270",
    "Last Name": "Brucic",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599027": {
    "id": "item_27618",
    "Last Name": "Harris",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599049": {
    "id": "item_29801",
    "Last Name": "Halloran",
    "First Name": "Felicity",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599112": {
    "id": "item_13025",
    "Last Name": "Shaw",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599131": {
    "id": "item_15399",
    "Last Name": "Russell",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599142": {
    "id": "item_15874",
    "Last Name": "Conlon",
    "First Name": "Lisa-Maree",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599152": {
    "id": "item_15830",
    "Last Name": "Liley",
    "First Name": "Tara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599169": {
    "id": "item_15829",
    "Last Name": "Taylor",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599193": {
    "id": "item_29800",
    "Last Name": "Perrett",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599197": {
    "id": "item_27861",
    "Last Name": "Bartho",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599207": {
    "id": "item_462",
    "Last Name": "Emmerich",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599230": {
    "id": "item_4643",
    "Last Name": "Henderson",
    "First Name": "Annette",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599258": {
    "id": "item_4606",
    "Last Name": "Neville",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599268": {
    "id": "item_476",
    "Last Name": "Hogan",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599281": {
    "id": "item_27858",
    "Last Name": "Martin",
    "First Name": "Trudy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599380": {
    "id": "item_4604",
    "Last Name": "Hawkett-Jones",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599432": {
    "id": "item_15826",
    "Last Name": "Tildsley",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599464": {
    "id": "item_2404",
    "Last Name": "Rebello",
    "First Name": "Russell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599510": {
    "id": "item_15824",
    "Last Name": "Smith",
    "First Name": "Blair",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599540": {
    "id": "item_15823",
    "Last Name": "LIU",
    "First Name": "Ching-Lung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599541": {
    "id": "item_15822",
    "Last Name": "Liu",
    "First Name": "Junhao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599552": {
    "id": "item_15821",
    "Last Name": "Madden",
    "First Name": "Deirdre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599572": {
    "id": "item_15820",
    "Last Name": "Rostami",
    "First Name": "Hasti",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599709": {
    "id": "item_27856",
    "Last Name": "Gray",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599718": {
    "id": "item_29545",
    "Last Name": "Block",
    "First Name": "Misty",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599733": {
    "id": "item_2403",
    "Last Name": "Barcelon",
    "First Name": "R.J.",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599743": {
    "id": "item_2189",
    "Last Name": "Glass",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599815": {
    "id": "item_29798",
    "Last Name": "Kernick-Wood",
    "First Name": "Max",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599842": {
    "id": "item_27855",
    "Last Name": "HTET",
    "First Name": "LINN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599852": {
    "id": "item_15396",
    "Last Name": "Mehta",
    "First Name": "Ritesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599862": {
    "id": "item_2401",
    "Last Name": "Blatchford",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599938": {
    "id": "item_4597",
    "Last Name": "Luong",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600037": {
    "id": "item_15873",
    "Last Name": "Barnier",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600275": {
    "id": "item_15816",
    "Last Name": "Johnson",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600301": {
    "id": "item_4596",
    "Last Name": "Carroll",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600313": {
    "id": "item_15394",
    "Last Name": "Blamire",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600384": {
    "id": "item_15393",
    "Last Name": "Whitfield",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600423": {
    "id": "item_2399",
    "Last Name": "Shigehara",
    "First Name": "Shinichi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600435": {
    "id": "item_268",
    "Last Name": "Anthony",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600538": {
    "id": "item_15814",
    "Last Name": "Cheng",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600560": {
    "id": "item_27748",
    "Last Name": "Pan",
    "First Name": "Rui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600627": {
    "id": "item_15811",
    "Last Name": "No",
    "First Name": "Ji Ye",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600629": {
    "id": "item_15813",
    "Last Name": "Dharmawan",
    "First Name": "Billy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600635": {
    "id": "item_27853",
    "Last Name": "Wang",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600701": {
    "id": "item_267",
    "Last Name": "Constantine",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600735": {
    "id": "item_15810",
    "Last Name": "Eldridge",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600774": {
    "id": "item_27851",
    "Last Name": "Bull",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600843": {
    "id": "item_453",
    "Last Name": "Connolly",
    "First Name": "Kiera",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600858": {
    "id": "item_13020",
    "Last Name": "Docker",
    "First Name": "Callum",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600913": {
    "id": "item_452",
    "Last Name": "Puspesh",
    "First Name": "Puspesh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600928": {
    "id": "item_29699",
    "Last Name": "Wilson",
    "First Name": "Rosa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600936": {
    "id": "item_266",
    "Last Name": "Di Muzio",
    "First Name": "Micah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600953": {
    "id": "item_451",
    "Last Name": "Isaaks",
    "First Name": "Roger",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600990": {
    "id": "item_29698",
    "Last Name": "Santos",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601051": {
    "id": "item_15806",
    "Last Name": "Economou",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601069": {
    "id": "item_15805",
    "Last Name": "Sinclair",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601088": {
    "id": "item_1983",
    "Last Name": "Ning",
    "First Name": "Xin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601110": {
    "id": "item_4642",
    "Last Name": "Maurer",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601155": {
    "id": "item_15804",
    "Last Name": "Stiddard",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601296": {
    "id": "item_475",
    "Last Name": "McConnell",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601297": {
    "id": "item_450",
    "Last Name": "Zervos",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601299": {
    "id": "item_15803",
    "Last Name": "Scott",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601392": {
    "id": "item_4278",
    "Last Name": "Lui",
    "First Name": "Kim Lun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601449": {
    "id": "item_2389",
    "Last Name": "Pagden",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601451": {
    "id": "item_265",
    "Last Name": "Wall",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601471": {
    "id": "item_4275",
    "Last Name": "Gehrke",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601576": {
    "id": "item_29543",
    "Last Name": "Yu",
    "First Name": "Yun qi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601858": {
    "id": "item_2187",
    "Last Name": "Lui",
    "First Name": "Kam SHing Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601904": {
    "id": "item_27847",
    "Last Name": "Rien",
    "First Name": "Sussana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602048": {
    "id": "item_449",
    "Last Name": "Doak",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602050": {
    "id": "item_15872",
    "Last Name": "Spake",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602067": {
    "id": "item_4588",
    "Last Name": "Botica",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602762": {
    "id": "item_27616",
    "Last Name": "Moyer",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602841": {
    "id": "item_263",
    "Last Name": "Beaumont",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602862": {
    "id": "item_4586",
    "Last Name": "Brent",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602881": {
    "id": "item_15388",
    "Last Name": "McFee",
    "First Name": "Jacinta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36603652": {
    "id": "item_2388",
    "Last Name": "Silver",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604335": {
    "id": "item_15796",
    "Last Name": "rodriguez",
    "First Name": "christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604367": {
    "id": "item_29541",
    "Last Name": "Belmonte",
    "First Name": "Christelle Angelique",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604382": {
    "id": "item_4272",
    "Last Name": "Mihaly",
    "First Name": "Miro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604467": {
    "id": "item_1981",
    "Last Name": "komatsu",
    "First Name": "noriyuki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604480": {
    "id": "item_4270",
    "Last Name": "Sapkota",
    "First Name": "Aashutosh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604638": {
    "id": "item_2385",
    "Last Name": "Eades",
    "First Name": "Jaydon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604672": {
    "id": "item_448",
    "Last Name": "Forde",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604791": {
    "id": "item_2383",
    "Last Name": "Zhao",
    "First Name": "Shiliang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604862": {
    "id": "item_447",
    "Last Name": "Tse",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605014": {
    "id": "item_4581",
    "Last Name": "Baran",
    "First Name": "Angie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605020": {
    "id": "item_4580",
    "Last Name": "Atkins",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605069": {
    "id": "item_4579",
    "Last Name": "Grace",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605204": {
    "id": "item_2381",
    "Last Name": "Roth",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605371": {
    "id": "item_29693",
    "Last Name": "Gilham",
    "First Name": "Ashleyrose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605394": {
    "id": "item_4268",
    "Last Name": "Jones",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605417": {
    "id": "item_2184",
    "Last Name": "Dang",
    "First Name": "Son",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605464": {
    "id": "item_15384",
    "Last Name": "Lee Serra",
    "First Name": "Fabio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605468": {
    "id": "item_538",
    "Last Name": "Zhang",
    "First Name": "Roger Cunyu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605616": {
    "id": "item_1980",
    "Last Name": "WANG",
    "First Name": "JUIDE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605660": {
    "id": "item_29692",
    "Last Name": "Tang",
    "First Name": "Budiaman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605691": {
    "id": "item_14917",
    "Last Name": "Cruz",
    "First Name": "Sylvia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605696": {
    "id": "item_14918",
    "Last Name": "Cheong",
    "First Name": "Gerald",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605724": {
    "id": "item_15787",
    "Last Name": "Hataya",
    "First Name": "Tomoko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605728": {
    "id": "item_4577",
    "Last Name": "Renting",
    "First Name": "Renzo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605742": {
    "id": "item_256",
    "Last Name": "Pulitano",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605755": {
    "id": "item_15782",
    "Last Name": "Li",
    "First Name": "RenJun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605763": {
    "id": "item_255",
    "Last Name": "Phillips",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605878": {
    "id": "item_441",
    "Last Name": "Ramos",
    "First Name": "Lester",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605883": {
    "id": "item_15784",
    "Last Name": "Toovey",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605916": {
    "id": "item_15383",
    "Last Name": "Halim",
    "First Name": "Roy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606042": {
    "id": "item_29814",
    "Last Name": "Shepherd",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606264": {
    "id": "item_14915",
    "Last Name": "Tjahjadi",
    "First Name": "Irwan Tirta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606426": {
    "id": "item_1979",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606573": {
    "id": "item_254",
    "Last Name": "White",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606599": {
    "id": "item_15777",
    "Last Name": "Kwak",
    "First Name": "Brian Pyung-Ho",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606632": {
    "id": "item_251",
    "Last Name": "Achuthan",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606638": {
    "id": "item_4263",
    "Last Name": "Luong",
    "First Name": "Gideon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606658": {
    "id": "item_14913",
    "Last Name": "LEE",
    "First Name": "DongKeun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606663": {
    "id": "item_4572",
    "Last Name": "Denton",
    "First Name": "Ned",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606728": {
    "id": "item_15776",
    "Last Name": "Corry",
    "First Name": "Eve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606776": {
    "id": "item_435",
    "Last Name": "Persen",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606793": {
    "id": "item_2376",
    "Last Name": "Kam",
    "First Name": "Alston",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606812": {
    "id": "item_2375",
    "Last Name": "Cunninghame",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606939": {
    "id": "item_4262",
    "Last Name": "Nicholls",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607073": {
    "id": "item_15381",
    "Last Name": "Coombes",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607102": {
    "id": "item_15772",
    "Last Name": "Ng",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607191": {
    "id": "item_4569",
    "Last Name": "Croly",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607192": {
    "id": "item_14910",
    "Last Name": "Sheng Jian",
    "First Name": "Ong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607193": {
    "id": "item_15767",
    "Last Name": "Downes",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607399": {
    "id": "item_73",
    "Last Name": "Pemberton",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607423": {
    "id": "item_27844",
    "Last Name": "Crofts",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607482": {
    "id": "item_4567",
    "Last Name": "Brennan",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607546": {
    "id": "item_15379",
    "Last Name": "Halkidis",
    "First Name": "Lambros",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607566": {
    "id": "item_15765",
    "Last Name": "Xiang",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607606": {
    "id": "item_29689",
    "Last Name": "Abedi",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607611": {
    "id": "item_2426",
    "Last Name": "Yuill",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607633": {
    "id": "item_27842",
    "Last Name": "Thorpe",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607654": {
    "id": "item_15764",
    "Last Name": "Hu",
    "First Name": "Guangze",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607959": {
    "id": "item_2372",
    "Last Name": "Yao",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607972": {
    "id": "item_4564",
    "Last Name": "Webb",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607985": {
    "id": "item_29540",
    "Last Name": "Huang",
    "First Name": "Danyu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607986": {
    "id": "item_431",
    "Last Name": "Goodwin",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608001": {
    "id": "item_15377",
    "Last Name": "de Scally",
    "First Name": "Storme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608084": {
    "id": "item_12926",
    "Last Name": "Primrose",
    "First Name": "Kait",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608099": {
    "id": "item_4562",
    "Last Name": "Johnsotne",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608121": {
    "id": "item_15871",
    "Last Name": "Adams",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608159": {
    "id": "item_14909",
    "Last Name": "Sukmawati",
    "First Name": "Yanne Erni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608180": {
    "id": "item_4258",
    "Last Name": "Clarke",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608191": {
    "id": "item_2178",
    "Last Name": "Dawson-Wink",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608265": {
    "id": "item_429",
    "Last Name": "Lee",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608318": {
    "id": "item_4560",
    "Last Name": "Kelly",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608366": {
    "id": "item_4558",
    "Last Name": "Lee",
    "First Name": "Youjae",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608379": {
    "id": "item_15375",
    "Last Name": "Teh",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608419": {
    "id": "item_4557",
    "Last Name": "Koeppenkastrop",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608422": {
    "id": "item_4556",
    "Last Name": "Malone",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608502": {
    "id": "item_14907",
    "Last Name": "Suwannarat",
    "First Name": "Chait",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608549": {
    "id": "item_15870",
    "Last Name": "Brown",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608637": {
    "id": "item_71",
    "Last Name": "CHUN",
    "First Name": "LI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608642": {
    "id": "item_4554",
    "Last Name": "Parsons",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608867": {
    "id": "item_425",
    "Last Name": "Cropper",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608903": {
    "id": "item_14906",
    "Last Name": "Zou",
    "First Name": "Kevin Cheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608942": {
    "id": "item_4251",
    "Last Name": "Pearce",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608943": {
    "id": "item_4726",
    "Last Name": "Ahern",
    "First Name": "Kate",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609087": {
    "id": "item_474",
    "Last Name": "Rolfe",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609194": {
    "id": "item_2177",
    "Last Name": "Watson",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609267": {
    "id": "item_29780",
    "Last Name": "Koirala",
    "First Name": "Sujan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609268": {
    "id": "item_12925",
    "Last Name": "Wise",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609294": {
    "id": "item_15753",
    "Last Name": "chan",
    "First Name": "chun ho",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609321": {
    "id": "item_27837",
    "Last Name": "Heriseanu",
    "First Name": "Andreea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609350": {
    "id": "item_2363",
    "Last Name": "Haq",
    "First Name": "Ridwan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609369": {
    "id": "item_29779",
    "Last Name": "Hwang",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609393": {
    "id": "item_15752",
    "Last Name": "Pellet",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609435": {
    "id": "item_246",
    "Last Name": "Kennedy",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609442": {
    "id": "item_4247",
    "Last Name": "Corkill",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609470": {
    "id": "item_13009",
    "Last Name": "Chapman",
    "First Name": "Holley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609488": {
    "id": "item_4551",
    "Last Name": "Willacy",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609561": {
    "id": "item_4245",
    "Last Name": "Cahill",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609574": {
    "id": "item_12924",
    "Last Name": "Wood",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609640": {
    "id": "item_2175",
    "Last Name": "Dickin",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609675": {
    "id": "item_27836",
    "Last Name": "Murphy",
    "First Name": "Julie Anne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609714": {
    "id": "item_15748",
    "Last Name": "Caldwell",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609735": {
    "id": "item_27834",
    "Last Name": "Owers",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609749": {
    "id": "item_4547",
    "Last Name": "Shanahan",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609836": {
    "id": "item_15745",
    "Last Name": "Collis",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609869": {
    "id": "item_15744",
    "Last Name": "McCowage",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609888": {
    "id": "item_15742",
    "Last Name": "Ward",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609906": {
    "id": "item_2359",
    "Last Name": "Pervan",
    "First Name": "Dominique",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609921": {
    "id": "item_27832",
    "Last Name": "Mason",
    "First Name": "Lesley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609924": {
    "id": "item_2172",
    "Last Name": "Byrne",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609957": {
    "id": "item_27830",
    "Last Name": "Saludo",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609971": {
    "id": "item_29777",
    "Last Name": "Cruz Reyes",
    "First Name": "Arvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609974": {
    "id": "item_4542",
    "Last Name": "Hickling",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609977": {
    "id": "item_4543",
    "Last Name": "Garrod",
    "First Name": "Brogan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610083": {
    "id": "item_4242",
    "Last Name": "Lee",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610108": {
    "id": "item_15739",
    "Last Name": "Mifsud",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610124": {
    "id": "item_4241",
    "Last Name": "Chen",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610131": {
    "id": "item_2357",
    "Last Name": "Bostridge",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610175": {
    "id": "item_4240",
    "Last Name": "Woodroffe",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610301": {
    "id": "item_4539",
    "Last Name": "Henare",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610311": {
    "id": "item_2355",
    "Last Name": "Heaton",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610315": {
    "id": "item_4537",
    "Last Name": "Savage",
    "First Name": "Fionnuala",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610331": {
    "id": "item_2354",
    "Last Name": "PETERS",
    "First Name": "DAVE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610346": {
    "id": "item_2353",
    "Last Name": "Simpson",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610372": {
    "id": "item_15736",
    "Last Name": "Liley",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610379": {
    "id": "item_4239",
    "Last Name": "Khoo",
    "First Name": "Ken Ho",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610381": {
    "id": "item_15735",
    "Last Name": "Cheng",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610433": {
    "id": "item_2171",
    "Last Name": "eastham",
    "First Name": "kylie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610467": {
    "id": "item_4536",
    "Last Name": "Kwong",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610509": {
    "id": "item_3929",
    "Last Name": "Emms",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610533": {
    "id": "item_15734",
    "Last Name": "Alonso",
    "First Name": "Julieta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610535": {
    "id": "item_1973",
    "Last Name": "JIANG",
    "First Name": "XIAOQING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610546": {
    "id": "item_413",
    "Last Name": "Huang",
    "First Name": "Linda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610576": {
    "id": "item_27743",
    "Last Name": "Docherty",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610580": {
    "id": "item_4236",
    "Last Name": "D' IPPOLITO",
    "First Name": "LEONARDO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610586": {
    "id": "item_14904",
    "Last Name": "Sim",
    "First Name": "Evan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610587": {
    "id": "item_29774",
    "Last Name": "Rahayu",
    "First Name": "Intan Sri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610599": {
    "id": "item_2170",
    "Last Name": "Rossi",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610642": {
    "id": "item_15732",
    "Last Name": "McLean",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610646": {
    "id": "item_15367",
    "Last Name": "Ng",
    "First Name": "Kwok Yan Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610650": {
    "id": "item_27827",
    "Last Name": "Trajkovski",
    "First Name": "Boris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610659": {
    "id": "item_13004",
    "Last Name": "Khor",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610684": {
    "id": "item_29773",
    "Last Name": "Vella",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610686": {
    "id": "item_4233",
    "Last Name": "Mowle",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610720": {
    "id": "item_29687",
    "Last Name": "Sturzaker",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610734": {
    "id": "item_2168",
    "Last Name": "Pienaar",
    "First Name": "Karen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610787": {
    "id": "item_15869",
    "Last Name": "Dimmock",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610834": {
    "id": "item_13002",
    "Last Name": "Zamani",
    "First Name": "Neeka",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610896": {
    "id": "item_29772",
    "Last Name": "Smart",
    "First Name": "Dorothy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610908": {
    "id": "item_15726",
    "Last Name": "Lucas",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610919": {
    "id": "item_29813",
    "Last Name": "Trojanowska",
    "First Name": "Zofia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610922": {
    "id": "item_241",
    "Last Name": "Marinaccio",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610923": {
    "id": "item_4530",
    "Last Name": "Stanton",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610946": {
    "id": "item_240",
    "Last Name": "CHOI",
    "First Name": "ONE SEOK",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611035": {
    "id": "item_4229",
    "Last Name": "WU",
    "First Name": "DI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611076": {
    "id": "item_4228",
    "Last Name": "Eastham",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611081": {
    "id": "item_15364",
    "Last Name": "Gilera",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611088": {
    "id": "item_29686",
    "Last Name": "Qian",
    "First Name": "Joreal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611090": {
    "id": "item_15720",
    "Last Name": "Pasquali",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611101": {
    "id": "item_27612",
    "Last Name": "Hodgson",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611166": {
    "id": "item_15362",
    "Last Name": "Sturgeon",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611180": {
    "id": "item_15361",
    "Last Name": "Foley",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611221": {
    "id": "item_27825",
    "Last Name": "Lough",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611240": {
    "id": "item_15717",
    "Last Name": "Montierro",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611243": {
    "id": "item_15715",
    "Last Name": "Oxby",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611280": {
    "id": "item_12999",
    "Last Name": "Cecil",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611318": {
    "id": "item_404",
    "Last Name": "Tolhurst",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611322": {
    "id": "item_2340",
    "Last Name": "Li",
    "First Name": "Yiwei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611330": {
    "id": "item_12998",
    "Last Name": "McMahon",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611351": {
    "id": "item_1922",
    "Last Name": "Pienkowski",
    "First Name": "Andrzej",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611356": {
    "id": "item_4524",
    "Last Name": "Griffiths",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611392": {
    "id": "item_401",
    "Last Name": "Kim",
    "First Name": "Sun-ha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611393": {
    "id": "item_15710",
    "Last Name": "Leung",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611437": {
    "id": "item_3926",
    "Last Name": "RODA",
    "First Name": "Cyrille",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611468": {
    "id": "item_1971",
    "Last Name": "Mello",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611502": {
    "id": "item_15360",
    "Last Name": "Tune",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611532": {
    "id": "item_3923",
    "Last Name": "LEBRUN",
    "First Name": "Mathilde",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611563": {
    "id": "item_29682",
    "Last Name": "Rauseo",
    "First Name": "Marco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611577": {
    "id": "item_15708",
    "Last Name": "Fitzsimons",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611588": {
    "id": "item_27611",
    "Last Name": "Quizon",
    "First Name": "Roswald John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611589": {
    "id": "item_4520",
    "Last Name": "BRITTAIN",
    "First Name": "JACOB",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611594": {
    "id": "item_15707",
    "Last Name": "Jackson",
    "First Name": "Katharine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611606": {
    "id": "item_4518",
    "Last Name": "Herb",
    "First Name": "Kali",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611644": {
    "id": "item_4517",
    "Last Name": "Morgan",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611661": {
    "id": "item_2164",
    "Last Name": "Ramsay",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611682": {
    "id": "item_12845",
    "Last Name": "KIM",
    "First Name": "HYUNYOUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611687": {
    "id": "item_29767",
    "Last Name": "McGarry",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611693": {
    "id": "item_14897",
    "Last Name": "De sanctis",
    "First Name": "Maria felicia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611701": {
    "id": "item_27742",
    "Last Name": "Modra",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611710": {
    "id": "item_1969",
    "Last Name": "Harris",
    "First Name": "Kriss",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611736": {
    "id": "item_2163",
    "Last Name": "Hodge",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611762": {
    "id": "item_4515",
    "Last Name": "Harvey",
    "First Name": "Glen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611776": {
    "id": "item_15700",
    "Last Name": "Holloway",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611785": {
    "id": "item_13039",
    "Last Name": "Ward",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611786": {
    "id": "item_15357",
    "Last Name": "Tse",
    "First Name": "Pauline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611788": {
    "id": "item_4224",
    "Last Name": "Pena",
    "First Name": "Guilherme",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611805": {
    "id": "item_15698",
    "Last Name": "Kroon",
    "First Name": "Nardi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611810": {
    "id": "item_397",
    "Last Name": "Cassidy",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611834": {
    "id": "item_29766",
    "Last Name": "Li",
    "First Name": "Yuet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611848": {
    "id": "item_473",
    "Last Name": "Morris",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611855": {
    "id": "item_2332",
    "Last Name": "Grice",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611904": {
    "id": "item_15695",
    "Last Name": "Grech",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611924": {
    "id": "item_4512",
    "Last Name": "Jiang",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611949": {
    "id": "item_15694",
    "Last Name": "Smyth",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611956": {
    "id": "item_15354",
    "Last Name": "Vincent",
    "First Name": "Marichris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611958": {
    "id": "item_27823",
    "Last Name": "Mears",
    "First Name": "Asha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611962": {
    "id": "item_395",
    "Last Name": "Bilski",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611975": {
    "id": "item_15355",
    "Last Name": "Hobart",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611981": {
    "id": "item_15693",
    "Last Name": "Cullen",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611986": {
    "id": "item_2161",
    "Last Name": "knight-gray",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612005": {
    "id": "item_4510",
    "Last Name": "Betros",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612018": {
    "id": "item_29763",
    "Last Name": "Zhao",
    "First Name": "Yaoqing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612029": {
    "id": "item_29764",
    "Last Name": "Robertson",
    "First Name": "Ed",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612064": {
    "id": "item_12993",
    "Last Name": "Meyer",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612092": {
    "id": "item_15691",
    "Last Name": "Hall",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612094": {
    "id": "item_2326",
    "Last Name": "Lam",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612095": {
    "id": "item_13031",
    "Last Name": "White",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612119": {
    "id": "item_2325",
    "Last Name": "Beech",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612123": {
    "id": "item_4507",
    "Last Name": "Coaldrake",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612125": {
    "id": "item_29812",
    "Last Name": "Peterson",
    "First Name": "Nerissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612178": {
    "id": "item_4506",
    "Last Name": "Cha",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612189": {
    "id": "item_27821",
    "Last Name": "Ma",
    "First Name": "Ying Kwan Dilys",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612193": {
    "id": "item_14895",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612207": {
    "id": "item_14894",
    "Last Name": "Riyanti",
    "First Name": "Vega",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612208": {
    "id": "item_14893",
    "Last Name": "Hutagalung",
    "First Name": "Hendry Donald",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612223": {
    "id": "item_15868",
    "Last Name": "Allott",
    "First Name": "Juanita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612227": {
    "id": "item_2323",
    "Last Name": "Woodside",
    "First Name": "Janine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612236": {
    "id": "item_15352",
    "Last Name": "Reimann",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612267": {
    "id": "item_4502",
    "Last Name": "Webb",
    "First Name": "Jai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612291": {
    "id": "item_15678",
    "Last Name": "Barker",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612297": {
    "id": "item_15351",
    "Last Name": "Nguyen",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612300": {
    "id": "item_29676",
    "Last Name": "Kamerling",
    "First Name": "Tabatha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612304": {
    "id": "item_472",
    "Last Name": "Stone",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612338": {
    "id": "item_2322",
    "Last Name": "Janu",
    "First Name": "Gretel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612351": {
    "id": "item_29675",
    "Last Name": "Kamerling",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612353": {
    "id": "item_4500",
    "Last Name": "Womersley",
    "First Name": "Howard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612373": {
    "id": "item_12990",
    "Last Name": "Montierro",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612392": {
    "id": "item_29760",
    "Last Name": "Dawson",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612409": {
    "id": "item_27888",
    "Last Name": "Lim",
    "First Name": "Celine Araullo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612411": {
    "id": "item_4499",
    "Last Name": "Luey",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612441": {
    "id": "item_15675",
    "Last Name": "Jakymin",
    "First Name": "Elisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612459": {
    "id": "item_15673",
    "Last Name": "Benjabutr",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612495": {
    "id": "item_385",
    "Last Name": "Griffiths",
    "First Name": "Heidi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612530": {
    "id": "item_27739",
    "Last Name": "Antah Putro",
    "First Name": "Gatot Pamungkas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612539": {
    "id": "item_2159",
    "Last Name": "Gibbons",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612540": {
    "id": "item_12987",
    "Last Name": "Mandoukos",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612544": {
    "id": "item_15671",
    "Last Name": "Boyte",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612552": {
    "id": "item_383",
    "Last Name": "Tang",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612569": {
    "id": "item_4492",
    "Last Name": "Le Bourdonnec",
    "First Name": "Pierre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612651": {
    "id": "item_4491",
    "Last Name": "Nieuwoudt",
    "First Name": "Elmi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612652": {
    "id": "item_14892",
    "Last Name": "Richardson",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612667": {
    "id": "item_64",
    "Last Name": "Lesar",
    "First Name": "Yehezkiel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612669": {
    "id": "item_4490",
    "Last Name": "Le Bourdonnec",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612692": {
    "id": "item_27814",
    "Last Name": "Fowler",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612728": {
    "id": "item_27813",
    "Last Name": "Manandhar",
    "First Name": "Rakesh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612735": {
    "id": "item_2478",
    "Last Name": "WU",
    "First Name": "ZEYING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612746": {
    "id": "item_14891",
    "Last Name": "ZHANG",
    "First Name": "CONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612768": {
    "id": "item_4485",
    "Last Name": "Burke",
    "First Name": "Ruben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612770": {
    "id": "item_15342",
    "Last Name": "Kassim",
    "First Name": "Nizam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612796": {
    "id": "item_2317",
    "Last Name": "Fu",
    "First Name": "Ming",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612836": {
    "id": "item_29671",
    "Last Name": "Potter",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612840": {
    "id": "item_376",
    "Last Name": "Shiren",
    "First Name": "Koki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612879": {
    "id": "item_15664",
    "Last Name": "Lewis",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612890": {
    "id": "item_15663",
    "Last Name": "Singh",
    "First Name": "Jagdevpal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612899": {
    "id": "item_4211",
    "Last Name": "Nguyen",
    "First Name": "Ba Thinh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612917": {
    "id": "item_2424",
    "Last Name": "Thompson",
    "First Name": "Genevieve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612932": {
    "id": "item_15867",
    "Last Name": "Allen",
    "First Name": "Allyson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612986": {
    "id": "item_4481",
    "Last Name": "Hilder",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612994": {
    "id": "item_4641",
    "Last Name": "Tran",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613066": {
    "id": "item_2314",
    "Last Name": "WANG",
    "First Name": "TIANYU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613186": {
    "id": "item_231",
    "Last Name": "Kim",
    "First Name": "SangHyun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613524": {
    "id": "item_12983",
    "Last Name": "Anderson",
    "First Name": "Lynn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613690": {
    "id": "item_4479",
    "Last Name": "MacAogain",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613730": {
    "id": "item_29532",
    "Last Name": "Arinda",
    "First Name": "Awang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613732": {
    "id": "item_3917",
    "Last Name": "kwon",
    "First Name": "yongkwan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613771": {
    "id": "item_3916",
    "Last Name": "jung",
    "First Name": "moonkyung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613890": {
    "id": "item_27806",
    "Last Name": "LAMOND",
    "First Name": "PAUL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613925": {
    "id": "item_373",
    "Last Name": "Bulaong",
    "First Name": "Eilwyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613952": {
    "id": "item_27736",
    "Last Name": "Jackson",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613961": {
    "id": "item_15866",
    "Last Name": "Henman",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613981": {
    "id": "item_27608",
    "Last Name": "McMillan",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614168": {
    "id": "item_1964",
    "Last Name": "Longo",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614170": {
    "id": "item_15335",
    "Last Name": "Hoang",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614360": {
    "id": "item_3915",
    "Last Name": "RUAN",
    "First Name": "TAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614430": {
    "id": "item_61",
    "Last Name": "LI",
    "First Name": "RUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614432": {
    "id": "item_3913",
    "Last Name": "HUANG",
    "First Name": "SHU-CHEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614453": {
    "id": "item_15657",
    "Last Name": "Li",
    "First Name": "Sui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614625": {
    "id": "item_14882",
    "Last Name": "Sawada",
    "First Name": "Kazuyoshi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614639": {
    "id": "item_3911",
    "Last Name": "Ilagan",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614682": {
    "id": "item_29527",
    "Last Name": "YAO",
    "First Name": "MINGZHANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614811": {
    "id": "item_1961",
    "Last Name": "NANG",
    "First Name": "Khan Kham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614912": {
    "id": "item_14881",
    "Last Name": "Zhou",
    "First Name": "Shuhua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36615079": {
    "id": "item_14879",
    "Last Name": "Kawasaki",
    "First Name": "Yukinori",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36615214": {
    "id": "item_27607",
    "Last Name": "Chong",
    "First Name": "Mee Ting",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36615426": {
    "id": "item_1960",
    "Last Name": "Phan",
    "First Name": "Anh Tuan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36615450": {
    "id": "item_229",
    "Last Name": "McKie",
    "First Name": "Fred",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36618265": {
    "id": "item_12838",
    "Last Name": "Wilson",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36618644": {
    "id": "item_1958",
    "Last Name": "Crosby",
    "First Name": "Karl",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36621168": {
    "id": "item_29526",
    "Last Name": "Lowery",
    "First Name": "Cory",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36621403": {
    "id": "item_58",
    "Last Name": "wu",
    "First Name": "rong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36621790": {
    "id": "item_369",
    "Last Name": "Mckechnie",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36622449": {
    "id": "item_227",
    "Last Name": "Alway",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36622678": {
    "id": "item_15653",
    "Last Name": "macinnes",
    "First Name": "matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36623252": {
    "id": "item_27606",
    "Last Name": "Kerker",
    "First Name": "Sindee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36623916": {
    "id": "item_2423",
    "Last Name": "Eastman",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624336": {
    "id": "item_29750",
    "Last Name": "Della-Libera",
    "First Name": "Elise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624504": {
    "id": "item_15651",
    "Last Name": "C‰ndido dos Anjos",
    "First Name": "Aline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624535": {
    "id": "item_367",
    "Last Name": "Peadon",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624606": {
    "id": "item_4471",
    "Last Name": "Vera Linares",
    "First Name": "Edvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624736": {
    "id": "item_4469",
    "Last Name": "Nguyen",
    "First Name": "Tien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625182": {
    "id": "item_15865",
    "Last Name": "Morgan",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625204": {
    "id": "item_2156",
    "Last Name": "Power",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625212": {
    "id": "item_12978",
    "Last Name": "Kolokotsas",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625382": {
    "id": "item_27605",
    "Last Name": "Choi",
    "First Name": "Hokyoo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625765": {
    "id": "item_15330",
    "Last Name": "Tamhane",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625818": {
    "id": "item_15649",
    "Last Name": "kennedy",
    "First Name": "sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625978": {
    "id": "item_15647",
    "Last Name": "Sharpe",
    "First Name": "Lois",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625979": {
    "id": "item_15648",
    "Last Name": "Hennessy",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626446": {
    "id": "item_27868",
    "Last Name": "Campbell",
    "First Name": "Debra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626466": {
    "id": "item_3904",
    "Last Name": "Koganezawa",
    "First Name": "Yuichi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626788": {
    "id": "item_15646",
    "Last Name": "Cate Christ",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626905": {
    "id": "item_15645",
    "Last Name": "Malan",
    "First Name": "DeVilliers",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627101": {
    "id": "item_2307",
    "Last Name": "Riegman",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627264": {
    "id": "item_2305",
    "Last Name": "Lauria",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627414": {
    "id": "item_15641",
    "Last Name": "Halls",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627541": {
    "id": "item_27802",
    "Last Name": "Brown",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627611": {
    "id": "item_2302",
    "Last Name": "Kapel",
    "First Name": "Anton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627616": {
    "id": "item_27801",
    "Last Name": "Souter",
    "First Name": "Matilda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627785": {
    "id": "item_15638",
    "Last Name": "Fountain",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627801": {
    "id": "item_4463",
    "Last Name": "Sergent",
    "First Name": "Warren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627937": {
    "id": "item_2422",
    "Last Name": "Goodwin",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627942": {
    "id": "item_362",
    "Last Name": "BRYANT",
    "First Name": "ADAM",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628081": {
    "id": "item_57",
    "Last Name": "OKUMURA",
    "First Name": "HARUHIKO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628083": {
    "id": "item_2300",
    "Last Name": "Jamieson",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628110": {
    "id": "item_224",
    "Last Name": "Sylvestre Ibrahim",
    "First Name": "Rachelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628281": {
    "id": "item_15635",
    "Last Name": "Summers-Levin",
    "First Name": "Trent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628349": {
    "id": "item_2298",
    "Last Name": "pacey",
    "First Name": "mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628613": {
    "id": "item_15327",
    "Last Name": "Marcus",
    "First Name": "Clive",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628626": {
    "id": "item_4461",
    "Last Name": "Ryan",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628722": {
    "id": "item_15632",
    "Last Name": "Horsman",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628729": {
    "id": "item_14869",
    "Last Name": "Eng",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628738": {
    "id": "item_29743",
    "Last Name": "Locke",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628747": {
    "id": "item_2295",
    "Last Name": "Laurenson-Gore",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628876": {
    "id": "item_4458",
    "Last Name": "Nguyen",
    "First Name": "Nam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628895": {
    "id": "item_4457",
    "Last Name": "Johnson",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629079": {
    "id": "item_4204",
    "Last Name": "Leung",
    "First Name": "Wing hei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629157": {
    "id": "item_4455",
    "Last Name": "Harris",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629274": {
    "id": "item_15625",
    "Last Name": "Burhan",
    "First Name": "Randy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629361": {
    "id": "item_13030",
    "Last Name": "Brown",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629435": {
    "id": "item_29810",
    "Last Name": "Bamblett",
    "First Name": "Nikita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629839": {
    "id": "item_15622",
    "Last Name": "Luvio",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630065": {
    "id": "item_2152",
    "Last Name": "Singh",
    "First Name": "Harminder",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630312": {
    "id": "item_4202",
    "Last Name": "Macdonald",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630424": {
    "id": "item_15621",
    "Last Name": "Hanson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630512": {
    "id": "item_356",
    "Last Name": "Lumsden",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630699": {
    "id": "item_2150",
    "Last Name": "Tamlyn",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630758": {
    "id": "item_4450",
    "Last Name": "Gilhooly",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630835": {
    "id": "item_15618",
    "Last Name": "Kenny",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630889": {
    "id": "item_2149",
    "Last Name": "Richy",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630901": {
    "id": "item_15617",
    "Last Name": "Knight",
    "First Name": "Zac",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630949": {
    "id": "item_4449",
    "Last Name": "Gerasimov",
    "First Name": "Grigory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630985": {
    "id": "item_15615",
    "Last Name": "Garcia",
    "First Name": "Len",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36631118": {
    "id": "item_2290",
    "Last Name": "van Uden",
    "First Name": "Yann",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36631296": {
    "id": "item_15613",
    "Last Name": "Lew",
    "First Name": "Terry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36631418": {
    "id": "item_15321",
    "Last Name": "Krippner",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36631518": {
    "id": "item_29483",
    "Last Name": "Mulligan",
    "First Name": "Esme",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36631924": {
    "id": "item_12972",
    "Last Name": "Marevich",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632334": {
    "id": "item_29742",
    "Last Name": "Luu",
    "First Name": "Sung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632373": {
    "id": "item_15864",
    "Last Name": "TURNBULL",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632547": {
    "id": "item_27730",
    "Last Name": "Jones",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632586": {
    "id": "item_4442",
    "Last Name": "Wolfe",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632853": {
    "id": "item_13029",
    "Last Name": "Johnstone",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633286": {
    "id": "item_2147",
    "Last Name": "Baird",
    "First Name": "Dallas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633454": {
    "id": "item_15609",
    "Last Name": "Leonard",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633501": {
    "id": "item_1",
    "Last Name": "Scott",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633774": {
    "id": "item_4440",
    "Last Name": "Riley",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633784": {
    "id": "item_16647",
    "Last Name": "van der Werf",
    "First Name": "Nils",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633793": {
    "id": "item_15607",
    "Last Name": "Hicks",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633822": {
    "id": "item_15604",
    "Last Name": "Stewart",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633992": {
    "id": "item_15602",
    "Last Name": "Carey",
    "First Name": "Damian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634007": {
    "id": "item_2282",
    "Last Name": "Tate",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634082": {
    "id": "item_15598",
    "Last Name": "Clark",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634124": {
    "id": "item_3902",
    "Last Name": "Ditangco",
    "First Name": "Abraham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634605": {
    "id": "item_15596",
    "Last Name": "Heneghan",
    "First Name": "Ashling",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634851": {
    "id": "item_4640",
    "Last Name": "Clarke",
    "First Name": "Kirby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634912": {
    "id": "item_15863",
    "Last Name": "DÕGluyas",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634914": {
    "id": "item_471",
    "Last Name": "Walters",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634946": {
    "id": "item_27794",
    "Last Name": "Sato-Fraser",
    "First Name": "Hideko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635095": {
    "id": "item_15592",
    "Last Name": "Nyar",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635134": {
    "id": "item_12970",
    "Last Name": "Meyer",
    "First Name": "Sofie Elisabeth Thome",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635333": {
    "id": "item_4639",
    "Last Name": "Walker",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635436": {
    "id": "item_4430",
    "Last Name": "Cheng",
    "First Name": "Ka Chung Keith",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636063": {
    "id": "item_220",
    "Last Name": "Bramley",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636165": {
    "id": "item_348",
    "Last Name": "McSweeney",
    "First Name": "Evan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636344": {
    "id": "item_4638",
    "Last Name": "Storey",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636427": {
    "id": "item_346",
    "Last Name": "Lim",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636457": {
    "id": "item_12837",
    "Last Name": "Sowman",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636510": {
    "id": "item_14866",
    "Last Name": "Tan",
    "First Name": "Weidong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636520": {
    "id": "item_2277",
    "Last Name": "Gleeson",
    "First Name": "Cian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636551": {
    "id": "item_345",
    "Last Name": "Goldsworthy",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636768": {
    "id": "item_27604",
    "Last Name": "sevi",
    "First Name": "diana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636774": {
    "id": "item_4423",
    "Last Name": "Huang",
    "First Name": "Jianping",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636818": {
    "id": "item_4422",
    "Last Name": "MacKinnon",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636961": {
    "id": "item_27790",
    "Last Name": "Murray",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637413": {
    "id": "item_29739",
    "Last Name": "Sanchez",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637694": {
    "id": "item_27867",
    "Last Name": "Bloomfield",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637699": {
    "id": "item_2146",
    "Last Name": "Carr",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637800": {
    "id": "item_2275",
    "Last Name": "Bridgemohan",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637829": {
    "id": "item_15577",
    "Last Name": "Cheng",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637851": {
    "id": "item_12966",
    "Last Name": "Cooke",
    "First Name": "Jo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638036": {
    "id": "item_344",
    "Last Name": "Hafi",
    "First Name": "Mohamed Isdihar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638258": {
    "id": "item_15574",
    "Last Name": "Balzarolo",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638269": {
    "id": "item_27866",
    "Last Name": "Gifford",
    "First Name": "Lara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638271": {
    "id": "item_15573",
    "Last Name": "Hoang",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638284": {
    "id": "item_13038",
    "Last Name": "Thompson",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638474": {
    "id": "item_29665",
    "Last Name": "Acharya Bhagavatula",
    "First Name": "Rakesh Kamal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638592": {
    "id": "item_2273",
    "Last Name": "Mckenzie-Gay",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638672": {
    "id": "item_14863",
    "Last Name": "Lee",
    "First Name": "Kok Yee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638707": {
    "id": "item_2270",
    "Last Name": "Gray",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638851": {
    "id": "item_4415",
    "Last Name": "Kinene",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638865": {
    "id": "item_4414",
    "Last Name": "Absalom",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638885": {
    "id": "item_29524",
    "Last Name": "Mohd Azhari",
    "First Name": "Arina Zaharah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638963": {
    "id": "item_15570",
    "Last Name": "Pittaway",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638985": {
    "id": "item_4636",
    "Last Name": "Murphy",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638993": {
    "id": "item_15862",
    "Last Name": "McGrath",
    "First Name": "Heidi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639049": {
    "id": "item_4196",
    "Last Name": "Mcevoy",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639132": {
    "id": "item_14859",
    "Last Name": "WENJUN",
    "First Name": "SHENG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639196": {
    "id": "item_15861",
    "Last Name": "Bush",
    "First Name": "Graham",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639250": {
    "id": "item_339",
    "Last Name": "Taylor",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639274": {
    "id": "item_3897",
    "Last Name": "Ireland",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639353": {
    "id": "item_4412",
    "Last Name": "Pont",
    "First Name": "Byron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639541": {
    "id": "item_4411",
    "Last Name": "LIM",
    "First Name": "GIM PENG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639546": {
    "id": "item_15568",
    "Last Name": "oskar",
    "First Name": "andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639572": {
    "id": "item_14857",
    "Last Name": "Gooding",
    "First Name": "Rose",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639660": {
    "id": "item_53",
    "Last Name": "Nakayama",
    "First Name": "Tomoyuki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639699": {
    "id": "item_15860",
    "Last Name": "Saunderson",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639733": {
    "id": "item_4192",
    "Last Name": "Pickering",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639756": {
    "id": "item_29737",
    "Last Name": "Contreras",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639795": {
    "id": "item_4407",
    "Last Name": "Calleija",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639804": {
    "id": "item_29736",
    "Last Name": "Cullen",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639865": {
    "id": "item_4191",
    "Last Name": "OReilly",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639866": {
    "id": "item_4405",
    "Last Name": "Sharp",
    "First Name": "Pete",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639873": {
    "id": "item_2144",
    "Last Name": "Zhang",
    "First Name": "Baoping",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640075": {
    "id": "item_4404",
    "Last Name": "Wilson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640142": {
    "id": "item_4190",
    "Last Name": "Ma",
    "First Name": "Liying",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640146": {
    "id": "item_29661",
    "Last Name": "MacGregor",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640147": {
    "id": "item_332",
    "Last Name": "Rigney",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640152": {
    "id": "item_331",
    "Last Name": "Ford",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640201": {
    "id": "item_4401",
    "Last Name": "Slakey",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640215": {
    "id": "item_4399",
    "Last Name": "Novoa Peralta",
    "First Name": "Vicente",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640290": {
    "id": "item_15859",
    "Last Name": "Wilson",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640343": {
    "id": "item_2263",
    "Last Name": "Zhang",
    "First Name": "Emmett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640369": {
    "id": "item_27727",
    "Last Name": "Cunningham",
    "First Name": "Alana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640486": {
    "id": "item_27787",
    "Last Name": "Wigzell",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640489": {
    "id": "item_4398",
    "Last Name": "Richard",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640567": {
    "id": "item_330",
    "Last Name": "Birch",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640628": {
    "id": "item_15558",
    "Last Name": "Gresham",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640741": {
    "id": "item_27602",
    "Last Name": "Xie",
    "First Name": "Peichen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640854": {
    "id": "item_15557",
    "Last Name": "Forrest",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640909": {
    "id": "item_4396",
    "Last Name": "XIAO",
    "First Name": "BEIZE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640931": {
    "id": "item_15858",
    "Last Name": "young",
    "First Name": "craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640937": {
    "id": "item_2260",
    "Last Name": "Crowley",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641026": {
    "id": "item_14854",
    "Last Name": "Gunawan",
    "First Name": "Endy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641065": {
    "id": "item_329",
    "Last Name": "Phillips",
    "First Name": "Jethro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641094": {
    "id": "item_328",
    "Last Name": "OÕConnor",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641168": {
    "id": "item_2143",
    "Last Name": "Albertos",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641170": {
    "id": "item_27784",
    "Last Name": "Gomes",
    "First Name": "Sheri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641215": {
    "id": "item_2141",
    "Last Name": "Bealby",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641221": {
    "id": "item_15553",
    "Last Name": "Eustace",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641265": {
    "id": "item_15552",
    "Last Name": "Hubble",
    "First Name": "Rowena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641281": {
    "id": "item_15551",
    "Last Name": "Rossi-Zalmons",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641307": {
    "id": "item_15548",
    "Last Name": "Economos",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641317": {
    "id": "item_13028",
    "Last Name": "Gauci",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641329": {
    "id": "item_27783",
    "Last Name": "OCHIAI",
    "First Name": "YUKIKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641357": {
    "id": "item_15545",
    "Last Name": "Kehagias",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641381": {
    "id": "item_4391",
    "Last Name": "Giraldo Caro",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641399": {
    "id": "item_4184",
    "Last Name": "Anderson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641408": {
    "id": "item_216",
    "Last Name": "Stefanac",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641773": {
    "id": "item_12961",
    "Last Name": "Kuru",
    "First Name": "TJ",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641783": {
    "id": "item_15305",
    "Last Name": "PAL",
    "First Name": "JOGINDER",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641815": {
    "id": "item_2250",
    "Last Name": "Dumesich",
    "First Name": "Heidi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641819": {
    "id": "item_15542",
    "Last Name": "Filbin",
    "First Name": "Tayler",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641861": {
    "id": "item_15541",
    "Last Name": "Williamson",
    "First Name": "Ainsley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641891": {
    "id": "item_14852",
    "Last Name": "Cheung",
    "First Name": "Chu Wah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641920": {
    "id": "item_4181",
    "Last Name": "Fisher",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641923": {
    "id": "item_15539",
    "Last Name": "Shriniwas",
    "First Name": "Badrish",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641977": {
    "id": "item_4387",
    "Last Name": "Seneviratne",
    "First Name": "Danusha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642013": {
    "id": "item_2247",
    "Last Name": "Soto Quiceno",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642019": {
    "id": "item_15857",
    "Last Name": "Morrow",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642044": {
    "id": "item_15299",
    "Last Name": "Lyons",
    "First Name": "Annabelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642068": {
    "id": "item_15856",
    "Last Name": "Rhodes",
    "First Name": "Poppy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642071": {
    "id": "item_322",
    "Last Name": "Chan",
    "First Name": "Kalia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642075": {
    "id": "item_15855",
    "Last Name": "Mortensen",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642111": {
    "id": "item_12914",
    "Last Name": "Levin",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642182": {
    "id": "item_12959",
    "Last Name": "Gaynes",
    "First Name": "Davin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642191": {
    "id": "item_29733",
    "Last Name": "Ziegler",
    "First Name": "Celia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642226": {
    "id": "item_15533",
    "Last Name": "Mcintyre",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642247": {
    "id": "item_4381",
    "Last Name": "Xavier Francisco",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642267": {
    "id": "item_29655",
    "Last Name": "Wood",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642377": {
    "id": "item_1954",
    "Last Name": "Zu–iga",
    "First Name": "Erwyn Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642455": {
    "id": "item_29731",
    "Last Name": "The",
    "First Name": "Clifford",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642462": {
    "id": "item_29730",
    "Last Name": "House",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642486": {
    "id": "item_51",
    "Last Name": "CHIU",
    "First Name": "TIEN HUA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642504": {
    "id": "item_12957",
    "Last Name": "Tse",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642718": {
    "id": "item_15526",
    "Last Name": "Juranes",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642987": {
    "id": "item_4178",
    "Last Name": "Syred",
    "First Name": "Kris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36643129": {
    "id": "item_211",
    "Last Name": "Chan",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36644024": {
    "id": "item_27779",
    "Last Name": "Wong",
    "First Name": "Siong Teck",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36644123": {
    "id": "item_27601",
    "Last Name": "__",
    "First Name": "___",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36644226": {
    "id": "item_1953",
    "Last Name": "LAW",
    "First Name": "WAI CHUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36644522": {
    "id": "item_15523",
    "Last Name": "Charlton-Hughes",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36645362": {
    "id": "item_29522",
    "Last Name": "HAN",
    "First Name": "JINYOUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36647236": {
    "id": "item_4378",
    "Last Name": "Spendelove",
    "First Name": "Tanisha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36648485": {
    "id": "item_4376",
    "Last Name": "Eustace",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36648577": {
    "id": "item_4175",
    "Last Name": "Conway",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36648848": {
    "id": "item_2242",
    "Last Name": "Agoo",
    "First Name": "Edna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649289": {
    "id": "item_15517",
    "Last Name": "Palmer",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649315": {
    "id": "item_4373",
    "Last Name": "Wu",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649365": {
    "id": "item_4372",
    "Last Name": "Bailie",
    "First Name": "Eamon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649592": {
    "id": "item_4369",
    "Last Name": "Stephens",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649848": {
    "id": "item_315",
    "Last Name": "Zunino",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649854": {
    "id": "item_15512",
    "Last Name": "Firmager",
    "First Name": "Billy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649919": {
    "id": "item_15854",
    "Last Name": "Smitsman",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649945": {
    "id": "item_29724",
    "Last Name": "Heyes",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650004": {
    "id": "item_4173",
    "Last Name": "Yat",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650064": {
    "id": "item_29723",
    "Last Name": "Weichert",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650238": {
    "id": "item_4365",
    "Last Name": "Hunter",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650298": {
    "id": "item_2134",
    "Last Name": "Pocknee",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650327": {
    "id": "item_15506",
    "Last Name": "Stafford",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650346": {
    "id": "item_29722",
    "Last Name": "Erasmo",
    "First Name": "Darius",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650365": {
    "id": "item_2239",
    "Last Name": "Rozo",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650568": {
    "id": "item_48",
    "Last Name": "Ho",
    "First Name": "Chun Yip Billy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650607": {
    "id": "item_27725",
    "Last Name": "Crosbie",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651019": {
    "id": "item_4361",
    "Last Name": "Vink",
    "First Name": "Jimmo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651049": {
    "id": "item_4171",
    "Last Name": "CAPEL",
    "First Name": "ANGUS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651077": {
    "id": "item_311",
    "Last Name": "Xie",
    "First Name": "Tianyi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651104": {
    "id": "item_4360",
    "Last Name": "Ngo",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651191": {
    "id": "item_15503",
    "Last Name": "Buchhorn",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651283": {
    "id": "item_27776",
    "Last Name": "Sun",
    "First Name": "Xianbin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651303": {
    "id": "item_207",
    "Last Name": "Zhang",
    "First Name": "Ying",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651372": {
    "id": "item_4358",
    "Last Name": "Bourke",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651480": {
    "id": "item_12913",
    "Last Name": "Zhang",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651516": {
    "id": "item_4357",
    "Last Name": "Smith",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651671": {
    "id": "item_2237",
    "Last Name": "Davis",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651676": {
    "id": "item_29654",
    "Last Name": "Randle",
    "First Name": "Susanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651752": {
    "id": "item_4355",
    "Last Name": "Sullivan",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651866": {
    "id": "item_29653",
    "Last Name": "Randle",
    "First Name": "Jazzy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651871": {
    "id": "item_27775",
    "Last Name": "Dharwadkar",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651925": {
    "id": "item_15495",
    "Last Name": "ROBINSON",
    "First Name": "ANTHONY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651929": {
    "id": "item_15496",
    "Last Name": "Cunneen",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651988": {
    "id": "item_2236",
    "Last Name": "Warland",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652063": {
    "id": "item_4353",
    "Last Name": "Madden",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652071": {
    "id": "item_15494",
    "Last Name": "Wall",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652080": {
    "id": "item_2132",
    "Last Name": "Wetherall",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652130": {
    "id": "item_27773",
    "Last Name": "Toa",
    "First Name": "Job",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652158": {
    "id": "item_15493",
    "Last Name": "McDonald",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652335": {
    "id": "item_15491",
    "Last Name": "Appel",
    "First Name": "Robin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652378": {
    "id": "item_27772",
    "Last Name": "Reyes",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652427": {
    "id": "item_29720",
    "Last Name": "Del Villar",
    "First Name": "Dyean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652471": {
    "id": "item_29652",
    "Last Name": "Wong",
    "First Name": "Tak Ho",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652526": {
    "id": "item_12951",
    "Last Name": "Matthews",
    "First Name": "Al",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652537": {
    "id": "item_2230",
    "Last Name": "Brown",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652657": {
    "id": "item_29719",
    "Last Name": "Barro",
    "First Name": "Darwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652711": {
    "id": "item_29651",
    "Last Name": "Yau",
    "First Name": "Siu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652713": {
    "id": "item_27771",
    "Last Name": "Carr",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652726": {
    "id": "item_29718",
    "Last Name": "Kirwan",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652744": {
    "id": "item_309",
    "Last Name": "Mandleberg",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652754": {
    "id": "item_27770",
    "Last Name": "So",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652806": {
    "id": "item_27769",
    "Last Name": "Moon",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652810": {
    "id": "item_15488",
    "Last Name": "Esaev",
    "First Name": "Bobby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652834": {
    "id": "item_29717",
    "Last Name": "Ye",
    "First Name": "Zimeng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652872": {
    "id": "item_4168",
    "Last Name": "Scarponi",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652877": {
    "id": "item_15284",
    "Last Name": "Houtman",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653224": {
    "id": "item_4348",
    "Last Name": "Sedain",
    "First Name": "Kamal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653365": {
    "id": "item_4347",
    "Last Name": "Young",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653379": {
    "id": "item_15484",
    "Last Name": "Chant",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653408": {
    "id": "item_4346",
    "Last Name": "Wang",
    "First Name": "Chunsheng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653462": {
    "id": "item_15483",
    "Last Name": "Houlahan",
    "First Name": "Tara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653499": {
    "id": "item_12911",
    "Last Name": "Martin",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653506": {
    "id": "item_15282",
    "Last Name": "Tran",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653513": {
    "id": "item_4345",
    "Last Name": "Brunacci",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653517": {
    "id": "item_27768",
    "Last Name": "Brown",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653593": {
    "id": "item_4344",
    "Last Name": "Booth",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653774": {
    "id": "item_27599",
    "Last Name": "Wang",
    "First Name": "Guoliang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653873": {
    "id": "item_15280",
    "Last Name": "Hunt",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653948": {
    "id": "item_4340",
    "Last Name": "JIN",
    "First Name": "HAITAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654024": {
    "id": "item_15478",
    "Last Name": "Leaney",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654040": {
    "id": "item_12946",
    "Last Name": "Rezaeimotlagh",
    "First Name": "Adel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654132": {
    "id": "item_12945",
    "Last Name": "Johnsun",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654174": {
    "id": "item_15477",
    "Last Name": "Castillo",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654218": {
    "id": "item_204",
    "Last Name": "Sun",
    "First Name": "D.",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654246": {
    "id": "item_2129",
    "Last Name": "Zhang",
    "First Name": "Qiongqiong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654282": {
    "id": "item_4336",
    "Last Name": "Keltchine",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654407": {
    "id": "item_4335",
    "Last Name": "Sun",
    "First Name": "Jiaxun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654468": {
    "id": "item_2224",
    "Last Name": "Williams",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654590": {
    "id": "item_303",
    "Last Name": "Holmes",
    "First Name": "Kristofer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654832": {
    "id": "item_302",
    "Last Name": "Hopkins",
    "First Name": "Grace",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654892": {
    "id": "item_12942",
    "Last Name": "Blackmore",
    "First Name": "Kieron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654952": {
    "id": "item_27865",
    "Last Name": "Lawson",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654957": {
    "id": "item_15471",
    "Last Name": "Murali",
    "First Name": "Nithin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654963": {
    "id": "item_15470",
    "Last Name": "Kwan",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654980": {
    "id": "item_15467",
    "Last Name": "Wood",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654982": {
    "id": "item_15466",
    "Last Name": "Paul",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654991": {
    "id": "item_12940",
    "Last Name": "Power",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654992": {
    "id": "item_12938",
    "Last Name": "Werry",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654994": {
    "id": "item_4329",
    "Last Name": "Rogers",
    "First Name": "Katie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654999": {
    "id": "item_4328",
    "Last Name": "Ahmed",
    "First Name": "Arslan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655002": {
    "id": "item_4164",
    "Last Name": "Kristanto",
    "First Name": "Abraham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655003": {
    "id": "item_15460",
    "Last Name": "Aprilia",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655012": {
    "id": "item_4325",
    "Last Name": "Hsu",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655017": {
    "id": "item_12937",
    "Last Name": "Fraser",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655019": {
    "id": "item_299",
    "Last Name": "Toohey",
    "First Name": "Pat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655024": {
    "id": "item_4326",
    "Last Name": "Woodall",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655025": {
    "id": "item_15279",
    "Last Name": "Snadden",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655032": {
    "id": "item_203",
    "Last Name": "Guan",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655035": {
    "id": "item_4324",
    "Last Name": "Lo",
    "First Name": "Hayson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655040": {
    "id": "item_2221",
    "Last Name": "Podzorov",
    "First Name": "Oleg",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655046": {
    "id": "item_4321",
    "Last Name": "Chang",
    "First Name": "Jane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655050": {
    "id": "item_15454",
    "Last Name": "Tan",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655057": {
    "id": "item_201",
    "Last Name": "Macatangay",
    "First Name": "Melech",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655060": {
    "id": "item_4320",
    "Last Name": "McCrohon",
    "First Name": "Bayley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655065": {
    "id": "item_27864",
    "Last Name": "Brock",
    "First Name": "Renae",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655073": {
    "id": "item_29710",
    "Last Name": "Kong",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655074": {
    "id": "item_15450",
    "Last Name": "Cooper",
    "First Name": "Billy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655075": {
    "id": "item_15449",
    "Last Name": "Jung",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655085": {
    "id": "item_4319",
    "Last Name": "Le",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655087": {
    "id": "item_199",
    "Last Name": "Nguyen",
    "First Name": "Huy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655092": {
    "id": "item_198",
    "Last Name": "Capper",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655096": {
    "id": "item_2219",
    "Last Name": "Branley",
    "First Name": "Monika",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655101": {
    "id": "item_27723",
    "Last Name": "Forsingdal",
    "First Name": "Shareen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655103": {
    "id": "item_297",
    "Last Name": "Allen",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655120": {
    "id": "item_4318",
    "Last Name": "Huang",
    "First Name": "Yiting",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655128": {
    "id": "item_15851",
    "Last Name": "Bloor",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655147": {
    "id": "item_15442",
    "Last Name": "Kim",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655150": {
    "id": "item_294",
    "Last Name": "Chapman",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655156": {
    "id": "item_4317",
    "Last Name": "Alderton",
    "First Name": "Ted",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655160": {
    "id": "item_4314",
    "Last Name": "Seol",
    "First Name": "Jin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655167": {
    "id": "item_4315",
    "Last Name": "Columbus",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655169": {
    "id": "item_4161",
    "Last Name": "Puarr",
    "First Name": "Amrit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655173": {
    "id": "item_2214",
    "Last Name": "Alley",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655174": {
    "id": "item_27757",
    "Last Name": "Barcelon",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655178": {
    "id": "item_2212",
    "Last Name": "Wein",
    "First Name": "Logan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655179": {
    "id": "item_4634",
    "Last Name": "Botha",
    "First Name": "Fonnie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655184": {
    "id": "item_27756",
    "Last Name": "Hoch",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655186": {
    "id": "item_29521",
    "Last Name": "NADELA",
    "First Name": "RAUL JR",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655193": {
    "id": "item_2213",
    "Last Name": "coskie",
    "First Name": "richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655196": {
    "id": "item_14840",
    "Last Name": "Garcia",
    "First Name": "Alexandra Faith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655204": {
    "id": "item_14841",
    "Last Name": "Mugisha",
    "First Name": "Landry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655205": {
    "id": "item_2211",
    "Last Name": "Bisschop",
    "First Name": "Frans",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655232": {
    "id": "item_2421",
    "Last Name": "Corrigan",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655238": {
    "id": "item_1950",
    "Last Name": "Gordon",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655253": {
    "id": "item_15433",
    "Last Name": "Garth",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655257": {
    "id": "item_15432",
    "Last Name": "Yuan",
    "First Name": "Shuai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655262": {
    "id": "item_15427",
    "Last Name": "Sorensen",
    "First Name": "Lars",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655264": {
    "id": "item_15849",
    "Last Name": "O'Toole",
    "First Name": "Callum",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655277": {
    "id": "item_2206",
    "Last Name": "Musulin",
    "First Name": "Stevan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655282": {
    "id": "item_29704",
    "Last Name": "Subramanian",
    "First Name": "Palani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655288": {
    "id": "item_43",
    "Last Name": "YEN",
    "First Name": "YUMING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655299": {
    "id": "item_2420",
    "Last Name": "Parker",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655307": {
    "id": "item_286",
    "Last Name": "Wolters",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655312": {
    "id": "item_15429",
    "Last Name": "Greatrex",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655317": {
    "id": "item_15425",
    "Last Name": "Marturano",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655318": {
    "id": "item_4160",
    "Last Name": "Emrose",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655321": {
    "id": "item_27755",
    "Last Name": "Wu",
    "First Name": "Xueshan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655322": {
    "id": "item_284",
    "Last Name": "Ahlawat",
    "First Name": "Parvinder",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655323": {
    "id": "item_15426",
    "Last Name": "Pariyarath",
    "First Name": "Arjun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655324": {
    "id": "item_14837",
    "Last Name": "herman",
    "First Name": "herman",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655331": {
    "id": "item_280",
    "Last Name": "Mansell",
    "First Name": "Kane Francis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655336": {
    "id": "item_15423",
    "Last Name": "Kliman",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655341": {
    "id": "item_15419",
    "Last Name": "Fewtrell",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655346": {
    "id": "item_15848",
    "Last Name": "King",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655349": {
    "id": "item_2207",
    "Last Name": "Soo",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655350": {
    "id": "item_281",
    "Last Name": "Leijer",
    "First Name": "NIck",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655351": {
    "id": "item_4303",
    "Last Name": "Ghaly",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655355": {
    "id": "item_278",
    "Last Name": "Kimpton",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655367": {
    "id": "item_29520",
    "Last Name": "INAJI",
    "First Name": "NATSUMI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655368": {
    "id": "item_279",
    "Last Name": "Wylie",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655369": {
    "id": "item_2201",
    "Last Name": "Cui",
    "First Name": "Hongjie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655387": {
    "id": "item_29646",
    "Last Name": "Finn",
    "First Name": "Aida",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655393": {
    "id": "item_29808",
    "Last Name": "Addinall",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655397": {
    "id": "item_12832",
    "Last Name": "Larson",
    "First Name": "Beata",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655400": {
    "id": "item_29700",
    "Last Name": "Wong",
    "First Name": "Allan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655411": {
    "id": "item_15414",
    "Last Name": "Wadud",
    "First Name": "Md Abu Raihan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655439": {
    "id": "item_3885",
    "Last Name": "Tumiel",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655447": {
    "id": "item_27722",
    "Last Name": "Yu",
    "First Name": "Siqi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655458": {
    "id": "item_2195",
    "Last Name": "Lamichhane",
    "First Name": "Amit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655463": {
    "id": "item_27597",
    "Last Name": "Gabucan",
    "First Name": "Marlo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655468": {
    "id": "item_276",
    "Last Name": "Ellis",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655477": {
    "id": "item_15407",
    "Last Name": "Ng",
    "First Name": "Sunny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655506": {
    "id": "item_275",
    "Last Name": "Serbin",
    "First Name": "Platon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655517": {
    "id": "item_4292",
    "Last Name": "Hollingworth",
    "First Name": "Rod",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655541": {
    "id": "item_15406",
    "Last Name": "Grigg",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655543": {
    "id": "item_4291",
    "Last Name": "Patching",
    "First Name": "Micah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655545": {
    "id": "item_29645",
    "Last Name": "Lamberg",
    "First Name": "Saara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655565": {
    "id": "item_4289",
    "Last Name": "Barton",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655590": {
    "id": "item_4158",
    "Last Name": "Anderson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655603": {
    "id": "item_15400",
    "Last Name": "Cawood",
    "First Name": "Flynn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655607": {
    "id": "item_15401",
    "Last Name": "Sandoval",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655620": {
    "id": "item_15844",
    "Last Name": "Marsh",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655623": {
    "id": "item_15397",
    "Last Name": "Song",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655634": {
    "id": "item_2190",
    "Last Name": "Deladriere",
    "First Name": "Charles-Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655657": {
    "id": "item_195",
    "Last Name": "Mooney",
    "First Name": "Lili",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655659": {
    "id": "item_269",
    "Last Name": "Dixon",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655665": {
    "id": "item_4283",
    "Last Name": "Gemell",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655680": {
    "id": "item_4281",
    "Last Name": "Rumpff",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655691": {
    "id": "item_4279",
    "Last Name": "Capistrano",
    "First Name": "Kirk",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655699": {
    "id": "item_4628",
    "Last Name": "Lim",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655710": {
    "id": "item_470",
    "Last Name": "Newling",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655711": {
    "id": "item_2188",
    "Last Name": "Perkins",
    "First Name": "Justine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655727": {
    "id": "item_29806",
    "Last Name": "Rampal",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655729": {
    "id": "item_4156",
    "Last Name": "Anderson",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655743": {
    "id": "item_29697",
    "Last Name": "Tsang",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655748": {
    "id": "item_4277",
    "Last Name": "Brinnand",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655754": {
    "id": "item_4276",
    "Last Name": "Sacharowitz",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655764": {
    "id": "item_40",
    "Last Name": "Poulin",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655770": {
    "id": "item_264",
    "Last Name": "Kapoor",
    "First Name": "Tejas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655776": {
    "id": "item_15390",
    "Last Name": "MPOFU",
    "First Name": "Josiah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655777": {
    "id": "item_27746",
    "Last Name": "Rimando",
    "First Name": "Norman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655778": {
    "id": "item_4273",
    "Last Name": "Carmody",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655780": {
    "id": "item_15391",
    "Last Name": "Burton",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655782": {
    "id": "item_29696",
    "Last Name": "Cheung",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655786": {
    "id": "item_4629",
    "Last Name": "Young",
    "First Name": "Zac",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655793": {
    "id": "item_15389",
    "Last Name": "Shortt",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655804": {
    "id": "item_15387",
    "Last Name": "Joseph",
    "First Name": "Cian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655818": {
    "id": "item_15386",
    "Last Name": "Collins",
    "First Name": "Cathal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655831": {
    "id": "item_13026",
    "Last Name": "Gibson",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655832": {
    "id": "item_15385",
    "Last Name": "Morris",
    "First Name": "Brayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655838": {
    "id": "item_194",
    "Last Name": "Mckeough",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655860": {
    "id": "item_4155",
    "Last Name": "Cornish",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655862": {
    "id": "item_29694",
    "Last Name": "Santos",
    "First Name": "Noreen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655865": {
    "id": "item_262",
    "Last Name": "Aerenga",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655895": {
    "id": "item_15843",
    "Last Name": "Peters",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655897": {
    "id": "item_258",
    "Last Name": "Milloy",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655900": {
    "id": "item_27594",
    "Last Name": "Pearce",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655907": {
    "id": "item_29691",
    "Last Name": "Player",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655909": {
    "id": "item_257",
    "Last Name": "Fanning",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656029": {
    "id": "item_252",
    "Last Name": "Glucina-stevens",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656121": {
    "id": "item_15841",
    "Last Name": "Gill",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656138": {
    "id": "item_2179",
    "Last Name": "Turhanlar",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656143": {
    "id": "item_4260",
    "Last Name": "Acosta",
    "First Name": "Puttarapong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656159": {
    "id": "item_15376",
    "Last Name": "Ham",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656165": {
    "id": "item_29803",
    "Last Name": "Sinaguinan",
    "First Name": "John Rafael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656219": {
    "id": "item_4257",
    "Last Name": "Servaas",
    "First Name": "Kim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656221": {
    "id": "item_4254",
    "Last Name": "Weinberg",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656225": {
    "id": "item_4256",
    "Last Name": "Killalea",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656232": {
    "id": "item_4255",
    "Last Name": "Tuit",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656235": {
    "id": "item_4253",
    "Last Name": "Alston",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656246": {
    "id": "item_4252",
    "Last Name": "Alston",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656279": {
    "id": "item_2413",
    "Last Name": "Frost",
    "First Name": "Berni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656296": {
    "id": "item_15372",
    "Last Name": "Piggott",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656302": {
    "id": "item_4249",
    "Last Name": "Dawes",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656311": {
    "id": "item_15371",
    "Last Name": "Reynolds",
    "First Name": "Neville",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656323": {
    "id": "item_15370",
    "Last Name": "Yoshimura",
    "First Name": "Edgardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656336": {
    "id": "item_15263",
    "Last Name": "Clarke",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656341": {
    "id": "item_247",
    "Last Name": "Sekimori",
    "First Name": "Junta",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656343": {
    "id": "item_15369",
    "Last Name": "Sutjipto",
    "First Name": "Anastasia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656345": {
    "id": "item_2174",
    "Last Name": "Wilkins",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656354": {
    "id": "item_244",
    "Last Name": "Noga",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656363": {
    "id": "item_243",
    "Last Name": "Lam",
    "First Name": "Garry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656376": {
    "id": "item_15368",
    "Last Name": "Culhane",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656387": {
    "id": "item_466",
    "Last Name": "Humphries",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656439": {
    "id": "item_4237",
    "Last Name": "Bindroo",
    "First Name": "Manish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656471": {
    "id": "item_14829",
    "Last Name": "Young",
    "First Name": "Riya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656485": {
    "id": "item_4235",
    "Last Name": "Clement-Churn",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656489": {
    "id": "item_242",
    "Last Name": "Polivnick",
    "First Name": "Warren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656490": {
    "id": "item_4231",
    "Last Name": "Blackler",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656492": {
    "id": "item_2169",
    "Last Name": "Rogers",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656506": {
    "id": "item_15365",
    "Last Name": "Chen",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656549": {
    "id": "item_239",
    "Last Name": "Millar",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656577": {
    "id": "item_2167",
    "Last Name": "Doumit",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656621": {
    "id": "item_29684",
    "Last Name": "Tziavaras",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656654": {
    "id": "item_2165",
    "Last Name": "Rutovitz",
    "First Name": "Liron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656672": {
    "id": "item_15359",
    "Last Name": "Wightman",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656681": {
    "id": "item_29683",
    "Last Name": "Palethorpe",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656721": {
    "id": "item_15358",
    "Last Name": "Hodes",
    "First Name": "Raphael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656734": {
    "id": "item_29680",
    "Last Name": "Absalom",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656771": {
    "id": "item_4227",
    "Last Name": "Gavazzi",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656788": {
    "id": "item_465",
    "Last Name": "Mcaneny",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656835": {
    "id": "item_4620",
    "Last Name": "ryder",
    "First Name": "william",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656842": {
    "id": "item_29643",
    "Last Name": "So",
    "First Name": "Cherry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656866": {
    "id": "item_4225",
    "Last Name": "Geraghty",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656872": {
    "id": "item_27741",
    "Last Name": "Martin",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656881": {
    "id": "item_237",
    "Last Name": "Reid",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656893": {
    "id": "item_191",
    "Last Name": "Harrington",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656932": {
    "id": "item_2162",
    "Last Name": "Hashemi Pour",
    "First Name": "Amir",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657044": {
    "id": "item_14827",
    "Last Name": "Tanzil",
    "First Name": "Irwan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657047": {
    "id": "item_15356",
    "Last Name": "Reichel",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657049": {
    "id": "item_29678",
    "Last Name": "Choi",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657065": {
    "id": "item_235",
    "Last Name": "Vo",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657119": {
    "id": "item_2412",
    "Last Name": "Jones",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657124": {
    "id": "item_29677",
    "Last Name": "Thomson",
    "First Name": "Kellie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657126": {
    "id": "item_4223",
    "Last Name": "Dinh",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657191": {
    "id": "item_233",
    "Last Name": "Little",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657196": {
    "id": "item_27862",
    "Last Name": "Makocha",
    "First Name": "Uno",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657231": {
    "id": "item_15350",
    "Last Name": "Graham",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657259": {
    "id": "item_15349",
    "Last Name": "Moseley",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657279": {
    "id": "item_29674",
    "Last Name": "Wong",
    "First Name": "Edmund",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657320": {
    "id": "item_15347",
    "Last Name": "Bungard",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657363": {
    "id": "item_4220",
    "Last Name": "Mc Menamin",
    "First Name": "Cliodhna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657365": {
    "id": "item_4219",
    "Last Name": "Muir",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657383": {
    "id": "item_29673",
    "Last Name": "JEONG",
    "First Name": "Derek",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657393": {
    "id": "item_27740",
    "Last Name": "Vijayan",
    "First Name": "Raju",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657409": {
    "id": "item_4216",
    "Last Name": "Chea",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657462": {
    "id": "item_4619",
    "Last Name": "Wood",
    "First Name": "Oenone",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657471": {
    "id": "item_4215",
    "Last Name": "Kelly",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657547": {
    "id": "item_4147",
    "Last Name": "Bakker",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657629": {
    "id": "item_36",
    "Last Name": "YAMAZAKI",
    "First Name": "TAKESHI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657636": {
    "id": "item_15341",
    "Last Name": "Souhani",
    "First Name": "Talal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657657": {
    "id": "item_15339",
    "Last Name": "SONG",
    "First Name": "Wanpeng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657706": {
    "id": "item_27738",
    "Last Name": "Ly",
    "First Name": "Alyce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657720": {
    "id": "item_4212",
    "Last Name": "Comiskey",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657759": {
    "id": "item_27737",
    "Last Name": "Arendse",
    "First Name": "Carl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657765": {
    "id": "item_29669",
    "Last Name": "Bhatnagar",
    "First Name": "Yash",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657789": {
    "id": "item_4618",
    "Last Name": "Dunstan",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657796": {
    "id": "item_232",
    "Last Name": "Bairstow",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657870": {
    "id": "item_230",
    "Last Name": "Walker",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657881": {
    "id": "item_12921",
    "Last Name": "Kerr",
    "First Name": "Karina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657885": {
    "id": "item_29642",
    "Last Name": "Jennings",
    "First Name": "Jotham",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657896": {
    "id": "item_15336",
    "Last Name": "O'ROURKE",
    "First Name": "JOHN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657986": {
    "id": "item_4209",
    "Last Name": "Gill",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658101": {
    "id": "item_15334",
    "Last Name": "Ying",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658141": {
    "id": "item_27735",
    "Last Name": "Deighton Shapcott",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658144": {
    "id": "item_27734",
    "Last Name": "Garnier",
    "First Name": "Dominique",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658191": {
    "id": "item_12919",
    "Last Name": "Romano",
    "First Name": "Catia-Rose",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658208": {
    "id": "item_14823",
    "Last Name": "Tran",
    "First Name": "Mimi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658332": {
    "id": "item_15259",
    "Last Name": "Heiskari",
    "First Name": "Jukka",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658364": {
    "id": "item_4145",
    "Last Name": "Goodacre",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658365": {
    "id": "item_15333",
    "Last Name": "Singh",
    "First Name": "Ranjit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658369": {
    "id": "item_464",
    "Last Name": "Maher",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658424": {
    "id": "item_15332",
    "Last Name": "Bourlias",
    "First Name": "Chrys",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658427": {
    "id": "item_15331",
    "Last Name": "Li",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658518": {
    "id": "item_225",
    "Last Name": "Lukey",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658525": {
    "id": "item_4206",
    "Last Name": "Yeo",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658562": {
    "id": "item_29516",
    "Last Name": "Galvez",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658563": {
    "id": "item_4205",
    "Last Name": "Melham",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658601": {
    "id": "item_190",
    "Last Name": "Huet",
    "First Name": "Olivier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658605": {
    "id": "item_15328",
    "Last Name": "Moore",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658656": {
    "id": "item_2154",
    "Last Name": "Elliott",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658683": {
    "id": "item_15325",
    "Last Name": "Yeo",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658727": {
    "id": "item_2153",
    "Last Name": "Kolbe",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658825": {
    "id": "item_15324",
    "Last Name": "Saunders",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658933": {
    "id": "item_29514",
    "Last Name": "Cuyugan",
    "First Name": "Benji-antonio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659100": {
    "id": "item_463",
    "Last Name": "Syengo",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659140": {
    "id": "item_27716",
    "Last Name": "Morris",
    "First Name": "Kelli-ann",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659168": {
    "id": "item_2151",
    "Last Name": "Blechl",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659210": {
    "id": "item_223",
    "Last Name": "McGourty",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659230": {
    "id": "item_29513",
    "Last Name": "Pabellon",
    "First Name": "Anna Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659256": {
    "id": "item_2148",
    "Last Name": "Gobl Ni Chasaide",
    "First Name": "Noirin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659474": {
    "id": "item_4201",
    "Last Name": "Lu",
    "First Name": "Rogr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659504": {
    "id": "item_15319",
    "Last Name": "Donaldson",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659515": {
    "id": "item_29667",
    "Last Name": "Marquez",
    "First Name": "Celle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659530": {
    "id": "item_221",
    "Last Name": "Quirk",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659596": {
    "id": "item_4200",
    "Last Name": "Daly",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659690": {
    "id": "item_27729",
    "Last Name": "Czapla",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659726": {
    "id": "item_3877",
    "Last Name": "Parker",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659843": {
    "id": "item_4142",
    "Last Name": "Vega",
    "First Name": "Andres",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659871": {
    "id": "item_15317",
    "Last Name": "Colonna",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659922": {
    "id": "item_15316",
    "Last Name": "Hipgrave",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659933": {
    "id": "item_4198",
    "Last Name": "Murphy",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660031": {
    "id": "item_4197",
    "Last Name": "Darvill",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660081": {
    "id": "item_15255",
    "Last Name": "Quinn",
    "First Name": "Gr‡inne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660096": {
    "id": "item_4195",
    "Last Name": "Marychurch",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660098": {
    "id": "item_12917",
    "Last Name": "Skuodas",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660158": {
    "id": "item_4193",
    "Last Name": "Ferguson",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660172": {
    "id": "item_12829",
    "Last Name": "LI",
    "First Name": "RENKAI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660181": {
    "id": "item_15254",
    "Last Name": "Gibbons",
    "First Name": "Genevieve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660184": {
    "id": "item_29664",
    "Last Name": "Portugal",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660266": {
    "id": "item_29662",
    "Last Name": "Faisal",
    "First Name": "Samira",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660307": {
    "id": "item_2145",
    "Last Name": "Quach",
    "First Name": "Mackenzie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660318": {
    "id": "item_29639",
    "Last Name": "Tyas Sasongko",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660321": {
    "id": "item_188",
    "Last Name": "KAZADI MBAMBA",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660386": {
    "id": "item_4141",
    "Last Name": "Kanhukamwe",
    "First Name": "Munya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660472": {
    "id": "item_15252",
    "Last Name": "Houghton",
    "First Name": "Linnea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660580": {
    "id": "item_15311",
    "Last Name": "Rubinstein",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660586": {
    "id": "item_15312",
    "Last Name": "McMullen",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660605": {
    "id": "item_15250",
    "Last Name": "Dodd",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660611": {
    "id": "item_219",
    "Last Name": "Ince",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660643": {
    "id": "item_33",
    "Last Name": "Fujita",
    "First Name": "Kazuya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660672": {
    "id": "item_4189",
    "Last Name": "Christian",
    "First Name": "Handy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660677": {
    "id": "item_15309",
    "Last Name": "Zheng",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660710": {
    "id": "item_15307",
    "Last Name": "Wang",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660771": {
    "id": "item_4188",
    "Last Name": "Meldrum",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660840": {
    "id": "item_29637",
    "Last Name": "Fu",
    "First Name": "Luca, Yu Feng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660867": {
    "id": "item_29636",
    "Last Name": "Dunk",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660881": {
    "id": "item_31",
    "Last Name": "Basri",
    "First Name": "Yurbianto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660888": {
    "id": "item_2142",
    "Last Name": "van Tongeren",
    "First Name": "Menno",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660931": {
    "id": "item_12915",
    "Last Name": "Patel",
    "First Name": "Shraddhaa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660984": {
    "id": "item_2140",
    "Last Name": "Wong",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661002": {
    "id": "item_4185",
    "Last Name": "Drutman",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661018": {
    "id": "item_15303",
    "Last Name": "Reimers",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661067": {
    "id": "item_15834",
    "Last Name": "Florek",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661105": {
    "id": "item_4183",
    "Last Name": "Chung",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661118": {
    "id": "item_15302",
    "Last Name": "Moran",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661147": {
    "id": "item_14818",
    "Last Name": "Bacabac",
    "First Name": "Kim Marko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661157": {
    "id": "item_4182",
    "Last Name": "Polglase",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661206": {
    "id": "item_29656",
    "Last Name": "OÕNeill",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661234": {
    "id": "item_27593",
    "Last Name": "NGU",
    "First Name": "KING MEE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661364": {
    "id": "item_4180",
    "Last Name": "Andre",
    "First Name": "Yves",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661433": {
    "id": "item_2118",
    "Last Name": "Coutts",
    "First Name": "Casey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661437": {
    "id": "item_15301",
    "Last Name": "Foat",
    "First Name": "Liz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661442": {
    "id": "item_185",
    "Last Name": "Liddle",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661513": {
    "id": "item_15298",
    "Last Name": "Squire",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661538": {
    "id": "item_15296",
    "Last Name": "Liu",
    "First Name": "Ying",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661539": {
    "id": "item_15833",
    "Last Name": "ADAMS",
    "First Name": "PETER",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661636": {
    "id": "item_4177",
    "Last Name": "CHOI",
    "First Name": "STEPHEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661637": {
    "id": "item_27726",
    "Last Name": "HALOI",
    "First Name": "CHANDAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661660": {
    "id": "item_208",
    "Last Name": "Preston",
    "First Name": "Mikal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661661": {
    "id": "item_15831",
    "Last Name": "Beal",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661662": {
    "id": "item_209",
    "Last Name": "Grinham",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661677": {
    "id": "item_4174",
    "Last Name": "Ayliffe",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661689": {
    "id": "item_15293",
    "Last Name": "Leggett",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661695": {
    "id": "item_4172",
    "Last Name": "jin",
    "First Name": "yoojoon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661727": {
    "id": "item_4139",
    "Last Name": "Nicolas",
    "First Name": "Holly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661798": {
    "id": "item_4170",
    "Last Name": "Frykberg",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661837": {
    "id": "item_2133",
    "Last Name": "McLeod",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661869": {
    "id": "item_4169",
    "Last Name": "Dube",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661955": {
    "id": "item_15288",
    "Last Name": "Dawes",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662086": {
    "id": "item_15286",
    "Last Name": "Lamba",
    "First Name": "Ajit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662092": {
    "id": "item_29650",
    "Last Name": "Huang",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662190": {
    "id": "item_15283",
    "Last Name": "Lim",
    "First Name": "Branden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662204": {
    "id": "item_2130",
    "Last Name": "Byrne",
    "First Name": "Helen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662205": {
    "id": "item_15281",
    "Last Name": "Conanan",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662206": {
    "id": "item_29649",
    "Last Name": "Tang",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662286": {
    "id": "item_27713",
    "Last Name": "Im",
    "First Name": "Hwi Yeon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662312": {
    "id": "item_202",
    "Last Name": "Karimali",
    "First Name": "Magda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662321": {
    "id": "item_2128",
    "Last Name": "Liu",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662366": {
    "id": "item_4607",
    "Last Name": "Zhao",
    "First Name": "Agnes",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662457": {
    "id": "item_13024",
    "Last Name": "Girdlestone",
    "First Name": "Cody",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662487": {
    "id": "item_2127",
    "Last Name": "Stockings",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662494": {
    "id": "item_15277",
    "Last Name": "Brownlie",
    "First Name": "Jin Hee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662552": {
    "id": "item_2126",
    "Last Name": "Scahill",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662568": {
    "id": "item_4605",
    "Last Name": "Goodwin",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662625": {
    "id": "item_15275",
    "Last Name": "DU",
    "First Name": "JINGHAI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662642": {
    "id": "item_2116",
    "Last Name": "Davis",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662652": {
    "id": "item_29647",
    "Last Name": "Shan",
    "First Name": "Yuhong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662679": {
    "id": "item_27712",
    "Last Name": "Coffey",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662727": {
    "id": "item_197",
    "Last Name": "Smith",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662741": {
    "id": "item_15272",
    "Last Name": "Hannon",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662787": {
    "id": "item_2123",
    "Last Name": "Halim",
    "First Name": "Gunawan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662840": {
    "id": "item_196",
    "Last Name": "Pearson",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662857": {
    "id": "item_15828",
    "Last Name": "Castley",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662899": {
    "id": "item_15270",
    "Last Name": "Smith",
    "First Name": "Barnaby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663066": {
    "id": "item_29644",
    "Last Name": "zhou",
    "First Name": "Yu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663110": {
    "id": "item_12910",
    "Last Name": "OÕtoole",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663126": {
    "id": "item_4153",
    "Last Name": "Clark",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663163": {
    "id": "item_15268",
    "Last Name": "Calpis",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663173": {
    "id": "item_15267",
    "Last Name": "Darby",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663249": {
    "id": "item_15265",
    "Last Name": "Satra",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663270": {
    "id": "item_4135",
    "Last Name": "Barra",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663273": {
    "id": "item_15827",
    "Last Name": "Larken",
    "First Name": "Zak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663279": {
    "id": "item_15264",
    "Last Name": "Ajaka",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663302": {
    "id": "item_2115",
    "Last Name": "Johnstone",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663336": {
    "id": "item_184",
    "Last Name": "Jang",
    "First Name": "Jeonghee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663350": {
    "id": "item_1943",
    "Last Name": "LUO",
    "First Name": "Jianhua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663366": {
    "id": "item_27718",
    "Last Name": "Weston",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663447": {
    "id": "item_15262",
    "Last Name": "Diaz",
    "First Name": "Rolando",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663493": {
    "id": "item_27717",
    "Last Name": "Ho",
    "First Name": "Melvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663538": {
    "id": "item_15236",
    "Last Name": "Khuu",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663642": {
    "id": "item_14810",
    "Last Name": "Lai",
    "First Name": "Sze Man",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663769": {
    "id": "item_4149",
    "Last Name": "Sun",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663853": {
    "id": "item_12904",
    "Last Name": "Barry",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36664083": {
    "id": "item_15261",
    "Last Name": "Jafri",
    "First Name": "Asad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36664174": {
    "id": "item_14806",
    "Last Name": "KIM",
    "First Name": "DASOM",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36664335": {
    "id": "item_4146",
    "Last Name": "Gonzalez",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36664724": {
    "id": "item_29641",
    "Last Name": "Cabrera",
    "First Name": "Benedict",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36664773": {
    "id": "item_14807",
    "Last Name": "Lukmanto",
    "First Name": "Martinus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36665080": {
    "id": "item_15258",
    "Last Name": "Sae Lao",
    "First Name": "Apinan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36665317": {
    "id": "item_15257",
    "Last Name": "Silberman",
    "First Name": "Avner",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36665420": {
    "id": "item_4144",
    "Last Name": "Wong",
    "First Name": "Fai Cheong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36665859": {
    "id": "item_4143",
    "Last Name": "Hill-Smith",
    "First Name": "Micah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36666799": {
    "id": "item_29508",
    "Last Name": "Wang",
    "First Name": "Luya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36667344": {
    "id": "item_14803",
    "Last Name": "PENG",
    "First Name": "ZHIXIONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36668614": {
    "id": "item_15253",
    "Last Name": "Dutta",
    "First Name": "Ravi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36669216": {
    "id": "item_2120",
    "Last Name": "Daly",
    "First Name": "Pete",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36670033": {
    "id": "item_187",
    "Last Name": "Kearing",
    "First Name": "Madelaine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672000": {
    "id": "item_2119",
    "Last Name": "Broad",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672049": {
    "id": "item_27715",
    "Last Name": "Lam",
    "First Name": "Charles",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672057": {
    "id": "item_4140",
    "Last Name": "Muir",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672806": {
    "id": "item_29631",
    "Last Name": "Frias",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672825": {
    "id": "item_15247",
    "Last Name": "Wilson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672949": {
    "id": "item_2117",
    "Last Name": "McKinley",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36673134": {
    "id": "item_29635",
    "Last Name": "Fang",
    "First Name": "Guiping",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36673279": {
    "id": "item_4138",
    "Last Name": "Murray",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36673439": {
    "id": "item_4603",
    "Last Name": "Deam",
    "First Name": "Siobhan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36673509": {
    "id": "item_15233",
    "Last Name": "Malla",
    "First Name": "Dinesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36673773": {
    "id": "item_15231",
    "Last Name": "O'Neill",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674072": {
    "id": "item_27857",
    "Last Name": "Chen",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674095": {
    "id": "item_15825",
    "Last Name": "Araya-Bishop",
    "First Name": "Josie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674173": {
    "id": "item_1941",
    "Last Name": "Koh",
    "First Name": "Ze Min Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674415": {
    "id": "item_29634",
    "Last Name": "MINIERI",
    "First Name": "CARLO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674456": {
    "id": "item_4137",
    "Last Name": "Wilson",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674507": {
    "id": "item_12907",
    "Last Name": "Faurby",
    "First Name": "Steffen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674670": {
    "id": "item_460",
    "Last Name": "Theunissen",
    "First Name": "Jeandre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674690": {
    "id": "item_27590",
    "Last Name": "Hierso-Hagberg",
    "First Name": "Severine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674712": {
    "id": "item_27591",
    "Last Name": "Werth",
    "First Name": "Glenda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674904": {
    "id": "item_15242",
    "Last Name": "Floresca",
    "First Name": "Francis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675003": {
    "id": "item_15241",
    "Last Name": "Kunii",
    "First Name": "Motoki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675130": {
    "id": "item_27711",
    "Last Name": "Hughes",
    "First Name": "Hazel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675238": {
    "id": "item_14798",
    "Last Name": "Raubenheimer",
    "First Name": "Jacques",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675324": {
    "id": "item_15239",
    "Last Name": "Stearn",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675388": {
    "id": "item_29506",
    "Last Name": "Carter",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675405": {
    "id": "item_4136",
    "Last Name": "Harley",
    "First Name": "Nicholas Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675525": {
    "id": "item_29505",
    "Last Name": "Carter",
    "First Name": "Heather",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675539": {
    "id": "item_12906",
    "Last Name": "Bonneton",
    "First Name": "Olivier",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675676": {
    "id": "item_13023",
    "Last Name": "Mccreary",
    "First Name": "Johno",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675716": {
    "id": "item_4133",
    "Last Name": "Liu",
    "First Name": "Zhifeng Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675938": {
    "id": "item_12905",
    "Last Name": "Russell",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676003": {
    "id": "item_183",
    "Last Name": "Dong",
    "First Name": "Stanley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676009": {
    "id": "item_3865",
    "Last Name": "Lindley",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676022": {
    "id": "item_29633",
    "Last Name": "Wijaya",
    "First Name": "Ratna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676046": {
    "id": "item_29632",
    "Last Name": "Block",
    "First Name": "York",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676077": {
    "id": "item_458",
    "Last Name": "Millar",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676086": {
    "id": "item_27709",
    "Last Name": "De Leon",
    "First Name": "Niko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676185": {
    "id": "item_15234",
    "Last Name": "Wong",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676365": {
    "id": "item_29630",
    "Last Name": "Smith",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676374": {
    "id": "item_2114",
    "Last Name": "Ng",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676575": {
    "id": "item_4130",
    "Last Name": "Jacobs",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676600": {
    "id": "item_15230",
    "Last Name": "Nordien",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676750": {
    "id": "item_15229",
    "Last Name": "Li",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676798": {
    "id": "item_4129",
    "Last Name": "Carroll",
    "First Name": "Kiara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676826": {
    "id": "item_15227",
    "Last Name": "Ng",
    "First Name": "Wing Hong Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676845": {
    "id": "item_2113",
    "Last Name": "Furlan",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676847": {
    "id": "item_4127",
    "Last Name": "Kim",
    "First Name": "Paterson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676883": {
    "id": "item_15226",
    "Last Name": "Shan",
    "First Name": "Yin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676976": {
    "id": "item_457",
    "Last Name": "French",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676987": {
    "id": "item_2112",
    "Last Name": "ZENG",
    "First Name": "YANWEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677064": {
    "id": "item_13022",
    "Last Name": "Griffith",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677077": {
    "id": "item_2110",
    "Last Name": "Suparyo",
    "First Name": "HimawanTriadiguno",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677485": {
    "id": "item_15225",
    "Last Name": "Vaughan",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677508": {
    "id": "item_15224",
    "Last Name": "Bhave",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677550": {
    "id": "item_15223",
    "Last Name": "Bailey",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677645": {
    "id": "item_15220",
    "Last Name": "Pang",
    "First Name": "Francis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677682": {
    "id": "item_29797",
    "Last Name": "Spiers",
    "First Name": "Annika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677735": {
    "id": "item_15219",
    "Last Name": "Lee",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677749": {
    "id": "item_4120",
    "Last Name": "Edwards",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677782": {
    "id": "item_12903",
    "Last Name": "Stevens",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677968": {
    "id": "item_14796",
    "Last Name": "Jing",
    "First Name": "Jing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678025": {
    "id": "item_2109",
    "Last Name": "Richardson",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678084": {
    "id": "item_4119",
    "Last Name": "Velovski",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678132": {
    "id": "item_4118",
    "Last Name": "Ng",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678241": {
    "id": "item_4117",
    "Last Name": "Wilson",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678422": {
    "id": "item_15214",
    "Last Name": "Johnston",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678443": {
    "id": "item_15211",
    "Last Name": "atchison",
    "First Name": "david",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678460": {
    "id": "item_4114",
    "Last Name": "Gore",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678486": {
    "id": "item_175",
    "Last Name": "Duggan",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678654": {
    "id": "item_4600",
    "Last Name": "Tobin",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678699": {
    "id": "item_174",
    "Last Name": "Nicol",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678931": {
    "id": "item_4123",
    "Last Name": "Funnell",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678976": {
    "id": "item_15210",
    "Last Name": "Yu",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679104": {
    "id": "item_12902",
    "Last Name": "Waser",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679118": {
    "id": "item_15208",
    "Last Name": "Jasovsky",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679182": {
    "id": "item_181",
    "Last Name": "Mah",
    "First Name": "Lincoln",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679200": {
    "id": "item_172",
    "Last Name": "Meenapinunt",
    "First Name": "Titayapa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679213": {
    "id": "item_14794",
    "Last Name": "XU",
    "First Name": "CHUAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679331": {
    "id": "item_4113",
    "Last Name": "Choe",
    "First Name": "Jaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679507": {
    "id": "item_15222",
    "Last Name": "Brown",
    "First Name": "Rhyleigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679523": {
    "id": "item_15221",
    "Last Name": "SULLIVAN",
    "First Name": "LIAM",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679851": {
    "id": "item_15205",
    "Last Name": "Yip",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679985": {
    "id": "item_4121",
    "Last Name": "Dinsdale",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680237": {
    "id": "item_15202",
    "Last Name": "Smyth",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680271": {
    "id": "item_29627",
    "Last Name": "Schaefer",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680280": {
    "id": "item_15197",
    "Last Name": "Vorobieff",
    "First Name": "Jacquie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680282": {
    "id": "item_15198",
    "Last Name": "CHOUHAN",
    "First Name": "PARAM",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680283": {
    "id": "item_15200",
    "Last Name": "Corrigan",
    "First Name": "Niall",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680324": {
    "id": "item_4110",
    "Last Name": "Roberts",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680377": {
    "id": "item_29625",
    "Last Name": "Aquilina",
    "First Name": "Raffaela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680518": {
    "id": "item_4109",
    "Last Name": "Kwan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680526": {
    "id": "item_178",
    "Last Name": "Freitas",
    "First Name": "Glauco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680873": {
    "id": "item_15195",
    "Last Name": "Saviane",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681015": {
    "id": "item_12897",
    "Last Name": "Hayhurst",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681461": {
    "id": "item_15193",
    "Last Name": "Michaleris",
    "First Name": "Stefani",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681510": {
    "id": "item_15218",
    "Last Name": "Berjaoui",
    "First Name": "Bilal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681515": {
    "id": "item_168",
    "Last Name": "Martinez Suancha",
    "First Name": "Wilmer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681545": {
    "id": "item_15191",
    "Last Name": "Lim",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681575": {
    "id": "item_15815",
    "Last Name": "Lesh",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681652": {
    "id": "item_15217",
    "Last Name": "Sinclair",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681704": {
    "id": "item_4594",
    "Last Name": "McCrossin",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681859": {
    "id": "item_15190",
    "Last Name": "Araneda",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681864": {
    "id": "item_29795",
    "Last Name": "Keough",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681926": {
    "id": "item_14793",
    "Last Name": "Aragon",
    "First Name": "Mark Frean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681970": {
    "id": "item_2100",
    "Last Name": "Jones",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681995": {
    "id": "item_4108",
    "Last Name": "Deer",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682036": {
    "id": "item_4107",
    "Last Name": "Yin",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682053": {
    "id": "item_29794",
    "Last Name": "Ashcroft",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682342": {
    "id": "item_15216",
    "Last Name": "Finn",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682405": {
    "id": "item_166",
    "Last Name": "Dodds",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682427": {
    "id": "item_2398",
    "Last Name": "Brow",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682465": {
    "id": "item_15188",
    "Last Name": "Salhan",
    "First Name": "Anmol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682548": {
    "id": "item_27700",
    "Last Name": "Collins",
    "First Name": "Glyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682746": {
    "id": "item_177",
    "Last Name": "Hancock",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683164": {
    "id": "item_14790",
    "Last Name": "Ho",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683365": {
    "id": "item_27699",
    "Last Name": "Slade",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683628": {
    "id": "item_4116",
    "Last Name": "PARK",
    "First Name": "JUNGMIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683663": {
    "id": "item_29624",
    "Last Name": "Chien",
    "First Name": "Chieh-En",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683820": {
    "id": "item_15180",
    "Last Name": "Dorostkar",
    "First Name": "Keyvan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683841": {
    "id": "item_15182",
    "Last Name": "Delaat",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36684105": {
    "id": "item_3862",
    "Last Name": "Lau",
    "First Name": "Clement",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36684206": {
    "id": "item_29501",
    "Last Name": "Agdon",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36684341": {
    "id": "item_4096",
    "Last Name": "Lu",
    "First Name": "You",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36684785": {
    "id": "item_456",
    "Last Name": "Hemson",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36685545": {
    "id": "item_4115",
    "Last Name": "Newsome",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36685717": {
    "id": "item_15812",
    "Last Name": "Henderson",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36685753": {
    "id": "item_27707",
    "Last Name": "Stevenson",
    "First Name": "Penny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36685935": {
    "id": "item_2088",
    "Last Name": "Hsieh",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36686062": {
    "id": "item_15212",
    "Last Name": "Day",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36686171": {
    "id": "item_29621",
    "Last Name": "Temp",
    "First Name": "Don",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36686207": {
    "id": "item_15175",
    "Last Name": "Green",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36686588": {
    "id": "item_4094",
    "Last Name": "Kihara",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36686849": {
    "id": "item_29619",
    "Last Name": "Digby",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687036": {
    "id": "item_2086",
    "Last Name": "Navarro de Braga",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687217": {
    "id": "item_29618",
    "Last Name": "Moore",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687219": {
    "id": "item_4093",
    "Last Name": "Wiseman",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687242": {
    "id": "item_27852",
    "Last Name": "Lau",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687437": {
    "id": "item_29629",
    "Last Name": "Suraweera",
    "First Name": "Amila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687440": {
    "id": "item_4092",
    "Last Name": "Li",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687638": {
    "id": "item_27698",
    "Last Name": "Lin",
    "First Name": "Hanyi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687646": {
    "id": "item_14787",
    "Last Name": "jeong",
    "First Name": "jinuk",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687688": {
    "id": "item_29499",
    "Last Name": "Tukapua",
    "First Name": "Matewai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687793": {
    "id": "item_176",
    "Last Name": "Robinson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687974": {
    "id": "item_15170",
    "Last Name": "Taylor",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688003": {
    "id": "item_163",
    "Last Name": "Moore",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688074": {
    "id": "item_454",
    "Last Name": "Waterhouse",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688262": {
    "id": "item_29617",
    "Last Name": "Kho",
    "First Name": "Edwina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688279": {
    "id": "item_2083",
    "Last Name": "Fensham",
    "First Name": "Nikita",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688402": {
    "id": "item_2105",
    "Last Name": "CHEN",
    "First Name": "Yinxin Steve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688683": {
    "id": "item_15163",
    "Last Name": "Bull",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688701": {
    "id": "item_27705",
    "Last Name": "Roten",
    "First Name": "Annie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688818": {
    "id": "item_29614",
    "Last Name": "Sanchez",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688856": {
    "id": "item_15160",
    "Last Name": "Vardakas",
    "First Name": "Anastasios",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688868": {
    "id": "item_27695",
    "Last Name": "Ivers",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688989": {
    "id": "item_4089",
    "Last Name": "Lidbetter",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688990": {
    "id": "item_2079",
    "Last Name": "Mc Hugh-Dolan",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689073": {
    "id": "item_159",
    "Last Name": "zhang",
    "First Name": "bochuan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689089": {
    "id": "item_13021",
    "Last Name": "Tudjman",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689215": {
    "id": "item_29612",
    "Last Name": "Shepherd",
    "First Name": "Corrin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689274": {
    "id": "item_2396",
    "Last Name": "paterson",
    "First Name": "steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689337": {
    "id": "item_4087",
    "Last Name": "Lee",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689401": {
    "id": "item_2076",
    "Last Name": "Pochep",
    "First Name": "Timofei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689432": {
    "id": "item_12894",
    "Last Name": "Callaghan",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689470": {
    "id": "item_2075",
    "Last Name": "Docker",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689589": {
    "id": "item_15156",
    "Last Name": "JI",
    "First Name": "ZHE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689748": {
    "id": "item_4084",
    "Last Name": "Mallon",
    "First Name": "Jacinta",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689777": {
    "id": "item_154",
    "Last Name": "Wu",
    "First Name": "Jyun Jie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689778": {
    "id": "item_157",
    "Last Name": "Pilu",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689807": {
    "id": "item_27692",
    "Last Name": "Ho",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689845": {
    "id": "item_3859",
    "Last Name": "Wongvisit",
    "First Name": "Pijak",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36690908": {
    "id": "item_15807",
    "Last Name": "Couper",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691018": {
    "id": "item_4083",
    "Last Name": "Griffiths",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691125": {
    "id": "item_15152",
    "Last Name": "Macleod",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691147": {
    "id": "item_2395",
    "Last Name": "Murphy",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691170": {
    "id": "item_2393",
    "Last Name": "Bergmeier",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691178": {
    "id": "item_15151",
    "Last Name": "Lynch",
    "First Name": "Sabine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691206": {
    "id": "item_27688",
    "Last Name": "Rajanala",
    "First Name": "Satya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691276": {
    "id": "item_15149",
    "Last Name": "Shum",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691360": {
    "id": "item_12892",
    "Last Name": "Barbov",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691424": {
    "id": "item_15146",
    "Last Name": "Ruane",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691437": {
    "id": "item_15145",
    "Last Name": "Comerford",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691463": {
    "id": "item_27687",
    "Last Name": "Comerford",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691466": {
    "id": "item_151",
    "Last Name": "Chen",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691497": {
    "id": "item_1937",
    "Last Name": "White",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691521": {
    "id": "item_4080",
    "Last Name": "Korr",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691563": {
    "id": "item_15144",
    "Last Name": "Wei",
    "First Name": "Brenda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691614": {
    "id": "item_14784",
    "Last Name": "Gahan",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691616": {
    "id": "item_14785",
    "Last Name": "Gahan",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691624": {
    "id": "item_15143",
    "Last Name": "Wade",
    "First Name": "Logan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691633": {
    "id": "item_1936",
    "Last Name": "Chang",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691649": {
    "id": "item_15140",
    "Last Name": "chen",
    "First Name": "yuhao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691679": {
    "id": "item_2392",
    "Last Name": "Watson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691684": {
    "id": "item_14782",
    "Last Name": "Woets",
    "First Name": "Sabine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691783": {
    "id": "item_14781",
    "Last Name": "Woets",
    "First Name": "Christophe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691802": {
    "id": "item_2103",
    "Last Name": "Gibson",
    "First Name": "Rowan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691880": {
    "id": "item_29607",
    "Last Name": "Imhoff",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691906": {
    "id": "item_27685",
    "Last Name": "Chen",
    "First Name": "Xiuqing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691943": {
    "id": "item_2067",
    "Last Name": "Wheals",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691944": {
    "id": "item_21",
    "Last Name": "KOSHIDA",
    "First Name": "SATOSHI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691994": {
    "id": "item_4077",
    "Last Name": "Herington",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692007": {
    "id": "item_4076",
    "Last Name": "ZHENG",
    "First Name": "HAOYANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692103": {
    "id": "item_27683",
    "Last Name": "Li",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692121": {
    "id": "item_15132",
    "Last Name": "Gan",
    "First Name": "chengyuan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692141": {
    "id": "item_15134",
    "Last Name": "Khonasti",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692244": {
    "id": "item_4074",
    "Last Name": "Cohen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692273": {
    "id": "item_15130",
    "Last Name": "Levine",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692365": {
    "id": "item_4072",
    "Last Name": "Trang",
    "First Name": "Evan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692366": {
    "id": "item_15128",
    "Last Name": "Nesterov",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36694472": {
    "id": "item_4112",
    "Last Name": "Larkin",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36694817": {
    "id": "item_15123",
    "Last Name": "THIRIET",
    "First Name": "STEPHANE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36694894": {
    "id": "item_27850",
    "Last Name": "Byrne",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36695788": {
    "id": "item_15120",
    "Last Name": "Chandra",
    "First Name": "Aniv",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36696715": {
    "id": "item_15119",
    "Last Name": "Sohn",
    "First Name": "Junghwi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36698923": {
    "id": "item_4068",
    "Last Name": "Openiano",
    "First Name": "Rollie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36699029": {
    "id": "item_15117",
    "Last Name": "Restrepo",
    "First Name": "Monica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36699663": {
    "id": "item_29497",
    "Last Name": "Javellana",
    "First Name": "Lilyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36700317": {
    "id": "item_1935",
    "Last Name": "Holmes",
    "First Name": "Carol",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36703233": {
    "id": "item_4065",
    "Last Name": "Watters",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36705397": {
    "id": "item_13019",
    "Last Name": "Riley",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36705727": {
    "id": "item_4111",
    "Last Name": "Dame",
    "First Name": "Megan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36705932": {
    "id": "item_12888",
    "Last Name": "Jomkamsing",
    "First Name": "Mayumi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36706606": {
    "id": "item_29603",
    "Last Name": "Chen",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36711219": {
    "id": "item_14774",
    "Last Name": "Fakhoury",
    "First Name": "Ammar Hassan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36711316": {
    "id": "item_1934",
    "Last Name": "Soh",
    "First Name": "Wei Chien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36711785": {
    "id": "item_15114",
    "Last Name": "Bond",
    "First Name": "Holly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36711792": {
    "id": "item_1933",
    "Last Name": "Chen",
    "First Name": "Cong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713105": {
    "id": "item_15111",
    "Last Name": "Kosman",
    "First Name": "Jedd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713337": {
    "id": "item_15802",
    "Last Name": "Smith",
    "First Name": "Dorian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713365": {
    "id": "item_12900",
    "Last Name": "Marcellus",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713395": {
    "id": "item_12899",
    "Last Name": "Corbett",
    "First Name": "Kaitlyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713551": {
    "id": "item_15801",
    "Last Name": "Johnson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713554": {
    "id": "item_4058",
    "Last Name": "Ullal",
    "First Name": "Nikhil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713707": {
    "id": "item_4057",
    "Last Name": "Storey",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713867": {
    "id": "item_27849",
    "Last Name": "Orr",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714025": {
    "id": "item_29494",
    "Last Name": "ELAINE ANN",
    "First Name": "KENNING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714039": {
    "id": "item_4590",
    "Last Name": "Calavassy",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714214": {
    "id": "item_142",
    "Last Name": "Johnston",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714314": {
    "id": "item_27584",
    "Last Name": "Shircel",
    "First Name": "Maria Ethel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714398": {
    "id": "item_15203",
    "Last Name": "Puarr",
    "First Name": "Harmeen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714428": {
    "id": "item_141",
    "Last Name": "OÕConnor",
    "First Name": "kieran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714674": {
    "id": "item_2059",
    "Last Name": "Doyle",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714825": {
    "id": "item_27583",
    "Last Name": "Clausell",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714934": {
    "id": "item_140",
    "Last Name": "Gordon",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715033": {
    "id": "item_4052",
    "Last Name": "Aston",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715035": {
    "id": "item_15106",
    "Last Name": "DO",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715039": {
    "id": "item_4053",
    "Last Name": "Heinke",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715164": {
    "id": "item_27848",
    "Last Name": "Strudwick",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715228": {
    "id": "item_15105",
    "Last Name": "Donovan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715389": {
    "id": "item_4050",
    "Last Name": "Carmody",
    "First Name": "Lyndal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715453": {
    "id": "item_4047",
    "Last Name": "Whild",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715483": {
    "id": "item_4048",
    "Last Name": "Ha",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715553": {
    "id": "item_15196",
    "Last Name": "Girle",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715583": {
    "id": "item_1931",
    "Last Name": "Wierdak",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715768": {
    "id": "item_29626",
    "Last Name": "Wong",
    "First Name": "Anita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715844": {
    "id": "item_29597",
    "Last Name": "TIAN",
    "First Name": "YUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715914": {
    "id": "item_29596",
    "Last Name": "Arago",
    "First Name": "Emann-Ray",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716165": {
    "id": "item_27582",
    "Last Name": "ASHIZAWA",
    "First Name": "YUMI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716255": {
    "id": "item_15099",
    "Last Name": "Ma",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716403": {
    "id": "item_2053",
    "Last Name": "Tinnock",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716511": {
    "id": "item_4589",
    "Last Name": "Fogarty",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716525": {
    "id": "item_29593",
    "Last Name": "Blakey Wadsworth",
    "First Name": "Rory",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716526": {
    "id": "item_29594",
    "Last Name": "Blakey Wadsworth",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716687": {
    "id": "item_15097",
    "Last Name": "Blum",
    "First Name": "Yoni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716787": {
    "id": "item_15095",
    "Last Name": "Wholohan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716829": {
    "id": "item_15094",
    "Last Name": "Sigmond",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716849": {
    "id": "item_15092",
    "Last Name": "NG",
    "First Name": "KANG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716955": {
    "id": "item_4043",
    "Last Name": "Mehta",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717000": {
    "id": "item_29791",
    "Last Name": "Moroney",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717183": {
    "id": "item_15089",
    "Last Name": "CORPUS",
    "First Name": "JORDAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717284": {
    "id": "item_4041",
    "Last Name": "Denkrairak",
    "First Name": "Maitri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717290": {
    "id": "item_15088",
    "Last Name": "Lim",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717467": {
    "id": "item_12898",
    "Last Name": "Jennings",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717472": {
    "id": "item_12884",
    "Last Name": "Lightfoot",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717518": {
    "id": "item_27673",
    "Last Name": "Warmeant",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717575": {
    "id": "item_29592",
    "Last Name": "Batongbacal",
    "First Name": "Carlo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717677": {
    "id": "item_4040",
    "Last Name": "Aardenburg",
    "First Name": "Elly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717707": {
    "id": "item_15085",
    "Last Name": "Gray",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717745": {
    "id": "item_2048",
    "Last Name": "Sufferini",
    "First Name": "Luca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717768": {
    "id": "item_15084",
    "Last Name": "Karris",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717797": {
    "id": "item_3849",
    "Last Name": "Loke",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717815": {
    "id": "item_4038",
    "Last Name": "Werakso",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718112": {
    "id": "item_4037",
    "Last Name": "Hunt",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718146": {
    "id": "item_27670",
    "Last Name": "Suministrado",
    "First Name": "Noelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718217": {
    "id": "item_4036",
    "Last Name": "King",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718635": {
    "id": "item_4587",
    "Last Name": "McAndrew",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718660": {
    "id": "item_169",
    "Last Name": "Roney",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718712": {
    "id": "item_4034",
    "Last Name": "Huang",
    "First Name": "Junjie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718889": {
    "id": "item_12896",
    "Last Name": "Souness",
    "First Name": "Sydney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718903": {
    "id": "item_15797",
    "Last Name": "cooney",
    "First Name": "brandon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718914": {
    "id": "item_2101",
    "Last Name": "Noll",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718969": {
    "id": "item_15077",
    "Last Name": "OÕShea",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718985": {
    "id": "item_29587",
    "Last Name": "Czarnota",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719012": {
    "id": "item_12881",
    "Last Name": "Stockton",
    "First Name": "Aimee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719027": {
    "id": "item_2099",
    "Last Name": "Clothier",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719250": {
    "id": "item_16",
    "Last Name": "Nguyen",
    "First Name": "Vuong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719388": {
    "id": "item_15076",
    "Last Name": "Lister",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719556": {
    "id": "item_167",
    "Last Name": "Thompson",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719557": {
    "id": "item_15075",
    "Last Name": "Lister",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719741": {
    "id": "item_132",
    "Last Name": "Sinibaldi",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719902": {
    "id": "item_15072",
    "Last Name": "Decaria",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719955": {
    "id": "item_12880",
    "Last Name": "Yi",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720248": {
    "id": "item_14770",
    "Last Name": "Evans",
    "First Name": "Patrizia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720251": {
    "id": "item_4030",
    "Last Name": "Williamson",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720268": {
    "id": "item_14769",
    "Last Name": "Almenario",
    "First Name": "Hannah Haile",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720416": {
    "id": "item_2098",
    "Last Name": "Zainol Abidin",
    "First Name": "Muhammad Isyraq",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720562": {
    "id": "item_2042",
    "Last Name": "Kirk",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720946": {
    "id": "item_128",
    "Last Name": "Tisaj",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720964": {
    "id": "item_2041",
    "Last Name": "Wall",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721074": {
    "id": "item_4029",
    "Last Name": "Yi",
    "First Name": "Dong Yub Macollin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721090": {
    "id": "item_15189",
    "Last Name": "Omo",
    "First Name": "Mary Jane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721100": {
    "id": "item_4028",
    "Last Name": "Le",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721104": {
    "id": "item_4025",
    "Last Name": "Winsbury",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721157": {
    "id": "item_15065",
    "Last Name": "Florio",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721272": {
    "id": "item_15064",
    "Last Name": "O'brien",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721291": {
    "id": "item_12878",
    "Last Name": "Maher",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721304": {
    "id": "item_15062",
    "Last Name": "Ciungan",
    "First Name": "Mircea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721362": {
    "id": "item_2039",
    "Last Name": "Hiramatsu",
    "First Name": "Yuta",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721404": {
    "id": "item_2037",
    "Last Name": "Shang",
    "First Name": "Terry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721476": {
    "id": "item_27846",
    "Last Name": "Watts",
    "First Name": "Bec",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721666": {
    "id": "item_29586",
    "Last Name": "Pang",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721885": {
    "id": "item_12877",
    "Last Name": "Gonzalez",
    "First Name": "Miranda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722005": {
    "id": "item_12876",
    "Last Name": "Mazeika",
    "First Name": "Gytis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722154": {
    "id": "item_15057",
    "Last Name": "Chin",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722244": {
    "id": "item_12824",
    "Last Name": "Nguyen",
    "First Name": "Vo Minh Tuan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722289": {
    "id": "item_15053",
    "Last Name": "McLoughlin",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722323": {
    "id": "item_29491",
    "Last Name": "Lee",
    "First Name": "Chung Wah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722395": {
    "id": "item_2032",
    "Last Name": "Luu",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722494": {
    "id": "item_4020",
    "Last Name": "Ryu",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722506": {
    "id": "item_2031",
    "Last Name": "Oram",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722870": {
    "id": "item_15048",
    "Last Name": "Kim",
    "First Name": "Noel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723047": {
    "id": "item_4017",
    "Last Name": "Cavill",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723087": {
    "id": "item_15044",
    "Last Name": "Taylor",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723188": {
    "id": "item_4584",
    "Last Name": "Beben",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723251": {
    "id": "item_4105",
    "Last Name": "Li",
    "First Name": "Ao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723268": {
    "id": "item_15795",
    "Last Name": "Harvey",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723286": {
    "id": "item_15042",
    "Last Name": "Goode",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723372": {
    "id": "item_2095",
    "Last Name": "Wang",
    "First Name": "Yihao(Tom)",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723389": {
    "id": "item_4016",
    "Last Name": "Henning",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723474": {
    "id": "item_14768",
    "Last Name": "Lee",
    "First Name": "Joyce",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723510": {
    "id": "item_4583",
    "Last Name": "Richardson",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723522": {
    "id": "item_15794",
    "Last Name": "Christall",
    "First Name": "Lianne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723527": {
    "id": "item_2027",
    "Last Name": "Downey",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723538": {
    "id": "item_2026",
    "Last Name": "Awad",
    "First Name": "Mahmoud",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723635": {
    "id": "item_12822",
    "Last Name": "Scott",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723683": {
    "id": "item_29581",
    "Last Name": "Yadav",
    "First Name": "Manish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723724": {
    "id": "item_4015",
    "Last Name": "Brennan",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723943": {
    "id": "item_4104",
    "Last Name": "Aripin",
    "First Name": "Ammarr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723978": {
    "id": "item_4014",
    "Last Name": "Clemmett",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724029": {
    "id": "item_2025",
    "Last Name": "Lee",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724128": {
    "id": "item_12873",
    "Last Name": "Grimaldi",
    "First Name": "Gina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724194": {
    "id": "item_15033",
    "Last Name": "Lesmana",
    "First Name": "Carl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724302": {
    "id": "item_15031",
    "Last Name": "Dave",
    "First Name": "Keval",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724324": {
    "id": "item_2024",
    "Last Name": "Kalos",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724360": {
    "id": "item_116",
    "Last Name": "Nong",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724387": {
    "id": "item_4010",
    "Last Name": "Herbertson",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724443": {
    "id": "item_4103",
    "Last Name": "Wong",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724567": {
    "id": "item_2093",
    "Last Name": "Mathews",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724650": {
    "id": "item_29578",
    "Last Name": "Hoare",
    "First Name": "Juanita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724868": {
    "id": "item_4006",
    "Last Name": "Su",
    "First Name": "XiaoShan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725001": {
    "id": "item_15186",
    "Last Name": "Proye",
    "First Name": "Axelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725016": {
    "id": "item_4004",
    "Last Name": "Lafferty",
    "First Name": "Lise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725065": {
    "id": "item_15791",
    "Last Name": "Cox",
    "First Name": "Jem",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725126": {
    "id": "item_4003",
    "Last Name": "Garratt",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725127": {
    "id": "item_4002",
    "Last Name": "Reilly",
    "First Name": "Fra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725197": {
    "id": "item_3999",
    "Last Name": "Ribeiro",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725222": {
    "id": "item_3998",
    "Last Name": "Park",
    "First Name": "Eunsu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725248": {
    "id": "item_15024",
    "Last Name": "McKee",
    "First Name": "Blaise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725266": {
    "id": "item_2022",
    "Last Name": "Vendrasco",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725270": {
    "id": "item_3997",
    "Last Name": "Binnington",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725286": {
    "id": "item_2384",
    "Last Name": "Lancey",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725288": {
    "id": "item_15023",
    "Last Name": "Abela",
    "First Name": "Zahra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725311": {
    "id": "item_112",
    "Last Name": "Paterson",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725380": {
    "id": "item_15021",
    "Last Name": "Mamytov",
    "First Name": "Ulan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725446": {
    "id": "item_3995",
    "Last Name": "Brooks",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725456": {
    "id": "item_2091",
    "Last Name": "lee",
    "First Name": "mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725512": {
    "id": "item_2018",
    "Last Name": "Ardiles",
    "First Name": "Doni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725518": {
    "id": "item_3994",
    "Last Name": "Huang",
    "First Name": "Qiang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725527": {
    "id": "item_29575",
    "Last Name": "Vali-Khojeini",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725557": {
    "id": "item_4101",
    "Last Name": "Ferguson",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725728": {
    "id": "item_15016",
    "Last Name": "McGrath",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725785": {
    "id": "item_2016",
    "Last Name": "Fan",
    "First Name": "Shao Yue",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725797": {
    "id": "item_110",
    "Last Name": "Blackwell",
    "First Name": "Tym",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725822": {
    "id": "item_15013",
    "Last Name": "Chilov",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725823": {
    "id": "item_15015",
    "Last Name": "Cawthorne",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725873": {
    "id": "item_2012",
    "Last Name": "Graham",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725917": {
    "id": "item_3991",
    "Last Name": "Wang",
    "First Name": "Bayee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725940": {
    "id": "item_15184",
    "Last Name": "Foot",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725947": {
    "id": "item_4098",
    "Last Name": "Daniels",
    "First Name": "Sahra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726019": {
    "id": "item_15183",
    "Last Name": "O'Sullivan",
    "First Name": "Roslyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726026": {
    "id": "item_2090",
    "Last Name": "Laramy",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726094": {
    "id": "item_3988",
    "Last Name": "Fletcher",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726144": {
    "id": "item_3987",
    "Last Name": "Delis",
    "First Name": "Rosario",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726148": {
    "id": "item_27652",
    "Last Name": "Coyle",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726162": {
    "id": "item_3986",
    "Last Name": "Robinson",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726164": {
    "id": "item_3984",
    "Last Name": "Kelly",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726169": {
    "id": "item_15789",
    "Last Name": "Frost",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726178": {
    "id": "item_15003",
    "Last Name": "Bayliss",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726219": {
    "id": "item_3982",
    "Last Name": "Jones",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726231": {
    "id": "item_2089",
    "Last Name": "liu",
    "First Name": "junhong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726249": {
    "id": "item_14999",
    "Last Name": "Baryla",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726260": {
    "id": "item_15179",
    "Last Name": "Sette",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726306": {
    "id": "item_105",
    "Last Name": "Wu",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726329": {
    "id": "item_4095",
    "Last Name": "McGenniskem",
    "First Name": "Quinn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726343": {
    "id": "item_15177",
    "Last Name": "Finn",
    "First Name": "Tyson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726419": {
    "id": "item_29570",
    "Last Name": "Courtney",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726475": {
    "id": "item_27649",
    "Last Name": "Zhang",
    "First Name": "Bo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726512": {
    "id": "item_102",
    "Last Name": "Lai",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726541": {
    "id": "item_27648",
    "Last Name": "Galloway",
    "First Name": "Louisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726561": {
    "id": "item_446",
    "Last Name": "Abrahamse",
    "First Name": "Nathaniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726572": {
    "id": "item_14991",
    "Last Name": "Braun",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726601": {
    "id": "item_3977",
    "Last Name": "Egan",
    "First Name": "Eamonn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726617": {
    "id": "item_98",
    "Last Name": "Ferrara",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726667": {
    "id": "item_2007",
    "Last Name": "Jones",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726669": {
    "id": "item_99",
    "Last Name": "Wahedally",
    "First Name": "Zubair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726672": {
    "id": "item_3976",
    "Last Name": "Tan",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726677": {
    "id": "item_12863",
    "Last Name": "Wheeler",
    "First Name": "Zak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726682": {
    "id": "item_14988",
    "Last Name": "Losco",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726688": {
    "id": "item_15176",
    "Last Name": "O'Grady",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726727": {
    "id": "item_14986",
    "Last Name": "Somani",
    "First Name": "Charbel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726789": {
    "id": "item_3974",
    "Last Name": "Hioki",
    "First Name": "Takanori",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726800": {
    "id": "item_14983",
    "Last Name": "Stephen",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726866": {
    "id": "item_14980",
    "Last Name": "Tang",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726877": {
    "id": "item_14981",
    "Last Name": "Doyle",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726910": {
    "id": "item_14978",
    "Last Name": "Trieu",
    "First Name": "Anderson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726926": {
    "id": "item_13015",
    "Last Name": "Chapman",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726934": {
    "id": "item_15173",
    "Last Name": "Weinert",
    "First Name": "Bella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726935": {
    "id": "item_14977",
    "Last Name": "Domanski",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726949": {
    "id": "item_12860",
    "Last Name": "Moore",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726953": {
    "id": "item_14975",
    "Last Name": "Lee",
    "First Name": "Albert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726963": {
    "id": "item_3971",
    "Last Name": "Balagtas",
    "First Name": "Nico",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726987": {
    "id": "item_13014",
    "Last Name": "Paleologos",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726989": {
    "id": "item_29569",
    "Last Name": "Chin",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727024": {
    "id": "item_29567",
    "Last Name": "Agarwal",
    "First Name": "Tanish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727026": {
    "id": "item_14974",
    "Last Name": "Atkins",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727051": {
    "id": "item_14973",
    "Last Name": "Millhouse",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727061": {
    "id": "item_14971",
    "Last Name": "Katz",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727063": {
    "id": "item_13013",
    "Last Name": "Collins",
    "First Name": "Rene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727071": {
    "id": "item_14969",
    "Last Name": "Heapy",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727072": {
    "id": "item_27638",
    "Last Name": "Wijaya",
    "First Name": "Angelia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727073": {
    "id": "item_4578",
    "Last Name": "Robinson",
    "First Name": "Keelan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727074": {
    "id": "item_3970",
    "Last Name": "Fernandes",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727109": {
    "id": "item_94",
    "Last Name": "Technitis",
    "First Name": "Adeline",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727119": {
    "id": "item_2001",
    "Last Name": "Richards",
    "First Name": "Donna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727151": {
    "id": "item_92",
    "Last Name": "Bae",
    "First Name": "Jihwan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727177": {
    "id": "item_27637",
    "Last Name": "Bowers",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727201": {
    "id": "item_2000",
    "Last Name": "O Mahony",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727229": {
    "id": "item_14966",
    "Last Name": "Hallinan",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727247": {
    "id": "item_2380",
    "Last Name": "Michie",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727258": {
    "id": "item_3962",
    "Last Name": "Chan",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727284": {
    "id": "item_12856",
    "Last Name": "Hammett",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727336": {
    "id": "item_14962",
    "Last Name": "Yang",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727344": {
    "id": "item_14766",
    "Last Name": "Liu",
    "First Name": "Yen-ling",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727368": {
    "id": "item_1999",
    "Last Name": "Yeo",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727385": {
    "id": "item_88",
    "Last Name": "Puse",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727417": {
    "id": "item_14959",
    "Last Name": "Keevers",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727545": {
    "id": "item_15169",
    "Last Name": "Adams",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727547": {
    "id": "item_14956",
    "Last Name": "VELASCO",
    "First Name": "IREEN JUDE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727617": {
    "id": "item_15168",
    "Last Name": "McShane",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727688": {
    "id": "item_15167",
    "Last Name": "Ko",
    "First Name": "Alan Ka Hou",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727700": {
    "id": "item_14765",
    "Last Name": "Julyasari",
    "First Name": "Julyasari",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727754": {
    "id": "item_14952",
    "Last Name": "Mealing",
    "First Name": "Laurence",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727808": {
    "id": "item_27634",
    "Last Name": "Lindsay",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727844": {
    "id": "item_14949",
    "Last Name": "Oong",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727869": {
    "id": "item_29559",
    "Last Name": "Tarbox",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727963": {
    "id": "item_2084",
    "Last Name": "Brannigan",
    "First Name": "Una",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728089": {
    "id": "item_29558",
    "Last Name": "Hall",
    "First Name": "Gail",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728110": {
    "id": "item_83",
    "Last Name": "Edwards",
    "First Name": "Devlin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728128": {
    "id": "item_29556",
    "Last Name": "Speedy",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728257": {
    "id": "item_29552",
    "Last Name": "Sauler",
    "First Name": "Jat Lucas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728278": {
    "id": "item_29551",
    "Last Name": "Chen",
    "First Name": "Peng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728290": {
    "id": "item_29555",
    "Last Name": "Gopperth",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728378": {
    "id": "item_29553",
    "Last Name": "Gatenby",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728437": {
    "id": "item_29788",
    "Last Name": "Wu",
    "First Name": "Jiarong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728456": {
    "id": "item_3957",
    "Last Name": "McMichael",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728540": {
    "id": "item_3956",
    "Last Name": "Hochuli",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728611": {
    "id": "item_27697",
    "Last Name": "Jimenez",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728973": {
    "id": "item_29550",
    "Last Name": "Siddabasappa",
    "First Name": "Praveen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729105": {
    "id": "item_3954",
    "Last Name": "FLEMING",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729152": {
    "id": "item_2082",
    "Last Name": "Kaczmarek",
    "First Name": "Bjoern",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729160": {
    "id": "item_27577",
    "Last Name": "Cheong",
    "First Name": "May Yee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729181": {
    "id": "item_160",
    "Last Name": "Como",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729208": {
    "id": "item_2081",
    "Last Name": "Tulley",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729412": {
    "id": "item_1994",
    "Last Name": "Wongpanyathaworn",
    "First Name": "Kamolwatchara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729451": {
    "id": "item_15162",
    "Last Name": "Park",
    "First Name": "Namju",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729462": {
    "id": "item_29548",
    "Last Name": "Belleza",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729622": {
    "id": "item_14945",
    "Last Name": "Herijanto",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729956": {
    "id": "item_3951",
    "Last Name": "Pham",
    "First Name": "Duc Minh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729984": {
    "id": "item_14943",
    "Last Name": "Nguyen",
    "First Name": "Cuong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36730393": {
    "id": "item_3950",
    "Last Name": "Carson",
    "First Name": "Bonar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36730413": {
    "id": "item_3949",
    "Last Name": "Cook",
    "First Name": "Alec",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36730584": {
    "id": "item_29488",
    "Last Name": "Abdilah",
    "First Name": "Gani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36730870": {
    "id": "item_29616",
    "Last Name": "Corlett",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731012": {
    "id": "item_14940",
    "Last Name": "Liu",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731140": {
    "id": "item_443",
    "Last Name": "Neville",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731288": {
    "id": "item_27624",
    "Last Name": "Humayun",
    "First Name": "Md Nazrul Islam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731421": {
    "id": "item_14760",
    "Last Name": "Bin Rozi",
    "First Name": "Abdul Aziz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731573": {
    "id": "item_14936",
    "Last Name": "Weng",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731775": {
    "id": "item_15161",
    "Last Name": "Cummings",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36732109": {
    "id": "item_14935",
    "Last Name": "Wong",
    "First Name": "Phoebe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36733040": {
    "id": "item_2080",
    "Last Name": "Agcaoili",
    "First Name": "Reymart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36733149": {
    "id": "item_3839",
    "Last Name": "BANCORO",
    "First Name": "ADRIAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36733267": {
    "id": "item_14758",
    "Last Name": "CHANG",
    "First Name": "YA LI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36733563": {
    "id": "item_1987",
    "Last Name": "Hammonds",
    "First Name": "Sydney",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36734152": {
    "id": "item_14755",
    "Last Name": "Huang",
    "First Name": "Chia Li",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36734274": {
    "id": "item_14753",
    "Last Name": "CHEN",
    "First Name": "FANGSHENG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36736096": {
    "id": "item_1984",
    "Last Name": "O Mainseal",
    "First Name": "Micheal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36736133": {
    "id": "item_27575",
    "Last Name": "Vipinosa",
    "First Name": "Jeano James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36740624": {
    "id": "item_1928",
    "Last Name": "Winoto",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36740917": {
    "id": "item_14749",
    "Last Name": "Cole",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36741592": {
    "id": "item_14930",
    "Last Name": "Jiang",
    "First Name": "Zhezhou",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36743106": {
    "id": "item_29547",
    "Last Name": "CHAN",
    "First Name": "TIMOTHY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36746066": {
    "id": "item_3944",
    "Last Name": "HELIN",
    "First Name": "Yoann",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36746606": {
    "id": "item_29613",
    "Last Name": "Giddings",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36748324": {
    "id": "item_14929",
    "Last Name": "Solomon",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36749251": {
    "id": "item_14926",
    "Last Name": "Wrigley",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36749284": {
    "id": "item_27573",
    "Last Name": "Harris",
    "First Name": "Nichola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36750214": {
    "id": "item_27694",
    "Last Name": "Wickremasinghe",
    "First Name": "Lilith",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36750325": {
    "id": "item_14925",
    "Last Name": "Liu",
    "First Name": "Jing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36750451": {
    "id": "item_29787",
    "Last Name": "Cornelius",
    "First Name": "Nyree",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36750826": {
    "id": "item_12848",
    "Last Name": "Fryer",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36750905": {
    "id": "item_442",
    "Last Name": "Hoult",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36751703": {
    "id": "item_2078",
    "Last Name": "Hilsdon",
    "First Name": "Ed",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36751979": {
    "id": "item_2378",
    "Last Name": "Donald",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752179": {
    "id": "item_77",
    "Last Name": "Ledbrook",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752543": {
    "id": "item_14921",
    "Last Name": "Maynoor",
    "First Name": "Taraswin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752832": {
    "id": "item_15158",
    "Last Name": "OÕDonnell",
    "First Name": "Nellie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752946": {
    "id": "item_14920",
    "Last Name": "Matthews",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752960": {
    "id": "item_29544",
    "Last Name": "Morris",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753020": {
    "id": "item_1982",
    "Last Name": "Penrose",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753029": {
    "id": "item_3940",
    "Last Name": "Sergeev",
    "First Name": "Pavlo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753060": {
    "id": "item_14919",
    "Last Name": "Bennie",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753144": {
    "id": "item_29542",
    "Last Name": "Linnegar",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753490": {
    "id": "item_76",
    "Last Name": "Judges",
    "First Name": "Laurence",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753603": {
    "id": "item_75",
    "Last Name": "Wood",
    "First Name": "Rowan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753639": {
    "id": "item_74",
    "Last Name": "Hyndman",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753646": {
    "id": "item_14916",
    "Last Name": "Yu",
    "First Name": "Miao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753750": {
    "id": "item_3937",
    "Last Name": "Warren",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754056": {
    "id": "item_14912",
    "Last Name": "Ruiz",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754098": {
    "id": "item_14914",
    "Last Name": "Cashmsn",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754165": {
    "id": "item_14911",
    "Last Name": "Medlicott",
    "First Name": "Elana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754451": {
    "id": "item_15157",
    "Last Name": "Scott",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754557": {
    "id": "item_3935",
    "Last Name": "Comafay",
    "First Name": "Nichol",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754567": {
    "id": "item_1976",
    "Last Name": "Mason",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755013": {
    "id": "item_3934",
    "Last Name": "Arnold",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755062": {
    "id": "item_3932",
    "Last Name": "Brooks",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755086": {
    "id": "item_14905",
    "Last Name": "Lie",
    "First Name": "Benaya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755451": {
    "id": "item_3931",
    "Last Name": "Armstrong",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755531": {
    "id": "item_1975",
    "Last Name": "Langhein",
    "First Name": "Jenna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755695": {
    "id": "item_3930",
    "Last Name": "Smith",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755766": {
    "id": "item_3836",
    "Last Name": "ARTIGAL JULIEN",
    "First Name": "SERGI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755787": {
    "id": "item_1974",
    "Last Name": "Swinfield",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755882": {
    "id": "item_3928",
    "Last Name": "Phillips",
    "First Name": "Darragh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755967": {
    "id": "item_27571",
    "Last Name": "Bremsteller",
    "First Name": "Frederik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756085": {
    "id": "item_1972",
    "Last Name": "Burn",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756149": {
    "id": "item_14902",
    "Last Name": "WOODBURN",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756361": {
    "id": "item_29536",
    "Last Name": "MacDonald",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756608": {
    "id": "item_1970",
    "Last Name": "Hinton",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756863": {
    "id": "item_14899",
    "Last Name": "Bemet",
    "First Name": "Nelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756895": {
    "id": "item_68",
    "Last Name": "Kaye",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756936": {
    "id": "item_15154",
    "Last Name": "Seton",
    "First Name": "Cody",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757148": {
    "id": "item_14898",
    "Last Name": "Chen",
    "First Name": "Ziliang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757252": {
    "id": "item_3922",
    "Last Name": "Allan",
    "First Name": "Corey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757300": {
    "id": "item_29533",
    "Last Name": "Lor",
    "First Name": "Hong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757307": {
    "id": "item_3921",
    "Last Name": "Mailey",
    "First Name": "Lachie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757337": {
    "id": "item_156",
    "Last Name": "Channell",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757641": {
    "id": "item_440",
    "Last Name": "Le Breton",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757672": {
    "id": "item_3919",
    "Last Name": "Jones",
    "First Name": "Clare",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757729": {
    "id": "item_29610",
    "Last Name": "Hookway",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757812": {
    "id": "item_65",
    "Last Name": "Vaneris",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758379": {
    "id": "item_14889",
    "Last Name": "Brown",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758419": {
    "id": "item_27689",
    "Last Name": "Martins",
    "First Name": "Leonardo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758457": {
    "id": "item_27609",
    "Last Name": "Pavely",
    "First Name": "Trish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758888": {
    "id": "item_29531",
    "Last Name": "Pang",
    "First Name": "Sabrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758937": {
    "id": "item_14887",
    "Last Name": "Nark-iam",
    "First Name": "Nattapon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759054": {
    "id": "item_15779",
    "Last Name": "Gameiro",
    "First Name": "Justine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759099": {
    "id": "item_14744",
    "Last Name": "Kennedy",
    "First Name": "Zac",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759144": {
    "id": "item_14886",
    "Last Name": "Edmonds",
    "First Name": "Damon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759253": {
    "id": "item_439",
    "Last Name": "Blunden",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759311": {
    "id": "item_12844",
    "Last Name": "West",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759340": {
    "id": "item_14884",
    "Last Name": "Tang",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759501": {
    "id": "item_3914",
    "Last Name": "SUN",
    "First Name": "YANAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759586": {
    "id": "item_14883",
    "Last Name": "Levin",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759632": {
    "id": "item_4573",
    "Last Name": "Hughes",
    "First Name": "Doug",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759689": {
    "id": "item_15148",
    "Last Name": "Hare",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759693": {
    "id": "item_1963",
    "Last Name": "Blair",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759764": {
    "id": "item_3912",
    "Last Name": "Brinson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759842": {
    "id": "item_3909",
    "Last Name": "Cooper",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760077": {
    "id": "item_14878",
    "Last Name": "Mast",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760293": {
    "id": "item_1959",
    "Last Name": "Spiteri",
    "First Name": "Trevan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760295": {
    "id": "item_14877",
    "Last Name": "Balona Brito Ferreira",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760530": {
    "id": "item_14876",
    "Last Name": "Jamgotchian",
    "First Name": "Cathie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760544": {
    "id": "item_14875",
    "Last Name": "Crawford",
    "First Name": "Juliet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760687": {
    "id": "item_60",
    "Last Name": "Luu",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760758": {
    "id": "item_59",
    "Last Name": "Rokebrand",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760759": {
    "id": "item_14874",
    "Last Name": "Evans",
    "First Name": "Fleur",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760932": {
    "id": "item_14873",
    "Last Name": "Heaney",
    "First Name": "Niall",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761019": {
    "id": "item_14871",
    "Last Name": "Pearson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761053": {
    "id": "item_14870",
    "Last Name": "Chea",
    "First Name": "Belrich",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761407": {
    "id": "item_29525",
    "Last Name": "Mok",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761455": {
    "id": "item_2070",
    "Last Name": "Chadzynski",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761535": {
    "id": "item_14867",
    "Last Name": "Arthur",
    "First Name": "Meg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761625": {
    "id": "item_3903",
    "Last Name": "Morgan",
    "First Name": "Bodhi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761754": {
    "id": "item_1955",
    "Last Name": "Yau",
    "First Name": "Rong Quan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761756": {
    "id": "item_56",
    "Last Name": "Mcveigh",
    "First Name": "Eli",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761778": {
    "id": "item_3833",
    "Last Name": "Qiu",
    "First Name": "Jingjing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761856": {
    "id": "item_3901",
    "Last Name": "Fraser",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761888": {
    "id": "item_3900",
    "Last Name": "Seetharaman",
    "First Name": "Arjun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762121": {
    "id": "item_14864",
    "Last Name": "Abbott",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762169": {
    "id": "item_4571",
    "Last Name": "Singleton",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762216": {
    "id": "item_3899",
    "Last Name": "Peters",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762221": {
    "id": "item_3898",
    "Last Name": "Lockett",
    "First Name": "Adna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762418": {
    "id": "item_54",
    "Last Name": "Bray",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762419": {
    "id": "item_27603",
    "Last Name": "McDonald",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762479": {
    "id": "item_3896",
    "Last Name": "Hjortborg",
    "First Name": "Sara Kim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762480": {
    "id": "item_14858",
    "Last Name": "Anderson",
    "First Name": "Dave",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762905": {
    "id": "item_3831",
    "Last Name": "Sapuan",
    "First Name": "Haziq",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763129": {
    "id": "item_52",
    "Last Name": "Harden",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763210": {
    "id": "item_2069",
    "Last Name": "Klett",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763428": {
    "id": "item_14856",
    "Last Name": "Lin",
    "First Name": "Yan-Shih",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763430": {
    "id": "item_16704",
    "Last Name": "Nienaber",
    "First Name": "Suane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763431": {
    "id": "item_29608",
    "Last Name": "Thai",
    "First Name": "Doyle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763486": {
    "id": "item_14853",
    "Last Name": "Thekkemuriyil",
    "First Name": "Satheesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763643": {
    "id": "item_3894",
    "Last Name": "Bilani",
    "First Name": "Dany",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763662": {
    "id": "item_14847",
    "Last Name": "Muniz",
    "First Name": "Viviane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763709": {
    "id": "item_3893",
    "Last Name": "Tay",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763856": {
    "id": "item_29523",
    "Last Name": "Tse",
    "First Name": "Cheuk Kai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763859": {
    "id": "item_14848",
    "Last Name": "Wearne",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763898": {
    "id": "item_436",
    "Last Name": "Reid",
    "First Name": "Dimitri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764146": {
    "id": "item_16669",
    "Last Name": "CAI",
    "First Name": "YIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764173": {
    "id": "item_49",
    "Last Name": "Lawrenson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764238": {
    "id": "item_1952",
    "Last Name": "Morcillo",
    "First Name": "Zak",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764474": {
    "id": "item_3830",
    "Last Name": "Chivasa",
    "First Name": "Ketina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764912": {
    "id": "item_3889",
    "Last Name": "de Beer",
    "First Name": "Luzaan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765046": {
    "id": "item_27600",
    "Last Name": "Munkhbat",
    "First Name": "Zaya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765308": {
    "id": "item_45",
    "Last Name": "Laughlin-Hyde",
    "First Name": "Donald",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765330": {
    "id": "item_46",
    "Last Name": "O'Leary",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765423": {
    "id": "item_44",
    "Last Name": "Moore",
    "First Name": "Ciaran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765960": {
    "id": "item_4082",
    "Last Name": "Tapia Ramos",
    "First Name": "Israel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766077": {
    "id": "item_1949",
    "Last Name": "McLean",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766247": {
    "id": "item_14836",
    "Last Name": "Holloway",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766366": {
    "id": "item_5",
    "Last Name": "Hong",
    "First Name": "Vantheth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766529": {
    "id": "item_4081",
    "Last Name": "Cotton",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766562": {
    "id": "item_12833",
    "Last Name": "Doyle",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766611": {
    "id": "item_29519",
    "Last Name": "Mann",
    "First Name": "Amit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766685": {
    "id": "item_14834",
    "Last Name": "Thacker",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766750": {
    "id": "item_1948",
    "Last Name": "Baillie",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766858": {
    "id": "item_12831",
    "Last Name": "Doyle",
    "First Name": "Philip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767093": {
    "id": "item_3884",
    "Last Name": "Gu",
    "First Name": "Yongxin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767315": {
    "id": "item_27596",
    "Last Name": "Yalisi",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767339": {
    "id": "item_3883",
    "Last Name": "Tang",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767410": {
    "id": "item_14740",
    "Last Name": "McGoohan",
    "First Name": "Farrell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767686": {
    "id": "item_14832",
    "Last Name": "ZHANG",
    "First Name": "ZHENGJIE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767833": {
    "id": "item_4079",
    "Last Name": "Brencheva",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768059": {
    "id": "item_1947",
    "Last Name": "Mendes",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768281": {
    "id": "item_27570",
    "Last Name": "ELNA",
    "First Name": "ELNA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768323": {
    "id": "item_14830",
    "Last Name": "Handel",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768325": {
    "id": "item_12817",
    "Last Name": "chen",
    "First Name": "yuefeng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768483": {
    "id": "item_3882",
    "Last Name": "Quirk",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768718": {
    "id": "item_3880",
    "Last Name": "Smith",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768727": {
    "id": "item_15142",
    "Last Name": "Lloyd",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768872": {
    "id": "item_38",
    "Last Name": "Sala",
    "First Name": "Nicolo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769025": {
    "id": "item_37",
    "Last Name": "Taylor",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769077": {
    "id": "item_29517",
    "Last Name": "Soe",
    "First Name": "Phyo Paing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769496": {
    "id": "item_150",
    "Last Name": "Howden",
    "First Name": "Rick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769578": {
    "id": "item_35",
    "Last Name": "Pang",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769641": {
    "id": "item_1946",
    "Last Name": "Mcgrath",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769910": {
    "id": "item_29515",
    "Last Name": "Adamson",
    "First Name": "Glen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36770413": {
    "id": "item_15137",
    "Last Name": "Naing",
    "First Name": "Zaw",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36770440": {
    "id": "item_1945",
    "Last Name": "McInerney",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36770626": {
    "id": "item_2",
    "Last Name": "WILSON",
    "First Name": "DUNCAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36770672": {
    "id": "item_14822",
    "Last Name": "Knox",
    "First Name": "Philip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36770836": {
    "id": "item_14821",
    "Last Name": "Steyn",
    "First Name": "Jaco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771305": {
    "id": "item_2374",
    "Last Name": "Tusha",
    "First Name": "Igli",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771320": {
    "id": "item_29512",
    "Last Name": "Clargo",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771331": {
    "id": "item_3876",
    "Last Name": "Cottam",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771469": {
    "id": "item_14815",
    "Last Name": "Fodor",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771543": {
    "id": "item_29511",
    "Last Name": "Phillips",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771595": {
    "id": "item_3874",
    "Last Name": "Priest",
    "First Name": "Arron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771712": {
    "id": "item_1942",
    "Last Name": "Gow",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771839": {
    "id": "item_14813",
    "Last Name": "Soetedja",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771894": {
    "id": "item_29510",
    "Last Name": "Kong",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771949": {
    "id": "item_148",
    "Last Name": "Kishi",
    "First Name": "Daisuke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772061": {
    "id": "item_29509",
    "Last Name": "Warner",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772063": {
    "id": "item_27",
    "Last Name": "Burns",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772068": {
    "id": "item_29",
    "Last Name": "Martin",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772101": {
    "id": "item_14808",
    "Last Name": "McGarty",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772210": {
    "id": "item_29507",
    "Last Name": "Kim",
    "First Name": "Sun-Young",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772222": {
    "id": "item_14800",
    "Last Name": "Chen",
    "First Name": "Ray",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772271": {
    "id": "item_3872",
    "Last Name": "Venu",
    "First Name": "Vivekanandhan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772388": {
    "id": "item_4570",
    "Last Name": "Cacace",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772397": {
    "id": "item_3828",
    "Last Name": "ZHOU",
    "First Name": "JIAYU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772399": {
    "id": "item_26",
    "Last Name": "Nicholas",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36773334": {
    "id": "item_15136",
    "Last Name": "Simon",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36773646": {
    "id": "item_3869",
    "Last Name": "McNamara",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774580": {
    "id": "item_3867",
    "Last Name": "Biazzo",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774612": {
    "id": "item_147",
    "Last Name": "Rodriguez Gutierrez",
    "First Name": "Andres Mauricio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774669": {
    "id": "item_1926",
    "Last Name": "GE",
    "First Name": "WEICONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774702": {
    "id": "item_14797",
    "Last Name": "DONG",
    "First Name": "WENCHAO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774767": {
    "id": "item_15135",
    "Last Name": "Bell",
    "First Name": "Judy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774772": {
    "id": "item_3864",
    "Last Name": "Sekhon",
    "First Name": "Harjot",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774778": {
    "id": "item_14792",
    "Last Name": "Ross",
    "First Name": "Josephine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774782": {
    "id": "item_14791",
    "Last Name": "Jennings",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774802": {
    "id": "item_15770",
    "Last Name": "Moss",
    "First Name": "Travis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774815": {
    "id": "item_14789",
    "Last Name": "Young",
    "First Name": "Elliott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774877": {
    "id": "item_29500",
    "Last Name": "Windred",
    "First Name": "Jon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774896": {
    "id": "item_3861",
    "Last Name": "Wedd",
    "First Name": "Dallas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774922": {
    "id": "item_12891",
    "Last Name": "PAMENSKY",
    "First Name": "IAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36776143": {
    "id": "item_23",
    "Last Name": "Turney",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36777778": {
    "id": "item_4075",
    "Last Name": "Golland",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779374": {
    "id": "item_3860",
    "Last Name": "Van Noort",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779376": {
    "id": "item_14786",
    "Last Name": "Xu",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779378": {
    "id": "item_27589",
    "Last Name": "Colosimo",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779405": {
    "id": "item_29485",
    "Last Name": "Narbutaite",
    "First Name": "Ugne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779423": {
    "id": "item_22",
    "Last Name": "Lardner",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779426": {
    "id": "item_15131",
    "Last Name": "Ao",
    "First Name": "Long (Alan)",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779456": {
    "id": "item_14780",
    "Last Name": "Nguyen",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779458": {
    "id": "item_27587",
    "Last Name": "RUSSELL",
    "First Name": "ANDREW",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779546": {
    "id": "item_3858",
    "Last Name": "Le",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36781947": {
    "id": "item_3857",
    "Last Name": "Bustos",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36783972": {
    "id": "item_15769",
    "Last Name": "Benson",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36783973": {
    "id": "item_20",
    "Last Name": "Tokuhara",
    "First Name": "Kazuyuki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784009": {
    "id": "item_4568",
    "Last Name": "Moore",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784029": {
    "id": "item_14778",
    "Last Name": "Richards",
    "First Name": "Glen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784082": {
    "id": "item_14776",
    "Last Name": "Kvaalsvold",
    "First Name": "Vilde",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784116": {
    "id": "item_14775",
    "Last Name": "Dilsiz",
    "First Name": "Deniz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784135": {
    "id": "item_27569",
    "Last Name": "Tumanday",
    "First Name": "Janette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784151": {
    "id": "item_18",
    "Last Name": "Lynch",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784152": {
    "id": "item_29495",
    "Last Name": "Vali-Khojeini",
    "First Name": "Arya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784169": {
    "id": "item_15766",
    "Last Name": "Batty",
    "First Name": "Dane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784208": {
    "id": "item_3851",
    "Last Name": "CHAN",
    "First Name": "WING YIU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784219": {
    "id": "item_27568",
    "Last Name": "Tumanday Jr",
    "First Name": "Juanito",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784310": {
    "id": "item_14772",
    "Last Name": "Chee",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784324": {
    "id": "item_17",
    "Last Name": "Fahy",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784356": {
    "id": "item_1932",
    "Last Name": "Delahay",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785287": {
    "id": "item_15125",
    "Last Name": "Bell",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785296": {
    "id": "item_13011",
    "Last Name": "Riley",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785304": {
    "id": "item_15908",
    "Last Name": "Xu",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785332": {
    "id": "item_15126",
    "Last Name": "Agius",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785346": {
    "id": "item_29493",
    "Last Name": "Corvila",
    "First Name": "Francoise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785359": {
    "id": "item_12825",
    "Last Name": "Jackson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785367": {
    "id": "item_29492",
    "Last Name": "Scomparin",
    "First Name": "Rossana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785373": {
    "id": "item_4566",
    "Last Name": "Evans",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785390": {
    "id": "item_29785",
    "Last Name": "Daffara",
    "First Name": "Maddi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785450": {
    "id": "item_27887",
    "Last Name": "Candra",
    "First Name": "Edy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785453": {
    "id": "item_12823",
    "Last Name": "Im",
    "First Name": "Sung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785455": {
    "id": "item_15",
    "Last Name": "Smith",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785464": {
    "id": "item_1929",
    "Last Name": "Cullen",
    "First Name": "Alister",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785484": {
    "id": "item_27580",
    "Last Name": "Hyun",
    "First Name": "Sukho",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785504": {
    "id": "item_4069",
    "Last Name": "Laroda",
    "First Name": "Ritche",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785515": {
    "id": "item_13",
    "Last Name": "Cronin",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785546": {
    "id": "item_29490",
    "Last Name": "Ye",
    "First Name": "Shirley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785567": {
    "id": "item_3845",
    "Last Name": "Lay",
    "First Name": "Jade",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785574": {
    "id": "item_14767",
    "Last Name": "Xie",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785576": {
    "id": "item_27578",
    "Last Name": "Bedo-Tanyi",
    "First Name": "Eva",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785596": {
    "id": "item_12",
    "Last Name": "Hume",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785606": {
    "id": "item_3843",
    "Last Name": "Nethercott",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785612": {
    "id": "item_12821",
    "Last Name": "Read",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785633": {
    "id": "item_144",
    "Last Name": "Berechree",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785668": {
    "id": "item_29487",
    "Last Name": "Prista",
    "First Name": "Evangeline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785672": {
    "id": "item_14761",
    "Last Name": "Dilidili",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785681": {
    "id": "item_14764",
    "Last Name": "Sillis",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785694": {
    "id": "item_14762",
    "Last Name": "Chan",
    "First Name": "Stephen Chi Ho",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785695": {
    "id": "item_27576",
    "Last Name": "Forsyth",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785742": {
    "id": "item_14759",
    "Last Name": "Burns",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785744": {
    "id": "item_3840",
    "Last Name": "Pilley",
    "First Name": "Renee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785757": {
    "id": "item_14737",
    "Last Name": "St Ather",
    "First Name": "Loes",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785773": {
    "id": "item_14757",
    "Last Name": "Davis",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785791": {
    "id": "item_14756",
    "Last Name": "Zorigt",
    "First Name": "Tanan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785816": {
    "id": "item_12818",
    "Last Name": "Mummery",
    "First Name": "Eli",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785819": {
    "id": "item_9",
    "Last Name": "Lobsey",
    "First Name": "Graham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785835": {
    "id": "item_27574",
    "Last Name": "Stubbs",
    "First Name": "Kye",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785847": {
    "id": "item_27682",
    "Last Name": "Sabag",
    "First Name": "Mina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785873": {
    "id": "item_8",
    "Last Name": "Glikin",
    "First Name": "Yury",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785892": {
    "id": "item_1927",
    "Last Name": "Kee",
    "First Name": "Phoebe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785894": {
    "id": "item_14746",
    "Last Name": "Shin",
    "First Name": "Deok",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785896": {
    "id": "item_7",
    "Last Name": "Lesoa",
    "First Name": "Ray",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785918": {
    "id": "item_4627",
    "Last Name": "Temple",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785919": {
    "id": "item_29807",
    "Last Name": "CHEN",
    "First Name": "JIAJING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785930": {
    "id": "item_3834",
    "Last Name": "Tait",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785939": {
    "id": "item_12889",
    "Last Name": "Jones",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785960": {
    "id": "item_15118",
    "Last Name": "Kok",
    "First Name": "Barry Wai Choo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785963": {
    "id": "item_2414",
    "Last Name": "Newby",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785964": {
    "id": "item_2418",
    "Last Name": "Doyle",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785968": {
    "id": "item_469",
    "Last Name": "Mullins",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785969": {
    "id": "item_15842",
    "Last Name": "Li",
    "First Name": "Archie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785986": {
    "id": "item_15763",
    "Last Name": "Carey",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785989": {
    "id": "item_4623",
    "Last Name": "Taylor",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785999": {
    "id": "item_468",
    "Last Name": "Strain",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786010": {
    "id": "item_2415",
    "Last Name": "Wright",
    "First Name": "Chad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786011": {
    "id": "item_4067",
    "Last Name": "DeLacey",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786012": {
    "id": "item_4625",
    "Last Name": "Spratt",
    "First Name": "Gloria",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786013": {
    "id": "item_4563",
    "Last Name": "Folkes",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786017": {
    "id": "item_4624",
    "Last Name": "Santos",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786025": {
    "id": "item_27840",
    "Last Name": "Sinclair",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786041": {
    "id": "item_15840",
    "Last Name": "Gonzales",
    "First Name": "RJ",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786042": {
    "id": "item_4064",
    "Last Name": "Hetzel",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786054": {
    "id": "item_27863",
    "Last Name": "Trotter-Wilson",
    "First Name": "Skye",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786085": {
    "id": "item_2410",
    "Last Name": "Hastings",
    "First Name": "Carl",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786102": {
    "id": "item_2409",
    "Last Name": "Jurd",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786121": {
    "id": "item_4617",
    "Last Name": "Martin",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786145": {
    "id": "item_4614",
    "Last Name": "Suwandi",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786152": {
    "id": "item_430",
    "Last Name": "Woolley",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786170": {
    "id": "item_16668",
    "Last Name": "Williamson",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786214": {
    "id": "item_4612",
    "Last Name": "Tomczak",
    "First Name": "Michal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786216": {
    "id": "item_15835",
    "Last Name": "Lai",
    "First Name": "Tsun Chuen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786217": {
    "id": "item_12887",
    "Last Name": "Brosnan",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786220": {
    "id": "item_4613",
    "Last Name": "Proops",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786226": {
    "id": "item_4609",
    "Last Name": "Wen",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786236": {
    "id": "item_15832",
    "Last Name": "Jones",
    "First Name": "Maddie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786256": {
    "id": "item_4610",
    "Last Name": "Hescock",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786271": {
    "id": "item_2406",
    "Last Name": "McNeill",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786275": {
    "id": "item_4061",
    "Last Name": "Stukova",
    "First Name": "Yekaterina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786282": {
    "id": "item_4608",
    "Last Name": "Frahill",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786284": {
    "id": "item_2405",
    "Last Name": "BUHAGIAR",
    "First Name": "JAMIE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786295": {
    "id": "item_15113",
    "Last Name": "Halme",
    "First Name": "Kristine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786305": {
    "id": "item_15761",
    "Last Name": "De Paoli",
    "First Name": "Giorgi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786307": {
    "id": "item_27860",
    "Last Name": "Wong",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786308": {
    "id": "item_27839",
    "Last Name": "Beesley",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786309": {
    "id": "item_27859",
    "Last Name": "Fernandes",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786315": {
    "id": "item_1924",
    "Last Name": "Magee",
    "First Name": "Laoise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786328": {
    "id": "item_4060",
    "Last Name": "Crowley",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786355": {
    "id": "item_461",
    "Last Name": "Brayshaw",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786378": {
    "id": "item_4059",
    "Last Name": "Pandiyan",
    "First Name": "Karthi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786404": {
    "id": "item_4561",
    "Last Name": "Leggett",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786433": {
    "id": "item_29799",
    "Last Name": "Sinclair",
    "First Name": "Dale",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786435": {
    "id": "item_29602",
    "Last Name": "Talarah",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786463": {
    "id": "item_15819",
    "Last Name": "Tarnow-Mordi",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786474": {
    "id": "item_4602",
    "Last Name": "Woodpower",
    "First Name": "Zeb",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786479": {
    "id": "item_459",
    "Last Name": "Skow",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786487": {
    "id": "item_4601",
    "Last Name": "Oconnor",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786505": {
    "id": "item_2402",
    "Last Name": "Harmston",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786507": {
    "id": "item_29484",
    "Last Name": "Kempton",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786509": {
    "id": "item_2370",
    "Last Name": "Cabaleiro Vianna",
    "First Name": "Julio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786527": {
    "id": "item_15817",
    "Last Name": "Erickson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786539": {
    "id": "item_15818",
    "Last Name": "Moody",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786545": {
    "id": "item_27567",
    "Last Name": "Tanguilig",
    "First Name": "Pearl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786551": {
    "id": "item_27854",
    "Last Name": "Pandharipande",
    "First Name": "Harshad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786558": {
    "id": "item_27681",
    "Last Name": "Galliver",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786560": {
    "id": "item_4598",
    "Last Name": "Nguyen",
    "First Name": "Quang Minh (Gavin)",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786561": {
    "id": "item_4599",
    "Last Name": "Tran",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786579": {
    "id": "item_4595",
    "Last Name": "Carmody",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786591": {
    "id": "item_2400",
    "Last Name": "Matthews",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786595": {
    "id": "item_29796",
    "Last Name": "Burrows",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786658": {
    "id": "item_2397",
    "Last Name": "Brown",
    "First Name": "Tegan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786665": {
    "id": "item_15758",
    "Last Name": "Camp",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786677": {
    "id": "item_29793",
    "Last Name": "Honey",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786687": {
    "id": "item_2369",
    "Last Name": "Crawford",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786708": {
    "id": "item_4555",
    "Last Name": "King",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786738": {
    "id": "item_455",
    "Last Name": "Beale",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786741": {
    "id": "item_29783",
    "Last Name": "Pauthenet",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786783": {
    "id": "item_4592",
    "Last Name": "fisher",
    "First Name": "marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786787": {
    "id": "item_143",
    "Last Name": "Moran",
    "First Name": "Rowan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786788": {
    "id": "item_27838",
    "Last Name": "Reid",
    "First Name": "Lee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786798": {
    "id": "item_4593",
    "Last Name": "Salac",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786833": {
    "id": "item_15809",
    "Last Name": "Stephen",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786837": {
    "id": "item_15808",
    "Last Name": "Dizon",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786874": {
    "id": "item_29601",
    "Last Name": "kittler",
    "First Name": "Zelpha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786885": {
    "id": "item_12886",
    "Last Name": "Feras",
    "First Name": "Monty",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786887": {
    "id": "item_4054",
    "Last Name": "Palmer",
    "First Name": "Samuel James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786891": {
    "id": "item_2391",
    "Last Name": "Nissen",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786917": {
    "id": "item_4591",
    "Last Name": "Fonseca",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786940": {
    "id": "item_2390",
    "Last Name": "Beckett",
    "First Name": "Nahshon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786976": {
    "id": "item_29792",
    "Last Name": "Velandia",
    "First Name": "Jairo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787035": {
    "id": "item_2368",
    "Last Name": "Munroe",
    "First Name": "Allan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787097": {
    "id": "item_1923",
    "Last Name": "Hernandez",
    "First Name": "Romeo Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787107": {
    "id": "item_15800",
    "Last Name": "Houston",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787172": {
    "id": "item_15799",
    "Last Name": "Lister",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787215": {
    "id": "item_29790",
    "Last Name": "zhang",
    "First Name": "xiaolong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787234": {
    "id": "item_15798",
    "Last Name": "Kinvig",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787263": {
    "id": "item_14735",
    "Last Name": "Garrett",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787326": {
    "id": "item_13018",
    "Last Name": "Koo",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787340": {
    "id": "item_14736",
    "Last Name": "yu",
    "First Name": "rong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787382": {
    "id": "item_29600",
    "Last Name": "Tung",
    "First Name": "Lee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787384": {
    "id": "item_4585",
    "Last Name": "Gardiner",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787414": {
    "id": "item_2387",
    "Last Name": "Tong",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787423": {
    "id": "item_4553",
    "Last Name": "Dowle",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787424": {
    "id": "item_29782",
    "Last Name": "Gunn",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787445": {
    "id": "item_2386",
    "Last Name": "Georgiades",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787551": {
    "id": "item_15793",
    "Last Name": "Doueihi",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787597": {
    "id": "item_13017",
    "Last Name": "De Vera",
    "First Name": "Marcke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787638": {
    "id": "item_15792",
    "Last Name": "Wu",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787661": {
    "id": "item_2058",
    "Last Name": "Nathan",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787671": {
    "id": "item_29789",
    "Last Name": "Xie",
    "First Name": "Peng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787704": {
    "id": "item_2057",
    "Last Name": "Quach",
    "First Name": "Son",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928272": {
    "id": "item_509",
    "Last Name": "Norton",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928283": {
    "id": "item_510",
    "Last Name": "Travis",
    "First Name": "Orla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928293": {
    "id": "item_13040",
    "Last Name": "Padwick",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928297": {
    "id": "item_511",
    "Last Name": "Watkins",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928328": {
    "id": "item_16675",
    "Last Name": "Dionson",
    "First Name": "Rouel Bert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928335": {
    "id": "item_4693",
    "Last Name": "Lumsdaine",
    "First Name": "jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928361": {
    "id": "item_2452",
    "Last Name": "Ropero",
    "First Name": "Yonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928364": {
    "id": "item_4691",
    "Last Name": "Sheridan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928366": {
    "id": "item_4695",
    "Last Name": "Thomson",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928369": {
    "id": "item_16676",
    "Last Name": "Frost",
    "First Name": "Yuko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928385": {
    "id": "item_4692",
    "Last Name": "Wuiyue",
    "First Name": "Phuriphat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928395": {
    "id": "item_4694",
    "Last Name": "mcdonald",
    "First Name": "simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928414": {
    "id": "item_2453",
    "Last Name": "Surjadi",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928415": {
    "id": "item_512",
    "Last Name": "Llewelyn-Davies",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928420": {
    "id": "item_2454",
    "Last Name": "Prince",
    "First Name": "Diana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928422": {
    "id": "item_27893",
    "Last Name": "Roberts",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928436": {
    "id": "item_513",
    "Last Name": "Irwin",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928442": {
    "id": "item_514",
    "Last Name": "Bond",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928456": {
    "id": "item_515",
    "Last Name": "Weston",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928459": {
    "id": "item_4696",
    "Last Name": "O Connell",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928466": {
    "id": "item_516",
    "Last Name": "Patterson",
    "First Name": "Erica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928478": {
    "id": "item_27894",
    "Last Name": "Raju",
    "First Name": "Shika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928500": {
    "id": "item_4698",
    "Last Name": "Noble",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928522": {
    "id": "item_16677",
    "Last Name": "Ogg",
    "First Name": "Monica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928529": {
    "id": "item_4697",
    "Last Name": "Penagos",
    "First Name": "Yesid",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928553": {
    "id": "item_15910",
    "Last Name": "Thaweewararuk",
    "First Name": "Wipa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928639": {
    "id": "item_16678",
    "Last Name": "Brosas",
    "First Name": "Jose",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928643": {
    "id": "item_2455",
    "Last Name": "Sacher",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928648": {
    "id": "item_16679",
    "Last Name": "McArthur",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928652": {
    "id": "item_13041",
    "Last Name": "Hadinata",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928654": {
    "id": "item_29839",
    "Last Name": "Wedesweiler",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928662": {
    "id": "item_4699",
    "Last Name": "Jerath",
    "First Name": "Naina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928668": {
    "id": "item_13042",
    "Last Name": "Ganga",
    "First Name": "Clifford",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928679": {
    "id": "item_16680",
    "Last Name": "Russell",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928689": {
    "id": "item_15911",
    "Last Name": "McGuire",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928694": {
    "id": "item_16682",
    "Last Name": "Delany",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928697": {
    "id": "item_16681",
    "Last Name": "Warneford",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928698": {
    "id": "item_517",
    "Last Name": "Cabezas",
    "First Name": "Andres",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928707": {
    "id": "item_29840",
    "Last Name": "McGuire",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928711": {
    "id": "item_4700",
    "Last Name": "cahill",
    "First Name": "Rossa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928726": {
    "id": "item_518",
    "Last Name": "Harding",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928729": {
    "id": "item_16683",
    "Last Name": "Schaffer",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928734": {
    "id": "item_4701",
    "Last Name": "De Cristo Marcondes",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928751": {
    "id": "item_15912",
    "Last Name": "Thomas",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928764": {
    "id": "item_2456",
    "Last Name": "Stewart-Nikolic",
    "First Name": "Jarrad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928816": {
    "id": "item_13043",
    "Last Name": "Hupton",
    "First Name": "Jai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928829": {
    "id": "item_16684",
    "Last Name": "KUO",
    "First Name": "LING-LING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928851": {
    "id": "item_519",
    "Last Name": "Velkovski",
    "First Name": "Dragi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928868": {
    "id": "item_4702",
    "Last Name": "Foster",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928869": {
    "id": "item_16685",
    "Last Name": "Griffiths",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928870": {
    "id": "item_4703",
    "Last Name": "Spiers",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928883": {
    "id": "item_2457",
    "Last Name": "Berry",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928900": {
    "id": "item_520",
    "Last Name": "Walters",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928905": {
    "id": "item_29841",
    "Last Name": "Limo",
    "First Name": "Carla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928921": {
    "id": "item_2458",
    "Last Name": "Titong",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928943": {
    "id": "item_521",
    "Last Name": "Truong",
    "First Name": "Khanh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928961": {
    "id": "item_2459",
    "Last Name": "Sayer",
    "First Name": "Danial",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928971": {
    "id": "item_27895",
    "Last Name": "Azzi",
    "First Name": "Divya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928973": {
    "id": "item_4704",
    "Last Name": "Ford",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928977": {
    "id": "item_27896",
    "Last Name": "Guerrero",
    "First Name": "Leonardo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929012": {
    "id": "item_4705",
    "Last Name": "Benstead",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929021": {
    "id": "item_4706",
    "Last Name": "Garcia Sada",
    "First Name": "Rosendo de Jesus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929044": {
    "id": "item_4707",
    "Last Name": "Denisenko",
    "First Name": "Jasper",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929055": {
    "id": "item_29842",
    "Last Name": "Woon",
    "First Name": "Wee-Sian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929072": {
    "id": "item_13044",
    "Last Name": "Figueroa Fuentes",
    "First Name": "Franklin Alfredo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929083": {
    "id": "item_4708",
    "Last Name": "Maloney",
    "First Name": "Benni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929087": {
    "id": "item_2460",
    "Last Name": "Sirampuj",
    "First Name": "Thittapong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929101": {
    "id": "item_4709",
    "Last Name": "Hastings",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929133": {
    "id": "item_15913",
    "Last Name": "Charalambous",
    "First Name": "Kylo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929140": {
    "id": "item_522",
    "Last Name": "Rea",
    "First Name": "Katie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929144": {
    "id": "item_27897",
    "Last Name": "Fischer",
    "First Name": "Lars",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929179": {
    "id": "item_2461",
    "Last Name": "Smith",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929182": {
    "id": "item_4710",
    "Last Name": "Alcazar",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929222": {
    "id": "item_27898",
    "Last Name": "ZARYAB",
    "First Name": "WALEED",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929230": {
    "id": "item_16686",
    "Last Name": "Muema",
    "First Name": "Raphael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929246": {
    "id": "item_4711",
    "Last Name": "Fyvie",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929302": {
    "id": "item_523",
    "Last Name": "Villadolid",
    "First Name": "Joaquin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929367": {
    "id": "item_29843",
    "Last Name": "keeling",
    "First Name": "kobie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929397": {
    "id": "item_4712",
    "Last Name": "Spofforth",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929403": {
    "id": "item_16687",
    "Last Name": "Wilcockson",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929407": {
    "id": "item_29844",
    "Last Name": "Louka",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929461": {
    "id": "item_16688",
    "Last Name": "Wang",
    "First Name": "Yixin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929473": {
    "id": "item_4713",
    "Last Name": "Vo",
    "First Name": "Khang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929488": {
    "id": "item_29845",
    "Last Name": "Bathan",
    "First Name": "Jhon Dave",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929506": {
    "id": "item_4714",
    "Last Name": "FLAUTA",
    "First Name": "NESTOR JAMES",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929548": {
    "id": "item_16689",
    "Last Name": "Ryan",
    "First Name": "Murray",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929600": {
    "id": "item_27899",
    "Last Name": "QIU",
    "First Name": "YUEFENG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929660": {
    "id": "item_16691",
    "Last Name": "Rosic",
    "First Name": "Antoni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929663": {
    "id": "item_16690",
    "Last Name": "Whitehead",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929699": {
    "id": "item_524",
    "Last Name": "Sarcia",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929700": {
    "id": "item_29846",
    "Last Name": "Cooper",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929702": {
    "id": "item_2462",
    "Last Name": "FNU",
    "First Name": "Barry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929711": {
    "id": "item_16692",
    "Last Name": "Green",
    "First Name": "Taytum",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929727": {
    "id": "item_525",
    "Last Name": "Nakamura",
    "First Name": "Dai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929799": {
    "id": "item_16693",
    "Last Name": "Voorend",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929807": {
    "id": "item_526",
    "Last Name": "Tang",
    "First Name": "Kylo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929808": {
    "id": "item_16694",
    "Last Name": "Baddeley",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929831": {
    "id": "item_16695",
    "Last Name": "Mand",
    "First Name": "Jasmeet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929884": {
    "id": "item_16696",
    "Last Name": "Choi",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929971": {
    "id": "item_27900",
    "Last Name": "Mawoneke",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930018": {
    "id": "item_29847",
    "Last Name": "Lyndon-James",
    "First Name": "PJ",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930376": {
    "id": "item_27901",
    "Last Name": "Browne",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930457": {
    "id": "item_16697",
    "Last Name": "Lu",
    "First Name": "Haixia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930617": {
    "id": "item_16698",
    "Last Name": "Jimeno",
    "First Name": "Michael Angelo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930650": {
    "id": "item_527",
    "Last Name": "Mcintyre",
    "First Name": "Campbell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930911": {
    "id": "item_528",
    "Last Name": "YEUNG",
    "First Name": "YING KIT ALVIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930968": {
    "id": "item_4715",
    "Last Name": "McCormick",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931289": {
    "id": "item_15914",
    "Last Name": "Howman",
    "First Name": "Abbie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931376": {
    "id": "item_2463",
    "Last Name": "Hang",
    "First Name": "Yiran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931451": {
    "id": "item_4716",
    "Last Name": "Nguyen",
    "First Name": "Clement",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931453": {
    "id": "item_529",
    "Last Name": "CUI",
    "First Name": "YUYING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931530": {
    "id": "item_16699",
    "Last Name": "Soon",
    "First Name": "Chen Peng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931535": {
    "id": "item_4717",
    "Last Name": "Brown",
    "First Name": "Luka",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931596": {
    "id": "item_27902",
    "Last Name": "Narayanan",
    "First Name": "Karthik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931619": {
    "id": "item_15915",
    "Last Name": "Behrmann",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931723": {
    "id": "item_2464",
    "Last Name": "Warren",
    "First Name": "Lee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931745": {
    "id": "item_16700",
    "Last Name": "CHAN",
    "First Name": "SHING LEUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931880": {
    "id": "item_4718",
    "Last Name": "WANG",
    "First Name": "CUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931965": {
    "id": "item_4719",
    "Last Name": "Congdon",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932039": {
    "id": "item_2465",
    "Last Name": "Mariany",
    "First Name": "Maya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932058": {
    "id": "item_4720",
    "Last Name": "Wang",
    "First Name": "Mingquan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932072": {
    "id": "item_530",
    "Last Name": "Niponcharoensri",
    "First Name": "Chatchalerm",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932085": {
    "id": "item_2466",
    "Last Name": "Fisk",
    "First Name": "Codie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932146": {
    "id": "item_531",
    "Last Name": "KOBAI",
    "First Name": "LI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932190": {
    "id": "item_2467",
    "Last Name": "Fisk",
    "First Name": "Jaidyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932210": {
    "id": "item_27903",
    "Last Name": "Ulrick",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932231": {
    "id": "item_4721",
    "Last Name": "Innes",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932399": {
    "id": "item_16701",
    "Last Name": "He",
    "First Name": "ZIHUA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932500": {
    "id": "item_13045",
    "Last Name": "Henderson",
    "First Name": "Catrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36934788": {
    "id": "item_4722",
    "Last Name": "Anderson",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36937380": {
    "id": "item_15916",
    "Last Name": "Lee",
    "First Name": "Xuan Hui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36937930": {
    "id": "item_4723",
    "Last Name": "Farnworth",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36939733": {
    "id": "item_532",
    "Last Name": "Franco",
    "First Name": "Ed",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36939769": {
    "id": "item_16702",
    "Last Name": "CAI",
    "First Name": "XIANG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36939784": {
    "id": "item_4725",
    "Last Name": "Farrugia",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36939788": {
    "id": "item_4724",
    "Last Name": "Hakim",
    "First Name": "Basher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36939795": {
    "id": "item_16703",
    "Last Name": "Dickson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36939839": {
    "id": "item_2468",
    "Last Name": "Aleksoski",
    "First Name": "Pece",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36939867": {
    "id": "item_15917",
    "Last Name": "Truszewski",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940026": {
    "id": "item_2469",
    "Last Name": "Jones",
    "First Name": "Lorcan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940194": {
    "id": "item_16705",
    "Last Name": "Udler",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940248": {
    "id": "item_2470",
    "Last Name": "XIE",
    "First Name": "SHANGCAI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940281": {
    "id": "item_4727",
    "Last Name": "Connolly",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940325": {
    "id": "item_29848",
    "Last Name": "WANG",
    "First Name": "WEIYI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940379": {
    "id": "item_16706",
    "Last Name": "Leung",
    "First Name": "Wing Hung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940662": {
    "id": "item_2471",
    "Last Name": "De Vera",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940696": {
    "id": "item_4728",
    "Last Name": "Rodrigues",
    "First Name": "Kalan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940773": {
    "id": "item_4729",
    "Last Name": "Webb",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940829": {
    "id": "item_16707",
    "Last Name": "Ash",
    "First Name": "Lorna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940856": {
    "id": "item_16708",
    "Last Name": "Lo",
    "First Name": "Brendin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941186": {
    "id": "item_533",
    "Last Name": "Nguyen",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941459": {
    "id": "item_2472",
    "Last Name": "Andrews",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941488": {
    "id": "item_2473",
    "Last Name": "Cajal",
    "First Name": "Ada",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941618": {
    "id": "item_16709",
    "Last Name": "Surynt",
    "First Name": "Ntonya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941672": {
    "id": "item_13046",
    "Last Name": "Lyu",
    "First Name": "Hanbing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941674": {
    "id": "item_534",
    "Last Name": "Zhao",
    "First Name": "Zhexi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941683": {
    "id": "item_2474",
    "Last Name": "LAW",
    "First Name": "CHUN HUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941705": {
    "id": "item_27904",
    "Last Name": "Nchabeleng",
    "First Name": "Masoono",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941717": {
    "id": "item_2475",
    "Last Name": "LAW",
    "First Name": "CHUN KUEN STANLEY",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941731": {
    "id": "item_29849",
    "Last Name": "Espe",
    "First Name": "Rogelio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941734": {
    "id": "item_16710",
    "Last Name": "Bowles",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941760": {
    "id": "item_16711",
    "Last Name": "Turner Jensen",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941815": {
    "id": "item_16712",
    "Last Name": "Keogh",
    "First Name": "Aine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942122": {
    "id": "item_535",
    "Last Name": "Arthurson",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942136": {
    "id": "item_16713",
    "Last Name": "Wright",
    "First Name": "Carla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942153": {
    "id": "item_29850",
    "Last Name": "Low",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942171": {
    "id": "item_2476",
    "Last Name": "Jia",
    "First Name": "Bangxian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942295": {
    "id": "item_4730",
    "Last Name": "Ostermann",
    "First Name": "Christoph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942409": {
    "id": "item_29851",
    "Last Name": "Thai",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942587": {
    "id": "item_15918",
    "Last Name": "Wouda",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942689": {
    "id": "item_27905",
    "Last Name": "Simpson",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942746": {
    "id": "item_16714",
    "Last Name": "zhao",
    "First Name": "junkai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942992": {
    "id": "item_4731",
    "Last Name": "Ling",
    "First Name": "Francis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36943379": {
    "id": "item_16715",
    "Last Name": "Andriyanto",
    "First Name": "Piston",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36943401": {
    "id": "item_4732",
    "Last Name": "Geniston",
    "First Name": "Mark Philip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36943900": {
    "id": "item_4733",
    "Last Name": "Cave",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36944322": {
    "id": "item_27906",
    "Last Name": "Aquino",
    "First Name": "Lady Mira",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37041847": {
    "id": "item_16716",
    "Last Name": "McClean",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37080304": {
    "id": "item_27907",
    "Last Name": "Hartina",
    "First Name": "Siti",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37093211": {
    "id": "item_4734",
    "Last Name": "Habibi",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37094853": {
    "id": "item_4735",
    "Last Name": "Abbonizio",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37096308": {
    "id": "item_16717",
    "Last Name": "Truong",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37098812": {
    "id": "item_16718",
    "Last Name": "Taylor",
    "First Name": "Kaitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37099359": {
    "id": "item_27908",
    "Last Name": "Fountain",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37099366": {
    "id": "item_27909",
    "Last Name": "Sangani",
    "First Name": "Krunal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37103465": {
    "id": "item_13047",
    "Last Name": "Sausa Ventura",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37109364": {
    "id": "item_2477",
    "Last Name": "Taylor",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37109455": {
    "id": "item_16719",
    "Last Name": "Ragavan",
    "First Name": "Gopinaath",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37109566": {
    "id": "item_16720",
    "Last Name": "Hribovsek",
    "First Name": "Timo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37110740": {
    "id": "item_4736",
    "Last Name": "Pusell",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37110920": {
    "id": "item_4737",
    "Last Name": "Tung",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37112235": {
    "id": "item_16721",
    "Last Name": "Hill",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37113609": {
    "id": "item_27910",
    "Last Name": "DADAL",
    "First Name": "ROSELLE MAY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37114565": {
    "id": "item_16722",
    "Last Name": "Rolfo",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37114925": {
    "id": "item_16723",
    "Last Name": "Brymer",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37115274": {
    "id": "item_16724",
    "Last Name": "Lee",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37115480": {
    "id": "item_4738",
    "Last Name": "Baker",
    "First Name": "Giles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37115610": {
    "id": "item_13048",
    "Last Name": "Feng",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37115899": {
    "id": "item_4739",
    "Last Name": "Steinwede",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37115900": {
    "id": "item_16725",
    "Last Name": "Fairbrother",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37115983": {
    "id": "item_13049",
    "Last Name": "Pells",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37116215": {
    "id": "item_4740",
    "Last Name": "Banks",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37116222": {
    "id": "item_4741",
    "Last Name": "Hunt",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37116233": {
    "id": "item_13050",
    "Last Name": "Gregors",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37116567": {
    "id": "item_29852",
    "Last Name": "Lee",
    "First Name": "Tiffany Si Yi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144594": {
    "id": "item_26207",
    "Last Name": "Villadelgado",
    "First Name": "Erika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144653": {
    "id": "item_13861",
    "Last Name": "Jacob",
    "First Name": "Sneha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144684": {
    "id": "item_26206",
    "Last Name": "Cunningham",
    "First Name": "Alaine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144715": {
    "id": "item_3153",
    "Last Name": "Bognar",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144723": {
    "id": "item_26509",
    "Last Name": "Reiner",
    "First Name": "Kayla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144734": {
    "id": "item_30890",
    "Last Name": "Guerra",
    "First Name": "Vennard Christian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144745": {
    "id": "item_13860",
    "Last Name": "Lai",
    "First Name": "Howard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144757": {
    "id": "item_16258",
    "Last Name": "Aldridge",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144813": {
    "id": "item_30889",
    "Last Name": "Lu",
    "First Name": "Shan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144822": {
    "id": "item_3152",
    "Last Name": "Elliott",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144823": {
    "id": "item_16257",
    "Last Name": "Billsborough",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144867": {
    "id": "item_3151",
    "Last Name": "Vasudavan",
    "First Name": "Sivabalan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144871": {
    "id": "item_13859",
    "Last Name": "Lindenmayer",
    "First Name": "Erika",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144912": {
    "id": "item_3150",
    "Last Name": "Weldon",
    "First Name": "Karl",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144913": {
    "id": "item_16256",
    "Last Name": "Gevaux",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144949": {
    "id": "item_26205",
    "Last Name": "March Masstui",
    "First Name": "Antonina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144963": {
    "id": "item_3149",
    "Last Name": "Hunt",
    "First Name": "Keanu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144971": {
    "id": "item_30888",
    "Last Name": "Ortega",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144977": {
    "id": "item_26204",
    "Last Name": "Edgren",
    "First Name": "Mathilde",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144986": {
    "id": "item_13858",
    "Last Name": "Flores",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144994": {
    "id": "item_13855",
    "Last Name": "Toumazos",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144997": {
    "id": "item_13857",
    "Last Name": "Klar",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145005": {
    "id": "item_26203",
    "Last Name": "Budiono",
    "First Name": "Edbert Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145013": {
    "id": "item_3148",
    "Last Name": "Firestone",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145018": {
    "id": "item_3146",
    "Last Name": "Osbourne",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145021": {
    "id": "item_13854",
    "Last Name": "Ung",
    "First Name": "Luck",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145023": {
    "id": "item_13856",
    "Last Name": "Chi",
    "First Name": "Selena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145026": {
    "id": "item_26200",
    "Last Name": "Harwood",
    "First Name": "Heather",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145031": {
    "id": "item_16255",
    "Last Name": "Tan",
    "First Name": "Poh See",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145033": {
    "id": "item_26191",
    "Last Name": "Eccarius",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145036": {
    "id": "item_26199",
    "Last Name": "Jaipin",
    "First Name": "Porapat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145043": {
    "id": "item_13838",
    "Last Name": "Melton",
    "First Name": "Madison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145048": {
    "id": "item_3147",
    "Last Name": "Osawa",
    "First Name": "Shu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145057": {
    "id": "item_13853",
    "Last Name": "Ible",
    "First Name": "Coco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145070": {
    "id": "item_26201",
    "Last Name": "Cocoman",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145071": {
    "id": "item_26202",
    "Last Name": "Spotswood",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145075": {
    "id": "item_30880",
    "Last Name": "Rennie",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145090": {
    "id": "item_26196",
    "Last Name": "Halis",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145091": {
    "id": "item_3140",
    "Last Name": "Bai",
    "First Name": "Yiqing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145097": {
    "id": "item_30886",
    "Last Name": "Wales",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145099": {
    "id": "item_26194",
    "Last Name": "McCormack",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145102": {
    "id": "item_26195",
    "Last Name": "Kleinig",
    "First Name": "Allegra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145125": {
    "id": "item_3141",
    "Last Name": "Donaghy",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145128": {
    "id": "item_13844",
    "Last Name": "Willebrand",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145133": {
    "id": "item_3143",
    "Last Name": "Toerien",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145134": {
    "id": "item_16253",
    "Last Name": "Judd",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145148": {
    "id": "item_1298",
    "Last Name": "Earl-King",
    "First Name": "Owen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145171": {
    "id": "item_1297",
    "Last Name": "Barker",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145206": {
    "id": "item_1294",
    "Last Name": "Lay",
    "First Name": "Dayna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145207": {
    "id": "item_13849",
    "Last Name": "Buman",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145216": {
    "id": "item_30885",
    "Last Name": "Barber",
    "First Name": "Molly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145229": {
    "id": "item_30883",
    "Last Name": "Evans",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145242": {
    "id": "item_13848",
    "Last Name": "Goh",
    "First Name": "Charlene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145253": {
    "id": "item_3136",
    "Last Name": "Marshall",
    "First Name": "Wallace",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145255": {
    "id": "item_26185",
    "Last Name": "Foran",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145277": {
    "id": "item_1295",
    "Last Name": "Hem",
    "First Name": "Tieren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145281": {
    "id": "item_26173",
    "Last Name": "Gardiner",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145289": {
    "id": "item_1292",
    "Last Name": "Zoia",
    "First Name": "Lorenzo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145301": {
    "id": "item_26144",
    "Last Name": "Talbot",
    "First Name": "Angus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145312": {
    "id": "item_26181",
    "Last Name": "Shukla",
    "First Name": "Umesh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145327": {
    "id": "item_28683",
    "Last Name": "O Reilly",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145332": {
    "id": "item_13837",
    "Last Name": "Ellis",
    "First Name": "Lochlan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145340": {
    "id": "item_28697",
    "Last Name": "Garcia Poire",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145350": {
    "id": "item_26179",
    "Last Name": "Chaseling",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145351": {
    "id": "item_26121",
    "Last Name": "Ma'zam",
    "First Name": "Hilmi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145358": {
    "id": "item_26168",
    "Last Name": "Smith",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145363": {
    "id": "item_13816",
    "Last Name": "Golding",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145368": {
    "id": "item_16251",
    "Last Name": "Harris",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145400": {
    "id": "item_16246",
    "Last Name": "Dempsey",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145417": {
    "id": "item_13825",
    "Last Name": "McKay",
    "First Name": "Amy Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145418": {
    "id": "item_3133",
    "Last Name": "Tran",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145421": {
    "id": "item_1378",
    "Last Name": "Crozier",
    "First Name": "Mimi-Jean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145425": {
    "id": "item_28696",
    "Last Name": "Ungar",
    "First Name": "Danny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145429": {
    "id": "item_28701",
    "Last Name": "Bauer",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145437": {
    "id": "item_26165",
    "Last Name": "Salisbury",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145444": {
    "id": "item_3125",
    "Last Name": "Benatar",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145450": {
    "id": "item_28694",
    "Last Name": "Ting",
    "First Name": "Lai Lim Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145451": {
    "id": "item_26159",
    "Last Name": "Roberts",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145458": {
    "id": "item_30862",
    "Last Name": "Zhao",
    "First Name": "Shuo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145461": {
    "id": "item_13818",
    "Last Name": "Snowball",
    "First Name": "Miranda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145466": {
    "id": "item_13815",
    "Last Name": "Bottomer",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145476": {
    "id": "item_16249",
    "Last Name": "Donovan",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145480": {
    "id": "item_14054",
    "Last Name": "Najdovski",
    "First Name": "Kane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145482": {
    "id": "item_26147",
    "Last Name": "Green",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145491": {
    "id": "item_28692",
    "Last Name": "Holland",
    "First Name": "Brad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145499": {
    "id": "item_1287",
    "Last Name": "Kelly",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145501": {
    "id": "item_30868",
    "Last Name": "Setiawan",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145509": {
    "id": "item_13819",
    "Last Name": "Lettieri",
    "First Name": "giuseppe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145517": {
    "id": "item_13814",
    "Last Name": "Papantoniou",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145520": {
    "id": "item_1280",
    "Last Name": "Weule",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145524": {
    "id": "item_26146",
    "Last Name": "Manibo",
    "First Name": "Ruel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145527": {
    "id": "item_26155",
    "Last Name": "Tran",
    "First Name": "Teri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145554": {
    "id": "item_30865",
    "Last Name": "Cameron",
    "First Name": "Renae",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145570": {
    "id": "item_30863",
    "Last Name": "Henin",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145582": {
    "id": "item_30864",
    "Last Name": "DEL CASTILLO",
    "First Name": "LIEZL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145591": {
    "id": "item_28685",
    "Last Name": "Jones",
    "First Name": "Alyssa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145598": {
    "id": "item_26088",
    "Last Name": "Ranson",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145599": {
    "id": "item_26154",
    "Last Name": "Yocom",
    "First Name": "Reagen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145601": {
    "id": "item_26142",
    "Last Name": "Whittaker",
    "First Name": "Carmen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145608": {
    "id": "item_30857",
    "Last Name": "Acharya",
    "First Name": "Jenna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145612": {
    "id": "item_1282",
    "Last Name": "Kynaston",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145618": {
    "id": "item_30854",
    "Last Name": "Mejias",
    "First Name": "Sharmila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145621": {
    "id": "item_13813",
    "Last Name": "Nguyen",
    "First Name": "Hien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145622": {
    "id": "item_1268",
    "Last Name": "Salman",
    "First Name": "Annali",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145626": {
    "id": "item_1257",
    "Last Name": "McLoughlin",
    "First Name": "Aengus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145628": {
    "id": "item_3124",
    "Last Name": "Thompson",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145631": {
    "id": "item_26150",
    "Last Name": "Moohin",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145633": {
    "id": "item_28830",
    "Last Name": "Sommer",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145634": {
    "id": "item_13739",
    "Last Name": "Boyle",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145636": {
    "id": "item_28678",
    "Last Name": "Pillaca",
    "First Name": "Beny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145640": {
    "id": "item_13809",
    "Last Name": "Schwab",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145647": {
    "id": "item_26133",
    "Last Name": "Barwick",
    "First Name": "Alisha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145650": {
    "id": "item_28674",
    "Last Name": "Pang",
    "First Name": "Yee Siaw",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145665": {
    "id": "item_28676",
    "Last Name": "richards",
    "First Name": "sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145667": {
    "id": "item_13804",
    "Last Name": "Love",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145668": {
    "id": "item_1271",
    "Last Name": "Moore",
    "First Name": "Jak",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145672": {
    "id": "item_26141",
    "Last Name": "Zhou",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145675": {
    "id": "item_13766",
    "Last Name": "McDaid",
    "First Name": "Colm",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145677": {
    "id": "item_30853",
    "Last Name": "Westgarth",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145696": {
    "id": "item_26132",
    "Last Name": "Tanuwijaya",
    "First Name": "Andre",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145707": {
    "id": "item_1251",
    "Last Name": "Cunningham",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145712": {
    "id": "item_13803",
    "Last Name": "Mogee",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145714": {
    "id": "item_3115",
    "Last Name": "Rutherford",
    "First Name": "Doug",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145716": {
    "id": "item_30842",
    "Last Name": "Belford",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145728": {
    "id": "item_28680",
    "Last Name": "MacLeod",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145737": {
    "id": "item_26102",
    "Last Name": "Faulks",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145743": {
    "id": "item_1236",
    "Last Name": "Zhang",
    "First Name": "Hao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145754": {
    "id": "item_26131",
    "Last Name": "W",
    "First Name": "Steph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145761": {
    "id": "item_30844",
    "Last Name": "Budiawan",
    "First Name": "Pratama Kukuh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145773": {
    "id": "item_26117",
    "Last Name": "Kanjrawi",
    "First Name": "Alisar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145774": {
    "id": "item_1276",
    "Last Name": "Pennicuik",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145807": {
    "id": "item_26111",
    "Last Name": "Proctor",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145817": {
    "id": "item_13778",
    "Last Name": "Gilich",
    "First Name": "Tara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145826": {
    "id": "item_1274",
    "Last Name": "Palmer",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145840": {
    "id": "item_28673",
    "Last Name": "Mikkelsen",
    "First Name": "Marcell Klixbuell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145851": {
    "id": "item_30840",
    "Last Name": "Prabowo",
    "First Name": "Benyamin A",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145855": {
    "id": "item_26116",
    "Last Name": "Boersma",
    "First Name": "Nathanial",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145863": {
    "id": "item_30838",
    "Last Name": "Holmes",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145869": {
    "id": "item_3112",
    "Last Name": "Wajsman",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145870": {
    "id": "item_26113",
    "Last Name": "Campbell",
    "First Name": "Lucinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145877": {
    "id": "item_3079",
    "Last Name": "Brown",
    "First Name": "Eve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145879": {
    "id": "item_16239",
    "Last Name": "sandritter",
    "First Name": "timo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145880": {
    "id": "item_1273",
    "Last Name": "Lloyd",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145908": {
    "id": "item_1255",
    "Last Name": "Wang",
    "First Name": "Xiaokun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145926": {
    "id": "item_13789",
    "Last Name": "Caruso",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145941": {
    "id": "item_26110",
    "Last Name": "Callery",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145960": {
    "id": "item_1269",
    "Last Name": "Mazza",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145968": {
    "id": "item_1262",
    "Last Name": "Talbot",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145975": {
    "id": "item_30835",
    "Last Name": "Mirtsis",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145982": {
    "id": "item_30839",
    "Last Name": "O'Neill",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145987": {
    "id": "item_28670",
    "Last Name": "Ferguson",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145988": {
    "id": "item_3098",
    "Last Name": "Proctor",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145992": {
    "id": "item_13785",
    "Last Name": "Scott",
    "First Name": "Jazmin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145995": {
    "id": "item_13770",
    "Last Name": "Jane",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146009": {
    "id": "item_26106",
    "Last Name": "Norris",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146011": {
    "id": "item_26101",
    "Last Name": "Barnes",
    "First Name": "Nusha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146012": {
    "id": "item_26068",
    "Last Name": "Haley",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146017": {
    "id": "item_3111",
    "Last Name": "Stacey",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146028": {
    "id": "item_28662",
    "Last Name": "Ager",
    "First Name": "Roy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146048": {
    "id": "item_1261",
    "Last Name": "Skinner",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146052": {
    "id": "item_26076",
    "Last Name": "Simeone",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146062": {
    "id": "item_30826",
    "Last Name": "Benson",
    "First Name": "Ollie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146066": {
    "id": "item_13782",
    "Last Name": "D'Aprano",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146071": {
    "id": "item_26057",
    "Last Name": "Gray",
    "First Name": "Desley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146073": {
    "id": "item_26098",
    "Last Name": "Campbell",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146075": {
    "id": "item_1260",
    "Last Name": "Quilter",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146083": {
    "id": "item_13771",
    "Last Name": "Burrett",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146088": {
    "id": "item_30820",
    "Last Name": "Powell",
    "First Name": "Clare",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146092": {
    "id": "item_1242",
    "Last Name": "Brown",
    "First Name": "Priscilla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146098": {
    "id": "item_26073",
    "Last Name": "Ong",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146106": {
    "id": "item_28671",
    "Last Name": "Walsh",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146109": {
    "id": "item_13773",
    "Last Name": "Brown",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146111": {
    "id": "item_1244",
    "Last Name": "Gong",
    "First Name": "Jayden Daozi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146113": {
    "id": "item_26070",
    "Last Name": "Ames",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146116": {
    "id": "item_1250",
    "Last Name": "Mann",
    "First Name": "Eloise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146119": {
    "id": "item_28645",
    "Last Name": "Macwilliam",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146120": {
    "id": "item_26092",
    "Last Name": "Feltham",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146129": {
    "id": "item_16231",
    "Last Name": "Henchey",
    "First Name": "Shilo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146142": {
    "id": "item_26097",
    "Last Name": "Dennis",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146143": {
    "id": "item_1245",
    "Last Name": "Ghysens",
    "First Name": "Renaud",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146153": {
    "id": "item_28665",
    "Last Name": "Little",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146166": {
    "id": "item_26064",
    "Last Name": "Close",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146170": {
    "id": "item_3105",
    "Last Name": "Regan-Beasley",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146177": {
    "id": "item_1254",
    "Last Name": "Mahemoff",
    "First Name": "Neda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146187": {
    "id": "item_13769",
    "Last Name": "Gallegos",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146193": {
    "id": "item_28666",
    "Last Name": "Xu",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146194": {
    "id": "item_28628",
    "Last Name": "Hamilton",
    "First Name": "Spencer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146200": {
    "id": "item_1249",
    "Last Name": "Riley",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146203": {
    "id": "item_3097",
    "Last Name": "Chak",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146206": {
    "id": "item_16235",
    "Last Name": "Powell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146210": {
    "id": "item_16232",
    "Last Name": "Lau",
    "First Name": "Ching San",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146245": {
    "id": "item_16233",
    "Last Name": "Araneda",
    "First Name": "Catalina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146254": {
    "id": "item_3102",
    "Last Name": "Scott-Hamilton",
    "First Name": "Ken",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146261": {
    "id": "item_28658",
    "Last Name": "Abihaggle",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146265": {
    "id": "item_26071",
    "Last Name": "Charnstrom",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146268": {
    "id": "item_26060",
    "Last Name": "Nolis",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146277": {
    "id": "item_1234",
    "Last Name": "Tan",
    "First Name": "Winson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146305": {
    "id": "item_30800",
    "Last Name": "Freemantle",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146313": {
    "id": "item_30809",
    "Last Name": "Avelino",
    "First Name": "Mary Myra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146322": {
    "id": "item_28655",
    "Last Name": "Wilson",
    "First Name": "Maya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146325": {
    "id": "item_13752",
    "Last Name": "McBain",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146337": {
    "id": "item_30805",
    "Last Name": "Wong",
    "First Name": "Winnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146351": {
    "id": "item_1232",
    "Last Name": "Sozis",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146352": {
    "id": "item_30780",
    "Last Name": "Hsieh",
    "First Name": "Yen-Fen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146363": {
    "id": "item_26062",
    "Last Name": "Maher",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146386": {
    "id": "item_13759",
    "Last Name": "O'Brien",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146391": {
    "id": "item_26059",
    "Last Name": "Sullivan",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146412": {
    "id": "item_30791",
    "Last Name": "Quach",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146423": {
    "id": "item_13751",
    "Last Name": "Cruz",
    "First Name": "Roger",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146426": {
    "id": "item_26047",
    "Last Name": "Brown",
    "First Name": "Kai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146443": {
    "id": "item_30793",
    "Last Name": "Rowe",
    "First Name": "Orla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146449": {
    "id": "item_26038",
    "Last Name": "Threlfo",
    "First Name": "Nina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146457": {
    "id": "item_30803",
    "Last Name": "SHEN",
    "First Name": "Zhufeng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146458": {
    "id": "item_28650",
    "Last Name": "Cuadros",
    "First Name": "Eduarda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146459": {
    "id": "item_1229",
    "Last Name": "Klok",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146462": {
    "id": "item_26052",
    "Last Name": "Regler",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146488": {
    "id": "item_1230",
    "Last Name": "Coxall",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146500": {
    "id": "item_26037",
    "Last Name": "Sim",
    "First Name": "Piseth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146539": {
    "id": "item_1228",
    "Last Name": "Blom",
    "First Name": "Francois",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146553": {
    "id": "item_30792",
    "Last Name": "Theovicka",
    "First Name": "Nadya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146554": {
    "id": "item_13744",
    "Last Name": "Gallagher",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146557": {
    "id": "item_28636",
    "Last Name": "Mendoza",
    "First Name": "Philip Alexander",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146568": {
    "id": "item_3086",
    "Last Name": "LaManna",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146596": {
    "id": "item_13749",
    "Last Name": "Graham",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146599": {
    "id": "item_1222",
    "Last Name": "Matejko",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146603": {
    "id": "item_26040",
    "Last Name": "Dunnett",
    "First Name": "Meg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146608": {
    "id": "item_1224",
    "Last Name": "Borg",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146610": {
    "id": "item_30798",
    "Last Name": "CHAN",
    "First Name": "NATALIE TERESA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146615": {
    "id": "item_3077",
    "Last Name": "Mckinney",
    "First Name": "Deidre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146616": {
    "id": "item_28639",
    "Last Name": "Patterson",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146619": {
    "id": "item_13742",
    "Last Name": "Edwards",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146622": {
    "id": "item_1226",
    "Last Name": "Morrison",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146629": {
    "id": "item_3081",
    "Last Name": "Skillington",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146642": {
    "id": "item_30797",
    "Last Name": "Britcher",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146649": {
    "id": "item_13740",
    "Last Name": "Laracy",
    "First Name": "Maggie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146662": {
    "id": "item_1221",
    "Last Name": "Lim",
    "First Name": "Lionel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146667": {
    "id": "item_26015",
    "Last Name": "Sumali",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146673": {
    "id": "item_26028",
    "Last Name": "Lynn",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146679": {
    "id": "item_16224",
    "Last Name": "Moss",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146682": {
    "id": "item_13733",
    "Last Name": "saw",
    "First Name": "jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146683": {
    "id": "item_13741",
    "Last Name": "de Wolf",
    "First Name": "Maisie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146685": {
    "id": "item_26035",
    "Last Name": "Owens",
    "First Name": "Penny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146692": {
    "id": "item_30790",
    "Last Name": "Brosnan",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146706": {
    "id": "item_30789",
    "Last Name": "Teoludzka",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146726": {
    "id": "item_26025",
    "Last Name": "BAHFEN",
    "First Name": "YUSRIA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146728": {
    "id": "item_30784",
    "Last Name": "Yap",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146729": {
    "id": "item_26029",
    "Last Name": "Suobiron",
    "First Name": "Carl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146746": {
    "id": "item_28635",
    "Last Name": "He",
    "First Name": "Jinhao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146751": {
    "id": "item_30779",
    "Last Name": "Huynh",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146757": {
    "id": "item_13737",
    "Last Name": "Nealon",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146761": {
    "id": "item_28624",
    "Last Name": "Irorita",
    "First Name": "Analyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146762": {
    "id": "item_1217",
    "Last Name": "Rattigan",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146782": {
    "id": "item_30786",
    "Last Name": "Batt",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146792": {
    "id": "item_1212",
    "Last Name": "Fosdike",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146794": {
    "id": "item_16223",
    "Last Name": "Angeles",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146810": {
    "id": "item_13728",
    "Last Name": "Douglas",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146818": {
    "id": "item_28632",
    "Last Name": "LANGAN",
    "First Name": "LESLIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146820": {
    "id": "item_13732",
    "Last Name": "Bushell",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146830": {
    "id": "item_30776",
    "Last Name": "Iyer",
    "First Name": "Radhika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146837": {
    "id": "item_28633",
    "Last Name": "Tran",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146841": {
    "id": "item_28630",
    "Last Name": "Turner",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146846": {
    "id": "item_18470",
    "Last Name": "Singh",
    "First Name": "Ravinderbir",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146858": {
    "id": "item_30778",
    "Last Name": "Colville",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146861": {
    "id": "item_16185",
    "Last Name": "Madrid",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146862": {
    "id": "item_13719",
    "Last Name": "Fogarty",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146868": {
    "id": "item_26004",
    "Last Name": "Wong",
    "First Name": "Clementina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146890": {
    "id": "item_1208",
    "Last Name": "Tester",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146896": {
    "id": "item_1201",
    "Last Name": "Cutting",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146900": {
    "id": "item_25971",
    "Last Name": "TAN",
    "First Name": "JEREMY ERN HWEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146912": {
    "id": "item_13724",
    "Last Name": "Jeffs",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146917": {
    "id": "item_26013",
    "Last Name": "Macdonald",
    "First Name": "Lin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146919": {
    "id": "item_30760",
    "Last Name": "Abrenio",
    "First Name": "Glenda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146921": {
    "id": "item_3069",
    "Last Name": "Romanin",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146924": {
    "id": "item_1207",
    "Last Name": "CATALANO",
    "First Name": "DOMENICO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146941": {
    "id": "item_1210",
    "Last Name": "Foreman",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146944": {
    "id": "item_13721",
    "Last Name": "Haller",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146951": {
    "id": "item_3066",
    "Last Name": "Tiemens",
    "First Name": "Magda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146962": {
    "id": "item_26007",
    "Last Name": "Fazakerley",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146972": {
    "id": "item_25882",
    "Last Name": "NOLAN",
    "First Name": "MARK",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146973": {
    "id": "item_26006",
    "Last Name": "Limuil",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146975": {
    "id": "item_25981",
    "Last Name": "Cheney",
    "First Name": "Ella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146979": {
    "id": "item_25995",
    "Last Name": "Holt",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146984": {
    "id": "item_26003",
    "Last Name": "Suesse",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147044": {
    "id": "item_28614",
    "Last Name": "palmer",
    "First Name": "thalia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147053": {
    "id": "item_26002",
    "Last Name": "Wright",
    "First Name": "Elise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147058": {
    "id": "item_13646",
    "Last Name": "Wempy",
    "First Name": "Famal Yurri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147067": {
    "id": "item_25998",
    "Last Name": "Grady",
    "First Name": "Arnett",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147068": {
    "id": "item_13714",
    "Last Name": "Clercin",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147080": {
    "id": "item_30769",
    "Last Name": "Herana",
    "First Name": "Kathryn Chelsea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147081": {
    "id": "item_3059",
    "Last Name": "Crichton",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147084": {
    "id": "item_1199",
    "Last Name": "David Miller",
    "First Name": "David Miller",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147091": {
    "id": "item_30757",
    "Last Name": "Lapuz",
    "First Name": "Jan Arvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147095": {
    "id": "item_30761",
    "Last Name": "Papachristos",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147099": {
    "id": "item_13710",
    "Last Name": "Bromley",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147103": {
    "id": "item_25991",
    "Last Name": "Stafford",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147108": {
    "id": "item_3058",
    "Last Name": "Greening",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147111": {
    "id": "item_25999",
    "Last Name": "Klemp",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147120": {
    "id": "item_30759",
    "Last Name": "Milner",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147125": {
    "id": "item_3060",
    "Last Name": "Smith",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147139": {
    "id": "item_3064",
    "Last Name": "Ceron",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147144": {
    "id": "item_25989",
    "Last Name": "ETCHELL",
    "First Name": "MELANIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147159": {
    "id": "item_28612",
    "Last Name": "Tod",
    "First Name": "Scarlett",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147176": {
    "id": "item_30737",
    "Last Name": "Won",
    "First Name": "Gukbong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147190": {
    "id": "item_30753",
    "Last Name": "Juanico",
    "First Name": "Tanya Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147213": {
    "id": "item_25964",
    "Last Name": "Atkinson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147224": {
    "id": "item_25985",
    "Last Name": "Hill",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147245": {
    "id": "item_3054",
    "Last Name": "McPherson",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147252": {
    "id": "item_30755",
    "Last Name": "Thu",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147254": {
    "id": "item_13690",
    "Last Name": "Fernandez",
    "First Name": "Berta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147255": {
    "id": "item_25972",
    "Last Name": "Wood",
    "First Name": "Daley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147256": {
    "id": "item_13695",
    "Last Name": "Keane",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147257": {
    "id": "item_25967",
    "Last Name": "Sypkes",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147263": {
    "id": "item_25814",
    "Last Name": "Walker-Price",
    "First Name": "Saghe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147266": {
    "id": "item_13708",
    "Last Name": "Mitchell",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147278": {
    "id": "item_13705",
    "Last Name": "Swamy",
    "First Name": "Monish",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147298": {
    "id": "item_30749",
    "Last Name": "Dolahenty",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147321": {
    "id": "item_1188",
    "Last Name": "Dinh",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147324": {
    "id": "item_3056",
    "Last Name": "Middleton",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147356": {
    "id": "item_30745",
    "Last Name": "Dean",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147358": {
    "id": "item_16209",
    "Last Name": "chatpattanasiri",
    "First Name": "surasidh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147369": {
    "id": "item_13701",
    "Last Name": "Hawthorne",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147384": {
    "id": "item_13699",
    "Last Name": "James",
    "First Name": "Eloise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147391": {
    "id": "item_28563",
    "Last Name": "Mnguni",
    "First Name": "Sphephelo Wenzokwakhe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147393": {
    "id": "item_25962",
    "Last Name": "Bishop",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147394": {
    "id": "item_18553",
    "Last Name": "Fabrizio",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147398": {
    "id": "item_30747",
    "Last Name": "Kahl",
    "First Name": "Murt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147401": {
    "id": "item_18511",
    "Last Name": "Inkson",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147405": {
    "id": "item_18552",
    "Last Name": "McMillan",
    "First Name": "Blair",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147411": {
    "id": "item_25945",
    "Last Name": "Sliwinski",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147412": {
    "id": "item_18560",
    "Last Name": "LeRoy",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147415": {
    "id": "item_25940",
    "Last Name": "Shivdasan",
    "First Name": "Vikram",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147416": {
    "id": "item_25953",
    "Last Name": "Robertson",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147422": {
    "id": "item_30746",
    "Last Name": "Stevens",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147423": {
    "id": "item_18558",
    "Last Name": "Carroll",
    "First Name": "Alyssa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147425": {
    "id": "item_3038",
    "Last Name": "LU",
    "First Name": "CHIENWEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147429": {
    "id": "item_18549",
    "Last Name": "Young",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147434": {
    "id": "item_13665",
    "Last Name": "Smith",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147441": {
    "id": "item_18543",
    "Last Name": "Williams",
    "First Name": "Roland",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147452": {
    "id": "item_1172",
    "Last Name": "Provedor",
    "First Name": "Ana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147458": {
    "id": "item_16212",
    "Last Name": "Batbayar",
    "First Name": "Selengee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147467": {
    "id": "item_3040",
    "Last Name": "Ferraro",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147470": {
    "id": "item_28592",
    "Last Name": "Hilakari",
    "First Name": "Maija",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147477": {
    "id": "item_1171",
    "Last Name": "Spiby",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147480": {
    "id": "item_3046",
    "Last Name": "Allan",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147493": {
    "id": "item_30742",
    "Last Name": "Labrado",
    "First Name": "Glenn Gian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147500": {
    "id": "item_25949",
    "Last Name": "Troyahn",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147512": {
    "id": "item_1173",
    "Last Name": "Cassidy",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147536": {
    "id": "item_30735",
    "Last Name": "Castillo",
    "First Name": "Jamie Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147544": {
    "id": "item_26508",
    "Last Name": "Warnock",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147550": {
    "id": "item_13684",
    "Last Name": "Aubrey",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147557": {
    "id": "item_25951",
    "Last Name": "Hurley",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147567": {
    "id": "item_16210",
    "Last Name": "Scheggia",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147569": {
    "id": "item_18517",
    "Last Name": "Zaffina",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147578": {
    "id": "item_30729",
    "Last Name": "Qureshi",
    "First Name": "Amina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147579": {
    "id": "item_18505",
    "Last Name": "Tangalakis",
    "First Name": "Con",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147604": {
    "id": "item_18527",
    "Last Name": "Bayley",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147608": {
    "id": "item_13683",
    "Last Name": "Kak",
    "First Name": "Abdel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147613": {
    "id": "item_28578",
    "Last Name": "Lennon",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147614": {
    "id": "item_25914",
    "Last Name": "Le",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147619": {
    "id": "item_13676",
    "Last Name": "ferlaino",
    "First Name": "robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147621": {
    "id": "item_18514",
    "Last Name": "Gallagher",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147623": {
    "id": "item_25926",
    "Last Name": "Buitendag",
    "First Name": "Merinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147627": {
    "id": "item_18535",
    "Last Name": "Panget",
    "First Name": "Jovian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147635": {
    "id": "item_1129",
    "Last Name": "Sampimon",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147643": {
    "id": "item_1071",
    "Last Name": "Li",
    "First Name": "Gengze",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147655": {
    "id": "item_18512",
    "Last Name": "Tran",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147667": {
    "id": "item_18506",
    "Last Name": "Roberts",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147674": {
    "id": "item_25932",
    "Last Name": "Manducdoc",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147677": {
    "id": "item_18528",
    "Last Name": "Barnes",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147688": {
    "id": "item_30706",
    "Last Name": "Zhang",
    "First Name": "Ningyun Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147698": {
    "id": "item_18513",
    "Last Name": "Abdul Aziz",
    "First Name": "Mohd Hafiz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147703": {
    "id": "item_1434",
    "Last Name": "Smith",
    "First Name": "Felicity",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147706": {
    "id": "item_30684",
    "Last Name": "Ulfa",
    "First Name": "Fathiyya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147708": {
    "id": "item_28576",
    "Last Name": "EDWARDS",
    "First Name": "FIONA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147710": {
    "id": "item_13679",
    "Last Name": "Kennedy",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147713": {
    "id": "item_1159",
    "Last Name": "Yang",
    "First Name": "Di",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147714": {
    "id": "item_18501",
    "Last Name": "Taylor",
    "First Name": "Sian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147720": {
    "id": "item_16207",
    "Last Name": "Sharpe",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147724": {
    "id": "item_1168",
    "Last Name": "Jin",
    "First Name": "Song",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147728": {
    "id": "item_25931",
    "Last Name": "Bray",
    "First Name": "Mardi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147731": {
    "id": "item_18485",
    "Last Name": "Camilo da Silva",
    "First Name": "Tarcius",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147735": {
    "id": "item_13658",
    "Last Name": "Havranek",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147740": {
    "id": "item_28580",
    "Last Name": "Mann",
    "First Name": "Ainsley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147741": {
    "id": "item_3028",
    "Last Name": "Fung",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147743": {
    "id": "item_28560",
    "Last Name": "Grech",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147746": {
    "id": "item_25918",
    "Last Name": "Kurney",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147753": {
    "id": "item_30723",
    "Last Name": "Dominguez",
    "First Name": "Eunice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147754": {
    "id": "item_25825",
    "Last Name": "Corpuz",
    "First Name": "Arnold",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147756": {
    "id": "item_1149",
    "Last Name": "Maher",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147757": {
    "id": "item_25924",
    "Last Name": "Kopano",
    "First Name": "Tshepho Kelly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147758": {
    "id": "item_25923",
    "Last Name": "Juma",
    "First Name": "Ali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147762": {
    "id": "item_18498",
    "Last Name": "Salvador",
    "First Name": "Ethel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147769": {
    "id": "item_25895",
    "Last Name": "Salt",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147787": {
    "id": "item_1126",
    "Last Name": "Bianco",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147795": {
    "id": "item_30710",
    "Last Name": "Wong",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147806": {
    "id": "item_30715",
    "Last Name": "Rasmussen",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147811": {
    "id": "item_16203",
    "Last Name": "Baillie",
    "First Name": "Steele",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147812": {
    "id": "item_18508",
    "Last Name": "PARK",
    "First Name": "SEUNGBIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147827": {
    "id": "item_28568",
    "Last Name": "Bin Abdul Guffoor",
    "First Name": "Muhammad Saifudin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147829": {
    "id": "item_3025",
    "Last Name": "Bell",
    "First Name": "Maggie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147838": {
    "id": "item_18502",
    "Last Name": "Harwood",
    "First Name": "Ngan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147840": {
    "id": "item_16196",
    "Last Name": "Burlayan",
    "First Name": "Arnel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147859": {
    "id": "item_28567",
    "Last Name": "Duffell",
    "First Name": "Penelope",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147867": {
    "id": "item_28565",
    "Last Name": "Bradshaw",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147870": {
    "id": "item_25891",
    "Last Name": "Dwyer",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147872": {
    "id": "item_25908",
    "Last Name": "Bamforth",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147878": {
    "id": "item_18492",
    "Last Name": "Alvis",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147898": {
    "id": "item_28880",
    "Last Name": "Bold",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147921": {
    "id": "item_1136",
    "Last Name": "Coleman",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147929": {
    "id": "item_30707",
    "Last Name": "Comedia",
    "First Name": "Eleuver",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147932": {
    "id": "item_30716",
    "Last Name": "Yang",
    "First Name": "Xiaoyan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147933": {
    "id": "item_30701",
    "Last Name": "Haney",
    "First Name": "Geraldine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147936": {
    "id": "item_3023",
    "Last Name": "MCENTEE",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147938": {
    "id": "item_1146",
    "Last Name": "Balasuriya",
    "First Name": "Kushan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147961": {
    "id": "item_13650",
    "Last Name": "Tank",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147963": {
    "id": "item_25896",
    "Last Name": "nguyen",
    "First Name": "kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147986": {
    "id": "item_3017",
    "Last Name": "Blackman",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148005": {
    "id": "item_13641",
    "Last Name": "Synnott",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148010": {
    "id": "item_1140",
    "Last Name": "Gyton",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148014": {
    "id": "item_18451",
    "Last Name": "Javed",
    "First Name": "Sufian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148017": {
    "id": "item_28549",
    "Last Name": "Marasigan",
    "First Name": "Benedick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148021": {
    "id": "item_25876",
    "Last Name": "Gibson",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148022": {
    "id": "item_18473",
    "Last Name": "Taylor",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148029": {
    "id": "item_30704",
    "Last Name": "Daly",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148041": {
    "id": "item_18453",
    "Last Name": "MCILWRICK",
    "First Name": "SAMANTHA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148044": {
    "id": "item_30685",
    "Last Name": "Kartikaputri",
    "First Name": "Clarensia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148065": {
    "id": "item_3011",
    "Last Name": "Gannon",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148074": {
    "id": "item_13638",
    "Last Name": "Roberts",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148078": {
    "id": "item_3013",
    "Last Name": "Luong",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148080": {
    "id": "item_16194",
    "Last Name": "Lyttle",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148087": {
    "id": "item_18448",
    "Last Name": "Jeffery",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148108": {
    "id": "item_3001",
    "Last Name": "Mistry",
    "First Name": "Heran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148113": {
    "id": "item_18429",
    "Last Name": "Pegg",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148125": {
    "id": "item_30697",
    "Last Name": "Aguilar",
    "First Name": "Jake Louis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148128": {
    "id": "item_18153",
    "Last Name": "McGarry",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148129": {
    "id": "item_18443",
    "Last Name": "McCormack",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148134": {
    "id": "item_1114",
    "Last Name": "Miranda Castro",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148135": {
    "id": "item_18412",
    "Last Name": "Malazarte",
    "First Name": "Jonah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148136": {
    "id": "item_1134",
    "Last Name": "Martin",
    "First Name": "Jimmie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148148": {
    "id": "item_1135",
    "Last Name": "Jackson",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148152": {
    "id": "item_28537",
    "Last Name": "Edwards",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148164": {
    "id": "item_18404",
    "Last Name": "Liu",
    "First Name": "Zhu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148175": {
    "id": "item_1119",
    "Last Name": "Shepherd",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148177": {
    "id": "item_1113",
    "Last Name": "Jenkin",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148181": {
    "id": "item_13614",
    "Last Name": "Liu",
    "First Name": "Jinhui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148185": {
    "id": "item_18446",
    "Last Name": "Solidum",
    "First Name": "Sirdick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148188": {
    "id": "item_25844",
    "Last Name": "Moschella",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148190": {
    "id": "item_18444",
    "Last Name": "Sharrock",
    "First Name": "Taylah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148195": {
    "id": "item_2997",
    "Last Name": "Pillay",
    "First Name": "Vishnu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148197": {
    "id": "item_1109",
    "Last Name": "Wade",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148203": {
    "id": "item_28516",
    "Last Name": "Schmidt",
    "First Name": "Hilary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148207": {
    "id": "item_25782",
    "Last Name": "APRILIA",
    "First Name": "CITRA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148213": {
    "id": "item_25864",
    "Last Name": "Arthur",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148233": {
    "id": "item_1123",
    "Last Name": "De Faria Borges",
    "First Name": "Henrique",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148234": {
    "id": "item_1125",
    "Last Name": "May",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148235": {
    "id": "item_25861",
    "Last Name": "Lao",
    "First Name": "Rowmhar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148245": {
    "id": "item_1130",
    "Last Name": "Astridge",
    "First Name": "Benedicte",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148276": {
    "id": "item_18433",
    "Last Name": "Cameron",
    "First Name": "Nicky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148279": {
    "id": "item_18425",
    "Last Name": "Venn",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148286": {
    "id": "item_25860",
    "Last Name": "Espinosa",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148295": {
    "id": "item_13982",
    "Last Name": "Theodor",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148297": {
    "id": "item_28546",
    "Last Name": "Beart",
    "First Name": "Genevieve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148304": {
    "id": "item_13629",
    "Last Name": "David",
    "First Name": "Kevin keith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148308": {
    "id": "item_25841",
    "Last Name": "White",
    "First Name": "Penny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148310": {
    "id": "item_1120",
    "Last Name": "Black",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148338": {
    "id": "item_25830",
    "Last Name": "Maiden",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148344": {
    "id": "item_28541",
    "Last Name": "Clarissa",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148352": {
    "id": "item_13627",
    "Last Name": "Goodwin",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148360": {
    "id": "item_13483",
    "Last Name": "Dowling",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148361": {
    "id": "item_18393",
    "Last Name": "Loh",
    "First Name": "Chee Kin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148363": {
    "id": "item_13621",
    "Last Name": "Tapia",
    "First Name": "Cristobal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148377": {
    "id": "item_25836",
    "Last Name": "Fasullo",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148379": {
    "id": "item_18414",
    "Last Name": "Tait",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148383": {
    "id": "item_18399",
    "Last Name": "Royce",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148384": {
    "id": "item_18416",
    "Last Name": "Baldori",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148387": {
    "id": "item_18407",
    "Last Name": "Abd Rahman",
    "First Name": "Nurul Azrin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148398": {
    "id": "item_2995",
    "Last Name": "Whelan",
    "First Name": "Niall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148400": {
    "id": "item_30627",
    "Last Name": "Nguyen",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148405": {
    "id": "item_1108",
    "Last Name": "Coric",
    "First Name": "Zdenko",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148410": {
    "id": "item_25817",
    "Last Name": "Hathaway",
    "First Name": "Jemma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148420": {
    "id": "item_18406",
    "Last Name": "McConchie",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148423": {
    "id": "item_13609",
    "Last Name": "Maher",
    "First Name": "Lyndon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148436": {
    "id": "item_1107",
    "Last Name": "Huang",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148440": {
    "id": "item_28525",
    "Last Name": "Murphy",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148453": {
    "id": "item_28529",
    "Last Name": "Fonua",
    "First Name": "Josiah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148454": {
    "id": "item_13559",
    "Last Name": "Villademosa",
    "First Name": "John-Rey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148461": {
    "id": "item_18304",
    "Last Name": "Yabut",
    "First Name": "Donneil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148463": {
    "id": "item_2987",
    "Last Name": "Gonz‡lez Vel‡zquez",
    "First Name": "Herman Rodolfo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148501": {
    "id": "item_18401",
    "Last Name": "Waldron",
    "First Name": "Enda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148507": {
    "id": "item_25811",
    "Last Name": "streuderst",
    "First Name": "johan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148508": {
    "id": "item_26507",
    "Last Name": "Fisher",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148512": {
    "id": "item_18395",
    "Last Name": "Heine",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148513": {
    "id": "item_18384",
    "Last Name": "Hewison",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148529": {
    "id": "item_13601",
    "Last Name": "Heichelbech",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148536": {
    "id": "item_30671",
    "Last Name": "Wang",
    "First Name": "Ziheng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148541": {
    "id": "item_2984",
    "Last Name": "Murillo",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148562": {
    "id": "item_25806",
    "Last Name": "Wardhani",
    "First Name": "Arimurti",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148568": {
    "id": "item_13611",
    "Last Name": "Rayne",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148575": {
    "id": "item_1087",
    "Last Name": "Budd",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148583": {
    "id": "item_2988",
    "Last Name": "Anibaldi",
    "First Name": "Alana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148600": {
    "id": "item_13615",
    "Last Name": "Puchana Cuadros",
    "First Name": "Jessyca Julieth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148610": {
    "id": "item_18381",
    "Last Name": "McNeill",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148615": {
    "id": "item_13613",
    "Last Name": "Chapman",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148635": {
    "id": "item_18356",
    "Last Name": "Denham",
    "First Name": "Clodagh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148636": {
    "id": "item_18374",
    "Last Name": "Spencer",
    "First Name": "Connor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148654": {
    "id": "item_25783",
    "Last Name": "Barber",
    "First Name": "Damian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148658": {
    "id": "item_1095",
    "Last Name": "Sullivan",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148661": {
    "id": "item_30668",
    "Last Name": "Gohard",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148686": {
    "id": "item_25808",
    "Last Name": "Navarrete",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148706": {
    "id": "item_25784",
    "Last Name": "Manson",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148712": {
    "id": "item_18367",
    "Last Name": "Ellery",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148717": {
    "id": "item_1100",
    "Last Name": "Sangwan",
    "First Name": "Anand",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148719": {
    "id": "item_25799",
    "Last Name": "Vargas Duarte",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148722": {
    "id": "item_25786",
    "Last Name": "Gentizon",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148726": {
    "id": "item_25794",
    "Last Name": "Ishor",
    "First Name": "Rambo Nepalayan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148750": {
    "id": "item_25720",
    "Last Name": "Daniel",
    "First Name": "Vivien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148751": {
    "id": "item_18373",
    "Last Name": "England",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148758": {
    "id": "item_1103",
    "Last Name": "Price",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148765": {
    "id": "item_28515",
    "Last Name": "Heah",
    "First Name": "Elwynn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148767": {
    "id": "item_13606",
    "Last Name": "Potgieter",
    "First Name": "Francois",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148772": {
    "id": "item_30658",
    "Last Name": "Hernandez",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148775": {
    "id": "item_18355",
    "Last Name": "Lim",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148783": {
    "id": "item_28506",
    "Last Name": "Kelly",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148794": {
    "id": "item_18343",
    "Last Name": "Daly",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148798": {
    "id": "item_13563",
    "Last Name": "Bendix",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148804": {
    "id": "item_18326",
    "Last Name": "Castillo",
    "First Name": "Hermie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148806": {
    "id": "item_2977",
    "Last Name": "Ly",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148809": {
    "id": "item_18353",
    "Last Name": "Veenhuizen",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148811": {
    "id": "item_25781",
    "Last Name": "Pritchard",
    "First Name": "Kaitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148814": {
    "id": "item_25796",
    "Last Name": "Achary",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148818": {
    "id": "item_18365",
    "Last Name": "Woods",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148830": {
    "id": "item_18352",
    "Last Name": "Callaly",
    "First Name": "Caoimhe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148832": {
    "id": "item_30659",
    "Last Name": "Rumengan",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148837": {
    "id": "item_13588",
    "Last Name": "Miller",
    "First Name": "Nate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148846": {
    "id": "item_18341",
    "Last Name": "Yusti Salazar",
    "First Name": "Dylan camilo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148856": {
    "id": "item_30656",
    "Last Name": "Chan",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148857": {
    "id": "item_18319",
    "Last Name": "Lane",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148865": {
    "id": "item_16137",
    "Last Name": "Rendell",
    "First Name": "Kara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148867": {
    "id": "item_18351",
    "Last Name": "Lo",
    "First Name": "Chi Pang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148870": {
    "id": "item_16164",
    "Last Name": "Dyball",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148877": {
    "id": "item_18359",
    "Last Name": "Vadlamudi",
    "First Name": "Lakshmi Dheeraj",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148886": {
    "id": "item_13596",
    "Last Name": "Romanov",
    "First Name": "Nikolai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148896": {
    "id": "item_13578",
    "Last Name": "Gallagher",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148902": {
    "id": "item_1092",
    "Last Name": "Whitehouse",
    "First Name": "Marshall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148905": {
    "id": "item_25769",
    "Last Name": "Caraballo",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148916": {
    "id": "item_25758",
    "Last Name": "Cheung",
    "First Name": "Ka Wai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148922": {
    "id": "item_13574",
    "Last Name": "McInerney",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148927": {
    "id": "item_26413",
    "Last Name": "Lucio",
    "First Name": "Marlo Alfonso",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148929": {
    "id": "item_13575",
    "Last Name": "Menezes",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148931": {
    "id": "item_18340",
    "Last Name": "Callow",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148937": {
    "id": "item_18160",
    "Last Name": "Dunlop",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148941": {
    "id": "item_13584",
    "Last Name": "Chazan",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148947": {
    "id": "item_30553",
    "Last Name": "Brinkmann",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148951": {
    "id": "item_18314",
    "Last Name": "Zhang",
    "First Name": "Zhongtao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148964": {
    "id": "item_2960",
    "Last Name": "Quarterman",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148967": {
    "id": "item_18328",
    "Last Name": "ZHANG",
    "First Name": "YONGCHUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148968": {
    "id": "item_18236",
    "Last Name": "Arena",
    "First Name": "Eva",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148973": {
    "id": "item_18338",
    "Last Name": "Moss",
    "First Name": "Indya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148979": {
    "id": "item_16173",
    "Last Name": "Miles",
    "First Name": "Allan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148981": {
    "id": "item_25651",
    "Last Name": "peatrie",
    "First Name": "carmel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149004": {
    "id": "item_2962",
    "Last Name": "Lew Ton",
    "First Name": "Kate",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149011": {
    "id": "item_30642",
    "Last Name": "Jones",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149015": {
    "id": "item_30636",
    "Last Name": "Bryant",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149037": {
    "id": "item_30640",
    "Last Name": "Ryan",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149050": {
    "id": "item_25757",
    "Last Name": "Wu",
    "First Name": "Di",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149053": {
    "id": "item_13580",
    "Last Name": "Hutton",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149066": {
    "id": "item_1080",
    "Last Name": "Manning",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149077": {
    "id": "item_25761",
    "Last Name": "James",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149081": {
    "id": "item_25753",
    "Last Name": "Kiss",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149095": {
    "id": "item_18311",
    "Last Name": "Wildman",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149100": {
    "id": "item_25749",
    "Last Name": "Li",
    "First Name": "Kejin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149101": {
    "id": "item_18287",
    "Last Name": "Bellico",
    "First Name": "Ana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149107": {
    "id": "item_25739",
    "Last Name": "Li",
    "First Name": "Angel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149108": {
    "id": "item_1077",
    "Last Name": "Acord",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149112": {
    "id": "item_18308",
    "Last Name": "Carter",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149161": {
    "id": "item_30608",
    "Last Name": "Rajakaruna",
    "First Name": "Mohan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149171": {
    "id": "item_13561",
    "Last Name": "Nguyen",
    "First Name": "Lanh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149179": {
    "id": "item_18293",
    "Last Name": "Davies",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149180": {
    "id": "item_2953",
    "Last Name": "Woodward",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149182": {
    "id": "item_28477",
    "Last Name": "Luna",
    "First Name": "Reggine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149189": {
    "id": "item_25722",
    "Last Name": "McNair",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149202": {
    "id": "item_18034",
    "Last Name": "Cass-Dunbar",
    "First Name": "Talon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149204": {
    "id": "item_13567",
    "Last Name": "Geoffroy",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149209": {
    "id": "item_25752",
    "Last Name": "dodsworth",
    "First Name": "leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149223": {
    "id": "item_18290",
    "Last Name": "Milner",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149230": {
    "id": "item_1070",
    "Last Name": "McKee",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149233": {
    "id": "item_1064",
    "Last Name": "Mecklemburg Galantini",
    "First Name": "Hanzel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149237": {
    "id": "item_18244",
    "Last Name": "Wang",
    "First Name": "Jing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149240": {
    "id": "item_25746",
    "Last Name": "Lao",
    "First Name": "Danielle Alexis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149247": {
    "id": "item_18302",
    "Last Name": "TAM",
    "First Name": "KA MING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149248": {
    "id": "item_13552",
    "Last Name": "Stevenson",
    "First Name": "Rheagan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149251": {
    "id": "item_18299",
    "Last Name": "Nicholson",
    "First Name": "Hunter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149254": {
    "id": "item_25726",
    "Last Name": "Shannon",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149261": {
    "id": "item_16166",
    "Last Name": "Anonymous",
    "First Name": "Anonymous",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149262": {
    "id": "item_2947",
    "Last Name": "Dam",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149268": {
    "id": "item_1026",
    "Last Name": "Giraldo Zapata",
    "First Name": "Daniel Mauricio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149269": {
    "id": "item_18296",
    "Last Name": "Patton",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149271": {
    "id": "item_13555",
    "Last Name": "McKinlay",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149272": {
    "id": "item_18305",
    "Last Name": "Lim",
    "First Name": "Gayle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149273": {
    "id": "item_13557",
    "Last Name": "He",
    "First Name": "Binwu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149280": {
    "id": "item_30616",
    "Last Name": "Rafol",
    "First Name": "Marl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149281": {
    "id": "item_2954",
    "Last Name": "Belcher",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149282": {
    "id": "item_13542",
    "Last Name": "Gilhooley",
    "First Name": "Aislinn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149286": {
    "id": "item_26506",
    "Last Name": "Ball",
    "First Name": "Ian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149287": {
    "id": "item_13560",
    "Last Name": "Clark",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149296": {
    "id": "item_18263",
    "Last Name": "Baldwin",
    "First Name": "Luisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149299": {
    "id": "item_30615",
    "Last Name": "Castellon",
    "First Name": "Mary rose angelica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149301": {
    "id": "item_25732",
    "Last Name": "Becher",
    "First Name": "Katja",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149312": {
    "id": "item_1069",
    "Last Name": "Mark",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149322": {
    "id": "item_1061",
    "Last Name": "Matthews",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149323": {
    "id": "item_18283",
    "Last Name": "SPROAT",
    "First Name": "NEIL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149332": {
    "id": "item_30617",
    "Last Name": "Conn",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149339": {
    "id": "item_2950",
    "Last Name": "Mohamad",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149341": {
    "id": "item_1057",
    "Last Name": "Than",
    "First Name": "Mawi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149344": {
    "id": "item_28491",
    "Last Name": "Lobe",
    "First Name": "Mia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149349": {
    "id": "item_13550",
    "Last Name": "Moseby",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149350": {
    "id": "item_18279",
    "Last Name": "Stott",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149351": {
    "id": "item_30604",
    "Last Name": "Ottinger",
    "First Name": "Mason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149363": {
    "id": "item_25708",
    "Last Name": "Gabe",
    "First Name": "Jeri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149366": {
    "id": "item_18284",
    "Last Name": "Highberger",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149367": {
    "id": "item_28431",
    "Last Name": "Boehm",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149368": {
    "id": "item_1059",
    "Last Name": "Best",
    "First Name": "Travis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149369": {
    "id": "item_1044",
    "Last Name": "Donila",
    "First Name": "Maricar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149388": {
    "id": "item_18268",
    "Last Name": "Yong",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149395": {
    "id": "item_30589",
    "Last Name": "Ordonio",
    "First Name": "Melchor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149398": {
    "id": "item_25717",
    "Last Name": "Travers",
    "First Name": "Destyni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149399": {
    "id": "item_28487",
    "Last Name": "Downey",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149408": {
    "id": "item_25701",
    "Last Name": "Salt",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149419": {
    "id": "item_18273",
    "Last Name": "Manser",
    "First Name": "Meiles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149421": {
    "id": "item_18275",
    "Last Name": "Woodruff",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149428": {
    "id": "item_30597",
    "Last Name": "Khalili",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149430": {
    "id": "item_18272",
    "Last Name": "Gerber",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149436": {
    "id": "item_28879",
    "Last Name": "Sinclair",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149475": {
    "id": "item_18246",
    "Last Name": "Dolman",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149477": {
    "id": "item_18270",
    "Last Name": "Morris",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149480": {
    "id": "item_25695",
    "Last Name": "Tesoro",
    "First Name": "James Russells",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149482": {
    "id": "item_28483",
    "Last Name": "Ter",
    "First Name": "Lindy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149485": {
    "id": "item_13414",
    "Last Name": "Kwon",
    "First Name": "Yoon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149497": {
    "id": "item_30595",
    "Last Name": "Jaroenpitpongsa",
    "First Name": "Thammanoon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149507": {
    "id": "item_30559",
    "Last Name": "Corpuz",
    "First Name": "Jen Cloei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149509": {
    "id": "item_30590",
    "Last Name": "Begum",
    "First Name": "Roszana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149537": {
    "id": "item_13541",
    "Last Name": "Tetof",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149540": {
    "id": "item_30598",
    "Last Name": "Gurney",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149543": {
    "id": "item_28486",
    "Last Name": "Sesta Jacobs",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149547": {
    "id": "item_2937",
    "Last Name": "Irvine",
    "First Name": "Narrischka",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149557": {
    "id": "item_18227",
    "Last Name": "Hill",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149559": {
    "id": "item_30599",
    "Last Name": "Prudlik",
    "First Name": "Sabrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149561": {
    "id": "item_30568",
    "Last Name": "Sanchez Barradas",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149568": {
    "id": "item_16163",
    "Last Name": "Meddings",
    "First Name": "Trina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149578": {
    "id": "item_28485",
    "Last Name": "White",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149582": {
    "id": "item_2926",
    "Last Name": "Chatham",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149599": {
    "id": "item_25680",
    "Last Name": "Duncan",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149610": {
    "id": "item_28479",
    "Last Name": "Morgan",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149611": {
    "id": "item_5723",
    "Last Name": "Gonzalez Garza",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149614": {
    "id": "item_5732",
    "Last Name": "Mauro",
    "First Name": "Carter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149617": {
    "id": "item_18229",
    "Last Name": "Xu",
    "First Name": "Eldon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149619": {
    "id": "item_1048",
    "Last Name": "Grant",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149626": {
    "id": "item_28480",
    "Last Name": "Michael",
    "First Name": "Helena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149628": {
    "id": "item_5741",
    "Last Name": "Heilig",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149634": {
    "id": "item_13535",
    "Last Name": "Nathan",
    "First Name": "Ayal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149640": {
    "id": "item_16158",
    "Last Name": "Price",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149643": {
    "id": "item_16162",
    "Last Name": "Plumb",
    "First Name": "Katerina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149645": {
    "id": "item_25682",
    "Last Name": "Reyes",
    "First Name": "Jose Meola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149646": {
    "id": "item_5742",
    "Last Name": "Gonzalez",
    "First Name": "Juan P",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149655": {
    "id": "item_18237",
    "Last Name": "Lienert",
    "First Name": "Heath",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149657": {
    "id": "item_13539",
    "Last Name": "McKnight",
    "First Name": "Kirstin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149662": {
    "id": "item_30557",
    "Last Name": "Parry",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149665": {
    "id": "item_5697",
    "Last Name": "Oloyede",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149669": {
    "id": "item_18214",
    "Last Name": "llenos",
    "First Name": "ricci",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149673": {
    "id": "item_25684",
    "Last Name": "Gooch",
    "First Name": "Cushla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149676": {
    "id": "item_18253",
    "Last Name": "Dwyer",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149677": {
    "id": "item_18234",
    "Last Name": "Wall",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149683": {
    "id": "item_2928",
    "Last Name": "Gibbons",
    "First Name": "Jonty",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149687": {
    "id": "item_30558",
    "Last Name": "ALLAN",
    "First Name": "jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149691": {
    "id": "item_5735",
    "Last Name": "Hunziker",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149694": {
    "id": "item_5714",
    "Last Name": "Liwag",
    "First Name": "Jesther Kim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149700": {
    "id": "item_30554",
    "Last Name": "Barrett",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149709": {
    "id": "item_1045",
    "Last Name": "Bretz",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149711": {
    "id": "item_18196",
    "Last Name": "Armstrong",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149714": {
    "id": "item_30561",
    "Last Name": "Aala",
    "First Name": "Hari Chandra Reddy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149739": {
    "id": "item_30580",
    "Last Name": "Dang",
    "First Name": "An",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149748": {
    "id": "item_5728",
    "Last Name": "Graham",
    "First Name": "Caity",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149757": {
    "id": "item_18211",
    "Last Name": "Coram",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149761": {
    "id": "item_1037",
    "Last Name": "Aldgate",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149762": {
    "id": "item_18225",
    "Last Name": "Renkin",
    "First Name": "Maeva",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149765": {
    "id": "item_30587",
    "Last Name": "Hendley",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149766": {
    "id": "item_18219",
    "Last Name": "Matthews",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149774": {
    "id": "item_5710",
    "Last Name": "Dalziel",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149787": {
    "id": "item_30575",
    "Last Name": "Roberts",
    "First Name": "Roxanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149789": {
    "id": "item_16157",
    "Last Name": "Given",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149792": {
    "id": "item_5729",
    "Last Name": "Roux",
    "First Name": "Lenid",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149798": {
    "id": "item_13460",
    "Last Name": "McGill",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149803": {
    "id": "item_18183",
    "Last Name": "Smith",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149805": {
    "id": "item_16143",
    "Last Name": "Latham",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149806": {
    "id": "item_5716",
    "Last Name": "Song",
    "First Name": "Yinghan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149813": {
    "id": "item_16155",
    "Last Name": "Broederlow",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149815": {
    "id": "item_18148",
    "Last Name": "Parayno",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149825": {
    "id": "item_18157",
    "Last Name": "Marcaida",
    "First Name": "Ana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149832": {
    "id": "item_30539",
    "Last Name": "Sharperson",
    "First Name": "Denise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149834": {
    "id": "item_18216",
    "Last Name": "Lo",
    "First Name": "Li-chia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149844": {
    "id": "item_5700",
    "Last Name": "Qin",
    "First Name": "Chunrong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149849": {
    "id": "item_18210",
    "Last Name": "Allen",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149855": {
    "id": "item_18205",
    "Last Name": "Robertson",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149860": {
    "id": "item_1027",
    "Last Name": "Hick",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149864": {
    "id": "item_1038",
    "Last Name": "Deng",
    "First Name": "Ruyun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149872": {
    "id": "item_13484",
    "Last Name": "Tushar",
    "First Name": "Abdullah Al",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149878": {
    "id": "item_30562",
    "Last Name": "Li",
    "First Name": "Xiaojing(Ivy)",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149883": {
    "id": "item_30565",
    "Last Name": "Arde",
    "First Name": "Alerick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149885": {
    "id": "item_18213",
    "Last Name": "Chick",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149888": {
    "id": "item_18207",
    "Last Name": "Tan",
    "First Name": "Byron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149903": {
    "id": "item_18194",
    "Last Name": "Ong",
    "First Name": "Jacson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149905": {
    "id": "item_30572",
    "Last Name": "Dover",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149906": {
    "id": "item_13500",
    "Last Name": "Agius",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149914": {
    "id": "item_13496",
    "Last Name": "Message",
    "First Name": "Roxann",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149919": {
    "id": "item_1034",
    "Last Name": "Nedovic",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149926": {
    "id": "item_18200",
    "Last Name": "Kamei",
    "First Name": "Fumihiko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149929": {
    "id": "item_25654",
    "Last Name": "Antonio",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149941": {
    "id": "item_13495",
    "Last Name": "Stott",
    "First Name": "Molly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149945": {
    "id": "item_25660",
    "Last Name": "Tait",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149950": {
    "id": "item_18178",
    "Last Name": "O'Connell",
    "First Name": "Ruairi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149951": {
    "id": "item_18201",
    "Last Name": "Phillips",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149954": {
    "id": "item_5699",
    "Last Name": "Macdonald",
    "First Name": "Nat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149971": {
    "id": "item_5687",
    "Last Name": "Masterson",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149974": {
    "id": "item_25649",
    "Last Name": "Hackney",
    "First Name": "Logan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149975": {
    "id": "item_5661",
    "Last Name": "Gines",
    "First Name": "Junaline",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149989": {
    "id": "item_28452",
    "Last Name": "Ogenche",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149996": {
    "id": "item_18156",
    "Last Name": "Li",
    "First Name": "Siran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150011": {
    "id": "item_18170",
    "Last Name": "Pogson",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150014": {
    "id": "item_28424",
    "Last Name": "Bodycoat",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150034": {
    "id": "item_2916",
    "Last Name": "Hiranuma",
    "First Name": "Taro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150036": {
    "id": "item_30533",
    "Last Name": "Levana",
    "First Name": "Eril",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150049": {
    "id": "item_1015",
    "Last Name": "GOMEZ CAPELLIN",
    "First Name": "OMAR JOSE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150052": {
    "id": "item_13491",
    "Last Name": "Yates",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150062": {
    "id": "item_16149",
    "Last Name": "D'Silva",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150068": {
    "id": "item_16145",
    "Last Name": "Sanderson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150072": {
    "id": "item_13502",
    "Last Name": "Andrews",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150076": {
    "id": "item_18172",
    "Last Name": "Jollow",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150084": {
    "id": "item_18166",
    "Last Name": "Keall",
    "First Name": "Azrielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150100": {
    "id": "item_5692",
    "Last Name": "Undy",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150103": {
    "id": "item_13497",
    "Last Name": "Arceo",
    "First Name": "Grace Perez",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150108": {
    "id": "item_5577",
    "Last Name": "Chan",
    "First Name": "Chi lap",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150114": {
    "id": "item_18168",
    "Last Name": "Tran",
    "First Name": "Thinh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150127": {
    "id": "item_28439",
    "Last Name": "Yun",
    "First Name": "Kangwoo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150135": {
    "id": "item_18125",
    "Last Name": "Villanueva",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150153": {
    "id": "item_2869",
    "Last Name": "McGlade",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150161": {
    "id": "item_30529",
    "Last Name": "Kettle",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150167": {
    "id": "item_5675",
    "Last Name": "Spiers",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150169": {
    "id": "item_1018",
    "Last Name": "Sinclair",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150170": {
    "id": "item_30518",
    "Last Name": "Hilario",
    "First Name": "Rachel Hannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150174": {
    "id": "item_18159",
    "Last Name": "Lui",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150200": {
    "id": "item_30512",
    "Last Name": "Bautista",
    "First Name": "Vince Justin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150204": {
    "id": "item_2919",
    "Last Name": "Hazzard",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150209": {
    "id": "item_5678",
    "Last Name": "Auld",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150210": {
    "id": "item_18144",
    "Last Name": "McCulloch",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150233": {
    "id": "item_1013",
    "Last Name": "Turpie",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150255": {
    "id": "item_18086",
    "Last Name": "List",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150262": {
    "id": "item_5639",
    "Last Name": "Marcaida",
    "First Name": "Arkhe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150263": {
    "id": "item_18118",
    "Last Name": "Rios",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150267": {
    "id": "item_1006",
    "Last Name": "Folkard",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150288": {
    "id": "item_2918",
    "Last Name": "Whitty",
    "First Name": "Evan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150302": {
    "id": "item_13455",
    "Last Name": "Hoffman",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150303": {
    "id": "item_988",
    "Last Name": "Wynn",
    "First Name": "Rolf",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150308": {
    "id": "item_18079",
    "Last Name": "Cortes Sanchez",
    "First Name": "Marcela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150309": {
    "id": "item_18103",
    "Last Name": "Lynch",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150314": {
    "id": "item_13479",
    "Last Name": "White",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150315": {
    "id": "item_1007",
    "Last Name": "Partland",
    "First Name": "Ned",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150320": {
    "id": "item_1433",
    "Last Name": "Li",
    "First Name": "Yang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150325": {
    "id": "item_5650",
    "Last Name": "Magno",
    "First Name": "Ebanjemin Jannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150328": {
    "id": "item_30525",
    "Last Name": "Boevink",
    "First Name": "Eleisha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150351": {
    "id": "item_13478",
    "Last Name": "Lowry",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150352": {
    "id": "item_2915",
    "Last Name": "McLeod",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150370": {
    "id": "item_18119",
    "Last Name": "Dains",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150379": {
    "id": "item_18112",
    "Last Name": "Busch",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150387": {
    "id": "item_13486",
    "Last Name": "Millard",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150391": {
    "id": "item_18041",
    "Last Name": "Do",
    "First Name": "Long",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150394": {
    "id": "item_17941",
    "Last Name": "kerr",
    "First Name": "dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150397": {
    "id": "item_2904",
    "Last Name": "Zhang",
    "First Name": "Yuting",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150399": {
    "id": "item_18088",
    "Last Name": "Vekaria",
    "First Name": "Aksay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150418": {
    "id": "item_30492",
    "Last Name": "Jones",
    "First Name": "Anne-Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150438": {
    "id": "item_2908",
    "Last Name": "Wittison-Southern",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150456": {
    "id": "item_5662",
    "Last Name": "Loxton",
    "First Name": "Helen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150462": {
    "id": "item_28437",
    "Last Name": "Harley Jr",
    "First Name": "Quincy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150464": {
    "id": "item_997",
    "Last Name": "Setiawan",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150465": {
    "id": "item_30506",
    "Last Name": "Ramsden",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150466": {
    "id": "item_16133",
    "Last Name": "Besas",
    "First Name": "Cherry Jene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150467": {
    "id": "item_5652",
    "Last Name": "Nam",
    "First Name": "Sinwu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150470": {
    "id": "item_5663",
    "Last Name": "Gurner",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150473": {
    "id": "item_18097",
    "Last Name": "Pilartha",
    "First Name": "I ketut",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150476": {
    "id": "item_18042",
    "Last Name": "Zhang",
    "First Name": "xuesong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150489": {
    "id": "item_2901",
    "Last Name": "Leonard",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150490": {
    "id": "item_2886",
    "Last Name": "BAZIN",
    "First Name": "ALEXANDER",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150493": {
    "id": "item_16136",
    "Last Name": "Tsui",
    "First Name": "Charmian Bernardine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150502": {
    "id": "item_5548",
    "Last Name": "Cueva",
    "First Name": "Rey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150503": {
    "id": "item_13476",
    "Last Name": "John",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150520": {
    "id": "item_1003",
    "Last Name": "Kegg",
    "First Name": "Saxon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150522": {
    "id": "item_2898",
    "Last Name": "Jack",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150526": {
    "id": "item_1001",
    "Last Name": "Markulija",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150540": {
    "id": "item_5656",
    "Last Name": "Oraison",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150550": {
    "id": "item_30477",
    "Last Name": "Clinch",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150556": {
    "id": "item_5643",
    "Last Name": "Arias",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150568": {
    "id": "item_18080",
    "Last Name": "WAN",
    "First Name": "RAY CHI-HO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150584": {
    "id": "item_2895",
    "Last Name": "Bailey",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150585": {
    "id": "item_2892",
    "Last Name": "Presser",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150592": {
    "id": "item_5642",
    "Last Name": "Branch",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150596": {
    "id": "item_5657",
    "Last Name": "Jones",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150603": {
    "id": "item_28405",
    "Last Name": "Garcia",
    "First Name": "Romuald Jozep De Los Trinos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150607": {
    "id": "item_998",
    "Last Name": "King",
    "First Name": "Jaxon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150627": {
    "id": "item_13464",
    "Last Name": "Brown",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150629": {
    "id": "item_2888",
    "Last Name": "Valis",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150634": {
    "id": "item_5651",
    "Last Name": "Geason",
    "First Name": "Albert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150635": {
    "id": "item_2894",
    "Last Name": "Sbrugnera",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150637": {
    "id": "item_18081",
    "Last Name": "Ryan",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150652": {
    "id": "item_28403",
    "Last Name": "Bhattrai",
    "First Name": "Vijay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150657": {
    "id": "item_13470",
    "Last Name": "Werror",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150667": {
    "id": "item_18071",
    "Last Name": "Neish",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150671": {
    "id": "item_30501",
    "Last Name": "Brydges",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150683": {
    "id": "item_18062",
    "Last Name": "Barrett",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150684": {
    "id": "item_981",
    "Last Name": "Jittriphot",
    "First Name": "Paniti",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150689": {
    "id": "item_13468",
    "Last Name": "Gunstone",
    "First Name": "Ally",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150693": {
    "id": "item_5631",
    "Last Name": "Nguyen",
    "First Name": "Phan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150694": {
    "id": "item_28430",
    "Last Name": "Blackwood",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150706": {
    "id": "item_28420",
    "Last Name": "Webb-Johnson",
    "First Name": "Viona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150710": {
    "id": "item_5623",
    "Last Name": "Daniels",
    "First Name": "Neville",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150730": {
    "id": "item_5565",
    "Last Name": "Marchetti",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150731": {
    "id": "item_5624",
    "Last Name": "Kelly",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150734": {
    "id": "item_17866",
    "Last Name": "Rosaia",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150741": {
    "id": "item_18033",
    "Last Name": "Wuolanne",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150752": {
    "id": "item_16121",
    "Last Name": "Luo",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150757": {
    "id": "item_5634",
    "Last Name": "Ketelbey",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150761": {
    "id": "item_13440",
    "Last Name": "Squire",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150767": {
    "id": "item_983",
    "Last Name": "Elderton",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150777": {
    "id": "item_5622",
    "Last Name": "Pommer",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150780": {
    "id": "item_18061",
    "Last Name": "Newall",
    "First Name": "Austin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150786": {
    "id": "item_2887",
    "Last Name": "Ramaseshadri",
    "First Name": "Sitaraman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150787": {
    "id": "item_30450",
    "Last Name": "Henderson",
    "First Name": "Priscilla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150791": {
    "id": "item_18074",
    "Last Name": "Nairn",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150794": {
    "id": "item_18060",
    "Last Name": "Lawrence",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150806": {
    "id": "item_5627",
    "Last Name": "Partridge",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150811": {
    "id": "item_30493",
    "Last Name": "Cisternas",
    "First Name": "Anahis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150813": {
    "id": "item_18059",
    "Last Name": "Novacek",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150822": {
    "id": "item_30488",
    "Last Name": "Tan",
    "First Name": "Lizette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150825": {
    "id": "item_18051",
    "Last Name": "Calvert",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150828": {
    "id": "item_2891",
    "Last Name": "Kennedy",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150832": {
    "id": "item_30479",
    "Last Name": "Pacheco",
    "First Name": "Fernanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150833": {
    "id": "item_5621",
    "Last Name": "Myhill",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150835": {
    "id": "item_974",
    "Last Name": "Cluff",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150852": {
    "id": "item_30455",
    "Last Name": "Lee",
    "First Name": "Jerrica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150867": {
    "id": "item_978",
    "Last Name": "Payne-Dearberg",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150872": {
    "id": "item_979",
    "Last Name": "Richards",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150874": {
    "id": "item_28419",
    "Last Name": "OÕHara",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150877": {
    "id": "item_18003",
    "Last Name": "Lee",
    "First Name": "Peng Han",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150881": {
    "id": "item_14053",
    "Last Name": "Cervantes Moreno",
    "First Name": "Gilberto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150883": {
    "id": "item_5614",
    "Last Name": "Palmer",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150885": {
    "id": "item_28412",
    "Last Name": "Qin",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150889": {
    "id": "item_5608",
    "Last Name": "Sinkovich",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150890": {
    "id": "item_18010",
    "Last Name": "Letten",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150892": {
    "id": "item_18050",
    "Last Name": "Drayton",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150896": {
    "id": "item_966",
    "Last Name": "Symons",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150897": {
    "id": "item_18054",
    "Last Name": "Hughes",
    "First Name": "Portia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150915": {
    "id": "item_2879",
    "Last Name": "Hogg",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150919": {
    "id": "item_30475",
    "Last Name": "Greer",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150927": {
    "id": "item_30485",
    "Last Name": "Jeon",
    "First Name": "Hyunwoo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150945": {
    "id": "item_977",
    "Last Name": "Chinotto",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150962": {
    "id": "item_18027",
    "Last Name": "O'Loughlin",
    "First Name": "Trent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150966": {
    "id": "item_2871",
    "Last Name": "SHAN",
    "First Name": "JUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150972": {
    "id": "item_13447",
    "Last Name": "Harrison",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150974": {
    "id": "item_17970",
    "Last Name": "Reoch",
    "First Name": "Holly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150979": {
    "id": "item_13444",
    "Last Name": "Morgan",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150990": {
    "id": "item_16120",
    "Last Name": "Collins",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150994": {
    "id": "item_16335",
    "Last Name": "Hunt",
    "First Name": "Shyon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151001": {
    "id": "item_18025",
    "Last Name": "Rawlinson",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151009": {
    "id": "item_5606",
    "Last Name": "Tangalakis",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151011": {
    "id": "item_5607",
    "Last Name": "Teoh",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151017": {
    "id": "item_18028",
    "Last Name": "Baez",
    "First Name": "Eleuterio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151038": {
    "id": "item_18008",
    "Last Name": "Edwards",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151045": {
    "id": "item_28363",
    "Last Name": "Simpson",
    "First Name": "Campbell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151064": {
    "id": "item_28400",
    "Last Name": "Croft",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151066": {
    "id": "item_28407",
    "Last Name": "Lawn",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151070": {
    "id": "item_18014",
    "Last Name": "Simpson",
    "First Name": "Ewan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151081": {
    "id": "item_18017",
    "Last Name": "Wilmot",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151085": {
    "id": "item_13441",
    "Last Name": "Chang",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151087": {
    "id": "item_5473",
    "Last Name": "malinao",
    "First Name": "marlon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151089": {
    "id": "item_30474",
    "Last Name": "Ferreira",
    "First Name": "Corentin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151108": {
    "id": "item_30459",
    "Last Name": "ZHANG",
    "First Name": "WEIMING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151123": {
    "id": "item_5585",
    "Last Name": "Langenberg",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151124": {
    "id": "item_5587",
    "Last Name": "Byrne",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151125": {
    "id": "item_5591",
    "Last Name": "Finnegan",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151126": {
    "id": "item_5589",
    "Last Name": "Bedelis",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151128": {
    "id": "item_18022",
    "Last Name": "PUTRI",
    "First Name": "DEVITA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151136": {
    "id": "item_17946",
    "Last Name": "Palmeri",
    "First Name": "Angel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151155": {
    "id": "item_18012",
    "Last Name": "Nguyen",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151159": {
    "id": "item_5522",
    "Last Name": "Mitchell",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151162": {
    "id": "item_2870",
    "Last Name": "Lloyd",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151165": {
    "id": "item_962",
    "Last Name": "Bromell",
    "First Name": "Archie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151179": {
    "id": "item_961",
    "Last Name": "Kwong",
    "First Name": "Edmund",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151184": {
    "id": "item_955",
    "Last Name": "Morris",
    "First Name": "Graham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151187": {
    "id": "item_18015",
    "Last Name": "Hernandez",
    "First Name": "Renee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151190": {
    "id": "item_18000",
    "Last Name": "Vaughan",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151191": {
    "id": "item_28396",
    "Last Name": "Wade",
    "First Name": "Rosemarie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151193": {
    "id": "item_2863",
    "Last Name": "SILIPHAYVANH",
    "First Name": "Manoly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151226": {
    "id": "item_5557",
    "Last Name": "Rhodes",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151227": {
    "id": "item_958",
    "Last Name": "Kuzminov",
    "First Name": "Yury",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151232": {
    "id": "item_17991",
    "Last Name": "O'Connell",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151242": {
    "id": "item_5573",
    "Last Name": "Leembruggen",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151251": {
    "id": "item_17997",
    "Last Name": "Anderson",
    "First Name": "Bec",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151253": {
    "id": "item_17968",
    "Last Name": "Manuel",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151263": {
    "id": "item_30444",
    "Last Name": "Kim",
    "First Name": "Gyeongmin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151269": {
    "id": "item_13430",
    "Last Name": "Dudina",
    "First Name": "Lidia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151271": {
    "id": "item_17959",
    "Last Name": "Moreil",
    "First Name": "Benedicte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151274": {
    "id": "item_5575",
    "Last Name": "Cejudo",
    "First Name": "Briseily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151286": {
    "id": "item_17985",
    "Last Name": "Clements",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151295": {
    "id": "item_17976",
    "Last Name": "Gibson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151296": {
    "id": "item_957",
    "Last Name": "Walding",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151299": {
    "id": "item_13434",
    "Last Name": "Fog",
    "First Name": "Sienna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151301": {
    "id": "item_17961",
    "Last Name": "FRANKLIN",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151308": {
    "id": "item_28393",
    "Last Name": "Fong",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151311": {
    "id": "item_14052",
    "Last Name": "KWON",
    "First Name": "SEHYUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151312": {
    "id": "item_30451",
    "Last Name": "Polotan",
    "First Name": "Beatriz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151327": {
    "id": "item_13424",
    "Last Name": "Tucker",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151332": {
    "id": "item_3264",
    "Last Name": "Whalan",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151337": {
    "id": "item_30457",
    "Last Name": "Gough",
    "First Name": "Byron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151348": {
    "id": "item_17982",
    "Last Name": "Broz",
    "First Name": "Janet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151363": {
    "id": "item_30440",
    "Last Name": "Huynh",
    "First Name": "Gina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151368": {
    "id": "item_13311",
    "Last Name": "Jin",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151370": {
    "id": "item_17978",
    "Last Name": "Pili",
    "First Name": "Jigo Rousel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151372": {
    "id": "item_950",
    "Last Name": "Lee",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151377": {
    "id": "item_30437",
    "Last Name": "Wendebourg",
    "First Name": "Magali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151383": {
    "id": "item_16099",
    "Last Name": "Molefe",
    "First Name": "Aweditswe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151386": {
    "id": "item_13416",
    "Last Name": "Lee",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151396": {
    "id": "item_953",
    "Last Name": "Lyons",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151402": {
    "id": "item_951",
    "Last Name": "Janz",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151410": {
    "id": "item_17963",
    "Last Name": "Roux",
    "First Name": "Marna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151416": {
    "id": "item_5545",
    "Last Name": "Monda",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151430": {
    "id": "item_2857",
    "Last Name": "Malone",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151433": {
    "id": "item_13367",
    "Last Name": "Sahem",
    "First Name": "Faris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151450": {
    "id": "item_5528",
    "Last Name": "Ganko",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151457": {
    "id": "item_5563",
    "Last Name": "Cole",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151462": {
    "id": "item_17953",
    "Last Name": "Morrison",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151473": {
    "id": "item_13412",
    "Last Name": "Peacock",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151479": {
    "id": "item_17869",
    "Last Name": "Santos",
    "First Name": "Aurea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151483": {
    "id": "item_28382",
    "Last Name": "Barbagallo",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151486": {
    "id": "item_5501",
    "Last Name": "DeCarlo",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151491": {
    "id": "item_5562",
    "Last Name": "Robinson",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151494": {
    "id": "item_13419",
    "Last Name": "Babanour",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151516": {
    "id": "item_30438",
    "Last Name": "Park",
    "First Name": "Sung Won",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151522": {
    "id": "item_18562",
    "Last Name": "Rogerson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151525": {
    "id": "item_2852",
    "Last Name": "Souza",
    "First Name": "Ivens",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151538": {
    "id": "item_13410",
    "Last Name": "Bedding",
    "First Name": "Ella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151544": {
    "id": "item_17930",
    "Last Name": "Arnott",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151552": {
    "id": "item_5541",
    "Last Name": "Peterson",
    "First Name": "Corey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151560": {
    "id": "item_5536",
    "Last Name": "Creek",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151562": {
    "id": "item_5558",
    "Last Name": "Blanco",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151564": {
    "id": "item_946",
    "Last Name": "Boyd",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151570": {
    "id": "item_28375",
    "Last Name": "Kay",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151588": {
    "id": "item_13417",
    "Last Name": "Scanlan",
    "First Name": "Peadar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151610": {
    "id": "item_28367",
    "Last Name": "Atkinson",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151612": {
    "id": "item_5513",
    "Last Name": "Taneja",
    "First Name": "Harshit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151640": {
    "id": "item_17948",
    "Last Name": "Soto",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151643": {
    "id": "item_5512",
    "Last Name": "Ignacio",
    "First Name": "Nicholson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151644": {
    "id": "item_5500",
    "Last Name": "Jing",
    "First Name": "Fengshan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151650": {
    "id": "item_16101",
    "Last Name": "Guimaraes",
    "First Name": "Rodrigo Guilherme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151653": {
    "id": "item_28366",
    "Last Name": "Vasquez",
    "First Name": "Leonie Lyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151654": {
    "id": "item_17920",
    "Last Name": "Camagong",
    "First Name": "Roby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151656": {
    "id": "item_16090",
    "Last Name": "Nandimandalam",
    "First Name": "Chandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151660": {
    "id": "item_17653",
    "Last Name": "Tang",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151661": {
    "id": "item_5526",
    "Last Name": "Gray",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151663": {
    "id": "item_944",
    "Last Name": "Marwick",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151668": {
    "id": "item_5540",
    "Last Name": "Morris",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151675": {
    "id": "item_30427",
    "Last Name": "Manio",
    "First Name": "Isabelito",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151676": {
    "id": "item_5497",
    "Last Name": "Haskett",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151679": {
    "id": "item_13409",
    "Last Name": "Kerner",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151686": {
    "id": "item_16334",
    "Last Name": "Eames",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151687": {
    "id": "item_5520",
    "Last Name": "O Callaghan",
    "First Name": "Emmet",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151698": {
    "id": "item_17922",
    "Last Name": "Haniman",
    "First Name": "Dashiel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151705": {
    "id": "item_13386",
    "Last Name": "Chmel",
    "First Name": "Zdenek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151711": {
    "id": "item_17850",
    "Last Name": "Kirton",
    "First Name": "Caitlyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151728": {
    "id": "item_13407",
    "Last Name": "Chua Te",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151733": {
    "id": "item_1432",
    "Last Name": "Ta",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151736": {
    "id": "item_17897",
    "Last Name": "Rogers",
    "First Name": "Avan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151741": {
    "id": "item_30423",
    "Last Name": "Kupke",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151751": {
    "id": "item_13404",
    "Last Name": "Wood",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151752": {
    "id": "item_17933",
    "Last Name": "Devers",
    "First Name": "Jared",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151753": {
    "id": "item_13390",
    "Last Name": "Barreto PŽrez",
    "First Name": "Lizeth Viviana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151756": {
    "id": "item_5335",
    "Last Name": "Tran",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151765": {
    "id": "item_5481",
    "Last Name": "Nicolosi",
    "First Name": "Dallas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151783": {
    "id": "item_30426",
    "Last Name": "Kermode",
    "First Name": "Felicity",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151795": {
    "id": "item_935",
    "Last Name": "Howard",
    "First Name": "Abraham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151809": {
    "id": "item_30348",
    "Last Name": "Travis",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151812": {
    "id": "item_28361",
    "Last Name": "Espinoza",
    "First Name": "Maria Marcelina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151820": {
    "id": "item_17822",
    "Last Name": "Smith",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151835": {
    "id": "item_2839",
    "Last Name": "Donnelly Aquilina",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151840": {
    "id": "item_2841",
    "Last Name": "Lethbridge",
    "First Name": "Jarrad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151846": {
    "id": "item_28360",
    "Last Name": "Grobler",
    "First Name": "Brenard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151850": {
    "id": "item_2831",
    "Last Name": "Castillo",
    "First Name": "Jonnathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151855": {
    "id": "item_30327",
    "Last Name": "Cadag",
    "First Name": "Benjamin Jorge",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151856": {
    "id": "item_5508",
    "Last Name": "Russo",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151867": {
    "id": "item_921",
    "Last Name": "Chang",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151884": {
    "id": "item_17798",
    "Last Name": "Brown",
    "First Name": "Mel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151890": {
    "id": "item_17902",
    "Last Name": "Sully",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151893": {
    "id": "item_28351",
    "Last Name": "Gallagher",
    "First Name": "Veronika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151902": {
    "id": "item_17819",
    "Last Name": "McNamara",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151911": {
    "id": "item_5416",
    "Last Name": "gonzales",
    "First Name": "brandon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151914": {
    "id": "item_874",
    "Last Name": "De Jersey",
    "First Name": "Maurice",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151917": {
    "id": "item_928",
    "Last Name": "Nguyen",
    "First Name": "Vu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151927": {
    "id": "item_16087",
    "Last Name": "Olbinar",
    "First Name": "Arrvie Dann Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151937": {
    "id": "item_2830",
    "Last Name": "Lyon",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151939": {
    "id": "item_2824",
    "Last Name": "Magee",
    "First Name": "Ciaran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151940": {
    "id": "item_28356",
    "Last Name": "Price",
    "First Name": "Caity",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151955": {
    "id": "item_30381",
    "Last Name": "Durairaj",
    "First Name": "Dhanashekaran",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151979": {
    "id": "item_5495",
    "Last Name": "Richards",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151994": {
    "id": "item_5489",
    "Last Name": "DiGirolamo",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151995": {
    "id": "item_13397",
    "Last Name": "O Hagan",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151997": {
    "id": "item_16091",
    "Last Name": "Havranek",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152004": {
    "id": "item_30409",
    "Last Name": "Nightingale",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152008": {
    "id": "item_28357",
    "Last Name": "O'Hara",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152017": {
    "id": "item_17899",
    "Last Name": "Johnson",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152021": {
    "id": "item_2834",
    "Last Name": "Hitchman",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152024": {
    "id": "item_5484",
    "Last Name": "Hu",
    "First Name": "Jinfeng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152026": {
    "id": "item_17892",
    "Last Name": "Hamilton",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152032": {
    "id": "item_5486",
    "Last Name": "Li",
    "First Name": "Chun Hei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152035": {
    "id": "item_30402",
    "Last Name": "Saraswati",
    "First Name": "Saraswati",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152043": {
    "id": "item_5490",
    "Last Name": "Silva",
    "First Name": "Jefferson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152059": {
    "id": "item_5477",
    "Last Name": "Cartman",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152094": {
    "id": "item_17881",
    "Last Name": "Rivera",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152095": {
    "id": "item_2822",
    "Last Name": "Sennett",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152102": {
    "id": "item_16086",
    "Last Name": "Sison",
    "First Name": "Andrei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152103": {
    "id": "item_17877",
    "Last Name": "Mazurek",
    "First Name": "Monique",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152104": {
    "id": "item_5474",
    "Last Name": "Waddon",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152106": {
    "id": "item_17873",
    "Last Name": "Brown",
    "First Name": "Hermione",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152112": {
    "id": "item_5471",
    "Last Name": "Dibben",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152117": {
    "id": "item_17875",
    "Last Name": "Chau",
    "First Name": "Chi Bong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152122": {
    "id": "item_13384",
    "Last Name": "Mand",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152129": {
    "id": "item_17778",
    "Last Name": "Vickers",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152130": {
    "id": "item_30394",
    "Last Name": "Surilestari",
    "First Name": "Wirna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152133": {
    "id": "item_17839",
    "Last Name": "Lowe",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152141": {
    "id": "item_28342",
    "Last Name": "Phitth",
    "First Name": "Worakorn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152146": {
    "id": "item_28341",
    "Last Name": "Tran",
    "First Name": "Tan Tam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152154": {
    "id": "item_17882",
    "Last Name": "Czischke",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152168": {
    "id": "item_13377",
    "Last Name": "Willcocks",
    "First Name": "Christia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152169": {
    "id": "item_914",
    "Last Name": "Fox",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152173": {
    "id": "item_17870",
    "Last Name": "Visser",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152184": {
    "id": "item_13364",
    "Last Name": "Mcdonagh",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152190": {
    "id": "item_17859",
    "Last Name": "Holding",
    "First Name": "Meg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152197": {
    "id": "item_17868",
    "Last Name": "Srinivasan",
    "First Name": "Maruthi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152202": {
    "id": "item_17880",
    "Last Name": "Tozer",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152206": {
    "id": "item_2806",
    "Last Name": "Duarte",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152207": {
    "id": "item_17852",
    "Last Name": "Cruden",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152223": {
    "id": "item_5449",
    "Last Name": "Corbett",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152225": {
    "id": "item_17821",
    "Last Name": "Chen",
    "First Name": "Xinxing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152256": {
    "id": "item_5453",
    "Last Name": "Dimattina",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152259": {
    "id": "item_5456",
    "Last Name": "Boylan",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152262": {
    "id": "item_5446",
    "Last Name": "Carwardine",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152264": {
    "id": "item_13368",
    "Last Name": "Zychski",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152269": {
    "id": "item_905",
    "Last Name": "Freer",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152274": {
    "id": "item_17845",
    "Last Name": "Cini",
    "First Name": "Kane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152292": {
    "id": "item_28336",
    "Last Name": "Dell-Reeves",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152300": {
    "id": "item_30372",
    "Last Name": "MA",
    "First Name": "Xiaolei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152301": {
    "id": "item_30385",
    "Last Name": "Burridge",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152304": {
    "id": "item_28333",
    "Last Name": "Kwon",
    "First Name": "Rose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152308": {
    "id": "item_13362",
    "Last Name": "zhou",
    "First Name": "renyi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152322": {
    "id": "item_17739",
    "Last Name": "Lee",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152324": {
    "id": "item_28339",
    "Last Name": "Jess",
    "First Name": "Keely",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152331": {
    "id": "item_17835",
    "Last Name": "Swift",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152335": {
    "id": "item_17836",
    "Last Name": "Huff",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152344": {
    "id": "item_30382",
    "Last Name": "Samson",
    "First Name": "Ken",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152348": {
    "id": "item_2817",
    "Last Name": "Hart",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152362": {
    "id": "item_5440",
    "Last Name": "Andrews",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152377": {
    "id": "item_892",
    "Last Name": "Harman",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152378": {
    "id": "item_5447",
    "Last Name": "Knight",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152385": {
    "id": "item_889",
    "Last Name": "Higgins",
    "First Name": "Drew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152388": {
    "id": "item_5420",
    "Last Name": "Geritz",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152392": {
    "id": "item_1431",
    "Last Name": "Jain",
    "First Name": "Aditya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152394": {
    "id": "item_17690",
    "Last Name": "Diesta",
    "First Name": "Allen Paolo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152395": {
    "id": "item_30373",
    "Last Name": "Khy",
    "First Name": "Sophea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152405": {
    "id": "item_17828",
    "Last Name": "Brindley",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152414": {
    "id": "item_28258",
    "Last Name": "Cooper",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152415": {
    "id": "item_16082",
    "Last Name": "Shah",
    "First Name": "Sonal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152418": {
    "id": "item_5422",
    "Last Name": "Small",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152438": {
    "id": "item_17750",
    "Last Name": "Susanti",
    "First Name": "Erlinda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152441": {
    "id": "item_17792",
    "Last Name": "Morgan",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152442": {
    "id": "item_17816",
    "Last Name": "Dekker",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152454": {
    "id": "item_2810",
    "Last Name": "Reintals",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152455": {
    "id": "item_5403",
    "Last Name": "Porter",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152470": {
    "id": "item_17811",
    "Last Name": "German Onofre",
    "First Name": "Sanso Dagostini",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152481": {
    "id": "item_895",
    "Last Name": "YU",
    "First Name": "YANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152482": {
    "id": "item_28331",
    "Last Name": "Gurung",
    "First Name": "Rajan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152491": {
    "id": "item_5415",
    "Last Name": "OÕ Shea",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152492": {
    "id": "item_17808",
    "Last Name": "Griffiths",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152497": {
    "id": "item_5434",
    "Last Name": "munoz",
    "First Name": "Julio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152499": {
    "id": "item_2802",
    "Last Name": "Campbell",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152506": {
    "id": "item_13312",
    "Last Name": "Bibat",
    "First Name": "Divina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152509": {
    "id": "item_5432",
    "Last Name": "Sherwen",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152532": {
    "id": "item_17790",
    "Last Name": "Jackson",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152533": {
    "id": "item_17794",
    "Last Name": "Cole",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152540": {
    "id": "item_13350",
    "Last Name": "Frogley",
    "First Name": "Stacy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152545": {
    "id": "item_13341",
    "Last Name": "Mecanovic",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152548": {
    "id": "item_28325",
    "Last Name": "Cabrales",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152552": {
    "id": "item_5350",
    "Last Name": "Wang",
    "First Name": "Simeng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152557": {
    "id": "item_28305",
    "Last Name": "Want",
    "First Name": "Merle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152563": {
    "id": "item_28323",
    "Last Name": "Sardinia",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152565": {
    "id": "item_26505",
    "Last Name": "MOREHEAD",
    "First Name": "JASON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152567": {
    "id": "item_28279",
    "Last Name": "Gusilatar",
    "First Name": "Leoniza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152574": {
    "id": "item_5428",
    "Last Name": "Casey",
    "First Name": "Riain",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152588": {
    "id": "item_30367",
    "Last Name": "bautista",
    "First Name": "marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152592": {
    "id": "item_13339",
    "Last Name": "Senti",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152593": {
    "id": "item_17800",
    "Last Name": "Nguyen",
    "First Name": "Kien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152599": {
    "id": "item_30341",
    "Last Name": "Villamor",
    "First Name": "Michael Angelo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152604": {
    "id": "item_883",
    "Last Name": "Rossiter",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152608": {
    "id": "item_17784",
    "Last Name": "Ritchie",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152609": {
    "id": "item_5410",
    "Last Name": "Bergas",
    "First Name": "Felix",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152611": {
    "id": "item_5401",
    "Last Name": "Veloso",
    "First Name": "Allen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152618": {
    "id": "item_28311",
    "Last Name": "Irawan",
    "First Name": "Edi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152621": {
    "id": "item_2801",
    "Last Name": "Cagulada",
    "First Name": "Warren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152627": {
    "id": "item_16080",
    "Last Name": "Styles",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152636": {
    "id": "item_28312",
    "Last Name": "Apikian",
    "First Name": "Martine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152637": {
    "id": "item_17761",
    "Last Name": "Holcombe",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152642": {
    "id": "item_17777",
    "Last Name": "Heine",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152650": {
    "id": "item_5407",
    "Last Name": "Hillam",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152658": {
    "id": "item_16075",
    "Last Name": "Nguyen",
    "First Name": "Augustin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152659": {
    "id": "item_30371",
    "Last Name": "Wang",
    "First Name": "Li Na",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152666": {
    "id": "item_17786",
    "Last Name": "Fernandez Lopez-Areal",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152671": {
    "id": "item_13340",
    "Last Name": "Ho",
    "First Name": "Philip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152679": {
    "id": "item_5417",
    "Last Name": "Farnan",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152681": {
    "id": "item_13336",
    "Last Name": "blundell",
    "First Name": "chelsea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152694": {
    "id": "item_17782",
    "Last Name": "Volpe",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152699": {
    "id": "item_13335",
    "Last Name": "Moore",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152702": {
    "id": "item_13334",
    "Last Name": "Donaldson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152735": {
    "id": "item_2805",
    "Last Name": "Mccallum",
    "First Name": "Laurie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152738": {
    "id": "item_28301",
    "Last Name": "Adam",
    "First Name": "Caden",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152741": {
    "id": "item_17758",
    "Last Name": "BOYD",
    "First Name": "WENDELL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152743": {
    "id": "item_28310",
    "Last Name": "Zhao",
    "First Name": "Ping",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152744": {
    "id": "item_13330",
    "Last Name": "Dixon",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152748": {
    "id": "item_5390",
    "Last Name": "Chu",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152766": {
    "id": "item_2804",
    "Last Name": "Costello",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152769": {
    "id": "item_5402",
    "Last Name": "Tran",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152776": {
    "id": "item_17746",
    "Last Name": "Woolbank",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152791": {
    "id": "item_16073",
    "Last Name": "Sebastian",
    "First Name": "Jinky Karlene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152795": {
    "id": "item_17747",
    "Last Name": "Gallagher",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152797": {
    "id": "item_13318",
    "Last Name": "MOLINA",
    "First Name": "CAROLINA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152801": {
    "id": "item_28304",
    "Last Name": "Claassens",
    "First Name": "Lana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152806": {
    "id": "item_17756",
    "Last Name": "Imam",
    "First Name": "Ali",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152818": {
    "id": "item_5397",
    "Last Name": "Wilson",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152830": {
    "id": "item_17640",
    "Last Name": "Coyne",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152832": {
    "id": "item_867",
    "Last Name": "WU",
    "First Name": "LEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152835": {
    "id": "item_30339",
    "Last Name": "Litvack",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152838": {
    "id": "item_17765",
    "Last Name": "Lee",
    "First Name": "Adele",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152839": {
    "id": "item_17725",
    "Last Name": "Hall",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152844": {
    "id": "item_16060",
    "Last Name": "Leacock",
    "First Name": "Mikaela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152855": {
    "id": "item_17757",
    "Last Name": "Sutton",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152860": {
    "id": "item_13316",
    "Last Name": "Jiang",
    "First Name": "Liansheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152863": {
    "id": "item_30299",
    "Last Name": "Fernandes de Abreu",
    "First Name": "Gabriele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152866": {
    "id": "item_28298",
    "Last Name": "Wooding",
    "First Name": "Phil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152873": {
    "id": "item_5381",
    "Last Name": "RAMOS",
    "First Name": "LUIS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152874": {
    "id": "item_5380",
    "Last Name": "Sammut",
    "First Name": "Corey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152888": {
    "id": "item_17693",
    "Last Name": "Ponomarev",
    "First Name": "Dmitrii",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152892": {
    "id": "item_5369",
    "Last Name": "Demonceau",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152910": {
    "id": "item_13323",
    "Last Name": "Davies",
    "First Name": "Bethan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152912": {
    "id": "item_17714",
    "Last Name": "Kim",
    "First Name": "Woo Jin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152913": {
    "id": "item_5373",
    "Last Name": "Reintals",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152924": {
    "id": "item_28296",
    "Last Name": "Bi",
    "First Name": "Bo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152929": {
    "id": "item_17737",
    "Last Name": "Boshard",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152932": {
    "id": "item_5365",
    "Last Name": "piehl",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152947": {
    "id": "item_17722",
    "Last Name": "Delic",
    "First Name": "Alen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152969": {
    "id": "item_5344",
    "Last Name": "Hanekom",
    "First Name": "Pieter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152989": {
    "id": "item_13315",
    "Last Name": "Schoenmaker",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152991": {
    "id": "item_17735",
    "Last Name": "Crespo-Rodriguez",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152993": {
    "id": "item_30344",
    "Last Name": "Smith",
    "First Name": "Innes",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152995": {
    "id": "item_30332",
    "Last Name": "Gozali",
    "First Name": "Hendra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153014": {
    "id": "item_13280",
    "Last Name": "Doyle",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153044": {
    "id": "item_30325",
    "Last Name": "Snook",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153051": {
    "id": "item_865",
    "Last Name": "Padilla",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153053": {
    "id": "item_2777",
    "Last Name": "Beetham",
    "First Name": "Blain",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153057": {
    "id": "item_13302",
    "Last Name": "McFarlane",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153061": {
    "id": "item_13310",
    "Last Name": "Cheng",
    "First Name": "Chi Wai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153066": {
    "id": "item_861",
    "Last Name": "Hurley",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153070": {
    "id": "item_2784",
    "Last Name": "Middleton",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153071": {
    "id": "item_28286",
    "Last Name": "Koh",
    "First Name": "Huey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153078": {
    "id": "item_13285",
    "Last Name": "Tang",
    "First Name": "Selena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153080": {
    "id": "item_17453",
    "Last Name": "Holzinger",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153090": {
    "id": "item_16068",
    "Last Name": "Stewart",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153100": {
    "id": "item_17678",
    "Last Name": "Mercer",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153117": {
    "id": "item_5360",
    "Last Name": "Ellis",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153118": {
    "id": "item_863",
    "Last Name": "Brown",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153136": {
    "id": "item_5337",
    "Last Name": "Clark",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153138": {
    "id": "item_17673",
    "Last Name": "CHENG",
    "First Name": "CHIN TAI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153157": {
    "id": "item_30326",
    "Last Name": "Davitt",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153163": {
    "id": "item_17695",
    "Last Name": "Cheung",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153164": {
    "id": "item_1430",
    "Last Name": "Zhu",
    "First Name": "Mengdi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153166": {
    "id": "item_5353",
    "Last Name": "Hayward",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153167": {
    "id": "item_17689",
    "Last Name": "Sullivan",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153168": {
    "id": "item_5343",
    "Last Name": "thomson",
    "First Name": "dave",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153177": {
    "id": "item_30321",
    "Last Name": "Dell",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153183": {
    "id": "item_5355",
    "Last Name": "Irawan",
    "First Name": "Hilman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153199": {
    "id": "item_5334",
    "Last Name": "Wilkinson",
    "First Name": "Elliott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153209": {
    "id": "item_5348",
    "Last Name": "Beedles",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153242": {
    "id": "item_17679",
    "Last Name": "White",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153253": {
    "id": "item_17665",
    "Last Name": "Jaireth",
    "First Name": "Manu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153282": {
    "id": "item_17682",
    "Last Name": "Woodward",
    "First Name": "Carl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153285": {
    "id": "item_30320",
    "Last Name": "Delgadillo Rubio",
    "First Name": "Jeisson David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153287": {
    "id": "item_5342",
    "Last Name": "Shields",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153290": {
    "id": "item_5260",
    "Last Name": "Kortick",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153300": {
    "id": "item_17681",
    "Last Name": "Ross",
    "First Name": "Jaimee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153330": {
    "id": "item_30193",
    "Last Name": "Sun",
    "First Name": "Rae",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153332": {
    "id": "item_13284",
    "Last Name": "Millhouse",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153356": {
    "id": "item_28273",
    "Last Name": "Bond",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153360": {
    "id": "item_5317",
    "Last Name": "Peel",
    "First Name": "Kate",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153361": {
    "id": "item_5326",
    "Last Name": "De Mesa",
    "First Name": "Erwin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153369": {
    "id": "item_5330",
    "Last Name": "Jones",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153371": {
    "id": "item_5331",
    "Last Name": "Sommerville",
    "First Name": "Troels",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153373": {
    "id": "item_28240",
    "Last Name": "Liu",
    "First Name": "Zhenyu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153381": {
    "id": "item_13279",
    "Last Name": "Eastwood",
    "First Name": "Cecily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153385": {
    "id": "item_801",
    "Last Name": "PARK",
    "First Name": "HYUNGKEUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153386": {
    "id": "item_17667",
    "Last Name": "Agnew",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153399": {
    "id": "item_17632",
    "Last Name": "Aliag-Vivar",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153401": {
    "id": "item_17662",
    "Last Name": "Scioscia",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153404": {
    "id": "item_5327",
    "Last Name": "Hutchinson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153416": {
    "id": "item_17659",
    "Last Name": "Vo",
    "First Name": "Vy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153426": {
    "id": "item_13281",
    "Last Name": "Bainbridge",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153438": {
    "id": "item_30314",
    "Last Name": "Lloyd",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153446": {
    "id": "item_30313",
    "Last Name": "Bhave",
    "First Name": "Devashish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153458": {
    "id": "item_30312",
    "Last Name": "Lowe",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153459": {
    "id": "item_16056",
    "Last Name": "Cho",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153462": {
    "id": "item_30309",
    "Last Name": "Yeung",
    "First Name": "Hoi Ying",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153470": {
    "id": "item_17643",
    "Last Name": "Boyton",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153476": {
    "id": "item_17617",
    "Last Name": "Patterson",
    "First Name": "Knightley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153505": {
    "id": "item_16058",
    "Last Name": "Clere",
    "First Name": "Nico",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153510": {
    "id": "item_17650",
    "Last Name": "Lacey",
    "First Name": "Tara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153517": {
    "id": "item_5320",
    "Last Name": "Kennaugh",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153527": {
    "id": "item_28272",
    "Last Name": "Drew",
    "First Name": "Kait",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153534": {
    "id": "item_5314",
    "Last Name": "Hermiston",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153535": {
    "id": "item_5321",
    "Last Name": "Carnachan",
    "First Name": "Katie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153544": {
    "id": "item_13239",
    "Last Name": "Suthithanakom",
    "First Name": "Kittisak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153547": {
    "id": "item_5308",
    "Last Name": "Stratton",
    "First Name": "Evan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153549": {
    "id": "item_30281",
    "Last Name": "Danuseputro",
    "First Name": "Lenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153550": {
    "id": "item_13276",
    "Last Name": "Butterworth",
    "First Name": "Brienna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153552": {
    "id": "item_17646",
    "Last Name": "Amedu",
    "First Name": "Akoji",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153553": {
    "id": "item_28251",
    "Last Name": "Abuan",
    "First Name": "Luis Miguel Angeles",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153557": {
    "id": "item_816",
    "Last Name": "Rimmer",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153571": {
    "id": "item_28259",
    "Last Name": "McKelvey",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153572": {
    "id": "item_838",
    "Last Name": "Harbourne",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153574": {
    "id": "item_5303",
    "Last Name": "Elmisalati",
    "First Name": "Wael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153578": {
    "id": "item_17621",
    "Last Name": "Stents",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153583": {
    "id": "item_5319",
    "Last Name": "hulbert",
    "First Name": "brittany",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153585": {
    "id": "item_5312",
    "Last Name": "Sajewicz",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153587": {
    "id": "item_13274",
    "Last Name": "Jones",
    "First Name": "Lizzy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153588": {
    "id": "item_13267",
    "Last Name": "Li",
    "First Name": "Wenlong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153589": {
    "id": "item_30296",
    "Last Name": "Jeffrey",
    "First Name": "Mick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153605": {
    "id": "item_13270",
    "Last Name": "McAllister",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153619": {
    "id": "item_17592",
    "Last Name": "Harris",
    "First Name": "Kathlyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153628": {
    "id": "item_17614",
    "Last Name": "Boon Juok",
    "First Name": "Ch'ng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153665": {
    "id": "item_28262",
    "Last Name": "Reinhard",
    "First Name": "Haneylu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153673": {
    "id": "item_13251",
    "Last Name": "Gonzales",
    "First Name": "Kalehla Nikole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153678": {
    "id": "item_30301",
    "Last Name": "Ma",
    "First Name": "Kwok Kwan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153679": {
    "id": "item_30268",
    "Last Name": "Song",
    "First Name": "Jiyoon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153681": {
    "id": "item_17623",
    "Last Name": "Connor",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153686": {
    "id": "item_30287",
    "Last Name": "Powell",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153692": {
    "id": "item_5298",
    "Last Name": "Ko",
    "First Name": "Chiu Kelvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153700": {
    "id": "item_30256",
    "Last Name": "Kumano",
    "First Name": "Aiko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153702": {
    "id": "item_17610",
    "Last Name": "Nguyen",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153706": {
    "id": "item_16053",
    "Last Name": "Gorobets",
    "First Name": "Eva",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153715": {
    "id": "item_17606",
    "Last Name": "Fong",
    "First Name": "Terence",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153717": {
    "id": "item_28250",
    "Last Name": "Smith",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153721": {
    "id": "item_17613",
    "Last Name": "Tan",
    "First Name": "Bernice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153727": {
    "id": "item_17601",
    "Last Name": "Chua",
    "First Name": "Melissa Denishka",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153734": {
    "id": "item_17607",
    "Last Name": "Emiliana",
    "First Name": "Emiliana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153735": {
    "id": "item_17570",
    "Last Name": "Xing",
    "First Name": "Xiaomin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153738": {
    "id": "item_28245",
    "Last Name": "Maralit",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153743": {
    "id": "item_2761",
    "Last Name": "Guichon",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153744": {
    "id": "item_831",
    "Last Name": "Comyn",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153761": {
    "id": "item_17603",
    "Last Name": "Richter",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153764": {
    "id": "item_2763",
    "Last Name": "Thomson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153782": {
    "id": "item_28254",
    "Last Name": "Wang",
    "First Name": "Qingzheng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153791": {
    "id": "item_17562",
    "Last Name": "Jamieson",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153818": {
    "id": "item_829",
    "Last Name": "Hayward",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153819": {
    "id": "item_17593",
    "Last Name": "Marcial",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153820": {
    "id": "item_28247",
    "Last Name": "Clementine",
    "First Name": "Jacques",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153825": {
    "id": "item_28151",
    "Last Name": "Montoya",
    "First Name": "Daryll",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153846": {
    "id": "item_30279",
    "Last Name": "Flannery",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153849": {
    "id": "item_17568",
    "Last Name": "QUACH",
    "First Name": "TAI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153854": {
    "id": "item_17590",
    "Last Name": "Hung",
    "First Name": "Kwan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153857": {
    "id": "item_28246",
    "Last Name": "Diamante",
    "First Name": "Dian Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153866": {
    "id": "item_13246",
    "Last Name": "Davis",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153871": {
    "id": "item_5275",
    "Last Name": "Eyles",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153880": {
    "id": "item_16045",
    "Last Name": "Chapman",
    "First Name": "Dee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153883": {
    "id": "item_17571",
    "Last Name": "Williams",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153886": {
    "id": "item_17583",
    "Last Name": "Nayak",
    "First Name": "Amit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153890": {
    "id": "item_17541",
    "Last Name": "Kamada",
    "First Name": "Kentaro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153896": {
    "id": "item_827",
    "Last Name": "THOMSON",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153901": {
    "id": "item_13232",
    "Last Name": "Wilson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153907": {
    "id": "item_30246",
    "Last Name": "Lau",
    "First Name": "Chung Yeung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153908": {
    "id": "item_17567",
    "Last Name": "Urech",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153910": {
    "id": "item_17569",
    "Last Name": "Casta–eda",
    "First Name": "Stephanie Joyce",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153912": {
    "id": "item_13247",
    "Last Name": "Sena-Becker",
    "First Name": "Tara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153917": {
    "id": "item_13244",
    "Last Name": "Graus",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153920": {
    "id": "item_17558",
    "Last Name": "Ferris",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153930": {
    "id": "item_5264",
    "Last Name": "Pow",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153932": {
    "id": "item_17581",
    "Last Name": "Goldie",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153935": {
    "id": "item_5281",
    "Last Name": "Deegan",
    "First Name": "Malcolm",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153938": {
    "id": "item_17554",
    "Last Name": "Drayton",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153943": {
    "id": "item_13236",
    "Last Name": "Qiu",
    "First Name": "Alister",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153944": {
    "id": "item_17574",
    "Last Name": "Cole",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153962": {
    "id": "item_5271",
    "Last Name": "Cobos Guasca",
    "First Name": "Andres",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153967": {
    "id": "item_2750",
    "Last Name": "Crothers",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153972": {
    "id": "item_17529",
    "Last Name": "Gomez",
    "First Name": "Realene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153988": {
    "id": "item_30189",
    "Last Name": "Nelson",
    "First Name": "Doug",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153996": {
    "id": "item_5213",
    "Last Name": "Lin",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153997": {
    "id": "item_13224",
    "Last Name": "Venn",
    "First Name": "ChantŽl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153998": {
    "id": "item_16046",
    "Last Name": "Bell",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154001": {
    "id": "item_30260",
    "Last Name": "Dyma",
    "First Name": "Simona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154008": {
    "id": "item_30267",
    "Last Name": "CONAWAY",
    "First Name": "SHAWN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154015": {
    "id": "item_817",
    "Last Name": "Tjong",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154016": {
    "id": "item_824",
    "Last Name": "Monaghan",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154027": {
    "id": "item_2749",
    "Last Name": "Hiller",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154034": {
    "id": "item_17538",
    "Last Name": "Arias",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154039": {
    "id": "item_17557",
    "Last Name": "Ng",
    "First Name": "Yue Hin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154075": {
    "id": "item_13219",
    "Last Name": "Quach",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154083": {
    "id": "item_17536",
    "Last Name": "Shepherd",
    "First Name": "Reece",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154086": {
    "id": "item_28233",
    "Last Name": "JansevanRensburg",
    "First Name": "Herman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154100": {
    "id": "item_17552",
    "Last Name": "Jarvis",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154104": {
    "id": "item_17546",
    "Last Name": "Rogers",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154108": {
    "id": "item_779",
    "Last Name": "Wood",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154111": {
    "id": "item_17551",
    "Last Name": "Cooper",
    "First Name": "Donna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154118": {
    "id": "item_788",
    "Last Name": "Schilling",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154136": {
    "id": "item_17545",
    "Last Name": "Cui",
    "First Name": "Maggie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154150": {
    "id": "item_13220",
    "Last Name": "GREEN",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154154": {
    "id": "item_13223",
    "Last Name": "Wing",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154160": {
    "id": "item_17525",
    "Last Name": "Long",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154174": {
    "id": "item_30242",
    "Last Name": "Darius",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154178": {
    "id": "item_30237",
    "Last Name": "Soegianto",
    "First Name": "Benny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154179": {
    "id": "item_2733",
    "Last Name": "Pulido",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154196": {
    "id": "item_30247",
    "Last Name": "Tan",
    "First Name": "christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154197": {
    "id": "item_17526",
    "Last Name": "Hicks",
    "First Name": "Dougal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154198": {
    "id": "item_17530",
    "Last Name": "Eng",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154201": {
    "id": "item_2739",
    "Last Name": "Clarkin",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154204": {
    "id": "item_5242",
    "Last Name": "Blunden",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154210": {
    "id": "item_814",
    "Last Name": "Nguyen",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154214": {
    "id": "item_28222",
    "Last Name": "Moran",
    "First Name": "Ally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154217": {
    "id": "item_28221",
    "Last Name": "Bathurst",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154219": {
    "id": "item_811",
    "Last Name": "Piazzoni",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154230": {
    "id": "item_17523",
    "Last Name": "Hoang",
    "First Name": "Long",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154234": {
    "id": "item_5246",
    "Last Name": "Peattie",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154242": {
    "id": "item_5247",
    "Last Name": "Westwood",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154245": {
    "id": "item_17521",
    "Last Name": "Marks",
    "First Name": "Brigette",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154246": {
    "id": "item_5233",
    "Last Name": "CLARK",
    "First Name": "BRETT",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154250": {
    "id": "item_30252",
    "Last Name": "Francisco",
    "First Name": "Joy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154262": {
    "id": "item_28878",
    "Last Name": "Klein",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154272": {
    "id": "item_28188",
    "Last Name": "Wong",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154274": {
    "id": "item_17506",
    "Last Name": "Motsick",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154278": {
    "id": "item_813",
    "Last Name": "Callianiotis",
    "First Name": "Zara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154280": {
    "id": "item_2732",
    "Last Name": "Ng",
    "First Name": "Chi Keung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154288": {
    "id": "item_28218",
    "Last Name": "Sandes",
    "First Name": "Coco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154289": {
    "id": "item_5224",
    "Last Name": "Kurniadi",
    "First Name": "Albert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154291": {
    "id": "item_13208",
    "Last Name": "Verrocchi",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154296": {
    "id": "item_26504",
    "Last Name": "Hardman",
    "First Name": "Stacy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154297": {
    "id": "item_5235",
    "Last Name": "Nikolakakis",
    "First Name": "Tori",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154301": {
    "id": "item_17511",
    "Last Name": "Garner",
    "First Name": "Donald",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154302": {
    "id": "item_28219",
    "Last Name": "Sulaeman",
    "First Name": "Nashrullah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154305": {
    "id": "item_13207",
    "Last Name": "Weir",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154306": {
    "id": "item_5231",
    "Last Name": "Thang Val",
    "First Name": "Chris Bon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154307": {
    "id": "item_2736",
    "Last Name": "Hoang",
    "First Name": "Dang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154325": {
    "id": "item_5239",
    "Last Name": "Gamble",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154335": {
    "id": "item_17513",
    "Last Name": "Merrick",
    "First Name": "Philippa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154344": {
    "id": "item_809",
    "Last Name": "Chia",
    "First Name": "Noel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154365": {
    "id": "item_30233",
    "Last Name": "Viswanathan",
    "First Name": "Ram",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154390": {
    "id": "item_5228",
    "Last Name": "Soulsby",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154394": {
    "id": "item_30231",
    "Last Name": "Rehayem",
    "First Name": "Pierre",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154419": {
    "id": "item_783",
    "Last Name": "Grabowski",
    "First Name": "Mariusz",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154427": {
    "id": "item_17493",
    "Last Name": "Nilsson",
    "First Name": "Samara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154430": {
    "id": "item_2730",
    "Last Name": "JAEWON",
    "First Name": "Choi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154438": {
    "id": "item_5220",
    "Last Name": "Kennedy",
    "First Name": "Rose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154443": {
    "id": "item_17501",
    "Last Name": "Yan",
    "First Name": "Lilian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154445": {
    "id": "item_17491",
    "Last Name": "Pritchard",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154463": {
    "id": "item_5222",
    "Last Name": "Francis",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154470": {
    "id": "item_5211",
    "Last Name": "Meyer",
    "First Name": "Leah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154474": {
    "id": "item_13203",
    "Last Name": "Hoang",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154479": {
    "id": "item_17494",
    "Last Name": "Fernandez",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154481": {
    "id": "item_13197",
    "Last Name": "D'alessio",
    "First Name": "Richie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154485": {
    "id": "item_802",
    "Last Name": "Monk",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154509": {
    "id": "item_28204",
    "Last Name": "Creighton",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154511": {
    "id": "item_30180",
    "Last Name": "Ponferrada",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154521": {
    "id": "item_17478",
    "Last Name": "Prirungruang",
    "First Name": "Didsayachai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154526": {
    "id": "item_28201",
    "Last Name": "Croft",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154540": {
    "id": "item_791",
    "Last Name": "Prinsloo",
    "First Name": "Viljoen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154546": {
    "id": "item_26503",
    "Last Name": "Citrin",
    "First Name": "Erika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154547": {
    "id": "item_13191",
    "Last Name": "Wertz",
    "First Name": "Quentinn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154548": {
    "id": "item_16026",
    "Last Name": "Crithary",
    "First Name": "Geremy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154551": {
    "id": "item_16036",
    "Last Name": "LIM",
    "First Name": "SUOK FUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154553": {
    "id": "item_17485",
    "Last Name": "Quiskamp",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154556": {
    "id": "item_17489",
    "Last Name": "Tabifranca",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154570": {
    "id": "item_28209",
    "Last Name": "Cardelli",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154574": {
    "id": "item_5212",
    "Last Name": "Drayton",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154582": {
    "id": "item_30226",
    "Last Name": "McGrail",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154583": {
    "id": "item_2727",
    "Last Name": "Newman",
    "First Name": "Zeke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154584": {
    "id": "item_5210",
    "Last Name": "Kim",
    "First Name": "Jung min",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154585": {
    "id": "item_13180",
    "Last Name": "Franco",
    "First Name": "Marcelo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154589": {
    "id": "item_30220",
    "Last Name": "SUSICK",
    "First Name": "KATHERINE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154592": {
    "id": "item_5215",
    "Last Name": "ALBERT",
    "First Name": "COREY",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154596": {
    "id": "item_30214",
    "Last Name": "Yeap",
    "First Name": "Kean Sek",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154597": {
    "id": "item_5206",
    "Last Name": "Baracchini",
    "First Name": "Giulia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154598": {
    "id": "item_5205",
    "Last Name": "Allwright",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154602": {
    "id": "item_17464",
    "Last Name": "Phan",
    "First Name": "Sang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154605": {
    "id": "item_16038",
    "Last Name": "Mercado",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154615": {
    "id": "item_30225",
    "Last Name": "Garrido",
    "First Name": "Xantine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154621": {
    "id": "item_5200",
    "Last Name": "Smith",
    "First Name": "Suzi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154634": {
    "id": "item_5202",
    "Last Name": "Smith",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154638": {
    "id": "item_17472",
    "Last Name": "Gallacher",
    "First Name": "Cat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154644": {
    "id": "item_784",
    "Last Name": "Murphy",
    "First Name": "Aleem",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154646": {
    "id": "item_16035",
    "Last Name": "Bhusal",
    "First Name": "Mani",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154664": {
    "id": "item_13185",
    "Last Name": "Gregory",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154669": {
    "id": "item_17447",
    "Last Name": "Nguyen",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154676": {
    "id": "item_17463",
    "Last Name": "Gorman",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154690": {
    "id": "item_13182",
    "Last Name": "Uren",
    "First Name": "Magnus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154723": {
    "id": "item_28190",
    "Last Name": "Holganza",
    "First Name": "Frances Chemaigne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154734": {
    "id": "item_17459",
    "Last Name": "Higgs",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154739": {
    "id": "item_28197",
    "Last Name": "Yang",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154743": {
    "id": "item_13178",
    "Last Name": "Standfield",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154744": {
    "id": "item_5153",
    "Last Name": "Ramah",
    "First Name": "Bede",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154746": {
    "id": "item_5186",
    "Last Name": "Bosustow",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154750": {
    "id": "item_5179",
    "Last Name": "Hayde",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154752": {
    "id": "item_30210",
    "Last Name": "THOMAS",
    "First Name": "Pierre Florian Michel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154754": {
    "id": "item_17451",
    "Last Name": "Sugiarto",
    "First Name": "Devin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154765": {
    "id": "item_17446",
    "Last Name": "Morton",
    "First Name": "Ceri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154769": {
    "id": "item_785",
    "Last Name": "Hodges",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154777": {
    "id": "item_2719",
    "Last Name": "Calero",
    "First Name": "Jillian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154781": {
    "id": "item_28195",
    "Last Name": "Sniderman",
    "First Name": "Brenna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154782": {
    "id": "item_5187",
    "Last Name": "Sylte",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154783": {
    "id": "item_13160",
    "Last Name": "Truong",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154804": {
    "id": "item_774",
    "Last Name": "Ricupero",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154823": {
    "id": "item_5169",
    "Last Name": "Fang",
    "First Name": "Jinglin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154836": {
    "id": "item_772",
    "Last Name": "McMahon",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154844": {
    "id": "item_777",
    "Last Name": "Kim",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154848": {
    "id": "item_16027",
    "Last Name": "Stafford",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154849": {
    "id": "item_2714",
    "Last Name": "Ooi",
    "First Name": "Wei Han",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154853": {
    "id": "item_30198",
    "Last Name": "Barratt",
    "First Name": "Beverley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154854": {
    "id": "item_17442",
    "Last Name": "Reading",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154863": {
    "id": "item_16030",
    "Last Name": "Chang",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154866": {
    "id": "item_2712",
    "Last Name": "Tobar",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154875": {
    "id": "item_13168",
    "Last Name": "Lawn",
    "First Name": "Derek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154885": {
    "id": "item_5172",
    "Last Name": "Robertson",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154894": {
    "id": "item_16029",
    "Last Name": "Byalik",
    "First Name": "Pavel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154912": {
    "id": "item_13164",
    "Last Name": "Bates",
    "First Name": "Juliet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154924": {
    "id": "item_5160",
    "Last Name": "Lim",
    "First Name": "Hok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154941": {
    "id": "item_30201",
    "Last Name": "Byrnes",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154959": {
    "id": "item_5163",
    "Last Name": "Patterson",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154963": {
    "id": "item_2710",
    "Last Name": "Jacobs",
    "First Name": "Jono",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154996": {
    "id": "item_5155",
    "Last Name": "McKinnon",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154999": {
    "id": "item_2704",
    "Last Name": "Carruthers",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155004": {
    "id": "item_762",
    "Last Name": "Blanch",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155014": {
    "id": "item_2708",
    "Last Name": "Rowlands",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155025": {
    "id": "item_2706",
    "Last Name": "Carruthers",
    "First Name": "Elliot",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155026": {
    "id": "item_30196",
    "Last Name": "Allen",
    "First Name": "Meredith",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155042": {
    "id": "item_17420",
    "Last Name": "vandepopeliere",
    "First Name": "catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155048": {
    "id": "item_5149",
    "Last Name": "Chang",
    "First Name": "Hok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155056": {
    "id": "item_2703",
    "Last Name": "Hall",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155064": {
    "id": "item_13157",
    "Last Name": "Meredith",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155069": {
    "id": "item_17402",
    "Last Name": "Carter",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155072": {
    "id": "item_17409",
    "Last Name": "Cook",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155075": {
    "id": "item_28163",
    "Last Name": "Mason",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155088": {
    "id": "item_2698",
    "Last Name": "Bohorquez",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155111": {
    "id": "item_28175",
    "Last Name": "Zevallos",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155123": {
    "id": "item_5150",
    "Last Name": "Bolaffi",
    "First Name": "Reuben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155132": {
    "id": "item_2701",
    "Last Name": "Fradinho",
    "First Name": "Maria",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155133": {
    "id": "item_17391",
    "Last Name": "Yong",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155134": {
    "id": "item_760",
    "Last Name": "Hong",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155145": {
    "id": "item_28098",
    "Last Name": "Hernandez",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155156": {
    "id": "item_757",
    "Last Name": "Connell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155157": {
    "id": "item_30181",
    "Last Name": "Nelson",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155159": {
    "id": "item_5141",
    "Last Name": "Jennings",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155176": {
    "id": "item_753",
    "Last Name": "Simonet",
    "First Name": "Justyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155185": {
    "id": "item_28160",
    "Last Name": "Reckerman",
    "First Name": "Romel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155187": {
    "id": "item_5127",
    "Last Name": "Posetti",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155194": {
    "id": "item_17333",
    "Last Name": "Narasimhan",
    "First Name": "Tejas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155204": {
    "id": "item_17389",
    "Last Name": "Robinson",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155206": {
    "id": "item_28171",
    "Last Name": "Wang",
    "First Name": "Xiao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155210": {
    "id": "item_28172",
    "Last Name": "Tonzing",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155216": {
    "id": "item_5130",
    "Last Name": "Hafiz",
    "First Name": "Alini",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155227": {
    "id": "item_30169",
    "Last Name": "Maddocks",
    "First Name": "Cariad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155243": {
    "id": "item_2693",
    "Last Name": "Gibson",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155257": {
    "id": "item_751",
    "Last Name": "Lee",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155258": {
    "id": "item_17376",
    "Last Name": "White",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155261": {
    "id": "item_30174",
    "Last Name": "Bell",
    "First Name": "Devlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155267": {
    "id": "item_2690",
    "Last Name": "East",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155271": {
    "id": "item_17386",
    "Last Name": "Baldwin",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155286": {
    "id": "item_30171",
    "Last Name": "Dandu",
    "First Name": "Shivanag",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155292": {
    "id": "item_17385",
    "Last Name": "Yap",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155308": {
    "id": "item_17378",
    "Last Name": "Ottaway",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155315": {
    "id": "item_28157",
    "Last Name": "Kawata",
    "First Name": "Kyla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155317": {
    "id": "item_30176",
    "Last Name": "Chan",
    "First Name": "Philli",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155321": {
    "id": "item_28166",
    "Last Name": "Bulafkin",
    "First Name": "Malcolm",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155334": {
    "id": "item_5114",
    "Last Name": "Corpuz",
    "First Name": "Kennex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155341": {
    "id": "item_5122",
    "Last Name": "Bernardes",
    "First Name": "Caio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155345": {
    "id": "item_2691",
    "Last Name": "Taylor",
    "First Name": "Lindy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155399": {
    "id": "item_744",
    "Last Name": "Dahlenburg",
    "First Name": "Dominique",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155401": {
    "id": "item_742",
    "Last Name": "Hawkins",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155429": {
    "id": "item_5119",
    "Last Name": "Collins",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155436": {
    "id": "item_13149",
    "Last Name": "Jones",
    "First Name": "Evie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155453": {
    "id": "item_741",
    "Last Name": "Oates",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155456": {
    "id": "item_2686",
    "Last Name": "LAM",
    "First Name": "JEMIMAH",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155466": {
    "id": "item_2687",
    "Last Name": "ONeill",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155468": {
    "id": "item_17365",
    "Last Name": "Moody",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155471": {
    "id": "item_28162",
    "Last Name": "Rodriguez",
    "First Name": "Elisha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155478": {
    "id": "item_30160",
    "Last Name": "Perry",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155482": {
    "id": "item_17316",
    "Last Name": "Cotrino",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155484": {
    "id": "item_17358",
    "Last Name": "Charles",
    "First Name": "Nikhil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155509": {
    "id": "item_2684",
    "Last Name": "Birrer",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155512": {
    "id": "item_13143",
    "Last Name": "Karakurt",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155529": {
    "id": "item_17354",
    "Last Name": "Witteveen",
    "First Name": "Miriam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155538": {
    "id": "item_736",
    "Last Name": "Giombini",
    "First Name": "Ennio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155541": {
    "id": "item_739",
    "Last Name": "Chartier",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155542": {
    "id": "item_30116",
    "Last Name": "Rosa Indah",
    "First Name": "Dewi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155547": {
    "id": "item_13148",
    "Last Name": "Pitts",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155548": {
    "id": "item_17352",
    "Last Name": "Moran",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155577": {
    "id": "item_726",
    "Last Name": "Young",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155581": {
    "id": "item_16016",
    "Last Name": "Koch",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155582": {
    "id": "item_5111",
    "Last Name": "Eames",
    "First Name": "Gabriel Ivan Louis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155584": {
    "id": "item_17339",
    "Last Name": "Muir",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155585": {
    "id": "item_16014",
    "Last Name": "Wong",
    "First Name": "Din chun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155617": {
    "id": "item_734",
    "Last Name": "Muffet",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155627": {
    "id": "item_28140",
    "Last Name": "CHEN",
    "First Name": "Yongqing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155631": {
    "id": "item_28158",
    "Last Name": "Wong",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155633": {
    "id": "item_5101",
    "Last Name": "Burrows",
    "First Name": "Derek",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155634": {
    "id": "item_30154",
    "Last Name": "Pitogo",
    "First Name": "Antolin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155648": {
    "id": "item_28147",
    "Last Name": "Galang",
    "First Name": "Ciro Augusto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155680": {
    "id": "item_17338",
    "Last Name": "Fraser",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155686": {
    "id": "item_729",
    "Last Name": "Scholtz",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155707": {
    "id": "item_5102",
    "Last Name": "Hoang",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155714": {
    "id": "item_732",
    "Last Name": "Turner",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155726": {
    "id": "item_16007",
    "Last Name": "Yeung",
    "First Name": "Yu Ming",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155727": {
    "id": "item_17327",
    "Last Name": "Wu",
    "First Name": "Han",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155733": {
    "id": "item_16010",
    "Last Name": "Hardcastle",
    "First Name": "Mercedez",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155740": {
    "id": "item_16009",
    "Last Name": "Vidal Hurtado",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155742": {
    "id": "item_17331",
    "Last Name": "Gates",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155750": {
    "id": "item_5091",
    "Last Name": "Andrews",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155755": {
    "id": "item_17313",
    "Last Name": "Lai",
    "First Name": "Serene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155759": {
    "id": "item_17303",
    "Last Name": "Haigh",
    "First Name": "Toni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155789": {
    "id": "item_17289",
    "Last Name": "Moran",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155809": {
    "id": "item_2667",
    "Last Name": "Quinn",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155810": {
    "id": "item_17298",
    "Last Name": "Carlson",
    "First Name": "BaiLeigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155813": {
    "id": "item_17311",
    "Last Name": "Haklar",
    "First Name": "Geordi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155816": {
    "id": "item_28149",
    "Last Name": "Silas",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155817": {
    "id": "item_17305",
    "Last Name": "Klomp",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155844": {
    "id": "item_721",
    "Last Name": "Lang",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155858": {
    "id": "item_28141",
    "Last Name": "Crafts",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155862": {
    "id": "item_17301",
    "Last Name": "Shea",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155864": {
    "id": "item_28144",
    "Last Name": "Lindhe",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155869": {
    "id": "item_17296",
    "Last Name": "Halchenko",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155871": {
    "id": "item_5090",
    "Last Name": "Yilmaz",
    "First Name": "Ty",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155914": {
    "id": "item_16004",
    "Last Name": "Pickard",
    "First Name": "Ariane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155915": {
    "id": "item_17295",
    "Last Name": "Zhang",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155918": {
    "id": "item_5082",
    "Last Name": "Elwiss",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155920": {
    "id": "item_30142",
    "Last Name": "Drummond",
    "First Name": "Jill",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155927": {
    "id": "item_28125",
    "Last Name": "Hand",
    "First Name": "April",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155936": {
    "id": "item_17291",
    "Last Name": "Battye",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155937": {
    "id": "item_17293",
    "Last Name": "Woollett",
    "First Name": "Beth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155940": {
    "id": "item_17283",
    "Last Name": "Yoon",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155943": {
    "id": "item_16001",
    "Last Name": "Kelly",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155949": {
    "id": "item_30141",
    "Last Name": "Erazo",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155953": {
    "id": "item_30130",
    "Last Name": "Riley",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155958": {
    "id": "item_719",
    "Last Name": "Cai",
    "First Name": "Chao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155966": {
    "id": "item_17284",
    "Last Name": "Paiva De Oliveira",
    "First Name": "Marina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155967": {
    "id": "item_28137",
    "Last Name": "Carino",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156007": {
    "id": "item_17282",
    "Last Name": "Carrick",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156010": {
    "id": "item_13128",
    "Last Name": "Zenil",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156032": {
    "id": "item_28107",
    "Last Name": "Jeffs",
    "First Name": "Kirsten",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156033": {
    "id": "item_30134",
    "Last Name": "Ablid",
    "First Name": "Mary Kimberly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156034": {
    "id": "item_717",
    "Last Name": "Mcdonald",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156037": {
    "id": "item_28120",
    "Last Name": "Calubaquib",
    "First Name": "Marie Dominique",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156038": {
    "id": "item_28127",
    "Last Name": "Tremain",
    "First Name": "Travis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156042": {
    "id": "item_17241",
    "Last Name": "Moulden",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156046": {
    "id": "item_30127",
    "Last Name": "Messyta",
    "First Name": "Ignes",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156051": {
    "id": "item_17279",
    "Last Name": "Sidana",
    "First Name": "Shivam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156056": {
    "id": "item_14051",
    "Last Name": "Tomlinson",
    "First Name": "Kelli",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156060": {
    "id": "item_2663",
    "Last Name": "Chin",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156064": {
    "id": "item_30132",
    "Last Name": "Aquino",
    "First Name": "Keanu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156073": {
    "id": "item_28130",
    "Last Name": "Leys",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156111": {
    "id": "item_13132",
    "Last Name": "Fitzgerald",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156118": {
    "id": "item_5067",
    "Last Name": "Cataldo",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156131": {
    "id": "item_26412",
    "Last Name": "Slotoroff",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156135": {
    "id": "item_5060",
    "Last Name": "Lee",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156168": {
    "id": "item_5062",
    "Last Name": "Wiranata",
    "First Name": "Gerald",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156175": {
    "id": "item_17252",
    "Last Name": "Innes",
    "First Name": "Rhiannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156176": {
    "id": "item_13131",
    "Last Name": "Neild",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156181": {
    "id": "item_30124",
    "Last Name": "Moakes-Evans",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156194": {
    "id": "item_30126",
    "Last Name": "Hidalgo",
    "First Name": "Christian Styner",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156200": {
    "id": "item_17265",
    "Last Name": "Rostholder",
    "First Name": "Erik",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156209": {
    "id": "item_30128",
    "Last Name": "Collins",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156210": {
    "id": "item_17248",
    "Last Name": "Ross",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156241": {
    "id": "item_17261",
    "Last Name": "Helsham",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156245": {
    "id": "item_5052",
    "Last Name": "Viddal",
    "First Name": "Kristoffer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156259": {
    "id": "item_2653",
    "Last Name": "Greaves",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156265": {
    "id": "item_30123",
    "Last Name": "Peterson",
    "First Name": "Virginia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156268": {
    "id": "item_701",
    "Last Name": "SALVANERA",
    "First Name": "ZECHARIAH",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156271": {
    "id": "item_696",
    "Last Name": "McMillan",
    "First Name": "Al",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156282": {
    "id": "item_31071",
    "Last Name": "Dela Cruz",
    "First Name": "Jojo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156286": {
    "id": "item_712",
    "Last Name": "Boundy",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156294": {
    "id": "item_28116",
    "Last Name": "Puleo",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156306": {
    "id": "item_30110",
    "Last Name": "Gibbons",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156308": {
    "id": "item_28114",
    "Last Name": "Wong Teo",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156323": {
    "id": "item_709",
    "Last Name": "Gallagher",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156333": {
    "id": "item_28877",
    "Last Name": "Berg",
    "First Name": "Dale",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156341": {
    "id": "item_15992",
    "Last Name": "Erigbuagas",
    "First Name": "Levi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156344": {
    "id": "item_5053",
    "Last Name": "Raward",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156349": {
    "id": "item_28096",
    "Last Name": "Kikuchi",
    "First Name": "Hiromi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156372": {
    "id": "item_5043",
    "Last Name": "Parkes",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156375": {
    "id": "item_28103",
    "Last Name": "Franceschi",
    "First Name": "Mario",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156390": {
    "id": "item_2643",
    "Last Name": "Ingle",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156394": {
    "id": "item_13124",
    "Last Name": "Jordan",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156418": {
    "id": "item_5033",
    "Last Name": "Evans",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156439": {
    "id": "item_17228",
    "Last Name": "Chang",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156440": {
    "id": "item_30114",
    "Last Name": "Vuong",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156442": {
    "id": "item_702",
    "Last Name": "Thacker",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156446": {
    "id": "item_30105",
    "Last Name": "PREAB",
    "First Name": "NATALIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156450": {
    "id": "item_703",
    "Last Name": "Kokinos",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156465": {
    "id": "item_28109",
    "Last Name": "Keating",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156491": {
    "id": "item_30107",
    "Last Name": "Low",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156502": {
    "id": "item_17185",
    "Last Name": "Huband",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156507": {
    "id": "item_698",
    "Last Name": "Alfiero",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156513": {
    "id": "item_5031",
    "Last Name": "Stevens",
    "First Name": "Beitris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156515": {
    "id": "item_5034",
    "Last Name": "Koudelka",
    "First Name": "Carl",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156523": {
    "id": "item_17219",
    "Last Name": "Martini",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156539": {
    "id": "item_2644",
    "Last Name": "Fok",
    "First Name": "Shun Kan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156544": {
    "id": "item_5037",
    "Last Name": "Guy",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156553": {
    "id": "item_28102",
    "Last Name": "Fortier",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156569": {
    "id": "item_17158",
    "Last Name": "Marvin",
    "First Name": "Yoshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156583": {
    "id": "item_5032",
    "Last Name": "Adams",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156585": {
    "id": "item_5028",
    "Last Name": "Spreckley",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156594": {
    "id": "item_30104",
    "Last Name": "Nguyen",
    "First Name": "Jenny Gia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156596": {
    "id": "item_5026",
    "Last Name": "Yip",
    "First Name": "Tak Fong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156630": {
    "id": "item_4999",
    "Last Name": "O Keeffe",
    "First Name": "Siobhan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156636": {
    "id": "item_17201",
    "Last Name": "Hird",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156646": {
    "id": "item_30097",
    "Last Name": "Murray",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156648": {
    "id": "item_17207",
    "Last Name": "Macilwain",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156654": {
    "id": "item_17204",
    "Last Name": "Dillard",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156662": {
    "id": "item_5023",
    "Last Name": "Frampton",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156677": {
    "id": "item_5018",
    "Last Name": "Jones",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156680": {
    "id": "item_17179",
    "Last Name": "carnevale",
    "First Name": "sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156686": {
    "id": "item_2641",
    "Last Name": "Engelbrecht",
    "First Name": "Pieter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156711": {
    "id": "item_17200",
    "Last Name": "Fu",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156724": {
    "id": "item_17195",
    "Last Name": "McClendon",
    "First Name": "Dallas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156725": {
    "id": "item_28093",
    "Last Name": "Binion",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156729": {
    "id": "item_17193",
    "Last Name": "Badenhorst",
    "First Name": "Nicolene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156747": {
    "id": "item_17189",
    "Last Name": "Sabo",
    "First Name": "Tami",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156761": {
    "id": "item_28089",
    "Last Name": "Santoro",
    "First Name": "Giuseppe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156798": {
    "id": "item_17184",
    "Last Name": "Turner",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156803": {
    "id": "item_28091",
    "Last Name": "Tecson",
    "First Name": "Marian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156819": {
    "id": "item_5012",
    "Last Name": "Dent",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156833": {
    "id": "item_675",
    "Last Name": "Fisher",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156855": {
    "id": "item_17177",
    "Last Name": "Nguyen",
    "First Name": "Enrique",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156864": {
    "id": "item_30092",
    "Last Name": "Pervera",
    "First Name": "Kerwin Kyle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156878": {
    "id": "item_30094",
    "Last Name": "Horvat",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156895": {
    "id": "item_15983",
    "Last Name": "Ng",
    "First Name": "Lai Soon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156911": {
    "id": "item_30093",
    "Last Name": "Patil",
    "First Name": "Prajyot",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156941": {
    "id": "item_17041",
    "Last Name": "Abella",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156942": {
    "id": "item_30086",
    "Last Name": "Bernitz",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156946": {
    "id": "item_17175",
    "Last Name": "Gonzalez",
    "First Name": "Arturo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156989": {
    "id": "item_682",
    "Last Name": "Tejada",
    "First Name": "Yen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156994": {
    "id": "item_17164",
    "Last Name": "Guirand",
    "First Name": "Herdy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156995": {
    "id": "item_28082",
    "Last Name": "Davenport",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156998": {
    "id": "item_2631",
    "Last Name": "Isaak",
    "First Name": "Lucian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157011": {
    "id": "item_2629",
    "Last Name": "Piperno",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157013": {
    "id": "item_30072",
    "Last Name": "Dredge",
    "First Name": "Lorraine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157014": {
    "id": "item_17162",
    "Last Name": "McMillan",
    "First Name": "Ralph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157029": {
    "id": "item_30080",
    "Last Name": "Ferguson",
    "First Name": "Alec",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157034": {
    "id": "item_5000",
    "Last Name": "perry",
    "First Name": "nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157049": {
    "id": "item_15979",
    "Last Name": "Crichton",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157055": {
    "id": "item_30065",
    "Last Name": "Smart",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157067": {
    "id": "item_17147",
    "Last Name": "Lai",
    "First Name": "Zhihui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157079": {
    "id": "item_17156",
    "Last Name": "Rendall",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157104": {
    "id": "item_17131",
    "Last Name": "Robin",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157105": {
    "id": "item_17145",
    "Last Name": "Cox",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157170": {
    "id": "item_4994",
    "Last Name": "Kastrinakis",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157176": {
    "id": "item_17137",
    "Last Name": "Condello",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157185": {
    "id": "item_30067",
    "Last Name": "Robinson",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157192": {
    "id": "item_30062",
    "Last Name": "Pamilar",
    "First Name": "Eddie Rick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157196": {
    "id": "item_14050",
    "Last Name": "Clohessy",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157199": {
    "id": "item_28064",
    "Last Name": "Limboto",
    "First Name": "Johan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157200": {
    "id": "item_673",
    "Last Name": "Hargreaves",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157202": {
    "id": "item_28068",
    "Last Name": "Hunt",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157213": {
    "id": "item_30061",
    "Last Name": "Teunissen",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157239": {
    "id": "item_17112",
    "Last Name": "Peirce",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157251": {
    "id": "item_30059",
    "Last Name": "Playford",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157268": {
    "id": "item_17126",
    "Last Name": "Kaban",
    "First Name": "Erkan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157283": {
    "id": "item_4984",
    "Last Name": "Sacca",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157319": {
    "id": "item_17237",
    "Last Name": "Kerwin",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157321": {
    "id": "item_30052",
    "Last Name": "Rosadi",
    "First Name": "Amran Zainuri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157336": {
    "id": "item_4986",
    "Last Name": "Warden",
    "First Name": "Doug",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157338": {
    "id": "item_15972",
    "Last Name": "Abbott",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157342": {
    "id": "item_4974",
    "Last Name": "Pacifici",
    "First Name": "Raffaele",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157353": {
    "id": "item_30049",
    "Last Name": "Smith",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157356": {
    "id": "item_17114",
    "Last Name": "Bowen",
    "First Name": "Rhiannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157364": {
    "id": "item_13104",
    "Last Name": "Porter",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157369": {
    "id": "item_2612",
    "Last Name": "Raley",
    "First Name": "Tabitha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157371": {
    "id": "item_30048",
    "Last Name": "Tan",
    "First Name": "Hazel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157376": {
    "id": "item_15973",
    "Last Name": "Middleton",
    "First Name": "Faith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157386": {
    "id": "item_664",
    "Last Name": "Patteeuw",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157387": {
    "id": "item_30051",
    "Last Name": "Contuzzi",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157389": {
    "id": "item_17113",
    "Last Name": "Peters",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157395": {
    "id": "item_4979",
    "Last Name": "Gordon",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157409": {
    "id": "item_17106",
    "Last Name": "Hardiman",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157418": {
    "id": "item_16333",
    "Last Name": "McSpadden",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157429": {
    "id": "item_4977",
    "Last Name": "Smit",
    "First Name": "Cam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157432": {
    "id": "item_17093",
    "Last Name": "Muir",
    "First Name": "Jenn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157434": {
    "id": "item_30045",
    "Last Name": "Brewer",
    "First Name": "Dean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157453": {
    "id": "item_4958",
    "Last Name": "Li",
    "First Name": "Lyla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157465": {
    "id": "item_4975",
    "Last Name": "Copeland",
    "First Name": "Kayleigh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157470": {
    "id": "item_17097",
    "Last Name": "Levey",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157484": {
    "id": "item_2603",
    "Last Name": "Burnheimer",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157487": {
    "id": "item_2608",
    "Last Name": "Kain",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157490": {
    "id": "item_2602",
    "Last Name": "Smith",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157493": {
    "id": "item_17091",
    "Last Name": "Bastasin",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157501": {
    "id": "item_17089",
    "Last Name": "Liew",
    "First Name": "Yvonne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157531": {
    "id": "item_4957",
    "Last Name": "Consolacion",
    "First Name": "Yestin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157535": {
    "id": "item_30038",
    "Last Name": "Cabonce",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157536": {
    "id": "item_17095",
    "Last Name": "Crumblin",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157546": {
    "id": "item_4970",
    "Last Name": "Heatley",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157547": {
    "id": "item_17077",
    "Last Name": "Yang",
    "First Name": "Yingyan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157551": {
    "id": "item_2605",
    "Last Name": "Huynh",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157556": {
    "id": "item_17085",
    "Last Name": "Donald",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157557": {
    "id": "item_17073",
    "Last Name": "Shackleton",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157567": {
    "id": "item_4966",
    "Last Name": "Thomas",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157578": {
    "id": "item_17083",
    "Last Name": "Raleigh",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157592": {
    "id": "item_28041",
    "Last Name": "Budhi",
    "First Name": "Ratih Andani Setyo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157606": {
    "id": "item_4964",
    "Last Name": "mcpherson",
    "First Name": "angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157611": {
    "id": "item_28045",
    "Last Name": "Hewitt",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157624": {
    "id": "item_4965",
    "Last Name": "Souter",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157627": {
    "id": "item_17072",
    "Last Name": "Hidalgo",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157633": {
    "id": "item_30022",
    "Last Name": "Chan",
    "First Name": "Yik Hong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157634": {
    "id": "item_30030",
    "Last Name": "Favelle",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157639": {
    "id": "item_26502",
    "Last Name": "Shek",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157646": {
    "id": "item_28046",
    "Last Name": "Lim",
    "First Name": "Jiin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157647": {
    "id": "item_656",
    "Last Name": "ashaolu",
    "First Name": "tomisin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157660": {
    "id": "item_17070",
    "Last Name": "Darika",
    "First Name": "Elijah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157663": {
    "id": "item_17061",
    "Last Name": "Bien",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157684": {
    "id": "item_657",
    "Last Name": "Saldarriaga",
    "First Name": "Milagros",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157729": {
    "id": "item_30024",
    "Last Name": "Simmons",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157734": {
    "id": "item_17064",
    "Last Name": "Giraldo Caro",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157763": {
    "id": "item_13099",
    "Last Name": "Berean",
    "First Name": "Jen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157768": {
    "id": "item_28040",
    "Last Name": "Harbin",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157773": {
    "id": "item_2592",
    "Last Name": "McCabe",
    "First Name": "Elsa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157780": {
    "id": "item_17058",
    "Last Name": "TAYLOR",
    "First Name": "PAIGE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157790": {
    "id": "item_30023",
    "Last Name": "Morgan",
    "First Name": "Brent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157807": {
    "id": "item_4950",
    "Last Name": "Hogan",
    "First Name": "Seb",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157808": {
    "id": "item_652",
    "Last Name": "Campbell",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157817": {
    "id": "item_17057",
    "Last Name": "Wang",
    "First Name": "Shuai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157818": {
    "id": "item_28038",
    "Last Name": "Hidayah",
    "First Name": "Rahmat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157827": {
    "id": "item_28036",
    "Last Name": "koens",
    "First Name": "sonia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157849": {
    "id": "item_17051",
    "Last Name": "Nash",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157877": {
    "id": "item_28023",
    "Last Name": "Jewell",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157880": {
    "id": "item_2587",
    "Last Name": "Lewis",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157885": {
    "id": "item_28033",
    "Last Name": "Roche",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157901": {
    "id": "item_4944",
    "Last Name": "Chakrabarti",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157911": {
    "id": "item_646",
    "Last Name": "Bickhoff",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157922": {
    "id": "item_30021",
    "Last Name": "Dunkerley",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157925": {
    "id": "item_14049",
    "Last Name": "Dhar",
    "First Name": "Adi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157928": {
    "id": "item_641",
    "Last Name": "Soon",
    "First Name": "An Sen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157954": {
    "id": "item_30020",
    "Last Name": "tian",
    "First Name": "zhaoping",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157962": {
    "id": "item_17045",
    "Last Name": "Tang",
    "First Name": "Jared",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157985": {
    "id": "item_28024",
    "Last Name": "Elgar",
    "First Name": "Cathy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157997": {
    "id": "item_28022",
    "Last Name": "Krauklis",
    "First Name": "Micayla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157999": {
    "id": "item_28025",
    "Last Name": "Clarke",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158003": {
    "id": "item_15960",
    "Last Name": "Thompson",
    "First Name": "Grant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158012": {
    "id": "item_15961",
    "Last Name": "Alvaro",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158019": {
    "id": "item_30012",
    "Last Name": "Thompson",
    "First Name": "Neil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158047": {
    "id": "item_28018",
    "Last Name": "Vazquez Flores",
    "First Name": "Ileana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158065": {
    "id": "item_28020",
    "Last Name": "Andrade",
    "First Name": "Clorinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158087": {
    "id": "item_4934",
    "Last Name": "Colverd",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158095": {
    "id": "item_17024",
    "Last Name": "Yang",
    "First Name": "Changwen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158106": {
    "id": "item_15958",
    "Last Name": "Blaney",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158121": {
    "id": "item_4935",
    "Last Name": "Scott",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158124": {
    "id": "item_13092",
    "Last Name": "OÕSullivan",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158134": {
    "id": "item_2573",
    "Last Name": "Romagnoli",
    "First Name": "Paolo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158149": {
    "id": "item_633",
    "Last Name": "Cornick",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158152": {
    "id": "item_2577",
    "Last Name": "Rofe",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158160": {
    "id": "item_636",
    "Last Name": "Westendorp",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158166": {
    "id": "item_17025",
    "Last Name": "Nguyen",
    "First Name": "Allan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158167": {
    "id": "item_28012",
    "Last Name": "Johnston",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158178": {
    "id": "item_632",
    "Last Name": "Howard",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158203": {
    "id": "item_15955",
    "Last Name": "Alexander",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158221": {
    "id": "item_17022",
    "Last Name": "Sellinger",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158222": {
    "id": "item_17003",
    "Last Name": "Woodburn",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158223": {
    "id": "item_17008",
    "Last Name": "Borja",
    "First Name": "Jereme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158228": {
    "id": "item_17017",
    "Last Name": "court",
    "First Name": "kris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158232": {
    "id": "item_13981",
    "Last Name": "Damian",
    "First Name": "Honey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158244": {
    "id": "item_30004",
    "Last Name": "Nagy",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158253": {
    "id": "item_631",
    "Last Name": "Duncan",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158258": {
    "id": "item_17018",
    "Last Name": "Vreugdenhil",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158271": {
    "id": "item_4907",
    "Last Name": "Wright",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158290": {
    "id": "item_13087",
    "Last Name": "Mccloy",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158294": {
    "id": "item_4923",
    "Last Name": "Freeman",
    "First Name": "Karyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158303": {
    "id": "item_621",
    "Last Name": "Douglas",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158308": {
    "id": "item_17013",
    "Last Name": "Nguyen",
    "First Name": "Van",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158309": {
    "id": "item_2570",
    "Last Name": "Morgan",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158319": {
    "id": "item_17006",
    "Last Name": "Conroy",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158333": {
    "id": "item_2568",
    "Last Name": "Casey",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158337": {
    "id": "item_625",
    "Last Name": "Xuereb",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158356": {
    "id": "item_28004",
    "Last Name": "Khan",
    "First Name": "Ahmer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158367": {
    "id": "item_624",
    "Last Name": "Vaughan",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158369": {
    "id": "item_29998",
    "Last Name": "song",
    "First Name": "manli",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158374": {
    "id": "item_627",
    "Last Name": "Secombe",
    "First Name": "Ella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158380": {
    "id": "item_1429",
    "Last Name": "Watt",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158394": {
    "id": "item_17004",
    "Last Name": "Horn",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158395": {
    "id": "item_2566",
    "Last Name": "Thomas",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158407": {
    "id": "item_2563",
    "Last Name": "Goldsmith",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158412": {
    "id": "item_16998",
    "Last Name": "Bolger",
    "First Name": "Tayarna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158432": {
    "id": "item_29976",
    "Last Name": "Gallardo",
    "First Name": "Milica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158440": {
    "id": "item_16997",
    "Last Name": "Bellenger",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158463": {
    "id": "item_16996",
    "Last Name": "SHI",
    "First Name": "LI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158472": {
    "id": "item_16999",
    "Last Name": "Olliver",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158474": {
    "id": "item_16993",
    "Last Name": "Hayes",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158484": {
    "id": "item_29982",
    "Last Name": "Tsai",
    "First Name": "Tzuwei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158485": {
    "id": "item_16991",
    "Last Name": "Roqica-Chang",
    "First Name": "Caty",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158486": {
    "id": "item_29990",
    "Last Name": "Williams",
    "First Name": "Ellena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158491": {
    "id": "item_15953",
    "Last Name": "LAU",
    "First Name": "TZE KEE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158493": {
    "id": "item_2557",
    "Last Name": "Betances",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158506": {
    "id": "item_2552",
    "Last Name": "Mustica",
    "First Name": "Marino",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158534": {
    "id": "item_2553",
    "Last Name": "Clinch",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158537": {
    "id": "item_618",
    "Last Name": "Salter",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158543": {
    "id": "item_4912",
    "Last Name": "Sereno",
    "First Name": "Ainsley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158547": {
    "id": "item_2550",
    "Last Name": "Cheung",
    "First Name": "Ko Ming",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158548": {
    "id": "item_13082",
    "Last Name": "Clarke",
    "First Name": "Casey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158555": {
    "id": "item_13080",
    "Last Name": "Quinn",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158565": {
    "id": "item_4914",
    "Last Name": "Fursdon",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158569": {
    "id": "item_16982",
    "Last Name": "bean",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158573": {
    "id": "item_29978",
    "Last Name": "Tanglao",
    "First Name": "Chenoa Noelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158582": {
    "id": "item_4910",
    "Last Name": "Millan",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158599": {
    "id": "item_4904",
    "Last Name": "Buchanan",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158601": {
    "id": "item_13079",
    "Last Name": "Rendell",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158618": {
    "id": "item_15950",
    "Last Name": "Matanguihan",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158621": {
    "id": "item_4897",
    "Last Name": "Palmer",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158625": {
    "id": "item_4906",
    "Last Name": "Slattery",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158631": {
    "id": "item_16947",
    "Last Name": "Lee",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158637": {
    "id": "item_4901",
    "Last Name": "Wighton",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158645": {
    "id": "item_16951",
    "Last Name": "Reeves",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158654": {
    "id": "item_609",
    "Last Name": "Romero",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158668": {
    "id": "item_27985",
    "Last Name": "Kaju",
    "First Name": "Albertin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158689": {
    "id": "item_27994",
    "Last Name": "Berry",
    "First Name": "Trenton",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158692": {
    "id": "item_4902",
    "Last Name": "Lush",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158710": {
    "id": "item_15947",
    "Last Name": "Stephens",
    "First Name": "Jen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158711": {
    "id": "item_29971",
    "Last Name": "Chen",
    "First Name": "Hao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158713": {
    "id": "item_16946",
    "Last Name": "Mahayagoda",
    "First Name": "Tilan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158755": {
    "id": "item_4889",
    "Last Name": "Ryan",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158769": {
    "id": "item_16953",
    "Last Name": "Chan",
    "First Name": "Ka Hei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158773": {
    "id": "item_4893",
    "Last Name": "Yates",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158775": {
    "id": "item_2542",
    "Last Name": "Millar",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158779": {
    "id": "item_27992",
    "Last Name": "Dickenson",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158809": {
    "id": "item_4875",
    "Last Name": "Freeman",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158814": {
    "id": "item_4888",
    "Last Name": "Raja",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158823": {
    "id": "item_27986",
    "Last Name": "Redmond",
    "First Name": "Miranda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158828": {
    "id": "item_16949",
    "Last Name": "Crehan",
    "First Name": "Richie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158831": {
    "id": "item_29959",
    "Last Name": "Esguerra",
    "First Name": "Michael Angelo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158839": {
    "id": "item_16948",
    "Last Name": "Yu",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158866": {
    "id": "item_16930",
    "Last Name": "Trinidad",
    "First Name": "Napoleon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158874": {
    "id": "item_16931",
    "Last Name": "Wing Fat",
    "First Name": "Li",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158882": {
    "id": "item_4878",
    "Last Name": "Kilpatrick",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158884": {
    "id": "item_4877",
    "Last Name": "Wright",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158889": {
    "id": "item_4879",
    "Last Name": "Gibbs",
    "First Name": "Erica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158912": {
    "id": "item_2535",
    "Last Name": "Lee",
    "First Name": "Bangsoo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158925": {
    "id": "item_16925",
    "Last Name": "Gordon",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158931": {
    "id": "item_16938",
    "Last Name": "Saniga",
    "First Name": "Debra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158962": {
    "id": "item_4872",
    "Last Name": "Pecoraro",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158968": {
    "id": "item_16932",
    "Last Name": "cameron",
    "First Name": "sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159001": {
    "id": "item_16854",
    "Last Name": "Giles",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159016": {
    "id": "item_4871",
    "Last Name": "Brown",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159023": {
    "id": "item_29940",
    "Last Name": "White",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159025": {
    "id": "item_29944",
    "Last Name": "Nishida",
    "First Name": "Chikako",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159036": {
    "id": "item_29951",
    "Last Name": "Yamashiro",
    "First Name": "Yuki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159043": {
    "id": "item_13075",
    "Last Name": "Ho",
    "First Name": "Bao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159054": {
    "id": "item_595",
    "Last Name": "Reyes Ramirez",
    "First Name": "Meriza Yanira",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159057": {
    "id": "item_29949",
    "Last Name": "Kinsella",
    "First Name": "Terri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159089": {
    "id": "item_27978",
    "Last Name": "Sharma",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159094": {
    "id": "item_29947",
    "Last Name": "Jenkins",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159097": {
    "id": "item_29943",
    "Last Name": "Griffiths",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159103": {
    "id": "item_16907",
    "Last Name": "LEONG",
    "First Name": "EDMUND",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159116": {
    "id": "item_29941",
    "Last Name": "Mojica",
    "First Name": "Maria Isabel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159181": {
    "id": "item_15941",
    "Last Name": "Ly",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159185": {
    "id": "item_4866",
    "Last Name": "Chalker",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159189": {
    "id": "item_2530",
    "Last Name": "Williamson",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159194": {
    "id": "item_597",
    "Last Name": "Mak",
    "First Name": "Kai Chung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159206": {
    "id": "item_15942",
    "Last Name": "Ng",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159238": {
    "id": "item_16904",
    "Last Name": "Yen",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159247": {
    "id": "item_16887",
    "Last Name": "KUAN",
    "First Name": "SUM YEE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159255": {
    "id": "item_29935",
    "Last Name": "Shibata",
    "First Name": "Konoka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159270": {
    "id": "item_4839",
    "Last Name": "Cai",
    "First Name": "Gengqing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159293": {
    "id": "item_29936",
    "Last Name": "Spain",
    "First Name": "Marnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159296": {
    "id": "item_2531",
    "Last Name": "Pescodd",
    "First Name": "Carly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159331": {
    "id": "item_2527",
    "Last Name": "Sutherland",
    "First Name": "Carmel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159333": {
    "id": "item_16875",
    "Last Name": "Wachter",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159352": {
    "id": "item_4854",
    "Last Name": "Matthews",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159358": {
    "id": "item_4853",
    "Last Name": "Tay",
    "First Name": "Jin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159361": {
    "id": "item_16889",
    "Last Name": "Cavalli",
    "First Name": "Jared",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159364": {
    "id": "item_16882",
    "Last Name": "Barnes",
    "First Name": "Willis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159390": {
    "id": "item_4847",
    "Last Name": "Sikder",
    "First Name": "Mohammad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159392": {
    "id": "item_27966",
    "Last Name": "Sullivan",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159393": {
    "id": "item_16332",
    "Last Name": "Ranola",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159395": {
    "id": "item_26501",
    "Last Name": "Li",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159401": {
    "id": "item_2522",
    "Last Name": "Woolford",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159405": {
    "id": "item_29920",
    "Last Name": "Kwan",
    "First Name": "Kai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159422": {
    "id": "item_15940",
    "Last Name": "Liddiard",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159429": {
    "id": "item_16873",
    "Last Name": "Collings",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159439": {
    "id": "item_547",
    "Last Name": "Yao",
    "First Name": "Ning",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159447": {
    "id": "item_29923",
    "Last Name": "Barber",
    "First Name": "Meghan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159449": {
    "id": "item_4849",
    "Last Name": "JIANG",
    "First Name": "Qiancheng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159469": {
    "id": "item_13065",
    "Last Name": "Ng",
    "First Name": "Ching Fai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159471": {
    "id": "item_16811",
    "Last Name": "HARVEY",
    "First Name": "BRIAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159488": {
    "id": "item_27958",
    "Last Name": "Nacorda",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159492": {
    "id": "item_16848",
    "Last Name": "Gilmore",
    "First Name": "Keiran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159502": {
    "id": "item_16863",
    "Last Name": "Gomez",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159515": {
    "id": "item_4841",
    "Last Name": "Blake",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159526": {
    "id": "item_16858",
    "Last Name": "Zhang",
    "First Name": "Chunxiao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159527": {
    "id": "item_16827",
    "Last Name": "Li",
    "First Name": "Man Chun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159530": {
    "id": "item_16864",
    "Last Name": "Walter",
    "First Name": "Janine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159534": {
    "id": "item_16856",
    "Last Name": "Nguyen",
    "First Name": "Minh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159549": {
    "id": "item_16849",
    "Last Name": "DORROUGH",
    "First Name": "FREDDY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159550": {
    "id": "item_27952",
    "Last Name": "Scott",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159559": {
    "id": "item_27957",
    "Last Name": "Cocciardi",
    "First Name": "Clare",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159564": {
    "id": "item_585",
    "Last Name": "Peel",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159570": {
    "id": "item_2518",
    "Last Name": "Mitchell",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159578": {
    "id": "item_29910",
    "Last Name": "Huynh",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159587": {
    "id": "item_4832",
    "Last Name": "Stapleton",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159593": {
    "id": "item_589",
    "Last Name": "Stewart",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159622": {
    "id": "item_16837",
    "Last Name": "Normoyle",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159635": {
    "id": "item_16841",
    "Last Name": "Dunne",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159650": {
    "id": "item_16838",
    "Last Name": "Lu",
    "First Name": "Wilson Jian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159657": {
    "id": "item_16843",
    "Last Name": "Goetjens",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159662": {
    "id": "item_29900",
    "Last Name": "Kwan",
    "First Name": "Tak Leung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159671": {
    "id": "item_16815",
    "Last Name": "Morgan",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159688": {
    "id": "item_16836",
    "Last Name": "Hicks",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159691": {
    "id": "item_16833",
    "Last Name": "Marcato",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159695": {
    "id": "item_16824",
    "Last Name": "Brad simmons",
    "First Name": "Brad simmons",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159701": {
    "id": "item_4801",
    "Last Name": "Zhao",
    "First Name": "Liang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159707": {
    "id": "item_16834",
    "Last Name": "Gallagher",
    "First Name": "Leeona",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159718": {
    "id": "item_4818",
    "Last Name": "Menon",
    "First Name": "Ashwin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159719": {
    "id": "item_16835",
    "Last Name": "Sheather-Robinson",
    "First Name": "Anya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159730": {
    "id": "item_13056",
    "Last Name": "Ackermann",
    "First Name": "Lutz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159732": {
    "id": "item_29902",
    "Last Name": "Binti Tengku Yahya",
    "First Name": "Tengku noor ashikin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159748": {
    "id": "item_16830",
    "Last Name": "Prada",
    "First Name": "Caterina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159754": {
    "id": "item_16816",
    "Last Name": "Atkinson",
    "First Name": "Lara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159756": {
    "id": "item_571",
    "Last Name": "Crossey",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159758": {
    "id": "item_29903",
    "Last Name": "Ballard",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159771": {
    "id": "item_4821",
    "Last Name": "Lo",
    "First Name": "Chuen Wai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159775": {
    "id": "item_16829",
    "Last Name": "Fallon",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159792": {
    "id": "item_16819",
    "Last Name": "Duong",
    "First Name": "Minh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159793": {
    "id": "item_13062",
    "Last Name": "Rogers-Jones",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159803": {
    "id": "item_16822",
    "Last Name": "Gaffney",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159820": {
    "id": "item_27949",
    "Last Name": "Hewitt",
    "First Name": "Barry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159834": {
    "id": "item_16801",
    "Last Name": "Lui",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159835": {
    "id": "item_2508",
    "Last Name": "Moonyup",
    "First Name": "Jang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159837": {
    "id": "item_16813",
    "Last Name": "Jacobsen",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159854": {
    "id": "item_13061",
    "Last Name": "Dunstan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159863": {
    "id": "item_575",
    "Last Name": "Church",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159866": {
    "id": "item_4799",
    "Last Name": "Broad",
    "First Name": "Harvey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159869": {
    "id": "item_29898",
    "Last Name": "Visvanathan",
    "First Name": "Sivenanthini",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159870": {
    "id": "item_4808",
    "Last Name": "Ball",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159876": {
    "id": "item_27945",
    "Last Name": "Choi",
    "First Name": "Hyunseok",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159880": {
    "id": "item_29894",
    "Last Name": "Fu",
    "First Name": "Jie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159889": {
    "id": "item_2510",
    "Last Name": "Lehane",
    "First Name": "Faye",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159890": {
    "id": "item_4809",
    "Last Name": "YANG",
    "First Name": "Yifei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159900": {
    "id": "item_4805",
    "Last Name": "Allison",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159902": {
    "id": "item_27941",
    "Last Name": "Teichtahl",
    "First Name": "Zvi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159907": {
    "id": "item_16807",
    "Last Name": "Atkinson",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159912": {
    "id": "item_4804",
    "Last Name": "Abraham",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159920": {
    "id": "item_16783",
    "Last Name": "Sun",
    "First Name": "Yige",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159954": {
    "id": "item_16800",
    "Last Name": "Paton",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159965": {
    "id": "item_16797",
    "Last Name": "Clark",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159981": {
    "id": "item_16799",
    "Last Name": "Ryan",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159985": {
    "id": "item_29888",
    "Last Name": "Searle",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160002": {
    "id": "item_4793",
    "Last Name": "Murphy",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160010": {
    "id": "item_29883",
    "Last Name": "Maher",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160018": {
    "id": "item_4792",
    "Last Name": "Cullen",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160026": {
    "id": "item_567",
    "Last Name": "Toole",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160038": {
    "id": "item_16795",
    "Last Name": "Corser",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160052": {
    "id": "item_27928",
    "Last Name": "Bourke",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160062": {
    "id": "item_16789",
    "Last Name": "Holohan",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160067": {
    "id": "item_16790",
    "Last Name": "Goble",
    "First Name": "Blair",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160076": {
    "id": "item_4789",
    "Last Name": "Mason",
    "First Name": "Kirrilly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160083": {
    "id": "item_16793",
    "Last Name": "Tang",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160090": {
    "id": "item_27930",
    "Last Name": "Ward",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160095": {
    "id": "item_15926",
    "Last Name": "Lord",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160099": {
    "id": "item_16788",
    "Last Name": "Shah",
    "First Name": "Tanay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160106": {
    "id": "item_560",
    "Last Name": "Wilson",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160113": {
    "id": "item_4782",
    "Last Name": "Cox",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160114": {
    "id": "item_558",
    "Last Name": "Jones",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160128": {
    "id": "item_16784",
    "Last Name": "Osadnik",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160129": {
    "id": "item_15929",
    "Last Name": "DeAngelis",
    "First Name": "Malgosia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160135": {
    "id": "item_561",
    "Last Name": "Martyn-Jones",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160169": {
    "id": "item_16777",
    "Last Name": "Ma",
    "First Name": "Wah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160179": {
    "id": "item_2494",
    "Last Name": "Heads",
    "First Name": "Damian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160182": {
    "id": "item_16776",
    "Last Name": "REYES MARTINEZ",
    "First Name": "MARIA JOSE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160192": {
    "id": "item_1428",
    "Last Name": "Appleton",
    "First Name": "Darryn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160242": {
    "id": "item_2495",
    "Last Name": "Hill",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160260": {
    "id": "item_553",
    "Last Name": "Beach",
    "First Name": "Bettina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160268": {
    "id": "item_555",
    "Last Name": "Hernandez",
    "First Name": "Belia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160281": {
    "id": "item_4771",
    "Last Name": "Atkins",
    "First Name": "Harvey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160298": {
    "id": "item_27924",
    "Last Name": "Basile-Hughes",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160300": {
    "id": "item_4770",
    "Last Name": "Catalano",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160302": {
    "id": "item_15924",
    "Last Name": "Webber",
    "First Name": "Bevan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160307": {
    "id": "item_4775",
    "Last Name": "Lawrence",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160323": {
    "id": "item_28588",
    "Last Name": "Purba",
    "First Name": "Oberlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160327": {
    "id": "item_25925",
    "Last Name": "HSIAO",
    "First Name": "YULIANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160352": {
    "id": "item_549",
    "Last Name": "Mathur",
    "First Name": "Nikolaus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160369": {
    "id": "item_13054",
    "Last Name": "McGrath",
    "First Name": "Ailbhe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160382": {
    "id": "item_29868",
    "Last Name": "Sheather",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160387": {
    "id": "item_545",
    "Last Name": "Stebbins",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160390": {
    "id": "item_27917",
    "Last Name": "Vella",
    "First Name": "Gena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160395": {
    "id": "item_13053",
    "Last Name": "Scarman",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160398": {
    "id": "item_548",
    "Last Name": "Osborne",
    "First Name": "Murray",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160407": {
    "id": "item_27916",
    "Last Name": "Raut",
    "First Name": "Prashant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160421": {
    "id": "item_16746",
    "Last Name": "GOODMAN",
    "First Name": "DANIEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160427": {
    "id": "item_28557",
    "Last Name": "Yang",
    "First Name": "Chin Yi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160434": {
    "id": "item_29861",
    "Last Name": "HSIEH",
    "First Name": "YA HUI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160436": {
    "id": "item_4761",
    "Last Name": "Nugroho",
    "First Name": "Muhammad Nazhif",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160461": {
    "id": "item_18537",
    "Last Name": "LIN",
    "First Name": "PO-YEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160462": {
    "id": "item_29865",
    "Last Name": "Clayton",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160463": {
    "id": "item_16751",
    "Last Name": "Shen",
    "First Name": "Yuchen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160475": {
    "id": "item_18544",
    "Last Name": "Sharma",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160476": {
    "id": "item_18548",
    "Last Name": "Arif",
    "First Name": "Muhammad Iqbal Fauzan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160485": {
    "id": "item_16745",
    "Last Name": "Kelly",
    "First Name": "Lachie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160501": {
    "id": "item_16738",
    "Last Name": "Mong",
    "First Name": "Cheuk Yin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160502": {
    "id": "item_543",
    "Last Name": "Wells",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160515": {
    "id": "item_18542",
    "Last Name": "Backx",
    "First Name": "Rogier",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160535": {
    "id": "item_16747",
    "Last Name": "Arjuna",
    "First Name": "Nirooshan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160555": {
    "id": "item_18531",
    "Last Name": "Chen",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160560": {
    "id": "item_30739",
    "Last Name": "Pannila",
    "First Name": "Chinthana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160569": {
    "id": "item_25954",
    "Last Name": "Caldwell",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160570": {
    "id": "item_16739",
    "Last Name": "Bennett",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160607": {
    "id": "item_3042",
    "Last Name": "Verhaeg",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160617": {
    "id": "item_1176",
    "Last Name": "Goldie",
    "First Name": "Jessie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160633": {
    "id": "item_28594",
    "Last Name": "Horgan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160645": {
    "id": "item_16211",
    "Last Name": "Laqui",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160650": {
    "id": "item_30743",
    "Last Name": "Diviacita",
    "First Name": "Indah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160651": {
    "id": "item_13686",
    "Last Name": "Carreon",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160654": {
    "id": "item_18546",
    "Last Name": "Wallace",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160669": {
    "id": "item_25944",
    "Last Name": "Heydari",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160690": {
    "id": "item_1180",
    "Last Name": "Orton",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160703": {
    "id": "item_25927",
    "Last Name": "HONG",
    "First Name": "HYUNBOON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160729": {
    "id": "item_18529",
    "Last Name": "Wheeler",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160732": {
    "id": "item_3039",
    "Last Name": "Barmby",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160736": {
    "id": "item_25937",
    "Last Name": "Ross",
    "First Name": "Neal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160737": {
    "id": "item_28589",
    "Last Name": "Thornhill",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160754": {
    "id": "item_25943",
    "Last Name": "Jacques",
    "First Name": "Line",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160759": {
    "id": "item_13680",
    "Last Name": "Olmos Berrio",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160761": {
    "id": "item_25934",
    "Last Name": "Beattie",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160763": {
    "id": "item_25939",
    "Last Name": "Gileppa",
    "First Name": "Tiani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160775": {
    "id": "item_18530",
    "Last Name": "MacDonald",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160798": {
    "id": "item_3036",
    "Last Name": "Kha",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160840": {
    "id": "item_30728",
    "Last Name": "Sneddon",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160842": {
    "id": "item_18526",
    "Last Name": "Tan",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160853": {
    "id": "item_25928",
    "Last Name": "Rumball",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160857": {
    "id": "item_28585",
    "Last Name": "Kasparov",
    "First Name": "Adolf",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160879": {
    "id": "item_18523",
    "Last Name": "Punzalan",
    "First Name": "Jan Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160887": {
    "id": "item_18519",
    "Last Name": "Comas",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160897": {
    "id": "item_16206",
    "Last Name": "Kashyap",
    "First Name": "Kush",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160938": {
    "id": "item_18484",
    "Last Name": "Douglass",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160942": {
    "id": "item_30724",
    "Last Name": "Kim",
    "First Name": "Jang Gyun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160947": {
    "id": "item_1154",
    "Last Name": "Huang",
    "First Name": "Kaizhen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160958": {
    "id": "item_18520",
    "Last Name": "Korpalski",
    "First Name": "Kacper",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160960": {
    "id": "item_25910",
    "Last Name": "Ortega",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160961": {
    "id": "item_13639",
    "Last Name": "Wong",
    "First Name": "Tai Wing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160965": {
    "id": "item_13675",
    "Last Name": "Harwell",
    "First Name": "Jenilee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160974": {
    "id": "item_28584",
    "Last Name": "Ytting",
    "First Name": "Aiden",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160978": {
    "id": "item_1166",
    "Last Name": "Larsen",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160989": {
    "id": "item_28579",
    "Last Name": "McKay",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161003": {
    "id": "item_16208",
    "Last Name": "Talerico",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161004": {
    "id": "item_30722",
    "Last Name": "Wortley",
    "First Name": "Tonile",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161011": {
    "id": "item_18515",
    "Last Name": "Lane",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161033": {
    "id": "item_13667",
    "Last Name": "Whitmore",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161050": {
    "id": "item_1164",
    "Last Name": "jobson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161052": {
    "id": "item_13672",
    "Last Name": "Maple",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161060": {
    "id": "item_13670",
    "Last Name": "Ohashi",
    "First Name": "Maki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161063": {
    "id": "item_25906",
    "Last Name": "Micallef",
    "First Name": "Silvana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161068": {
    "id": "item_1157",
    "Last Name": "Bartlett",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161080": {
    "id": "item_1162",
    "Last Name": "Navin",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161085": {
    "id": "item_25912",
    "Last Name": "Wang",
    "First Name": "Bo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161088": {
    "id": "item_25889",
    "Last Name": "Muyot",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161109": {
    "id": "item_3030",
    "Last Name": "Segantini",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161114": {
    "id": "item_18504",
    "Last Name": "Howard",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161123": {
    "id": "item_25909",
    "Last Name": "MAZZOLETTI",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161130": {
    "id": "item_25907",
    "Last Name": "Jacobs",
    "First Name": "Ainslie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161136": {
    "id": "item_18500",
    "Last Name": "Macpherson",
    "First Name": "Tyson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161140": {
    "id": "item_18495",
    "Last Name": "Vanderburg",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161143": {
    "id": "item_25902",
    "Last Name": "Liwaliw",
    "First Name": "Patricia Abigail",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161151": {
    "id": "item_18491",
    "Last Name": "Fallon",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161191": {
    "id": "item_25904",
    "Last Name": "Michalos",
    "First Name": "Rebeka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161202": {
    "id": "item_13664",
    "Last Name": "Misturi",
    "First Name": "Mat Sony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161217": {
    "id": "item_18490",
    "Last Name": "Gutknecht",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161220": {
    "id": "item_28570",
    "Last Name": "Ferguson",
    "First Name": "Kendrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161231": {
    "id": "item_26500",
    "Last Name": "Harvey",
    "First Name": "Ray",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161236": {
    "id": "item_28569",
    "Last Name": "Arrowsmith",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161238": {
    "id": "item_16202",
    "Last Name": "Dioluin",
    "First Name": "Cal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161243": {
    "id": "item_1152",
    "Last Name": "Lovett",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161244": {
    "id": "item_3024",
    "Last Name": "McCloud",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161262": {
    "id": "item_28571",
    "Last Name": "Carey",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161263": {
    "id": "item_30711",
    "Last Name": "Nichols",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161279": {
    "id": "item_18486",
    "Last Name": "Jenkins",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161283": {
    "id": "item_30712",
    "Last Name": "Latham",
    "First Name": "Deanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161290": {
    "id": "item_18487",
    "Last Name": "Fennessy",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161298": {
    "id": "item_3022",
    "Last Name": "Jones",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161299": {
    "id": "item_13656",
    "Last Name": "Beveridge",
    "First Name": "Todd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161311": {
    "id": "item_18449",
    "Last Name": "Santiago",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161314": {
    "id": "item_14048",
    "Last Name": "Lin",
    "First Name": "Pei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161318": {
    "id": "item_30714",
    "Last Name": "Son",
    "First Name": "Phi Run",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161325": {
    "id": "item_3021",
    "Last Name": "Leemon",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161334": {
    "id": "item_18482",
    "Last Name": "Martinez",
    "First Name": "Jose Luis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161335": {
    "id": "item_1141",
    "Last Name": "Kelly",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161336": {
    "id": "item_18477",
    "Last Name": "Williams",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161342": {
    "id": "item_13652",
    "Last Name": "Gordon-Menon",
    "First Name": "Sohana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161345": {
    "id": "item_18474",
    "Last Name": "Pecotich",
    "First Name": "Monica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161351": {
    "id": "item_18478",
    "Last Name": "Carr",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161356": {
    "id": "item_18481",
    "Last Name": "McAlister",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161370": {
    "id": "item_25886",
    "Last Name": "Whitt",
    "First Name": "Cheri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161371": {
    "id": "item_18471",
    "Last Name": "da Palma",
    "First Name": "Alisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161390": {
    "id": "item_18464",
    "Last Name": "Del Rosario",
    "First Name": "Mary Grace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161392": {
    "id": "item_28555",
    "Last Name": "Li",
    "First Name": "PEIHUA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161397": {
    "id": "item_1143",
    "Last Name": "Yakubanets",
    "First Name": "Sergey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161400": {
    "id": "item_25877",
    "Last Name": "TANG",
    "First Name": "PUI YI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161402": {
    "id": "item_30709",
    "Last Name": "Belton",
    "First Name": "Chance",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161422": {
    "id": "item_13648",
    "Last Name": "Burke-jeffries",
    "First Name": "Zac",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161429": {
    "id": "item_25887",
    "Last Name": "McMillan",
    "First Name": "Temisha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161436": {
    "id": "item_18468",
    "Last Name": "Levine",
    "First Name": "Cindy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161438": {
    "id": "item_25883",
    "Last Name": "wencckowski",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161464": {
    "id": "item_3016",
    "Last Name": "Dallimore",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161467": {
    "id": "item_18466",
    "Last Name": "Downings",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161474": {
    "id": "item_25880",
    "Last Name": "Desuyo",
    "First Name": "Arwyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161492": {
    "id": "item_30692",
    "Last Name": "Smith",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161494": {
    "id": "item_28559",
    "Last Name": "Wong",
    "First Name": "Diana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161500": {
    "id": "item_1101",
    "Last Name": "Fitzgerald",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161505": {
    "id": "item_18454",
    "Last Name": "Park",
    "First Name": "Joowon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161539": {
    "id": "item_25875",
    "Last Name": "McLeod",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161541": {
    "id": "item_25873",
    "Last Name": "Smith",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161548": {
    "id": "item_25871",
    "Last Name": "Minogue",
    "First Name": "Ger",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161551": {
    "id": "item_16197",
    "Last Name": "Williams",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161569": {
    "id": "item_30700",
    "Last Name": "Chou",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161575": {
    "id": "item_16195",
    "Last Name": "Jacka",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161579": {
    "id": "item_13642",
    "Last Name": "jang",
    "First Name": "geongu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161595": {
    "id": "item_18455",
    "Last Name": "Xu",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161616": {
    "id": "item_30695",
    "Last Name": "Yam",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161625": {
    "id": "item_30699",
    "Last Name": "Day",
    "First Name": "Lilly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161633": {
    "id": "item_13640",
    "Last Name": "Lee",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161647": {
    "id": "item_25866",
    "Last Name": "Thomas",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161653": {
    "id": "item_13634",
    "Last Name": "Kao",
    "First Name": "Chai Yen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161678": {
    "id": "item_25862",
    "Last Name": "Mc Donald",
    "First Name": "Conor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161680": {
    "id": "item_25867",
    "Last Name": "Lim",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161696": {
    "id": "item_28547",
    "Last Name": "Huynh",
    "First Name": "Johana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161731": {
    "id": "item_1133",
    "Last Name": "Taylor",
    "First Name": "Keegan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161749": {
    "id": "item_18440",
    "Last Name": "Budair",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161757": {
    "id": "item_3008",
    "Last Name": "fang",
    "First Name": "Yaojiajun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161759": {
    "id": "item_30690",
    "Last Name": "Hernandez",
    "First Name": "Guadalupe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161760": {
    "id": "item_3009",
    "Last Name": "MOK",
    "First Name": "KA WAI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161774": {
    "id": "item_30688",
    "Last Name": "Costa",
    "First Name": "Marta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161787": {
    "id": "item_26499",
    "Last Name": "Lam",
    "First Name": "Pak Kai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161791": {
    "id": "item_3004",
    "Last Name": "Freebairn",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161812": {
    "id": "item_18428",
    "Last Name": "Constantine",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161826": {
    "id": "item_25854",
    "Last Name": "Morgan",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161834": {
    "id": "item_16191",
    "Last Name": "Javier",
    "First Name": "John Karyl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161841": {
    "id": "item_2990",
    "Last Name": "Eveleigh",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161855": {
    "id": "item_25853",
    "Last Name": "Jefferies",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161874": {
    "id": "item_18431",
    "Last Name": "Paterson",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161881": {
    "id": "item_14047",
    "Last Name": "Choong",
    "First Name": "Joo Kee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161882": {
    "id": "item_25852",
    "Last Name": "Iliadis",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161911": {
    "id": "item_18423",
    "Last Name": "Patterson",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161921": {
    "id": "item_25822",
    "Last Name": "ge",
    "First Name": "hao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161929": {
    "id": "item_1122",
    "Last Name": "Kastrinakis",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161934": {
    "id": "item_18424",
    "Last Name": "Echano",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161947": {
    "id": "item_3002",
    "Last Name": "Eldridge-Waters",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161967": {
    "id": "item_25848",
    "Last Name": "Guerra",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161981": {
    "id": "item_30681",
    "Last Name": "Manlunas",
    "First Name": "Zyra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161983": {
    "id": "item_13628",
    "Last Name": "Frean",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162002": {
    "id": "item_1118",
    "Last Name": "Henderson",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162020": {
    "id": "item_28539",
    "Last Name": "Saing",
    "First Name": "Sok",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162028": {
    "id": "item_28532",
    "Last Name": "Streuderst",
    "First Name": "Heilani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162031": {
    "id": "item_1116",
    "Last Name": "Gloor",
    "First Name": "Erin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162061": {
    "id": "item_30680",
    "Last Name": "Suntau",
    "First Name": "Bodin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162063": {
    "id": "item_18418",
    "Last Name": "Almonicar",
    "First Name": "Marlon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162066": {
    "id": "item_18411",
    "Last Name": "Reid",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162080": {
    "id": "item_25831",
    "Last Name": "Ghee",
    "First Name": "Eng How",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162081": {
    "id": "item_25840",
    "Last Name": "Bayliss-White",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162117": {
    "id": "item_3263",
    "Last Name": "Connor",
    "First Name": "Maree",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162122": {
    "id": "item_18400",
    "Last Name": "Martinez",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162124": {
    "id": "item_18409",
    "Last Name": "Fung",
    "First Name": "Hui Tsun Vincent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162133": {
    "id": "item_13622",
    "Last Name": "Beattie",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162154": {
    "id": "item_30676",
    "Last Name": "Alonzo",
    "First Name": "Maria Theresa Justine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162161": {
    "id": "item_25834",
    "Last Name": "Rouillon",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162184": {
    "id": "item_18405",
    "Last Name": "Malone",
    "First Name": "Coen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162194": {
    "id": "item_2983",
    "Last Name": "Wong",
    "First Name": "Chun Kit Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162213": {
    "id": "item_18403",
    "Last Name": "Clark",
    "First Name": "Joelie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162215": {
    "id": "item_13620",
    "Last Name": "Keogh",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162216": {
    "id": "item_28524",
    "Last Name": "Wilson",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162219": {
    "id": "item_16186",
    "Last Name": "Scognamiglio",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162229": {
    "id": "item_28523",
    "Last Name": "Gehrig",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162242": {
    "id": "item_1075",
    "Last Name": "Balie",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162255": {
    "id": "item_30666",
    "Last Name": "SIANG",
    "First Name": "YEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162263": {
    "id": "item_2993",
    "Last Name": "coates",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162266": {
    "id": "item_13616",
    "Last Name": "Alarcon Rivera",
    "First Name": "Juan Felipe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162277": {
    "id": "item_18398",
    "Last Name": "Van Eekelen",
    "First Name": "Anita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162287": {
    "id": "item_30675",
    "Last Name": "Shipley",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162297": {
    "id": "item_18391",
    "Last Name": "Yeung",
    "First Name": "Yu Man",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162316": {
    "id": "item_28518",
    "Last Name": "Lima de Sousa",
    "First Name": "Lysandra Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162339": {
    "id": "item_28519",
    "Last Name": "Truong",
    "First Name": "Fithria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162372": {
    "id": "item_18364",
    "Last Name": "Howton",
    "First Name": "Maddison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162374": {
    "id": "item_25816",
    "Last Name": "Horng",
    "First Name": "Vuthy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162378": {
    "id": "item_2989",
    "Last Name": "Montanari",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162419": {
    "id": "item_25807",
    "Last Name": "Hasibuan",
    "First Name": "Kiki Nitalia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162446": {
    "id": "item_1106",
    "Last Name": "Stevenson",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162469": {
    "id": "item_16182",
    "Last Name": "Maldonado",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162481": {
    "id": "item_16184",
    "Last Name": "Otieno",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162484": {
    "id": "item_25809",
    "Last Name": "Tankersley",
    "First Name": "Shelagh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162509": {
    "id": "item_25779",
    "Last Name": "Dobosz",
    "First Name": "Katarzyna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162513": {
    "id": "item_18377",
    "Last Name": "Tu",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162526": {
    "id": "item_18382",
    "Last Name": "Brockhurst",
    "First Name": "Tiana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162543": {
    "id": "item_18361",
    "Last Name": "Chinhamo",
    "First Name": "Petronella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162546": {
    "id": "item_18372",
    "Last Name": "Smith",
    "First Name": "Myles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162553": {
    "id": "item_2981",
    "Last Name": "Cheung",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162558": {
    "id": "item_28499",
    "Last Name": "Tang",
    "First Name": "Kam Fai Robson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162562": {
    "id": "item_13603",
    "Last Name": "Jokinen",
    "First Name": "Liisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162595": {
    "id": "item_28513",
    "Last Name": "Hans",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162607": {
    "id": "item_30662",
    "Last Name": "Veiga",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162613": {
    "id": "item_16181",
    "Last Name": "Weaver",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162614": {
    "id": "item_30661",
    "Last Name": "Suntau",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162629": {
    "id": "item_25792",
    "Last Name": "Kupshik",
    "First Name": "Darron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162634": {
    "id": "item_2982",
    "Last Name": "Fragos",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162665": {
    "id": "item_25790",
    "Last Name": "Ng",
    "First Name": "Stanley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162672": {
    "id": "item_13597",
    "Last Name": "Pose",
    "First Name": "Sarais",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162694": {
    "id": "item_30651",
    "Last Name": "Bui",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162699": {
    "id": "item_30630",
    "Last Name": "Karilo",
    "First Name": "Gede Paskara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162716": {
    "id": "item_3262",
    "Last Name": "fu",
    "First Name": "longchang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162721": {
    "id": "item_1090",
    "Last Name": "Sumskas",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162726": {
    "id": "item_13595",
    "Last Name": "WAI PUI",
    "First Name": "VONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162739": {
    "id": "item_18360",
    "Last Name": "TEO",
    "First Name": "Chee Wen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162758": {
    "id": "item_18350",
    "Last Name": "Coe",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162772": {
    "id": "item_2976",
    "Last Name": "Moselen",
    "First Name": "Tenille",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162781": {
    "id": "item_18354",
    "Last Name": "Thorpe",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162785": {
    "id": "item_28509",
    "Last Name": "Urbanovski",
    "First Name": "Macy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162793": {
    "id": "item_18348",
    "Last Name": "ye",
    "First Name": "xicheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162797": {
    "id": "item_25777",
    "Last Name": "Howell",
    "First Name": "Simone",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162806": {
    "id": "item_18346",
    "Last Name": "Appeleyil",
    "First Name": "Alix",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162809": {
    "id": "item_28508",
    "Last Name": "Wilson",
    "First Name": "Denise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162811": {
    "id": "item_13587",
    "Last Name": "Keyte",
    "First Name": "Austin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162812": {
    "id": "item_18345",
    "Last Name": "Truong",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162817": {
    "id": "item_2974",
    "Last Name": "LEE",
    "First Name": "CHEUK HO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162851": {
    "id": "item_18347",
    "Last Name": "McGregor",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162864": {
    "id": "item_30648",
    "Last Name": "Westerhold",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162881": {
    "id": "item_25773",
    "Last Name": "Colobong",
    "First Name": "Rustan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162882": {
    "id": "item_1081",
    "Last Name": "Ho",
    "First Name": "Ka Yan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162886": {
    "id": "item_13586",
    "Last Name": "Shan",
    "First Name": "Xiaotong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162915": {
    "id": "item_18336",
    "Last Name": "FALCON",
    "First Name": "NELSON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162917": {
    "id": "item_28502",
    "Last Name": "Herold",
    "First Name": "Miriam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162922": {
    "id": "item_30641",
    "Last Name": "Ekanayake",
    "First Name": "Nimali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162926": {
    "id": "item_18333",
    "Last Name": "Bindoff",
    "First Name": "Daisie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162937": {
    "id": "item_18339",
    "Last Name": "Condi",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162948": {
    "id": "item_2969",
    "Last Name": "McCormick",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162955": {
    "id": "item_16177",
    "Last Name": "Velez",
    "First Name": "Manolo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162964": {
    "id": "item_1084",
    "Last Name": "Fischer",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162971": {
    "id": "item_18295",
    "Last Name": "Bong",
    "First Name": "Bobby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162972": {
    "id": "item_25765",
    "Last Name": "Boentarya",
    "First Name": "Joko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162999": {
    "id": "item_30638",
    "Last Name": "Covarrubias",
    "First Name": "Camila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163018": {
    "id": "item_2966",
    "Last Name": "ORTIZ CANAVATE MARIN",
    "First Name": "IGNACIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163023": {
    "id": "item_30639",
    "Last Name": "Wheeler",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163027": {
    "id": "item_13579",
    "Last Name": "Wijaya",
    "First Name": "Nicolaus Edwin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163031": {
    "id": "item_2957",
    "Last Name": "Munoz",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163049": {
    "id": "item_25763",
    "Last Name": "Bradley",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163051": {
    "id": "item_2965",
    "Last Name": "Buselli",
    "First Name": "Stella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163058": {
    "id": "item_13576",
    "Last Name": "Dudgeon",
    "First Name": "Todd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163062": {
    "id": "item_18329",
    "Last Name": "Sharp",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163077": {
    "id": "item_18324",
    "Last Name": "Elumba",
    "First Name": "Janno",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163088": {
    "id": "item_28500",
    "Last Name": "Mak",
    "First Name": "Shavonne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163100": {
    "id": "item_30629",
    "Last Name": "Pan",
    "First Name": "Rong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163105": {
    "id": "item_2961",
    "Last Name": "Buncle",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163110": {
    "id": "item_16175",
    "Last Name": "Rudolph",
    "First Name": "Navin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163115": {
    "id": "item_30632",
    "Last Name": "Wang",
    "First Name": "Songmin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163122": {
    "id": "item_30626",
    "Last Name": "Bin Setiyana",
    "First Name": "Muhammad Luqman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163126": {
    "id": "item_25759",
    "Last Name": "Ringo",
    "First Name": "Sri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163140": {
    "id": "item_18316",
    "Last Name": "Lopez",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163148": {
    "id": "item_25756",
    "Last Name": "Fleming",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163158": {
    "id": "item_2955",
    "Last Name": "ROMAN GUTIERREZ",
    "First Name": "JOSE MARIA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163162": {
    "id": "item_18315",
    "Last Name": "Karp",
    "First Name": "Antony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163186": {
    "id": "item_25741",
    "Last Name": "Lee",
    "First Name": "Seungmook",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163199": {
    "id": "item_28498",
    "Last Name": "Urtula",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163218": {
    "id": "item_18310",
    "Last Name": "Cavenagh",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163225": {
    "id": "item_30625",
    "Last Name": "Thompson",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163226": {
    "id": "item_13569",
    "Last Name": "Swift",
    "First Name": "Deirdre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163238": {
    "id": "item_25751",
    "Last Name": "Cheung",
    "First Name": "Wai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163240": {
    "id": "item_1068",
    "Last Name": "Nguyen",
    "First Name": "Quy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163258": {
    "id": "item_16172",
    "Last Name": "Fong",
    "First Name": "Kwai Shing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163273": {
    "id": "item_16171",
    "Last Name": "Cruz",
    "First Name": "Carlos III",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163287": {
    "id": "item_13558",
    "Last Name": "Carey",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163294": {
    "id": "item_18307",
    "Last Name": "Mower",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163299": {
    "id": "item_13562",
    "Last Name": "Sarkhosh",
    "First Name": "Sarahjane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163326": {
    "id": "item_25748",
    "Last Name": "Azzalini",
    "First Name": "Dean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163327": {
    "id": "item_30618",
    "Last Name": "Latief",
    "First Name": "Yasmin Melani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163334": {
    "id": "item_30624",
    "Last Name": "Harahap",
    "First Name": "Armand",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163351": {
    "id": "item_28497",
    "Last Name": "Nepia",
    "First Name": "Tapuku",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163363": {
    "id": "item_16170",
    "Last Name": "Nguyen",
    "First Name": "Derek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163397": {
    "id": "item_16169",
    "Last Name": "Hung",
    "First Name": "Eddie Fan Yat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163413": {
    "id": "item_25740",
    "Last Name": "Chen",
    "First Name": "Shufeng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163432": {
    "id": "item_18297",
    "Last Name": "Masyuk",
    "First Name": "Oleksandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163455": {
    "id": "item_25736",
    "Last Name": "Wanigasekera",
    "First Name": "Rashanthi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163458": {
    "id": "item_2945",
    "Last Name": "Setiabudi",
    "First Name": "Andri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163461": {
    "id": "item_25738",
    "Last Name": "Craig",
    "First Name": "Jayne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163468": {
    "id": "item_25737",
    "Last Name": "Moses",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163474": {
    "id": "item_18294",
    "Last Name": "Sutherland",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163478": {
    "id": "item_18289",
    "Last Name": "Crowder",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163482": {
    "id": "item_14046",
    "Last Name": "Au",
    "First Name": "Cheuk Lam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163494": {
    "id": "item_25727",
    "Last Name": "Nguyen",
    "First Name": "Hong Quy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163508": {
    "id": "item_1067",
    "Last Name": "CHAN",
    "First Name": "KAI PUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163512": {
    "id": "item_2949",
    "Last Name": "Figueroa",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163533": {
    "id": "item_25734",
    "Last Name": "Madden",
    "First Name": "Maree",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163545": {
    "id": "item_25731",
    "Last Name": "Stewart",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163552": {
    "id": "item_13551",
    "Last Name": "Flanagan",
    "First Name": "Eoghan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163565": {
    "id": "item_13543",
    "Last Name": "Sumendap",
    "First Name": "Yulia Margaretha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163570": {
    "id": "item_25730",
    "Last Name": "Magnussen",
    "First Name": "Lexi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163578": {
    "id": "item_13530",
    "Last Name": "Barringon",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163595": {
    "id": "item_1060",
    "Last Name": "CHEN",
    "First Name": "HONGJIE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163598": {
    "id": "item_25725",
    "Last Name": "Angeles",
    "First Name": "Francis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163613": {
    "id": "item_25718",
    "Last Name": "De Vegarini",
    "First Name": "Citra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163621": {
    "id": "item_25721",
    "Last Name": "Pannozzi",
    "First Name": "Alyssa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163624": {
    "id": "item_25723",
    "Last Name": "Tatam",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163629": {
    "id": "item_28488",
    "Last Name": "Harold",
    "First Name": "Ranulph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163634": {
    "id": "item_13549",
    "Last Name": "Martin",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163636": {
    "id": "item_16165",
    "Last Name": "Love",
    "First Name": "Taj",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163646": {
    "id": "item_30611",
    "Last Name": "Carters",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163668": {
    "id": "item_18281",
    "Last Name": "DO",
    "First Name": "BRANDON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163670": {
    "id": "item_18280",
    "Last Name": "Chase",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163676": {
    "id": "item_13548",
    "Last Name": "Dobson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163677": {
    "id": "item_30609",
    "Last Name": "Pelham",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163678": {
    "id": "item_25715",
    "Last Name": "Sabarudin",
    "First Name": "Mohd Nur Iqdham",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163689": {
    "id": "item_1058",
    "Last Name": "Tran",
    "First Name": "Johnson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163715": {
    "id": "item_25714",
    "Last Name": "Rumble",
    "First Name": "Dennie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163716": {
    "id": "item_13544",
    "Last Name": "Ochtavia",
    "First Name": "Suhartini",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163729": {
    "id": "item_30601",
    "Last Name": "Webber",
    "First Name": "Jolanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163731": {
    "id": "item_18271",
    "Last Name": "Higgins",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163737": {
    "id": "item_25702",
    "Last Name": "Varela",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163759": {
    "id": "item_14045",
    "Last Name": "Trimmer",
    "First Name": "Larry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163781": {
    "id": "item_30581",
    "Last Name": "Delloro",
    "First Name": "Sean Willy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163784": {
    "id": "item_30605",
    "Last Name": "Ng",
    "First Name": "Derek",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163809": {
    "id": "item_2942",
    "Last Name": "Law",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163823": {
    "id": "item_25705",
    "Last Name": "Lehmann",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163846": {
    "id": "item_25703",
    "Last Name": "Angelia",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163847": {
    "id": "item_25704",
    "Last Name": "Li",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163887": {
    "id": "item_18260",
    "Last Name": "Allemand",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163890": {
    "id": "item_18258",
    "Last Name": "Peirson",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163914": {
    "id": "item_26498",
    "Last Name": "Xu",
    "First Name": "Peng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163921": {
    "id": "item_13522",
    "Last Name": "ANGELES",
    "First Name": "REYMUNDO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163922": {
    "id": "item_28474",
    "Last Name": "Dur‡n Vargas",
    "First Name": "Yesenia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163925": {
    "id": "item_18256",
    "Last Name": "Chavis",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163933": {
    "id": "item_25692",
    "Last Name": "Kelly",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163942": {
    "id": "item_13536",
    "Last Name": "Pynt",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163946": {
    "id": "item_18242",
    "Last Name": "Morrison",
    "First Name": "Rochelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163960": {
    "id": "item_18252",
    "Last Name": "Sneddon",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163979": {
    "id": "item_13538",
    "Last Name": "Crawford",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163993": {
    "id": "item_18240",
    "Last Name": "Roque",
    "First Name": "Jude David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164016": {
    "id": "item_30588",
    "Last Name": "Winter",
    "First Name": "Camilla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164026": {
    "id": "item_30593",
    "Last Name": "Yoo",
    "First Name": "Hyung Sun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164032": {
    "id": "item_28475",
    "Last Name": "Stenning",
    "First Name": "Juliette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164037": {
    "id": "item_28473",
    "Last Name": "Leepson",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164045": {
    "id": "item_5740",
    "Last Name": "Hetherington",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164072": {
    "id": "item_13532",
    "Last Name": "SHEN",
    "First Name": "Guoxiang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164076": {
    "id": "item_30591",
    "Last Name": "Addison",
    "First Name": "Hazel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164077": {
    "id": "item_25688",
    "Last Name": "Joslin",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164097": {
    "id": "item_13531",
    "Last Name": "Rich",
    "First Name": "Evan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164110": {
    "id": "item_1049",
    "Last Name": "Timoney",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164126": {
    "id": "item_18235",
    "Last Name": "Kantharia",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164129": {
    "id": "item_1050",
    "Last Name": "CHEN",
    "First Name": "RYAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164132": {
    "id": "item_5738",
    "Last Name": "Dowling",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164150": {
    "id": "item_25681",
    "Last Name": "Foote",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164152": {
    "id": "item_13526",
    "Last Name": "Chung",
    "First Name": "Kit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164155": {
    "id": "item_25683",
    "Last Name": "Ho",
    "First Name": "Bernard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164172": {
    "id": "item_18231",
    "Last Name": "Jackson",
    "First Name": "Skye",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164175": {
    "id": "item_13529",
    "Last Name": "Moore",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164176": {
    "id": "item_5718",
    "Last Name": "Hafreth",
    "First Name": "Haafi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164177": {
    "id": "item_30579",
    "Last Name": "Chow",
    "First Name": "Elana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164180": {
    "id": "item_13528",
    "Last Name": "Butault",
    "First Name": "Valentin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164183": {
    "id": "item_25650",
    "Last Name": "Anwar",
    "First Name": "Donny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164185": {
    "id": "item_5734",
    "Last Name": "Ohlmus",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164194": {
    "id": "item_13524",
    "Last Name": "Lam",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164196": {
    "id": "item_1043",
    "Last Name": "Chai",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164210": {
    "id": "item_5725",
    "Last Name": "Chen",
    "First Name": "Yan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164211": {
    "id": "item_16156",
    "Last Name": "Rios",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164217": {
    "id": "item_18221",
    "Last Name": "An",
    "First Name": "Le",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164218": {
    "id": "item_25677",
    "Last Name": "Ortiz",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164235": {
    "id": "item_1042",
    "Last Name": "Graham",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164239": {
    "id": "item_1041",
    "Last Name": "Plattner",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164244": {
    "id": "item_5733",
    "Last Name": "Drewett",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164281": {
    "id": "item_5731",
    "Last Name": "Ho",
    "First Name": "Yik Cheung Dickson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164287": {
    "id": "item_1427",
    "Last Name": "Vieira",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164306": {
    "id": "item_18217",
    "Last Name": "Desselle",
    "First Name": "Mathilde",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164323": {
    "id": "item_18215",
    "Last Name": "Pellew",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164333": {
    "id": "item_25668",
    "Last Name": "Morrison",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164338": {
    "id": "item_25666",
    "Last Name": "Rajendran",
    "First Name": "Manikandan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164372": {
    "id": "item_25669",
    "Last Name": "Heald",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164385": {
    "id": "item_30573",
    "Last Name": "Dela Cruz",
    "First Name": "Annalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164396": {
    "id": "item_25667",
    "Last Name": "Colafella",
    "First Name": "Alissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164418": {
    "id": "item_18199",
    "Last Name": "Nabong",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164424": {
    "id": "item_25665",
    "Last Name": "Palenkas",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164440": {
    "id": "item_28465",
    "Last Name": "Mohan-Ram",
    "First Name": "Arvi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164457": {
    "id": "item_2929",
    "Last Name": "Revels",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164458": {
    "id": "item_5721",
    "Last Name": "Wijesuriya",
    "First Name": "Dillon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164467": {
    "id": "item_13516",
    "Last Name": "Wong",
    "First Name": "Shifa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164471": {
    "id": "item_5719",
    "Last Name": "Law",
    "First Name": "Lee Sa Vanessa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164481": {
    "id": "item_25661",
    "Last Name": "Lipinski",
    "First Name": "Rikke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164493": {
    "id": "item_25658",
    "Last Name": "Estrada",
    "First Name": "Karl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164494": {
    "id": "item_5709",
    "Last Name": "Abadi",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164504": {
    "id": "item_16154",
    "Last Name": "Li",
    "First Name": "Weihong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164535": {
    "id": "item_30570",
    "Last Name": "Pattison",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164538": {
    "id": "item_30571",
    "Last Name": "Davies",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164560": {
    "id": "item_18197",
    "Last Name": "Nichols",
    "First Name": "Marty",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164574": {
    "id": "item_28463",
    "Last Name": "Symonds",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164580": {
    "id": "item_30567",
    "Last Name": "Baskcomb",
    "First Name": "Candida",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164616": {
    "id": "item_18191",
    "Last Name": "Leung",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164623": {
    "id": "item_25652",
    "Last Name": "Strutt",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164638": {
    "id": "item_25653",
    "Last Name": "Casey",
    "First Name": "Jai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164641": {
    "id": "item_18189",
    "Last Name": "Heuzenroeder",
    "First Name": "Philip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164651": {
    "id": "item_5704",
    "Last Name": "Williams",
    "First Name": "Graham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164652": {
    "id": "item_5705",
    "Last Name": "Limrattanakan",
    "First Name": "Komes",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164658": {
    "id": "item_18188",
    "Last Name": "Watt",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164662": {
    "id": "item_28459",
    "Last Name": "Cadden",
    "First Name": "Shaunna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164686": {
    "id": "item_1031",
    "Last Name": "Keating",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164711": {
    "id": "item_28458",
    "Last Name": "Lee-Ross",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164726": {
    "id": "item_18186",
    "Last Name": "Evans",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164737": {
    "id": "item_18185",
    "Last Name": "de Franzoni",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164752": {
    "id": "item_25646",
    "Last Name": "Harrowfield",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164769": {
    "id": "item_5698",
    "Last Name": "Dare",
    "First Name": "Sharna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164771": {
    "id": "item_5701",
    "Last Name": "Bencsik",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164774": {
    "id": "item_28455",
    "Last Name": "Bailes",
    "First Name": "Jayne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164777": {
    "id": "item_18182",
    "Last Name": "Cardoso Castro",
    "First Name": "Awiri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164784": {
    "id": "item_13509",
    "Last Name": "Seen",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164802": {
    "id": "item_5695",
    "Last Name": "Mitchell",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164846": {
    "id": "item_28454",
    "Last Name": "Suico",
    "First Name": "Maria Bernadette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164847": {
    "id": "item_5694",
    "Last Name": "Oliver",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164859": {
    "id": "item_18171",
    "Last Name": "Osborne",
    "First Name": "Antony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164866": {
    "id": "item_13507",
    "Last Name": "Zannes",
    "First Name": "Bree",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164905": {
    "id": "item_13506",
    "Last Name": "Patch",
    "First Name": "Kayla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164922": {
    "id": "item_5693",
    "Last Name": "Hsieh",
    "First Name": "Ji-An",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164954": {
    "id": "item_30552",
    "Last Name": "Esma",
    "First Name": "Frechie Vega",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164965": {
    "id": "item_30551",
    "Last Name": "Yii",
    "First Name": "See Liong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165018": {
    "id": "item_26411",
    "Last Name": "Motyka",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165038": {
    "id": "item_5690",
    "Last Name": "Logie",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165039": {
    "id": "item_18161",
    "Last Name": "SHA",
    "First Name": "QI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165041": {
    "id": "item_5688",
    "Last Name": "Herron",
    "First Name": "Luisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165044": {
    "id": "item_26410",
    "Last Name": "Jayoung",
    "First Name": "Jung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165060": {
    "id": "item_5689",
    "Last Name": "Cotter",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165066": {
    "id": "item_18158",
    "Last Name": "Quiquinato",
    "First Name": "Bruna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165068": {
    "id": "item_13503",
    "Last Name": "Thomson",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165074": {
    "id": "item_30549",
    "Last Name": "Grose",
    "First Name": "Lindy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165106": {
    "id": "item_5683",
    "Last Name": "Lai",
    "First Name": "Erica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165120": {
    "id": "item_16146",
    "Last Name": "Lee",
    "First Name": "Chuck Po",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165148": {
    "id": "item_25645",
    "Last Name": "Kieliszek",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165152": {
    "id": "item_18149",
    "Last Name": "Sanchez Sainz",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165181": {
    "id": "item_18155",
    "Last Name": "Mackenzie",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165189": {
    "id": "item_18150",
    "Last Name": "McRae",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165192": {
    "id": "item_1023",
    "Last Name": "Donakey",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165202": {
    "id": "item_30542",
    "Last Name": "Liu",
    "First Name": "Shu-ting",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165203": {
    "id": "item_16142",
    "Last Name": "Pettigrew",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165241": {
    "id": "item_5685",
    "Last Name": "Buyanovsky",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165269": {
    "id": "item_18116",
    "Last Name": "Lu",
    "First Name": "Marianne Daisy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165283": {
    "id": "item_18147",
    "Last Name": "Correa",
    "First Name": "Ruben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165284": {
    "id": "item_1022",
    "Last Name": "Osborn",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165301": {
    "id": "item_13494",
    "Last Name": "Hong",
    "First Name": "Woon Wei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165306": {
    "id": "item_5679",
    "Last Name": "Chapman",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165316": {
    "id": "item_13489",
    "Last Name": "Estaniel",
    "First Name": "Estella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165318": {
    "id": "item_18141",
    "Last Name": "morrissey",
    "First Name": "patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165333": {
    "id": "item_18137",
    "Last Name": "Chiem",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165340": {
    "id": "item_1021",
    "Last Name": "Glover",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165341": {
    "id": "item_28448",
    "Last Name": "Eman",
    "First Name": "Kezia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165349": {
    "id": "item_28446",
    "Last Name": "Mcnamara",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165369": {
    "id": "item_16140",
    "Last Name": "Sukawan",
    "First Name": "Sukritta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165374": {
    "id": "item_18134",
    "Last Name": "Jones",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165376": {
    "id": "item_5674",
    "Last Name": "Keogh",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165405": {
    "id": "item_30530",
    "Last Name": "Tuffley",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165410": {
    "id": "item_18128",
    "Last Name": "King",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165421": {
    "id": "item_18132",
    "Last Name": "Mullin",
    "First Name": "Malachy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165425": {
    "id": "item_18131",
    "Last Name": "Saxon",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165438": {
    "id": "item_30527",
    "Last Name": "Genson",
    "First Name": "Paulyne Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165445": {
    "id": "item_30528",
    "Last Name": "Norman",
    "First Name": "Ailish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165446": {
    "id": "item_1016",
    "Last Name": "Gomes",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165470": {
    "id": "item_5676",
    "Last Name": "Nassar",
    "First Name": "Hassan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165475": {
    "id": "item_5677",
    "Last Name": "Smith",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165478": {
    "id": "item_30526",
    "Last Name": "Sydenham",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165480": {
    "id": "item_18121",
    "Last Name": "KIM",
    "First Name": "TAEHWAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165501": {
    "id": "item_1011",
    "Last Name": "Ortiz",
    "First Name": "Inaki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165504": {
    "id": "item_1014",
    "Last Name": "Lovric",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165520": {
    "id": "item_13474",
    "Last Name": "LEE",
    "First Name": "JEOUNGUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165536": {
    "id": "item_18115",
    "Last Name": "Li",
    "First Name": "Emerson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165542": {
    "id": "item_13485",
    "Last Name": "KIM",
    "First Name": "SUN HEE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165579": {
    "id": "item_5668",
    "Last Name": "Posada",
    "First Name": "Guillermo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165599": {
    "id": "item_1009",
    "Last Name": "Kaelin",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165618": {
    "id": "item_13482",
    "Last Name": "Powell",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165622": {
    "id": "item_30521",
    "Last Name": "Lyall",
    "First Name": "Ashlee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165644": {
    "id": "item_13481",
    "Last Name": "Wilson",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165696": {
    "id": "item_30520",
    "Last Name": "Eady",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165707": {
    "id": "item_5666",
    "Last Name": "Jurado",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165717": {
    "id": "item_2909",
    "Last Name": "Moloney",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165725": {
    "id": "item_5665",
    "Last Name": "Dickson",
    "First Name": "Rory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165767": {
    "id": "item_2910",
    "Last Name": "Mann",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165768": {
    "id": "item_18109",
    "Last Name": "Deves",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165786": {
    "id": "item_18106",
    "Last Name": "Pladdy",
    "First Name": "Sian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165792": {
    "id": "item_2906",
    "Last Name": "Guzm‡n Vargas",
    "First Name": "Teresa Paulina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165795": {
    "id": "item_13475",
    "Last Name": "LI",
    "First Name": "ZHERUI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165800": {
    "id": "item_2907",
    "Last Name": "Chou",
    "First Name": "Ching Tang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165802": {
    "id": "item_30513",
    "Last Name": "Ip",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165810": {
    "id": "item_18099",
    "Last Name": "Hunter",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165835": {
    "id": "item_18094",
    "Last Name": "Gillespie",
    "First Name": "Madison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165838": {
    "id": "item_5660",
    "Last Name": "Hunt",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165844": {
    "id": "item_18098",
    "Last Name": "Kolb",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165848": {
    "id": "item_5640",
    "Last Name": "Ahn",
    "First Name": "Se-Hwan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165851": {
    "id": "item_28422",
    "Last Name": "Nilsson",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165852": {
    "id": "item_18100",
    "Last Name": "Uy",
    "First Name": "Karl Presly G.",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165904": {
    "id": "item_18095",
    "Last Name": "Mayer",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165905": {
    "id": "item_18093",
    "Last Name": "Cheung",
    "First Name": "Ming Yan Melanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165914": {
    "id": "item_13472",
    "Last Name": "Thompson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165936": {
    "id": "item_2902",
    "Last Name": "Hall",
    "First Name": "Becca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165958": {
    "id": "item_1000",
    "Last Name": "Thompson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165972": {
    "id": "item_30507",
    "Last Name": "Lim",
    "First Name": "Ophelia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166003": {
    "id": "item_28876",
    "Last Name": "Gomez",
    "First Name": "Luis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166019": {
    "id": "item_5647",
    "Last Name": "Vasiliou",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166032": {
    "id": "item_28427",
    "Last Name": "Sudiyanto",
    "First Name": "Pieter Tandu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166036": {
    "id": "item_18084",
    "Last Name": "Desai",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166037": {
    "id": "item_18085",
    "Last Name": "Fitzgerald",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166042": {
    "id": "item_30503",
    "Last Name": "Nyamsuren",
    "First Name": "Battushig",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166050": {
    "id": "item_2899",
    "Last Name": "Creeper",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166058": {
    "id": "item_2896",
    "Last Name": "He",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166069": {
    "id": "item_16131",
    "Last Name": "Maguire",
    "First Name": "Miren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166072": {
    "id": "item_30497",
    "Last Name": "Lam",
    "First Name": "Lok Kan Orion",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166077": {
    "id": "item_996",
    "Last Name": "Roe",
    "First Name": "Boyd",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166079": {
    "id": "item_5641",
    "Last Name": "Grears",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166110": {
    "id": "item_30500",
    "Last Name": "Hurling",
    "First Name": "Felicity",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166117": {
    "id": "item_30498",
    "Last Name": "Jin",
    "First Name": "Xia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166237": {
    "id": "item_13465",
    "Last Name": "Dunn",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166275": {
    "id": "item_993",
    "Last Name": "Po",
    "First Name": "John Clement",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166310": {
    "id": "item_992",
    "Last Name": "Beasley",
    "First Name": "Damian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166329": {
    "id": "item_18053",
    "Last Name": "Surapaneni",
    "First Name": "Prateek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166361": {
    "id": "item_13461",
    "Last Name": "Wang",
    "First Name": "Bei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166371": {
    "id": "item_13463",
    "Last Name": "Cooke",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166372": {
    "id": "item_5619",
    "Last Name": "LEE",
    "First Name": "SEUL JI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166380": {
    "id": "item_986",
    "Last Name": "Marshall",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166396": {
    "id": "item_16126",
    "Last Name": "Docking",
    "First Name": "Jim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166425": {
    "id": "item_18069",
    "Last Name": "Yenny",
    "First Name": "Yenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166434": {
    "id": "item_2890",
    "Last Name": "OBrien",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166435": {
    "id": "item_13459",
    "Last Name": "Brown",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166444": {
    "id": "item_18066",
    "Last Name": "OÕBrien",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166487": {
    "id": "item_2889",
    "Last Name": "Brownlie",
    "First Name": "Louise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166504": {
    "id": "item_5626",
    "Last Name": "OÕKearney",
    "First Name": "Ally",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166507": {
    "id": "item_5628",
    "Last Name": "PEI JU",
    "First Name": "WANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166531": {
    "id": "item_985",
    "Last Name": "Bonds",
    "First Name": "Tommy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166536": {
    "id": "item_28414",
    "Last Name": "Arifin",
    "First Name": "Ho",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166553": {
    "id": "item_982",
    "Last Name": "Rawlins",
    "First Name": "Corey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166581": {
    "id": "item_13456",
    "Last Name": "Hewitt",
    "First Name": "Gareth Georgie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166604": {
    "id": "item_28418",
    "Last Name": "Waddington",
    "First Name": "Freya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166608": {
    "id": "item_28417",
    "Last Name": "McMahon",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166617": {
    "id": "item_13454",
    "Last Name": "Kumar",
    "First Name": "Kiran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166633": {
    "id": "item_976",
    "Last Name": "Lee",
    "First Name": "Chi Chung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166642": {
    "id": "item_18038",
    "Last Name": "Dhoorah",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166705": {
    "id": "item_18047",
    "Last Name": "Whibley",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166758": {
    "id": "item_18044",
    "Last Name": "Marsden-Jones",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166770": {
    "id": "item_28410",
    "Last Name": "Lach",
    "First Name": "Kannika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166787": {
    "id": "item_975",
    "Last Name": "Creighton",
    "First Name": "stella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166803": {
    "id": "item_5605",
    "Last Name": "King",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166823": {
    "id": "item_5604",
    "Last Name": "Song",
    "First Name": "Hyunki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166843": {
    "id": "item_5598",
    "Last Name": "Eirene",
    "First Name": "Melisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166848": {
    "id": "item_16119",
    "Last Name": "Kam",
    "First Name": "Kwong Fai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166906": {
    "id": "item_5600",
    "Last Name": "Wang",
    "First Name": "Yao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166907": {
    "id": "item_5588",
    "Last Name": "Yeung",
    "First Name": "Sung Hei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166919": {
    "id": "item_30481",
    "Last Name": "MAHILUM",
    "First Name": "ANDRICO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166932": {
    "id": "item_18026",
    "Last Name": "Bak",
    "First Name": "Sohyeon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166956": {
    "id": "item_5595",
    "Last Name": "Wilkin",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166962": {
    "id": "item_28875",
    "Last Name": "son",
    "First Name": "taewoo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166972": {
    "id": "item_2875",
    "Last Name": "Lafuente",
    "First Name": "Ramiro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166988": {
    "id": "item_2874",
    "Last Name": "Clarke",
    "First Name": "Bessie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166996": {
    "id": "item_18023",
    "Last Name": "Gantan",
    "First Name": "Lito",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167009": {
    "id": "item_30473",
    "Last Name": "Gamez",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167034": {
    "id": "item_5594",
    "Last Name": "chan",
    "First Name": "shih hao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167043": {
    "id": "item_17990",
    "Last Name": "Knowles",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167054": {
    "id": "item_18020",
    "Last Name": "Scott",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167073": {
    "id": "item_30472",
    "Last Name": "Sugumaran",
    "First Name": "Vani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167096": {
    "id": "item_16118",
    "Last Name": "Kim",
    "First Name": "Sumi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167109": {
    "id": "item_28404",
    "Last Name": "Reilly",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167130": {
    "id": "item_18005",
    "Last Name": "Chen",
    "First Name": "Yingqi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167145": {
    "id": "item_30469",
    "Last Name": "De campo",
    "First Name": "Luisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167151": {
    "id": "item_965",
    "Last Name": "Elsden",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167154": {
    "id": "item_28401",
    "Last Name": "Jordan",
    "First Name": "Robbin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167163": {
    "id": "item_28398",
    "Last Name": "Maclagan",
    "First Name": "Vicky",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167185": {
    "id": "item_28402",
    "Last Name": "Quaisar",
    "First Name": "Masarrat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167192": {
    "id": "item_1426",
    "Last Name": "Knight",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167194": {
    "id": "item_16115",
    "Last Name": "Lumb",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167198": {
    "id": "item_2868",
    "Last Name": "Basha",
    "First Name": "Albert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167206": {
    "id": "item_18002",
    "Last Name": "Robertson",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167208": {
    "id": "item_5584",
    "Last Name": "Hamilton",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167251": {
    "id": "item_18001",
    "Last Name": "Ngu",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167256": {
    "id": "item_5579",
    "Last Name": "Yeung",
    "First Name": "Chi Ho",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167260": {
    "id": "item_30462",
    "Last Name": "Feng",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167266": {
    "id": "item_30463",
    "Last Name": "Dhanommitrapap",
    "First Name": "Tida",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167268": {
    "id": "item_963",
    "Last Name": "Fang",
    "First Name": "Bo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167282": {
    "id": "item_16111",
    "Last Name": "Pfeil",
    "First Name": "Marco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167284": {
    "id": "item_28394",
    "Last Name": "Manliguez",
    "First Name": "Roselle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167290": {
    "id": "item_2858",
    "Last Name": "Lay Chung",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167299": {
    "id": "item_30456",
    "Last Name": "Kale",
    "First Name": "Shrirang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167301": {
    "id": "item_17989",
    "Last Name": "Kwok",
    "First Name": "Man Ho",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167309": {
    "id": "item_28392",
    "Last Name": "Meer",
    "First Name": "Lamberto Jr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167358": {
    "id": "item_17988",
    "Last Name": "NAREN",
    "First Name": "THILEEPAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167363": {
    "id": "item_30452",
    "Last Name": "Choi",
    "First Name": "Benny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167365": {
    "id": "item_17987",
    "Last Name": "Sartori",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167386": {
    "id": "item_959",
    "Last Name": "Muir",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167404": {
    "id": "item_13427",
    "Last Name": "Li Pi Shan",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167412": {
    "id": "item_30442",
    "Last Name": "Bustos",
    "First Name": "Daniel Marti",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167419": {
    "id": "item_28387",
    "Last Name": "Hoogendoorn",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167420": {
    "id": "item_2862",
    "Last Name": "ROCHA",
    "First Name": "JADER",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167421": {
    "id": "item_13428",
    "Last Name": "Miller",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167428": {
    "id": "item_17986",
    "Last Name": "Kaplan",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167431": {
    "id": "item_5567",
    "Last Name": "Kohne",
    "First Name": "Neale",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167442": {
    "id": "item_5568",
    "Last Name": "quail",
    "First Name": "jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167515": {
    "id": "item_17965",
    "Last Name": "stoddart",
    "First Name": "frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167542": {
    "id": "item_13423",
    "Last Name": "Harrison",
    "First Name": "Ranu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167543": {
    "id": "item_17964",
    "Last Name": "Kim",
    "First Name": "Mikhail",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167557": {
    "id": "item_30445",
    "Last Name": "McCallister",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167591": {
    "id": "item_2851",
    "Last Name": "Calderon",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167623": {
    "id": "item_17958",
    "Last Name": "Bletsas",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167647": {
    "id": "item_13422",
    "Last Name": "Ambyo",
    "First Name": "Karina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167678": {
    "id": "item_17957",
    "Last Name": "Howard",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167706": {
    "id": "item_28381",
    "Last Name": "Nasol",
    "First Name": "Romeo Jr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167708": {
    "id": "item_5559",
    "Last Name": "Reynolds",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167715": {
    "id": "item_17954",
    "Last Name": "Kye",
    "First Name": "Myunghoon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167728": {
    "id": "item_5561",
    "Last Name": "Witteveen",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167766": {
    "id": "item_28829",
    "Last Name": "Yenumula",
    "First Name": "Arun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167779": {
    "id": "item_17956",
    "Last Name": "Cameron",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167795": {
    "id": "item_13420",
    "Last Name": "Jones",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167813": {
    "id": "item_30432",
    "Last Name": "Yu",
    "First Name": "Wing Yiu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167834": {
    "id": "item_5556",
    "Last Name": "Tan",
    "First Name": "Hibban",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167852": {
    "id": "item_17942",
    "Last Name": "WEI",
    "First Name": "LIANG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167879": {
    "id": "item_16103",
    "Last Name": "Donner",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167904": {
    "id": "item_30434",
    "Last Name": "TEO",
    "First Name": "JUN HONG KENNETH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167906": {
    "id": "item_30435",
    "Last Name": "Munoz",
    "First Name": "Anay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167909": {
    "id": "item_16102",
    "Last Name": "Ip",
    "First Name": "Chi Pang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167911": {
    "id": "item_5554",
    "Last Name": "Lawrence",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167920": {
    "id": "item_30433",
    "Last Name": "Gallash",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167929": {
    "id": "item_17952",
    "Last Name": "Wang",
    "First Name": "Tianyue",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167931": {
    "id": "item_5553",
    "Last Name": "Wilson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167936": {
    "id": "item_28372",
    "Last Name": "Crabtree",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167967": {
    "id": "item_13415",
    "Last Name": "Barrie",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167994": {
    "id": "item_17950",
    "Last Name": "Togwell",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168014": {
    "id": "item_5539",
    "Last Name": "Vasquez Solsol",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168040": {
    "id": "item_936",
    "Last Name": "Li",
    "First Name": "Dexin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168056": {
    "id": "item_28369",
    "Last Name": "Tochterman",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168074": {
    "id": "item_2848",
    "Last Name": "Galvin-Ridge",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168103": {
    "id": "item_5537",
    "Last Name": "Xu",
    "First Name": "Lingli",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168133": {
    "id": "item_5534",
    "Last Name": "Baird",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168173": {
    "id": "item_4742",
    "Last Name": "Berenhole",
    "First Name": "Marion",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168183": {
    "id": "item_942",
    "Last Name": "Vittayakomollert",
    "First Name": "Suteera",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168194": {
    "id": "item_5533",
    "Last Name": "Low",
    "First Name": "Randall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168195": {
    "id": "item_28368",
    "Last Name": "Dewey",
    "First Name": "Madison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168216": {
    "id": "item_16100",
    "Last Name": "Wong",
    "First Name": "Lai Sze",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168219": {
    "id": "item_17936",
    "Last Name": "Alhafis",
    "First Name": "Arsi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168224": {
    "id": "item_17935",
    "Last Name": "Urquhart",
    "First Name": "Anne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168237": {
    "id": "item_940",
    "Last Name": "Teale",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168248": {
    "id": "item_17927",
    "Last Name": "Vongsaraphanh",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168249": {
    "id": "item_28364",
    "Last Name": "De Abreu",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168256": {
    "id": "item_13400",
    "Last Name": "CAO",
    "First Name": "XUEZHI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168265": {
    "id": "item_30422",
    "Last Name": "PUTRI",
    "First Name": "PRAMITA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168267": {
    "id": "item_5530",
    "Last Name": "Reid",
    "First Name": "Jolien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168288": {
    "id": "item_1425",
    "Last Name": "Chamala",
    "First Name": "Vamshidhar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168291": {
    "id": "item_5519",
    "Last Name": "Bezzina",
    "First Name": "Alasdair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168296": {
    "id": "item_16095",
    "Last Name": "rizkiansyah",
    "First Name": "agung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168302": {
    "id": "item_16331",
    "Last Name": "kim",
    "First Name": "sanghyun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168304": {
    "id": "item_13405",
    "Last Name": "Nguyen",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168307": {
    "id": "item_28362",
    "Last Name": "Richardson",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168310": {
    "id": "item_5523",
    "Last Name": "Nguyen",
    "First Name": "Judy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168314": {
    "id": "item_17925",
    "Last Name": "Barbosa",
    "First Name": "Jeanette",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168320": {
    "id": "item_17917",
    "Last Name": "Sun",
    "First Name": "Zhiying",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168325": {
    "id": "item_5521",
    "Last Name": "Bravo",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168363": {
    "id": "item_2843",
    "Last Name": "Sy Peng",
    "First Name": "Wilfrance",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168376": {
    "id": "item_2842",
    "Last Name": "MacDonald",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168378": {
    "id": "item_14044",
    "Last Name": "Acevedo",
    "First Name": "Gilbert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168387": {
    "id": "item_13402",
    "Last Name": "Siemieniak",
    "First Name": "Karol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168404": {
    "id": "item_30419",
    "Last Name": "Talusan",
    "First Name": "Justin Emmanuelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168405": {
    "id": "item_28358",
    "Last Name": "Tang",
    "First Name": "Billy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168439": {
    "id": "item_17886",
    "Last Name": "MA",
    "First Name": "FUZHOU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168443": {
    "id": "item_5511",
    "Last Name": "Fung",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168448": {
    "id": "item_2838",
    "Last Name": "XU",
    "First Name": "DONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168452": {
    "id": "item_5504",
    "Last Name": "Dalwood",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168453": {
    "id": "item_17915",
    "Last Name": "Jiang",
    "First Name": "Le",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168471": {
    "id": "item_17912",
    "Last Name": "Thakur",
    "First Name": "Poonam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168490": {
    "id": "item_16096",
    "Last Name": "Yuipco",
    "First Name": "Carlos Chivas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168513": {
    "id": "item_930",
    "Last Name": "Rodriguez",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168518": {
    "id": "item_13399",
    "Last Name": "Ye",
    "First Name": "Liansheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168524": {
    "id": "item_5507",
    "Last Name": "Ismay",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168539": {
    "id": "item_932",
    "Last Name": "Kelly",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168548": {
    "id": "item_13392",
    "Last Name": "Wong",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168564": {
    "id": "item_28359",
    "Last Name": "TJIONG",
    "First Name": "BILLY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168590": {
    "id": "item_923",
    "Last Name": "yip",
    "First Name": "sau mui",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168600": {
    "id": "item_30407",
    "Last Name": "Choi",
    "First Name": "Dahan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168604": {
    "id": "item_13396",
    "Last Name": "Medina",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168612": {
    "id": "item_2837",
    "Last Name": "Dwyer",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168646": {
    "id": "item_5499",
    "Last Name": "Brooks",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168649": {
    "id": "item_5503",
    "Last Name": "Gosbell",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168669": {
    "id": "item_927",
    "Last Name": "Manuel",
    "First Name": "Heydon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168692": {
    "id": "item_926",
    "Last Name": "Hill",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168696": {
    "id": "item_17890",
    "Last Name": "Wang",
    "First Name": "Xi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168716": {
    "id": "item_5498",
    "Last Name": "Samson",
    "First Name": "Senara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168719": {
    "id": "item_17896",
    "Last Name": "Antolini",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168723": {
    "id": "item_13393",
    "Last Name": "Goijen",
    "First Name": "Hedwig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168731": {
    "id": "item_13391",
    "Last Name": "Simonsen",
    "First Name": "Bjorn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168732": {
    "id": "item_17901",
    "Last Name": "Ten",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168783": {
    "id": "item_16092",
    "Last Name": "Kearns",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168838": {
    "id": "item_5494",
    "Last Name": "TSE",
    "First Name": "Tit Ho Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168851": {
    "id": "item_1424",
    "Last Name": "Lindquist",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168879": {
    "id": "item_28354",
    "Last Name": "Transfiguracion",
    "First Name": "Mon Jeffrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168886": {
    "id": "item_16089",
    "Last Name": "Liow",
    "First Name": "Sue May",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168893": {
    "id": "item_5488",
    "Last Name": "Chiu",
    "First Name": "Louise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168896": {
    "id": "item_5483",
    "Last Name": "de Brito Antonio",
    "First Name": "Igor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168898": {
    "id": "item_17889",
    "Last Name": "Williams",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168907": {
    "id": "item_13385",
    "Last Name": "Drury",
    "First Name": "Storm",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168917": {
    "id": "item_28353",
    "Last Name": "blackwood",
    "First Name": "michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168928": {
    "id": "item_5485",
    "Last Name": "Brokenshire",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168944": {
    "id": "item_17885",
    "Last Name": "Ferns",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168955": {
    "id": "item_917",
    "Last Name": "Chen",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168980": {
    "id": "item_16088",
    "Last Name": "Lloyd",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168985": {
    "id": "item_5476",
    "Last Name": "Archibald",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168988": {
    "id": "item_17884",
    "Last Name": "Ching",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169008": {
    "id": "item_30404",
    "Last Name": "LEHANIE",
    "First Name": "Carole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169016": {
    "id": "item_5480",
    "Last Name": "Warren",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169030": {
    "id": "item_28348",
    "Last Name": "Firmansyah",
    "First Name": "Ferry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169032": {
    "id": "item_915",
    "Last Name": "Lee",
    "First Name": "Yin Ling",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169037": {
    "id": "item_913",
    "Last Name": "Heys",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169041": {
    "id": "item_5482",
    "Last Name": "Li",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169053": {
    "id": "item_17876",
    "Last Name": "Ledingham",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169086": {
    "id": "item_911",
    "Last Name": "Goodwin",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169088": {
    "id": "item_30401",
    "Last Name": "Andersen",
    "First Name": "Rory",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169121": {
    "id": "item_5472",
    "Last Name": "Silverwood",
    "First Name": "Carly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169143": {
    "id": "item_17871",
    "Last Name": "Dwihan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169165": {
    "id": "item_17831",
    "Last Name": "Chavarria Najera",
    "First Name": "Daniela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169289": {
    "id": "item_26497",
    "Last Name": "Hord",
    "First Name": "Danyelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169302": {
    "id": "item_17862",
    "Last Name": "WU",
    "First Name": "YI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169480": {
    "id": "item_5469",
    "Last Name": "Dolbel",
    "First Name": "Logan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169585": {
    "id": "item_30397",
    "Last Name": "Chen",
    "First Name": "Chun Wei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169701": {
    "id": "item_5468",
    "Last Name": "Perkins",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169707": {
    "id": "item_30398",
    "Last Name": "Lee",
    "First Name": "Trent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169819": {
    "id": "item_5465",
    "Last Name": "Huang",
    "First Name": "Tzu-Yao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169918": {
    "id": "item_2823",
    "Last Name": "Randle",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169968": {
    "id": "item_5463",
    "Last Name": "Love",
    "First Name": "Murray",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170045": {
    "id": "item_17851",
    "Last Name": "Stibilj",
    "First Name": "Jayde",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170065": {
    "id": "item_30395",
    "Last Name": "Amador Rojas",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170177": {
    "id": "item_17855",
    "Last Name": "Khan",
    "First Name": "Nasir",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170445": {
    "id": "item_13369",
    "Last Name": "Remollo",
    "First Name": "Jupert John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170490": {
    "id": "item_5462",
    "Last Name": "Sewell",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170608": {
    "id": "item_31070",
    "Last Name": "Christina",
    "First Name": "Merry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170693": {
    "id": "item_17847",
    "Last Name": "BRAGAT",
    "First Name": "SHEILA GAY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170959": {
    "id": "item_13363",
    "Last Name": "Mace",
    "First Name": "Clayton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171318": {
    "id": "item_13365",
    "Last Name": "McNamara",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171392": {
    "id": "item_26496",
    "Last Name": "Russell-Gibson",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171413": {
    "id": "item_28338",
    "Last Name": "Valdivia",
    "First Name": "Brenda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171887": {
    "id": "item_17840",
    "Last Name": "Lui",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172149": {
    "id": "item_28337",
    "Last Name": "Ho",
    "First Name": "Chi Wai Harry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172347": {
    "id": "item_17838",
    "Last Name": "JIANG",
    "First Name": "HUA WEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172400": {
    "id": "item_5438",
    "Last Name": "Bastian",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172437": {
    "id": "item_5451",
    "Last Name": "Daza",
    "First Name": "Alejo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172444": {
    "id": "item_13359",
    "Last Name": "Quinlan",
    "First Name": "Harper",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172455": {
    "id": "item_5450",
    "Last Name": "Keary",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172458": {
    "id": "item_28874",
    "Last Name": "Rodriguez",
    "First Name": "Marla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172459": {
    "id": "item_13361",
    "Last Name": "Clarke",
    "First Name": "Jen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172461": {
    "id": "item_906",
    "Last Name": "Salem",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172478": {
    "id": "item_2814",
    "Last Name": "Sciamannetti",
    "First Name": "Valerio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172489": {
    "id": "item_28334",
    "Last Name": "Pappalardo",
    "First Name": "Gab",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172516": {
    "id": "item_13356",
    "Last Name": "Rizki",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172540": {
    "id": "item_17826",
    "Last Name": "Condon",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172551": {
    "id": "item_898",
    "Last Name": "Sherry",
    "First Name": "Zane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172559": {
    "id": "item_5448",
    "Last Name": "Rodriguez Ortega",
    "First Name": "Juan Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172567": {
    "id": "item_17814",
    "Last Name": "Merkel",
    "First Name": "Kellie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172575": {
    "id": "item_17820",
    "Last Name": "Winley",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172586": {
    "id": "item_30384",
    "Last Name": "Rumble",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172590": {
    "id": "item_30383",
    "Last Name": "Pedrotti",
    "First Name": "Chad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172596": {
    "id": "item_900",
    "Last Name": "Thake",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172607": {
    "id": "item_2816",
    "Last Name": "Carr",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172628": {
    "id": "item_897",
    "Last Name": "Hasselerharm",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172635": {
    "id": "item_13352",
    "Last Name": "Chan",
    "First Name": "Ming Hei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172636": {
    "id": "item_13355",
    "Last Name": "Whitelaw",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172673": {
    "id": "item_17813",
    "Last Name": "OÕConnor",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172682": {
    "id": "item_28328",
    "Last Name": "Lee Kun Hong",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172701": {
    "id": "item_13353",
    "Last Name": "Bird",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172714": {
    "id": "item_28316",
    "Last Name": "Tsai",
    "First Name": "Ming Ju Marjorie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172722": {
    "id": "item_5437",
    "Last Name": "Coffey",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172739": {
    "id": "item_30361",
    "Last Name": "Hakim",
    "First Name": "Lusiana Fitriyani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172746": {
    "id": "item_894",
    "Last Name": "Haksoz",
    "First Name": "Mutlu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172753": {
    "id": "item_28873",
    "Last Name": "Primisani",
    "First Name": "Irma Listyana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172774": {
    "id": "item_17806",
    "Last Name": "Norsworthy",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172784": {
    "id": "item_2813",
    "Last Name": "Chanaka",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172792": {
    "id": "item_5433",
    "Last Name": "Sahely",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172798": {
    "id": "item_17796",
    "Last Name": "Santoso",
    "First Name": "Alice Aurelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172811": {
    "id": "item_17803",
    "Last Name": "HSING TZU",
    "First Name": "KO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172838": {
    "id": "item_13349",
    "Last Name": "Villanueva",
    "First Name": "Chester",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172866": {
    "id": "item_28320",
    "Last Name": "Sreeram",
    "First Name": "Sai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172869": {
    "id": "item_5431",
    "Last Name": "Irvin",
    "First Name": "Jo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172870": {
    "id": "item_3261",
    "Last Name": "Monteiro",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172872": {
    "id": "item_13345",
    "Last Name": "Goulbourne",
    "First Name": "Duane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172875": {
    "id": "item_14043",
    "Last Name": "NEALEGA",
    "First Name": "JOSE GABRIEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172877": {
    "id": "item_30376",
    "Last Name": "Bryan",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172885": {
    "id": "item_28322",
    "Last Name": "Seale",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172895": {
    "id": "item_17795",
    "Last Name": "West-Riley",
    "First Name": "Kayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172897": {
    "id": "item_2812",
    "Last Name": "wei chi",
    "First Name": "Huang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172907": {
    "id": "item_28319",
    "Last Name": "Mule",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172926": {
    "id": "item_888",
    "Last Name": "Conroy",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172940": {
    "id": "item_17781",
    "Last Name": "Park",
    "First Name": "Heejin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172950": {
    "id": "item_28318",
    "Last Name": "faitg",
    "First Name": "meryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172958": {
    "id": "item_13344",
    "Last Name": "Esden",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172995": {
    "id": "item_28314",
    "Last Name": "Soegondo",
    "First Name": "Wibawa Setiadjit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173012": {
    "id": "item_28315",
    "Last Name": "Armistead",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173031": {
    "id": "item_17789",
    "Last Name": "Trueman",
    "First Name": "Jenna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173039": {
    "id": "item_13343",
    "Last Name": "lintern",
    "First Name": "bryce",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173045": {
    "id": "item_5412",
    "Last Name": "Hooper",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173063": {
    "id": "item_5413",
    "Last Name": "Pulella",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173105": {
    "id": "item_5406",
    "Last Name": "Carvalho",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173107": {
    "id": "item_2808",
    "Last Name": "Kwok",
    "First Name": "Wah Lam Aelam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173125": {
    "id": "item_26409",
    "Last Name": "Ansari",
    "First Name": "Muhammad Ammar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173146": {
    "id": "item_5409",
    "Last Name": "Lynch",
    "First Name": "Koby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173147": {
    "id": "item_30365",
    "Last Name": "Donohoe",
    "First Name": "Y",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173181": {
    "id": "item_17774",
    "Last Name": "Hawk",
    "First Name": "Shanah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173186": {
    "id": "item_2797",
    "Last Name": "Campbell",
    "First Name": "Jenni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173189": {
    "id": "item_30363",
    "Last Name": "Downie",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173192": {
    "id": "item_876",
    "Last Name": "XU",
    "First Name": "KUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173203": {
    "id": "item_17767",
    "Last Name": "Mok",
    "First Name": "Wing Hei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173207": {
    "id": "item_17773",
    "Last Name": "Black",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173422": {
    "id": "item_17772",
    "Last Name": "Ngu",
    "First Name": "Franky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173603": {
    "id": "item_28308",
    "Last Name": "Collins",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37174619": {
    "id": "item_13332",
    "Last Name": "Woolnough",
    "First Name": "Nikita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37174724": {
    "id": "item_17766",
    "Last Name": "Scott",
    "First Name": "Callum",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37174760": {
    "id": "item_13331",
    "Last Name": "Pidgeon",
    "First Name": "Ned",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175132": {
    "id": "item_5394",
    "Last Name": "WANG",
    "First Name": "FONG-WEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175210": {
    "id": "item_1423",
    "Last Name": "Villari",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175243": {
    "id": "item_28306",
    "Last Name": "Battersby",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175330": {
    "id": "item_17759",
    "Last Name": "Ho",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175385": {
    "id": "item_5383",
    "Last Name": "Wu",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175650": {
    "id": "item_5396",
    "Last Name": "Turner",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175753": {
    "id": "item_873",
    "Last Name": "Liu",
    "First Name": "Yong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175837": {
    "id": "item_5391",
    "Last Name": "Tobin",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176095": {
    "id": "item_17760",
    "Last Name": "birch",
    "First Name": "simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176145": {
    "id": "item_5384",
    "Last Name": "Hubbard",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176153": {
    "id": "item_17752",
    "Last Name": "Johnston",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176154": {
    "id": "item_17755",
    "Last Name": "Chen",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176172": {
    "id": "item_17753",
    "Last Name": "Kuang",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176174": {
    "id": "item_30356",
    "Last Name": "Brown",
    "First Name": "Kelsie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176180": {
    "id": "item_13327",
    "Last Name": "Paras",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176188": {
    "id": "item_17742",
    "Last Name": "Liang",
    "First Name": "PoCheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176189": {
    "id": "item_875",
    "Last Name": "Hall",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176200": {
    "id": "item_5382",
    "Last Name": "Surpin",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176203": {
    "id": "item_17744",
    "Last Name": "Pullman",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176324": {
    "id": "item_28297",
    "Last Name": "Gater",
    "First Name": "Sharnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176693": {
    "id": "item_2798",
    "Last Name": "Glover",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176749": {
    "id": "item_30351",
    "Last Name": "Gerke",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176839": {
    "id": "item_13320",
    "Last Name": "Heyes",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176874": {
    "id": "item_30345",
    "Last Name": "Kindangen",
    "First Name": "Erwino",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176946": {
    "id": "item_5379",
    "Last Name": "Wachiraphong",
    "First Name": "Hathaichanok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37177212": {
    "id": "item_28289",
    "Last Name": "Bertulano",
    "First Name": "Laarni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37177244": {
    "id": "item_28288",
    "Last Name": "Tucker",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37177247": {
    "id": "item_13321",
    "Last Name": "Anwar",
    "First Name": "Khairil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37177551": {
    "id": "item_2793",
    "Last Name": "Manal",
    "First Name": "Mazin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37177764": {
    "id": "item_2795",
    "Last Name": "Pinero",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178170": {
    "id": "item_28295",
    "Last Name": "Lee",
    "First Name": "Jeanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178519": {
    "id": "item_16072",
    "Last Name": "Allen",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178528": {
    "id": "item_17721",
    "Last Name": "Tran",
    "First Name": "Huan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178722": {
    "id": "item_17724",
    "Last Name": "Jeong",
    "First Name": "Taejong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178731": {
    "id": "item_17727",
    "Last Name": "Hodges",
    "First Name": "Kyleen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178744": {
    "id": "item_17729",
    "Last Name": "Gierak",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178747": {
    "id": "item_868",
    "Last Name": "STEWART",
    "First Name": "Karl",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178767": {
    "id": "item_5367",
    "Last Name": "Zhang",
    "First Name": "Xiaoyang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178803": {
    "id": "item_5370",
    "Last Name": "Blackwell",
    "First Name": "Warwick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178819": {
    "id": "item_13314",
    "Last Name": "Plover",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178850": {
    "id": "item_17720",
    "Last Name": "Wicks",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178854": {
    "id": "item_17717",
    "Last Name": "Uribe",
    "First Name": "juan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178977": {
    "id": "item_5364",
    "Last Name": "Le",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179193": {
    "id": "item_17711",
    "Last Name": "Willis",
    "First Name": "Aroha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179236": {
    "id": "item_30338",
    "Last Name": "Croft",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179303": {
    "id": "item_862",
    "Last Name": "MOU",
    "First Name": "ZHENHUA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179376": {
    "id": "item_30334",
    "Last Name": "Stewart",
    "First Name": "Janine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179673": {
    "id": "item_13309",
    "Last Name": "Dunn",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179879": {
    "id": "item_13307",
    "Last Name": "Schaffer",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179926": {
    "id": "item_13303",
    "Last Name": "Nicholls",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180089": {
    "id": "item_17700",
    "Last Name": "Phillips",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180129": {
    "id": "item_13304",
    "Last Name": "Orr",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180219": {
    "id": "item_5357",
    "Last Name": "Allan",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180260": {
    "id": "item_5356",
    "Last Name": "Johns",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180388": {
    "id": "item_16067",
    "Last Name": "Chen",
    "First Name": "Fan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180650": {
    "id": "item_30333",
    "Last Name": "Pham",
    "First Name": "Quang Huy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180829": {
    "id": "item_30330",
    "Last Name": "Gunnis",
    "First Name": "Adina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180880": {
    "id": "item_17697",
    "Last Name": "Chou",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180997": {
    "id": "item_13301",
    "Last Name": "Acosta",
    "First Name": "Marisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181039": {
    "id": "item_13298",
    "Last Name": "Grobstein",
    "First Name": "Judy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181185": {
    "id": "item_2782",
    "Last Name": "Fuller",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181288": {
    "id": "item_30329",
    "Last Name": "Bostick",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181441": {
    "id": "item_5352",
    "Last Name": "Duffett",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181553": {
    "id": "item_17696",
    "Last Name": "Christelis",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181557": {
    "id": "item_860",
    "Last Name": "Hughes",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181568": {
    "id": "item_30328",
    "Last Name": "Stevens",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181605": {
    "id": "item_17692",
    "Last Name": "Do",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181634": {
    "id": "item_30324",
    "Last Name": "Burgess",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181635": {
    "id": "item_5349",
    "Last Name": "Goodlet",
    "First Name": "Mat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181682": {
    "id": "item_28281",
    "Last Name": "Surya Mandala",
    "First Name": "Hendy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181707": {
    "id": "item_13980",
    "Last Name": "Situru",
    "First Name": "Hasyuda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181712": {
    "id": "item_17685",
    "Last Name": "Williams",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181727": {
    "id": "item_5346",
    "Last Name": "Ludford",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181747": {
    "id": "item_858",
    "Last Name": "Danieletto",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181770": {
    "id": "item_17683",
    "Last Name": "Shen",
    "First Name": "Shirly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181774": {
    "id": "item_859",
    "Last Name": "Patel",
    "First Name": "Jaiman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181789": {
    "id": "item_857",
    "Last Name": "GO",
    "First Name": "EUGENE JEROME",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181815": {
    "id": "item_5341",
    "Last Name": "Neild",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181826": {
    "id": "item_16066",
    "Last Name": "Lawrence",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181827": {
    "id": "item_851",
    "Last Name": "Qiu",
    "First Name": "Dong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181830": {
    "id": "item_5339",
    "Last Name": "FONG",
    "First Name": "Kin Man",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181831": {
    "id": "item_856",
    "Last Name": "Thomas",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181835": {
    "id": "item_852",
    "Last Name": "Wang",
    "First Name": "Cheng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181889": {
    "id": "item_13288",
    "Last Name": "Pfeffer",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182092": {
    "id": "item_17674",
    "Last Name": "Harvey",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182344": {
    "id": "item_17672",
    "Last Name": "Novijanto",
    "First Name": "Edi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182604": {
    "id": "item_855",
    "Last Name": "O Brien",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182693": {
    "id": "item_14042",
    "Last Name": "YUN",
    "First Name": "JUNGHWAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37183168": {
    "id": "item_28277",
    "Last Name": "Joynes",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37183290": {
    "id": "item_2778",
    "Last Name": "Harrington",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37183340": {
    "id": "item_17666",
    "Last Name": "kim",
    "First Name": "chu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37183355": {
    "id": "item_5336",
    "Last Name": "Fitton",
    "First Name": "Boyd",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37183783": {
    "id": "item_13283",
    "Last Name": "Rezeki",
    "First Name": "Herniyati",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37183820": {
    "id": "item_17663",
    "Last Name": "Martin",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37183894": {
    "id": "item_2773",
    "Last Name": "Sutardi",
    "First Name": "Michael Sherwin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184359": {
    "id": "item_30316",
    "Last Name": "Dichoso",
    "First Name": "Alyssa Zoe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184376": {
    "id": "item_5333",
    "Last Name": "Hutchinson",
    "First Name": "Deacon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184515": {
    "id": "item_28276",
    "Last Name": "Davis",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184600": {
    "id": "item_17658",
    "Last Name": "demafeliz",
    "First Name": "ian neil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184700": {
    "id": "item_5332",
    "Last Name": "Caloutas",
    "First Name": "Paras",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184719": {
    "id": "item_5325",
    "Last Name": "Pritmani",
    "First Name": "Sahil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184736": {
    "id": "item_848",
    "Last Name": "Leslie",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184742": {
    "id": "item_17651",
    "Last Name": "SIA",
    "First Name": "Song",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184743": {
    "id": "item_17655",
    "Last Name": "Chung",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184751": {
    "id": "item_5329",
    "Last Name": "Novikov",
    "First Name": "Yury",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184767": {
    "id": "item_5328",
    "Last Name": "Mulcahy",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184771": {
    "id": "item_845",
    "Last Name": "Pradhan",
    "First Name": "Satyashil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184817": {
    "id": "item_2768",
    "Last Name": "ZHILIANG",
    "First Name": "DUAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184824": {
    "id": "item_846",
    "Last Name": "Wuoti",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184885": {
    "id": "item_843",
    "Last Name": "Harley",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184950": {
    "id": "item_17620",
    "Last Name": "Gerathy",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37185012": {
    "id": "item_17649",
    "Last Name": "Snow",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37185147": {
    "id": "item_2769",
    "Last Name": "Paiva",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37185487": {
    "id": "item_842",
    "Last Name": "Hu",
    "First Name": "Weiqiang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37185631": {
    "id": "item_5322",
    "Last Name": "Gillett",
    "First Name": "Nadene",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37185737": {
    "id": "item_17645",
    "Last Name": "Johnston",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37185798": {
    "id": "item_30307",
    "Last Name": "Bolin",
    "First Name": "Kat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37185913": {
    "id": "item_13272",
    "Last Name": "Ye",
    "First Name": "Weifeng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186057": {
    "id": "item_13275",
    "Last Name": "Andriske",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186086": {
    "id": "item_5299",
    "Last Name": "Antony",
    "First Name": "Kay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186367": {
    "id": "item_30302",
    "Last Name": "Homiak",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186546": {
    "id": "item_28269",
    "Last Name": "Olaniyan",
    "First Name": "Olatokunbo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186604": {
    "id": "item_1422",
    "Last Name": "GAO",
    "First Name": "QINFEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186806": {
    "id": "item_17634",
    "Last Name": "mendis",
    "First Name": "Amila",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186858": {
    "id": "item_13269",
    "Last Name": "Evans",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186989": {
    "id": "item_5316",
    "Last Name": "Wood",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187312": {
    "id": "item_841",
    "Last Name": "Sverdloff",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187447": {
    "id": "item_17635",
    "Last Name": "George",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187456": {
    "id": "item_28268",
    "Last Name": "Fagence",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187490": {
    "id": "item_5313",
    "Last Name": "Stoneman",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187493": {
    "id": "item_13273",
    "Last Name": "Young",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187508": {
    "id": "item_16057",
    "Last Name": "Treacy",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187522": {
    "id": "item_5309",
    "Last Name": "lim",
    "First Name": "seng chai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187546": {
    "id": "item_28264",
    "Last Name": "Distant",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187547": {
    "id": "item_17626",
    "Last Name": "Santos",
    "First Name": "Amalyn Cortez",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187579": {
    "id": "item_5304",
    "Last Name": "Beech",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187592": {
    "id": "item_17618",
    "Last Name": "KIM",
    "First Name": "HAYOUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187612": {
    "id": "item_30297",
    "Last Name": "Sastradjaja",
    "First Name": "Frencing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187623": {
    "id": "item_30295",
    "Last Name": "LEUNG",
    "First Name": "SIU MING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187627": {
    "id": "item_28265",
    "Last Name": "Vincent",
    "First Name": "Christyna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187641": {
    "id": "item_28263",
    "Last Name": "Sung",
    "First Name": "Cheng Hsi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187659": {
    "id": "item_28260",
    "Last Name": "Yusuf",
    "First Name": "Nurvi Apriana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187661": {
    "id": "item_17612",
    "Last Name": "Febrianto",
    "First Name": "Febrianto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187687": {
    "id": "item_30288",
    "Last Name": "LaGreca",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187691": {
    "id": "item_13262",
    "Last Name": "Gabrielson",
    "First Name": "Leah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187830": {
    "id": "item_17616",
    "Last Name": "Donahoo",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187962": {
    "id": "item_30290",
    "Last Name": "Kittell-Porter",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37188314": {
    "id": "item_5297",
    "Last Name": "Stone",
    "First Name": "Julia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37188929": {
    "id": "item_28253",
    "Last Name": "Tran",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189157": {
    "id": "item_5291",
    "Last Name": "Diamantis",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189627": {
    "id": "item_13258",
    "Last Name": "Hansor",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189773": {
    "id": "item_17604",
    "Last Name": "Chetty",
    "First Name": "Naven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189924": {
    "id": "item_13245",
    "Last Name": "Pan",
    "First Name": "HsiangYun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189937": {
    "id": "item_5289",
    "Last Name": "Wood",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189990": {
    "id": "item_17598",
    "Last Name": "Taylor",
    "First Name": "Seth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190142": {
    "id": "item_30284",
    "Last Name": "Virgantara",
    "First Name": "Benaga",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190199": {
    "id": "item_834",
    "Last Name": "Huang",
    "First Name": "Bao-Shih",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190326": {
    "id": "item_833",
    "Last Name": "Wilson",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190415": {
    "id": "item_28244",
    "Last Name": "Hays",
    "First Name": "Jeanine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190465": {
    "id": "item_30283",
    "Last Name": "Baigent",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190731": {
    "id": "item_5286",
    "Last Name": "Langlands",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190732": {
    "id": "item_16051",
    "Last Name": "Kanyugi",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190843": {
    "id": "item_13253",
    "Last Name": "Vincent",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190900": {
    "id": "item_13252",
    "Last Name": "MIllar",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191050": {
    "id": "item_17595",
    "Last Name": "Cox",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191189": {
    "id": "item_2759",
    "Last Name": "Hambleton",
    "First Name": "Marni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191218": {
    "id": "item_30280",
    "Last Name": "Yuo",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191226": {
    "id": "item_16050",
    "Last Name": "Jowett",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191496": {
    "id": "item_28243",
    "Last Name": "Ooi",
    "First Name": "Racquel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191905": {
    "id": "item_828",
    "Last Name": "Ubaldo",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191971": {
    "id": "item_17586",
    "Last Name": "Luu",
    "First Name": "Phu Yen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192109": {
    "id": "item_17589",
    "Last Name": "Palencia",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192129": {
    "id": "item_17587",
    "Last Name": "Nicoll",
    "First Name": "Callum",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192206": {
    "id": "item_17573",
    "Last Name": "Hong",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192270": {
    "id": "item_17576",
    "Last Name": "Schueler",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192274": {
    "id": "item_13250",
    "Last Name": "Soedjatmiko",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192287": {
    "id": "item_5279",
    "Last Name": "Wells",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192293": {
    "id": "item_13248",
    "Last Name": "Singh",
    "First Name": "Satvir",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192295": {
    "id": "item_826",
    "Last Name": "La Paglia",
    "First Name": "Domenic",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192300": {
    "id": "item_17580",
    "Last Name": "Heron",
    "First Name": "Allan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192308": {
    "id": "item_30278",
    "Last Name": "Merrick",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192322": {
    "id": "item_30276",
    "Last Name": "WAT",
    "First Name": "Sze wan Zoe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192338": {
    "id": "item_30277",
    "Last Name": "McDonald",
    "First Name": "Odette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192350": {
    "id": "item_28239",
    "Last Name": "GAO",
    "First Name": "LEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192362": {
    "id": "item_16330",
    "Last Name": "To",
    "First Name": "Chi Pan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192376": {
    "id": "item_28238",
    "Last Name": "Henderson",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192377": {
    "id": "item_13243",
    "Last Name": "Long",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192379": {
    "id": "item_13241",
    "Last Name": "Ridley",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192409": {
    "id": "item_2755",
    "Last Name": "Stallard",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192414": {
    "id": "item_2754",
    "Last Name": "Phelan",
    "First Name": "Noel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192445": {
    "id": "item_2753",
    "Last Name": "Gonzalez bordalas",
    "First Name": "Guillermo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192464": {
    "id": "item_17565",
    "Last Name": "Rasyid",
    "First Name": "Muhammad Fadhil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192515": {
    "id": "item_2751",
    "Last Name": "Taylor",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192531": {
    "id": "item_5262",
    "Last Name": "Soeriaatmadja",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192536": {
    "id": "item_30264",
    "Last Name": "Engdahl",
    "First Name": "Rohan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192551": {
    "id": "item_2747",
    "Last Name": "Hall",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192552": {
    "id": "item_2748",
    "Last Name": "Bailey",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192557": {
    "id": "item_5270",
    "Last Name": "Kamei",
    "First Name": "Shinri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192558": {
    "id": "item_5267",
    "Last Name": "Lim",
    "First Name": "Siong Yew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192583": {
    "id": "item_17560",
    "Last Name": "Howard",
    "First Name": "Austin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192589": {
    "id": "item_819",
    "Last Name": "Tupy",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192594": {
    "id": "item_13234",
    "Last Name": "Dai",
    "First Name": "Xiaoning",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192607": {
    "id": "item_30262",
    "Last Name": "Law",
    "First Name": "Wai Kit Irving",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192615": {
    "id": "item_30263",
    "Last Name": "Gonzalez",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192629": {
    "id": "item_16044",
    "Last Name": "Hohenleitner",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192630": {
    "id": "item_5255",
    "Last Name": "Rubios",
    "First Name": "Mary France",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192633": {
    "id": "item_17555",
    "Last Name": "Johnston",
    "First Name": "Heath",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192639": {
    "id": "item_13231",
    "Last Name": "Giallourou",
    "First Name": "Nikolas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192673": {
    "id": "item_17550",
    "Last Name": "Barrett",
    "First Name": "Guy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192674": {
    "id": "item_28232",
    "Last Name": "Cole",
    "First Name": "Cheron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192738": {
    "id": "item_17548",
    "Last Name": "Helm",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192740": {
    "id": "item_17547",
    "Last Name": "Ling",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192751": {
    "id": "item_17537",
    "Last Name": "Barnes",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192753": {
    "id": "item_13222",
    "Last Name": "Pease",
    "First Name": "Clodagh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192758": {
    "id": "item_17543",
    "Last Name": "Chin",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192760": {
    "id": "item_5252",
    "Last Name": "LAM",
    "First Name": "YIM HUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192791": {
    "id": "item_2745",
    "Last Name": "Gerard",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192798": {
    "id": "item_17533",
    "Last Name": "CHANG",
    "First Name": "YI JEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192803": {
    "id": "item_13218",
    "Last Name": "Lee",
    "First Name": "Ching Sze Susana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192836": {
    "id": "item_28228",
    "Last Name": "Merrick",
    "First Name": "Cassie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192841": {
    "id": "item_2744",
    "Last Name": "TSZ KIT",
    "First Name": "CHOW",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192861": {
    "id": "item_28224",
    "Last Name": "Rahim",
    "First Name": "Faizal Sirajuddin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192870": {
    "id": "item_17534",
    "Last Name": "Von Berg",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192878": {
    "id": "item_5249",
    "Last Name": "Rodgers",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192929": {
    "id": "item_2743",
    "Last Name": "KIM",
    "First Name": "SEHOON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192935": {
    "id": "item_30255",
    "Last Name": "Hanson",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192944": {
    "id": "item_5237",
    "Last Name": "Lee",
    "First Name": "Hakmin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192951": {
    "id": "item_2742",
    "Last Name": "Hannay",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192953": {
    "id": "item_13216",
    "Last Name": "Brenner",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192958": {
    "id": "item_13211",
    "Last Name": "Molloy",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192960": {
    "id": "item_13215",
    "Last Name": "Attard",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192976": {
    "id": "item_30253",
    "Last Name": "Gomez",
    "First Name": "German",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193034": {
    "id": "item_17522",
    "Last Name": "Pandolfo",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193037": {
    "id": "item_17519",
    "Last Name": "Mestousis",
    "First Name": "Mikayla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193038": {
    "id": "item_5243",
    "Last Name": "Byles",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193048": {
    "id": "item_2737",
    "Last Name": "Pathak",
    "First Name": "Pat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193064": {
    "id": "item_13209",
    "Last Name": "Michaels",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193079": {
    "id": "item_13210",
    "Last Name": "Undercoffler",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193121": {
    "id": "item_30244",
    "Last Name": "Anwari",
    "First Name": "Taufik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193134": {
    "id": "item_17516",
    "Last Name": "Gee",
    "First Name": "Tyson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193161": {
    "id": "item_5234",
    "Last Name": "Besnard",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193191": {
    "id": "item_1421",
    "Last Name": "Louie",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193201": {
    "id": "item_28217",
    "Last Name": "Bett",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193202": {
    "id": "item_17512",
    "Last Name": "Ayare",
    "First Name": "Prathamesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193207": {
    "id": "item_2734",
    "Last Name": "Gambranis",
    "First Name": "Lili",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193215": {
    "id": "item_17509",
    "Last Name": "Cuenca Arambarri",
    "First Name": "Ignacio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193232": {
    "id": "item_5230",
    "Last Name": "Martin",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193233": {
    "id": "item_5229",
    "Last Name": "Houston",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193235": {
    "id": "item_16041",
    "Last Name": "Frankel",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193247": {
    "id": "item_5232",
    "Last Name": "Traut",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193260": {
    "id": "item_30238",
    "Last Name": "Kim",
    "First Name": "Jee Hyun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193262": {
    "id": "item_30240",
    "Last Name": "Page",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193270": {
    "id": "item_807",
    "Last Name": "Barker",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193279": {
    "id": "item_17507",
    "Last Name": "Quinn",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193285": {
    "id": "item_17502",
    "Last Name": "Nolan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193303": {
    "id": "item_808",
    "Last Name": "Ughetto",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193324": {
    "id": "item_5218",
    "Last Name": "Gordon",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193344": {
    "id": "item_804",
    "Last Name": "harati",
    "First Name": "Mohammad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193349": {
    "id": "item_805",
    "Last Name": "Omond",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193353": {
    "id": "item_17500",
    "Last Name": "foong",
    "First Name": "tuck lun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193381": {
    "id": "item_13201",
    "Last Name": "Torrington",
    "First Name": "Jin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193389": {
    "id": "item_17495",
    "Last Name": "Balas Borba",
    "First Name": "Stefani",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193391": {
    "id": "item_13196",
    "Last Name": "tadden",
    "First Name": "vincent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193392": {
    "id": "item_800",
    "Last Name": "Jackson",
    "First Name": "Miles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193404": {
    "id": "item_30232",
    "Last Name": "Kwok",
    "First Name": "Wai Choi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193418": {
    "id": "item_28210",
    "Last Name": "Ycoy",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193421": {
    "id": "item_5221",
    "Last Name": "Gomez",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193422": {
    "id": "item_17492",
    "Last Name": "Pinzon Piraquive",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193431": {
    "id": "item_17486",
    "Last Name": "Jaiboonmak",
    "First Name": "Panadda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193434": {
    "id": "item_17490",
    "Last Name": "Burrage",
    "First Name": "Jon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193436": {
    "id": "item_30230",
    "Last Name": "limworawiwat",
    "First Name": "nuttawat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193476": {
    "id": "item_17480",
    "Last Name": "Yunita",
    "First Name": "Agata Feni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193477": {
    "id": "item_28208",
    "Last Name": "Wright",
    "First Name": "Simone",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193481": {
    "id": "item_2729",
    "Last Name": "Marshall",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193485": {
    "id": "item_5182",
    "Last Name": "MUGARUKA",
    "First Name": "SERAPHIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193496": {
    "id": "item_17477",
    "Last Name": "Singh",
    "First Name": "Chandra Mohan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193500": {
    "id": "item_17475",
    "Last Name": "Orozco",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193502": {
    "id": "item_17476",
    "Last Name": "Dejputtawat",
    "First Name": "Nalathaporn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193526": {
    "id": "item_13189",
    "Last Name": "Hines",
    "First Name": "Kaitlyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193535": {
    "id": "item_792",
    "Last Name": "Skruch",
    "First Name": "Pawel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193539": {
    "id": "item_5204",
    "Last Name": "Smith",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193540": {
    "id": "item_13188",
    "Last Name": "gonzalez",
    "First Name": "victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193541": {
    "id": "item_31069",
    "Last Name": "Vazquez",
    "First Name": "Luis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193546": {
    "id": "item_13192",
    "Last Name": "Bennett",
    "First Name": "Todd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193562": {
    "id": "item_28203",
    "Last Name": "Uy",
    "First Name": "Neil Wincent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193580": {
    "id": "item_793",
    "Last Name": "Lee",
    "First Name": "Man Leung Kenneth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193586": {
    "id": "item_5203",
    "Last Name": "Kuo",
    "First Name": "Ming Shiue",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193597": {
    "id": "item_2726",
    "Last Name": "Gulliver",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193620": {
    "id": "item_30223",
    "Last Name": "Newby",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193625": {
    "id": "item_28202",
    "Last Name": "Firmin",
    "First Name": "Joelly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193631": {
    "id": "item_17468",
    "Last Name": "Edwards",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193632": {
    "id": "item_5201",
    "Last Name": "Delmore",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193656": {
    "id": "item_5199",
    "Last Name": "Wynne",
    "First Name": "Ky",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193660": {
    "id": "item_17470",
    "Last Name": "Lee",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193674": {
    "id": "item_5198",
    "Last Name": "Lindley",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193687": {
    "id": "item_17466",
    "Last Name": "Penning",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193691": {
    "id": "item_17465",
    "Last Name": "Bear",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193725": {
    "id": "item_28199",
    "Last Name": "Benitez Blanco",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193728": {
    "id": "item_30218",
    "Last Name": "Gouveia",
    "First Name": "Claudio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193776": {
    "id": "item_17443",
    "Last Name": "Yuntaek",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193797": {
    "id": "item_2721",
    "Last Name": "Shukla",
    "First Name": "Avin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193806": {
    "id": "item_2720",
    "Last Name": "Delos Reyes",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193829": {
    "id": "item_17458",
    "Last Name": "Winata",
    "First Name": "Kenrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193878": {
    "id": "item_13181",
    "Last Name": "Grosmann",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193900": {
    "id": "item_5185",
    "Last Name": "Wu",
    "First Name": "Chien Cheng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193931": {
    "id": "item_786",
    "Last Name": "Fortington",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193939": {
    "id": "item_5184",
    "Last Name": "James",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194279": {
    "id": "item_13176",
    "Last Name": "Roberts",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194284": {
    "id": "item_28193",
    "Last Name": "Luo",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194289": {
    "id": "item_13175",
    "Last Name": "CHEN",
    "First Name": "ZIQI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194290": {
    "id": "item_2718",
    "Last Name": "Lawford",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194301": {
    "id": "item_776",
    "Last Name": "Tritton",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194317": {
    "id": "item_13173",
    "Last Name": "Chan",
    "First Name": "Ka Chun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194320": {
    "id": "item_782",
    "Last Name": "SHIN",
    "First Name": "SOYEON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194324": {
    "id": "item_1420",
    "Last Name": "wongkanlapathiti",
    "First Name": "natthapong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194334": {
    "id": "item_778",
    "Last Name": "O Sullivan",
    "First Name": "Eoghan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194337": {
    "id": "item_17444",
    "Last Name": "van der Werff",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194351": {
    "id": "item_17436",
    "Last Name": "Butcher",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194358": {
    "id": "item_13172",
    "Last Name": "Ormond",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194368": {
    "id": "item_775",
    "Last Name": "Wong",
    "First Name": "Kit Shun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194370": {
    "id": "item_13171",
    "Last Name": "Chivers",
    "First Name": "Jorrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194373": {
    "id": "item_2715",
    "Last Name": "Yuldashev",
    "First Name": "Rustam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194374": {
    "id": "item_5177",
    "Last Name": "Lao",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194376": {
    "id": "item_17439",
    "Last Name": "Perkins",
    "First Name": "Deirdre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194410": {
    "id": "item_5174",
    "Last Name": "Challis",
    "First Name": "Katelyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194425": {
    "id": "item_28189",
    "Last Name": "Luu",
    "First Name": "Co",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194427": {
    "id": "item_16028",
    "Last Name": "Hijikata",
    "First Name": "Shori",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194448": {
    "id": "item_771",
    "Last Name": "Edmiston",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194453": {
    "id": "item_2713",
    "Last Name": "Dunbar-Reid",
    "First Name": "Kloe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194455": {
    "id": "item_770",
    "Last Name": "Fordham",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194494": {
    "id": "item_16025",
    "Last Name": "Kucewicz",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194497": {
    "id": "item_17437",
    "Last Name": "Armstrong",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194499": {
    "id": "item_30202",
    "Last Name": "Claud",
    "First Name": "John Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194530": {
    "id": "item_13165",
    "Last Name": "Raus",
    "First Name": "Elizaveta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194611": {
    "id": "item_17431",
    "Last Name": "Brule",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194630": {
    "id": "item_17434",
    "Last Name": "Marshall",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194890": {
    "id": "item_17426",
    "Last Name": "Nuth",
    "First Name": "Dara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194895": {
    "id": "item_5166",
    "Last Name": "Lewis",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194897": {
    "id": "item_5164",
    "Last Name": "yustikania",
    "First Name": "indira",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194902": {
    "id": "item_17427",
    "Last Name": "MacDonald",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194919": {
    "id": "item_30195",
    "Last Name": "Hickey",
    "First Name": "Eoin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194929": {
    "id": "item_766",
    "Last Name": "Patton",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194936": {
    "id": "item_5161",
    "Last Name": "Vilela",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194940": {
    "id": "item_5162",
    "Last Name": "Lucey",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194962": {
    "id": "item_17422",
    "Last Name": "Venter",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195000": {
    "id": "item_13158",
    "Last Name": "Yung",
    "First Name": "Ming",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195009": {
    "id": "item_5159",
    "Last Name": "Le",
    "First Name": "Tuan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195037": {
    "id": "item_5158",
    "Last Name": "Li",
    "First Name": "Yifei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195039": {
    "id": "item_30199",
    "Last Name": "Gilchrist",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195058": {
    "id": "item_16023",
    "Last Name": "CHUNG",
    "First Name": "STACY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195078": {
    "id": "item_28184",
    "Last Name": "Charron",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195088": {
    "id": "item_5151",
    "Last Name": "Medina",
    "First Name": "Leonardo Jr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195437": {
    "id": "item_5152",
    "Last Name": "Cayari",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195447": {
    "id": "item_30186",
    "Last Name": "ENEMEDES",
    "First Name": "JIEZELLE MAE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195449": {
    "id": "item_17412",
    "Last Name": "Frantti-Glen",
    "First Name": "Connor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195452": {
    "id": "item_28183",
    "Last Name": "Callard",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195469": {
    "id": "item_13156",
    "Last Name": "Nair",
    "First Name": "Kailas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195474": {
    "id": "item_17410",
    "Last Name": "Brewer-Kemp",
    "First Name": "Laiken",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195487": {
    "id": "item_30188",
    "Last Name": "Taylor",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195513": {
    "id": "item_16022",
    "Last Name": "Adams",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195519": {
    "id": "item_17405",
    "Last Name": "Watts",
    "First Name": "Dale",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195551": {
    "id": "item_13154",
    "Last Name": "Carpenter",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195580": {
    "id": "item_17401",
    "Last Name": "Donkin",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195590": {
    "id": "item_17400",
    "Last Name": "Gonzalez",
    "First Name": "Leonardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195592": {
    "id": "item_30184",
    "Last Name": "Chang",
    "First Name": "Huang Chi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195595": {
    "id": "item_5148",
    "Last Name": "Gregory",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195606": {
    "id": "item_754",
    "Last Name": "LIU",
    "First Name": "SHANGHSIU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195619": {
    "id": "item_28177",
    "Last Name": "Sparks",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195622": {
    "id": "item_2699",
    "Last Name": "Chen",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195637": {
    "id": "item_5146",
    "Last Name": "Whiteman",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195639": {
    "id": "item_5143",
    "Last Name": "Kim",
    "First Name": "Deokyong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195644": {
    "id": "item_755",
    "Last Name": "Vadagnini",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195708": {
    "id": "item_30183",
    "Last Name": "Foo",
    "First Name": "Addison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195726": {
    "id": "item_5140",
    "Last Name": "Lyons",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195727": {
    "id": "item_5138",
    "Last Name": "Colreavy",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195745": {
    "id": "item_5136",
    "Last Name": "Goh",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195769": {
    "id": "item_17384",
    "Last Name": "Nel",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195796": {
    "id": "item_30179",
    "Last Name": "Gao",
    "First Name": "Chao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195823": {
    "id": "item_17381",
    "Last Name": "Foo",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195827": {
    "id": "item_17382",
    "Last Name": "Parr",
    "First Name": "Eva",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195844": {
    "id": "item_17380",
    "Last Name": "Hateley",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195851": {
    "id": "item_5128",
    "Last Name": "Polushina",
    "First Name": "Elizaveta",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195853": {
    "id": "item_17377",
    "Last Name": "Turner",
    "First Name": "Jean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195871": {
    "id": "item_5126",
    "Last Name": "Choi",
    "First Name": "Jinyoung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195872": {
    "id": "item_5131",
    "Last Name": "Holm",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195937": {
    "id": "item_28168",
    "Last Name": "Spencer",
    "First Name": "Cath",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195988": {
    "id": "item_30172",
    "Last Name": "Pedrosa",
    "First Name": "Christian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195989": {
    "id": "item_30168",
    "Last Name": "Limongan",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196005": {
    "id": "item_5120",
    "Last Name": "Gook",
    "First Name": "Harley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196035": {
    "id": "item_17369",
    "Last Name": "Jackson",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196055": {
    "id": "item_5123",
    "Last Name": "Sanderson",
    "First Name": "Sally",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196056": {
    "id": "item_745",
    "Last Name": "Chisholm",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196059": {
    "id": "item_17368",
    "Last Name": "Budo",
    "First Name": "Eno",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196086": {
    "id": "item_16018",
    "Last Name": "Yang",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196099": {
    "id": "item_17363",
    "Last Name": "Lawson",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196123": {
    "id": "item_17361",
    "Last Name": "Diaz",
    "First Name": "Trent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196124": {
    "id": "item_30161",
    "Last Name": "Astill",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196140": {
    "id": "item_740",
    "Last Name": "Stewart",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196159": {
    "id": "item_17356",
    "Last Name": "Tran",
    "First Name": "Viet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196182": {
    "id": "item_738",
    "Last Name": "Garzon Ortiz",
    "First Name": "William Mauricio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196188": {
    "id": "item_17346",
    "Last Name": "NG",
    "First Name": "wai leung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196207": {
    "id": "item_1377",
    "Last Name": "Wurch",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196211": {
    "id": "item_5117",
    "Last Name": "Gorman",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196229": {
    "id": "item_2679",
    "Last Name": "Hateley",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196320": {
    "id": "item_17347",
    "Last Name": "Coma Colom",
    "First Name": "Ingrid",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196325": {
    "id": "item_5113",
    "Last Name": "Dixon",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196331": {
    "id": "item_30158",
    "Last Name": "Mendoza",
    "First Name": "Julius",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196340": {
    "id": "item_30156",
    "Last Name": "KIM",
    "First Name": "YOUN KYU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196354": {
    "id": "item_28159",
    "Last Name": "Kang",
    "First Name": "Haylee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196357": {
    "id": "item_13979",
    "Last Name": "Leung",
    "First Name": "Yat Lai Adrian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196370": {
    "id": "item_2676",
    "Last Name": "Burling",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196391": {
    "id": "item_17332",
    "Last Name": "Cozens",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196406": {
    "id": "item_26495",
    "Last Name": "Golam",
    "First Name": "Hasanain",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196414": {
    "id": "item_28155",
    "Last Name": "Chirnside",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196423": {
    "id": "item_2675",
    "Last Name": "Hung",
    "First Name": "Yan yi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196434": {
    "id": "item_17336",
    "Last Name": "Wright",
    "First Name": "Bernadette",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196437": {
    "id": "item_5106",
    "Last Name": "Mckevitt",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196476": {
    "id": "item_2672",
    "Last Name": "Jokiel",
    "First Name": "Micha_",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196513": {
    "id": "item_13146",
    "Last Name": "Fisher",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196520": {
    "id": "item_731",
    "Last Name": "Yim",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196529": {
    "id": "item_5097",
    "Last Name": "Austin",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196587": {
    "id": "item_5093",
    "Last Name": "Shen",
    "First Name": "Lei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196588": {
    "id": "item_5094",
    "Last Name": "Collins",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196591": {
    "id": "item_17319",
    "Last Name": "tanoyo",
    "First Name": "debora",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196600": {
    "id": "item_17320",
    "Last Name": "Fitzgerald",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196607": {
    "id": "item_28142",
    "Last Name": "YANG",
    "First Name": "LIJUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196615": {
    "id": "item_2671",
    "Last Name": "CHIENYI",
    "First Name": "SU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196621": {
    "id": "item_28143",
    "Last Name": "Mayer",
    "First Name": "Riley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196652": {
    "id": "item_28146",
    "Last Name": "Waldron",
    "First Name": "Sienna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196686": {
    "id": "item_724",
    "Last Name": "O'Neill",
    "First Name": "Candice",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196740": {
    "id": "item_30146",
    "Last Name": "FENG",
    "First Name": "YINGFENG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196751": {
    "id": "item_17310",
    "Last Name": "Geers",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196758": {
    "id": "item_17281",
    "Last Name": "Healey",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196775": {
    "id": "item_5086",
    "Last Name": "Kinch",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196796": {
    "id": "item_16005",
    "Last Name": "Simes",
    "First Name": "Garry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196797": {
    "id": "item_17307",
    "Last Name": "Walters",
    "First Name": "Janet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196801": {
    "id": "item_17306",
    "Last Name": "Bartnik",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196806": {
    "id": "item_13142",
    "Last Name": "Macmang",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196812": {
    "id": "item_17304",
    "Last Name": "Mew",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196815": {
    "id": "item_16006",
    "Last Name": "Servin",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196854": {
    "id": "item_17302",
    "Last Name": "daigle",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196879": {
    "id": "item_30143",
    "Last Name": "He",
    "First Name": "Xiaohong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196889": {
    "id": "item_16003",
    "Last Name": "Pryde",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196907": {
    "id": "item_17297",
    "Last Name": "French",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196908": {
    "id": "item_5083",
    "Last Name": "Gutierrez",
    "First Name": "Duxsann",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196983": {
    "id": "item_16002",
    "Last Name": "Yang",
    "First Name": "TzuHan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196993": {
    "id": "item_30140",
    "Last Name": "Rawangkan",
    "First Name": "Watcharaporn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197017": {
    "id": "item_30139",
    "Last Name": "Ginting",
    "First Name": "Ramona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197022": {
    "id": "item_17292",
    "Last Name": "Roach",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197045": {
    "id": "item_5081",
    "Last Name": "Cassard",
    "First Name": "Nolan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197077": {
    "id": "item_13140",
    "Last Name": "Fingleton",
    "First Name": "Eilise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197078": {
    "id": "item_2666",
    "Last Name": "Ellis",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197096": {
    "id": "item_718",
    "Last Name": "Grycner",
    "First Name": "Tomasz",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197107": {
    "id": "item_16000",
    "Last Name": "Grove",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197133": {
    "id": "item_28134",
    "Last Name": "Harvey-Trappel",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197148": {
    "id": "item_28135",
    "Last Name": "Puyat",
    "First Name": "Andrea Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197185": {
    "id": "item_28131",
    "Last Name": "CHIH",
    "First Name": "TSUNGMIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197231": {
    "id": "item_17278",
    "Last Name": "Umali",
    "First Name": "Winston",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197251": {
    "id": "item_715",
    "Last Name": "Laskey",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197252": {
    "id": "item_5072",
    "Last Name": "chen",
    "First Name": "jun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197265": {
    "id": "item_13134",
    "Last Name": "HANKOOK",
    "First Name": "LEE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197274": {
    "id": "item_17273",
    "Last Name": "LESPERT",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197296": {
    "id": "item_5069",
    "Last Name": "Stanley",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197297": {
    "id": "item_13135",
    "Last Name": "Herrera",
    "First Name": "Aldi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197311": {
    "id": "item_5068",
    "Last Name": "Ren",
    "First Name": "Annica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197337": {
    "id": "item_5066",
    "Last Name": "Coulson",
    "First Name": "Dane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197422": {
    "id": "item_2659",
    "Last Name": "kang",
    "First Name": "minyoung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197425": {
    "id": "item_13133",
    "Last Name": "Goatley",
    "First Name": "Byron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197428": {
    "id": "item_2657",
    "Last Name": "Kerr",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197431": {
    "id": "item_15997",
    "Last Name": "Yuwono",
    "First Name": "Widiarti",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197450": {
    "id": "item_30125",
    "Last Name": "Rigor",
    "First Name": "Gio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197452": {
    "id": "item_5057",
    "Last Name": "Wu",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197455": {
    "id": "item_5056",
    "Last Name": "Finnegan",
    "First Name": "Byron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197461": {
    "id": "item_2656",
    "Last Name": "McCreadie",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197506": {
    "id": "item_15995",
    "Last Name": "Stansfield",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197513": {
    "id": "item_15996",
    "Last Name": "Grant",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197523": {
    "id": "item_17257",
    "Last Name": "Rosario",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197530": {
    "id": "item_5055",
    "Last Name": "Goy",
    "First Name": "Shen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197627": {
    "id": "item_710",
    "Last Name": "Barber",
    "First Name": "Kirk",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197651": {
    "id": "item_536",
    "Last Name": "Christodoulou",
    "First Name": "Sebastien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197654": {
    "id": "item_5051",
    "Last Name": "Napoleone",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197694": {
    "id": "item_708",
    "Last Name": "Chong",
    "First Name": "Asher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197702": {
    "id": "item_707",
    "Last Name": "Kwan",
    "First Name": "Stephanie Wai Yin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197703": {
    "id": "item_17240",
    "Last Name": "Lin",
    "First Name": "Chia Hou",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197710": {
    "id": "item_17242",
    "Last Name": "Ikhu-Omoregbe",
    "First Name": "Isoken",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197735": {
    "id": "item_5048",
    "Last Name": "Drever",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197749": {
    "id": "item_30115",
    "Last Name": "Wiggill",
    "First Name": "CLAIRE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197750": {
    "id": "item_28113",
    "Last Name": "Woolley",
    "First Name": "Yasmine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197770": {
    "id": "item_28110",
    "Last Name": "Walters",
    "First Name": "Diane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197793": {
    "id": "item_705",
    "Last Name": "Grayling",
    "First Name": "Nellie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197808": {
    "id": "item_5044",
    "Last Name": "Dunne",
    "First Name": "Glen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197811": {
    "id": "item_704",
    "Last Name": "Lau",
    "First Name": "Pak Shing Pakson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197850": {
    "id": "item_13129",
    "Last Name": "Dela Cruz Van Niekerk",
    "First Name": "Jessel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197852": {
    "id": "item_17230",
    "Last Name": "O'Dwyer",
    "First Name": "Josephine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197854": {
    "id": "item_28108",
    "Last Name": "Hla",
    "First Name": "San Shwe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197856": {
    "id": "item_17232",
    "Last Name": "Thorpe",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197863": {
    "id": "item_30109",
    "Last Name": "Svensen",
    "First Name": "Libby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197869": {
    "id": "item_17231",
    "Last Name": "Convery",
    "First Name": "Rory",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197900": {
    "id": "item_30111",
    "Last Name": "Hope",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197908": {
    "id": "item_17226",
    "Last Name": "Tsebelis",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197917": {
    "id": "item_5040",
    "Last Name": "Davis",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197925": {
    "id": "item_17224",
    "Last Name": "Slarke",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197931": {
    "id": "item_13125",
    "Last Name": "Do",
    "First Name": "Nam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197948": {
    "id": "item_17222",
    "Last Name": "Kerr",
    "First Name": "Michele",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197979": {
    "id": "item_17218",
    "Last Name": "AGNEL",
    "First Name": "Pierre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198006": {
    "id": "item_17216",
    "Last Name": "Hughes",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198020": {
    "id": "item_699",
    "Last Name": "Nores",
    "First Name": "Fran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198025": {
    "id": "item_2646",
    "Last Name": "Owen",
    "First Name": "Helen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198034": {
    "id": "item_5036",
    "Last Name": "Andrews",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198069": {
    "id": "item_17209",
    "Last Name": "Crouser",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198080": {
    "id": "item_692",
    "Last Name": "Cheung",
    "First Name": "Hoi Wing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198093": {
    "id": "item_5035",
    "Last Name": "Tsai",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198116": {
    "id": "item_28100",
    "Last Name": "Pacitti",
    "First Name": "Eugenia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198122": {
    "id": "item_30101",
    "Last Name": "Gi Cheol",
    "First Name": "Shin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198141": {
    "id": "item_694",
    "Last Name": "Fernandez",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198178": {
    "id": "item_5030",
    "Last Name": "Wang",
    "First Name": "Ye",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198235": {
    "id": "item_693",
    "Last Name": "Reimers Smith",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198253": {
    "id": "item_5024",
    "Last Name": "Richardson",
    "First Name": "Priya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198269": {
    "id": "item_2642",
    "Last Name": "Dennis",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198328": {
    "id": "item_5022",
    "Last Name": "Nieh",
    "First Name": "Tak Kin Dennis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198333": {
    "id": "item_17203",
    "Last Name": "Workman",
    "First Name": "Jade",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198342": {
    "id": "item_15985",
    "Last Name": "Suchard",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198351": {
    "id": "item_2640",
    "Last Name": "Jamshidi",
    "First Name": "Neda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198384": {
    "id": "item_17197",
    "Last Name": "Crew",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198389": {
    "id": "item_28094",
    "Last Name": "Aranguren",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198403": {
    "id": "item_690",
    "Last Name": "Taylor",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198409": {
    "id": "item_5017",
    "Last Name": "Thompson",
    "First Name": "Kara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198417": {
    "id": "item_5016",
    "Last Name": "Weerdenburg",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198435": {
    "id": "item_2638",
    "Last Name": "Karki",
    "First Name": "Mohan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198474": {
    "id": "item_28092",
    "Last Name": "Wade",
    "First Name": "Dion",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198586": {
    "id": "item_26494",
    "Last Name": "Abdullah",
    "First Name": "Mohamad Arif",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198593": {
    "id": "item_3260",
    "Last Name": "DONOHOE",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198661": {
    "id": "item_5010",
    "Last Name": "Mahon",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198668": {
    "id": "item_688",
    "Last Name": "Lawrence",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198679": {
    "id": "item_30090",
    "Last Name": "Firmin",
    "First Name": "Zara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198690": {
    "id": "item_2633",
    "Last Name": "KURAMITSU",
    "First Name": "NOZOMI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198709": {
    "id": "item_5006",
    "Last Name": "Santiago",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198711": {
    "id": "item_15981",
    "Last Name": "Egan",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198725": {
    "id": "item_17178",
    "Last Name": "San Jose",
    "First Name": "Madelaine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198741": {
    "id": "item_686",
    "Last Name": "Mason",
    "First Name": "Guy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198748": {
    "id": "item_28083",
    "Last Name": "Mustapic",
    "First Name": "Glen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198770": {
    "id": "item_17176",
    "Last Name": "Seeger",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198802": {
    "id": "item_13114",
    "Last Name": "sin",
    "First Name": "sio seng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198809": {
    "id": "item_17169",
    "Last Name": "Murphy",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198812": {
    "id": "item_17174",
    "Last Name": "MA",
    "First Name": "XUANNAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198814": {
    "id": "item_30087",
    "Last Name": "Webber",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198839": {
    "id": "item_15980",
    "Last Name": "Han",
    "First Name": "Yuan Soohan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198867": {
    "id": "item_684",
    "Last Name": "Tracey",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198904": {
    "id": "item_30084",
    "Last Name": "Eide",
    "First Name": "Vidar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198911": {
    "id": "item_17168",
    "Last Name": "Hwang",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198913": {
    "id": "item_2630",
    "Last Name": "JIN",
    "First Name": "CHENGCHENG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198940": {
    "id": "item_683",
    "Last Name": "Hansen",
    "First Name": "Malte",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198975": {
    "id": "item_30071",
    "Last Name": "Chew",
    "First Name": "Kai Hoong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199025": {
    "id": "item_30077",
    "Last Name": "Connolly",
    "First Name": "Aileen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199033": {
    "id": "item_2628",
    "Last Name": "VILLA",
    "First Name": "CHRISTIAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199050": {
    "id": "item_30076",
    "Last Name": "Stefanus",
    "First Name": "Ardian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199057": {
    "id": "item_680",
    "Last Name": "Meakins",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199063": {
    "id": "item_15978",
    "Last Name": "Zienau",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199073": {
    "id": "item_17153",
    "Last Name": "Stephenson",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199075": {
    "id": "item_15977",
    "Last Name": "Yang",
    "First Name": "Jin Jin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199082": {
    "id": "item_17154",
    "Last Name": "Bravo",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199099": {
    "id": "item_2626",
    "Last Name": "Maher",
    "First Name": "Lynsey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199114": {
    "id": "item_30070",
    "Last Name": "Zhang",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199122": {
    "id": "item_15976",
    "Last Name": "Sturmer",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199146": {
    "id": "item_17146",
    "Last Name": "Canny",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199153": {
    "id": "item_17144",
    "Last Name": "Cornejo",
    "First Name": "Bernadette",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199194": {
    "id": "item_28075",
    "Last Name": "Graham",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199199": {
    "id": "item_17142",
    "Last Name": "Murphy",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199206": {
    "id": "item_676",
    "Last Name": "Hope",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199210": {
    "id": "item_30066",
    "Last Name": "LOVELL",
    "First Name": "JENNIFER",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199246": {
    "id": "item_17138",
    "Last Name": "Zhang",
    "First Name": "Erkang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199262": {
    "id": "item_28073",
    "Last Name": "Huynh",
    "First Name": "Briana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199263": {
    "id": "item_28872",
    "Last Name": "McKelvey",
    "First Name": "Serena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199268": {
    "id": "item_28871",
    "Last Name": "Keeling",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199271": {
    "id": "item_17136",
    "Last Name": "FERLIN",
    "First Name": "ANGREKTA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199281": {
    "id": "item_4988",
    "Last Name": "Daw",
    "First Name": "Caspar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199314": {
    "id": "item_30064",
    "Last Name": "Sartori",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199317": {
    "id": "item_30063",
    "Last Name": "Tandijanto",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199319": {
    "id": "item_2624",
    "Last Name": "De Rosa",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199320": {
    "id": "item_17130",
    "Last Name": "Johnson",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199328": {
    "id": "item_17132",
    "Last Name": "Sparkes",
    "First Name": "Dwayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199343": {
    "id": "item_2622",
    "Last Name": "Adendorff",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199346": {
    "id": "item_13107",
    "Last Name": "Shi",
    "First Name": "Caixia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199373": {
    "id": "item_17128",
    "Last Name": "Ray",
    "First Name": "Janita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199383": {
    "id": "item_30060",
    "Last Name": "Moyle",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199394": {
    "id": "item_28071",
    "Last Name": "Daley",
    "First Name": "Carly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199404": {
    "id": "item_2619",
    "Last Name": "Narkevich",
    "First Name": "Aleksandr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199413": {
    "id": "item_17125",
    "Last Name": "McInerney",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199427": {
    "id": "item_4987",
    "Last Name": "Osborne",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199439": {
    "id": "item_13106",
    "Last Name": "Lowe",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199458": {
    "id": "item_30058",
    "Last Name": "Greer",
    "First Name": "Allanah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199499": {
    "id": "item_17118",
    "Last Name": "Brown",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199501": {
    "id": "item_17117",
    "Last Name": "Generalao",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199508": {
    "id": "item_28066",
    "Last Name": "Keegan",
    "First Name": "Tegan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199522": {
    "id": "item_2617",
    "Last Name": "CortŽs",
    "First Name": "Camilo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199543": {
    "id": "item_4983",
    "Last Name": "Alderson",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199553": {
    "id": "item_17108",
    "Last Name": "Gani",
    "First Name": "Gusmawan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199566": {
    "id": "item_15975",
    "Last Name": "Owens",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199570": {
    "id": "item_15974",
    "Last Name": "Rolf",
    "First Name": "Bjarne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199571": {
    "id": "item_17111",
    "Last Name": "Parma",
    "First Name": "Marco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199584": {
    "id": "item_30053",
    "Last Name": "Cheng",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199652": {
    "id": "item_17110",
    "Last Name": "NEGRO",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199666": {
    "id": "item_17109",
    "Last Name": "Driesen",
    "First Name": "Annelies",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199675": {
    "id": "item_2607",
    "Last Name": "Chalkley",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199683": {
    "id": "item_4980",
    "Last Name": "Van Gordon",
    "First Name": "Kate",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199695": {
    "id": "item_28061",
    "Last Name": "Rigby",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199710": {
    "id": "item_670",
    "Last Name": "Tan",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199716": {
    "id": "item_17107",
    "Last Name": "Grassi",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199732": {
    "id": "item_15971",
    "Last Name": "Eclarino",
    "First Name": "Reena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199743": {
    "id": "item_17103",
    "Last Name": "Monaghan",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199770": {
    "id": "item_28057",
    "Last Name": "LAM",
    "First Name": "KAI LUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199784": {
    "id": "item_669",
    "Last Name": "Darcy",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199806": {
    "id": "item_17100",
    "Last Name": "Kang",
    "First Name": "Jian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199849": {
    "id": "item_4973",
    "Last Name": "Collins",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199851": {
    "id": "item_28055",
    "Last Name": "Huang",
    "First Name": "Yi-Zhen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199861": {
    "id": "item_4972",
    "Last Name": "Jackson",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199866": {
    "id": "item_15967",
    "Last Name": "Ivison",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199877": {
    "id": "item_17094",
    "Last Name": "James",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199902": {
    "id": "item_14041",
    "Last Name": "TODA",
    "First Name": "HIDEYUKI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199917": {
    "id": "item_30044",
    "Last Name": "Rodrigo",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199943": {
    "id": "item_28053",
    "Last Name": "Larrazabal",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199963": {
    "id": "item_4961",
    "Last Name": "Vaudelle",
    "First Name": "denis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199969": {
    "id": "item_4967",
    "Last Name": "Sarvos",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199970": {
    "id": "item_17076",
    "Last Name": "Cheshire",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199973": {
    "id": "item_17082",
    "Last Name": "Brown",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199980": {
    "id": "item_661",
    "Last Name": "Blanchett Hearn",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199985": {
    "id": "item_660",
    "Last Name": "Noonan",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200004": {
    "id": "item_17079",
    "Last Name": "Burgon",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200005": {
    "id": "item_28048",
    "Last Name": "Mustapic",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200011": {
    "id": "item_30039",
    "Last Name": "Fasher",
    "First Name": "Carla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200036": {
    "id": "item_30037",
    "Last Name": "Chang",
    "First Name": "Yuan-Hung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200044": {
    "id": "item_4960",
    "Last Name": "SOMERVILLE",
    "First Name": "LUKE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200081": {
    "id": "item_4959",
    "Last Name": "Vashchuk",
    "First Name": "Mykhailo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200092": {
    "id": "item_30029",
    "Last Name": "Ellis",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200109": {
    "id": "item_30035",
    "Last Name": "Chen",
    "First Name": "Yingying",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200124": {
    "id": "item_2595",
    "Last Name": "Poyner",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200140": {
    "id": "item_28043",
    "Last Name": "Ang",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200151": {
    "id": "item_17065",
    "Last Name": "Rajaram",
    "First Name": "Vasant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200202": {
    "id": "item_4954",
    "Last Name": "DO",
    "First Name": "MINH TAM",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200206": {
    "id": "item_17063",
    "Last Name": "Fitzpatrick",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200207": {
    "id": "item_4956",
    "Last Name": "Murray",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200211": {
    "id": "item_15966",
    "Last Name": "Murray",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200215": {
    "id": "item_30025",
    "Last Name": "Doyle",
    "First Name": "Charlene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200253": {
    "id": "item_28039",
    "Last Name": "Pramana",
    "First Name": "Gilang widya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200267": {
    "id": "item_17060",
    "Last Name": "Brennen",
    "First Name": "Rich",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200304": {
    "id": "item_17055",
    "Last Name": "LOPEZ CALDERON",
    "First Name": "MIGUEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200364": {
    "id": "item_26493",
    "Last Name": "Fallins",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200379": {
    "id": "item_13097",
    "Last Name": "Stoltz",
    "First Name": "Karl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200407": {
    "id": "item_4743",
    "Last Name": "Mulhearn",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200467": {
    "id": "item_17053",
    "Last Name": "Thompson",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200485": {
    "id": "item_28032",
    "Last Name": "Kajornwuttideth",
    "First Name": "Duangjai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200490": {
    "id": "item_4943",
    "Last Name": "Seal",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200492": {
    "id": "item_17050",
    "Last Name": "Foote",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200498": {
    "id": "item_4939",
    "Last Name": "Ahmad",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200518": {
    "id": "item_4940",
    "Last Name": "Holt",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200522": {
    "id": "item_15963",
    "Last Name": "Fuhrmann",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200525": {
    "id": "item_28029",
    "Last Name": "Kummalue",
    "First Name": "Posawat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200537": {
    "id": "item_647",
    "Last Name": "Dykes",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200539": {
    "id": "item_28030",
    "Last Name": "Sommers",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200540": {
    "id": "item_17046",
    "Last Name": "Powell",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200544": {
    "id": "item_2589",
    "Last Name": "mcquaid",
    "First Name": "olivia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200558": {
    "id": "item_28027",
    "Last Name": "Ramage",
    "First Name": "Rebekah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200574": {
    "id": "item_643",
    "Last Name": "Wodzinski",
    "First Name": "Michal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200578": {
    "id": "item_17044",
    "Last Name": "Sweeney",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200589": {
    "id": "item_16726",
    "Last Name": "Morris",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200690": {
    "id": "item_17036",
    "Last Name": "Carey",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200691": {
    "id": "item_30016",
    "Last Name": "Buckley",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200694": {
    "id": "item_2583",
    "Last Name": "TSIAPRAZLIS",
    "First Name": "SPYRIDON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200704": {
    "id": "item_2581",
    "Last Name": "Hannon",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200749": {
    "id": "item_28019",
    "Last Name": "Cohen",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200788": {
    "id": "item_30010",
    "Last Name": "Keane",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200805": {
    "id": "item_15959",
    "Last Name": "Pullen",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200807": {
    "id": "item_30008",
    "Last Name": "Wang",
    "First Name": "Xiaohan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200838": {
    "id": "item_2578",
    "Last Name": "Pitman",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200859": {
    "id": "item_14040",
    "Last Name": "Ortega",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200866": {
    "id": "item_30006",
    "Last Name": "Ruan",
    "First Name": "Ivy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200867": {
    "id": "item_2575",
    "Last Name": "Sankey",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200869": {
    "id": "item_17028",
    "Last Name": "Cherry",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200873": {
    "id": "item_17027",
    "Last Name": "Medlin",
    "First Name": "Alyra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200876": {
    "id": "item_28017",
    "Last Name": "Chapman",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200887": {
    "id": "item_638",
    "Last Name": "Martin",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200896": {
    "id": "item_4930",
    "Last Name": "Cavalheiro",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200933": {
    "id": "item_4931",
    "Last Name": "Voronin",
    "First Name": "Egor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200936": {
    "id": "item_30007",
    "Last Name": "Luo",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200951": {
    "id": "item_635",
    "Last Name": "Benito",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200954": {
    "id": "item_17021",
    "Last Name": "Lurati",
    "First Name": "Tenae",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200972": {
    "id": "item_17020",
    "Last Name": "Hamp",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201011": {
    "id": "item_13090",
    "Last Name": "Cordner",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201015": {
    "id": "item_2572",
    "Last Name": "Da Silva De Freitas",
    "First Name": "Nelio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201020": {
    "id": "item_28014",
    "Last Name": "Metselaar",
    "First Name": "Maaike",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201040": {
    "id": "item_28013",
    "Last Name": "Lawrence",
    "First Name": "Cissy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201053": {
    "id": "item_17016",
    "Last Name": "Pedersen",
    "First Name": "Nicklas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201120": {
    "id": "item_30002",
    "Last Name": "JANG",
    "First Name": "HWANHOON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201130": {
    "id": "item_17009",
    "Last Name": "Bailey",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201166": {
    "id": "item_30000",
    "Last Name": "Dyet",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201171": {
    "id": "item_28011",
    "Last Name": "Ware",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201177": {
    "id": "item_30001",
    "Last Name": "Howard",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201181": {
    "id": "item_28007",
    "Last Name": "Peck",
    "First Name": "Grant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201188": {
    "id": "item_28010",
    "Last Name": "Kragl",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201195": {
    "id": "item_29999",
    "Last Name": "Munckton",
    "First Name": "Jacki-Lee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201199": {
    "id": "item_630",
    "Last Name": "Boling",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201200": {
    "id": "item_13088",
    "Last Name": "AYDIN",
    "First Name": "MERT",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201204": {
    "id": "item_629",
    "Last Name": "Montemurro",
    "First Name": "Luigi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201217": {
    "id": "item_28006",
    "Last Name": "Buttacavoli",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201245": {
    "id": "item_29996",
    "Last Name": "Stefanovic",
    "First Name": "Elise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201255": {
    "id": "item_28005",
    "Last Name": "Ware",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201284": {
    "id": "item_29995",
    "Last Name": "Cowgill",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201322": {
    "id": "item_4918",
    "Last Name": "Watkins",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201325": {
    "id": "item_626",
    "Last Name": "Scott-Young",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201351": {
    "id": "item_29986",
    "Last Name": "Tsai",
    "First Name": "Hsin-Jung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201353": {
    "id": "item_17000",
    "Last Name": "Simpson",
    "First Name": "Travers",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201359": {
    "id": "item_29987",
    "Last Name": "Winship",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201360": {
    "id": "item_29989",
    "Last Name": "Stjepic",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201418": {
    "id": "item_4916",
    "Last Name": "Hasell",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201451": {
    "id": "item_2555",
    "Last Name": "Laskova",
    "First Name": "Veronika",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201468": {
    "id": "item_16990",
    "Last Name": "yu",
    "First Name": "Huang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201472": {
    "id": "item_29981",
    "Last Name": "Byers",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201482": {
    "id": "item_27998",
    "Last Name": "Tap",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201490": {
    "id": "item_27999",
    "Last Name": "Dela Cruz",
    "First Name": "Meinell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201492": {
    "id": "item_16992",
    "Last Name": "Collier",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201502": {
    "id": "item_29975",
    "Last Name": "Mineo",
    "First Name": "Ana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201518": {
    "id": "item_2551",
    "Last Name": "Andersson",
    "First Name": "Mattias",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201539": {
    "id": "item_13083",
    "Last Name": "Lacson",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201551": {
    "id": "item_16983",
    "Last Name": "Mccormack",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201554": {
    "id": "item_16979",
    "Last Name": "Peppard",
    "First Name": "Ruarhi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201557": {
    "id": "item_612",
    "Last Name": "ZHANG",
    "First Name": "Chaoxu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201564": {
    "id": "item_4911",
    "Last Name": "Schmidt",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201569": {
    "id": "item_29979",
    "Last Name": "Lightfoot",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201571": {
    "id": "item_13081",
    "Last Name": "Turner",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201593": {
    "id": "item_16980",
    "Last Name": "de la Mano",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201598": {
    "id": "item_14039",
    "Last Name": "FU",
    "First Name": "YUK KIU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201608": {
    "id": "item_15952",
    "Last Name": "De Silva",
    "First Name": "Prasanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201625": {
    "id": "item_4908",
    "Last Name": "Morton",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201626": {
    "id": "item_4909",
    "Last Name": "Truong",
    "First Name": "Khoa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201638": {
    "id": "item_614",
    "Last Name": "sun",
    "First Name": "guangyi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201643": {
    "id": "item_15951",
    "Last Name": "Hendarman",
    "First Name": "Ferdi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201646": {
    "id": "item_27996",
    "Last Name": "Mckinnon",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201671": {
    "id": "item_16976",
    "Last Name": "Reynolds",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201674": {
    "id": "item_16977",
    "Last Name": "McIntyre",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201697": {
    "id": "item_13078",
    "Last Name": "Larsen",
    "First Name": "Anders Binne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201700": {
    "id": "item_16973",
    "Last Name": "Green",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201713": {
    "id": "item_4905",
    "Last Name": "Gibbons",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201714": {
    "id": "item_16972",
    "Last Name": "Hall",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201719": {
    "id": "item_27995",
    "Last Name": "Schack",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201726": {
    "id": "item_2549",
    "Last Name": "Whitaker",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201729": {
    "id": "item_4900",
    "Last Name": "Scheggia",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201742": {
    "id": "item_16969",
    "Last Name": "Fox",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201770": {
    "id": "item_16962",
    "Last Name": "Welsch",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201778": {
    "id": "item_4899",
    "Last Name": "Pope",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201787": {
    "id": "item_611",
    "Last Name": "Gibbs",
    "First Name": "Sara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201811": {
    "id": "item_608",
    "Last Name": "Fagan",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201839": {
    "id": "item_16963",
    "Last Name": "Quinn",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201859": {
    "id": "item_27991",
    "Last Name": "Timmerman",
    "First Name": "Aovana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201898": {
    "id": "item_27989",
    "Last Name": "Markwart",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201918": {
    "id": "item_16959",
    "Last Name": "Glavas",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201920": {
    "id": "item_16957",
    "Last Name": "Tuncer",
    "First Name": "Mehmet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201924": {
    "id": "item_16954",
    "Last Name": "lu",
    "First Name": "Huy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201944": {
    "id": "item_29962",
    "Last Name": "Burgess",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201958": {
    "id": "item_4886",
    "Last Name": "Walsh",
    "First Name": "Eammon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201967": {
    "id": "item_16950",
    "Last Name": "BONIFACE",
    "First Name": "Aude",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201998": {
    "id": "item_4883",
    "Last Name": "Hodge",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202016": {
    "id": "item_4881",
    "Last Name": "Coull",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202023": {
    "id": "item_606",
    "Last Name": "Evans",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202030": {
    "id": "item_29960",
    "Last Name": "Zhuo",
    "First Name": "Qi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202065": {
    "id": "item_16940",
    "Last Name": "Windapo",
    "First Name": "Titi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202075": {
    "id": "item_29954",
    "Last Name": "Pabillore",
    "First Name": "Marna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202090": {
    "id": "item_16936",
    "Last Name": "Swan",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202093": {
    "id": "item_16941",
    "Last Name": "Brough",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202124": {
    "id": "item_2536",
    "Last Name": "Carter",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202127": {
    "id": "item_4873",
    "Last Name": "Lee",
    "First Name": "Suwon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202129": {
    "id": "item_16934",
    "Last Name": "Vanparijs",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202139": {
    "id": "item_16933",
    "Last Name": "McGarrell",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202148": {
    "id": "item_16727",
    "Last Name": "Fairbourn",
    "First Name": "Guy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202158": {
    "id": "item_15945",
    "Last Name": "Leung",
    "First Name": "Shui Han",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202163": {
    "id": "item_14038",
    "Last Name": "Cray",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202187": {
    "id": "item_16922",
    "Last Name": "Swindley",
    "First Name": "Alana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202195": {
    "id": "item_27981",
    "Last Name": "Hibbert",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202198": {
    "id": "item_603",
    "Last Name": "Griffith",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202202": {
    "id": "item_537",
    "Last Name": "YU",
    "First Name": "HONGRUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202217": {
    "id": "item_16920",
    "Last Name": "Myers",
    "First Name": "Martha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202238": {
    "id": "item_4869",
    "Last Name": "Wood",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202240": {
    "id": "item_16921",
    "Last Name": "McGown",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202243": {
    "id": "item_27979",
    "Last Name": "HUANG",
    "First Name": "PERNGCHIH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202253": {
    "id": "item_2534",
    "Last Name": "Taneja",
    "First Name": "Tushar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202255": {
    "id": "item_4870",
    "Last Name": "Bobbett",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202260": {
    "id": "item_16918",
    "Last Name": "Carr",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202266": {
    "id": "item_27976",
    "Last Name": "Moore",
    "First Name": "Lena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202280": {
    "id": "item_27975",
    "Last Name": "OÕMahony",
    "First Name": "Cliona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202298": {
    "id": "item_16914",
    "Last Name": "Pan",
    "First Name": "Peng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202314": {
    "id": "item_16912",
    "Last Name": "Lane",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202346": {
    "id": "item_16913",
    "Last Name": "Wirasasmita",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202371": {
    "id": "item_29946",
    "Last Name": "Field",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202381": {
    "id": "item_598",
    "Last Name": "Scamporlino",
    "First Name": "Beau",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202386": {
    "id": "item_15943",
    "Last Name": "Hennessy",
    "First Name": "Jillian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202393": {
    "id": "item_29930",
    "Last Name": "Anderson",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202395": {
    "id": "item_4864",
    "Last Name": "Whittle",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202424": {
    "id": "item_4865",
    "Last Name": "Kang",
    "First Name": "Dayeon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202425": {
    "id": "item_13072",
    "Last Name": "Souza",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202430": {
    "id": "item_27970",
    "Last Name": "Walford",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202438": {
    "id": "item_16896",
    "Last Name": "Jones",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202441": {
    "id": "item_29939",
    "Last Name": "Szypulski",
    "First Name": "Brett",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202448": {
    "id": "item_16898",
    "Last Name": "Eagleton",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202465": {
    "id": "item_16903",
    "Last Name": "Amirul Danial",
    "First Name": "Mohamad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202496": {
    "id": "item_29937",
    "Last Name": "Dudley",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202498": {
    "id": "item_596",
    "Last Name": "Frunze",
    "First Name": "Sergey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202510": {
    "id": "item_4860",
    "Last Name": "Hiller",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202525": {
    "id": "item_16892",
    "Last Name": "Smith",
    "First Name": "Tynan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202541": {
    "id": "item_4856",
    "Last Name": "Batongbakal",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202566": {
    "id": "item_29934",
    "Last Name": "Christian",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202567": {
    "id": "item_4852",
    "Last Name": "Burt",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202586": {
    "id": "item_16879",
    "Last Name": "Preston",
    "First Name": "Jarrad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202605": {
    "id": "item_16885",
    "Last Name": "Vas",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202608": {
    "id": "item_2524",
    "Last Name": "Jameson",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202610": {
    "id": "item_2523",
    "Last Name": "GAUTHIER",
    "First Name": "FLORENT",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202625": {
    "id": "item_16881",
    "Last Name": "Lugrin",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202668": {
    "id": "item_16878",
    "Last Name": "Centonza",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202676": {
    "id": "item_29926",
    "Last Name": "Setiawan",
    "First Name": "Dadang Agus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202692": {
    "id": "item_29928",
    "Last Name": "Rante",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202700": {
    "id": "item_16876",
    "Last Name": "McKay",
    "First Name": "Drewe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202701": {
    "id": "item_594",
    "Last Name": "Chan",
    "First Name": "Ping Kei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202707": {
    "id": "item_29922",
    "Last Name": "Anderson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202721": {
    "id": "item_2520",
    "Last Name": "Yossef",
    "First Name": "Hosam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202725": {
    "id": "item_4848",
    "Last Name": "Ogden",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202753": {
    "id": "item_29914",
    "Last Name": "Gautama",
    "First Name": "Ahimsa Dwi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202771": {
    "id": "item_13067",
    "Last Name": "Barredo",
    "First Name": "Kenneth Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202786": {
    "id": "item_16865",
    "Last Name": "Hawkins",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202795": {
    "id": "item_16868",
    "Last Name": "Chhean",
    "First Name": "Theodore",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202798": {
    "id": "item_16866",
    "Last Name": "Walker",
    "First Name": "AJ",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202820": {
    "id": "item_4843",
    "Last Name": "Abdiyeva",
    "First Name": "Akmaral",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202829": {
    "id": "item_587",
    "Last Name": "KALKANIDIS",
    "First Name": "DIMITRIOS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202831": {
    "id": "item_591",
    "Last Name": "Batty",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202851": {
    "id": "item_29916",
    "Last Name": "Barry",
    "First Name": "Isagani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202887": {
    "id": "item_16859",
    "Last Name": "Kendall",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202890": {
    "id": "item_16862",
    "Last Name": "Devenny",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202938": {
    "id": "item_16851",
    "Last Name": "Papen",
    "First Name": "Negin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202957": {
    "id": "item_2519",
    "Last Name": "Wong",
    "First Name": "Viv",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202964": {
    "id": "item_15938",
    "Last Name": "Zerna",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202979": {
    "id": "item_16846",
    "Last Name": "Koscak",
    "First Name": "Aleksander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202986": {
    "id": "item_29909",
    "Last Name": "Sellings",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203015": {
    "id": "item_16842",
    "Last Name": "Smith",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203016": {
    "id": "item_16839",
    "Last Name": "Higgs",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203017": {
    "id": "item_4830",
    "Last Name": "Copp",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203034": {
    "id": "item_4826",
    "Last Name": "Bond",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203040": {
    "id": "item_4825",
    "Last Name": "Makarewicz",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203051": {
    "id": "item_584",
    "Last Name": "Ostrowski",
    "First Name": "Kacper",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203070": {
    "id": "item_13064",
    "Last Name": "Chan",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203115": {
    "id": "item_27951",
    "Last Name": "Doble",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203118": {
    "id": "item_16832",
    "Last Name": "Pham",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203121": {
    "id": "item_4823",
    "Last Name": "Wu",
    "First Name": "Yihong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203150": {
    "id": "item_579",
    "Last Name": "Reavill-Blake",
    "First Name": "Jatila",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203154": {
    "id": "item_4822",
    "Last Name": "Khalil",
    "First Name": "Wassim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203173": {
    "id": "item_4817",
    "Last Name": "Condron",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203179": {
    "id": "item_4816",
    "Last Name": "Jaconelli",
    "First Name": "Jerome",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203191": {
    "id": "item_16821",
    "Last Name": "Kaczynski",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203205": {
    "id": "item_16818",
    "Last Name": "Lawrence",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203209": {
    "id": "item_29901",
    "Last Name": "WANG",
    "First Name": "QIPING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203247": {
    "id": "item_2509",
    "Last Name": "LI",
    "First Name": "WENJING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203258": {
    "id": "item_576",
    "Last Name": "Lam",
    "First Name": "Kai Cheuk",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203265": {
    "id": "item_2511",
    "Last Name": "Lam",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203283": {
    "id": "item_4807",
    "Last Name": "Fader",
    "First Name": "Eliane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203308": {
    "id": "item_16805",
    "Last Name": "Aleksovski",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203313": {
    "id": "item_29895",
    "Last Name": "WANG",
    "First Name": "ZIWEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203323": {
    "id": "item_4806",
    "Last Name": "Matheson",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203336": {
    "id": "item_29893",
    "Last Name": "Novita anom",
    "First Name": "Candra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203344": {
    "id": "item_14037",
    "Last Name": "KWONG",
    "First Name": "CHI HANG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203359": {
    "id": "item_16802",
    "Last Name": "Aprilliani",
    "First Name": "Sani",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203367": {
    "id": "item_29892",
    "Last Name": "Ngo",
    "First Name": "Quang Loc",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203374": {
    "id": "item_16803",
    "Last Name": "Lai",
    "First Name": "Cho Lok Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203377": {
    "id": "item_572",
    "Last Name": "Progin",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203402": {
    "id": "item_570",
    "Last Name": "Fairley",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203411": {
    "id": "item_16798",
    "Last Name": "THIREAU",
    "First Name": "FRANCOIS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203440": {
    "id": "item_3259",
    "Last Name": "Bartlett",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203447": {
    "id": "item_29889",
    "Last Name": "Szilagyi",
    "First Name": "Tamas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203449": {
    "id": "item_27936",
    "Last Name": "Ksit",
    "First Name": "Malgorzata",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203478": {
    "id": "item_2506",
    "Last Name": "Day",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203481": {
    "id": "item_27938",
    "Last Name": "Lui",
    "First Name": "Wai Man",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203491": {
    "id": "item_1376",
    "Last Name": "cambou",
    "First Name": "thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203526": {
    "id": "item_26492",
    "Last Name": "West",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203529": {
    "id": "item_2505",
    "Last Name": "Ball",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203546": {
    "id": "item_16796",
    "Last Name": "Beresford",
    "First Name": "Anne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203547": {
    "id": "item_2503",
    "Last Name": "Collins",
    "First Name": "Damian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203579": {
    "id": "item_16792",
    "Last Name": "Crouch",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203586": {
    "id": "item_27932",
    "Last Name": "Edelman",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203607": {
    "id": "item_563",
    "Last Name": "DING",
    "First Name": "HUA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203609": {
    "id": "item_15930",
    "Last Name": "Morphett",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203619": {
    "id": "item_4785",
    "Last Name": "Stavnitskiy",
    "First Name": "Irina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203631": {
    "id": "item_4787",
    "Last Name": "Moorcroft",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203644": {
    "id": "item_2501",
    "Last Name": "Hong",
    "First Name": "Jie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203648": {
    "id": "item_562",
    "Last Name": "castro pardo",
    "First Name": "david",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203651": {
    "id": "item_4784",
    "Last Name": "Heyward",
    "First Name": "Sofia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203664": {
    "id": "item_564",
    "Last Name": "Farquhar",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203667": {
    "id": "item_559",
    "Last Name": "Baranova",
    "First Name": "Nataliia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203675": {
    "id": "item_556",
    "Last Name": "Phillips",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203689": {
    "id": "item_2500",
    "Last Name": "Lopez",
    "First Name": "Andres",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203697": {
    "id": "item_4781",
    "Last Name": "Cheng",
    "First Name": "Jareth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203706": {
    "id": "item_29879",
    "Last Name": "Ploshkina",
    "First Name": "Anastasiia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203713": {
    "id": "item_4780",
    "Last Name": "Sacca",
    "First Name": "Domenic",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203715": {
    "id": "item_29877",
    "Last Name": "tam",
    "First Name": "winnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203746": {
    "id": "item_16781",
    "Last Name": "Doust",
    "First Name": "Damian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203754": {
    "id": "item_2498",
    "Last Name": "Browne",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203762": {
    "id": "item_2496",
    "Last Name": "Tseng",
    "First Name": "Hsiang-Ting",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203779": {
    "id": "item_27925",
    "Last Name": "Vaughan",
    "First Name": "Kerri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203781": {
    "id": "item_4774",
    "Last Name": "Costea",
    "First Name": "Dragos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203816": {
    "id": "item_4773",
    "Last Name": "Zaki",
    "First Name": "Khai Fahmi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203823": {
    "id": "item_16773",
    "Last Name": "Madders",
    "First Name": "Kelsie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203825": {
    "id": "item_16772",
    "Last Name": "van Baalen",
    "First Name": "Emilie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203834": {
    "id": "item_4776",
    "Last Name": "Bandiera",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203854": {
    "id": "item_2492",
    "Last Name": "Youngson",
    "First Name": "Rochelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203893": {
    "id": "item_27922",
    "Last Name": "Sahapat",
    "First Name": "Thammanoon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203896": {
    "id": "item_551",
    "Last Name": "Leung",
    "First Name": "Kar Wing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203898": {
    "id": "item_2491",
    "Last Name": "Mills",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203907": {
    "id": "item_2490",
    "Last Name": "Korenc",
    "First Name": "Ajda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203931": {
    "id": "item_2488",
    "Last Name": "van Rhoon",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203948": {
    "id": "item_16765",
    "Last Name": "Campbell",
    "First Name": "Beck",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203955": {
    "id": "item_16766",
    "Last Name": "Day",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203987": {
    "id": "item_15922",
    "Last Name": "Krantz",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203989": {
    "id": "item_4768",
    "Last Name": "Young",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203992": {
    "id": "item_16763",
    "Last Name": "Moriska",
    "First Name": "Moriska",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204014": {
    "id": "item_16760",
    "Last Name": "Bowen",
    "First Name": "Kelleigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204021": {
    "id": "item_2487",
    "Last Name": "Orchard",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204027": {
    "id": "item_4766",
    "Last Name": "Lu",
    "First Name": "Phung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204033": {
    "id": "item_16761",
    "Last Name": "Pietrobon",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204059": {
    "id": "item_29866",
    "Last Name": "Harrison",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204100": {
    "id": "item_546",
    "Last Name": "Meyer",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204102": {
    "id": "item_4763",
    "Last Name": "Hatchman",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204127": {
    "id": "item_16749",
    "Last Name": "Connolly",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204138": {
    "id": "item_16753",
    "Last Name": "Hallikas",
    "First Name": "Juha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204150": {
    "id": "item_16750",
    "Last Name": "park",
    "First Name": "Jeongeun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204151": {
    "id": "item_1419",
    "Last Name": "Rosas",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204181": {
    "id": "item_4757",
    "Last Name": "Rehmann",
    "First Name": "Lesley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204187": {
    "id": "item_15920",
    "Last Name": "Zammit",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204188": {
    "id": "item_544",
    "Last Name": "Rutherford",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204219": {
    "id": "item_4754",
    "Last Name": "Burgess",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204235": {
    "id": "item_13052",
    "Last Name": "Murphy",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204237": {
    "id": "item_542",
    "Last Name": "Khramchenkov",
    "First Name": "Andrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204244": {
    "id": "item_541",
    "Last Name": "Bode",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204248": {
    "id": "item_4752",
    "Last Name": "MORAS",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204257": {
    "id": "item_4751",
    "Last Name": "Malazarte",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204258": {
    "id": "item_27915",
    "Last Name": "Brown",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204277": {
    "id": "item_4750",
    "Last Name": "Gunton",
    "First Name": "Kade",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204290": {
    "id": "item_4749",
    "Last Name": "Moore",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204323": {
    "id": "item_1293",
    "Last Name": "Kitney",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204330": {
    "id": "item_1418",
    "Last Name": "Zdinak",
    "First Name": "Juraj",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204337": {
    "id": "item_26183",
    "Last Name": "Buaboocha",
    "First Name": "Ratakorn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204357": {
    "id": "item_3138",
    "Last Name": "Hart",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204443": {
    "id": "item_26182",
    "Last Name": "Caldwell",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204449": {
    "id": "item_30882",
    "Last Name": "Hackett",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204453": {
    "id": "item_28705",
    "Last Name": "ADIB",
    "First Name": "AHMAD",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204466": {
    "id": "item_13842",
    "Last Name": "Masters",
    "First Name": "Paris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204480": {
    "id": "item_30881",
    "Last Name": "Mcpherson",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204527": {
    "id": "item_16250",
    "Last Name": "TOTANI",
    "First Name": "OLIVIA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204579": {
    "id": "item_3135",
    "Last Name": "Bodikhuu",
    "First Name": "Uilszaya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204590": {
    "id": "item_3134",
    "Last Name": "Ilott",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204612": {
    "id": "item_26177",
    "Last Name": "Eames",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204617": {
    "id": "item_16252",
    "Last Name": "Kindler",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204620": {
    "id": "item_26176",
    "Last Name": "Miller",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204627": {
    "id": "item_26175",
    "Last Name": "Hollick",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204655": {
    "id": "item_28704",
    "Last Name": "Passey",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204666": {
    "id": "item_26171",
    "Last Name": "Shah",
    "First Name": "Nihar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204697": {
    "id": "item_30877",
    "Last Name": "Casey",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204701": {
    "id": "item_28703",
    "Last Name": "Stiel",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204727": {
    "id": "item_1291",
    "Last Name": "Hazell",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204741": {
    "id": "item_13833",
    "Last Name": "Popovski",
    "First Name": "Filip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204766": {
    "id": "item_14036",
    "Last Name": "Macdonald",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204777": {
    "id": "item_13830",
    "Last Name": "Spazzoli",
    "First Name": "Lihor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204793": {
    "id": "item_28699",
    "Last Name": "Kerr",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204827": {
    "id": "item_1288",
    "Last Name": "Middleton",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204830": {
    "id": "item_13831",
    "Last Name": "Aghazu",
    "First Name": "Akuchukwu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204852": {
    "id": "item_30875",
    "Last Name": "Dudziak Guimaraes",
    "First Name": "Priscila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204856": {
    "id": "item_13828",
    "Last Name": "Maartensz",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204861": {
    "id": "item_30874",
    "Last Name": "Lo",
    "First Name": "Jude",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204868": {
    "id": "item_3132",
    "Last Name": "Hughes",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204905": {
    "id": "item_26163",
    "Last Name": "Jovanovic",
    "First Name": "Milan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204925": {
    "id": "item_26162",
    "Last Name": "Pugsley",
    "First Name": "Teaghan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204926": {
    "id": "item_3131",
    "Last Name": "Drake",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204938": {
    "id": "item_13822",
    "Last Name": "Hume",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204943": {
    "id": "item_30873",
    "Last Name": "Ye",
    "First Name": "Laetitia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204954": {
    "id": "item_3130",
    "Last Name": "Jack",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204969": {
    "id": "item_3129",
    "Last Name": "O'Kane",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204990": {
    "id": "item_1285",
    "Last Name": "ZENG",
    "First Name": "JIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204998": {
    "id": "item_13821",
    "Last Name": "Zubair",
    "First Name": "Ahmad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205027": {
    "id": "item_30870",
    "Last Name": "Abdul Rachman",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205031": {
    "id": "item_28690",
    "Last Name": "HATEGAN",
    "First Name": "MARIUS",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205038": {
    "id": "item_3121",
    "Last Name": "Popov",
    "First Name": "Evgeny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205056": {
    "id": "item_1286",
    "Last Name": "King",
    "First Name": "Rhianna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205069": {
    "id": "item_30867",
    "Last Name": "Agustinus",
    "First Name": "Daud",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205073": {
    "id": "item_26157",
    "Last Name": "Carmody",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205076": {
    "id": "item_3127",
    "Last Name": "Olmi",
    "First Name": "Maurizio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205081": {
    "id": "item_26408",
    "Last Name": "LundbŠck",
    "First Name": "Joakim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205120": {
    "id": "item_26156",
    "Last Name": "Sherwood",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205129": {
    "id": "item_3126",
    "Last Name": "Howes",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205164": {
    "id": "item_26152",
    "Last Name": "Burns",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205172": {
    "id": "item_28688",
    "Last Name": "Shum",
    "First Name": "Chun Kwok Edward",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205188": {
    "id": "item_26153",
    "Last Name": "Cotter",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205227": {
    "id": "item_28687",
    "Last Name": "Caruso",
    "First Name": "Marisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205233": {
    "id": "item_3122",
    "Last Name": "Dolmans",
    "First Name": "Bard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205240": {
    "id": "item_30861",
    "Last Name": "Alzamora Goncalves",
    "First Name": "Carla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205269": {
    "id": "item_3120",
    "Last Name": "Hidrus",
    "First Name": "Aizuddin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205279": {
    "id": "item_26148",
    "Last Name": "Thomas",
    "First Name": "Immy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205296": {
    "id": "item_1281",
    "Last Name": "Tierney",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205297": {
    "id": "item_1283",
    "Last Name": "Matuszek",
    "First Name": "Marek",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205317": {
    "id": "item_30858",
    "Last Name": "Zivkovic",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205326": {
    "id": "item_26145",
    "Last Name": "Bateman",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205344": {
    "id": "item_26143",
    "Last Name": "Cepetelli",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205347": {
    "id": "item_30856",
    "Last Name": "Haldane",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205378": {
    "id": "item_26138",
    "Last Name": "O'Leary",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205387": {
    "id": "item_30855",
    "Last Name": "tian",
    "First Name": "zheng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205408": {
    "id": "item_26136",
    "Last Name": "Teo",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205410": {
    "id": "item_3119",
    "Last Name": "ENGELS",
    "First Name": "STEVE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205416": {
    "id": "item_16244",
    "Last Name": "Oliva",
    "First Name": "Emir",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205449": {
    "id": "item_13807",
    "Last Name": "Allen",
    "First Name": "Lachie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205454": {
    "id": "item_16245",
    "Last Name": "Peggie",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205459": {
    "id": "item_28681",
    "Last Name": "Carruthers",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205478": {
    "id": "item_30852",
    "Last Name": "Khan",
    "First Name": "Imran",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205480": {
    "id": "item_1278",
    "Last Name": "Mexia",
    "First Name": "Jo‹o",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205502": {
    "id": "item_3117",
    "Last Name": "Taylor",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205519": {
    "id": "item_26130",
    "Last Name": "Hwang",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205547": {
    "id": "item_26129",
    "Last Name": "Baxter",
    "First Name": "Elyce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205554": {
    "id": "item_26128",
    "Last Name": "P‡ramo",
    "First Name": "Gissela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205600": {
    "id": "item_1277",
    "Last Name": "Mock",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205623": {
    "id": "item_13800",
    "Last Name": "Stubbs",
    "First Name": "Jemma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205624": {
    "id": "item_30846",
    "Last Name": "TANIGAWA",
    "First Name": "SEIJI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205626": {
    "id": "item_30847",
    "Last Name": "Shipman",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205628": {
    "id": "item_30848",
    "Last Name": "Pascoe",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205637": {
    "id": "item_16240",
    "Last Name": "Hermawan",
    "First Name": "Achmad Dzulfikar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205638": {
    "id": "item_13801",
    "Last Name": "Chow",
    "First Name": "Wai Ming",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205644": {
    "id": "item_13799",
    "Last Name": "Siva",
    "First Name": "Anand",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205648": {
    "id": "item_16241",
    "Last Name": "Kirk",
    "First Name": "Julie Yung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205649": {
    "id": "item_13797",
    "Last Name": "Judai Junior",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205664": {
    "id": "item_13796",
    "Last Name": "Luo",
    "First Name": "Sichen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205719": {
    "id": "item_16309",
    "Last Name": "Jang",
    "First Name": "Jong Hyun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205779": {
    "id": "item_3113",
    "Last Name": "Tang",
    "First Name": "GuLei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205790": {
    "id": "item_30843",
    "Last Name": "Moir",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205802": {
    "id": "item_26115",
    "Last Name": "Rechten",
    "First Name": "Nikolai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205806": {
    "id": "item_3114",
    "Last Name": "Sharpe",
    "First Name": "Stirling",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205812": {
    "id": "item_1272",
    "Last Name": "Lang",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205838": {
    "id": "item_13793",
    "Last Name": "Lowry",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205882": {
    "id": "item_26112",
    "Last Name": "Wong",
    "First Name": "Karen Hor Yan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205901": {
    "id": "item_28672",
    "Last Name": "Caroni",
    "First Name": "Matias",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205915": {
    "id": "item_1266",
    "Last Name": "HU",
    "First Name": "QINGFU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205936": {
    "id": "item_1265",
    "Last Name": "McKeown",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205973": {
    "id": "item_26491",
    "Last Name": "Cochrane",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205994": {
    "id": "item_26109",
    "Last Name": "Carter",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205995": {
    "id": "item_1264",
    "Last Name": "Van De Voorde",
    "First Name": "Stijn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206012": {
    "id": "item_13790",
    "Last Name": "Hux",
    "First Name": "Sal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206016": {
    "id": "item_13791",
    "Last Name": "Watson",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206053": {
    "id": "item_13788",
    "Last Name": "Bullen",
    "First Name": "Scarlet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206107": {
    "id": "item_13787",
    "Last Name": "Ramsey",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206133": {
    "id": "item_26107",
    "Last Name": "kuang",
    "First Name": "katherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206141": {
    "id": "item_26105",
    "Last Name": "M DAVIS",
    "First Name": "PAUL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206187": {
    "id": "item_3110",
    "Last Name": "FORMIGA",
    "First Name": "IRIS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206221": {
    "id": "item_30834",
    "Last Name": "Gifford",
    "First Name": "Digby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206243": {
    "id": "item_30836",
    "Last Name": "Hung",
    "First Name": "Sze Man Gloria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206246": {
    "id": "item_26490",
    "Last Name": "Gimena",
    "First Name": "Antonio Jr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206280": {
    "id": "item_30832",
    "Last Name": "Igot",
    "First Name": "Jess Christiane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206293": {
    "id": "item_3109",
    "Last Name": "Nguy_n Ph__c",
    "First Name": "T_nh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206306": {
    "id": "item_13784",
    "Last Name": "Lee",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206314": {
    "id": "item_13783",
    "Last Name": "whittle",
    "First Name": "helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206315": {
    "id": "item_30833",
    "Last Name": "Hussain",
    "First Name": "Jamal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206324": {
    "id": "item_1258",
    "Last Name": "HU",
    "First Name": "YUXUAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206340": {
    "id": "item_26100",
    "Last Name": "Wong",
    "First Name": "Lai Kwan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206390": {
    "id": "item_13781",
    "Last Name": "Donald",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206396": {
    "id": "item_3108",
    "Last Name": "SHAH",
    "First Name": "NIKHIL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206399": {
    "id": "item_13780",
    "Last Name": "Walsh",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206411": {
    "id": "item_30829",
    "Last Name": "Tse",
    "First Name": "King To Myles",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206436": {
    "id": "item_26095",
    "Last Name": "Nguyen",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206441": {
    "id": "item_1256",
    "Last Name": "Chen",
    "First Name": "Bernie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206447": {
    "id": "item_28668",
    "Last Name": "Nagrani",
    "First Name": "Rakhi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206462": {
    "id": "item_28669",
    "Last Name": "Oguma",
    "First Name": "Akiko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206466": {
    "id": "item_13779",
    "Last Name": "Lane",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206479": {
    "id": "item_28667",
    "Last Name": "Powell Jr",
    "First Name": "Arthur L",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206483": {
    "id": "item_30828",
    "Last Name": "Travis",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206497": {
    "id": "item_26090",
    "Last Name": "Sheehan",
    "First Name": "Deirdre",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206507": {
    "id": "item_26091",
    "Last Name": "Johnson",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206514": {
    "id": "item_16236",
    "Last Name": "Bryant",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206521": {
    "id": "item_1253",
    "Last Name": "Ellwood",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206564": {
    "id": "item_3258",
    "Last Name": "LIU",
    "First Name": "SHIH MING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206566": {
    "id": "item_26089",
    "Last Name": "De Re",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206569": {
    "id": "item_3106",
    "Last Name": "Pierret",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206617": {
    "id": "item_3104",
    "Last Name": "Wilson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206619": {
    "id": "item_28664",
    "Last Name": "Hiron",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206694": {
    "id": "item_26086",
    "Last Name": "Laurenaria",
    "First Name": "Laisa Sedrei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206704": {
    "id": "item_13774",
    "Last Name": "Griffith",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206712": {
    "id": "item_26085",
    "Last Name": "LEUNG",
    "First Name": "KAM SHING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206717": {
    "id": "item_30825",
    "Last Name": "Parchariyanon",
    "First Name": "Sumana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206729": {
    "id": "item_30824",
    "Last Name": "Devitt",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206731": {
    "id": "item_3100",
    "Last Name": "Brennan",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206735": {
    "id": "item_28663",
    "Last Name": "Inglis",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206749": {
    "id": "item_13772",
    "Last Name": "Irfan",
    "First Name": "Isthi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206769": {
    "id": "item_26082",
    "Last Name": "Nelson",
    "First Name": "Adelaide",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206775": {
    "id": "item_26080",
    "Last Name": "Chan",
    "First Name": "Jessie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206789": {
    "id": "item_26079",
    "Last Name": "Reese",
    "First Name": "Orla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206798": {
    "id": "item_26077",
    "Last Name": "Balolong",
    "First Name": "John Elvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206812": {
    "id": "item_26075",
    "Last Name": "Hung",
    "First Name": "Fan Fong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206839": {
    "id": "item_30823",
    "Last Name": "LEE",
    "First Name": "WING YIU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206847": {
    "id": "item_26074",
    "Last Name": "Azzam",
    "First Name": "Fathony Firmansyah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206880": {
    "id": "item_13768",
    "Last Name": "Cheung",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206889": {
    "id": "item_26072",
    "Last Name": "Worley",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206894": {
    "id": "item_30822",
    "Last Name": "Muchtar",
    "First Name": "Kartika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206897": {
    "id": "item_13978",
    "Last Name": "Qian",
    "First Name": "Min",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206957": {
    "id": "item_26069",
    "Last Name": "Bosshard",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207015": {
    "id": "item_28659",
    "Last Name": "Tey",
    "First Name": "Hui San",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207103": {
    "id": "item_3095",
    "Last Name": "Nguyen",
    "First Name": "Viet Ha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207110": {
    "id": "item_30819",
    "Last Name": "Tan",
    "First Name": "Li Ying",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207113": {
    "id": "item_1237",
    "Last Name": "Bouhali",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207129": {
    "id": "item_30818",
    "Last Name": "Fisher",
    "First Name": "Colleen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207157": {
    "id": "item_28657",
    "Last Name": "Bohmer",
    "First Name": "Jill",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207175": {
    "id": "item_26066",
    "Last Name": "Lim",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207185": {
    "id": "item_28656",
    "Last Name": "Srivastava",
    "First Name": "Abhishek",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207209": {
    "id": "item_30814",
    "Last Name": "HU",
    "First Name": "TINGTING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207228": {
    "id": "item_26058",
    "Last Name": "CHEN",
    "First Name": "JIANJIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207232": {
    "id": "item_30815",
    "Last Name": "Van Keuren Parent",
    "First Name": "Korinne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207244": {
    "id": "item_28654",
    "Last Name": "Perpepaj",
    "First Name": "Alexandria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207261": {
    "id": "item_30813",
    "Last Name": "Stanton",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207279": {
    "id": "item_28653",
    "Last Name": "Bailey",
    "First Name": "Alaine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207306": {
    "id": "item_28651",
    "Last Name": "Wu",
    "First Name": "Colin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207308": {
    "id": "item_3092",
    "Last Name": "Squire",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207336": {
    "id": "item_30812",
    "Last Name": "Khowsurat",
    "First Name": "Sureeyot",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207355": {
    "id": "item_26488",
    "Last Name": "Plete",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207381": {
    "id": "item_30810",
    "Last Name": "To",
    "First Name": "Chun ming",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207384": {
    "id": "item_26489",
    "Last Name": "Brown",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207439": {
    "id": "item_3090",
    "Last Name": "Chu",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207513": {
    "id": "item_26056",
    "Last Name": "Charlton",
    "First Name": "Tara Lee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207541": {
    "id": "item_30808",
    "Last Name": "Giovanno",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207617": {
    "id": "item_13755",
    "Last Name": "Evans",
    "First Name": "Ria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207627": {
    "id": "item_13757",
    "Last Name": "Becarevic",
    "First Name": "Denijel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207630": {
    "id": "item_13754",
    "Last Name": "Wang",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207649": {
    "id": "item_30806",
    "Last Name": "Vizcarrondo",
    "First Name": "Jackly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207660": {
    "id": "item_30804",
    "Last Name": "Kirana",
    "First Name": "Dezi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207661": {
    "id": "item_16728",
    "Last Name": "Nugroho",
    "First Name": "Igo setyo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207676": {
    "id": "item_3088",
    "Last Name": "Goldfinger",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207700": {
    "id": "item_28649",
    "Last Name": "Turnau",
    "First Name": "Katarzyna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207716": {
    "id": "item_26049",
    "Last Name": "Evans",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207717": {
    "id": "item_3087",
    "Last Name": "Li",
    "First Name": "Hongzhe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207728": {
    "id": "item_26048",
    "Last Name": "Ellis",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207822": {
    "id": "item_28647",
    "Last Name": "Height",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207855": {
    "id": "item_30801",
    "Last Name": "Kuesal",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207894": {
    "id": "item_26046",
    "Last Name": "Golding-Barrett",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207910": {
    "id": "item_16229",
    "Last Name": "McCrory",
    "First Name": "Mackenzie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207967": {
    "id": "item_26045",
    "Last Name": "Jiang",
    "First Name": "Feng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208036": {
    "id": "item_16228",
    "Last Name": "Boulton",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208129": {
    "id": "item_13747",
    "Last Name": "TOMOMATSU",
    "First Name": "MIKU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208136": {
    "id": "item_26043",
    "Last Name": "Cornwell",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208180": {
    "id": "item_14035",
    "Last Name": "choa",
    "First Name": "pong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208197": {
    "id": "item_3085",
    "Last Name": "Austen",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208207": {
    "id": "item_14034",
    "Last Name": "Tiller",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208242": {
    "id": "item_26041",
    "Last Name": "Kwan",
    "First Name": "Kah Yip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208249": {
    "id": "item_3084",
    "Last Name": "Jeevanjee",
    "First Name": "Aarif",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208298": {
    "id": "item_26039",
    "Last Name": "Lien",
    "First Name": "Cheng Chieh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208328": {
    "id": "item_13745",
    "Last Name": "Castelhano Marques",
    "First Name": "Clayton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208332": {
    "id": "item_30795",
    "Last Name": "Tympanick",
    "First Name": "Theodore",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208346": {
    "id": "item_30794",
    "Last Name": "Dover",
    "First Name": "Twila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208387": {
    "id": "item_13743",
    "Last Name": "Lin",
    "First Name": "Yucheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208425": {
    "id": "item_3083",
    "Last Name": "Zaisanbayev",
    "First Name": "Ilyas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208492": {
    "id": "item_28638",
    "Last Name": "Vela",
    "First Name": "Maria De Jesus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208524": {
    "id": "item_28637",
    "Last Name": "Cabreira Bauer",
    "First Name": "Erika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208537": {
    "id": "item_3082",
    "Last Name": "Casares",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208621": {
    "id": "item_31068",
    "Last Name": "Yoon",
    "First Name": "Jiyeong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208811": {
    "id": "item_16308",
    "Last Name": "Lee",
    "First Name": "Kai Loong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208836": {
    "id": "item_1220",
    "Last Name": "Mu–oz",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208852": {
    "id": "item_26030",
    "Last Name": "Kwansiripat",
    "First Name": "Nathdanai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208873": {
    "id": "item_26031",
    "Last Name": "Briley",
    "First Name": "Addy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208921": {
    "id": "item_1219",
    "Last Name": "Evans",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208955": {
    "id": "item_16227",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208990": {
    "id": "item_13738",
    "Last Name": "Whitehead",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209000": {
    "id": "item_13735",
    "Last Name": "Yeagley",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209023": {
    "id": "item_3257",
    "Last Name": "Knittl",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209049": {
    "id": "item_13736",
    "Last Name": "Chang",
    "First Name": "Yir Lirng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209075": {
    "id": "item_13734",
    "Last Name": "SOCORRO PERDOMO",
    "First Name": "MIGUEL ANGEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209092": {
    "id": "item_28634",
    "Last Name": "Traxler",
    "First Name": "Becca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209101": {
    "id": "item_13731",
    "Last Name": "Spivak",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209119": {
    "id": "item_16226",
    "Last Name": "Wong",
    "First Name": "Francis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209154": {
    "id": "item_3256",
    "Last Name": "Columna",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209168": {
    "id": "item_26024",
    "Last Name": "Weller",
    "First Name": "Kara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209187": {
    "id": "item_26023",
    "Last Name": "Celimen",
    "First Name": "Joyce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209257": {
    "id": "item_13729",
    "Last Name": "Losapio",
    "First Name": "Stefano",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209260": {
    "id": "item_26022",
    "Last Name": "Gondwe",
    "First Name": "Felix",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209293": {
    "id": "item_26019",
    "Last Name": "ZHANG",
    "First Name": "FAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209305": {
    "id": "item_30782",
    "Last Name": "Newman",
    "First Name": "Yvonne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209318": {
    "id": "item_1214",
    "Last Name": "Navarro",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209343": {
    "id": "item_30781",
    "Last Name": "Inan�",
    "First Name": "Jana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209374": {
    "id": "item_3074",
    "Last Name": "Husen",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209426": {
    "id": "item_28629",
    "Last Name": "Revecho",
    "First Name": "Reynaldo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209450": {
    "id": "item_3075",
    "Last Name": "Matthews",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209467": {
    "id": "item_1211",
    "Last Name": "Beiram",
    "First Name": "Caio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209483": {
    "id": "item_3073",
    "Last Name": "Tartaglia",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209501": {
    "id": "item_26017",
    "Last Name": "Rengifo Varila",
    "First Name": "Zully Viviana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209530": {
    "id": "item_26016",
    "Last Name": "Jenkins",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209585": {
    "id": "item_26014",
    "Last Name": "Marcjasz",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209588": {
    "id": "item_3072",
    "Last Name": "Wray-Yeargin",
    "First Name": "Debra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209592": {
    "id": "item_1209",
    "Last Name": "Timimoun",
    "First Name": "Naime",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209648": {
    "id": "item_26012",
    "Last Name": "Ariwibowo",
    "First Name": "Adrianto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209668": {
    "id": "item_26011",
    "Last Name": "O'Brien",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209704": {
    "id": "item_3071",
    "Last Name": "Mairena",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209776": {
    "id": "item_26009",
    "Last Name": "McDonald",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209789": {
    "id": "item_13716",
    "Last Name": "Luo",
    "First Name": "Yuan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209798": {
    "id": "item_13722",
    "Last Name": "Kian Huat",
    "First Name": "Lim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209802": {
    "id": "item_28870",
    "Last Name": "Ojolakin",
    "First Name": "Bukola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209834": {
    "id": "item_13723",
    "Last Name": "Latif",
    "First Name": "Khaled",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209916": {
    "id": "item_3068",
    "Last Name": "Kuan-Yu",
    "First Name": "Pan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209948": {
    "id": "item_13720",
    "Last Name": "Gradison",
    "First Name": "Maile",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209968": {
    "id": "item_3067",
    "Last Name": "Wong",
    "First Name": "Su Tak",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209972": {
    "id": "item_26008",
    "Last Name": "Shen",
    "First Name": "Li",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210005": {
    "id": "item_28619",
    "Last Name": "PANG",
    "First Name": "RONNIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210039": {
    "id": "item_28621",
    "Last Name": "Chiu",
    "First Name": "chenling",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210048": {
    "id": "item_16222",
    "Last Name": "Tran",
    "First Name": "Duc Thao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210134": {
    "id": "item_13717",
    "Last Name": "Vona",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210156": {
    "id": "item_1206",
    "Last Name": "Lackner",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210163": {
    "id": "item_26005",
    "Last Name": "Adhiyat",
    "First Name": "Fajar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210214": {
    "id": "item_1205",
    "Last Name": "Timmerman",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210238": {
    "id": "item_30770",
    "Last Name": "Hennessy",
    "First Name": "Mary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210265": {
    "id": "item_30767",
    "Last Name": "Wang",
    "First Name": "Hui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210269": {
    "id": "item_13712",
    "Last Name": "Pak",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210359": {
    "id": "item_30768",
    "Last Name": "Barrera",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210394": {
    "id": "item_26487",
    "Last Name": "Nardin",
    "First Name": "Lia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210442": {
    "id": "item_1203",
    "Last Name": "MAEKAWA",
    "First Name": "TAKAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210472": {
    "id": "item_30766",
    "Last Name": "Kent",
    "First Name": "Judith",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210537": {
    "id": "item_26001",
    "Last Name": "Chung",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210607": {
    "id": "item_28615",
    "Last Name": "Hawthorne",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210666": {
    "id": "item_26000",
    "Last Name": "Gaughran",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210801": {
    "id": "item_25997",
    "Last Name": "Leung",
    "First Name": "Ho Wang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210815": {
    "id": "item_28613",
    "Last Name": "Managbanag",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210816": {
    "id": "item_25992",
    "Last Name": "Siriwattanakate",
    "First Name": "Budsakorn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210865": {
    "id": "item_25994",
    "Last Name": "Patton",
    "First Name": "Camille",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210898": {
    "id": "item_3219",
    "Last Name": "Bernard",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210953": {
    "id": "item_16221",
    "Last Name": "Hankla",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211053": {
    "id": "item_28611",
    "Last Name": "Nkhoma",
    "First Name": "Ella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211055": {
    "id": "item_3062",
    "Last Name": "Sabacinski",
    "First Name": "Jakub",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211063": {
    "id": "item_28610",
    "Last Name": "Leija",
    "First Name": "Blanca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211143": {
    "id": "item_25990",
    "Last Name": "Sarubbi",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211179": {
    "id": "item_3061",
    "Last Name": "Lo",
    "First Name": "Yenliang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211200": {
    "id": "item_16220",
    "Last Name": "Chen",
    "First Name": "Yu Ying",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211295": {
    "id": "item_1198",
    "Last Name": "Einsidler",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211299": {
    "id": "item_28609",
    "Last Name": "Gascon",
    "First Name": "Sunny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211346": {
    "id": "item_13709",
    "Last Name": "Carrera SR",
    "First Name": "Joan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211361": {
    "id": "item_25986",
    "Last Name": "Lorentz",
    "First Name": "Angie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211460": {
    "id": "item_30758",
    "Last Name": "Yusri",
    "First Name": "Elina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211486": {
    "id": "item_28828",
    "Last Name": "Hao",
    "First Name": "Martha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211527": {
    "id": "item_28608",
    "Last Name": "Taha",
    "First Name": "Riyan Dhama",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211576": {
    "id": "item_16219",
    "Last Name": "LEELASHAW",
    "First Name": "APINAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211585": {
    "id": "item_28869",
    "Last Name": "Shah",
    "First Name": "Manan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211676": {
    "id": "item_25980",
    "Last Name": "Ng",
    "First Name": "Lok Yee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211695": {
    "id": "item_25979",
    "Last Name": "GAMAS",
    "First Name": "JOCEL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211735": {
    "id": "item_25978",
    "Last Name": "Doyle",
    "First Name": "LeaAnne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211787": {
    "id": "item_28606",
    "Last Name": "Puening",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211804": {
    "id": "item_25976",
    "Last Name": "HSU",
    "First Name": "CHENGKUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211865": {
    "id": "item_1195",
    "Last Name": "Remeika",
    "First Name": "Darius",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211925": {
    "id": "item_1193",
    "Last Name": "Khoo",
    "First Name": "Koon Kok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211958": {
    "id": "item_1194",
    "Last Name": "Derkach",
    "First Name": "Oleksiy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211970": {
    "id": "item_25970",
    "Last Name": "Abdul Rohman",
    "First Name": "Fuji",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211994": {
    "id": "item_3255",
    "Last Name": "Kurahashi",
    "First Name": "Masahiko",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212065": {
    "id": "item_25973",
    "Last Name": "Amador",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212115": {
    "id": "item_26486",
    "Last Name": "Cortes",
    "First Name": "Luis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212214": {
    "id": "item_28602",
    "Last Name": "Crabb",
    "First Name": "Sydnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212272": {
    "id": "item_13700",
    "Last Name": "Cunich",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212282": {
    "id": "item_1191",
    "Last Name": "Markwell",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212340": {
    "id": "item_25968",
    "Last Name": "O'Brien",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212376": {
    "id": "item_28868",
    "Last Name": "Tsoi",
    "First Name": "Kam Lung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212492": {
    "id": "item_14033",
    "Last Name": "Alburquerque Prieto",
    "First Name": "Doris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212535": {
    "id": "item_13698",
    "Last Name": "Tan",
    "First Name": "Vi Shuen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212570": {
    "id": "item_1189",
    "Last Name": "TREVINO",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212571": {
    "id": "item_3053",
    "Last Name": "Pelligreen",
    "First Name": "Lee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212579": {
    "id": "item_13697",
    "Last Name": "LEI",
    "First Name": "YANG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212695": {
    "id": "item_3052",
    "Last Name": "LAM",
    "First Name": "KAM HIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212800": {
    "id": "item_1375",
    "Last Name": "Howard",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212801": {
    "id": "item_3218",
    "Last Name": "Varela Fallas",
    "First Name": "Juan Carlos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212844": {
    "id": "item_30752",
    "Last Name": "Aidoo",
    "First Name": "Rita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212924": {
    "id": "item_25966",
    "Last Name": "Statman",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212991": {
    "id": "item_30748",
    "Last Name": "Wida",
    "First Name": "Anak agung istri agung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213030": {
    "id": "item_3050",
    "Last Name": "Ferrando",
    "First Name": "Lorenzo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213124": {
    "id": "item_16216",
    "Last Name": "Vargas",
    "First Name": "Agust’n",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213198": {
    "id": "item_13693",
    "Last Name": "Gauci",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213241": {
    "id": "item_16215",
    "Last Name": "De Silva",
    "First Name": "Terence",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213244": {
    "id": "item_3049",
    "Last Name": "Melgarejo",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213294": {
    "id": "item_3048",
    "Last Name": "HUANG",
    "First Name": "BIYU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213300": {
    "id": "item_18555",
    "Last Name": "Akkarawatcharasathien",
    "First Name": "Chetchai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213358": {
    "id": "item_16214",
    "Last Name": "Lau",
    "First Name": "Wai Kwong Johnny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213368": {
    "id": "item_25960",
    "Last Name": "Benns",
    "First Name": "Jill",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213574": {
    "id": "item_18551",
    "Last Name": "Vanstalle",
    "First Name": "Laetitia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213589": {
    "id": "item_28598",
    "Last Name": "Chan",
    "First Name": "Norman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213600": {
    "id": "item_1186",
    "Last Name": "Arhonidis",
    "First Name": "Aris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213637": {
    "id": "item_28597",
    "Last Name": "Dammous",
    "First Name": "Joe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213644": {
    "id": "item_16213",
    "Last Name": "Jones",
    "First Name": "Clint",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213724": {
    "id": "item_28596",
    "Last Name": "Stocks",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213744": {
    "id": "item_1185",
    "Last Name": "Van Maele",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213801": {
    "id": "item_18550",
    "Last Name": "Sylvester",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213854": {
    "id": "item_1183",
    "Last Name": "Day",
    "First Name": "Katie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213910": {
    "id": "item_1181",
    "Last Name": "Nufer",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213937": {
    "id": "item_25955",
    "Last Name": "Yun ming",
    "First Name": "Chiu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213951": {
    "id": "item_3045",
    "Last Name": "Day",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213985": {
    "id": "item_1182",
    "Last Name": "Anderson",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213987": {
    "id": "item_25957",
    "Last Name": "Carandang Nocon",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214038": {
    "id": "item_28595",
    "Last Name": "Vialon",
    "First Name": "Jaysen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214044": {
    "id": "item_30744",
    "Last Name": "Devakul Na Ayutthaya",
    "First Name": "Thipsiri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214139": {
    "id": "item_25952",
    "Last Name": "Hartlage",
    "First Name": "Bristol",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214150": {
    "id": "item_13687",
    "Last Name": "Garvey",
    "First Name": "Crystal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214152": {
    "id": "item_3044",
    "Last Name": "Parthasarathy",
    "First Name": "Varun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214213": {
    "id": "item_25950",
    "Last Name": "Duong",
    "First Name": "Marcia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214214": {
    "id": "item_18547",
    "Last Name": "Malaret",
    "First Name": "Hendryx",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214231": {
    "id": "item_30740",
    "Last Name": "LIN",
    "First Name": "LI TING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214262": {
    "id": "item_3041",
    "Last Name": "Deng",
    "First Name": "Xiaokun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214356": {
    "id": "item_28591",
    "Last Name": "Sullivan",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214371": {
    "id": "item_1179",
    "Last Name": "Price",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214385": {
    "id": "item_25947",
    "Last Name": "Stone",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214398": {
    "id": "item_18541",
    "Last Name": "McMillan",
    "First Name": "TIffany",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214429": {
    "id": "item_25946",
    "Last Name": "Yuan",
    "First Name": "Billy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214466": {
    "id": "item_30738",
    "Last Name": "Calvert",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214475": {
    "id": "item_1177",
    "Last Name": "FLORES",
    "First Name": "DAMIAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214482": {
    "id": "item_18539",
    "Last Name": "Chendrawan",
    "First Name": "Russel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214584": {
    "id": "item_1174",
    "Last Name": "Pinel",
    "First Name": "Enrique",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214600": {
    "id": "item_18536",
    "Last Name": "Newnham",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214644": {
    "id": "item_28590",
    "Last Name": "Murphy",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214729": {
    "id": "item_13681",
    "Last Name": "Wu",
    "First Name": "PoCheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214772": {
    "id": "item_25942",
    "Last Name": "Ridley",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214817": {
    "id": "item_18532",
    "Last Name": "Gerth",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214859": {
    "id": "item_25941",
    "Last Name": "Gonzales",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214875": {
    "id": "item_18533",
    "Last Name": "Ortega",
    "First Name": "M—nica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214900": {
    "id": "item_25938",
    "Last Name": "Yang",
    "First Name": "Yun-Rong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215026": {
    "id": "item_3037",
    "Last Name": "Hudson",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215053": {
    "id": "item_25933",
    "Last Name": "Nathan",
    "First Name": "Johnathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215260": {
    "id": "item_30731",
    "Last Name": "Flores-Rojas",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215307": {
    "id": "item_25929",
    "Last Name": "VAN STRAATEN",
    "First Name": "Snyman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215322": {
    "id": "item_18521",
    "Last Name": "Kairu",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215370": {
    "id": "item_1170",
    "Last Name": "Dias",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215391": {
    "id": "item_1169",
    "Last Name": "Mai",
    "First Name": "Jing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215405": {
    "id": "item_18522",
    "Last Name": "Lovik",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215410": {
    "id": "item_13678",
    "Last Name": "Kaplan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215577": {
    "id": "item_3035",
    "Last Name": "Boyle",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215635": {
    "id": "item_13677",
    "Last Name": "Huang",
    "First Name": "Huang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215644": {
    "id": "item_3034",
    "Last Name": "Shah",
    "First Name": "Vinil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215648": {
    "id": "item_30726",
    "Last Name": "Nguyen",
    "First Name": "Xuan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215759": {
    "id": "item_3033",
    "Last Name": "Schwartz",
    "First Name": "Jinhee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215868": {
    "id": "item_13673",
    "Last Name": "You",
    "First Name": "Wen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215873": {
    "id": "item_14032",
    "Last Name": "Kasi Perumal",
    "First Name": "Yogendran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215941": {
    "id": "item_28867",
    "Last Name": "Anderson",
    "First Name": "Kaitlyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215970": {
    "id": "item_28583",
    "Last Name": "Ibuado",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215999": {
    "id": "item_25922",
    "Last Name": "Charlton",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216116": {
    "id": "item_25921",
    "Last Name": "Gonzalez",
    "First Name": "Emmanuell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216172": {
    "id": "item_1163",
    "Last Name": "BŸcker",
    "First Name": "Marlene",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216187": {
    "id": "item_25920",
    "Last Name": "Noble",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216197": {
    "id": "item_13669",
    "Last Name": "Jain",
    "First Name": "Amber",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216236": {
    "id": "item_18507",
    "Last Name": "Marasovic",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216292": {
    "id": "item_3031",
    "Last Name": "Gethers",
    "First Name": "Brittanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216317": {
    "id": "item_25916",
    "Last Name": "Yap-Weber",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216333": {
    "id": "item_25917",
    "Last Name": "Wong",
    "First Name": "Siu kwan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216370": {
    "id": "item_25913",
    "Last Name": "Hirsch",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216463": {
    "id": "item_18503",
    "Last Name": "WIN",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216507": {
    "id": "item_30721",
    "Last Name": "CORTES",
    "First Name": "DIANA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216527": {
    "id": "item_28577",
    "Last Name": "Marenes",
    "First Name": "Cody",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216544": {
    "id": "item_30720",
    "Last Name": "Busch",
    "First Name": "Jens",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216586": {
    "id": "item_16204",
    "Last Name": "McKinley-Smith",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216641": {
    "id": "item_25911",
    "Last Name": "Fu",
    "First Name": "Cat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216653": {
    "id": "item_3029",
    "Last Name": "Fenton",
    "First Name": "Emerson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216699": {
    "id": "item_1156",
    "Last Name": "Lalor",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216738": {
    "id": "item_1155",
    "Last Name": "Riley",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216795": {
    "id": "item_18499",
    "Last Name": "Beard",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216846": {
    "id": "item_28575",
    "Last Name": "Smirnova",
    "First Name": "Marianna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216908": {
    "id": "item_3026",
    "Last Name": "Landbeck",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216921": {
    "id": "item_1153",
    "Last Name": "Garcia",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217004": {
    "id": "item_28574",
    "Last Name": "Logan",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217032": {
    "id": "item_18494",
    "Last Name": "Harrison",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217068": {
    "id": "item_28827",
    "Last Name": "Rabulan",
    "First Name": "Nicko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217080": {
    "id": "item_28573",
    "Last Name": "Woo",
    "First Name": "Wing-Fay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217090": {
    "id": "item_18493",
    "Last Name": "Alvares",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217117": {
    "id": "item_1151",
    "Last Name": "Andrade",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217148": {
    "id": "item_13663",
    "Last Name": "Mullins",
    "First Name": "Caieta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217159": {
    "id": "item_13662",
    "Last Name": "Ingram",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217160": {
    "id": "item_18489",
    "Last Name": "Woods",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217215": {
    "id": "item_25899",
    "Last Name": "Ferreira Junior",
    "First Name": "Renato",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217268": {
    "id": "item_25897",
    "Last Name": "Reith",
    "First Name": "Andres",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217389": {
    "id": "item_13659",
    "Last Name": "Kimball",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217459": {
    "id": "item_13653",
    "Last Name": "Kaye",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217496": {
    "id": "item_1147",
    "Last Name": "Scott",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217505": {
    "id": "item_13654",
    "Last Name": "Ycaza",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217579": {
    "id": "item_25893",
    "Last Name": "Butters",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217582": {
    "id": "item_14031",
    "Last Name": "Strykowski",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217586": {
    "id": "item_30713",
    "Last Name": "Jackson",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217592": {
    "id": "item_18479",
    "Last Name": "Giles",
    "First Name": "Gerad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217596": {
    "id": "item_16201",
    "Last Name": "Stanley",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217599": {
    "id": "item_28566",
    "Last Name": "Palomba",
    "First Name": "Clare",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217666": {
    "id": "item_25892",
    "Last Name": "Hickey",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217676": {
    "id": "item_25890",
    "Last Name": "Garrahy",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217683": {
    "id": "item_18476",
    "Last Name": "Zhang",
    "First Name": "Xinyan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217728": {
    "id": "item_18475",
    "Last Name": "Sweeney",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217750": {
    "id": "item_1144",
    "Last Name": "Jacobs",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217754": {
    "id": "item_28564",
    "Last Name": "Vavra",
    "First Name": "Anastasiya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217775": {
    "id": "item_18472",
    "Last Name": "Pacheco",
    "First Name": "Zaida",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217878": {
    "id": "item_25885",
    "Last Name": "Wong",
    "First Name": "Yat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217947": {
    "id": "item_1142",
    "Last Name": "Christensen",
    "First Name": "Per Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218001": {
    "id": "item_3018",
    "Last Name": "Wilkinson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218005": {
    "id": "item_18465",
    "Last Name": "Timmings",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218006": {
    "id": "item_30705",
    "Last Name": "Newman",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218021": {
    "id": "item_14030",
    "Last Name": "wong",
    "First Name": "kwok kin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218036": {
    "id": "item_28561",
    "Last Name": "Quadrat",
    "First Name": "Claudine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218058": {
    "id": "item_18463",
    "Last Name": "Baptiste",
    "First Name": "Breeann",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218101": {
    "id": "item_18462",
    "Last Name": "Kabaria",
    "First Name": "Ajay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218102": {
    "id": "item_16198",
    "Last Name": "Abesamis",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218111": {
    "id": "item_14029",
    "Last Name": "Casilag",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218114": {
    "id": "item_25874",
    "Last Name": "Scott",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218225": {
    "id": "item_18459",
    "Last Name": "Woolley",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218256": {
    "id": "item_3254",
    "Last Name": "Cheng",
    "First Name": "Tandy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218257": {
    "id": "item_1139",
    "Last Name": "Baek",
    "First Name": "Seung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218266": {
    "id": "item_18457",
    "Last Name": "Garcia Casado",
    "First Name": "Miguel Angel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218318": {
    "id": "item_25869",
    "Last Name": "Bhattacharjee",
    "First Name": "Indronil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218459": {
    "id": "item_18450",
    "Last Name": "Allpress",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218471": {
    "id": "item_3012",
    "Last Name": "Nichols",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218554": {
    "id": "item_28554",
    "Last Name": "Marshall",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218567": {
    "id": "item_18445",
    "Last Name": "Kwong",
    "First Name": "Sze Chit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218597": {
    "id": "item_28552",
    "Last Name": "Comley",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218601": {
    "id": "item_13637",
    "Last Name": "Sheehan",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218602": {
    "id": "item_3010",
    "Last Name": "Kennedy",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218606": {
    "id": "item_18442",
    "Last Name": "Colman",
    "First Name": "Nina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218618": {
    "id": "item_25863",
    "Last Name": "Liu",
    "First Name": "Austine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218633": {
    "id": "item_1132",
    "Last Name": "Zhao",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218641": {
    "id": "item_28551",
    "Last Name": "Flanagan",
    "First Name": "Eithne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218668": {
    "id": "item_18438",
    "Last Name": "Norris",
    "First Name": "Dale",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218702": {
    "id": "item_18437",
    "Last Name": "Ahmed",
    "First Name": "Samiul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218723": {
    "id": "item_30687",
    "Last Name": "KARAMAHMUT",
    "First Name": "UMUT",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218752": {
    "id": "item_16192",
    "Last Name": "O'Brien",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218766": {
    "id": "item_14028",
    "Last Name": "Lyssens",
    "First Name": "Jurgen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218788": {
    "id": "item_18436",
    "Last Name": "Wylie",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218829": {
    "id": "item_3006",
    "Last Name": "Phan",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218850": {
    "id": "item_13635",
    "Last Name": "VERDUZCO BECERRA",
    "First Name": "JORGE ALEJANDRO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218866": {
    "id": "item_18434",
    "Last Name": "Drape",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218867": {
    "id": "item_3005",
    "Last Name": "Guillen",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218929": {
    "id": "item_25859",
    "Last Name": "CHEN",
    "First Name": "WEN-CHING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218935": {
    "id": "item_1128",
    "Last Name": "Zygadlo",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218940": {
    "id": "item_28548",
    "Last Name": "Studdert",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218946": {
    "id": "item_25856",
    "Last Name": "Williams",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218969": {
    "id": "item_1127",
    "Last Name": "Clarke",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218979": {
    "id": "item_13632",
    "Last Name": "Suijkerbuijk",
    "First Name": "Servi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219018": {
    "id": "item_18430",
    "Last Name": "Simpson",
    "First Name": "Glen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219021": {
    "id": "item_28543",
    "Last Name": "Colon",
    "First Name": "Esmeralda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219064": {
    "id": "item_25849",
    "Last Name": "Atkins",
    "First Name": "Diep",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219071": {
    "id": "item_3003",
    "Last Name": "Young",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219098": {
    "id": "item_18427",
    "Last Name": "Worden",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219127": {
    "id": "item_25850",
    "Last Name": "Gatzemeier",
    "First Name": "Bernadette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219154": {
    "id": "item_1121",
    "Last Name": "Velarde Lazo",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219212": {
    "id": "item_13630",
    "Last Name": "Berndt",
    "First Name": "jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219276": {
    "id": "item_25847",
    "Last Name": "CHEN",
    "First Name": "SU-CHIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219293": {
    "id": "item_25845",
    "Last Name": "Whitaker",
    "First Name": "Grant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219319": {
    "id": "item_28540",
    "Last Name": "McGhee-Kerins",
    "First Name": "Mary Rose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219322": {
    "id": "item_18420",
    "Last Name": "Foo",
    "First Name": "Zhi-wei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219329": {
    "id": "item_14027",
    "Last Name": "Song",
    "First Name": "Keanu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219334": {
    "id": "item_28538",
    "Last Name": "Hellmann",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219348": {
    "id": "item_28536",
    "Last Name": "Villalobos",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219364": {
    "id": "item_2999",
    "Last Name": "Zapata",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219370": {
    "id": "item_25842",
    "Last Name": "Carins",
    "First Name": "Ross",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219372": {
    "id": "item_1117",
    "Last Name": "Wright",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219475": {
    "id": "item_18417",
    "Last Name": "Sommerard",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219521": {
    "id": "item_13626",
    "Last Name": "McMahon",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219552": {
    "id": "item_13624",
    "Last Name": "Goulter",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219603": {
    "id": "item_27911",
    "Last Name": "Rodriguez",
    "First Name": "Lord",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219630": {
    "id": "item_28531",
    "Last Name": "Herdman",
    "First Name": "Brock",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219640": {
    "id": "item_2996",
    "Last Name": "lee",
    "First Name": "jeunghee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219690": {
    "id": "item_25839",
    "Last Name": "Karalus",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219695": {
    "id": "item_18408",
    "Last Name": "Holevs",
    "First Name": "Ondrej",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219750": {
    "id": "item_28528",
    "Last Name": "Thomas",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219806": {
    "id": "item_25832",
    "Last Name": "Coad",
    "First Name": "Marguerite",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219850": {
    "id": "item_1112",
    "Last Name": "Kim",
    "First Name": "Soyeon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219859": {
    "id": "item_16187",
    "Last Name": "Benkhauser",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219876": {
    "id": "item_28527",
    "Last Name": "Singh",
    "First Name": "Nilesh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219894": {
    "id": "item_25828",
    "Last Name": "Cillekens",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220000": {
    "id": "item_18402",
    "Last Name": "Diaz",
    "First Name": "Margarita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220086": {
    "id": "item_30674",
    "Last Name": "Sipaseutsak",
    "First Name": "Karuna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220164": {
    "id": "item_25824",
    "Last Name": "Lo",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220176": {
    "id": "item_13619",
    "Last Name": "Chen",
    "First Name": "Paigi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220182": {
    "id": "item_3253",
    "Last Name": "Luscombe",
    "First Name": "Campbell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220192": {
    "id": "item_30673",
    "Last Name": "Cheng",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220203": {
    "id": "item_30672",
    "Last Name": "Gopi",
    "First Name": "Soubhag",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220214": {
    "id": "item_18394",
    "Last Name": "Gilmour",
    "First Name": "Howard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220274": {
    "id": "item_28522",
    "Last Name": "Nelson",
    "First Name": "Nerida",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220306": {
    "id": "item_18392",
    "Last Name": "Azzopardi",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220320": {
    "id": "item_2992",
    "Last Name": "OConnor",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220329": {
    "id": "item_18389",
    "Last Name": "Gonzalez",
    "First Name": "Imelda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220396": {
    "id": "item_2991",
    "Last Name": "CUELLAR, ERICA (4748)",
    "First Name": "Erica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220459": {
    "id": "item_28521",
    "Last Name": "Mclaurin",
    "First Name": "Marc",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220481": {
    "id": "item_30669",
    "Last Name": "Martinez",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220497": {
    "id": "item_25819",
    "Last Name": "Villiers",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220498": {
    "id": "item_18388",
    "Last Name": "Boudehane",
    "First Name": "Aisha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220527": {
    "id": "item_25815",
    "Last Name": "Ghaffaripour",
    "First Name": "Omid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220528": {
    "id": "item_13610",
    "Last Name": "Tan",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220548": {
    "id": "item_25812",
    "Last Name": "McDermott",
    "First Name": "Shean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220552": {
    "id": "item_18386",
    "Last Name": "Robertson",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220579": {
    "id": "item_18385",
    "Last Name": "Buchanan",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220690": {
    "id": "item_30667",
    "Last Name": "GAMA OSUNA",
    "First Name": "GRACIA CONCHITA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220716": {
    "id": "item_3252",
    "Last Name": "Lim",
    "First Name": "Phu Yuen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220731": {
    "id": "item_2985",
    "Last Name": "Muir",
    "First Name": "Isla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220758": {
    "id": "item_25803",
    "Last Name": "Wells",
    "First Name": "Clare",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220760": {
    "id": "item_18380",
    "Last Name": "Vano",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220818": {
    "id": "item_25801",
    "Last Name": "Ho",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220823": {
    "id": "item_25800",
    "Last Name": "Cameron",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220854": {
    "id": "item_30665",
    "Last Name": "Mendoza",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220861": {
    "id": "item_25797",
    "Last Name": "Merrick",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220869": {
    "id": "item_25798",
    "Last Name": "Gongora",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220871": {
    "id": "item_13604",
    "Last Name": "Ramboyong",
    "First Name": "Darrie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220882": {
    "id": "item_30664",
    "Last Name": "Pontifex",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220891": {
    "id": "item_13602",
    "Last Name": "Falconer",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220952": {
    "id": "item_28514",
    "Last Name": "Branscum",
    "First Name": "Norma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220975": {
    "id": "item_1099",
    "Last Name": "Arriola",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220979": {
    "id": "item_25795",
    "Last Name": "Hawker",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221040": {
    "id": "item_18368",
    "Last Name": "Neff",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221052": {
    "id": "item_1097",
    "Last Name": "VanLuvender III",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221101": {
    "id": "item_25791",
    "Last Name": "Phillips",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221118": {
    "id": "item_18363",
    "Last Name": "Luboya",
    "First Name": "Francine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221120": {
    "id": "item_13598",
    "Last Name": "Cook",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221126": {
    "id": "item_16180",
    "Last Name": "Monaco maciel",
    "First Name": "Juliano",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221162": {
    "id": "item_18362",
    "Last Name": "Liu",
    "First Name": "Wai Keung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221203": {
    "id": "item_30653",
    "Last Name": "Chen",
    "First Name": "Jun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221222": {
    "id": "item_18358",
    "Last Name": "PRODEAU",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221230": {
    "id": "item_1093",
    "Last Name": "Dwyer",
    "First Name": "Bernard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221234": {
    "id": "item_30652",
    "Last Name": "Massengale",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221236": {
    "id": "item_28511",
    "Last Name": "Onofeta",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221244": {
    "id": "item_2979",
    "Last Name": "Hodson",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221249": {
    "id": "item_2978",
    "Last Name": "Myatt",
    "First Name": "Rhiarna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221274": {
    "id": "item_28512",
    "Last Name": "Lu",
    "First Name": "Kun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221304": {
    "id": "item_13593",
    "Last Name": "O'Callaghan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221305": {
    "id": "item_2975",
    "Last Name": "Garner",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221317": {
    "id": "item_26407",
    "Last Name": "Wang",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221324": {
    "id": "item_3217",
    "Last Name": "Mutavdzic",
    "First Name": "Goran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221331": {
    "id": "item_28510",
    "Last Name": "Stephens",
    "First Name": "Alisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221388": {
    "id": "item_30650",
    "Last Name": "Siglos",
    "First Name": "Kay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221444": {
    "id": "item_18349",
    "Last Name": "Quinn",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221510": {
    "id": "item_28507",
    "Last Name": "Lamriben",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221549": {
    "id": "item_30649",
    "Last Name": "Casipit",
    "First Name": "Penelope",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221553": {
    "id": "item_28505",
    "Last Name": "Aldana",
    "First Name": "Otto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221588": {
    "id": "item_26406",
    "Last Name": "Torres",
    "First Name": "Jaqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221681": {
    "id": "item_28504",
    "Last Name": "Nissen",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221682": {
    "id": "item_28503",
    "Last Name": "Carpenter",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221719": {
    "id": "item_18342",
    "Last Name": "Aguilar",
    "First Name": "Xiomara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221748": {
    "id": "item_16179",
    "Last Name": "Guarasio",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221776": {
    "id": "item_16178",
    "Last Name": "Harwood",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221796": {
    "id": "item_30646",
    "Last Name": "Lau",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221824": {
    "id": "item_30645",
    "Last Name": "Bloor",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221827": {
    "id": "item_2972",
    "Last Name": "May",
    "First Name": "Clint",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221832": {
    "id": "item_2973",
    "Last Name": "O'Dwyer",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221910": {
    "id": "item_1086",
    "Last Name": "Lenormand",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221940": {
    "id": "item_25774",
    "Last Name": "Perez",
    "First Name": "Arilys",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221984": {
    "id": "item_30644",
    "Last Name": "Imbriano",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222008": {
    "id": "item_25772",
    "Last Name": "Viswanathan",
    "First Name": "Karthikeyan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222056": {
    "id": "item_2971",
    "Last Name": "Hopman",
    "First Name": "Cade",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222064": {
    "id": "item_25771",
    "Last Name": "SUN",
    "First Name": "YUEFENG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222083": {
    "id": "item_30643",
    "Last Name": "HABIBI",
    "First Name": "MUHAMMAD DEYAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222118": {
    "id": "item_16176",
    "Last Name": "Bui",
    "First Name": "Cong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222150": {
    "id": "item_25770",
    "Last Name": "Burton",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222173": {
    "id": "item_25768",
    "Last Name": "Robertson",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222191": {
    "id": "item_25764",
    "Last Name": "Gifford",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222193": {
    "id": "item_2968",
    "Last Name": "Campbell",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222194": {
    "id": "item_13581",
    "Last Name": "WANG",
    "First Name": "FUQUAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222302": {
    "id": "item_2964",
    "Last Name": "Geraghty",
    "First Name": "Clara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222329": {
    "id": "item_30637",
    "Last Name": "Heng",
    "First Name": "Hong Yet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222422": {
    "id": "item_25762",
    "Last Name": "Dixit",
    "First Name": "Naveen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222423": {
    "id": "item_30633",
    "Last Name": "Lau",
    "First Name": "Cheuk Hei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222451": {
    "id": "item_28501",
    "Last Name": "Basya",
    "First Name": "Mochamad Zacky",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222459": {
    "id": "item_1417",
    "Last Name": "gong",
    "First Name": "Xiumei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222528": {
    "id": "item_16174",
    "Last Name": "Bellamy",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222548": {
    "id": "item_13572",
    "Last Name": "Kim",
    "First Name": "Eunjung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222585": {
    "id": "item_13571",
    "Last Name": "Hooley",
    "First Name": "Paris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222590": {
    "id": "item_18322",
    "Last Name": "Hamaty",
    "First Name": "Sabina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222623": {
    "id": "item_18320",
    "Last Name": "McConville",
    "First Name": "Aoibhin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222647": {
    "id": "item_1078",
    "Last Name": "Logan",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222678": {
    "id": "item_30631",
    "Last Name": "Greer",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222685": {
    "id": "item_18317",
    "Last Name": "Ng",
    "First Name": "Jenn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222702": {
    "id": "item_18318",
    "Last Name": "Hughes",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222754": {
    "id": "item_18313",
    "Last Name": "Solomon",
    "First Name": "Kevin Rusty",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222770": {
    "id": "item_30628",
    "Last Name": "Vijayakumar",
    "First Name": "Srihari",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222775": {
    "id": "item_18312",
    "Last Name": "Calleja",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222780": {
    "id": "item_16729",
    "Last Name": "Dickie",
    "First Name": "Riley-Jane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222906": {
    "id": "item_25754",
    "Last Name": "Westhoff",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222926": {
    "id": "item_1076",
    "Last Name": "Russo",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223130": {
    "id": "item_25750",
    "Last Name": "Dash",
    "First Name": "Campbell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223193": {
    "id": "item_1074",
    "Last Name": "Dowling",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223194": {
    "id": "item_18303",
    "Last Name": "Kentwell",
    "First Name": "Kade",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223197": {
    "id": "item_25747",
    "Last Name": "Tsai",
    "First Name": "Mengtsun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223217": {
    "id": "item_30622",
    "Last Name": "Thompson",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223240": {
    "id": "item_26485",
    "Last Name": "Sider",
    "First Name": "Darby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223252": {
    "id": "item_30621",
    "Last Name": "Arun",
    "First Name": "Pattaraporn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223256": {
    "id": "item_25745",
    "Last Name": "Marshman",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223275": {
    "id": "item_25744",
    "Last Name": "Miscala",
    "First Name": "Hector Leo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223283": {
    "id": "item_30619",
    "Last Name": "Tran",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223306": {
    "id": "item_25743",
    "Last Name": "Nixon",
    "First Name": "Chantelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223356": {
    "id": "item_28495",
    "Last Name": "Gupta",
    "First Name": "Nimish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223365": {
    "id": "item_25742",
    "Last Name": "Johnson",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223392": {
    "id": "item_18301",
    "Last Name": "Samuri",
    "First Name": "Haziq",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223418": {
    "id": "item_1072",
    "Last Name": "Chua",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223558": {
    "id": "item_13554",
    "Last Name": "Corry",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223597": {
    "id": "item_28492",
    "Last Name": "Chavis",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223600": {
    "id": "item_13553",
    "Last Name": "Dill",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223768": {
    "id": "item_30614",
    "Last Name": "Galvan",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223804": {
    "id": "item_25729",
    "Last Name": "Marco",
    "First Name": "Oriane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223876": {
    "id": "item_25728",
    "Last Name": "NUGROHO",
    "First Name": "FRANSISCUS",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223905": {
    "id": "item_18288",
    "Last Name": "French",
    "First Name": "Desiree",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223937": {
    "id": "item_1066",
    "Last Name": "Kozlovskii",
    "First Name": "Slava",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223950": {
    "id": "item_16167",
    "Last Name": "Davey",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224006": {
    "id": "item_18285",
    "Last Name": "Cesar Dias",
    "First Name": "Ana Luiza",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224057": {
    "id": "item_25724",
    "Last Name": "Zhen",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224090": {
    "id": "item_1063",
    "Last Name": "Latchford",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224095": {
    "id": "item_18282",
    "Last Name": "Rostron",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224150": {
    "id": "item_28866",
    "Last Name": "Ninh",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224234": {
    "id": "item_2948",
    "Last Name": "Liu",
    "First Name": "Ya Ching",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224389": {
    "id": "item_25719",
    "Last Name": "Wilkins",
    "First Name": "Annabelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224404": {
    "id": "item_18278",
    "Last Name": "Del Castillo",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224511": {
    "id": "item_18276",
    "Last Name": "Liu",
    "First Name": "Ed",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224527": {
    "id": "item_25716",
    "Last Name": "He",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224544": {
    "id": "item_28489",
    "Last Name": "Doyle",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224650": {
    "id": "item_2944",
    "Last Name": "Hanssen",
    "First Name": "Marina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224661": {
    "id": "item_1416",
    "Last Name": "Picos",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224674": {
    "id": "item_25713",
    "Last Name": "(Ms)",
    "First Name": "Rundle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224713": {
    "id": "item_13546",
    "Last Name": "Vanden Berghe",
    "First Name": "Hanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224813": {
    "id": "item_18269",
    "Last Name": "Kornberg",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224880": {
    "id": "item_18267",
    "Last Name": "Coutts",
    "First Name": "Graham",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224937": {
    "id": "item_25711",
    "Last Name": "Pedersen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224994": {
    "id": "item_25709",
    "Last Name": "Newton",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225048": {
    "id": "item_25707",
    "Last Name": "Statos",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225137": {
    "id": "item_25706",
    "Last Name": "Stammers",
    "First Name": "Piers",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225191": {
    "id": "item_18262",
    "Last Name": "Assaf",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225195": {
    "id": "item_3251",
    "Last Name": "Alaniz",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225216": {
    "id": "item_4744",
    "Last Name": "Mollies",
    "First Name": "Mathilde",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225288": {
    "id": "item_30600",
    "Last Name": "Reyes",
    "First Name": "Roger",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225300": {
    "id": "item_26484",
    "Last Name": "Duncan",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225404": {
    "id": "item_25697",
    "Last Name": "masae",
    "First Name": "kanno",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225457": {
    "id": "item_18259",
    "Last Name": "Crossing",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225475": {
    "id": "item_18257",
    "Last Name": "Fisher",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225493": {
    "id": "item_18255",
    "Last Name": "Badillo",
    "First Name": "Mc Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225610": {
    "id": "item_25699",
    "Last Name": "Hutapea",
    "First Name": "Frisca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225616": {
    "id": "item_16730",
    "Last Name": "Dunford",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225637": {
    "id": "item_1056",
    "Last Name": "LYU",
    "First Name": "YE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225658": {
    "id": "item_13540",
    "Last Name": "Ho",
    "First Name": "Chi Wing Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225673": {
    "id": "item_30596",
    "Last Name": "burger",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225746": {
    "id": "item_25696",
    "Last Name": "HUANG",
    "First Name": "HUIJU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225775": {
    "id": "item_28478",
    "Last Name": "Arias Coyotl",
    "First Name": "Yaratzed",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225824": {
    "id": "item_18251",
    "Last Name": "Sompheng",
    "First Name": "Antoine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225825": {
    "id": "item_18250",
    "Last Name": "Liu",
    "First Name": "Qian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225827": {
    "id": "item_13537",
    "Last Name": "Stuart",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225838": {
    "id": "item_28865",
    "Last Name": "Sauls",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225907": {
    "id": "item_28476",
    "Last Name": "Jumawan",
    "First Name": "John Reevo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225959": {
    "id": "item_18248",
    "Last Name": "Collins",
    "First Name": "Teigan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225961": {
    "id": "item_16161",
    "Last Name": "Monterroso",
    "First Name": "Diego",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225965": {
    "id": "item_1052",
    "Last Name": "Johnson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226045": {
    "id": "item_18245",
    "Last Name": "Taoa",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226112": {
    "id": "item_1051",
    "Last Name": "Esperanca Ventura",
    "First Name": "Joao Mario",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226125": {
    "id": "item_13534",
    "Last Name": "SHRIMPTON",
    "First Name": "PAULA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226354": {
    "id": "item_13533",
    "Last Name": "Sanchez",
    "First Name": "Jose Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226359": {
    "id": "item_30592",
    "Last Name": "Hegarty",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226490": {
    "id": "item_25691",
    "Last Name": "Lo",
    "First Name": "Wing Lam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226499": {
    "id": "item_18238",
    "Last Name": "Gannett",
    "First Name": "Sheri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226506": {
    "id": "item_25690",
    "Last Name": "Heath",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226546": {
    "id": "item_30586",
    "Last Name": "Hopkinson",
    "First Name": "Dom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226597": {
    "id": "item_2941",
    "Last Name": "Urue–a",
    "First Name": "Jairo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226611": {
    "id": "item_25687",
    "Last Name": "Helguera",
    "First Name": "Solana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226683": {
    "id": "item_25685",
    "Last Name": "Law",
    "First Name": "Taryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226727": {
    "id": "item_2939",
    "Last Name": "Peters",
    "First Name": "Kane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226784": {
    "id": "item_18232",
    "Last Name": "ZHOU",
    "First Name": "WEIDONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226817": {
    "id": "item_28472",
    "Last Name": "LIU",
    "First Name": "HONGFANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226825": {
    "id": "item_1047",
    "Last Name": "Ellingham",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226828": {
    "id": "item_16329",
    "Last Name": "Leung",
    "First Name": "Miu kwan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226877": {
    "id": "item_13527",
    "Last Name": "Conacher",
    "First Name": "Sheree",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226912": {
    "id": "item_30582",
    "Last Name": "Belair",
    "First Name": "Ethel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226913": {
    "id": "item_30583",
    "Last Name": "Gorman",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226966": {
    "id": "item_25678",
    "Last Name": "GETALLA",
    "First Name": "JOHN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227019": {
    "id": "item_18228",
    "Last Name": "Morrissey",
    "First Name": "Conor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227045": {
    "id": "item_2938",
    "Last Name": "Bourne",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227078": {
    "id": "item_25676",
    "Last Name": "Antrobus",
    "First Name": "Shennell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227101": {
    "id": "item_25679",
    "Last Name": "Hancock",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227146": {
    "id": "item_2936",
    "Last Name": "Rydannykh",
    "First Name": "Egor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227152": {
    "id": "item_18223",
    "Last Name": "Teixeira",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227181": {
    "id": "item_18220",
    "Last Name": "Court",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227185": {
    "id": "item_2935",
    "Last Name": "Kwong",
    "First Name": "Po Yee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227204": {
    "id": "item_1040",
    "Last Name": "Somers",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227222": {
    "id": "item_13523",
    "Last Name": "Fletcher",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227234": {
    "id": "item_1039",
    "Last Name": "Suarez",
    "First Name": "Valeria",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227280": {
    "id": "item_25674",
    "Last Name": "Mosot",
    "First Name": "Pem",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227282": {
    "id": "item_30578",
    "Last Name": "AZARES",
    "First Name": "GEORGE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227308": {
    "id": "item_25673",
    "Last Name": "James",
    "First Name": "Benet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227324": {
    "id": "item_28470",
    "Last Name": "KIM",
    "First Name": "BEEBUM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227346": {
    "id": "item_30577",
    "Last Name": "Deck",
    "First Name": "Kali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227348": {
    "id": "item_2934",
    "Last Name": "Bishop",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227366": {
    "id": "item_2933",
    "Last Name": "Go",
    "First Name": "Mar Jefferson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227474": {
    "id": "item_5722",
    "Last Name": "Hanley",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227476": {
    "id": "item_30574",
    "Last Name": "Lin",
    "First Name": "Yu-Hsuan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227503": {
    "id": "item_13520",
    "Last Name": "Mancuso",
    "First Name": "Krystal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227546": {
    "id": "item_2932",
    "Last Name": "Chan",
    "First Name": "Hoi Lam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227561": {
    "id": "item_5724",
    "Last Name": "KIM",
    "First Name": "GEONUK",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227593": {
    "id": "item_13518",
    "Last Name": "Thomas",
    "First Name": "Ash",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227691": {
    "id": "item_13517",
    "Last Name": "Zhang",
    "First Name": "Rui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227728": {
    "id": "item_25662",
    "Last Name": "Neidhart",
    "First Name": "Boonwadee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227808": {
    "id": "item_18204",
    "Last Name": "LU",
    "First Name": "XUE-MIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227818": {
    "id": "item_1036",
    "Last Name": "Tong",
    "First Name": "Kin Chung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227833": {
    "id": "item_28468",
    "Last Name": "Moncrief",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227897": {
    "id": "item_5715",
    "Last Name": "Song",
    "First Name": "Jia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227930": {
    "id": "item_18198",
    "Last Name": "Van Heurck",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227960": {
    "id": "item_2927",
    "Last Name": "Leary",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227979": {
    "id": "item_5713",
    "Last Name": "Jones",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227994": {
    "id": "item_13514",
    "Last Name": "Teanio",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227999": {
    "id": "item_25657",
    "Last Name": "Zhao",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228012": {
    "id": "item_5711",
    "Last Name": "Essex",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228094": {
    "id": "item_13513",
    "Last Name": "Edson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228117": {
    "id": "item_28864",
    "Last Name": "Dhani",
    "First Name": "Rama",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228118": {
    "id": "item_5706",
    "Last Name": "Courtney",
    "First Name": "Sincleia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228126": {
    "id": "item_18190",
    "Last Name": "Rayner",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228129": {
    "id": "item_28462",
    "Last Name": "Ma",
    "First Name": "Zhengtao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228169": {
    "id": "item_30566",
    "Last Name": "gao",
    "First Name": "xiaodong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228186": {
    "id": "item_16153",
    "Last Name": "Saunders",
    "First Name": "Jono",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228189": {
    "id": "item_30563",
    "Last Name": "Shanahan",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228308": {
    "id": "item_25647",
    "Last Name": "Dizon",
    "First Name": "Viennah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228311": {
    "id": "item_25648",
    "Last Name": "Dixon",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228330": {
    "id": "item_16152",
    "Last Name": "Haney",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228345": {
    "id": "item_2924",
    "Last Name": "martinez lopez",
    "First Name": "gabriel hugo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228351": {
    "id": "item_26483",
    "Last Name": "Ma",
    "First Name": "Ming",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228369": {
    "id": "item_1030",
    "Last Name": "Zhang",
    "First Name": "Bihua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228370": {
    "id": "item_30560",
    "Last Name": "Corish",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228607": {
    "id": "item_5696",
    "Last Name": "Kaye",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228627": {
    "id": "item_18180",
    "Last Name": "Au",
    "First Name": "Lok Him Rodney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228635": {
    "id": "item_30555",
    "Last Name": "LEUNG",
    "First Name": "LAI KAM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228670": {
    "id": "item_13508",
    "Last Name": "Hayhow",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228899": {
    "id": "item_18174",
    "Last Name": "Childs",
    "First Name": "Jye",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228941": {
    "id": "item_18169",
    "Last Name": "Davis",
    "First Name": "Katie Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228984": {
    "id": "item_16148",
    "Last Name": "GALANG",
    "First Name": "NOEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229003": {
    "id": "item_30550",
    "Last Name": "Deng",
    "First Name": "Xiaoyu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229032": {
    "id": "item_28453",
    "Last Name": "Napier",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229097": {
    "id": "item_1025",
    "Last Name": "Jing",
    "First Name": "Lei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229136": {
    "id": "item_5691",
    "Last Name": "Wilkins",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229144": {
    "id": "item_2921",
    "Last Name": "Roberts",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229148": {
    "id": "item_18165",
    "Last Name": "Cheung",
    "First Name": "Renwick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229169": {
    "id": "item_28451",
    "Last Name": "WANG",
    "First Name": "JING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229174": {
    "id": "item_30546",
    "Last Name": "Kennedy",
    "First Name": "Krystal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229183": {
    "id": "item_13501",
    "Last Name": "Gregg",
    "First Name": "Ed",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229185": {
    "id": "item_30545",
    "Last Name": "Cuevas Meza",
    "First Name": "Maria Fernanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229194": {
    "id": "item_30547",
    "Last Name": "Park",
    "First Name": "Suhwa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229227": {
    "id": "item_30541",
    "Last Name": "Jordan",
    "First Name": "Joe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229262": {
    "id": "item_30544",
    "Last Name": "liang",
    "First Name": "chen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229350": {
    "id": "item_3250",
    "Last Name": "Wei",
    "First Name": "Xueyan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229545": {
    "id": "item_18154",
    "Last Name": "brandis",
    "First Name": "Gerald",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229740": {
    "id": "item_1024",
    "Last Name": "McKenzie",
    "First Name": "Kirk",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229816": {
    "id": "item_18152",
    "Last Name": "Rehman",
    "First Name": "Zain",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229883": {
    "id": "item_30538",
    "Last Name": "Hong",
    "First Name": "Young",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229884": {
    "id": "item_18151",
    "Last Name": "Matherson",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230019": {
    "id": "item_30537",
    "Last Name": "Bulayungan",
    "First Name": "Gerald Kress",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230175": {
    "id": "item_14026",
    "Last Name": "Shi",
    "First Name": "Honghua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230221": {
    "id": "item_30536",
    "Last Name": "Lai",
    "First Name": "Chun Yu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230385": {
    "id": "item_13492",
    "Last Name": "SHI",
    "First Name": "JI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230394": {
    "id": "item_18143",
    "Last Name": "Park",
    "First Name": "Jiyong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230435": {
    "id": "item_18142",
    "Last Name": "Mark",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230497": {
    "id": "item_1374",
    "Last Name": "Poole",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230582": {
    "id": "item_18138",
    "Last Name": "Glass",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230611": {
    "id": "item_30532",
    "Last Name": "Fu",
    "First Name": "Le",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230644": {
    "id": "item_13490",
    "Last Name": "Gunawan",
    "First Name": "Novi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230757": {
    "id": "item_28447",
    "Last Name": "O Hanlon",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230847": {
    "id": "item_30531",
    "Last Name": "Jeyakumar",
    "First Name": "Ragavi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230899": {
    "id": "item_18135",
    "Last Name": "Fresnillo",
    "First Name": "Javier",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230948": {
    "id": "item_26482",
    "Last Name": "Gounden",
    "First Name": "Jaydh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231023": {
    "id": "item_13488",
    "Last Name": "Huntsman",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231062": {
    "id": "item_5681",
    "Last Name": "Edgerley",
    "First Name": "Carmel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231084": {
    "id": "item_5680",
    "Last Name": "Park",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231163": {
    "id": "item_28826",
    "Last Name": "LAM",
    "First Name": "YAN FANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231185": {
    "id": "item_28444",
    "Last Name": "Walker",
    "First Name": "Yolande",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231276": {
    "id": "item_30524",
    "Last Name": "Ramnath",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231302": {
    "id": "item_5673",
    "Last Name": "Doyle",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231303": {
    "id": "item_18124",
    "Last Name": "Sirithanachai",
    "First Name": "Piyanuch",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231368": {
    "id": "item_5672",
    "Last Name": "Griffin",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231383": {
    "id": "item_14025",
    "Last Name": "Young",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231412": {
    "id": "item_28442",
    "Last Name": "Walker",
    "First Name": "Scout",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231416": {
    "id": "item_16139",
    "Last Name": "Duan",
    "First Name": "Sherry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231516": {
    "id": "item_1010",
    "Last Name": "Lee",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231517": {
    "id": "item_18117",
    "Last Name": "Ulmer",
    "First Name": "Trent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231527": {
    "id": "item_28440",
    "Last Name": "Walker",
    "First Name": "Piper",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231542": {
    "id": "item_5670",
    "Last Name": "Lee",
    "First Name": "Karpoh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231575": {
    "id": "item_1008",
    "Last Name": "KIM",
    "First Name": "SODAM",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231595": {
    "id": "item_28438",
    "Last Name": "IM",
    "First Name": "UIHYUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231599": {
    "id": "item_18114",
    "Last Name": "Clarke",
    "First Name": "Dale",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231615": {
    "id": "item_2912",
    "Last Name": "Stewart",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231635": {
    "id": "item_30522",
    "Last Name": "YI",
    "First Name": "CHINTING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231670": {
    "id": "item_13480",
    "Last Name": "Woodenberg",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231676": {
    "id": "item_5667",
    "Last Name": "Whales",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231695": {
    "id": "item_28436",
    "Last Name": "Jones",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231817": {
    "id": "item_30516",
    "Last Name": "Macoun",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231818": {
    "id": "item_2911",
    "Last Name": "Beard",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231872": {
    "id": "item_26481",
    "Last Name": "Rajalabis",
    "First Name": "Moris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231921": {
    "id": "item_1004",
    "Last Name": "QIN",
    "First Name": "LIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231950": {
    "id": "item_28435",
    "Last Name": "Payne",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232003": {
    "id": "item_18102",
    "Last Name": "Orton",
    "First Name": "Indigo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232081": {
    "id": "item_28434",
    "Last Name": "Yip",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232142": {
    "id": "item_13477",
    "Last Name": "Jago",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232155": {
    "id": "item_5659",
    "Last Name": "Campbell",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232156": {
    "id": "item_30511",
    "Last Name": "Nguyen",
    "First Name": "Chi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232207": {
    "id": "item_28432",
    "Last Name": "Phelps",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232295": {
    "id": "item_5658",
    "Last Name": "Marsh",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232315": {
    "id": "item_2903",
    "Last Name": "Williamson",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232338": {
    "id": "item_18091",
    "Last Name": "Bade",
    "First Name": "Kunal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232349": {
    "id": "item_5654",
    "Last Name": "Williams",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232358": {
    "id": "item_30509",
    "Last Name": "Wong",
    "First Name": "Wai Cheong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232385": {
    "id": "item_30508",
    "Last Name": "Kurnianto",
    "First Name": "Awal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232512": {
    "id": "item_5653",
    "Last Name": "Bowman",
    "First Name": "Tara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232531": {
    "id": "item_18083",
    "Last Name": "Aspinall",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232545": {
    "id": "item_16328",
    "Last Name": "Sirikul",
    "First Name": "Pichapak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232568": {
    "id": "item_30505",
    "Last Name": "Banks",
    "First Name": "Ian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232577": {
    "id": "item_5649",
    "Last Name": "Siddiq",
    "First Name": "Haikal Amhar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232649": {
    "id": "item_5646",
    "Last Name": "CHEN",
    "First Name": "PO-LIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232695": {
    "id": "item_28429",
    "Last Name": "Martinez",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232704": {
    "id": "item_28428",
    "Last Name": "Catorall",
    "First Name": "Dean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232728": {
    "id": "item_995",
    "Last Name": "Wang",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232732": {
    "id": "item_30499",
    "Last Name": "Taing",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232763": {
    "id": "item_28426",
    "Last Name": "HO",
    "First Name": "WING YIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232793": {
    "id": "item_18078",
    "Last Name": "Giam",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232840": {
    "id": "item_28425",
    "Last Name": "PROU",
    "First Name": "Helene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232869": {
    "id": "item_30496",
    "Last Name": "Salazar",
    "First Name": "Editha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232876": {
    "id": "item_30495",
    "Last Name": "Purvis",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232919": {
    "id": "item_991",
    "Last Name": "Wang",
    "First Name": "Zhenhua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232933": {
    "id": "item_16129",
    "Last Name": "Wicker",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232935": {
    "id": "item_18073",
    "Last Name": "Kent",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232968": {
    "id": "item_5637",
    "Last Name": "Mcgugan Wevill",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233108": {
    "id": "item_5635",
    "Last Name": "Wallis",
    "First Name": "Carrie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233158": {
    "id": "item_2893",
    "Last Name": "Cable",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233201": {
    "id": "item_987",
    "Last Name": "PANG",
    "First Name": "XIAOBING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233236": {
    "id": "item_5632",
    "Last Name": "Lennon",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233251": {
    "id": "item_16127",
    "Last Name": "Tudor",
    "First Name": "Tasnim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233261": {
    "id": "item_18063",
    "Last Name": "Kelly",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233292": {
    "id": "item_13458",
    "Last Name": "burke",
    "First Name": "dennis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233295": {
    "id": "item_30491",
    "Last Name": "Mak",
    "First Name": "Tsz Wing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233296": {
    "id": "item_18058",
    "Last Name": "Langdown",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233335": {
    "id": "item_18057",
    "Last Name": "Smith",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233382": {
    "id": "item_30490",
    "Last Name": "Yuan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233386": {
    "id": "item_18056",
    "Last Name": "zhao",
    "First Name": "yiqiu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233426": {
    "id": "item_5620",
    "Last Name": "Hanna",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233431": {
    "id": "item_5617",
    "Last Name": "carver",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233438": {
    "id": "item_5618",
    "Last Name": "Goodall",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233501": {
    "id": "item_16125",
    "Last Name": "CHAN WAI PEDRO",
    "First Name": "KONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233512": {
    "id": "item_2884",
    "Last Name": "Liu",
    "First Name": "Chen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233527": {
    "id": "item_2883",
    "Last Name": "Jimenez",
    "First Name": "Francisco Antonio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233532": {
    "id": "item_28416",
    "Last Name": "YUE",
    "First Name": "XIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233541": {
    "id": "item_5612",
    "Last Name": "Park",
    "First Name": "Sungjun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233544": {
    "id": "item_18052",
    "Last Name": "Watts",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233576": {
    "id": "item_4746",
    "Last Name": "Drever",
    "First Name": "Graham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233588": {
    "id": "item_28415",
    "Last Name": "LEONG",
    "First Name": "KA TAT",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233594": {
    "id": "item_18049",
    "Last Name": "RENOUF",
    "First Name": "MICHAEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233598": {
    "id": "item_18048",
    "Last Name": "Washer",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233600": {
    "id": "item_13453",
    "Last Name": "Van Reybroeck",
    "First Name": "Elisabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233616": {
    "id": "item_18045",
    "Last Name": "Fawcett",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233620": {
    "id": "item_18043",
    "Last Name": "Burns",
    "First Name": "Quentin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233632": {
    "id": "item_13452",
    "Last Name": "Cottam",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233658": {
    "id": "item_18037",
    "Last Name": "Chung",
    "First Name": "Man Wei Jenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233667": {
    "id": "item_16122",
    "Last Name": "Paape",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233676": {
    "id": "item_973",
    "Last Name": "Chandler",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233712": {
    "id": "item_18035",
    "Last Name": "Wallett",
    "First Name": "Arabella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233744": {
    "id": "item_13450",
    "Last Name": "Clark",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233750": {
    "id": "item_18032",
    "Last Name": "Milburn",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233783": {
    "id": "item_30483",
    "Last Name": "Kongwong",
    "First Name": "Nikhom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233791": {
    "id": "item_18030",
    "Last Name": "Shen",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233796": {
    "id": "item_18029",
    "Last Name": "Samson",
    "First Name": "Rowena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233867": {
    "id": "item_30482",
    "Last Name": "hoang",
    "First Name": "shu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233882": {
    "id": "item_972",
    "Last Name": "Delgado",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233892": {
    "id": "item_539",
    "Last Name": "Skuodas",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233897": {
    "id": "item_5599",
    "Last Name": "Ioannou",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233921": {
    "id": "item_30480",
    "Last Name": "Dean",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233948": {
    "id": "item_3249",
    "Last Name": "AL Hasan",
    "First Name": "Mahmood",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233963": {
    "id": "item_30478",
    "Last Name": "Della Franca",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233975": {
    "id": "item_2877",
    "Last Name": "Healy",
    "First Name": "Belle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233988": {
    "id": "item_5596",
    "Last Name": "Suesakul",
    "First Name": "Warate",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234003": {
    "id": "item_971",
    "Last Name": "Saeed",
    "First Name": "Rizwan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234008": {
    "id": "item_968",
    "Last Name": "acosta",
    "First Name": "Raul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234009": {
    "id": "item_2873",
    "Last Name": "Myers",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234023": {
    "id": "item_28409",
    "Last Name": "ARDYANTO",
    "First Name": "Didit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234067": {
    "id": "item_13446",
    "Last Name": "Coote",
    "First Name": "Fia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234076": {
    "id": "item_5592",
    "Last Name": "Hernandez Alverio",
    "First Name": "Gonzalo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234090": {
    "id": "item_28406",
    "Last Name": "Thorpe",
    "First Name": "Bec",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234098": {
    "id": "item_13445",
    "Last Name": "Nguyen",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234154": {
    "id": "item_18016",
    "Last Name": "Rennes",
    "First Name": "Dayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234181": {
    "id": "item_30471",
    "Last Name": "Loone",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234204": {
    "id": "item_16117",
    "Last Name": "Vallas",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234241": {
    "id": "item_30468",
    "Last Name": "Loone",
    "First Name": "Ken",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234266": {
    "id": "item_30466",
    "Last Name": "Chaisakgreenon",
    "First Name": "Pimpika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234269": {
    "id": "item_30467",
    "Last Name": "Llewellyn",
    "First Name": "Rhiannon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234311": {
    "id": "item_16114",
    "Last Name": "TALIBOV",
    "First Name": "UMID",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234316": {
    "id": "item_5586",
    "Last Name": "McKay",
    "First Name": "Molly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234339": {
    "id": "item_5582",
    "Last Name": "Sinnott",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234359": {
    "id": "item_5581",
    "Last Name": "TAYLOR",
    "First Name": "ADAM",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234400": {
    "id": "item_18004",
    "Last Name": "Collins",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234410": {
    "id": "item_17998",
    "Last Name": "ZHANG",
    "First Name": "YUEYA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234458": {
    "id": "item_17999",
    "Last Name": "Carr",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234477": {
    "id": "item_17996",
    "Last Name": "Myburgh",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234494": {
    "id": "item_964",
    "Last Name": "Saunders",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234514": {
    "id": "item_30460",
    "Last Name": "Chen",
    "First Name": "Ssu-Yin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234522": {
    "id": "item_2867",
    "Last Name": "Murray",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234537": {
    "id": "item_13436",
    "Last Name": "Plunkett",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234610": {
    "id": "item_13435",
    "Last Name": "Rahn",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234626": {
    "id": "item_3248",
    "Last Name": "Egan",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234686": {
    "id": "item_16733",
    "Last Name": "Sampang",
    "First Name": "Reesha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234701": {
    "id": "item_17994",
    "Last Name": "Spillane",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234703": {
    "id": "item_5576",
    "Last Name": "Swimmer",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234714": {
    "id": "item_17992",
    "Last Name": "Tottman",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234770": {
    "id": "item_5574",
    "Last Name": "Anderson",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234806": {
    "id": "item_30453",
    "Last Name": "namthong",
    "First Name": "Supachai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234835": {
    "id": "item_13431",
    "Last Name": "Mudie",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234862": {
    "id": "item_5572",
    "Last Name": "Vidler",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234891": {
    "id": "item_17984",
    "Last Name": "Dunster",
    "First Name": "Millie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234908": {
    "id": "item_5570",
    "Last Name": "moyse",
    "First Name": "Dion",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234911": {
    "id": "item_2866",
    "Last Name": "Vu",
    "First Name": "Thi Thu Hong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235045": {
    "id": "item_2864",
    "Last Name": "Qin",
    "First Name": "Dongjiang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235077": {
    "id": "item_13425",
    "Last Name": "Virk",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235145": {
    "id": "item_17981",
    "Last Name": "Tang",
    "First Name": "Jianzhen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235178": {
    "id": "item_17979",
    "Last Name": "Hassoon",
    "First Name": "Walid",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235226": {
    "id": "item_28388",
    "Last Name": "Lee",
    "First Name": "Cheuk Lun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235244": {
    "id": "item_2861",
    "Last Name": "Howell",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235280": {
    "id": "item_2860",
    "Last Name": "meoni",
    "First Name": "daniele",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235322": {
    "id": "item_17975",
    "Last Name": "Margaret",
    "First Name": "Dame Rosaline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235324": {
    "id": "item_17974",
    "Last Name": "KO",
    "First Name": "Po LUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235325": {
    "id": "item_2859",
    "Last Name": "Dwyer",
    "First Name": "Serena",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235335": {
    "id": "item_30448",
    "Last Name": "LAU",
    "First Name": "HON WAI BRIAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235341": {
    "id": "item_13977",
    "Last Name": "Farquhar",
    "First Name": "Keith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235356": {
    "id": "item_30449",
    "Last Name": "Kaminski",
    "First Name": "Lori",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235359": {
    "id": "item_17972",
    "Last Name": "Fung",
    "First Name": "Pui Sze",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235428": {
    "id": "item_16108",
    "Last Name": "hsu",
    "First Name": "huiting",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235448": {
    "id": "item_30447",
    "Last Name": "banuelos",
    "First Name": "lloyd edsel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235464": {
    "id": "item_1373",
    "Last Name": "Chen",
    "First Name": "Junyu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235465": {
    "id": "item_28385",
    "Last Name": "Abog",
    "First Name": "Mark James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235474": {
    "id": "item_952",
    "Last Name": "McCarthy",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235496": {
    "id": "item_28384",
    "Last Name": "Furuhata",
    "First Name": "Mako",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235634": {
    "id": "item_16105",
    "Last Name": "Hoppenheit",
    "First Name": "Pia Rebecca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235645": {
    "id": "item_28383",
    "Last Name": "CHOE",
    "First Name": "ERIC",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235706": {
    "id": "item_948",
    "Last Name": "WASUNUN",
    "First Name": "PATTAMA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235849": {
    "id": "item_30441",
    "Last Name": "Reynolds",
    "First Name": "Ava",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235861": {
    "id": "item_28379",
    "Last Name": "Rambala",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235920": {
    "id": "item_28380",
    "Last Name": "Luxford",
    "First Name": "Ava",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235934": {
    "id": "item_16307",
    "Last Name": "Cho",
    "First Name": "Daekeun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235986": {
    "id": "item_2854",
    "Last Name": "Melara",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236065": {
    "id": "item_5560",
    "Last Name": "Dono",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236088": {
    "id": "item_16104",
    "Last Name": "Power",
    "First Name": "Anita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236137": {
    "id": "item_947",
    "Last Name": "Chui",
    "First Name": "Tony Ka Tung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236139": {
    "id": "item_28378",
    "Last Name": "Zhu",
    "First Name": "Candice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236187": {
    "id": "item_28376",
    "Last Name": "Rosi",
    "First Name": "Fahror",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236255": {
    "id": "item_17955",
    "Last Name": "Mackaness",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236321": {
    "id": "item_30436",
    "Last Name": "Osipova",
    "First Name": "Olya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236344": {
    "id": "item_5555",
    "Last Name": "yang",
    "First Name": "hsi chuan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236351": {
    "id": "item_28374",
    "Last Name": "Deane",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236389": {
    "id": "item_28373",
    "Last Name": "WANG",
    "First Name": "YANG KAI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236537": {
    "id": "item_17951",
    "Last Name": "saut",
    "First Name": "jerson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236925": {
    "id": "item_2849",
    "Last Name": "LAI",
    "First Name": "CHI WAI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236978": {
    "id": "item_945",
    "Last Name": "farnham",
    "First Name": "harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37237000": {
    "id": "item_17947",
    "Last Name": "Shim",
    "First Name": "JeongYun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37237097": {
    "id": "item_5547",
    "Last Name": "Mure",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37237168": {
    "id": "item_5546",
    "Last Name": "Lay",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37237184": {
    "id": "item_17944",
    "Last Name": "Fontaine",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37237215": {
    "id": "item_5544",
    "Last Name": "Aramburo Dartiguez",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239147": {
    "id": "item_5543",
    "Last Name": "Gomez",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239310": {
    "id": "item_2847",
    "Last Name": "Semerenko",
    "First Name": "Dmytro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239613": {
    "id": "item_2846",
    "Last Name": "Fuentes",
    "First Name": "Hector",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239640": {
    "id": "item_30430",
    "Last Name": "AlSarraf",
    "First Name": "Khaled",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239716": {
    "id": "item_943",
    "Last Name": "Martinez Guzman",
    "First Name": "Abraham Rafael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239800": {
    "id": "item_17939",
    "Last Name": "Hanna",
    "First Name": "Anita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239827": {
    "id": "item_17938",
    "Last Name": "chong",
    "First Name": "cherrie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239967": {
    "id": "item_30429",
    "Last Name": "Smith",
    "First Name": "Beth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239982": {
    "id": "item_30428",
    "Last Name": "Bobbybuana",
    "First Name": "Ahmad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240202": {
    "id": "item_5529",
    "Last Name": "Dillow",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240269": {
    "id": "item_17934",
    "Last Name": "Wopat",
    "First Name": "K.K.",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240440": {
    "id": "item_28365",
    "Last Name": "Konrad",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240544": {
    "id": "item_2845",
    "Last Name": "Lawrence",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240831": {
    "id": "item_5524",
    "Last Name": "liao",
    "First Name": "gang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240978": {
    "id": "item_17931",
    "Last Name": "Nibbs",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241206": {
    "id": "item_17929",
    "Last Name": "Lee",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241230": {
    "id": "item_17926",
    "Last Name": "Liu",
    "First Name": "Guorui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241321": {
    "id": "item_939",
    "Last Name": "Thomas",
    "First Name": "Mary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241447": {
    "id": "item_28863",
    "Last Name": "Crowley",
    "First Name": "Madalyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241671": {
    "id": "item_13406",
    "Last Name": "Frampton",
    "First Name": "Mish",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241804": {
    "id": "item_938",
    "Last Name": "Davis",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241851": {
    "id": "item_17921",
    "Last Name": "Madsen",
    "First Name": "Lars Kristian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241916": {
    "id": "item_5516",
    "Last Name": "MEZA",
    "First Name": "JUAN CARLOS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241978": {
    "id": "item_30420",
    "Last Name": "Nguyen",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242196": {
    "id": "item_5514",
    "Last Name": "Edrington",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242323": {
    "id": "item_17919",
    "Last Name": "Kraushar",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242763": {
    "id": "item_17914",
    "Last Name": "Raj",
    "First Name": "Karthik",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242989": {
    "id": "item_13401",
    "Last Name": "Dye",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243128": {
    "id": "item_30417",
    "Last Name": "Hugh-Fong",
    "First Name": "Lesley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243368": {
    "id": "item_934",
    "Last Name": "Mortenson",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243567": {
    "id": "item_17913",
    "Last Name": "Barrett",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243686": {
    "id": "item_17911",
    "Last Name": "Morrow",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243695": {
    "id": "item_17910",
    "Last Name": "Meyer",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243808": {
    "id": "item_5505",
    "Last Name": "Urbanovski",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243819": {
    "id": "item_13976",
    "Last Name": "Nolan",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243846": {
    "id": "item_28825",
    "Last Name": "Haust",
    "First Name": "Wilhelm (Bill)",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243888": {
    "id": "item_17908",
    "Last Name": "Nonxuba",
    "First Name": "Sino",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244042": {
    "id": "item_13398",
    "Last Name": "Faraji",
    "First Name": "Eva",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244048": {
    "id": "item_13395",
    "Last Name": "Pieterse",
    "First Name": "Deon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244059": {
    "id": "item_26480",
    "Last Name": "Vercauteren",
    "First Name": "Lieve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244073": {
    "id": "item_16094",
    "Last Name": "McMahon",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244130": {
    "id": "item_13394",
    "Last Name": "Ward",
    "First Name": "Natalee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244133": {
    "id": "item_1415",
    "Last Name": "Fletcher",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244260": {
    "id": "item_28824",
    "Last Name": "Hwang",
    "First Name": "Suntae",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244296": {
    "id": "item_30413",
    "Last Name": "Ellis-Davies",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244330": {
    "id": "item_2836",
    "Last Name": "Munoz",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244423": {
    "id": "item_5502",
    "Last Name": "Falkenmire",
    "First Name": "Shayne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244434": {
    "id": "item_17903",
    "Last Name": "Aleksieva",
    "First Name": "Martina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244669": {
    "id": "item_16093",
    "Last Name": "Johnson",
    "First Name": "Athena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244774": {
    "id": "item_17898",
    "Last Name": "Negrin",
    "First Name": "Alejandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244917": {
    "id": "item_922",
    "Last Name": "Dewar",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244987": {
    "id": "item_30411",
    "Last Name": "Lee",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245019": {
    "id": "item_30408",
    "Last Name": "McAvoy",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245051": {
    "id": "item_17893",
    "Last Name": "Bielma",
    "First Name": "Paola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245052": {
    "id": "item_13389",
    "Last Name": "Beaton-Wells",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245115": {
    "id": "item_920",
    "Last Name": "Morrison",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245385": {
    "id": "item_5492",
    "Last Name": "MENEZES",
    "First Name": "JEFFERSON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245437": {
    "id": "item_2832",
    "Last Name": "Black",
    "First Name": "Janelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245490": {
    "id": "item_13387",
    "Last Name": "Metcalfe",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245495": {
    "id": "item_5491",
    "Last Name": "Sloan",
    "First Name": "Mary-Louise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245698": {
    "id": "item_919",
    "Last Name": "Sveen",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245815": {
    "id": "item_30406",
    "Last Name": "Oliver",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245832": {
    "id": "item_2828",
    "Last Name": "Melloy",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245843": {
    "id": "item_13383",
    "Last Name": "Zhao",
    "First Name": "Chongmin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245867": {
    "id": "item_916",
    "Last Name": "Watts",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245915": {
    "id": "item_13382",
    "Last Name": "Gonzalez",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245987": {
    "id": "item_17883",
    "Last Name": "Miller",
    "First Name": "Dirk",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246000": {
    "id": "item_13975",
    "Last Name": "Gani",
    "First Name": "Mikuni Safbrine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246042": {
    "id": "item_30405",
    "Last Name": "Freeman",
    "First Name": "Sheila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246104": {
    "id": "item_2827",
    "Last Name": "Baisden",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246115": {
    "id": "item_28347",
    "Last Name": "Sinsukporn",
    "First Name": "Pantila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246118": {
    "id": "item_16327",
    "Last Name": "Wu",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246119": {
    "id": "item_1414",
    "Last Name": "Chiang",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246129": {
    "id": "item_16734",
    "Last Name": "Nolan",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246185": {
    "id": "item_1413",
    "Last Name": "Wan",
    "First Name": "Frank",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246237": {
    "id": "item_1412",
    "Last Name": "Nguyen",
    "First Name": "Hoa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246355": {
    "id": "item_13376",
    "Last Name": "Girling",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246415": {
    "id": "item_13374",
    "Last Name": "Browning",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246422": {
    "id": "item_912",
    "Last Name": "O Callaghan",
    "First Name": "Donncha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246425": {
    "id": "item_2826",
    "Last Name": "Brammer",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246442": {
    "id": "item_13373",
    "Last Name": "Elix",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246472": {
    "id": "item_30403",
    "Last Name": "Gementiza",
    "First Name": "Daryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246510": {
    "id": "item_13372",
    "Last Name": "Obermiller",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246556": {
    "id": "item_13371",
    "Last Name": "Thompson",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246559": {
    "id": "item_28346",
    "Last Name": "Vogel",
    "First Name": "Anna Sophie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246675": {
    "id": "item_30400",
    "Last Name": "Lai",
    "First Name": "Chi Kin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246685": {
    "id": "item_909",
    "Last Name": "Davis",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246704": {
    "id": "item_17867",
    "Last Name": "Rosario",
    "First Name": "Jose",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246706": {
    "id": "item_17860",
    "Last Name": "Brodigan",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246724": {
    "id": "item_13370",
    "Last Name": "Mugavin",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246727": {
    "id": "item_5467",
    "Last Name": "Weewan",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246762": {
    "id": "item_17863",
    "Last Name": "Gibbeson",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246834": {
    "id": "item_17857",
    "Last Name": "McInney",
    "First Name": "Kent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246839": {
    "id": "item_17858",
    "Last Name": "Yap",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246917": {
    "id": "item_17856",
    "Last Name": "Wyndham-Kidd",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246973": {
    "id": "item_17853",
    "Last Name": "Batorijs",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247021": {
    "id": "item_28340",
    "Last Name": "Muyano",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247120": {
    "id": "item_17848",
    "Last Name": "Fleck",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247139": {
    "id": "item_5461",
    "Last Name": "Clark",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247167": {
    "id": "item_17846",
    "Last Name": "Fleck",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247181": {
    "id": "item_5458",
    "Last Name": "Saeteurn",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247276": {
    "id": "item_13366",
    "Last Name": "Sopena",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247291": {
    "id": "item_17844",
    "Last Name": "Thirumanjanam Ragavan",
    "First Name": "Raghu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247313": {
    "id": "item_908",
    "Last Name": "Johnston",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247410": {
    "id": "item_17842",
    "Last Name": "Gordon",
    "First Name": "Ned",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247484": {
    "id": "item_2821",
    "Last Name": "Miliovski",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247548": {
    "id": "item_17837",
    "Last Name": "Gupta",
    "First Name": "Sabyasachi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247575": {
    "id": "item_30392",
    "Last Name": "Delos Santos",
    "First Name": "Allan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247592": {
    "id": "item_17834",
    "Last Name": "Foudy",
    "First Name": "KATHERINE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247669": {
    "id": "item_13360",
    "Last Name": "Quinn",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247681": {
    "id": "item_30390",
    "Last Name": "Shyam",
    "First Name": "Sreesh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247692": {
    "id": "item_2819",
    "Last Name": "Kennedy",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247747": {
    "id": "item_17827",
    "Last Name": "Salvador",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247753": {
    "id": "item_17829",
    "Last Name": "Parrott",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247936": {
    "id": "item_30386",
    "Last Name": "Hollington",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248113": {
    "id": "item_903",
    "Last Name": "Vojinovic",
    "First Name": "Filip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248139": {
    "id": "item_17823",
    "Last Name": "Ko",
    "First Name": "LingTa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248166": {
    "id": "item_902",
    "Last Name": "Kennedy",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248318": {
    "id": "item_5445",
    "Last Name": "Garcia",
    "First Name": "Julio Cesar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248353": {
    "id": "item_28332",
    "Last Name": "Perkins",
    "First Name": "Crystal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248545": {
    "id": "item_5444",
    "Last Name": "Byrne",
    "First Name": "Jaz",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248606": {
    "id": "item_3247",
    "Last Name": "Downer",
    "First Name": "Corey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248609": {
    "id": "item_17818",
    "Last Name": "Gabb",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248610": {
    "id": "item_899",
    "Last Name": "Cheung",
    "First Name": "Suet Ying",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248611": {
    "id": "item_16084",
    "Last Name": "XIE",
    "First Name": "QING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248794": {
    "id": "item_17817",
    "Last Name": "Robinson",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248801": {
    "id": "item_5443",
    "Last Name": "Estrada Ocampo",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248829": {
    "id": "item_17815",
    "Last Name": "Davies",
    "First Name": "Bree",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248873": {
    "id": "item_28329",
    "Last Name": "Biason",
    "First Name": "Janelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248892": {
    "id": "item_13354",
    "Last Name": "Richards",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248926": {
    "id": "item_5441",
    "Last Name": "Carneiro da Silva",
    "First Name": "Adriano",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37249543": {
    "id": "item_17812",
    "Last Name": "Sharman",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251091": {
    "id": "item_2815",
    "Last Name": "Timbrell",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251255": {
    "id": "item_16083",
    "Last Name": "Daafous Villamar",
    "First Name": "Yasir",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251256": {
    "id": "item_17809",
    "Last Name": "O'Neill",
    "First Name": "mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251301": {
    "id": "item_16081",
    "Last Name": "Taylor",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251338": {
    "id": "item_13351",
    "Last Name": "Jewson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251372": {
    "id": "item_893",
    "Last Name": "Bell",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251427": {
    "id": "item_17804",
    "Last Name": "Williamson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251476": {
    "id": "item_28324",
    "Last Name": "Hernandez",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251527": {
    "id": "item_890",
    "Last Name": "Tupper-Creed",
    "First Name": "Darcy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251535": {
    "id": "item_30377",
    "Last Name": "Ashton",
    "First Name": "Mary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251557": {
    "id": "item_17801",
    "Last Name": "Osborne-Grinter",
    "First Name": "Maia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251596": {
    "id": "item_17797",
    "Last Name": "Matthews",
    "First Name": "Hazel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251620": {
    "id": "item_5429",
    "Last Name": "Bennett",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251659": {
    "id": "item_30374",
    "Last Name": "Liu",
    "First Name": "Ming",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251848": {
    "id": "item_13346",
    "Last Name": "Inall",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251864": {
    "id": "item_17791",
    "Last Name": "Milner",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251963": {
    "id": "item_5427",
    "Last Name": "Charlton",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251990": {
    "id": "item_28317",
    "Last Name": "LIONG",
    "First Name": "JENNY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251993": {
    "id": "item_887",
    "Last Name": "Kennedy",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252087": {
    "id": "item_5425",
    "Last Name": "Johnson",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252128": {
    "id": "item_5424",
    "Last Name": "Strickland",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252243": {
    "id": "item_2811",
    "Last Name": "Lukianenko",
    "First Name": "Mikhai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252313": {
    "id": "item_5419",
    "Last Name": "Sharma",
    "First Name": "Satyendra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252401": {
    "id": "item_886",
    "Last Name": "Rodriguez",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252426": {
    "id": "item_17788",
    "Last Name": "Clansky",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252430": {
    "id": "item_17787",
    "Last Name": "Tse",
    "First Name": "Kwan Hang Calvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252441": {
    "id": "item_17785",
    "Last Name": "Barry",
    "First Name": "Isobel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252490": {
    "id": "item_30368",
    "Last Name": "tirtana",
    "First Name": "wira",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252520": {
    "id": "item_5411",
    "Last Name": "Singh",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252557": {
    "id": "item_17780",
    "Last Name": "Fox",
    "First Name": "Archibald",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252592": {
    "id": "item_2809",
    "Last Name": "OHiggins",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252610": {
    "id": "item_16077",
    "Last Name": "Whitelam",
    "First Name": "Carrie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252640": {
    "id": "item_884",
    "Last Name": "Wilkinson",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252719": {
    "id": "item_5408",
    "Last Name": "Wan",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252744": {
    "id": "item_13337",
    "Last Name": "conde colin",
    "First Name": "adriana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252752": {
    "id": "item_28313",
    "Last Name": "Aton",
    "First Name": "Golda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252842": {
    "id": "item_30364",
    "Last Name": "Kamalesha",
    "First Name": "Gede",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252849": {
    "id": "item_17776",
    "Last Name": "Peck",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252910": {
    "id": "item_2807",
    "Last Name": "Ravbar",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252911": {
    "id": "item_17775",
    "Last Name": "Fearn-Wannan",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252939": {
    "id": "item_5405",
    "Last Name": "SHU",
    "First Name": "QIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253157": {
    "id": "item_881",
    "Last Name": "Leung",
    "First Name": "pui yin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253242": {
    "id": "item_17770",
    "Last Name": "Tay",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253434": {
    "id": "item_16076",
    "Last Name": "Zelaya Castro",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253476": {
    "id": "item_880",
    "Last Name": "King",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253490": {
    "id": "item_13333",
    "Last Name": "LIN",
    "First Name": "CYUN WUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253573": {
    "id": "item_17769",
    "Last Name": "Atsumi",
    "First Name": "Sachiko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253625": {
    "id": "item_879",
    "Last Name": "Thompson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253729": {
    "id": "item_17768",
    "Last Name": "CHAN",
    "First Name": "PARK HAY DAMIAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253850": {
    "id": "item_5399",
    "Last Name": "Shak",
    "First Name": "Melina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253876": {
    "id": "item_877",
    "Last Name": "Lees",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253939": {
    "id": "item_2803",
    "Last Name": "Driver",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253941": {
    "id": "item_13329",
    "Last Name": "Beasley",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253946": {
    "id": "item_31057",
    "Last Name": "SUDRAJAD",
    "First Name": "AGUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253999": {
    "id": "item_30359",
    "Last Name": "Tavornshevin",
    "First Name": "Komkrit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254044": {
    "id": "item_5395",
    "Last Name": "Horton",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254056": {
    "id": "item_5392",
    "Last Name": "Moore",
    "First Name": "Steven Gary Gainsford",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254057": {
    "id": "item_17762",
    "Last Name": "Slade",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254120": {
    "id": "item_30357",
    "Last Name": "Watt",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254164": {
    "id": "item_5389",
    "Last Name": "Markatos",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254193": {
    "id": "item_28302",
    "Last Name": "Balding",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254224": {
    "id": "item_5388",
    "Last Name": "Lilley",
    "First Name": "Cai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254236": {
    "id": "item_13326",
    "Last Name": "Muhammad K",
    "First Name": "Anees",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254251": {
    "id": "item_5385",
    "Last Name": "Williams",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254368": {
    "id": "item_13325",
    "Last Name": "Kao",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254512": {
    "id": "item_17751",
    "Last Name": "Garcia Martinez",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254570": {
    "id": "item_30354",
    "Last Name": "Taylor",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254589": {
    "id": "item_2800",
    "Last Name": "Parkin",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254605": {
    "id": "item_2799",
    "Last Name": "Fellowes",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254609": {
    "id": "item_17748",
    "Last Name": "Ibarra",
    "First Name": "Lesley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254642": {
    "id": "item_28300",
    "Last Name": "Swe",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254652": {
    "id": "item_17745",
    "Last Name": "Tan",
    "First Name": "KK",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254699": {
    "id": "item_30352",
    "Last Name": "Padilla",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254726": {
    "id": "item_30350",
    "Last Name": "Lucas",
    "First Name": "Kymberly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254736": {
    "id": "item_30349",
    "Last Name": "Tallon",
    "First Name": "Elissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254748": {
    "id": "item_5378",
    "Last Name": "Egan Martinez",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254853": {
    "id": "item_5377",
    "Last Name": "Cunningham",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254868": {
    "id": "item_5376",
    "Last Name": "NIGI",
    "First Name": "GIORGIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254884": {
    "id": "item_870",
    "Last Name": "NAMUGERA",
    "First Name": "RONALD",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254892": {
    "id": "item_2794",
    "Last Name": "CHUN",
    "First Name": "BONGWOO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254928": {
    "id": "item_17738",
    "Last Name": "McQuillan",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254930": {
    "id": "item_871",
    "Last Name": "Tolin",
    "First Name": "Ralph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254949": {
    "id": "item_28292",
    "Last Name": "Lee",
    "First Name": "Patricia Pei Voon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254988": {
    "id": "item_17736",
    "Last Name": "Reade",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254989": {
    "id": "item_17734",
    "Last Name": "Keeley",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254996": {
    "id": "item_5374",
    "Last Name": "Ma",
    "First Name": "Yuqing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255038": {
    "id": "item_17732",
    "Last Name": "WU",
    "First Name": "ZHIYI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255082": {
    "id": "item_17731",
    "Last Name": "Pasculado",
    "First Name": "Janice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255091": {
    "id": "item_17728",
    "Last Name": "Stephen",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255148": {
    "id": "item_16071",
    "Last Name": "Kenny",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255151": {
    "id": "item_5372",
    "Last Name": "Kakanoor",
    "First Name": "Rohit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255223": {
    "id": "item_17723",
    "Last Name": "Leak",
    "First Name": "Jaclyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255529": {
    "id": "item_2786",
    "Last Name": "Nugent",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255619": {
    "id": "item_16070",
    "Last Name": "Hee",
    "First Name": "Zach",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255749": {
    "id": "item_5366",
    "Last Name": "Ruiz",
    "First Name": "Kassandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255799": {
    "id": "item_2785",
    "Last Name": "ZHONG",
    "First Name": "RUIHUA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255803": {
    "id": "item_17716",
    "Last Name": "Soe Mya",
    "First Name": "Zain",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255813": {
    "id": "item_864",
    "Last Name": "Mutyaba",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255890": {
    "id": "item_17712",
    "Last Name": "Barton",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255967": {
    "id": "item_17710",
    "Last Name": "Yoo",
    "First Name": "Jimin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255994": {
    "id": "item_13308",
    "Last Name": "Hemarawong",
    "First Name": "Aomkaew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256033": {
    "id": "item_17709",
    "Last Name": "Kim",
    "First Name": "Youngeun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256089": {
    "id": "item_13306",
    "Last Name": "Cullen",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256104": {
    "id": "item_17707",
    "Last Name": "Lee",
    "First Name": "Donghoon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256116": {
    "id": "item_30337",
    "Last Name": "ANDIN",
    "First Name": "CECIL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256319": {
    "id": "item_30335",
    "Last Name": "CHEN",
    "First Name": "PEI-HSI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256368": {
    "id": "item_2783",
    "Last Name": "Srisomboon",
    "First Name": "Natanon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256416": {
    "id": "item_17702",
    "Last Name": "Paparo",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256421": {
    "id": "item_5358",
    "Last Name": "Scholes",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256451": {
    "id": "item_30331",
    "Last Name": "Clift",
    "First Name": "Jess",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256569": {
    "id": "item_17699",
    "Last Name": "Paradiso",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256652": {
    "id": "item_5354",
    "Last Name": "Lilburne",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256751": {
    "id": "item_13295",
    "Last Name": "Crowley",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256880": {
    "id": "item_17694",
    "Last Name": "Pratt",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256903": {
    "id": "item_13294",
    "Last Name": "Lantzke",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256962": {
    "id": "item_5351",
    "Last Name": "Catchpole",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257076": {
    "id": "item_17691",
    "Last Name": "Prados",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257101": {
    "id": "item_13293",
    "Last Name": "Kippax",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257114": {
    "id": "item_17688",
    "Last Name": "HAN",
    "First Name": "JINWOO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257172": {
    "id": "item_28283",
    "Last Name": "Nguyen",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257229": {
    "id": "item_17687",
    "Last Name": "KADIR IDRUS",
    "First Name": "ADINATA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257268": {
    "id": "item_30323",
    "Last Name": "Le",
    "First Name": "Duc",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257319": {
    "id": "item_5345",
    "Last Name": "Liao",
    "First Name": "Chen Chang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257430": {
    "id": "item_2780",
    "Last Name": "Zimmermann",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257432": {
    "id": "item_17680",
    "Last Name": "Dale",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257469": {
    "id": "item_13290",
    "Last Name": "Xanthos",
    "First Name": "Elias",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257474": {
    "id": "item_2779",
    "Last Name": "Hutchinson",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257589": {
    "id": "item_16065",
    "Last Name": "Hamlet",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257783": {
    "id": "item_854",
    "Last Name": "Kwong",
    "First Name": "Paul Kin Yip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257828": {
    "id": "item_26479",
    "Last Name": "Couture",
    "First Name": "Stephan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257856": {
    "id": "item_17671",
    "Last Name": "Clarke",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257938": {
    "id": "item_17668",
    "Last Name": "Jones",
    "First Name": "Meg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257946": {
    "id": "item_17669",
    "Last Name": "Manka",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258043": {
    "id": "item_850",
    "Last Name": "Taylor",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258088": {
    "id": "item_30317",
    "Last Name": "Kitisopakul",
    "First Name": "Chupong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258125": {
    "id": "item_16063",
    "Last Name": "Asuncion",
    "First Name": "Levi Laurence",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258156": {
    "id": "item_17661",
    "Last Name": "Enright",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258182": {
    "id": "item_3246",
    "Last Name": "Flanagan",
    "First Name": "Bill",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258192": {
    "id": "item_2775",
    "Last Name": "Boers",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258193": {
    "id": "item_17657",
    "Last Name": "Siqueira",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258206": {
    "id": "item_2774",
    "Last Name": "Silva",
    "First Name": "LŽnia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258212": {
    "id": "item_17656",
    "Last Name": "Kalach Mussali",
    "First Name": "Alberto Jaime",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258418": {
    "id": "item_17652",
    "Last Name": "Bradwell",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258527": {
    "id": "item_3245",
    "Last Name": "ROMERO",
    "First Name": "SEBASTIAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258541": {
    "id": "item_28274",
    "Last Name": "Khitrov",
    "First Name": "Dmitri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258566": {
    "id": "item_847",
    "Last Name": "Gray",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258577": {
    "id": "item_16062",
    "Last Name": "Kuo",
    "First Name": "Fang-chi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258599": {
    "id": "item_2771",
    "Last Name": "Chen",
    "First Name": "Ray",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258644": {
    "id": "item_16061",
    "Last Name": "CHUNG",
    "First Name": "SHIH-YU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258656": {
    "id": "item_2770",
    "Last Name": "Collier",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258713": {
    "id": "item_844",
    "Last Name": "Palman",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258718": {
    "id": "item_30311",
    "Last Name": "Zeng",
    "First Name": "Tao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258737": {
    "id": "item_5323",
    "Last Name": "Durand",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258749": {
    "id": "item_28270",
    "Last Name": "Dachraksa",
    "First Name": "Chusak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258760": {
    "id": "item_28271",
    "Last Name": "Cross",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258787": {
    "id": "item_30308",
    "Last Name": "Tasker",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258937": {
    "id": "item_13277",
    "Last Name": "Schenk",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258952": {
    "id": "item_17644",
    "Last Name": "Imai",
    "First Name": "Erina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258975": {
    "id": "item_30305",
    "Last Name": "Blackwell",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258983": {
    "id": "item_17642",
    "Last Name": "Condon",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259043": {
    "id": "item_17641",
    "Last Name": "Chang",
    "First Name": "Min Luen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259055": {
    "id": "item_5318",
    "Last Name": "Klink",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259076": {
    "id": "item_5315",
    "Last Name": "Kaya",
    "First Name": "Ahmet Turan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259111": {
    "id": "item_17638",
    "Last Name": "Cullen",
    "First Name": "Jon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259263": {
    "id": "item_2767",
    "Last Name": "ZHANG",
    "First Name": "ZHUOQI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259358": {
    "id": "item_17637",
    "Last Name": "Olsen",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259380": {
    "id": "item_540",
    "Last Name": "violante",
    "First Name": "victor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259416": {
    "id": "item_840",
    "Last Name": "SIM",
    "First Name": "JAAN YEU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259421": {
    "id": "item_28266",
    "Last Name": "ivanovski",
    "First Name": "lidija",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259519": {
    "id": "item_839",
    "Last Name": "Fisseha",
    "First Name": "Girum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259577": {
    "id": "item_5310",
    "Last Name": "Tigre",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259599": {
    "id": "item_17631",
    "Last Name": "Kamoshita",
    "First Name": "Yuichi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259649": {
    "id": "item_2766",
    "Last Name": "De Cinque",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259652": {
    "id": "item_13271",
    "Last Name": "Ryan",
    "First Name": "Rory",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259684": {
    "id": "item_17629",
    "Last Name": "CHO",
    "First Name": "HYELIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259714": {
    "id": "item_2765",
    "Last Name": "Gutierrez Pantoja",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259719": {
    "id": "item_5305",
    "Last Name": "BACHOK",
    "First Name": "MOHD BAZLI BIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259755": {
    "id": "item_5306",
    "Last Name": "Krysiak",
    "First Name": "Krzysztof",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259985": {
    "id": "item_30300",
    "Last Name": "Chan",
    "First Name": "Winson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259997": {
    "id": "item_17625",
    "Last Name": "Gara",
    "First Name": "Kieren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260019": {
    "id": "item_17624",
    "Last Name": "Fafian",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260087": {
    "id": "item_13268",
    "Last Name": "Murray-Smith",
    "First Name": "Paige",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260106": {
    "id": "item_5302",
    "Last Name": "Susanto",
    "First Name": "Arnold",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260179": {
    "id": "item_5301",
    "Last Name": "LAI",
    "First Name": "PO-TING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260349": {
    "id": "item_17619",
    "Last Name": "Jun",
    "First Name": "Liu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260528": {
    "id": "item_30294",
    "Last Name": "Mori",
    "First Name": "Debora",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260538": {
    "id": "item_13265",
    "Last Name": "Pichardo",
    "First Name": "Ana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260564": {
    "id": "item_28261",
    "Last Name": "Gigje",
    "First Name": "Gerry Paolo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260613": {
    "id": "item_14024",
    "Last Name": "Barp",
    "First Name": "Fabio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260673": {
    "id": "item_30292",
    "Last Name": "Tsui",
    "First Name": "Chin Meng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260717": {
    "id": "item_13263",
    "Last Name": "Yi",
    "First Name": "Zheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260836": {
    "id": "item_837",
    "Last Name": "Lunsford",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260911": {
    "id": "item_30289",
    "Last Name": "AU",
    "First Name": "CHING YIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260919": {
    "id": "item_13261",
    "Last Name": "Solano",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261008": {
    "id": "item_30286",
    "Last Name": "PUN",
    "First Name": "HO YAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261014": {
    "id": "item_17609",
    "Last Name": "LAW",
    "First Name": "FONG YUEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261047": {
    "id": "item_1411",
    "Last Name": "ZHANG",
    "First Name": "JIE HONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261119": {
    "id": "item_13260",
    "Last Name": "Ruemhiranwong",
    "First Name": "Tul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261388": {
    "id": "item_5294",
    "Last Name": "Raduto",
    "First Name": "Michailas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261391": {
    "id": "item_17605",
    "Last Name": "LEUNG",
    "First Name": "HIU YEE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261456": {
    "id": "item_28256",
    "Last Name": "Chou",
    "First Name": "Ming Lun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261484": {
    "id": "item_5292",
    "Last Name": "Fang",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261512": {
    "id": "item_30285",
    "Last Name": "Roux",
    "First Name": "Mathieu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261566": {
    "id": "item_13257",
    "Last Name": "Chacha",
    "First Name": "Moises",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261780": {
    "id": "item_17602",
    "Last Name": "Tague",
    "First Name": "Josie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37262036": {
    "id": "item_5287",
    "Last Name": "Martin",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37262138": {
    "id": "item_13256",
    "Last Name": "Smith",
    "First Name": "Keeley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37268739": {
    "id": "item_13255",
    "Last Name": "Alonso Qui–ones",
    "First Name": "Gerardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37268805": {
    "id": "item_28249",
    "Last Name": "Miranda",
    "First Name": "Armando",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37275378": {
    "id": "item_2760",
    "Last Name": "Metlitzky",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37275380": {
    "id": "item_830",
    "Last Name": "Chesky",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37275450": {
    "id": "item_17594",
    "Last Name": "Soran",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37277238": {
    "id": "item_14023",
    "Last Name": "BAPTISTA DUBEUX JUNIOR",
    "First Name": "ROBERTO JOSE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37280317": {
    "id": "item_30282",
    "Last Name": "Rao",
    "First Name": "Prithvi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37284972": {
    "id": "item_3244",
    "Last Name": "Zheng",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37285004": {
    "id": "item_28242",
    "Last Name": "LOPEZ",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287026": {
    "id": "item_16049",
    "Last Name": "Benitez",
    "First Name": "Kaitlyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287254": {
    "id": "item_2757",
    "Last Name": "Kuo",
    "First Name": "Ching",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287300": {
    "id": "item_17585",
    "Last Name": "Mak",
    "First Name": "Franco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287745": {
    "id": "item_5284",
    "Last Name": "Sauve",
    "First Name": "Erica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287752": {
    "id": "item_17582",
    "Last Name": "Novillo Jr.",
    "First Name": "Romulo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287786": {
    "id": "item_16306",
    "Last Name": "Tripathi",
    "First Name": "Deepak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287865": {
    "id": "item_2756",
    "Last Name": "Yesgat",
    "First Name": "Abraham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287936": {
    "id": "item_5282",
    "Last Name": "Munene",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288055": {
    "id": "item_17577",
    "Last Name": "Reeves",
    "First Name": "Harvey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288107": {
    "id": "item_5280",
    "Last Name": "Ulaszek",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288170": {
    "id": "item_1410",
    "Last Name": "Rodoreda",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288212": {
    "id": "item_17572",
    "Last Name": "MOLINA SECHEL",
    "First Name": "CLAUDIO DAVID",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288234": {
    "id": "item_26478",
    "Last Name": "Glover",
    "First Name": "Sachiko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288327": {
    "id": "item_30275",
    "Last Name": "Miller",
    "First Name": "Alana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288420": {
    "id": "item_16048",
    "Last Name": "Thomas",
    "First Name": "Leah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288446": {
    "id": "item_14022",
    "Last Name": "Tistelberg",
    "First Name": "�ke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288490": {
    "id": "item_30271",
    "Last Name": "Tucay",
    "First Name": "Rodino",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288527": {
    "id": "item_30272",
    "Last Name": "Gorska",
    "First Name": "Patrycja",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288565": {
    "id": "item_16047",
    "Last Name": "Vailloud",
    "First Name": "Jean-Marie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288640": {
    "id": "item_30269",
    "Last Name": "Mahn",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288665": {
    "id": "item_823",
    "Last Name": "Solverson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288946": {
    "id": "item_822",
    "Last Name": "Li",
    "First Name": "Handong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288949": {
    "id": "item_2752",
    "Last Name": "Neselu",
    "First Name": "Kasahun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288963": {
    "id": "item_30266",
    "Last Name": "Tasker",
    "First Name": "Brad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288970": {
    "id": "item_13238",
    "Last Name": "Coleman",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289012": {
    "id": "item_13237",
    "Last Name": "Cronin",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289064": {
    "id": "item_821",
    "Last Name": "Moore",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289175": {
    "id": "item_820",
    "Last Name": "Jung",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289225": {
    "id": "item_17561",
    "Last Name": "Liu",
    "First Name": "Beverly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289293": {
    "id": "item_5268",
    "Last Name": "McSharry",
    "First Name": "Cathal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289312": {
    "id": "item_13235",
    "Last Name": "Juliatti",
    "First Name": "Thiago",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289355": {
    "id": "item_14021",
    "Last Name": "Tayob",
    "First Name": "Khabir",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289367": {
    "id": "item_5266",
    "Last Name": "Arnoni",
    "First Name": "Aryel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289375": {
    "id": "item_5265",
    "Last Name": "Aksoy",
    "First Name": "Numan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289396": {
    "id": "item_818",
    "Last Name": "Warren",
    "First Name": "Nate",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289445": {
    "id": "item_5263",
    "Last Name": "Zoukhri",
    "First Name": "Julia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289480": {
    "id": "item_5259",
    "Last Name": "RIVERA",
    "First Name": "MARIA FERNANDA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289506": {
    "id": "item_5261",
    "Last Name": "Rapetti",
    "First Name": "Cristiano",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289527": {
    "id": "item_17556",
    "Last Name": "Murphy",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289597": {
    "id": "item_13229",
    "Last Name": "Taylor",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289604": {
    "id": "item_13230",
    "Last Name": "Barry",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289742": {
    "id": "item_5257",
    "Last Name": "Ritzert",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289745": {
    "id": "item_13228",
    "Last Name": "Hahofer",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289818": {
    "id": "item_28862",
    "Last Name": "Alvarado Hernandez",
    "First Name": "Luis Manuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289835": {
    "id": "item_16043",
    "Last Name": "Martinez Zayas",
    "First Name": "Irma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289894": {
    "id": "item_2746",
    "Last Name": "Nicholson",
    "First Name": "Keren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290023": {
    "id": "item_13227",
    "Last Name": "GUERRERO ROMERO",
    "First Name": "KAREN I",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290088": {
    "id": "item_28230",
    "Last Name": "Kim",
    "First Name": "Alyssa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290103": {
    "id": "item_13226",
    "Last Name": "Komisarz",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290170": {
    "id": "item_17544",
    "Last Name": "Burton",
    "First Name": "Felissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290218": {
    "id": "item_28229",
    "Last Name": "Lema",
    "First Name": "Marquito",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290246": {
    "id": "item_17542",
    "Last Name": "Casey",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290366": {
    "id": "item_13221",
    "Last Name": "Hamar",
    "First Name": "Dusan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290390": {
    "id": "item_30259",
    "Last Name": "Ibale",
    "First Name": "Jarell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290449": {
    "id": "item_28227",
    "Last Name": "Glendenning",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290479": {
    "id": "item_5248",
    "Last Name": "Chuc",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290497": {
    "id": "item_5251",
    "Last Name": "Forster",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290507": {
    "id": "item_26477",
    "Last Name": "Rane",
    "First Name": "Suyash",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290617": {
    "id": "item_31067",
    "Last Name": "Swietochowski",
    "First Name": "Konrad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290651": {
    "id": "item_28226",
    "Last Name": "Ali",
    "First Name": "Fahad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290656": {
    "id": "item_13217",
    "Last Name": "Kleban",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290736": {
    "id": "item_28823",
    "Last Name": "GUANDIQUE",
    "First Name": "RINA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290770": {
    "id": "item_17527",
    "Last Name": "Stevens",
    "First Name": "Clark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290788": {
    "id": "item_815",
    "Last Name": "Giraudo",
    "First Name": "Ludovico",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290805": {
    "id": "item_28225",
    "Last Name": "Spratt",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290920": {
    "id": "item_2741",
    "Last Name": "McKinnon",
    "First Name": "Leish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290937": {
    "id": "item_13212",
    "Last Name": "Thompson",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290964": {
    "id": "item_2740",
    "Last Name": "Simpson",
    "First Name": "Lloyd",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291162": {
    "id": "item_5244",
    "Last Name": "Salinas",
    "First Name": "Jjunry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291242": {
    "id": "item_30251",
    "Last Name": "Webster",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291314": {
    "id": "item_17524",
    "Last Name": "Lawton",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291325": {
    "id": "item_5241",
    "Last Name": "Carigma",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291335": {
    "id": "item_30248",
    "Last Name": "Kaewkanittharak",
    "First Name": "Sittipong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291455": {
    "id": "item_17520",
    "Last Name": "Purser",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291471": {
    "id": "item_17517",
    "Last Name": "Gomez Gutierrez",
    "First Name": "Ruben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291592": {
    "id": "item_5240",
    "Last Name": "Zarate Garza",
    "First Name": "Gustavo Fernando",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291706": {
    "id": "item_812",
    "Last Name": "Obed",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291804": {
    "id": "item_30245",
    "Last Name": "Myers",
    "First Name": "Kendra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292017": {
    "id": "item_13974",
    "Last Name": "Shown",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292028": {
    "id": "item_16042",
    "Last Name": "Ireland",
    "First Name": "Wade",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292157": {
    "id": "item_28216",
    "Last Name": "Hing",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292203": {
    "id": "item_2731",
    "Last Name": "Darroch",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292308": {
    "id": "item_17504",
    "Last Name": "GAO",
    "First Name": "HONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292326": {
    "id": "item_17505",
    "Last Name": "McGarvey",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292337": {
    "id": "item_28214",
    "Last Name": "Rioux",
    "First Name": "Charles-Alexandre",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292394": {
    "id": "item_5227",
    "Last Name": "Mooney",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292397": {
    "id": "item_17503",
    "Last Name": "Lawton",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292426": {
    "id": "item_806",
    "Last Name": "Crawley",
    "First Name": "Sheena",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292479": {
    "id": "item_5226",
    "Last Name": "Tan",
    "First Name": "Kok Siong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292499": {
    "id": "item_803",
    "Last Name": "Kirchner",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292555": {
    "id": "item_17497",
    "Last Name": "Phinney",
    "First Name": "Emilie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292575": {
    "id": "item_17496",
    "Last Name": "Elster",
    "First Name": "Esther",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292578": {
    "id": "item_28213",
    "Last Name": "Craft",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292608": {
    "id": "item_5223",
    "Last Name": "Wall",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292733": {
    "id": "item_13202",
    "Last Name": "Younger",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292751": {
    "id": "item_30236",
    "Last Name": "Ching",
    "First Name": "King",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292793": {
    "id": "item_13198",
    "Last Name": "ZHANG",
    "First Name": "LIANG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292794": {
    "id": "item_28212",
    "Last Name": "HUANGFU",
    "First Name": "SONGMEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292799": {
    "id": "item_798",
    "Last Name": "Cui",
    "First Name": "Jin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292802": {
    "id": "item_1409",
    "Last Name": "Yu",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293017": {
    "id": "item_28211",
    "Last Name": "nguyen",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293103": {
    "id": "item_17487",
    "Last Name": "Ramirez Barrales",
    "First Name": "Christian Eduardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293122": {
    "id": "item_5216",
    "Last Name": "Matsuda",
    "First Name": "Kohei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293368": {
    "id": "item_17483",
    "Last Name": "O'Sullivan",
    "First Name": "Sofia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293418": {
    "id": "item_5214",
    "Last Name": "Kobayashi",
    "First Name": "Takumi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293427": {
    "id": "item_17482",
    "Last Name": "Lee",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293444": {
    "id": "item_17481",
    "Last Name": "Muroi",
    "First Name": "Millie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293452": {
    "id": "item_30229",
    "Last Name": "LO",
    "First Name": "PUI SHAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293490": {
    "id": "item_17479",
    "Last Name": "Lockwood",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293615": {
    "id": "item_30228",
    "Last Name": "Preston",
    "First Name": "Josh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293726": {
    "id": "item_13193",
    "Last Name": "Hordern",
    "First Name": "Janine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293780": {
    "id": "item_13190",
    "Last Name": "Bromley",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293788": {
    "id": "item_28207",
    "Last Name": "Uy",
    "First Name": "Paul Rainier",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293796": {
    "id": "item_2728",
    "Last Name": "Oh",
    "First Name": "Jungjin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293798": {
    "id": "item_28206",
    "Last Name": "Crilly",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293823": {
    "id": "item_13187",
    "Last Name": "Menday Lee",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293941": {
    "id": "item_13186",
    "Last Name": "Sehonamin",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293942": {
    "id": "item_31056",
    "Last Name": "Santillan",
    "First Name": "Joachim Mischa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294108": {
    "id": "item_17469",
    "Last Name": "Liu",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294152": {
    "id": "item_17471",
    "Last Name": "Avelino",
    "First Name": "Karmel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294166": {
    "id": "item_30224",
    "Last Name": "Langkarat",
    "First Name": "Jansuda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294313": {
    "id": "item_16037",
    "Last Name": "Chuang",
    "First Name": "Ming Jing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294319": {
    "id": "item_2724",
    "Last Name": "Stuart",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294337": {
    "id": "item_30222",
    "Last Name": "Buttfield",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294358": {
    "id": "item_790",
    "Last Name": "Tracy",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294391": {
    "id": "item_30221",
    "Last Name": "Park",
    "First Name": "Thur Mi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294403": {
    "id": "item_789",
    "Last Name": "LIM",
    "First Name": "YOUNG BIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294406": {
    "id": "item_5196",
    "Last Name": "Shu",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294413": {
    "id": "item_13184",
    "Last Name": "Ottenberg",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294455": {
    "id": "item_5194",
    "Last Name": "Wiersma",
    "First Name": "Jochum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294516": {
    "id": "item_30219",
    "Last Name": "Francis",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294519": {
    "id": "item_30217",
    "Last Name": "Varsani",
    "First Name": "Aashish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294561": {
    "id": "item_13183",
    "Last Name": "Attarha",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294578": {
    "id": "item_17460",
    "Last Name": "Mancini",
    "First Name": "Shelby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294678": {
    "id": "item_5191",
    "Last Name": "DAVIS",
    "First Name": "Wade",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294679": {
    "id": "item_787",
    "Last Name": "Hur",
    "First Name": "Beatrice",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294729": {
    "id": "item_5190",
    "Last Name": "Manchanda",
    "First Name": "Neelam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294793": {
    "id": "item_30215",
    "Last Name": "On",
    "First Name": "Mary Chiriqui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294816": {
    "id": "item_16034",
    "Last Name": "Mawby",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294895": {
    "id": "item_17456",
    "Last Name": "Andrae",
    "First Name": "Dana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294916": {
    "id": "item_30212",
    "Last Name": "le",
    "First Name": "manh hung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295034": {
    "id": "item_17455",
    "Last Name": "Nguyen",
    "First Name": "Thi Thuy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295035": {
    "id": "item_17457",
    "Last Name": "Chong",
    "First Name": "Hwa King",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295055": {
    "id": "item_30213",
    "Last Name": "Lee",
    "First Name": "Shiu Kin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295159": {
    "id": "item_1408",
    "Last Name": "Kim",
    "First Name": "Sungmin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295363": {
    "id": "item_17454",
    "Last Name": "Jordan",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295374": {
    "id": "item_13177",
    "Last Name": "Gregor",
    "First Name": "Erica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295377": {
    "id": "item_16032",
    "Last Name": "Carlyon",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295643": {
    "id": "item_13174",
    "Last Name": "Coggan",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295649": {
    "id": "item_17449",
    "Last Name": "Rodriguez",
    "First Name": "Nathalia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295713": {
    "id": "item_780",
    "Last Name": "Nolan",
    "First Name": "Pat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295738": {
    "id": "item_17445",
    "Last Name": "Noble",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295772": {
    "id": "item_2717",
    "Last Name": "Bento",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295804": {
    "id": "item_2716",
    "Last Name": "ZHANG",
    "First Name": "XIA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295808": {
    "id": "item_28191",
    "Last Name": "Shah",
    "First Name": "Pratik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295830": {
    "id": "item_5180",
    "Last Name": "Porta",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295870": {
    "id": "item_16031",
    "Last Name": "Gibson",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295902": {
    "id": "item_13170",
    "Last Name": "Maynard",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295911": {
    "id": "item_17441",
    "Last Name": "Lung",
    "First Name": "Yue Cheung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295914": {
    "id": "item_5175",
    "Last Name": "Camansag",
    "First Name": "Ronald Bryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295971": {
    "id": "item_17440",
    "Last Name": "Wisnal Sumardi",
    "First Name": "Defryanto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296025": {
    "id": "item_30208",
    "Last Name": "Moser",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296044": {
    "id": "item_4747",
    "Last Name": "Lee",
    "First Name": "Jiah Hao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296046": {
    "id": "item_5173",
    "Last Name": "Shi",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296160": {
    "id": "item_769",
    "Last Name": "Mansur Rassam",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296179": {
    "id": "item_768",
    "Last Name": "SHUILIANG",
    "First Name": "HUANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296203": {
    "id": "item_30205",
    "Last Name": "Patel",
    "First Name": "Sheryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296231": {
    "id": "item_5171",
    "Last Name": "Paredes",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296261": {
    "id": "item_28822",
    "Last Name": "Guerrero",
    "First Name": "Lauri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296269": {
    "id": "item_30204",
    "Last Name": "Kennedy",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296320": {
    "id": "item_17433",
    "Last Name": "Miller",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296541": {
    "id": "item_17430",
    "Last Name": "Fewtrell",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296548": {
    "id": "item_30203",
    "Last Name": "Baker",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296582": {
    "id": "item_17428",
    "Last Name": "Tong",
    "First Name": "Luoyi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296696": {
    "id": "item_13162",
    "Last Name": "Jaramillo Restrepo",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296752": {
    "id": "item_17425",
    "Last Name": "Ryoo",
    "First Name": "Jae Choon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296757": {
    "id": "item_13161",
    "Last Name": "Jackson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296842": {
    "id": "item_17424",
    "Last Name": "Min",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296961": {
    "id": "item_4748",
    "Last Name": "Cotterill",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297076": {
    "id": "item_2705",
    "Last Name": "Melville",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297084": {
    "id": "item_17423",
    "Last Name": "Benavides",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297216": {
    "id": "item_2707",
    "Last Name": "Ford",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297253": {
    "id": "item_16024",
    "Last Name": "Raso",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297323": {
    "id": "item_28185",
    "Last Name": "Wu",
    "First Name": "Kunfang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297348": {
    "id": "item_5157",
    "Last Name": "Foo",
    "First Name": "Yin Ho",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297353": {
    "id": "item_30197",
    "Last Name": "Mulhearn",
    "First Name": "Amie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297378": {
    "id": "item_17418",
    "Last Name": "CARRASCO",
    "First Name": "NADINE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297529": {
    "id": "item_765",
    "Last Name": "Triplett",
    "First Name": "Drew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297546": {
    "id": "item_17415",
    "Last Name": "Lunn",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297949": {
    "id": "item_2702",
    "Last Name": "Prieto",
    "First Name": "Guillermo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297973": {
    "id": "item_13973",
    "Last Name": "Wang",
    "First Name": "Jing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297982": {
    "id": "item_17413",
    "Last Name": "Kekre",
    "First Name": "Prachi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298009": {
    "id": "item_14020",
    "Last Name": "Rosenthal",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298025": {
    "id": "item_764",
    "Last Name": "Farrow",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298179": {
    "id": "item_17407",
    "Last Name": "McGarry",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298215": {
    "id": "item_13155",
    "Last Name": "Doan",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298258": {
    "id": "item_30187",
    "Last Name": "Tran",
    "First Name": "Maily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298283": {
    "id": "item_28180",
    "Last Name": "Valerio",
    "First Name": "Melecio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298326": {
    "id": "item_763",
    "Last Name": "Ma",
    "First Name": "Miles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298458": {
    "id": "item_17403",
    "Last Name": "Chaikornkij",
    "First Name": "Pavis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298627": {
    "id": "item_759",
    "Last Name": "Wilson",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298739": {
    "id": "item_2700",
    "Last Name": "Miletic",
    "First Name": "SinŽad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298804": {
    "id": "item_15919",
    "Last Name": "Nguyen",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298899": {
    "id": "item_28176",
    "Last Name": "SUN",
    "First Name": "JUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298909": {
    "id": "item_17395",
    "Last Name": "Avery",
    "First Name": "Caleb",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299026": {
    "id": "item_17394",
    "Last Name": "Ditchfield",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299077": {
    "id": "item_5144",
    "Last Name": "Henricks",
    "First Name": "Aub",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299184": {
    "id": "item_2697",
    "Last Name": "Wongsirikul",
    "First Name": "Sewee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299218": {
    "id": "item_16021",
    "Last Name": "Hur",
    "First Name": "Kunyoung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299336": {
    "id": "item_17390",
    "Last Name": "Mo",
    "First Name": "Hoi Lung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299556": {
    "id": "item_30182",
    "Last Name": "ITO",
    "First Name": "Hachidai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299578": {
    "id": "item_16020",
    "Last Name": "Egan",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299592": {
    "id": "item_17388",
    "Last Name": "Nguyen",
    "First Name": "Diamond",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299627": {
    "id": "item_2695",
    "Last Name": "Yau",
    "First Name": "Carmen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299648": {
    "id": "item_13051",
    "Last Name": "James",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299664": {
    "id": "item_17387",
    "Last Name": "Pulungan",
    "First Name": "Ardyan Winanshah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299724": {
    "id": "item_5135",
    "Last Name": "Zhao",
    "First Name": "Ning",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299738": {
    "id": "item_2692",
    "Last Name": "Cahill",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299762": {
    "id": "item_749",
    "Last Name": "Duff",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299776": {
    "id": "item_28170",
    "Last Name": "Bice",
    "First Name": "Jonalyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299827": {
    "id": "item_13151",
    "Last Name": "James",
    "First Name": "Hailey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299847": {
    "id": "item_5132",
    "Last Name": "Leckenby",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299851": {
    "id": "item_17379",
    "Last Name": "Connell",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299863": {
    "id": "item_28169",
    "Last Name": "Jantra",
    "First Name": "Jakkrit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299899": {
    "id": "item_748",
    "Last Name": "Frazier",
    "First Name": "Ken",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299915": {
    "id": "item_747",
    "Last Name": "Murdock",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299971": {
    "id": "item_16735",
    "Last Name": "Khuu",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300050": {
    "id": "item_25644",
    "Last Name": "Chequer-Edwards",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300158": {
    "id": "item_28167",
    "Last Name": "Chiu",
    "First Name": "Xenia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300188": {
    "id": "item_17373",
    "Last Name": "Sng",
    "First Name": "Hong Leng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300271": {
    "id": "item_16019",
    "Last Name": "Foxon",
    "First Name": "Radley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300279": {
    "id": "item_5124",
    "Last Name": "Mangani",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300289": {
    "id": "item_746",
    "Last Name": "Martin",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300330": {
    "id": "item_28165",
    "Last Name": "Wang",
    "First Name": "Zita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300436": {
    "id": "item_2689",
    "Last Name": "Siappas",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300456": {
    "id": "item_30165",
    "Last Name": "Jeanjaitrong",
    "First Name": "Nattapong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300534": {
    "id": "item_5121",
    "Last Name": "Kishauov",
    "First Name": "Abilkassym",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300579": {
    "id": "item_30164",
    "Last Name": "Kim",
    "First Name": "Sang Hwan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300595": {
    "id": "item_17364",
    "Last Name": "Crickmore",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300630": {
    "id": "item_2688",
    "Last Name": "Cheshire",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300694": {
    "id": "item_30163",
    "Last Name": "Kent",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300742": {
    "id": "item_17362",
    "Last Name": "Magee",
    "First Name": "Finley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300839": {
    "id": "item_17357",
    "Last Name": "Sharma",
    "First Name": "Sagar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300843": {
    "id": "item_17355",
    "Last Name": "Giannes",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300907": {
    "id": "item_2685",
    "Last Name": "OÕCallaghan",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300917": {
    "id": "item_28164",
    "Last Name": "Tran",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300941": {
    "id": "item_17353",
    "Last Name": "Gonzalez del Castillo Monroy",
    "First Name": "Paola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300992": {
    "id": "item_2683",
    "Last Name": "Vogt",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301028": {
    "id": "item_2681",
    "Last Name": "wan",
    "First Name": "meng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301031": {
    "id": "item_2682",
    "Last Name": "Szlicht",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301045": {
    "id": "item_17350",
    "Last Name": "Garland",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301058": {
    "id": "item_5115",
    "Last Name": "Uglow",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301082": {
    "id": "item_17351",
    "Last Name": "Donaldson",
    "First Name": "Rochelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301113": {
    "id": "item_737",
    "Last Name": "chanaiwa",
    "First Name": "kudzai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301155": {
    "id": "item_28161",
    "Last Name": "Buechi-Mbouwe",
    "First Name": "Laurianne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301257": {
    "id": "item_5112",
    "Last Name": "Yuan",
    "First Name": "LiangHua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301315": {
    "id": "item_17348",
    "Last Name": "Supreyaporn",
    "First Name": "Taweesak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301342": {
    "id": "item_735",
    "Last Name": "Giocondo",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301381": {
    "id": "item_2677",
    "Last Name": "tsai",
    "First Name": "yuehtinh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301429": {
    "id": "item_5110",
    "Last Name": "Allison",
    "First Name": "Larin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301522": {
    "id": "item_30157",
    "Last Name": "you",
    "First Name": "mi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301532": {
    "id": "item_17342",
    "Last Name": "Tandra",
    "First Name": "Hendra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301553": {
    "id": "item_17343",
    "Last Name": "Tian",
    "First Name": "Tian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301572": {
    "id": "item_30155",
    "Last Name": "Geli",
    "First Name": "Cheska Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301619": {
    "id": "item_17340",
    "Last Name": "Setyadi ramadhona",
    "First Name": "Ragil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301651": {
    "id": "item_5108",
    "Last Name": "Rushton",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301697": {
    "id": "item_28156",
    "Last Name": "Robertson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301706": {
    "id": "item_5105",
    "Last Name": "Eastoe",
    "First Name": "Julia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301713": {
    "id": "item_5103",
    "Last Name": "Cullum",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301718": {
    "id": "item_2674",
    "Last Name": "Evans",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301775": {
    "id": "item_5099",
    "Last Name": "Reed",
    "First Name": "Rich",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301776": {
    "id": "item_28154",
    "Last Name": "Surkis",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301792": {
    "id": "item_17330",
    "Last Name": "Cordoba Mena",
    "First Name": "Marilin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301809": {
    "id": "item_13145",
    "Last Name": "Yao",
    "First Name": "Axo Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301810": {
    "id": "item_17328",
    "Last Name": "Madrigal Garcia",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301812": {
    "id": "item_17329",
    "Last Name": "Ward",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301890": {
    "id": "item_730",
    "Last Name": "Wellenstein",
    "First Name": "Edmund",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301905": {
    "id": "item_17326",
    "Last Name": "Carlyon",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301917": {
    "id": "item_17325",
    "Last Name": "Chandler",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301927": {
    "id": "item_5095",
    "Last Name": "hill",
    "First Name": "thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301929": {
    "id": "item_28150",
    "Last Name": "Surkis",
    "First Name": "Roman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301955": {
    "id": "item_16305",
    "Last Name": "TSANG",
    "First Name": "TSZYAU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301975": {
    "id": "item_17323",
    "Last Name": "cho",
    "First Name": "sungjin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301993": {
    "id": "item_17321",
    "Last Name": "Chignardet",
    "First Name": "Oriana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302038": {
    "id": "item_13144",
    "Last Name": "Gray",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302046": {
    "id": "item_17317",
    "Last Name": "Lo Surdo",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302087": {
    "id": "item_28148",
    "Last Name": "Moran",
    "First Name": "Brrndon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302097": {
    "id": "item_5092",
    "Last Name": "McDonald",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302109": {
    "id": "item_17314",
    "Last Name": "Bayliss",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302158": {
    "id": "item_30150",
    "Last Name": "Meadowcroft",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302166": {
    "id": "item_30151",
    "Last Name": "MA",
    "First Name": "JIAJU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302189": {
    "id": "item_28145",
    "Last Name": "janetzki Janetzki",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302246": {
    "id": "item_30149",
    "Last Name": "Patel",
    "First Name": "Harsil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302255": {
    "id": "item_2670",
    "Last Name": "Roberts",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302271": {
    "id": "item_2669",
    "Last Name": "Zou",
    "First Name": "Roger",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302277": {
    "id": "item_2668",
    "Last Name": "Beach",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302297": {
    "id": "item_30145",
    "Last Name": "Agustika",
    "First Name": "Riki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302311": {
    "id": "item_722",
    "Last Name": "Rujak",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302315": {
    "id": "item_5087",
    "Last Name": "Mcmahon",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302341": {
    "id": "item_17299",
    "Last Name": "Braas",
    "First Name": "Dirk",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302343": {
    "id": "item_30144",
    "Last Name": "Fabila",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302429": {
    "id": "item_17294",
    "Last Name": "Garcia Rodriguez",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302460": {
    "id": "item_3243",
    "Last Name": "Ganter",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302613": {
    "id": "item_5080",
    "Last Name": "Taylor",
    "First Name": "Camden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302619": {
    "id": "item_26476",
    "Last Name": "Ghimire",
    "First Name": "Sujata",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302730": {
    "id": "item_5079",
    "Last Name": "McGrath",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302740": {
    "id": "item_17285",
    "Last Name": "Akeg",
    "First Name": "Rahma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302761": {
    "id": "item_5076",
    "Last Name": "Kennedy",
    "First Name": "Carl",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302762": {
    "id": "item_5078",
    "Last Name": "Nakkan",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302775": {
    "id": "item_28133",
    "Last Name": "Pryce",
    "First Name": "Mikaela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302778": {
    "id": "item_5075",
    "Last Name": "Lin",
    "First Name": "Chi Yen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302784": {
    "id": "item_30136",
    "Last Name": "Cockroft",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302789": {
    "id": "item_30135",
    "Last Name": "Rigby",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302818": {
    "id": "item_28129",
    "Last Name": "Tamsett",
    "First Name": "Zacchary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302837": {
    "id": "item_716",
    "Last Name": "Giddins",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302869": {
    "id": "item_30133",
    "Last Name": "Susilowati",
    "First Name": "Emi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302870": {
    "id": "item_28128",
    "Last Name": "Grieve",
    "First Name": "Shellie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302876": {
    "id": "item_5073",
    "Last Name": "CALLEJA PUEYO",
    "First Name": "PEDRO LUIS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302894": {
    "id": "item_5071",
    "Last Name": "De Wever",
    "First Name": "Nele",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302904": {
    "id": "item_13138",
    "Last Name": "Glazbrook",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302916": {
    "id": "item_2662",
    "Last Name": "Stuart-Grant",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302936": {
    "id": "item_17276",
    "Last Name": "Li",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302955": {
    "id": "item_13137",
    "Last Name": "Estanislao",
    "First Name": "Pedro Paolo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303085": {
    "id": "item_17275",
    "Last Name": "Tan",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303201": {
    "id": "item_5063",
    "Last Name": "Bohan",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303218": {
    "id": "item_17272",
    "Last Name": "Ernst",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303225": {
    "id": "item_2661",
    "Last Name": "Howden",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303251": {
    "id": "item_2660",
    "Last Name": "Phan",
    "First Name": "An",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303253": {
    "id": "item_17269",
    "Last Name": "Buttera",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303279": {
    "id": "item_26475",
    "Last Name": "Supyan",
    "First Name": "Ade",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303284": {
    "id": "item_13972",
    "Last Name": "LAM",
    "First Name": "WAI KIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303287": {
    "id": "item_3216",
    "Last Name": "Lipatov",
    "First Name": "Anton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303303": {
    "id": "item_28122",
    "Last Name": "MCEWEN",
    "First Name": "JUDE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303345": {
    "id": "item_17264",
    "Last Name": "Mulia",
    "First Name": "Ricki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303436": {
    "id": "item_17262",
    "Last Name": "Thurecht",
    "First Name": "Norman",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303461": {
    "id": "item_17260",
    "Last Name": "Thurecht",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303489": {
    "id": "item_17256",
    "Last Name": "Archagraisorn",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303545": {
    "id": "item_17255",
    "Last Name": "Bennett",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303548": {
    "id": "item_17254",
    "Last Name": "Nicholas",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303612": {
    "id": "item_28861",
    "Last Name": "LAN",
    "First Name": "YU-MIAO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303653": {
    "id": "item_17251",
    "Last Name": "Taylor",
    "First Name": "Kerri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303802": {
    "id": "item_17250",
    "Last Name": "McGee",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303835": {
    "id": "item_28821",
    "Last Name": "Lee",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303848": {
    "id": "item_30118",
    "Last Name": "Garlapati",
    "First Name": "Vishnu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303854": {
    "id": "item_30117",
    "Last Name": "Sunga",
    "First Name": "Jay-Pee Patao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303872": {
    "id": "item_17247",
    "Last Name": "Hoff",
    "First Name": "Anne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303884": {
    "id": "item_15993",
    "Last Name": "Comendador",
    "First Name": "Joel Marco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303898": {
    "id": "item_17243",
    "Last Name": "Ferguson",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303904": {
    "id": "item_17244",
    "Last Name": "Gearing",
    "First Name": "Jen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303992": {
    "id": "item_5049",
    "Last Name": "Lam",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304030": {
    "id": "item_5047",
    "Last Name": "Cooper",
    "First Name": "Oakley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304048": {
    "id": "item_17239",
    "Last Name": "Trueman",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304051": {
    "id": "item_17238",
    "Last Name": "Haley",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304262": {
    "id": "item_28111",
    "Last Name": "Saldivar",
    "First Name": "Jerrold",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304286": {
    "id": "item_5045",
    "Last Name": "Eichstaedt",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304370": {
    "id": "item_17234",
    "Last Name": "Hyndsman",
    "First Name": "Marc",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304372": {
    "id": "item_13130",
    "Last Name": "Diaz Quintana",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304396": {
    "id": "item_30113",
    "Last Name": "Popiolkiewicz",
    "First Name": "Victor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304424": {
    "id": "item_17233",
    "Last Name": "Kinhofer",
    "First Name": "Gianna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304679": {
    "id": "item_17229",
    "Last Name": "Anirudh",
    "First Name": "Vaishak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37305030": {
    "id": "item_2648",
    "Last Name": "Mellos Carlos",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37306635": {
    "id": "item_5041",
    "Last Name": "LAUTA",
    "First Name": "IEVGEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37306748": {
    "id": "item_26474",
    "Last Name": "Man",
    "First Name": "Chun Yin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37306834": {
    "id": "item_13127",
    "Last Name": "Griffiths",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307011": {
    "id": "item_15991",
    "Last Name": "Huang",
    "First Name": "Finna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307048": {
    "id": "item_5039",
    "Last Name": "Xing",
    "First Name": "Feifei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307097": {
    "id": "item_13126",
    "Last Name": "Severin",
    "First Name": "Brock",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307259": {
    "id": "item_17225",
    "Last Name": "Sanimthong",
    "First Name": "Apiwat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307389": {
    "id": "item_17221",
    "Last Name": "Siu",
    "First Name": "Chun Ki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307450": {
    "id": "item_17220",
    "Last Name": "Hoban",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307655": {
    "id": "item_30108",
    "Last Name": "Fong",
    "First Name": "Leung Yui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307691": {
    "id": "item_700",
    "Last Name": "Wilson",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307779": {
    "id": "item_2647",
    "Last Name": "Zhumakanov",
    "First Name": "Nikolay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37311128": {
    "id": "item_13122",
    "Last Name": "GUELMAN",
    "First Name": "DORON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37311510": {
    "id": "item_5038",
    "Last Name": "Chan",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37313423": {
    "id": "item_28105",
    "Last Name": "Edwards",
    "First Name": "Allison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37316842": {
    "id": "item_697",
    "Last Name": "Rietbrock",
    "First Name": "Philipp",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37317438": {
    "id": "item_28104",
    "Last Name": "Coutts",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37322672": {
    "id": "item_15989",
    "Last Name": "Iha",
    "First Name": "Jaeves",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37325023": {
    "id": "item_2645",
    "Last Name": "Norcross",
    "First Name": "Sydney",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37333302": {
    "id": "item_28101",
    "Last Name": "Suttisung",
    "First Name": "Sarawut",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37333313": {
    "id": "item_17213",
    "Last Name": "McDaniel",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37344575": {
    "id": "item_28099",
    "Last Name": "Kim",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37344608": {
    "id": "item_17212",
    "Last Name": "VILLAREAL",
    "First Name": "JESSIE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37344680": {
    "id": "item_17210",
    "Last Name": "Badenhorst",
    "First Name": "Hannes",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37351864": {
    "id": "item_5029",
    "Last Name": "Ma",
    "First Name": "Minglu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37351955": {
    "id": "item_30102",
    "Last Name": "Gabarczyk",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365283": {
    "id": "item_17206",
    "Last Name": "Simonton",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365421": {
    "id": "item_691",
    "Last Name": "Ji",
    "First Name": "Ya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365464": {
    "id": "item_28097",
    "Last Name": "Tirpak",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365513": {
    "id": "item_15987",
    "Last Name": "Martirez",
    "First Name": "Harieth Joy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365615": {
    "id": "item_5021",
    "Last Name": "Bayar",
    "First Name": "Myagmarsuren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365629": {
    "id": "item_30100",
    "Last Name": "Villanueva",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365630": {
    "id": "item_17202",
    "Last Name": "Attia",
    "First Name": "Nada",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365659": {
    "id": "item_5020",
    "Last Name": "Oakes",
    "First Name": "Colleen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365711": {
    "id": "item_28095",
    "Last Name": "Flanagan",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365749": {
    "id": "item_30099",
    "Last Name": "cefis",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365756": {
    "id": "item_2639",
    "Last Name": "Wilson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366182": {
    "id": "item_17194",
    "Last Name": "Altenhofen",
    "First Name": "Marjorye",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366345": {
    "id": "item_17192",
    "Last Name": "McGlone",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366373": {
    "id": "item_30098",
    "Last Name": "BERNALES",
    "First Name": "NOEL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366436": {
    "id": "item_5015",
    "Last Name": "Lemos Neto",
    "First Name": "Paulo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366476": {
    "id": "item_17190",
    "Last Name": "Beattie",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366587": {
    "id": "item_17187",
    "Last Name": "Kellock",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366660": {
    "id": "item_2637",
    "Last Name": "Ramsey",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366673": {
    "id": "item_14019",
    "Last Name": "Shilov",
    "First Name": "Aleksey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366708": {
    "id": "item_689",
    "Last Name": "Andrade",
    "First Name": "Lui",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366810": {
    "id": "item_5014",
    "Last Name": "West",
    "First Name": "Isa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366879": {
    "id": "item_17186",
    "Last Name": "Lowe",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366920": {
    "id": "item_13119",
    "Last Name": "Sergeant-Wood",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366953": {
    "id": "item_28820",
    "Last Name": "Lum Young",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367107": {
    "id": "item_28090",
    "Last Name": "Dhesi",
    "First Name": "Sukhi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367222": {
    "id": "item_17182",
    "Last Name": "Segura",
    "First Name": "Erik",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367365": {
    "id": "item_2635",
    "Last Name": "Morton",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367402": {
    "id": "item_5009",
    "Last Name": "Crowley",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367573": {
    "id": "item_13117",
    "Last Name": "Gibbins",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367680": {
    "id": "item_13118",
    "Last Name": "He",
    "First Name": "Jian Gang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367734": {
    "id": "item_687",
    "Last Name": "Lam",
    "First Name": "Christina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367908": {
    "id": "item_2634",
    "Last Name": "Smith",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367919": {
    "id": "item_5007",
    "Last Name": "Mazzarolo",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367945": {
    "id": "item_30089",
    "Last Name": "Martin",
    "First Name": "Philio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368002": {
    "id": "item_13116",
    "Last Name": "Mendoza",
    "First Name": "Angelica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368176": {
    "id": "item_28086",
    "Last Name": "Lymer",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368254": {
    "id": "item_685",
    "Last Name": "Samsoniuk",
    "First Name": "Yurii",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368263": {
    "id": "item_28085",
    "Last Name": "hoffman",
    "First Name": "Kelly Anne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368284": {
    "id": "item_5003",
    "Last Name": "Ciciliano",
    "First Name": "Gerald",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368376": {
    "id": "item_13113",
    "Last Name": "ren",
    "First Name": "yudong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368387": {
    "id": "item_28084",
    "Last Name": "Pedrozo",
    "First Name": "Raimundo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368469": {
    "id": "item_17171",
    "Last Name": "Pendleton",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368538": {
    "id": "item_17167",
    "Last Name": "Gogoski",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368625": {
    "id": "item_30081",
    "Last Name": "Esquibel",
    "First Name": "Bibiana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368648": {
    "id": "item_28081",
    "Last Name": "Hasan",
    "First Name": "Farid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368668": {
    "id": "item_17166",
    "Last Name": "Knobbs",
    "First Name": "Riley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368697": {
    "id": "item_17165",
    "Last Name": "Sills",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368718": {
    "id": "item_5001",
    "Last Name": "Phillips",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368740": {
    "id": "item_17163",
    "Last Name": "Osborne",
    "First Name": "Jarryd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368762": {
    "id": "item_17161",
    "Last Name": "Reynolds",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368896": {
    "id": "item_17159",
    "Last Name": "Power",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368975": {
    "id": "item_679",
    "Last Name": "Nelson",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369039": {
    "id": "item_4998",
    "Last Name": "Gelsleichter ludwig",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369124": {
    "id": "item_678",
    "Last Name": "Mills",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369147": {
    "id": "item_28079",
    "Last Name": "De Re",
    "First Name": "Sacha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369253": {
    "id": "item_2627",
    "Last Name": "Sullivan",
    "First Name": "Carlie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369272": {
    "id": "item_17151",
    "Last Name": "Bourke",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369316": {
    "id": "item_677",
    "Last Name": "Ballarini",
    "First Name": "Aldo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369366": {
    "id": "item_28077",
    "Last Name": "Thanh Tinh",
    "First Name": "Nguyen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369451": {
    "id": "item_17148",
    "Last Name": "Temperly",
    "First Name": "Aled",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369574": {
    "id": "item_4995",
    "Last Name": "Zheng",
    "First Name": "Jinhua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369599": {
    "id": "item_17143",
    "Last Name": "Lim",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369632": {
    "id": "item_17141",
    "Last Name": "Beall",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369739": {
    "id": "item_2625",
    "Last Name": "Tsekrekos",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369904": {
    "id": "item_17135",
    "Last Name": "Langham",
    "First Name": "Serena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369950": {
    "id": "item_4993",
    "Last Name": "Morana",
    "First Name": "Benoit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370171": {
    "id": "item_17133",
    "Last Name": "McNamara",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370188": {
    "id": "item_4992",
    "Last Name": "Taborda",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370272": {
    "id": "item_13109",
    "Last Name": "Todd",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370334": {
    "id": "item_4991",
    "Last Name": "Tran",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370384": {
    "id": "item_17129",
    "Last Name": "Rivai",
    "First Name": "Maya Aachenita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370399": {
    "id": "item_2620",
    "Last Name": "Lee",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370446": {
    "id": "item_13108",
    "Last Name": "Mckaig",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370560": {
    "id": "item_17127",
    "Last Name": "Organ",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370581": {
    "id": "item_4989",
    "Last Name": "Clayton",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370603": {
    "id": "item_17124",
    "Last Name": "jung",
    "First Name": "cederic",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370619": {
    "id": "item_28070",
    "Last Name": "Smith",
    "First Name": "Aliesha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370636": {
    "id": "item_17123",
    "Last Name": "Dodd",
    "First Name": "Andrew Rudisha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370695": {
    "id": "item_17122",
    "Last Name": "Culbong",
    "First Name": "Hunter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370709": {
    "id": "item_17120",
    "Last Name": "Pearce",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370712": {
    "id": "item_28067",
    "Last Name": "Yeomans",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370749": {
    "id": "item_2618",
    "Last Name": "Garciga",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370760": {
    "id": "item_674",
    "Last Name": "Wright",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370869": {
    "id": "item_26473",
    "Last Name": "HSIEH",
    "First Name": "CHAO JAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370906": {
    "id": "item_17116",
    "Last Name": "Cabang",
    "First Name": "Loyd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371169": {
    "id": "item_30055",
    "Last Name": "Talbot",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371327": {
    "id": "item_2616",
    "Last Name": "Vainzof",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371458": {
    "id": "item_17236",
    "Last Name": "Groves",
    "First Name": "Barry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371535": {
    "id": "item_2614",
    "Last Name": "Nava",
    "First Name": "Fabiano",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371574": {
    "id": "item_4982",
    "Last Name": "Baloglow",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371704": {
    "id": "item_4981",
    "Last Name": "Ballantyne",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372226": {
    "id": "item_17104",
    "Last Name": "Wong",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372257": {
    "id": "item_28059",
    "Last Name": "Huynh",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372281": {
    "id": "item_17102",
    "Last Name": "Ngiam",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372347": {
    "id": "item_668",
    "Last Name": "Larkin",
    "First Name": "Rick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372429": {
    "id": "item_28058",
    "Last Name": "Ram",
    "First Name": "Omkar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372443": {
    "id": "item_17099",
    "Last Name": "CHEAM",
    "First Name": "BENJAMIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372655": {
    "id": "item_28056",
    "Last Name": "Vazquez Silva",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372757": {
    "id": "item_30046",
    "Last Name": "Panegyres",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372783": {
    "id": "item_17098",
    "Last Name": "Reynolds",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372787": {
    "id": "item_28054",
    "Last Name": "Wittenoom",
    "First Name": "Matilda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372804": {
    "id": "item_15970",
    "Last Name": "Hotta",
    "First Name": "Noriko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372857": {
    "id": "item_15969",
    "Last Name": "Tiongson",
    "First Name": "Frelea Lyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372980": {
    "id": "item_666",
    "Last Name": "robertson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373049": {
    "id": "item_15968",
    "Last Name": "Jol",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373073": {
    "id": "item_2606",
    "Last Name": "OÕDriscoll",
    "First Name": "Cian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373242": {
    "id": "item_2604",
    "Last Name": "YI",
    "First Name": "XINYA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373370": {
    "id": "item_17092",
    "Last Name": "Ng",
    "First Name": "Lesley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373429": {
    "id": "item_13103",
    "Last Name": "OR",
    "First Name": "HAROLD",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373448": {
    "id": "item_3215",
    "Last Name": "CARDENAS",
    "First Name": "ALBERTO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373467": {
    "id": "item_662",
    "Last Name": "Bernstein",
    "First Name": "Oyungerel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373519": {
    "id": "item_4969",
    "Last Name": "Lohanda",
    "First Name": "Mega",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373597": {
    "id": "item_17084",
    "Last Name": "Constance",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373627": {
    "id": "item_4968",
    "Last Name": "Breen",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373650": {
    "id": "item_30041",
    "Last Name": "Felton",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373672": {
    "id": "item_17081",
    "Last Name": "Boydell",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373685": {
    "id": "item_30040",
    "Last Name": "Ishino",
    "First Name": "Mizue",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373705": {
    "id": "item_13102",
    "Last Name": "Travers",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373735": {
    "id": "item_28050",
    "Last Name": "Dharamadhat",
    "First Name": "Thammapong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373762": {
    "id": "item_28049",
    "Last Name": "Granda",
    "First Name": "Jefferson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373780": {
    "id": "item_4962",
    "Last Name": "Dassanayake",
    "First Name": "Inushka",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373870": {
    "id": "item_659",
    "Last Name": "Bhugtiar",
    "First Name": "Kabir",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373926": {
    "id": "item_658",
    "Last Name": "Juengling",
    "First Name": "Anne-Marie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373994": {
    "id": "item_2600",
    "Last Name": "LEE",
    "First Name": "JUIFEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374166": {
    "id": "item_2597",
    "Last Name": "JIMENEZ",
    "First Name": "PATRICIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374190": {
    "id": "item_17071",
    "Last Name": "Streng",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374226": {
    "id": "item_17069",
    "Last Name": "Nguyen",
    "First Name": "Hoang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374297": {
    "id": "item_17068",
    "Last Name": "AGUS",
    "First Name": "YOHANES DWI SUSANTA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374334": {
    "id": "item_17066",
    "Last Name": "Zhao",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374352": {
    "id": "item_30033",
    "Last Name": "Fiumara",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374384": {
    "id": "item_655",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374480": {
    "id": "item_30032",
    "Last Name": "Lo",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374737": {
    "id": "item_30026",
    "Last Name": "Ritschel",
    "First Name": "Janina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374914": {
    "id": "item_654",
    "Last Name": "Baker",
    "First Name": "Drew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374964": {
    "id": "item_4951",
    "Last Name": "Lin",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375055": {
    "id": "item_4949",
    "Last Name": "Rianto",
    "First Name": "Darwin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375100": {
    "id": "item_651",
    "Last Name": "Laing",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375315": {
    "id": "item_15965",
    "Last Name": "Barclay",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375364": {
    "id": "item_17052",
    "Last Name": "Romanis",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375495": {
    "id": "item_28034",
    "Last Name": "Kava",
    "First Name": "Empur",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375541": {
    "id": "item_648",
    "Last Name": "Walker",
    "First Name": "Dougal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375545": {
    "id": "item_2591",
    "Last Name": "Tsang",
    "First Name": "Chun Hung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375602": {
    "id": "item_15964",
    "Last Name": "Lisbon",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375625": {
    "id": "item_4941",
    "Last Name": "Matthys",
    "First Name": "Bemjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375641": {
    "id": "item_2590",
    "Last Name": "McLean",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375672": {
    "id": "item_645",
    "Last Name": "Diederichs",
    "First Name": "Henk",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375698": {
    "id": "item_644",
    "Last Name": "Healy",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375746": {
    "id": "item_30019",
    "Last Name": "Macaskill",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375752": {
    "id": "item_28026",
    "Last Name": "Lei",
    "First Name": "Xiaran",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375788": {
    "id": "item_4937",
    "Last Name": "Simpson",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375891": {
    "id": "item_2585",
    "Last Name": "Carey",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375916": {
    "id": "item_17039",
    "Last Name": "Walker",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375917": {
    "id": "item_30017",
    "Last Name": "McKenzie",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375935": {
    "id": "item_2582",
    "Last Name": "Thomas",
    "First Name": "Bella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376126": {
    "id": "item_642",
    "Last Name": "Long",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376203": {
    "id": "item_640",
    "Last Name": "Mogridge",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376217": {
    "id": "item_13093",
    "Last Name": "Pasquale",
    "First Name": "Guerino",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376241": {
    "id": "item_30011",
    "Last Name": "Doan",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376267": {
    "id": "item_16736",
    "Last Name": "Gallagher",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376322": {
    "id": "item_4936",
    "Last Name": "Moro",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376382": {
    "id": "item_17029",
    "Last Name": "Weule",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376392": {
    "id": "item_639",
    "Last Name": "Miles",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376417": {
    "id": "item_4933",
    "Last Name": "Boyd",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376471": {
    "id": "item_17023",
    "Last Name": "Sheehan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376482": {
    "id": "item_4929",
    "Last Name": "Penman",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376489": {
    "id": "item_31066",
    "Last Name": "CHIANG",
    "First Name": "YUNSHU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376565": {
    "id": "item_4928",
    "Last Name": "Fung",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376574": {
    "id": "item_2574",
    "Last Name": "NAM",
    "First Name": "YUNSANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376591": {
    "id": "item_4927",
    "Last Name": "Robinson",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376600": {
    "id": "item_17019",
    "Last Name": "Capper",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376696": {
    "id": "item_28015",
    "Last Name": "Paveltish",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376735": {
    "id": "item_4925",
    "Last Name": "Bowers",
    "First Name": "Amber",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376764": {
    "id": "item_13089",
    "Last Name": "Le",
    "First Name": "Mick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376781": {
    "id": "item_30003",
    "Last Name": "Coley",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376993": {
    "id": "item_17012",
    "Last Name": "Dai",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377070": {
    "id": "item_17011",
    "Last Name": "McKay",
    "First Name": "Corey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377200": {
    "id": "item_4922",
    "Last Name": "LUO",
    "First Name": "RUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377211": {
    "id": "item_4921",
    "Last Name": "Mathee",
    "First Name": "Rickus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377312": {
    "id": "item_4920",
    "Last Name": "Chiu",
    "First Name": "Kim Seng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377379": {
    "id": "item_17007",
    "Last Name": "May",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377498": {
    "id": "item_28008",
    "Last Name": "King",
    "First Name": "courtney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377897": {
    "id": "item_628",
    "Last Name": "Cullell",
    "First Name": "Federico",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377974": {
    "id": "item_2564",
    "Last Name": "Yanqi",
    "First Name": "Chen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378183": {
    "id": "item_4919",
    "Last Name": "Nurick",
    "First Name": "Ash",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378311": {
    "id": "item_17002",
    "Last Name": "park",
    "First Name": "gunyeol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378460": {
    "id": "item_2562",
    "Last Name": "Nichols",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378541": {
    "id": "item_2561",
    "Last Name": "Fatkhutdinova",
    "First Name": "Liliia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378562": {
    "id": "item_29993",
    "Last Name": "LAUSIN SERRANO",
    "First Name": "JOAQUIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378598": {
    "id": "item_28003",
    "Last Name": "MacNaughton",
    "First Name": "Skye",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378628": {
    "id": "item_29991",
    "Last Name": "Miranda",
    "First Name": "Vivek",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378684": {
    "id": "item_2559",
    "Last Name": "YANG",
    "First Name": "ZI-DE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378753": {
    "id": "item_2558",
    "Last Name": "Gonz‡lez",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378895": {
    "id": "item_29988",
    "Last Name": "Ni Bhuigleir",
    "First Name": "Toyah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378907": {
    "id": "item_28002",
    "Last Name": "LIN",
    "First Name": "CHING-YUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37379347": {
    "id": "item_2556",
    "Last Name": "Talarn Caubet",
    "First Name": "Joaquin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37379593": {
    "id": "item_28001",
    "Last Name": "Cendana",
    "First Name": "Hanvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37379858": {
    "id": "item_4915",
    "Last Name": "Ecija",
    "First Name": "Mar John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37380099": {
    "id": "item_29985",
    "Last Name": "Calderon",
    "First Name": "Adolfo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37380279": {
    "id": "item_620",
    "Last Name": "Bartusch",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37380476": {
    "id": "item_2554",
    "Last Name": "KIM",
    "First Name": "BYOUNG SAM",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37381525": {
    "id": "item_13085",
    "Last Name": "Zajac",
    "First Name": "Jaroslaw",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37381579": {
    "id": "item_16989",
    "Last Name": "Vo",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37382167": {
    "id": "item_16988",
    "Last Name": "Butel",
    "First Name": "Regina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37382275": {
    "id": "item_27997",
    "Last Name": "Krueger",
    "First Name": "Chaela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37382642": {
    "id": "item_3242",
    "Last Name": "Alves da Silva Bezerra",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37382653": {
    "id": "item_13084",
    "Last Name": "Rodriguez Salas",
    "First Name": "Javier",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37383068": {
    "id": "item_16986",
    "Last Name": "Shipard",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37383083": {
    "id": "item_4913",
    "Last Name": "Kim",
    "First Name": "Junggeun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37383397": {
    "id": "item_16984",
    "Last Name": "Kang",
    "First Name": "Hoon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37383887": {
    "id": "item_29977",
    "Last Name": "Munar",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37384532": {
    "id": "item_615",
    "Last Name": "de Haydu",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385374": {
    "id": "item_16978",
    "Last Name": "Massey",
    "First Name": "Sasha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385426": {
    "id": "item_15949",
    "Last Name": "Nguyen",
    "First Name": "David-James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385532": {
    "id": "item_4903",
    "Last Name": "Jones",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385759": {
    "id": "item_16970",
    "Last Name": "Nozoe",
    "First Name": "Masayuki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385853": {
    "id": "item_16968",
    "Last Name": "Tosh",
    "First Name": "Jim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385944": {
    "id": "item_2546",
    "Last Name": "Zitzelsberger",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385949": {
    "id": "item_15948",
    "Last Name": "Singh",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385965": {
    "id": "item_29970",
    "Last Name": "Flores",
    "First Name": "Roxana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386156": {
    "id": "item_4898",
    "Last Name": "Maki-Richards",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386182": {
    "id": "item_2545",
    "Last Name": "Kagan",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386229": {
    "id": "item_29967",
    "Last Name": "Rames",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386338": {
    "id": "item_16966",
    "Last Name": "Dowd",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386384": {
    "id": "item_4895",
    "Last Name": "Sim",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386386": {
    "id": "item_4896",
    "Last Name": "Muldabayev",
    "First Name": "Arman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386781": {
    "id": "item_4894",
    "Last Name": "lane",
    "First Name": "Jarred",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386830": {
    "id": "item_27993",
    "Last Name": "Evans",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386854": {
    "id": "item_29964",
    "Last Name": "Goodes",
    "First Name": "Howard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386926": {
    "id": "item_4891",
    "Last Name": "Sztefek",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386940": {
    "id": "item_16960",
    "Last Name": "Hodgkinson",
    "First Name": "Andtew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387120": {
    "id": "item_27990",
    "Last Name": "Kolb",
    "First Name": "Nadiele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387184": {
    "id": "item_2541",
    "Last Name": "Gong",
    "First Name": "Carole",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387187": {
    "id": "item_29963",
    "Last Name": "Winkler",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387297": {
    "id": "item_16956",
    "Last Name": "Gonsier",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387307": {
    "id": "item_4887",
    "Last Name": "Hodge",
    "First Name": "Poppy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387363": {
    "id": "item_27988",
    "Last Name": "Ramirez acevedo",
    "First Name": "Deycy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387430": {
    "id": "item_16952",
    "Last Name": "Sandvik",
    "First Name": "Eilif",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387496": {
    "id": "item_29961",
    "Last Name": "Lesser",
    "First Name": "nikki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387501": {
    "id": "item_4885",
    "Last Name": "Rodger",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387608": {
    "id": "item_4884",
    "Last Name": "San Jose",
    "First Name": "Paolo Angelo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387671": {
    "id": "item_27987",
    "Last Name": "Haden",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387973": {
    "id": "item_2539",
    "Last Name": "So",
    "First Name": "Wing Kuen Edward",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388041": {
    "id": "item_605",
    "Last Name": "Chong",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388114": {
    "id": "item_16945",
    "Last Name": "Frey",
    "First Name": "Seth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388571": {
    "id": "item_29958",
    "Last Name": "Byrne",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388621": {
    "id": "item_16942",
    "Last Name": "Bucolo",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388648": {
    "id": "item_29956",
    "Last Name": "Chear",
    "First Name": "Chakriya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388695": {
    "id": "item_16937",
    "Last Name": "Chau",
    "First Name": "Yeuk Kei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388771": {
    "id": "item_27983",
    "Last Name": "Egelton",
    "First Name": "Gem",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388799": {
    "id": "item_2537",
    "Last Name": "Cottrill",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389067": {
    "id": "item_16929",
    "Last Name": "Vendi",
    "First Name": "Andri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389111": {
    "id": "item_29953",
    "Last Name": "Pimchaipong",
    "First Name": "Rapeeporn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389272": {
    "id": "item_602",
    "Last Name": "Kell",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389280": {
    "id": "item_29952",
    "Last Name": "Hambly-Riddell",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389351": {
    "id": "item_16923",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389471": {
    "id": "item_601",
    "Last Name": "Gibson",
    "First Name": "Theo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389667": {
    "id": "item_15944",
    "Last Name": "Lang",
    "First Name": "Liza",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389744": {
    "id": "item_27977",
    "Last Name": "Kilby",
    "First Name": "Ryshelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389884": {
    "id": "item_600",
    "Last Name": "Au",
    "First Name": "Ka Kiu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389913": {
    "id": "item_16919",
    "Last Name": "Thompson",
    "First Name": "Kieren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390094": {
    "id": "item_13074",
    "Last Name": "Renney",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390096": {
    "id": "item_4868",
    "Last Name": "Moore",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390130": {
    "id": "item_16915",
    "Last Name": "Hart",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390172": {
    "id": "item_27974",
    "Last Name": "Swann",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390222": {
    "id": "item_13073",
    "Last Name": "Taylor",
    "First Name": "Maddison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390304": {
    "id": "item_27973",
    "Last Name": "corrigan",
    "First Name": "Orla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390534": {
    "id": "item_16906",
    "Last Name": "YUN",
    "First Name": "JONGWOO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390936": {
    "id": "item_28860",
    "Last Name": "Gancayco",
    "First Name": "Maria Pilar Teresa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390947": {
    "id": "item_27972",
    "Last Name": "Anderson",
    "First Name": "Sue",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390992": {
    "id": "item_27971",
    "Last Name": "Rasmussen",
    "First Name": "Jody",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391102": {
    "id": "item_13071",
    "Last Name": "Blake",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391119": {
    "id": "item_16902",
    "Last Name": "Noble",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391146": {
    "id": "item_16901",
    "Last Name": "Curry",
    "First Name": "Bobbi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391247": {
    "id": "item_29938",
    "Last Name": "Keegan",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391319": {
    "id": "item_4862",
    "Last Name": "Fitzgerald",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391423": {
    "id": "item_16895",
    "Last Name": "Webster",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391503": {
    "id": "item_16894",
    "Last Name": "Cunningham",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391525": {
    "id": "item_16893",
    "Last Name": "Tang",
    "First Name": "Chaka",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391680": {
    "id": "item_13070",
    "Last Name": "Tyurin",
    "First Name": "Konstantin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391699": {
    "id": "item_4858",
    "Last Name": "Gadsby",
    "First Name": "Bree-Anna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391710": {
    "id": "item_13069",
    "Last Name": "Lowe",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391778": {
    "id": "item_4855",
    "Last Name": "Allen-Waters",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391779": {
    "id": "item_16890",
    "Last Name": "Young",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391901": {
    "id": "item_16888",
    "Last Name": "Stebbings",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391946": {
    "id": "item_27969",
    "Last Name": "Zeng",
    "First Name": "Harry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391958": {
    "id": "item_2525",
    "Last Name": "Watts",
    "First Name": "Fiesta",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392136": {
    "id": "item_27968",
    "Last Name": "Smith",
    "First Name": "Madason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392240": {
    "id": "item_29932",
    "Last Name": "de Plater",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392487": {
    "id": "item_2521",
    "Last Name": "Clifton",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392548": {
    "id": "item_29929",
    "Last Name": "Lapid",
    "First Name": "Norman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392598": {
    "id": "item_27965",
    "Last Name": "Lo",
    "First Name": "Chin Hung Tommy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392753": {
    "id": "item_29927",
    "Last Name": "Siapno",
    "First Name": "Noel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392764": {
    "id": "item_29925",
    "Last Name": "Yong",
    "First Name": "Sarah-Ann",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392901": {
    "id": "item_593",
    "Last Name": "Chan",
    "First Name": "Moses",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392950": {
    "id": "item_592",
    "Last Name": "WERY",
    "First Name": "Laurent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392978": {
    "id": "item_16874",
    "Last Name": "Doyle",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393034": {
    "id": "item_16870",
    "Last Name": "Garc’a",
    "First Name": "çngel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393052": {
    "id": "item_4846",
    "Last Name": "Fennell",
    "First Name": "Lochie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393115": {
    "id": "item_27962",
    "Last Name": "Rumsey",
    "First Name": "Marcia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393155": {
    "id": "item_16867",
    "Last Name": "Munoz",
    "First Name": "Danier",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393185": {
    "id": "item_27961",
    "Last Name": "Sonnek",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393235": {
    "id": "item_4842",
    "Last Name": "Cook",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393241": {
    "id": "item_29917",
    "Last Name": "Etter",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393244": {
    "id": "item_4840",
    "Last Name": "Carboni",
    "First Name": "Cy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393249": {
    "id": "item_15939",
    "Last Name": "Reid",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393314": {
    "id": "item_29915",
    "Last Name": "Nahoor",
    "First Name": "Yasmeen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393330": {
    "id": "item_16861",
    "Last Name": "Ong",
    "First Name": "Veronica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393361": {
    "id": "item_590",
    "Last Name": "Golden",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393371": {
    "id": "item_29913",
    "Last Name": "CHOI",
    "First Name": "DOOJIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393414": {
    "id": "item_16855",
    "Last Name": "Bond",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393425": {
    "id": "item_16853",
    "Last Name": "Locker",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393460": {
    "id": "item_16852",
    "Last Name": "Beven",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393488": {
    "id": "item_4836",
    "Last Name": "Jeon",
    "First Name": "Yohan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393514": {
    "id": "item_4835",
    "Last Name": "Montague",
    "First Name": "Mat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393550": {
    "id": "item_16847",
    "Last Name": "Moffat",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393551": {
    "id": "item_4834",
    "Last Name": "Tridgell",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393557": {
    "id": "item_16845",
    "Last Name": "Simpson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393558": {
    "id": "item_4833",
    "Last Name": "Yap",
    "First Name": "Bing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393572": {
    "id": "item_2517",
    "Last Name": "Ten Harkel",
    "First Name": "Remco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393589": {
    "id": "item_15937",
    "Last Name": "ONG",
    "First Name": "ANDREW",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393590": {
    "id": "item_2516",
    "Last Name": "Shorten",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393595": {
    "id": "item_27955",
    "Last Name": "KHOONG",
    "First Name": "Siew Chin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393596": {
    "id": "item_4831",
    "Last Name": "LEE",
    "First Name": "CHENG-HAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393686": {
    "id": "item_4828",
    "Last Name": "Uluave",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393707": {
    "id": "item_29906",
    "Last Name": "Pinho",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393712": {
    "id": "item_4827",
    "Last Name": "Kruger",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393715": {
    "id": "item_29905",
    "Last Name": "North",
    "First Name": "Noemi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393791": {
    "id": "item_583",
    "Last Name": "Bosch Pastor",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393803": {
    "id": "item_16831",
    "Last Name": "Parker",
    "First Name": "Callum",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393812": {
    "id": "item_581",
    "Last Name": "ARESMOUK",
    "First Name": "AZIZ",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393887": {
    "id": "item_4824",
    "Last Name": "Hovanec",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393920": {
    "id": "item_13063",
    "Last Name": "Owens",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393930": {
    "id": "item_16828",
    "Last Name": "GEORGE",
    "First Name": "NITHIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393953": {
    "id": "item_16825",
    "Last Name": "macgregor",
    "First Name": "matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394045": {
    "id": "item_578",
    "Last Name": "Waugh",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394046": {
    "id": "item_4819",
    "Last Name": "Eekhof",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394071": {
    "id": "item_27950",
    "Last Name": "Kato",
    "First Name": "Nana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394145": {
    "id": "item_4815",
    "Last Name": "Kubacka",
    "First Name": "Veronika",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394170": {
    "id": "item_16814",
    "Last Name": "Wang",
    "First Name": "Hongxiang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394190": {
    "id": "item_29899",
    "Last Name": "Zhang",
    "First Name": "Man",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394210": {
    "id": "item_4814",
    "Last Name": "Humphries",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394250": {
    "id": "item_4812",
    "Last Name": "Thompson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394252": {
    "id": "item_4811",
    "Last Name": "Kasby",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394287": {
    "id": "item_16812",
    "Last Name": "Lotz",
    "First Name": "Byron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394307": {
    "id": "item_16810",
    "Last Name": "Smith",
    "First Name": "Peyton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394314": {
    "id": "item_16809",
    "Last Name": "Fisher",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394317": {
    "id": "item_27946",
    "Last Name": "Hussain",
    "First Name": "Shafaqut",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394322": {
    "id": "item_574",
    "Last Name": "Walker",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394381": {
    "id": "item_27944",
    "Last Name": "Simatos",
    "First Name": "Costas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394384": {
    "id": "item_15935",
    "Last Name": "Martin",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394429": {
    "id": "item_16806",
    "Last Name": "song",
    "First Name": "jacky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394438": {
    "id": "item_573",
    "Last Name": "Lee",
    "First Name": "Chun wing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394458": {
    "id": "item_13059",
    "Last Name": "Halford",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394598": {
    "id": "item_28819",
    "Last Name": "Paine",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394606": {
    "id": "item_4802",
    "Last Name": "Ahern",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394623": {
    "id": "item_29890",
    "Last Name": "Shiu hong",
    "First Name": "Chan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394631": {
    "id": "item_569",
    "Last Name": "Robertson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394637": {
    "id": "item_4800",
    "Last Name": "Wratten",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394643": {
    "id": "item_27939",
    "Last Name": "Beggs",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394649": {
    "id": "item_4798",
    "Last Name": "Sheehan",
    "First Name": "Jaxon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394676": {
    "id": "item_4796",
    "Last Name": "Farlow",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394679": {
    "id": "item_4797",
    "Last Name": "Tran",
    "First Name": "Anthony-Sabastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394695": {
    "id": "item_29887",
    "Last Name": "Cervetto",
    "First Name": "Robin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394698": {
    "id": "item_27937",
    "Last Name": "Steer",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394699": {
    "id": "item_4794",
    "Last Name": "Hackett",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394750": {
    "id": "item_568",
    "Last Name": "Gedvilas",
    "First Name": "Justinas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394856": {
    "id": "item_2504",
    "Last Name": "HERTEN",
    "First Name": "PETER",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394879": {
    "id": "item_27933",
    "Last Name": "Hamer",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395088": {
    "id": "item_27931",
    "Last Name": "Lamb",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395125": {
    "id": "item_16791",
    "Last Name": "Lu",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395189": {
    "id": "item_15931",
    "Last Name": "Jeyamanoharan",
    "First Name": "Nivedan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395506": {
    "id": "item_16787",
    "Last Name": "Lane",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395683": {
    "id": "item_29878",
    "Last Name": "Acharya",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395700": {
    "id": "item_29875",
    "Last Name": "Gonzalez",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395817": {
    "id": "item_15928",
    "Last Name": "Millard",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395916": {
    "id": "item_16326",
    "Last Name": "Leung",
    "First Name": "Kai Cheong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37396108": {
    "id": "item_4779",
    "Last Name": "Bot",
    "First Name": "Grayson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37396279": {
    "id": "item_2499",
    "Last Name": "SU",
    "First Name": "WEITAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37396361": {
    "id": "item_16780",
    "Last Name": "Rinasari",
    "First Name": "Umi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37396386": {
    "id": "item_4777",
    "Last Name": "Hardman",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37396608": {
    "id": "item_2497",
    "Last Name": "Nelis",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37396802": {
    "id": "item_27927",
    "Last Name": "Tang",
    "First Name": "Chong ling",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37397308": {
    "id": "item_15925",
    "Last Name": "Seet",
    "First Name": "Jolyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37397522": {
    "id": "item_2493",
    "Last Name": "Sirirattanachaikul",
    "First Name": "Prasert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37397727": {
    "id": "item_13055",
    "Last Name": "Ru Wei",
    "First Name": "Sim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37397915": {
    "id": "item_16770",
    "Last Name": "Lee",
    "First Name": "Nathanael Kin Leong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37398149": {
    "id": "item_552",
    "Last Name": "Allen",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37398248": {
    "id": "item_4772",
    "Last Name": "LI",
    "First Name": "ZHULONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37398540": {
    "id": "item_29873",
    "Last Name": "Ollila",
    "First Name": "Curt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37398565": {
    "id": "item_29872",
    "Last Name": "Lewis",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37398910": {
    "id": "item_16769",
    "Last Name": "austen",
    "First Name": "richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37399234": {
    "id": "item_27923",
    "Last Name": "Boyer",
    "First Name": "Lynn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37399286": {
    "id": "item_16767",
    "Last Name": "Mosey",
    "First Name": "Britney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37399499": {
    "id": "item_2489",
    "Last Name": "block",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37399698": {
    "id": "item_29871",
    "Last Name": "Garavaglia",
    "First Name": "Heather",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37399851": {
    "id": "item_27921",
    "Last Name": "Jabbarova",
    "First Name": "Tamilla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37400348": {
    "id": "item_16764",
    "Last Name": "barkley",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37400546": {
    "id": "item_16762",
    "Last Name": "Sobey",
    "First Name": "Bill",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401257": {
    "id": "item_16758",
    "Last Name": "Sefo",
    "First Name": "Briar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401340": {
    "id": "item_28859",
    "Last Name": "Felix",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401585": {
    "id": "item_2486",
    "Last Name": "Borges",
    "First Name": "Igor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401594": {
    "id": "item_4764",
    "Last Name": "Tillman",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401700": {
    "id": "item_16757",
    "Last Name": "sayil",
    "First Name": "huseyin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401879": {
    "id": "item_28818",
    "Last Name": "Preissner",
    "First Name": "Karl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401979": {
    "id": "item_16755",
    "Last Name": "Jasch",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401990": {
    "id": "item_4762",
    "Last Name": "McSpadden",
    "First Name": "Calum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402323": {
    "id": "item_14018",
    "Last Name": "Breton",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402346": {
    "id": "item_4760",
    "Last Name": "Zammit",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402437": {
    "id": "item_4759",
    "Last Name": "Orchard",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402464": {
    "id": "item_4756",
    "Last Name": "Sheridan",
    "First Name": "Padraig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402517": {
    "id": "item_29862",
    "Last Name": "McGrath",
    "First Name": "Jacinta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402522": {
    "id": "item_2485",
    "Last Name": "Stone",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402576": {
    "id": "item_2484",
    "Last Name": "Case",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402772": {
    "id": "item_27919",
    "Last Name": "Ng",
    "First Name": "Wai Yan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402957": {
    "id": "item_29859",
    "Last Name": "Abreu",
    "First Name": "Aline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403272": {
    "id": "item_4755",
    "Last Name": "Harrngton",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403273": {
    "id": "item_29857",
    "Last Name": "Massarotti",
    "First Name": "Caitlyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403545": {
    "id": "item_16742",
    "Last Name": "Rimmer",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403858": {
    "id": "item_4753",
    "Last Name": "Elliott",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403863": {
    "id": "item_16741",
    "Last Name": "Tabbah",
    "First Name": "Taymore",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404131": {
    "id": "item_29854",
    "Last Name": "Gibson-Williamson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404140": {
    "id": "item_27914",
    "Last Name": "Zhang",
    "First Name": "Huang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404145": {
    "id": "item_2483",
    "Last Name": "Burke",
    "First Name": "Louise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404314": {
    "id": "item_2480",
    "Last Name": "Tan",
    "First Name": "Yong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404379": {
    "id": "item_29853",
    "Last Name": "Kang",
    "First Name": "Alyssa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404558": {
    "id": "item_16737",
    "Last Name": "Bruce",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404954": {
    "id": "item_3142",
    "Last Name": "Souto Romero",
    "First Name": "Gonzalo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404978": {
    "id": "item_3145",
    "Last Name": "Prasad",
    "First Name": "Braj",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404988": {
    "id": "item_26198",
    "Last Name": "Hamilton",
    "First Name": "Mardie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405057": {
    "id": "item_3144",
    "Last Name": "Foyle",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405082": {
    "id": "item_26197",
    "Last Name": "Alejo",
    "First Name": "Angelica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405109": {
    "id": "item_28708",
    "Last Name": "Burns",
    "First Name": "Alexsandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405110": {
    "id": "item_30887",
    "Last Name": "Moyo",
    "First Name": "Zwelithini",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405115": {
    "id": "item_16254",
    "Last Name": "Sender",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405198": {
    "id": "item_13852",
    "Last Name": "Fitzgerald",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405250": {
    "id": "item_13851",
    "Last Name": "Wassall",
    "First Name": "Annabelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405270": {
    "id": "item_13850",
    "Last Name": "Neivandt",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405283": {
    "id": "item_26193",
    "Last Name": "Mongan",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405308": {
    "id": "item_28707",
    "Last Name": "McDonald",
    "First Name": "Lynsey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405329": {
    "id": "item_26192",
    "Last Name": "Thompson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405345": {
    "id": "item_1296",
    "Last Name": "Ey",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405398": {
    "id": "item_28706",
    "Last Name": "McNally",
    "First Name": "Gretchen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405420": {
    "id": "item_26190",
    "Last Name": "Collier",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405479": {
    "id": "item_13847",
    "Last Name": "Henry",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405490": {
    "id": "item_26189",
    "Last Name": "Luo",
    "First Name": "Robin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405511": {
    "id": "item_26188",
    "Last Name": "Tooley",
    "First Name": "Leona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405523": {
    "id": "item_13846",
    "Last Name": "Lewis",
    "First Name": "Yvonne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405524": {
    "id": "item_3139",
    "Last Name": "Kaplan",
    "First Name": "Anne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405621": {
    "id": "item_26186",
    "Last Name": "Monteleone",
    "First Name": "Kieren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405629": {
    "id": "item_26187",
    "Last Name": "Gracias",
    "First Name": "Rebekah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405732": {
    "id": "item_13845",
    "Last Name": "Gifford",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405746": {
    "id": "item_13843",
    "Last Name": "Reeve",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405767": {
    "id": "item_30884",
    "Last Name": "Windsor",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405883": {
    "id": "item_26184",
    "Last Name": "Carter",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406035": {
    "id": "item_3137",
    "Last Name": "Pitt",
    "First Name": "Fergus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406045": {
    "id": "item_13841",
    "Last Name": "Leach",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406068": {
    "id": "item_13840",
    "Last Name": "Halloran",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406083": {
    "id": "item_26180",
    "Last Name": "Bowden",
    "First Name": "Guy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406255": {
    "id": "item_13839",
    "Last Name": "Gultiano",
    "First Name": "Rahnee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406421": {
    "id": "item_26178",
    "Last Name": "Yonathan",
    "First Name": "Grace Belinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406480": {
    "id": "item_13836",
    "Last Name": "Sergeeva",
    "First Name": "Nadiya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406483": {
    "id": "item_30879",
    "Last Name": "Lerma",
    "First Name": "L. Angelica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406793": {
    "id": "item_30878",
    "Last Name": "Burton",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406812": {
    "id": "item_26172",
    "Last Name": "Luu",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406817": {
    "id": "item_13835",
    "Last Name": "Willcock",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406823": {
    "id": "item_26174",
    "Last Name": "Gan",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406977": {
    "id": "item_26170",
    "Last Name": "Coe",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407167": {
    "id": "item_26169",
    "Last Name": "Fry",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407503": {
    "id": "item_28702",
    "Last Name": "Jackson",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407530": {
    "id": "item_13834",
    "Last Name": "Shepherd",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407536": {
    "id": "item_1290",
    "Last Name": "O'Brien",
    "First Name": "Fergal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407625": {
    "id": "item_13832",
    "Last Name": "McGinnigle",
    "First Name": "Keith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407674": {
    "id": "item_1289",
    "Last Name": "Vargas Vaca",
    "First Name": "Miguel Angel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407691": {
    "id": "item_26167",
    "Last Name": "Koch",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407696": {
    "id": "item_1407",
    "Last Name": "Fourie",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407700": {
    "id": "item_26166",
    "Last Name": "Hutchinson",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407796": {
    "id": "item_28700",
    "Last Name": "Costello",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407821": {
    "id": "item_26164",
    "Last Name": "Crawford",
    "First Name": "Eloise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407825": {
    "id": "item_26472",
    "Last Name": "Palmore",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407931": {
    "id": "item_28698",
    "Last Name": "Erdei",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407943": {
    "id": "item_30876",
    "Last Name": "Vickers",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37408012": {
    "id": "item_13829",
    "Last Name": "Mitchell",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37408486": {
    "id": "item_13827",
    "Last Name": "Tran",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37408493": {
    "id": "item_13826",
    "Last Name": "Johnston",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37408845": {
    "id": "item_13824",
    "Last Name": "Whitfeld",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409141": {
    "id": "item_28695",
    "Last Name": "ZHU",
    "First Name": "LEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409284": {
    "id": "item_13823",
    "Last Name": "Harrison",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409434": {
    "id": "item_30872",
    "Last Name": "Ong",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409573": {
    "id": "item_26161",
    "Last Name": "Carey",
    "First Name": "Janet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409577": {
    "id": "item_3128",
    "Last Name": "Garniss",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409595": {
    "id": "item_26160",
    "Last Name": "San Jose",
    "First Name": "Mark Noel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409627": {
    "id": "item_30871",
    "Last Name": "Hammond",
    "First Name": "Innes",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409661": {
    "id": "item_28691",
    "Last Name": "Edwards",
    "First Name": "Colin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409692": {
    "id": "item_28693",
    "Last Name": "Bailey",
    "First Name": "Ngaire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409697": {
    "id": "item_30869",
    "Last Name": "Worsnop",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409907": {
    "id": "item_13820",
    "Last Name": "Rasic",
    "First Name": "Edvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409996": {
    "id": "item_26158",
    "Last Name": "Samms",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410024": {
    "id": "item_16248",
    "Last Name": "Day",
    "First Name": "Fletcher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410109": {
    "id": "item_28689",
    "Last Name": "Macinas",
    "First Name": "Gaderick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410176": {
    "id": "item_13817",
    "Last Name": "Dahlmann",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410310": {
    "id": "item_16247",
    "Last Name": "Galimberti",
    "First Name": "Davis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410409": {
    "id": "item_30866",
    "Last Name": "Prompalad",
    "First Name": "Kobngern",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410905": {
    "id": "item_26151",
    "Last Name": "Ellis",
    "First Name": "Rob",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411051": {
    "id": "item_3123",
    "Last Name": "Stalling",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411132": {
    "id": "item_1284",
    "Last Name": "Yue",
    "First Name": "Hang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411467": {
    "id": "item_28686",
    "Last Name": "Renzi",
    "First Name": "Harley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411556": {
    "id": "item_26149",
    "Last Name": "Tooley",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411619": {
    "id": "item_28684",
    "Last Name": "Delamotte",
    "First Name": "Christie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411753": {
    "id": "item_30859",
    "Last Name": "Hadji",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411818": {
    "id": "item_30860",
    "Last Name": "Conlon",
    "First Name": "Anne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411899": {
    "id": "item_28682",
    "Last Name": "Erasmus",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37411904": {
    "id": "item_13812",
    "Last Name": "Townsend",
    "First Name": "Esher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37412034": {
    "id": "item_13811",
    "Last Name": "McKenzie",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37412735": {
    "id": "item_26140",
    "Last Name": "Nguyen",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413296": {
    "id": "item_13810",
    "Last Name": "jun",
    "First Name": "wu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413334": {
    "id": "item_26137",
    "Last Name": "SUWANNARAK",
    "First Name": "MATHEE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413335": {
    "id": "item_26139",
    "Last Name": "Mirsaeian",
    "First Name": "Mitra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413458": {
    "id": "item_26135",
    "Last Name": "Cordova",
    "First Name": "Faza Faikar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413630": {
    "id": "item_28817",
    "Last Name": "agustiawan",
    "First Name": "putu gede",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413735": {
    "id": "item_26134",
    "Last Name": "Richardson",
    "First Name": "Gabi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413960": {
    "id": "item_13808",
    "Last Name": "Van Brummen",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414035": {
    "id": "item_1279",
    "Last Name": "luo",
    "First Name": "shiyi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414136": {
    "id": "item_13806",
    "Last Name": "Verano",
    "First Name": "Milton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414236": {
    "id": "item_13805",
    "Last Name": "Little",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414248": {
    "id": "item_30851",
    "Last Name": "healy",
    "First Name": "stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414263": {
    "id": "item_3118",
    "Last Name": "DODD",
    "First Name": "JASON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414355": {
    "id": "item_28679",
    "Last Name": "Grace-Cashin",
    "First Name": "Rhea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414425": {
    "id": "item_30850",
    "Last Name": "Tandika",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414455": {
    "id": "item_13802",
    "Last Name": "Yau",
    "First Name": "Benjamin Chun-Pong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414530": {
    "id": "item_30849",
    "Last Name": "Craiger",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414635": {
    "id": "item_28677",
    "Last Name": "JIANG",
    "First Name": "JIANHAI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414860": {
    "id": "item_3116",
    "Last Name": "Gao",
    "First Name": "Jie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414908": {
    "id": "item_26127",
    "Last Name": "Cleymans",
    "First Name": "Rudi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414984": {
    "id": "item_26126",
    "Last Name": "Lee",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415042": {
    "id": "item_26125",
    "Last Name": "Tu",
    "First Name": "Teke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415105": {
    "id": "item_16243",
    "Last Name": "Woo",
    "First Name": "Sunhwa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415109": {
    "id": "item_26124",
    "Last Name": "Tagore",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415139": {
    "id": "item_13798",
    "Last Name": "Jones",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415173": {
    "id": "item_16242",
    "Last Name": "TAGURI",
    "First Name": "HARUNA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415214": {
    "id": "item_28675",
    "Last Name": "Wood",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415238": {
    "id": "item_26123",
    "Last Name": "Jung",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415375": {
    "id": "item_26122",
    "Last Name": "Bowman",
    "First Name": "Sorelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415516": {
    "id": "item_26120",
    "Last Name": "ONG",
    "First Name": "Lee Chin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415526": {
    "id": "item_26119",
    "Last Name": "Betancur Escobar",
    "First Name": "Maria Camila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415616": {
    "id": "item_13795",
    "Last Name": "Martin",
    "First Name": "Yves",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415666": {
    "id": "item_26118",
    "Last Name": "Gibson",
    "First Name": "Jacinta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415738": {
    "id": "item_1275",
    "Last Name": "Keirns",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415747": {
    "id": "item_30845",
    "Last Name": "Litchfield",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415920": {
    "id": "item_13794",
    "Last Name": "Bedzis",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416069": {
    "id": "item_26114",
    "Last Name": "Viana",
    "First Name": "Yanina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416182": {
    "id": "item_13792",
    "Last Name": "Bailey",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416191": {
    "id": "item_1270",
    "Last Name": "Blair",
    "First Name": "Haydn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416213": {
    "id": "item_30841",
    "Last Name": "Villacruz",
    "First Name": "Bambi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416268": {
    "id": "item_1406",
    "Last Name": "Song",
    "First Name": "Rong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416381": {
    "id": "item_1267",
    "Last Name": "Belleflamme",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416646": {
    "id": "item_1263",
    "Last Name": "Mortlock",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416657": {
    "id": "item_16238",
    "Last Name": "Rushby",
    "First Name": "Michaela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416795": {
    "id": "item_26108",
    "Last Name": "Bastos",
    "First Name": "Raquel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416893": {
    "id": "item_13786",
    "Last Name": "Ure–a Araya",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417071": {
    "id": "item_30837",
    "Last Name": "Japadermawan",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417174": {
    "id": "item_26104",
    "Last Name": "Fleming",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417193": {
    "id": "item_16237",
    "Last Name": "Jagielka",
    "First Name": "Tatiana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417197": {
    "id": "item_26103",
    "Last Name": "Davila",
    "First Name": "Andres",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417317": {
    "id": "item_1259",
    "Last Name": "O'Brien",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417337": {
    "id": "item_26099",
    "Last Name": "Domanti",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417516": {
    "id": "item_30831",
    "Last Name": "Lee",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417525": {
    "id": "item_26096",
    "Last Name": "Ricketts",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417558": {
    "id": "item_30830",
    "Last Name": "Lloyd",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417609": {
    "id": "item_26094",
    "Last Name": "TSAI",
    "First Name": "HUNG-CHANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417623": {
    "id": "item_13777",
    "Last Name": "Behrens",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417628": {
    "id": "item_26093",
    "Last Name": "Hui",
    "First Name": "Yuen Kei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417777": {
    "id": "item_30827",
    "Last Name": "Lin",
    "First Name": "Yihong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417816": {
    "id": "item_3107",
    "Last Name": "Harrison",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417830": {
    "id": "item_1252",
    "Last Name": "Fatkin",
    "First Name": "Denis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417866": {
    "id": "item_13776",
    "Last Name": "McKew",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418103": {
    "id": "item_1248",
    "Last Name": "Chung",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418117": {
    "id": "item_3103",
    "Last Name": "Smith",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418128": {
    "id": "item_26087",
    "Last Name": "Khan",
    "First Name": "Rafi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418133": {
    "id": "item_1247",
    "Last Name": "Viens",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418164": {
    "id": "item_1246",
    "Last Name": "Xu",
    "First Name": "Guanrong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418233": {
    "id": "item_26084",
    "Last Name": "Allen",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418280": {
    "id": "item_13775",
    "Last Name": "Tjan",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418455": {
    "id": "item_26083",
    "Last Name": "Neira",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418544": {
    "id": "item_1243",
    "Last Name": "Veilleux",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418584": {
    "id": "item_26081",
    "Last Name": "Burce",
    "First Name": "Eric Vince",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418613": {
    "id": "item_3101",
    "Last Name": "Matranga",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418896": {
    "id": "item_28661",
    "Last Name": "Barkemeyer",
    "First Name": "Sven",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418974": {
    "id": "item_26078",
    "Last Name": "Bracamonte",
    "First Name": "Ana Lucia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37419247": {
    "id": "item_1241",
    "Last Name": "Yi",
    "First Name": "Yubeen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37419249": {
    "id": "item_3099",
    "Last Name": "TUGAL",
    "First Name": "MEHMET",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37419375": {
    "id": "item_28660",
    "Last Name": "Modi",
    "First Name": "Setu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37419425": {
    "id": "item_13767",
    "Last Name": "Gomez",
    "First Name": "Maria Adela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37419480": {
    "id": "item_1240",
    "Last Name": "Herzig",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37432265": {
    "id": "item_3096",
    "Last Name": "hafezi",
    "First Name": "ammaarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37434346": {
    "id": "item_30821",
    "Last Name": "Toh",
    "First Name": "Tze Yan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37449511": {
    "id": "item_1239",
    "Last Name": "Davies",
    "First Name": "Huw",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37460230": {
    "id": "item_16234",
    "Last Name": "Ledesma",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37470405": {
    "id": "item_1238",
    "Last Name": "Davis",
    "First Name": "Lachie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37473644": {
    "id": "item_13765",
    "Last Name": "Preli",
    "First Name": "Francis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37476000": {
    "id": "item_13764",
    "Last Name": "Travagini Milla de Oliveira",
    "First Name": "Ludmila",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37478249": {
    "id": "item_26067",
    "Last Name": "ELLIOTT",
    "First Name": "JONATHAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37479877": {
    "id": "item_13763",
    "Last Name": "Arnold",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480216": {
    "id": "item_26065",
    "Last Name": "Avtarovski",
    "First Name": "Daniella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480400": {
    "id": "item_13762",
    "Last Name": "Rodriguez Cyrman",
    "First Name": "Mariano",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480455": {
    "id": "item_30817",
    "Last Name": "Tully",
    "First Name": "Natika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480491": {
    "id": "item_3094",
    "Last Name": "Dungate",
    "First Name": "Tara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480585": {
    "id": "item_30816",
    "Last Name": "Mcgowan",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480652": {
    "id": "item_1405",
    "Last Name": "Winterton",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480845": {
    "id": "item_13761",
    "Last Name": "Martin",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480891": {
    "id": "item_1235",
    "Last Name": "Perillo",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481000": {
    "id": "item_26063",
    "Last Name": "Raath",
    "First Name": "George Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481098": {
    "id": "item_28652",
    "Last Name": "Harrison",
    "First Name": "Eboni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481238": {
    "id": "item_3093",
    "Last Name": "borowiec",
    "First Name": "thierry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481316": {
    "id": "item_13760",
    "Last Name": "melo",
    "First Name": "gabriela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481517": {
    "id": "item_30811",
    "Last Name": "mallion-woods",
    "First Name": "jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481523": {
    "id": "item_3091",
    "Last Name": "Caltabiano",
    "First Name": "Corena",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481534": {
    "id": "item_13758",
    "Last Name": "Fonseca Costa",
    "First Name": "Ana Cristina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481619": {
    "id": "item_26061",
    "Last Name": "Bell",
    "First Name": "Heather",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37482373": {
    "id": "item_3089",
    "Last Name": "Rutter",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37482485": {
    "id": "item_16325",
    "Last Name": "GALLEGOS",
    "First Name": "MARIA PIA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37482786": {
    "id": "item_26055",
    "Last Name": "Onishi",
    "First Name": "Hirokuni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37482942": {
    "id": "item_1233",
    "Last Name": "BARBOSA",
    "First Name": "GILBERT",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37482982": {
    "id": "item_30807",
    "Last Name": "Ningiga",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37483179": {
    "id": "item_26054",
    "Last Name": "Cooper",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37483363": {
    "id": "item_13756",
    "Last Name": "Spencer",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37483407": {
    "id": "item_1231",
    "Last Name": "Zeniou",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37483441": {
    "id": "item_26053",
    "Last Name": "Lloyd",
    "First Name": "Caleb",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37483661": {
    "id": "item_26050",
    "Last Name": "Chang",
    "First Name": "Yu-Hsin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37483663": {
    "id": "item_26051",
    "Last Name": "Bradicich",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484038": {
    "id": "item_28648",
    "Last Name": "Keatley",
    "First Name": "Josh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484069": {
    "id": "item_28858",
    "Last Name": "Vokas",
    "First Name": "Lindsey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484161": {
    "id": "item_1227",
    "Last Name": "Lane",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484197": {
    "id": "item_13753",
    "Last Name": "Arena",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484203": {
    "id": "item_30802",
    "Last Name": "kang",
    "First Name": "seongwook",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484542": {
    "id": "item_16230",
    "Last Name": "han",
    "First Name": "wookjun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484652": {
    "id": "item_13750",
    "Last Name": "De la Torre",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484812": {
    "id": "item_28646",
    "Last Name": "Dalla Costa",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484944": {
    "id": "item_26044",
    "Last Name": "Wang",
    "First Name": "Zhi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484966": {
    "id": "item_28857",
    "Last Name": "Cheng",
    "First Name": "sun fung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485167": {
    "id": "item_28644",
    "Last Name": "McIlroy",
    "First Name": "Maeve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485374": {
    "id": "item_13748",
    "Last Name": "Stigter",
    "First Name": "Jewel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485429": {
    "id": "item_28643",
    "Last Name": "Fabbri",
    "First Name": "Lesly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485457": {
    "id": "item_28642",
    "Last Name": "Ng",
    "First Name": "Yan Ting",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485580": {
    "id": "item_1225",
    "Last Name": "Grigsby",
    "First Name": "Rick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485954": {
    "id": "item_30799",
    "Last Name": "Rani",
    "First Name": "Ian Agisti Dewi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486051": {
    "id": "item_26042",
    "Last Name": "Robinson",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486114": {
    "id": "item_13746",
    "Last Name": "Weller",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486233": {
    "id": "item_28641",
    "Last Name": "Youn",
    "First Name": "Jeehye",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486311": {
    "id": "item_28640",
    "Last Name": "Wong",
    "First Name": "Yan Wah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486356": {
    "id": "item_30796",
    "Last Name": "Stewart",
    "First Name": "Walter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486611": {
    "id": "item_1404",
    "Last Name": "ZE",
    "First Name": "DU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486657": {
    "id": "item_1223",
    "Last Name": "WENG",
    "First Name": "MINGCHUAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486943": {
    "id": "item_26036",
    "Last Name": "Poettinger",
    "First Name": "Magdalena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486970": {
    "id": "item_3080",
    "Last Name": "Davidson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37487390": {
    "id": "item_26034",
    "Last Name": "To",
    "First Name": "Keith",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37487395": {
    "id": "item_26033",
    "Last Name": "Chotiros",
    "First Name": "Veeya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37487534": {
    "id": "item_30788",
    "Last Name": "Demchuk",
    "First Name": "Agata",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37487957": {
    "id": "item_26032",
    "Last Name": "Luo",
    "First Name": "Junhao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488305": {
    "id": "item_1218",
    "Last Name": "Lovett",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488363": {
    "id": "item_30787",
    "Last Name": "Dobson",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488402": {
    "id": "item_3078",
    "Last Name": "Hempton",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488467": {
    "id": "item_1216",
    "Last Name": "Barter",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488469": {
    "id": "item_26027",
    "Last Name": "Baker",
    "First Name": "Tori",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488570": {
    "id": "item_26026",
    "Last Name": "Bosman",
    "First Name": "Teofilus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488879": {
    "id": "item_30785",
    "Last Name": "Folsom",
    "First Name": "Mila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488963": {
    "id": "item_16225",
    "Last Name": "Hyang",
    "First Name": "Byunghak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488964": {
    "id": "item_1215",
    "Last Name": "Chu",
    "First Name": "Tze Fung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488981": {
    "id": "item_13730",
    "Last Name": "Chang",
    "First Name": "ShinTzu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489067": {
    "id": "item_26021",
    "Last Name": "Brombal",
    "First Name": "Daniele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489072": {
    "id": "item_3076",
    "Last Name": "McLeod",
    "First Name": "Darcy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489089": {
    "id": "item_26471",
    "Last Name": "Thompson",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489125": {
    "id": "item_26020",
    "Last Name": "Tramonte",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489150": {
    "id": "item_30783",
    "Last Name": "ainsworth",
    "First Name": "jessie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489316": {
    "id": "item_28631",
    "Last Name": "Ye",
    "First Name": "Fang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489439": {
    "id": "item_13727",
    "Last Name": "Carre",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489440": {
    "id": "item_1213",
    "Last Name": "park",
    "First Name": "junghyun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489551": {
    "id": "item_26018",
    "Last Name": "Zlotnik",
    "First Name": "Karsten",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489635": {
    "id": "item_13726",
    "Last Name": "Binbin",
    "First Name": "Zhang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489765": {
    "id": "item_28627",
    "Last Name": "Preston",
    "First Name": "Skye",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489793": {
    "id": "item_28626",
    "Last Name": "hwang",
    "First Name": "jungsoo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490079": {
    "id": "item_28625",
    "Last Name": "Rimba",
    "First Name": "Tjubong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490132": {
    "id": "item_30777",
    "Last Name": "Fauzi",
    "First Name": "Taufiq",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490173": {
    "id": "item_13725",
    "Last Name": "Walser",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490288": {
    "id": "item_31055",
    "Last Name": "Lee",
    "First Name": "Yun Joo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490389": {
    "id": "item_26010",
    "Last Name": "Brasileiro",
    "First Name": "Iago",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490404": {
    "id": "item_28623",
    "Last Name": "REN",
    "First Name": "KANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490426": {
    "id": "item_3070",
    "Last Name": "Allan",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490488": {
    "id": "item_30775",
    "Last Name": "Li",
    "First Name": "Chen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490520": {
    "id": "item_28622",
    "Last Name": "Zammit",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490726": {
    "id": "item_30774",
    "Last Name": "Wang",
    "First Name": "Zhengjie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490752": {
    "id": "item_13718",
    "Last Name": "Xu",
    "First Name": "Guangda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490801": {
    "id": "item_30773",
    "Last Name": "Myatt",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490867": {
    "id": "item_28620",
    "Last Name": "Song",
    "First Name": "Xiaomei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490921": {
    "id": "item_13715",
    "Last Name": "Horgan",
    "First Name": "Caolum",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490922": {
    "id": "item_30772",
    "Last Name": "Orpen",
    "First Name": "Emiko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490984": {
    "id": "item_28618",
    "Last Name": "Monteiro",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491044": {
    "id": "item_13713",
    "Last Name": "Buchanan",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491051": {
    "id": "item_28617",
    "Last Name": "KI",
    "First Name": "SIAO HANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491069": {
    "id": "item_1204",
    "Last Name": "Thiele",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491092": {
    "id": "item_30771",
    "Last Name": "Wayman",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491158": {
    "id": "item_28616",
    "Last Name": "Sheridan",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491199": {
    "id": "item_13711",
    "Last Name": "Watson",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491202": {
    "id": "item_3065",
    "Last Name": "Joshy",
    "First Name": "Sino",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491277": {
    "id": "item_1202",
    "Last Name": "McDougall",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491373": {
    "id": "item_1200",
    "Last Name": "Custance-Thurston",
    "First Name": "Letitia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491389": {
    "id": "item_3063",
    "Last Name": "Coleman",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491421": {
    "id": "item_30765",
    "Last Name": "Poll",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491455": {
    "id": "item_30764",
    "Last Name": "Debelle",
    "First Name": "Arno",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491458": {
    "id": "item_30763",
    "Last Name": "Doidge",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491461": {
    "id": "item_25996",
    "Last Name": "Jagger",
    "First Name": "Jake",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491492": {
    "id": "item_25993",
    "Last Name": "Csik",
    "First Name": "Nikolett",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491607": {
    "id": "item_30762",
    "Last Name": "Charters",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491931": {
    "id": "item_25988",
    "Last Name": "Peng",
    "First Name": "WeiTe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491988": {
    "id": "item_25987",
    "Last Name": "Deller",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492136": {
    "id": "item_1197",
    "Last Name": "Knevett",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492244": {
    "id": "item_25984",
    "Last Name": "Van Niekerk",
    "First Name": "Etienne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492316": {
    "id": "item_25983",
    "Last Name": "Edebiri",
    "First Name": "Uyi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492378": {
    "id": "item_1196",
    "Last Name": "LU",
    "First Name": "KUANYU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492387": {
    "id": "item_25982",
    "Last Name": "Lau",
    "First Name": "Hiu Wai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492408": {
    "id": "item_28856",
    "Last Name": "Pua",
    "First Name": "Jielor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492478": {
    "id": "item_3057",
    "Last Name": "WU",
    "First Name": "JING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492482": {
    "id": "item_28607",
    "Last Name": "Krahe",
    "First Name": "Sheldon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492562": {
    "id": "item_26470",
    "Last Name": "Roe",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492788": {
    "id": "item_14017",
    "Last Name": "Murphy",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492875": {
    "id": "item_25977",
    "Last Name": "Vuu",
    "First Name": "Henry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37493118": {
    "id": "item_16324",
    "Last Name": "Daniswara",
    "First Name": "Nanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37493149": {
    "id": "item_16218",
    "Last Name": "Tangsongjaroen",
    "First Name": "Chairat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37493460": {
    "id": "item_3241",
    "Last Name": "Arnold",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37493779": {
    "id": "item_30756",
    "Last Name": "N’ Bhroin",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37493835": {
    "id": "item_13707",
    "Last Name": "Tsz Yan",
    "First Name": "Lau",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37494280": {
    "id": "item_13706",
    "Last Name": "Smith",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37494282": {
    "id": "item_28605",
    "Last Name": "Pratama Mahindra",
    "First Name": "Mohamad Harrys",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37494597": {
    "id": "item_16217",
    "Last Name": "Cairns",
    "First Name": "Taryn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37494657": {
    "id": "item_25975",
    "Last Name": "Nelson",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37494664": {
    "id": "item_30754",
    "Last Name": "Varndell",
    "First Name": "Kristi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37494724": {
    "id": "item_25974",
    "Last Name": "Orlando",
    "First Name": "Jacey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37494876": {
    "id": "item_28604",
    "Last Name": "Kitt",
    "First Name": "Frances",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495058": {
    "id": "item_28603",
    "Last Name": "Gonzalez",
    "First Name": "Angeles",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495098": {
    "id": "item_28855",
    "Last Name": "Gunadi",
    "First Name": "Kaleb Marcel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495159": {
    "id": "item_13704",
    "Last Name": "Pang",
    "First Name": "Tak Tai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495326": {
    "id": "item_13703",
    "Last Name": "Crowle",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495369": {
    "id": "item_1403",
    "Last Name": "Deitsch",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495374": {
    "id": "item_3055",
    "Last Name": "Ho",
    "First Name": "Kin Lung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495393": {
    "id": "item_13702",
    "Last Name": "Ross",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495912": {
    "id": "item_1192",
    "Last Name": "Torres Gonzalez",
    "First Name": "Alejandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495987": {
    "id": "item_25969",
    "Last Name": "Kumaraswamy",
    "First Name": "Deepak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37496486": {
    "id": "item_1190",
    "Last Name": "Tucker",
    "First Name": "Guy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37496755": {
    "id": "item_28601",
    "Last Name": "Junod",
    "First Name": "Renee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37496942": {
    "id": "item_13696",
    "Last Name": "Stevens",
    "First Name": "Cian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497479": {
    "id": "item_30751",
    "Last Name": "Daniell",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497627": {
    "id": "item_13694",
    "Last Name": "Clarke",
    "First Name": "Dave",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497641": {
    "id": "item_18561",
    "Last Name": "Nishimatsu",
    "First Name": "Kento",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497751": {
    "id": "item_30750",
    "Last Name": "Cleverley",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497968": {
    "id": "item_3051",
    "Last Name": "Hutchinson",
    "First Name": "Helen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497989": {
    "id": "item_18559",
    "Last Name": "Young",
    "First Name": "Rory",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37498176": {
    "id": "item_18557",
    "Last Name": "Reid",
    "First Name": "Calum",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37499851": {
    "id": "item_25965",
    "Last Name": "Williams",
    "First Name": "Yasmin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37500641": {
    "id": "item_28600",
    "Last Name": "Lushbough",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37501726": {
    "id": "item_18556",
    "Last Name": "CHONG",
    "First Name": "WAN WAI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37507428": {
    "id": "item_1187",
    "Last Name": "Hall",
    "First Name": "Travis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37508848": {
    "id": "item_25963",
    "Last Name": "Karger",
    "First Name": "Shannen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509225": {
    "id": "item_18554",
    "Last Name": "Kember",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509344": {
    "id": "item_25961",
    "Last Name": "Lam",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509444": {
    "id": "item_13692",
    "Last Name": "Shaw",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509589": {
    "id": "item_28599",
    "Last Name": "Mack",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509735": {
    "id": "item_13691",
    "Last Name": "Firth",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509786": {
    "id": "item_25959",
    "Last Name": "Mack",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510035": {
    "id": "item_25958",
    "Last Name": "Wood",
    "First Name": "Yasmin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510082": {
    "id": "item_3047",
    "Last Name": "Begbie",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510249": {
    "id": "item_1184",
    "Last Name": "McWhirter",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510257": {
    "id": "item_13689",
    "Last Name": "Handscombe",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510261": {
    "id": "item_25956",
    "Last Name": "Komarova",
    "First Name": "Daria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510809": {
    "id": "item_13688",
    "Last Name": "Howard",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37512564": {
    "id": "item_30741",
    "Last Name": "Villesca",
    "First Name": "Asher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37512668": {
    "id": "item_3043",
    "Last Name": "Thompson",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37512863": {
    "id": "item_13685",
    "Last Name": "ZHUO",
    "First Name": "YILI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37513473": {
    "id": "item_26469",
    "Last Name": "Talintyre",
    "First Name": "Nick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37513653": {
    "id": "item_28593",
    "Last Name": "Adare",
    "First Name": "Charles",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37513853": {
    "id": "item_18545",
    "Last Name": "Webster",
    "First Name": "Jacqui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37513999": {
    "id": "item_25948",
    "Last Name": "Suzuki",
    "First Name": "Takafumi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514342": {
    "id": "item_1178",
    "Last Name": "Khan",
    "First Name": "Farhad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514418": {
    "id": "item_18538",
    "Last Name": "MAK",
    "First Name": "PUI YI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514449": {
    "id": "item_1175",
    "Last Name": "Archer",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514466": {
    "id": "item_18540",
    "Last Name": "Adiputra",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514522": {
    "id": "item_18534",
    "Last Name": "shang",
    "First Name": "haitao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514630": {
    "id": "item_13682",
    "Last Name": "Cotter",
    "First Name": "Louis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514670": {
    "id": "item_30736",
    "Last Name": "Maxwell",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515134": {
    "id": "item_30734",
    "Last Name": "Smith",
    "First Name": "Edmund",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515265": {
    "id": "item_25936",
    "Last Name": "O'Donnell",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515348": {
    "id": "item_25935",
    "Last Name": "WU",
    "First Name": "CHIH-YING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515395": {
    "id": "item_30732",
    "Last Name": "SAU WAI",
    "First Name": "CHOI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515418": {
    "id": "item_30733",
    "Last Name": "Stockley",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515546": {
    "id": "item_25930",
    "Last Name": "Stepatschuk",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515631": {
    "id": "item_18525",
    "Last Name": "Breen",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515707": {
    "id": "item_18524",
    "Last Name": "Kwong",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515771": {
    "id": "item_30730",
    "Last Name": "Massey",
    "First Name": "Cath",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515883": {
    "id": "item_28587",
    "Last Name": "CHANG",
    "First Name": "YA-HUI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516037": {
    "id": "item_28586",
    "Last Name": "Jeong",
    "First Name": "Cheoluk",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516122": {
    "id": "item_30727",
    "Last Name": "Martin",
    "First Name": "Cally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516180": {
    "id": "item_1167",
    "Last Name": "Velasquez",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516344": {
    "id": "item_18518",
    "Last Name": "Newton",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516459": {
    "id": "item_30725",
    "Last Name": "Liu",
    "First Name": "Sing Keung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516504": {
    "id": "item_1165",
    "Last Name": "Hanrahan",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516507": {
    "id": "item_18516",
    "Last Name": "Tolley",
    "First Name": "Zach",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516710": {
    "id": "item_13674",
    "Last Name": "Koh",
    "First Name": "Kai Wai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516821": {
    "id": "item_3032",
    "Last Name": "Deem",
    "First Name": "Robby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37517030": {
    "id": "item_28582",
    "Last Name": "chan",
    "First Name": "nga hei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37517058": {
    "id": "item_28581",
    "Last Name": "Baek",
    "First Name": "SungHee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37517598": {
    "id": "item_13671",
    "Last Name": "Mendez",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37517992": {
    "id": "item_18510",
    "Last Name": "Omeara",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37517993": {
    "id": "item_18509",
    "Last Name": "Fernandez Banderas",
    "First Name": "Melania",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518015": {
    "id": "item_13668",
    "Last Name": "Loo",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518020": {
    "id": "item_1161",
    "Last Name": "Kagera",
    "First Name": "Crispine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518070": {
    "id": "item_1160",
    "Last Name": "Mangos",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518071": {
    "id": "item_25919",
    "Last Name": "Broadbent",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518119": {
    "id": "item_13666",
    "Last Name": "Marshall",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518208": {
    "id": "item_25915",
    "Last Name": "Erkinov",
    "First Name": "Shokhrukhbek",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518408": {
    "id": "item_16205",
    "Last Name": "shi",
    "First Name": "xiaojian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518573": {
    "id": "item_1158",
    "Last Name": "Supasap",
    "First Name": "Tanrug",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518756": {
    "id": "item_30719",
    "Last Name": "Sulistio",
    "First Name": "Agus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518879": {
    "id": "item_25905",
    "Last Name": "Dean",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519094": {
    "id": "item_14016",
    "Last Name": "Lambert",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519100": {
    "id": "item_30718",
    "Last Name": "Gang",
    "First Name": "Liu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519138": {
    "id": "item_18497",
    "Last Name": "HENG",
    "First Name": "VANTHEY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519175": {
    "id": "item_3027",
    "Last Name": "Penney-Smith",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519196": {
    "id": "item_25903",
    "Last Name": "Monks",
    "First Name": "Eidan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519247": {
    "id": "item_18496",
    "Last Name": "jonathan",
    "First Name": "chan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519259": {
    "id": "item_25901",
    "Last Name": "Nock",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519397": {
    "id": "item_30717",
    "Last Name": "kanotra",
    "First Name": "neha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519595": {
    "id": "item_28572",
    "Last Name": "Chiko",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519649": {
    "id": "item_25900",
    "Last Name": "Wise",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519696": {
    "id": "item_1150",
    "Last Name": "Kiley",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519784": {
    "id": "item_13661",
    "Last Name": "Adams",
    "First Name": "Liz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519795": {
    "id": "item_18488",
    "Last Name": "Nair",
    "First Name": "Ashvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519804": {
    "id": "item_1148",
    "Last Name": "OBrien",
    "First Name": "Cilliam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519829": {
    "id": "item_13660",
    "Last Name": "Chang",
    "First Name": "Hui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519843": {
    "id": "item_25898",
    "Last Name": "Lee",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519850": {
    "id": "item_13657",
    "Last Name": "Asisi Laksana Kesuma",
    "First Name": "Fransiskus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519922": {
    "id": "item_13655",
    "Last Name": "Narits",
    "First Name": "Arko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520077": {
    "id": "item_18483",
    "Last Name": "DiPaola",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520153": {
    "id": "item_25894",
    "Last Name": "Coe",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520237": {
    "id": "item_18480",
    "Last Name": "Mok",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520239": {
    "id": "item_3020",
    "Last Name": "Prabakar",
    "First Name": "Shaan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520308": {
    "id": "item_13651",
    "Last Name": "Livingstone",
    "First Name": "Monica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520507": {
    "id": "item_1145",
    "Last Name": "HAKKAR",
    "First Name": "OLIVIER",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520627": {
    "id": "item_25888",
    "Last Name": "Vishchuk",
    "First Name": "Yuliya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520716": {
    "id": "item_13649",
    "Last Name": "James",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520719": {
    "id": "item_16200",
    "Last Name": "van Heerden",
    "First Name": "Vaughan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520831": {
    "id": "item_30708",
    "Last Name": "Berger",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520945": {
    "id": "item_25884",
    "Last Name": "Garcha",
    "First Name": "Jas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520947": {
    "id": "item_18469",
    "Last Name": "Wenti",
    "First Name": "Dedy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521040": {
    "id": "item_18467",
    "Last Name": "CHIU",
    "First Name": "TSZ KI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521149": {
    "id": "item_3019",
    "Last Name": "LIN",
    "First Name": "SHU HSIEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521288": {
    "id": "item_25881",
    "Last Name": "Poh",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521381": {
    "id": "item_28562",
    "Last Name": "Joshi",
    "First Name": "Jashan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521536": {
    "id": "item_16199",
    "Last Name": "Uasomsaksakul",
    "First Name": "Suwicha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521553": {
    "id": "item_16323",
    "Last Name": "Oh",
    "First Name": "Younghwa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521614": {
    "id": "item_13647",
    "Last Name": "Schwab",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521672": {
    "id": "item_30703",
    "Last Name": "Umpleby",
    "First Name": "Debra Ann",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521681": {
    "id": "item_25879",
    "Last Name": "Kusdi",
    "First Name": "Suhariyanto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521745": {
    "id": "item_25878",
    "Last Name": "Ashworth",
    "First Name": "Greg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521792": {
    "id": "item_30702",
    "Last Name": "Liao",
    "First Name": "Fang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521828": {
    "id": "item_3015",
    "Last Name": "LEUNG",
    "First Name": "KING WA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37522094": {
    "id": "item_18461",
    "Last Name": "Wu",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37522387": {
    "id": "item_13645",
    "Last Name": "LUK",
    "First Name": "MAN CHUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37522660": {
    "id": "item_3014",
    "Last Name": "Gerrard",
    "First Name": "Brynne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37522797": {
    "id": "item_28558",
    "Last Name": "Sharow",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37522808": {
    "id": "item_18460",
    "Last Name": "Boller",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37522941": {
    "id": "item_13644",
    "Last Name": "Yap",
    "First Name": "Erwin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37523361": {
    "id": "item_13643",
    "Last Name": "Mmamakoko",
    "First Name": "Aubrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37523604": {
    "id": "item_18458",
    "Last Name": "Signer",
    "First Name": "Karina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37523613": {
    "id": "item_25872",
    "Last Name": "Roberts",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37523642": {
    "id": "item_1138",
    "Last Name": "Saliwa",
    "First Name": "Bulela Mcinga",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37523769": {
    "id": "item_1137",
    "Last Name": "Xie",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37524293": {
    "id": "item_25870",
    "Last Name": "MOYA ARANZUBIA",
    "First Name": "MARIA ROSA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37524370": {
    "id": "item_28556",
    "Last Name": "PALACIOS",
    "First Name": "JORGE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37525176": {
    "id": "item_26405",
    "Last Name": "Koh",
    "First Name": "Myung Gyu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37525246": {
    "id": "item_18456",
    "Last Name": "Burgess",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37530131": {
    "id": "item_30698",
    "Last Name": "Pribadi",
    "First Name": "Reza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37535996": {
    "id": "item_18452",
    "Last Name": "Bosnjak",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37539206": {
    "id": "item_25868",
    "Last Name": "Sprecher",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37547866": {
    "id": "item_18447",
    "Last Name": "Liveriadis",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37547917": {
    "id": "item_16193",
    "Last Name": "Nerhood",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37548735": {
    "id": "item_30696",
    "Last Name": "McCabe",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556021": {
    "id": "item_30694",
    "Last Name": "Legoe",
    "First Name": "Charles",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556036": {
    "id": "item_25865",
    "Last Name": "Reedman",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556104": {
    "id": "item_30693",
    "Last Name": "Legoe",
    "First Name": "Sile",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556572": {
    "id": "item_28553",
    "Last Name": "Hennessy",
    "First Name": "Isobel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556593": {
    "id": "item_18441",
    "Last Name": "Yarwood",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556653": {
    "id": "item_1131",
    "Last Name": "White",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556662": {
    "id": "item_18439",
    "Last Name": "Okamoto",
    "First Name": "Taro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556820": {
    "id": "item_30691",
    "Last Name": "Sangalang",
    "First Name": "Rose Carmille",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556950": {
    "id": "item_30689",
    "Last Name": "Ravi",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556993": {
    "id": "item_28550",
    "Last Name": "Ririassa",
    "First Name": "david",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37557179": {
    "id": "item_13636",
    "Last Name": "Kamrath",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37557187": {
    "id": "item_3007",
    "Last Name": "Bouffler",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558091": {
    "id": "item_18435",
    "Last Name": "Bernal",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558155": {
    "id": "item_13633",
    "Last Name": "Roberts",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558251": {
    "id": "item_25857",
    "Last Name": "Jumhardani",
    "First Name": "Jumhardani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558275": {
    "id": "item_25858",
    "Last Name": "OÕDonovan",
    "First Name": "Archie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558334": {
    "id": "item_30686",
    "Last Name": "George",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558414": {
    "id": "item_18432",
    "Last Name": "Caci",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558459": {
    "id": "item_30682",
    "Last Name": "Delos Angeles",
    "First Name": "Florence",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558464": {
    "id": "item_25855",
    "Last Name": "Cabot",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558528": {
    "id": "item_30683",
    "Last Name": "Monaco Tan",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558754": {
    "id": "item_25851",
    "Last Name": "Hannah",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37559220": {
    "id": "item_18426",
    "Last Name": "Birch",
    "First Name": "Paloma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37559277": {
    "id": "item_1124",
    "Last Name": "Hukins",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37559287": {
    "id": "item_28545",
    "Last Name": "Gerena",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37559335": {
    "id": "item_28544",
    "Last Name": "HO",
    "First Name": "NIEN YI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37559373": {
    "id": "item_13631",
    "Last Name": "Hose",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560518": {
    "id": "item_16190",
    "Last Name": "Virochpoka",
    "First Name": "Buskorn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560541": {
    "id": "item_28854",
    "Last Name": "Xiao",
    "First Name": "Meiqin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560578": {
    "id": "item_25846",
    "Last Name": "Rasolomalala",
    "First Name": "Mathilde",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560623": {
    "id": "item_18422",
    "Last Name": "Iasello",
    "First Name": "Sabrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560720": {
    "id": "item_18421",
    "Last Name": "Lee",
    "First Name": "Kihyun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560772": {
    "id": "item_28542",
    "Last Name": "Nugroho Putra",
    "First Name": "Bimowisda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560789": {
    "id": "item_3000",
    "Last Name": "Ashen",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560884": {
    "id": "item_16189",
    "Last Name": "Merrilees",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37561419": {
    "id": "item_28535",
    "Last Name": "Vasconcellos",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37561446": {
    "id": "item_25843",
    "Last Name": "Phillips",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37561522": {
    "id": "item_2998",
    "Last Name": "KANG",
    "First Name": "CHIUNGCHIH",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37561693": {
    "id": "item_28534",
    "Last Name": "Zhang",
    "First Name": "Hong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37561730": {
    "id": "item_18419",
    "Last Name": "Aji",
    "First Name": "Yunus Kuntawi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562161": {
    "id": "item_28533",
    "Last Name": "Knight",
    "First Name": "Colleen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562284": {
    "id": "item_1115",
    "Last Name": "Burt",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562366": {
    "id": "item_13625",
    "Last Name": "HO",
    "First Name": "Kam Wing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562384": {
    "id": "item_18415",
    "Last Name": "Cooke",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562539": {
    "id": "item_13623",
    "Last Name": "Khoudair",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562541": {
    "id": "item_18413",
    "Last Name": "JANG",
    "First Name": "Hyun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562570": {
    "id": "item_16188",
    "Last Name": "Ronchi",
    "First Name": "Bernard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562573": {
    "id": "item_18410",
    "Last Name": "Firdayanti",
    "First Name": "Vanisia Hayu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562626": {
    "id": "item_30679",
    "Last Name": "Hahn",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37563412": {
    "id": "item_28530",
    "Last Name": "Chargros",
    "First Name": "Lou",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565202": {
    "id": "item_25838",
    "Last Name": "Williamson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565250": {
    "id": "item_25837",
    "Last Name": "Leigh",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565340": {
    "id": "item_25835",
    "Last Name": "Gao",
    "First Name": "LinBo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565390": {
    "id": "item_25833",
    "Last Name": "Neville",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565753": {
    "id": "item_30678",
    "Last Name": "Clifton",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565831": {
    "id": "item_30677",
    "Last Name": "Thiele",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565927": {
    "id": "item_28526",
    "Last Name": "Yeap",
    "First Name": "Saw Khuan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566025": {
    "id": "item_25829",
    "Last Name": "Manning",
    "First Name": "Caris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566125": {
    "id": "item_25827",
    "Last Name": "Holt",
    "First Name": "Phoebe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566440": {
    "id": "item_2994",
    "Last Name": "Fong",
    "First Name": "Tsz Lok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566496": {
    "id": "item_25826",
    "Last Name": "Mark",
    "First Name": "Kar Fai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566531": {
    "id": "item_3240",
    "Last Name": "Huihui",
    "First Name": "Mao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566538": {
    "id": "item_1111",
    "Last Name": "Champion",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566545": {
    "id": "item_18397",
    "Last Name": "Low",
    "First Name": "Bryant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566560": {
    "id": "item_18396",
    "Last Name": "Lance",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566574": {
    "id": "item_13618",
    "Last Name": "Sambell",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566642": {
    "id": "item_1110",
    "Last Name": "Pembroke",
    "First Name": "Sigrid",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566665": {
    "id": "item_13617",
    "Last Name": "Wessels",
    "First Name": "Luca",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566693": {
    "id": "item_25823",
    "Last Name": "Jones",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566818": {
    "id": "item_25821",
    "Last Name": "Anuar",
    "First Name": "Mohd Razealy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567032": {
    "id": "item_18390",
    "Last Name": "Ernsting",
    "First Name": "Chiara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567082": {
    "id": "item_30670",
    "Last Name": "Fu",
    "First Name": "Chun Fa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567110": {
    "id": "item_25820",
    "Last Name": "White",
    "First Name": "Jake",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567118": {
    "id": "item_13612",
    "Last Name": "Hodgson",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567164": {
    "id": "item_28520",
    "Last Name": "Davies",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567167": {
    "id": "item_25818",
    "Last Name": "Pella",
    "First Name": "Romain",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567184": {
    "id": "item_18387",
    "Last Name": "Ko",
    "First Name": "Desmond",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567279": {
    "id": "item_25813",
    "Last Name": "Saveka",
    "First Name": "Nickalus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567344": {
    "id": "item_28517",
    "Last Name": "Shah",
    "First Name": "Eveena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567364": {
    "id": "item_25810",
    "Last Name": "Palmer",
    "First Name": "Greg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567390": {
    "id": "item_13608",
    "Last Name": "CHIRSTIAN",
    "First Name": "DENNY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567412": {
    "id": "item_13607",
    "Last Name": "MACELLINA",
    "First Name": "DELVITA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567484": {
    "id": "item_2986",
    "Last Name": "Jian",
    "First Name": "Mou",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567489": {
    "id": "item_18383",
    "Last Name": "Cox",
    "First Name": "Rowan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567591": {
    "id": "item_16183",
    "Last Name": "SEO",
    "First Name": "JUNHO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567607": {
    "id": "item_25805",
    "Last Name": "McKenzie-Low",
    "First Name": "Ashlea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567670": {
    "id": "item_25804",
    "Last Name": "Jackson",
    "First Name": "Adele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567792": {
    "id": "item_18379",
    "Last Name": "Calladine",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567820": {
    "id": "item_25802",
    "Last Name": "Gandabhai",
    "First Name": "Shefali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567882": {
    "id": "item_1105",
    "Last Name": "Thomson",
    "First Name": "Glen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567973": {
    "id": "item_1104",
    "Last Name": "cheng",
    "First Name": "mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567991": {
    "id": "item_13605",
    "Last Name": "YANG",
    "First Name": "SUHWA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568028": {
    "id": "item_18378",
    "Last Name": "Li",
    "First Name": "ChungYuan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568082": {
    "id": "item_18376",
    "Last Name": "Fong",
    "First Name": "Amos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568125": {
    "id": "item_18375",
    "Last Name": "Coe",
    "First Name": "Elijah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568129": {
    "id": "item_30663",
    "Last Name": "OÕMalley",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568317": {
    "id": "item_28853",
    "Last Name": "Indranugroho",
    "First Name": "Demmy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568320": {
    "id": "item_1102",
    "Last Name": "Frioux",
    "First Name": "Aurelien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568401": {
    "id": "item_18371",
    "Last Name": "C—rdova",
    "First Name": "Diana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568643": {
    "id": "item_18370",
    "Last Name": "Farr",
    "First Name": "Venice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568691": {
    "id": "item_25793",
    "Last Name": "Chi",
    "First Name": "Yilin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568743": {
    "id": "item_1098",
    "Last Name": "Dunn",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568745": {
    "id": "item_1096",
    "Last Name": "WEI",
    "First Name": "FANG JIE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568753": {
    "id": "item_18366",
    "Last Name": "Vasiuk",
    "First Name": "Mila",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568768": {
    "id": "item_18369",
    "Last Name": "PELLEGRINO",
    "First Name": "DANIELE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568776": {
    "id": "item_30660",
    "Last Name": "Chan Sui Ko",
    "First Name": "Christelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568825": {
    "id": "item_13600",
    "Last Name": "Contreras",
    "First Name": "Cristian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568862": {
    "id": "item_30657",
    "Last Name": "Wong Ping Lun",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568980": {
    "id": "item_13599",
    "Last Name": "Hugo",
    "First Name": "Andjela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37570579": {
    "id": "item_25789",
    "Last Name": "Sevilla",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37576289": {
    "id": "item_30655",
    "Last Name": "HSU",
    "First Name": "TZYMEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37578306": {
    "id": "item_25788",
    "Last Name": "Noia",
    "First Name": "Marisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37578443": {
    "id": "item_30654",
    "Last Name": "Agustin",
    "First Name": "Maricris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37578485": {
    "id": "item_2980",
    "Last Name": "Gorny",
    "First Name": "Conrad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37587849": {
    "id": "item_25787",
    "Last Name": "Wirajaya",
    "First Name": "Adi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37594551": {
    "id": "item_1094",
    "Last Name": "Barchalk",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37595567": {
    "id": "item_25785",
    "Last Name": "Leigh",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37597377": {
    "id": "item_18357",
    "Last Name": "Fitzpatrick",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37597718": {
    "id": "item_1402",
    "Last Name": "Goodliffe",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37600184": {
    "id": "item_1372",
    "Last Name": "Nelson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37610285": {
    "id": "item_13594",
    "Last Name": "Milam",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37620571": {
    "id": "item_1091",
    "Last Name": "Costello",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37630510": {
    "id": "item_13592",
    "Last Name": "Heitkamp",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37631433": {
    "id": "item_13591",
    "Last Name": "Buti",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37631652": {
    "id": "item_13590",
    "Last Name": "van der Zwan",
    "First Name": "Marianne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37632171": {
    "id": "item_13589",
    "Last Name": "Iantorno",
    "First Name": "Micaela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37632546": {
    "id": "item_1089",
    "Last Name": "Uhler",
    "First Name": "Olive",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37632813": {
    "id": "item_25780",
    "Last Name": "Ashar",
    "First Name": "Harekrishna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37632814": {
    "id": "item_1088",
    "Last Name": "Johnston-Hall",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37633055": {
    "id": "item_18344",
    "Last Name": "Zietsch",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37643488": {
    "id": "item_30647",
    "Last Name": "Sedgwick",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37643647": {
    "id": "item_25778",
    "Last Name": "Lee",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37643662": {
    "id": "item_1401",
    "Last Name": "valente",
    "First Name": "andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645118": {
    "id": "item_13585",
    "Last Name": "Smark",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645245": {
    "id": "item_25776",
    "Last Name": "Donald",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645294": {
    "id": "item_25775",
    "Last Name": "Robinson",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645338": {
    "id": "item_18337",
    "Last Name": "Nesci",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645421": {
    "id": "item_1085",
    "Last Name": "Guidi",
    "First Name": "Honorat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645501": {
    "id": "item_1083",
    "Last Name": "Nugent",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645566": {
    "id": "item_2970",
    "Last Name": "Truong",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645879": {
    "id": "item_1082",
    "Last Name": "Robinson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645947": {
    "id": "item_18334",
    "Last Name": "Clarkson",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646028": {
    "id": "item_18335",
    "Last Name": "Zaki",
    "First Name": "Achmad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646056": {
    "id": "item_25767",
    "Last Name": "Fredrickson",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646062": {
    "id": "item_13583",
    "Last Name": "Cullen",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646140": {
    "id": "item_25766",
    "Last Name": "Schweinberger",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646162": {
    "id": "item_13582",
    "Last Name": "Du",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646294": {
    "id": "item_18332",
    "Last Name": "WANG",
    "First Name": "YIZHAO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646300": {
    "id": "item_18331",
    "Last Name": "Irawan Nurfajar",
    "First Name": "Reza",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646562": {
    "id": "item_30635",
    "Last Name": "Luo",
    "First Name": "Jie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646578": {
    "id": "item_2967",
    "Last Name": "Wilkinson",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646655": {
    "id": "item_18330",
    "Last Name": "Bustos Lara",
    "First Name": "Alvaro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646794": {
    "id": "item_13577",
    "Last Name": "Hayne",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646884": {
    "id": "item_30634",
    "Last Name": "Marsden",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646981": {
    "id": "item_18327",
    "Last Name": "Berry",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647086": {
    "id": "item_18325",
    "Last Name": "Dinata",
    "First Name": "Herman",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647163": {
    "id": "item_2963",
    "Last Name": "Corona de la Cruz",
    "First Name": "Olga",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647185": {
    "id": "item_1079",
    "Last Name": "DEVENEY",
    "First Name": "JACK",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647269": {
    "id": "item_13573",
    "Last Name": "Hanlon",
    "First Name": "Ciara Jo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647479": {
    "id": "item_18323",
    "Last Name": "Porter",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647526": {
    "id": "item_26468",
    "Last Name": "Wright",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647845": {
    "id": "item_18321",
    "Last Name": "Taylor",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647919": {
    "id": "item_25760",
    "Last Name": "Close",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37648022": {
    "id": "item_2959",
    "Last Name": "chavez montoya",
    "First Name": "dayani",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37648573": {
    "id": "item_2958",
    "Last Name": "LU",
    "First Name": "YICONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37648586": {
    "id": "item_13570",
    "Last Name": "Gleeson",
    "First Name": "Mahoney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37648789": {
    "id": "item_2956",
    "Last Name": "Sutton",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37649663": {
    "id": "item_25755",
    "Last Name": "Roach",
    "First Name": "Mel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37649778": {
    "id": "item_18309",
    "Last Name": "Lilis",
    "First Name": "Lilis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650007": {
    "id": "item_13568",
    "Last Name": "Barclay",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650051": {
    "id": "item_13566",
    "Last Name": "Austin",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650279": {
    "id": "item_18306",
    "Last Name": "Gonzales",
    "First Name": "Caryl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650293": {
    "id": "item_13565",
    "Last Name": "Reid",
    "First Name": "Noah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650298": {
    "id": "item_1073",
    "Last Name": "Crabb",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650336": {
    "id": "item_13564",
    "Last Name": "Huang",
    "First Name": "Jinqian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650405": {
    "id": "item_30623",
    "Last Name": "Seonghun",
    "First Name": "Hong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650588": {
    "id": "item_30620",
    "Last Name": "Antonio",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650642": {
    "id": "item_26467",
    "Last Name": "Wijaya",
    "First Name": "Andi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650703": {
    "id": "item_28496",
    "Last Name": "MISA",
    "First Name": "KATHLYN RUTH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650946": {
    "id": "item_28494",
    "Last Name": "Townsend",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650951": {
    "id": "item_18300",
    "Last Name": "Kopp",
    "First Name": "Jennell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651321": {
    "id": "item_18298",
    "Last Name": "Godfrey",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651376": {
    "id": "item_28493",
    "Last Name": "Patel",
    "First Name": "Prajay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651460": {
    "id": "item_13556",
    "Last Name": "Nothman",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651463": {
    "id": "item_2952",
    "Last Name": "Kim",
    "First Name": "Sun Hee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651485": {
    "id": "item_2951",
    "Last Name": "YEN",
    "First Name": "SHIH JUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651734": {
    "id": "item_16168",
    "Last Name": "Warneke",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651847": {
    "id": "item_18292",
    "Last Name": "Croft",
    "First Name": "Zach",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651855": {
    "id": "item_25735",
    "Last Name": "Zhang",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651868": {
    "id": "item_18291",
    "Last Name": "Bourke",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651873": {
    "id": "item_25733",
    "Last Name": "CHENG",
    "First Name": "QIAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652024": {
    "id": "item_18286",
    "Last Name": "ZHOU",
    "First Name": "JIANJUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652091": {
    "id": "item_1065",
    "Last Name": "CIOU",
    "First Name": "JHENG-MIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652161": {
    "id": "item_30613",
    "Last Name": "Thiers",
    "First Name": "Geanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652228": {
    "id": "item_1062",
    "Last Name": "Knott",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652262": {
    "id": "item_28490",
    "Last Name": "Filipas",
    "First Name": "Doina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652274": {
    "id": "item_30612",
    "Last Name": "Boylan",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652287": {
    "id": "item_2946",
    "Last Name": "Tchibonkola",
    "First Name": "Jeremie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652333": {
    "id": "item_18277",
    "Last Name": "ferrell",
    "First Name": "wayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652339": {
    "id": "item_3239",
    "Last Name": "Perry",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652371": {
    "id": "item_26466",
    "Last Name": "Slade",
    "First Name": "Greg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652419": {
    "id": "item_30610",
    "Last Name": null,
    "First Name": "HYOBIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652467": {
    "id": "item_18274",
    "Last Name": "Christis",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652687": {
    "id": "item_13547",
    "Last Name": "Mizusaki",
    "First Name": "Sho",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652694": {
    "id": "item_30607",
    "Last Name": "Fox",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652872": {
    "id": "item_30606",
    "Last Name": "McNamee",
    "First Name": "çine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652892": {
    "id": "item_25712",
    "Last Name": "Baldasso",
    "First Name": "Paula",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652946": {
    "id": "item_18266",
    "Last Name": "Fšldv‡ri",
    "First Name": "Tam‡s",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652998": {
    "id": "item_25710",
    "Last Name": "Hossain",
    "First Name": "Mohammed",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37653025": {
    "id": "item_13545",
    "Last Name": "Austin Mena",
    "First Name": "Clark Lee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37653182": {
    "id": "item_18265",
    "Last Name": "Henderson",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37653318": {
    "id": "item_30603",
    "Last Name": "Green",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37653535": {
    "id": "item_18264",
    "Last Name": "Pratama",
    "First Name": "Dafa Sena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37653672": {
    "id": "item_2943",
    "Last Name": "Platt",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37654096": {
    "id": "item_30602",
    "Last Name": "Cheng",
    "First Name": "Wai Sze",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37665459": {
    "id": "item_18261",
    "Last Name": "Chudal",
    "First Name": "Sushant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37665913": {
    "id": "item_28484",
    "Last Name": "Andrews",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37665925": {
    "id": "item_1400",
    "Last Name": "Staszewski",
    "First Name": "Jaros_aw",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37668172": {
    "id": "item_25700",
    "Last Name": "DIEFFENBAUCH",
    "First Name": "PAMELA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37670975": {
    "id": "item_25698",
    "Last Name": "Ontiveros",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37678760": {
    "id": "item_1055",
    "Last Name": "Baker",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37680262": {
    "id": "item_1399",
    "Last Name": "Goldoni",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37680800": {
    "id": "item_18254",
    "Last Name": "Fernandez",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37684524": {
    "id": "item_28482",
    "Last Name": "Bouchier",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37691539": {
    "id": "item_28481",
    "Last Name": "Kwok",
    "First Name": "Shuk Yi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37694763": {
    "id": "item_1054",
    "Last Name": "Villasenin ra–a",
    "First Name": "jose luis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37696023": {
    "id": "item_1053",
    "Last Name": "Vilkevicius",
    "First Name": "Aurimas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37697483": {
    "id": "item_5744",
    "Last Name": "DiCenso",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37697989": {
    "id": "item_30594",
    "Last Name": "Nicoll",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37698635": {
    "id": "item_18249",
    "Last Name": "Kayani",
    "First Name": "Neelab",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37698737": {
    "id": "item_31065",
    "Last Name": "Manning",
    "First Name": "Cole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699108": {
    "id": "item_18247",
    "Last Name": "O'Donovan",
    "First Name": "Dara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699495": {
    "id": "item_25694",
    "Last Name": "Cunningham",
    "First Name": "Ronnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699622": {
    "id": "item_5743",
    "Last Name": "Ramage",
    "First Name": "Austen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699786": {
    "id": "item_18243",
    "Last Name": "Tan",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699926": {
    "id": "item_25693",
    "Last Name": "Oke",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37700013": {
    "id": "item_18241",
    "Last Name": "Bertoni",
    "First Name": "Daniela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37700373": {
    "id": "item_18239",
    "Last Name": "Su",
    "First Name": "Zhao Hong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37700517": {
    "id": "item_16160",
    "Last Name": "Leonard",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37700880": {
    "id": "item_25689",
    "Last Name": "Zhong",
    "First Name": "Phoenix",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701065": {
    "id": "item_5739",
    "Last Name": "Castrey",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701315": {
    "id": "item_25686",
    "Last Name": "Evans",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701671": {
    "id": "item_2940",
    "Last Name": "Lindstršm",
    "First Name": "Noa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701710": {
    "id": "item_30585",
    "Last Name": "HWANG",
    "First Name": "HSIEN SHENG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701774": {
    "id": "item_30584",
    "Last Name": "LO FAN HIN",
    "First Name": "MARIE JUSTINE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701991": {
    "id": "item_5737",
    "Last Name": "Almond",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701995": {
    "id": "item_1398",
    "Last Name": "Birch",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702093": {
    "id": "item_18233",
    "Last Name": "Wong",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702157": {
    "id": "item_5736",
    "Last Name": "Han",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702376": {
    "id": "item_1046",
    "Last Name": "Howe",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702453": {
    "id": "item_18230",
    "Last Name": "Weir",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702487": {
    "id": "item_16159",
    "Last Name": "MOISEENKO",
    "First Name": "INGA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702668": {
    "id": "item_18226",
    "Last Name": "Phillips",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702719": {
    "id": "item_18224",
    "Last Name": "Tomasoni",
    "First Name": "Rodolfo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703015": {
    "id": "item_18222",
    "Last Name": "LIU",
    "First Name": "WEI CHEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703103": {
    "id": "item_13525",
    "Last Name": "Drummond",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703303": {
    "id": "item_28471",
    "Last Name": "Hageman",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703332": {
    "id": "item_25675",
    "Last Name": "McArdle",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703498": {
    "id": "item_18218",
    "Last Name": "Fossa",
    "First Name": "Denis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703583": {
    "id": "item_5730",
    "Last Name": "NG",
    "First Name": "SU HAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703842": {
    "id": "item_25672",
    "Last Name": "MICHEL",
    "First Name": "Margaux",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703911": {
    "id": "item_25671",
    "Last Name": "Johnson",
    "First Name": "Zhanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703923": {
    "id": "item_30576",
    "Last Name": "Balabat",
    "First Name": "Micole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703931": {
    "id": "item_13521",
    "Last Name": "YUAN",
    "First Name": "HEFEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703936": {
    "id": "item_5727",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703983": {
    "id": "item_5726",
    "Last Name": "HOWARD",
    "First Name": "Ally",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704062": {
    "id": "item_18212",
    "Last Name": "Pignet",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704074": {
    "id": "item_25670",
    "Last Name": "Clunes",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704111": {
    "id": "item_2931",
    "Last Name": "Selemba",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704155": {
    "id": "item_13519",
    "Last Name": "Tooley",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704162": {
    "id": "item_18209",
    "Last Name": "Whitehead",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704173": {
    "id": "item_2930",
    "Last Name": "Ronayne",
    "First Name": "Zac",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704176": {
    "id": "item_18208",
    "Last Name": "Palackal",
    "First Name": "Robby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704219": {
    "id": "item_28852",
    "Last Name": "Sacares",
    "First Name": "Florleane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704316": {
    "id": "item_2479",
    "Last Name": "Thompson",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704400": {
    "id": "item_18206",
    "Last Name": "Pember",
    "First Name": "Danyon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704426": {
    "id": "item_25664",
    "Last Name": "Peaston",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704501": {
    "id": "item_25663",
    "Last Name": "Callander",
    "First Name": "Janine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704607": {
    "id": "item_28469",
    "Last Name": "Johnson",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704617": {
    "id": "item_18203",
    "Last Name": "Norkunas",
    "First Name": "Guy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704697": {
    "id": "item_18202",
    "Last Name": "Tso",
    "First Name": "Yuen Au",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704698": {
    "id": "item_5720",
    "Last Name": "Bosanquet",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704919": {
    "id": "item_28466",
    "Last Name": "Simmons",
    "First Name": "Mardi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704963": {
    "id": "item_5717",
    "Last Name": "Nicholas",
    "First Name": "Rhett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705013": {
    "id": "item_28467",
    "Last Name": "Hageman",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705069": {
    "id": "item_28464",
    "Last Name": "Hislop",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705081": {
    "id": "item_25659",
    "Last Name": "Bell",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705179": {
    "id": "item_13515",
    "Last Name": "Wall",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705197": {
    "id": "item_1035",
    "Last Name": "Brookes",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705234": {
    "id": "item_5712",
    "Last Name": "Zucco",
    "First Name": "Devin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705240": {
    "id": "item_25656",
    "Last Name": "Lui",
    "First Name": "Ching Tung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705255": {
    "id": "item_18195",
    "Last Name": "Bhatti",
    "First Name": "Armaan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705301": {
    "id": "item_5708",
    "Last Name": "Donaldson",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705399": {
    "id": "item_18193",
    "Last Name": "Doyle",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705427": {
    "id": "item_30569",
    "Last Name": "Viray",
    "First Name": "Therese Abigail",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705430": {
    "id": "item_18192",
    "Last Name": "Weston",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705463": {
    "id": "item_5707",
    "Last Name": "DAI",
    "First Name": "LICHEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705479": {
    "id": "item_2925",
    "Last Name": "Hart",
    "First Name": "Renee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705556": {
    "id": "item_25655",
    "Last Name": "voda",
    "First Name": "adriana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705562": {
    "id": "item_1033",
    "Last Name": "Fung",
    "First Name": "Wai Cheong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705575": {
    "id": "item_28461",
    "Last Name": "Tambunan",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705605": {
    "id": "item_13512",
    "Last Name": "Seet",
    "First Name": "Wei Liang, Desmond",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705611": {
    "id": "item_18187",
    "Last Name": "Kiley",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705647": {
    "id": "item_13511",
    "Last Name": "Lachugin",
    "First Name": "Vladimir",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705652": {
    "id": "item_30564",
    "Last Name": "YEH",
    "First Name": "HSIN-JOU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705667": {
    "id": "item_28460",
    "Last Name": "Betts",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705669": {
    "id": "item_5703",
    "Last Name": "Caskey",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705692": {
    "id": "item_5702",
    "Last Name": "Misterski",
    "First Name": "Marcin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705776": {
    "id": "item_1032",
    "Last Name": "Pearse",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705809": {
    "id": "item_26465",
    "Last Name": "Twitchett",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705886": {
    "id": "item_18184",
    "Last Name": "Alexander",
    "First Name": "Trent",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705911": {
    "id": "item_16151",
    "Last Name": "SHIN",
    "First Name": "KOOKKI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705962": {
    "id": "item_13510",
    "Last Name": "Neff",
    "First Name": "Debbie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705985": {
    "id": "item_16150",
    "Last Name": "Murray",
    "First Name": "Benn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705994": {
    "id": "item_18181",
    "Last Name": "Pile",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705995": {
    "id": "item_28456",
    "Last Name": "Parada",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706002": {
    "id": "item_28457",
    "Last Name": "LI",
    "First Name": "LINA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706221": {
    "id": "item_30556",
    "Last Name": "Espiritu",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706264": {
    "id": "item_18179",
    "Last Name": "Hudson",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706289": {
    "id": "item_1029",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706445": {
    "id": "item_18177",
    "Last Name": "Hill",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706541": {
    "id": "item_18176",
    "Last Name": "Schofield",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706587": {
    "id": "item_18175",
    "Last Name": "Schofield",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706657": {
    "id": "item_16322",
    "Last Name": "xiaoyu",
    "First Name": "wang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707011": {
    "id": "item_1397",
    "Last Name": "Pirwitz",
    "First Name": "Boris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707028": {
    "id": "item_18173",
    "Last Name": "Heathcock, Jr",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707033": {
    "id": "item_1028",
    "Last Name": "NESTEROV",
    "First Name": "ROMAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707290": {
    "id": "item_1396",
    "Last Name": "YOSHINO",
    "First Name": "TOMOHIRO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707997": {
    "id": "item_13505",
    "Last Name": "Stutley",
    "First Name": "Carlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37708108": {
    "id": "item_13504",
    "Last Name": "Wahid",
    "First Name": "Abdul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37708137": {
    "id": "item_2923",
    "Last Name": "Vevere",
    "First Name": "Julija",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37709097": {
    "id": "item_26464",
    "Last Name": "Argent",
    "First Name": "Liz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37709621": {
    "id": "item_18167",
    "Last Name": "Camp",
    "First Name": "Caryn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37709949": {
    "id": "item_2922",
    "Last Name": "Filentas",
    "First Name": "Fotis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37710093": {
    "id": "item_18164",
    "Last Name": "Lewis",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37710729": {
    "id": "item_16147",
    "Last Name": "Williams",
    "First Name": "Barton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37710928": {
    "id": "item_18163",
    "Last Name": "McGowan",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37710940": {
    "id": "item_18162",
    "Last Name": "PARADA",
    "First Name": "PAOLA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37711248": {
    "id": "item_30548",
    "Last Name": "Green",
    "First Name": "Janet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37711488": {
    "id": "item_2920",
    "Last Name": "Stollery",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37711617": {
    "id": "item_5686",
    "Last Name": "Brown",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37711720": {
    "id": "item_30543",
    "Last Name": "Mengden",
    "First Name": "Miriam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37711909": {
    "id": "item_13499",
    "Last Name": "Lynn",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712127": {
    "id": "item_13498",
    "Last Name": "Cardillo",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712269": {
    "id": "item_30540",
    "Last Name": "Carr",
    "First Name": "Sonya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712365": {
    "id": "item_5684",
    "Last Name": "Harris",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712771": {
    "id": "item_30535",
    "Last Name": "La",
    "First Name": "Prescilla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712776": {
    "id": "item_18145",
    "Last Name": "Tuazon",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712784": {
    "id": "item_18146",
    "Last Name": "Tuazon",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712878": {
    "id": "item_16144",
    "Last Name": "Chou",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712897": {
    "id": "item_5682",
    "Last Name": "BENNETT",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712944": {
    "id": "item_30534",
    "Last Name": "Sherer",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712958": {
    "id": "item_13493",
    "Last Name": "Norton",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713148": {
    "id": "item_28450",
    "Last Name": "Kennedy",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713201": {
    "id": "item_18140",
    "Last Name": "HUANG",
    "First Name": "SHIH-FENG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713254": {
    "id": "item_18139",
    "Last Name": "Onden-Lim",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713302": {
    "id": "item_1020",
    "Last Name": "Bright",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713353": {
    "id": "item_28449",
    "Last Name": "Burton-McKeich",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713374": {
    "id": "item_18136",
    "Last Name": "Tometchko",
    "First Name": "Christina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713432": {
    "id": "item_16141",
    "Last Name": "Krushka",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713588": {
    "id": "item_1019",
    "Last Name": "Bryan",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713759": {
    "id": "item_18133",
    "Last Name": "Donnelly",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713779": {
    "id": "item_2917",
    "Last Name": "Unger",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713838": {
    "id": "item_18130",
    "Last Name": "McGregor",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713868": {
    "id": "item_18129",
    "Last Name": "Gilmore",
    "First Name": "Kennedy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713901": {
    "id": "item_26463",
    "Last Name": "Tang",
    "First Name": "Yuk Hing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714015": {
    "id": "item_28445",
    "Last Name": "Callen",
    "First Name": "Angus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714167": {
    "id": "item_18127",
    "Last Name": "Singh",
    "First Name": "Anjani",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714211": {
    "id": "item_26462",
    "Last Name": "Yamaji",
    "First Name": "Yumi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714244": {
    "id": "item_1017",
    "Last Name": "kim",
    "First Name": "gyeongtae",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714278": {
    "id": "item_13487",
    "Last Name": "Soegeng",
    "First Name": "Agustinus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714340": {
    "id": "item_18126",
    "Last Name": "Best",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714664": {
    "id": "item_28443",
    "Last Name": "Yu",
    "First Name": "Shu Yuan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714705": {
    "id": "item_18123",
    "Last Name": "Sparrow",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714735": {
    "id": "item_18122",
    "Last Name": "Fischer",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714765": {
    "id": "item_1012",
    "Last Name": "Roberts",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714766": {
    "id": "item_28441",
    "Last Name": "Akpolat",
    "First Name": "Rahmet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714831": {
    "id": "item_2914",
    "Last Name": "Andrada",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715035": {
    "id": "item_18120",
    "Last Name": "Jackson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715086": {
    "id": "item_5671",
    "Last Name": "Zupanc",
    "First Name": "Katarina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715129": {
    "id": "item_2913",
    "Last Name": "Schutz",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715210": {
    "id": "item_16138",
    "Last Name": "Fernando",
    "First Name": "Antonio Lorenzo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715220": {
    "id": "item_30523",
    "Last Name": "Brigoli",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715345": {
    "id": "item_5669",
    "Last Name": "Kuntjoro",
    "First Name": "Kahfi Kurnia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715601": {
    "id": "item_18113",
    "Last Name": "Segura",
    "First Name": "Ana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715661": {
    "id": "item_31054",
    "Last Name": "NAINGGOLAN",
    "First Name": "ASTRID",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715741": {
    "id": "item_18111",
    "Last Name": "Wong",
    "First Name": "Nathaniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715831": {
    "id": "item_18110",
    "Last Name": "Kavanagh",
    "First Name": "Sinead",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715939": {
    "id": "item_30519",
    "Last Name": "Cheung",
    "First Name": "Wing Yin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715950": {
    "id": "item_5664",
    "Last Name": "Greenwald",
    "First Name": "Blair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715996": {
    "id": "item_30517",
    "Last Name": "Yang",
    "First Name": "Jung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716014": {
    "id": "item_1005",
    "Last Name": "FAN",
    "First Name": "KUO LUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716033": {
    "id": "item_18108",
    "Last Name": "NOGUCHI",
    "First Name": "Yoshiki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716159": {
    "id": "item_18107",
    "Last Name": "Miller",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716161": {
    "id": "item_18105",
    "Last Name": "Bridger",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716207": {
    "id": "item_30515",
    "Last Name": "Cashmere",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716219": {
    "id": "item_18104",
    "Last Name": "Otto",
    "First Name": "Reece",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716221": {
    "id": "item_30514",
    "Last Name": "Rodd",
    "First Name": "Elliott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716380": {
    "id": "item_18101",
    "Last Name": "Collins",
    "First Name": "Drew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716408": {
    "id": "item_28433",
    "Last Name": "Brown",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716479": {
    "id": "item_16135",
    "Last Name": "Chan",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716531": {
    "id": "item_2905",
    "Last Name": "McGinty",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716540": {
    "id": "item_18096",
    "Last Name": "Limmena",
    "First Name": "Shannen Anabella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716591": {
    "id": "item_16134",
    "Last Name": "Lubberink",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716598": {
    "id": "item_30510",
    "Last Name": "McLeod",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716620": {
    "id": "item_18092",
    "Last Name": "Shukla",
    "First Name": "Mantra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716662": {
    "id": "item_1002",
    "Last Name": "Brunt",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716715": {
    "id": "item_5655",
    "Last Name": "Goulding",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716718": {
    "id": "item_13473",
    "Last Name": "SHEN",
    "First Name": "LI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716943": {
    "id": "item_999",
    "Last Name": "Gutierrez",
    "First Name": "Jake Benedict",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716958": {
    "id": "item_3238",
    "Last Name": "Imai",
    "First Name": "Yutaka",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717060": {
    "id": "item_18090",
    "Last Name": "Laide",
    "First Name": "Lorna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717065": {
    "id": "item_13471",
    "Last Name": "Lin",
    "First Name": "Cheng Yi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717096": {
    "id": "item_2900",
    "Last Name": "Tarnate",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717124": {
    "id": "item_18089",
    "Last Name": "Anderson",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717192": {
    "id": "item_18087",
    "Last Name": "Choi",
    "First Name": "Nara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717290": {
    "id": "item_13469",
    "Last Name": "Huang",
    "First Name": "Yinghui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717291": {
    "id": "item_16132",
    "Last Name": "Tan Han Sheng",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717331": {
    "id": "item_18082",
    "Last Name": "Mochizuki",
    "First Name": "Hironobu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717334": {
    "id": "item_30504",
    "Last Name": "Coombe",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717350": {
    "id": "item_5648",
    "Last Name": "PARK",
    "First Name": "SUNGJO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717357": {
    "id": "item_2897",
    "Last Name": "Cadby",
    "First Name": "Cam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717403": {
    "id": "item_5645",
    "Last Name": "Ferdinandus",
    "First Name": "Stanley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717460": {
    "id": "item_30502",
    "Last Name": "Burman",
    "First Name": "Amrita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717465": {
    "id": "item_5644",
    "Last Name": "rojas",
    "First Name": "carlos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717612": {
    "id": "item_13467",
    "Last Name": "Goebel",
    "First Name": "Andreas Buch",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717834": {
    "id": "item_18077",
    "Last Name": "LEE",
    "First Name": "SEONGHO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717991": {
    "id": "item_18076",
    "Last Name": "Goh",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718034": {
    "id": "item_14015",
    "Last Name": "Garcia",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718048": {
    "id": "item_18075",
    "Last Name": "Chansiri",
    "First Name": "Navy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718055": {
    "id": "item_994",
    "Last Name": "Salim",
    "First Name": "Polniwati",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718129": {
    "id": "item_16130",
    "Last Name": "Lee",
    "First Name": "Hoshin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718130": {
    "id": "item_13466",
    "Last Name": "Engsirorat",
    "First Name": "Thawat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718537": {
    "id": "item_16321",
    "Last Name": "Limpo",
    "First Name": "Maria Julia Gabriela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718547": {
    "id": "item_30494",
    "Last Name": "Raman",
    "First Name": "Aditi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718609": {
    "id": "item_28423",
    "Last Name": "Sahetapy Engel",
    "First Name": "Johannes Christian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718660": {
    "id": "item_18072",
    "Last Name": "Li",
    "First Name": "Yee Ting",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718769": {
    "id": "item_5638",
    "Last Name": "Liu",
    "First Name": "Wai Lap",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718916": {
    "id": "item_990",
    "Last Name": "Bliss",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718970": {
    "id": "item_989",
    "Last Name": "Chow",
    "First Name": "Chun Pong Derek",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37719043": {
    "id": "item_18070",
    "Last Name": "Funk",
    "First Name": "Kyra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37719115": {
    "id": "item_13462",
    "Last Name": "CHIANG",
    "First Name": "YEN CHUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37719197": {
    "id": "item_5636",
    "Last Name": "CHEW SANCHEZ",
    "First Name": "JULIO CESAR",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37719619": {
    "id": "item_16128",
    "Last Name": "KIM",
    "First Name": "HEEYEON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37719828": {
    "id": "item_18068",
    "Last Name": "Proctor",
    "First Name": "Halee S",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37719924": {
    "id": "item_18067",
    "Last Name": "Scheibel",
    "First Name": "Barbara Anne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37720356": {
    "id": "item_28421",
    "Last Name": "Carandang",
    "First Name": "Shuangying",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37720369": {
    "id": "item_16320",
    "Last Name": "Deggerich",
    "First Name": "Guido",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37720953": {
    "id": "item_5633",
    "Last Name": "Mikhaylov",
    "First Name": "Artem",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721312": {
    "id": "item_18064",
    "Last Name": "Wedd",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721321": {
    "id": "item_18065",
    "Last Name": "Carvalho",
    "First Name": "Ana Leonor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721718": {
    "id": "item_5630",
    "Last Name": "Tentinger",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721953": {
    "id": "item_5629",
    "Last Name": "Borger",
    "First Name": "Bobby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722286": {
    "id": "item_984",
    "Last Name": "Eguchi",
    "First Name": "Junya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722497": {
    "id": "item_5625",
    "Last Name": "Chaudhry",
    "First Name": "Naman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722554": {
    "id": "item_13457",
    "Last Name": "Ellis",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722854": {
    "id": "item_18055",
    "Last Name": "Chen",
    "First Name": "Yongzhen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722934": {
    "id": "item_5616",
    "Last Name": "Delaney",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723115": {
    "id": "item_2885",
    "Last Name": "Rambach",
    "First Name": "Whit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723196": {
    "id": "item_5615",
    "Last Name": "Jaunay",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723337": {
    "id": "item_980",
    "Last Name": "Grant",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723461": {
    "id": "item_2882",
    "Last Name": "Teahan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723580": {
    "id": "item_5613",
    "Last Name": "Casas Arenas",
    "First Name": "Mayra Liliana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723703": {
    "id": "item_5611",
    "Last Name": "OFlaherty",
    "First Name": "Seamus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723764": {
    "id": "item_5610",
    "Last Name": "Rolland",
    "First Name": "Eilish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723936": {
    "id": "item_5609",
    "Last Name": "Ivanhoe",
    "First Name": "Saskia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723962": {
    "id": "item_16124",
    "Last Name": "orelowitz",
    "First Name": "jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724041": {
    "id": "item_18046",
    "Last Name": "Johansen",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724057": {
    "id": "item_16123",
    "Last Name": "Graber",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724259": {
    "id": "item_28413",
    "Last Name": "Paul",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724457": {
    "id": "item_18039",
    "Last Name": "Mancini",
    "First Name": "Anna-Lea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724465": {
    "id": "item_18040",
    "Last Name": "McAleer",
    "First Name": "Phebe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724731": {
    "id": "item_30489",
    "Last Name": "Reyes",
    "First Name": "Marnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724749": {
    "id": "item_13451",
    "Last Name": "Tsai",
    "First Name": "YA FANG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724802": {
    "id": "item_18036",
    "Last Name": "Cosentino",
    "First Name": "Vince",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724876": {
    "id": "item_30487",
    "Last Name": "Uhlarik",
    "First Name": "Jozef",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724960": {
    "id": "item_30486",
    "Last Name": "Vickery",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37725120": {
    "id": "item_18031",
    "Last Name": "Wang",
    "First Name": "Yu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37725133": {
    "id": "item_28411",
    "Last Name": "Dolman",
    "First Name": "Caleb",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37725157": {
    "id": "item_2881",
    "Last Name": "Pattison",
    "First Name": "Garry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37725541": {
    "id": "item_30484",
    "Last Name": "Wong",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37725652": {
    "id": "item_2880",
    "Last Name": "Calleja",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37725817": {
    "id": "item_5603",
    "Last Name": "Chow",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726000": {
    "id": "item_5601",
    "Last Name": "Redman",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726001": {
    "id": "item_5602",
    "Last Name": "Liao",
    "First Name": "Chih-Yi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726036": {
    "id": "item_2878",
    "Last Name": "Hozack",
    "First Name": "Heather",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726359": {
    "id": "item_13449",
    "Last Name": "Mathews",
    "First Name": "Kiel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726420": {
    "id": "item_13448",
    "Last Name": "Hedberg Grimlund",
    "First Name": "Nils",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726703": {
    "id": "item_30476",
    "Last Name": "Suppiah",
    "First Name": "Muthupandi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726780": {
    "id": "item_5597",
    "Last Name": "Athwal",
    "First Name": "Dilsher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726795": {
    "id": "item_2876",
    "Last Name": "Lim",
    "First Name": "Geri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726879": {
    "id": "item_18024",
    "Last Name": "Montes",
    "First Name": "Janice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726912": {
    "id": "item_970",
    "Last Name": "Tan",
    "First Name": "Jian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726948": {
    "id": "item_969",
    "Last Name": "Hicks",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727088": {
    "id": "item_28408",
    "Last Name": "Pham Minh",
    "First Name": "Duc",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727128": {
    "id": "item_18021",
    "Last Name": "LEE",
    "First Name": "CHANG YOUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727145": {
    "id": "item_967",
    "Last Name": "Brooker",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727170": {
    "id": "item_2872",
    "Last Name": "WANG",
    "First Name": "YUEKUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727413": {
    "id": "item_5593",
    "Last Name": "Patch",
    "First Name": "Trineane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727727": {
    "id": "item_18019",
    "Last Name": "Roberts",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727793": {
    "id": "item_18018",
    "Last Name": "Johnson",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728085": {
    "id": "item_30470",
    "Last Name": "Brotherton",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728109": {
    "id": "item_5590",
    "Last Name": "LIN",
    "First Name": "YU HSIEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728120": {
    "id": "item_13443",
    "Last Name": "Hynes",
    "First Name": "Deirdre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728161": {
    "id": "item_13442",
    "Last Name": "Watson",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728173": {
    "id": "item_18013",
    "Last Name": "Tufuga",
    "First Name": "Kane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728185": {
    "id": "item_18011",
    "Last Name": "Wong",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728188": {
    "id": "item_13439",
    "Last Name": "PARK",
    "First Name": "JIHO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728214": {
    "id": "item_16116",
    "Last Name": "Singleton",
    "First Name": "Nikita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728314": {
    "id": "item_18009",
    "Last Name": "CHEN",
    "First Name": "SHIH LING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728365": {
    "id": "item_18006",
    "Last Name": "Bigg",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728371": {
    "id": "item_13438",
    "Last Name": "Jexenov",
    "First Name": "Dastan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728372": {
    "id": "item_18007",
    "Last Name": "Parsonage",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728436": {
    "id": "item_13437",
    "Last Name": "Love",
    "First Name": "Dax",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728617": {
    "id": "item_5583",
    "Last Name": "Romero Calvo",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728641": {
    "id": "item_16113",
    "Last Name": "Tangpongprasit",
    "First Name": "Sanya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728655": {
    "id": "item_16112",
    "Last Name": "KIM",
    "First Name": "SEO JUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728693": {
    "id": "item_28399",
    "Last Name": "Shearer",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728750": {
    "id": "item_5580",
    "Last Name": "Tickner",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728778": {
    "id": "item_14014",
    "Last Name": "Duarte",
    "First Name": "Leticia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728812": {
    "id": "item_28397",
    "Last Name": "Gupta",
    "First Name": "Saurabh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728818": {
    "id": "item_26461",
    "Last Name": "JING",
    "First Name": "ZHAO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728842": {
    "id": "item_30465",
    "Last Name": "Moolman",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728861": {
    "id": "item_30464",
    "Last Name": "Jones",
    "First Name": "Maggie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728900": {
    "id": "item_28395",
    "Last Name": "Cunningham",
    "First Name": "Cait",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728903": {
    "id": "item_30461",
    "Last Name": "Kardush",
    "First Name": "Igor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728951": {
    "id": "item_16110",
    "Last Name": "MŸller",
    "First Name": "Mareike",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728985": {
    "id": "item_5578",
    "Last Name": "Warner",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729004": {
    "id": "item_17995",
    "Last Name": "Stalmokaite",
    "First Name": "Simona",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729025": {
    "id": "item_14013",
    "Last Name": "MATTO23",
    "First Name": "JOSE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729099": {
    "id": "item_28391",
    "Last Name": "Adam",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729148": {
    "id": "item_28390",
    "Last Name": "Beckett",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729190": {
    "id": "item_30458",
    "Last Name": "SAPUTRA",
    "First Name": "MUHAMMAD OKY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729218": {
    "id": "item_17993",
    "Last Name": "Tan",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729341": {
    "id": "item_960",
    "Last Name": "Verkaart",
    "First Name": "Theo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729456": {
    "id": "item_30454",
    "Last Name": "Adachi",
    "First Name": "Kai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729518": {
    "id": "item_14012",
    "Last Name": "Towattanakit",
    "First Name": "Pattraporn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729523": {
    "id": "item_13433",
    "Last Name": "Debrouvier",
    "First Name": "Hemilse",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729571": {
    "id": "item_13432",
    "Last Name": "Chestnut",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729648": {
    "id": "item_956",
    "Last Name": "KUANG",
    "First Name": "IHSIU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729748": {
    "id": "item_28816",
    "Last Name": "Deckard",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729883": {
    "id": "item_28389",
    "Last Name": "Chan",
    "First Name": "Kim Hung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729928": {
    "id": "item_1395",
    "Last Name": "Chen",
    "First Name": "Pochiang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730296": {
    "id": "item_5571",
    "Last Name": "Feng",
    "First Name": "Xuefeng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730330": {
    "id": "item_13429",
    "Last Name": "Goubet",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730383": {
    "id": "item_17983",
    "Last Name": "Brasacchio",
    "First Name": "Massimo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730390": {
    "id": "item_2865",
    "Last Name": "Gonzalez Cruz",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730752": {
    "id": "item_5569",
    "Last Name": "Mascle",
    "First Name": "Maxime",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730771": {
    "id": "item_13426",
    "Last Name": "Perez",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37732060": {
    "id": "item_17980",
    "Last Name": "Mann",
    "First Name": "Alesha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37732382": {
    "id": "item_17977",
    "Last Name": "Sweet",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37732398": {
    "id": "item_954",
    "Last Name": "Figueroa",
    "First Name": "Wilfredo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37732636": {
    "id": "item_5566",
    "Last Name": "Alden",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37732769": {
    "id": "item_28386",
    "Last Name": "Pok",
    "First Name": "Bora",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37733140": {
    "id": "item_5564",
    "Last Name": "Evans",
    "First Name": "Angharad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37733249": {
    "id": "item_17973",
    "Last Name": "Vasic",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37733301": {
    "id": "item_16304",
    "Last Name": "Cheong",
    "First Name": "Changhee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37733503": {
    "id": "item_17969",
    "Last Name": "Delangle",
    "First Name": "Jerome",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37733554": {
    "id": "item_17971",
    "Last Name": "Delangle",
    "First Name": "Guy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37733655": {
    "id": "item_17967",
    "Last Name": "Zodrow",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734058": {
    "id": "item_17966",
    "Last Name": "van Cuylenburg-Reimers",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734114": {
    "id": "item_16109",
    "Last Name": "Fathi",
    "First Name": "Shireen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734228": {
    "id": "item_30446",
    "Last Name": "Spittle",
    "First Name": "Rychelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734258": {
    "id": "item_16107",
    "Last Name": "Hall",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734392": {
    "id": "item_2856",
    "Last Name": "Holland",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734503": {
    "id": "item_17962",
    "Last Name": "Ross",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734660": {
    "id": "item_3237",
    "Last Name": "Young",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734871": {
    "id": "item_17960",
    "Last Name": "Plester-Tompa",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734872": {
    "id": "item_16106",
    "Last Name": "Burditt",
    "First Name": "Emilie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734876": {
    "id": "item_30443",
    "Last Name": "Lan",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734893": {
    "id": "item_949",
    "Last Name": "Sheely",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735097": {
    "id": "item_2855",
    "Last Name": "Gao",
    "First Name": "Yun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735320": {
    "id": "item_1394",
    "Last Name": "Petrus",
    "First Name": "Michal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735441": {
    "id": "item_13421",
    "Last Name": "Adamovsky",
    "First Name": "Jan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735600": {
    "id": "item_2853",
    "Last Name": "Jun",
    "First Name": "Gyoungbok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735708": {
    "id": "item_28377",
    "Last Name": "Pham",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735945": {
    "id": "item_30439",
    "Last Name": "Sun",
    "First Name": "Tzu-Wen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37737751": {
    "id": "item_13418",
    "Last Name": "Rotondo",
    "First Name": "Tyran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37737962": {
    "id": "item_2850",
    "Last Name": "Zhang",
    "First Name": "Ziliang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738287": {
    "id": "item_5552",
    "Last Name": "Traisilanan",
    "First Name": "_Bundit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738378": {
    "id": "item_28851",
    "Last Name": "Krohner",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738388": {
    "id": "item_5551",
    "Last Name": "Solomon",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738512": {
    "id": "item_28371",
    "Last Name": "Snook",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738636": {
    "id": "item_28370",
    "Last Name": "Dally",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738663": {
    "id": "item_5550",
    "Last Name": "Hartshorn",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738666": {
    "id": "item_17949",
    "Last Name": "Marney",
    "First Name": "Maraina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738740": {
    "id": "item_5549",
    "Last Name": "Suh",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738751": {
    "id": "item_13413",
    "Last Name": "SHIH",
    "First Name": "YUYA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738978": {
    "id": "item_17945",
    "Last Name": "Kilborn",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739014": {
    "id": "item_13411",
    "Last Name": "Deason",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739267": {
    "id": "item_17943",
    "Last Name": "KIM",
    "First Name": "JIYONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739390": {
    "id": "item_5542",
    "Last Name": "Spencer-Pepper",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739556": {
    "id": "item_30431",
    "Last Name": "Joshi Maharjan",
    "First Name": "Anjani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739583": {
    "id": "item_5538",
    "Last Name": "Carable",
    "First Name": "Sarah Marie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739595": {
    "id": "item_17940",
    "Last Name": "Dong",
    "First Name": "Kimvy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739680": {
    "id": "item_5535",
    "Last Name": "Howarth",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739720": {
    "id": "item_13971",
    "Last Name": "Wang",
    "First Name": "Hai Wen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739929": {
    "id": "item_5532",
    "Last Name": "Jia",
    "First Name": "Baishan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739961": {
    "id": "item_5531",
    "Last Name": "Bye",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740061": {
    "id": "item_17937",
    "Last Name": "CHEN",
    "First Name": "Huixing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740068": {
    "id": "item_941",
    "Last Name": "Levin",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740224": {
    "id": "item_13408",
    "Last Name": "Chegwyn",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740377": {
    "id": "item_17932",
    "Last Name": "Herdina",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740449": {
    "id": "item_5527",
    "Last Name": "Lloyd",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740508": {
    "id": "item_16098",
    "Last Name": "Mishra",
    "First Name": "Prashant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740535": {
    "id": "item_2844",
    "Last Name": "HUANG",
    "First Name": "CHUNG WEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740554": {
    "id": "item_5525",
    "Last Name": "Halupka",
    "First Name": "Kat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740682": {
    "id": "item_30425",
    "Last Name": "Bridgeman",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740726": {
    "id": "item_17928",
    "Last Name": "Khan",
    "First Name": "Shadab",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740832": {
    "id": "item_30424",
    "Last Name": "Mathews",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740881": {
    "id": "item_5518",
    "Last Name": "Farnsworth",
    "First Name": "Jarrad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740914": {
    "id": "item_5517",
    "Last Name": "Carobene",
    "First Name": "Gianluca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740947": {
    "id": "item_17924",
    "Last Name": "OÕBrien",
    "First Name": "Duane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740948": {
    "id": "item_17923",
    "Last Name": "Franca",
    "First Name": "Viktor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740975": {
    "id": "item_30421",
    "Last Name": "Maron",
    "First Name": "Luciano",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741034": {
    "id": "item_5515",
    "Last Name": "Rayner",
    "First Name": "Bart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741064": {
    "id": "item_937",
    "Last Name": "Shin",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741164": {
    "id": "item_17918",
    "Last Name": "Moir",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741248": {
    "id": "item_17916",
    "Last Name": "Wai Hong",
    "First Name": "Wong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741316": {
    "id": "item_13403",
    "Last Name": "T S K NAGENDRA RAO",
    "First Name": "LOGEENTH RAO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741328": {
    "id": "item_30418",
    "Last Name": "Squires",
    "First Name": "Reuben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741331": {
    "id": "item_5510",
    "Last Name": "danilov",
    "First Name": "stepan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741379": {
    "id": "item_16097",
    "Last Name": "Di Giovanni",
    "First Name": "Monica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741442": {
    "id": "item_5509",
    "Last Name": "CHANG",
    "First Name": "LI-HO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741491": {
    "id": "item_933",
    "Last Name": "Spence",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741545": {
    "id": "item_30416",
    "Last Name": "Moon",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741562": {
    "id": "item_931",
    "Last Name": "Iles",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741569": {
    "id": "item_31064",
    "Last Name": "Muhamad",
    "First Name": "Julian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741674": {
    "id": "item_5506",
    "Last Name": "Mousset",
    "First Name": "Stephane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741742": {
    "id": "item_17909",
    "Last Name": "McConnell",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741772": {
    "id": "item_929",
    "Last Name": "Banasiewicz",
    "First Name": "Jacek",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741919": {
    "id": "item_2840",
    "Last Name": "Berzamina",
    "First Name": "Melvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742022": {
    "id": "item_17907",
    "Last Name": "Balan",
    "First Name": "Sharath",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742035": {
    "id": "item_17906",
    "Last Name": "Grellman",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742036": {
    "id": "item_30415",
    "Last Name": "an",
    "First Name": "mingjun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742293": {
    "id": "item_30414",
    "Last Name": "Wang",
    "First Name": "Kanfu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742717": {
    "id": "item_17905",
    "Last Name": "Bluck",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742879": {
    "id": "item_17904",
    "Last Name": "LHOPITAL",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742928": {
    "id": "item_2835",
    "Last Name": "Darisse",
    "First Name": "Kailee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37743559": {
    "id": "item_30412",
    "Last Name": "Bae",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37743713": {
    "id": "item_17900",
    "Last Name": "Goretzki",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37743716": {
    "id": "item_925",
    "Last Name": "Heimann",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37744356": {
    "id": "item_924",
    "Last Name": "Zemlicka",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37744867": {
    "id": "item_17895",
    "Last Name": "Hooper",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37744872": {
    "id": "item_5496",
    "Last Name": "Glithero",
    "First Name": "Reece",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37744884": {
    "id": "item_17894",
    "Last Name": "Alvindo",
    "First Name": "Ryann",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745011": {
    "id": "item_30410",
    "Last Name": "Hartman",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745264": {
    "id": "item_2833",
    "Last Name": "Bishop",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745323": {
    "id": "item_13388",
    "Last Name": "De Marco",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745388": {
    "id": "item_5493",
    "Last Name": "Marcus",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745464": {
    "id": "item_17891",
    "Last Name": "Gordon",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745571": {
    "id": "item_28355",
    "Last Name": "Lara",
    "First Name": "Nap",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746005": {
    "id": "item_17888",
    "Last Name": "Kehoe",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746068": {
    "id": "item_17887",
    "Last Name": "North",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746074": {
    "id": "item_28352",
    "Last Name": "Carroll",
    "First Name": "Madison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746377": {
    "id": "item_28350",
    "Last Name": "Wu",
    "First Name": "Zhehao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746393": {
    "id": "item_2829",
    "Last Name": "HIROFUJI",
    "First Name": "YOSHIKAZU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746463": {
    "id": "item_918",
    "Last Name": "Bromfield",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746520": {
    "id": "item_28349",
    "Last Name": "Wang",
    "First Name": "Jing-Huei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746759": {
    "id": "item_5487",
    "Last Name": "Hart",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747397": {
    "id": "item_13381",
    "Last Name": "Gibson Williamson",
    "First Name": "Keith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747451": {
    "id": "item_13380",
    "Last Name": "Toon",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747480": {
    "id": "item_13379",
    "Last Name": "He",
    "First Name": "Chongchong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747520": {
    "id": "item_17879",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747571": {
    "id": "item_13378",
    "Last Name": "Bryan",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747633": {
    "id": "item_17878",
    "Last Name": "Liew",
    "First Name": "Jin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747635": {
    "id": "item_28850",
    "Last Name": "Doughan",
    "First Name": "Clinton",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747918": {
    "id": "item_5479",
    "Last Name": "Delloye",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747989": {
    "id": "item_5478",
    "Last Name": "Cavanagh",
    "First Name": "Keith",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748093": {
    "id": "item_13375",
    "Last Name": "ElArabi",
    "First Name": "Anas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748111": {
    "id": "item_26460",
    "Last Name": "Nasrun",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748165": {
    "id": "item_17874",
    "Last Name": "Kepert",
    "First Name": "Karly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748188": {
    "id": "item_5475",
    "Last Name": "Campbell",
    "First Name": "Rory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748281": {
    "id": "item_17872",
    "Last Name": "Garcia",
    "First Name": "Denis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748364": {
    "id": "item_2825",
    "Last Name": "Graham",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748449": {
    "id": "item_28345",
    "Last Name": "Sutherland",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748540": {
    "id": "item_5470",
    "Last Name": "van Wyk",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748586": {
    "id": "item_910",
    "Last Name": "Taylor",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748643": {
    "id": "item_30399",
    "Last Name": "Bentley",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748700": {
    "id": "item_28344",
    "Last Name": "Kin Foong",
    "First Name": "Wong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748736": {
    "id": "item_17865",
    "Last Name": "Carpenter",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748849": {
    "id": "item_28343",
    "Last Name": "Gifford",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748851": {
    "id": "item_17864",
    "Last Name": "Harvey",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748913": {
    "id": "item_5466",
    "Last Name": "Williams",
    "First Name": "Gug",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748940": {
    "id": "item_17861",
    "Last Name": "Nguyen",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748979": {
    "id": "item_30396",
    "Last Name": "Fritz Heck",
    "First Name": "Hanna Carolina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749241": {
    "id": "item_17854",
    "Last Name": "Choi",
    "First Name": "Hong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749243": {
    "id": "item_5464",
    "Last Name": "Gibson",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749272": {
    "id": "item_16085",
    "Last Name": "Aldag",
    "First Name": "Saxon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749368": {
    "id": "item_17849",
    "Last Name": "Aitkenhead",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749468": {
    "id": "item_5460",
    "Last Name": "Pritchard",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749499": {
    "id": "item_30393",
    "Last Name": "Lo",
    "First Name": "Yuk Fung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749504": {
    "id": "item_5459",
    "Last Name": "Garton",
    "First Name": "Alana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749579": {
    "id": "item_5457",
    "Last Name": "Vlass",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749606": {
    "id": "item_17843",
    "Last Name": "Hazell",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749637": {
    "id": "item_17841",
    "Last Name": "FENG",
    "First Name": "YUXIA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749721": {
    "id": "item_907",
    "Last Name": "WEI",
    "First Name": "ZHENGQI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749756": {
    "id": "item_3214",
    "Last Name": "LIANG",
    "First Name": "KAI-CHIEH",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749767": {
    "id": "item_5455",
    "Last Name": "Williams",
    "First Name": "Neale",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749782": {
    "id": "item_2820",
    "Last Name": "Lac",
    "First Name": "Tam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749817": {
    "id": "item_30391",
    "Last Name": "Lim",
    "First Name": "Zhi Ching",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749819": {
    "id": "item_17833",
    "Last Name": "LIANG",
    "First Name": "DONGMEI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749833": {
    "id": "item_5454",
    "Last Name": "Manners",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749876": {
    "id": "item_5452",
    "Last Name": "LIU",
    "First Name": "XUEMEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749945": {
    "id": "item_30389",
    "Last Name": "FERRER",
    "First Name": "JAE MARIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749972": {
    "id": "item_17832",
    "Last Name": "Kovacs",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37750054": {
    "id": "item_30388",
    "Last Name": "CHEN",
    "First Name": "YI HAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37750085": {
    "id": "item_28335",
    "Last Name": "Liu",
    "First Name": "Yang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37750238": {
    "id": "item_17830",
    "Last Name": "Armstrong",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37750517": {
    "id": "item_30387",
    "Last Name": "CHAE",
    "First Name": "YUNA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37750893": {
    "id": "item_17825",
    "Last Name": "Roux",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37750997": {
    "id": "item_904",
    "Last Name": "Gurung",
    "First Name": "San",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751113": {
    "id": "item_31053",
    "Last Name": "KASIREDDY",
    "First Name": "SURESH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751126": {
    "id": "item_2818",
    "Last Name": "Silva",
    "First Name": "Claudio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751163": {
    "id": "item_17824",
    "Last Name": "Skinner",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751529": {
    "id": "item_901",
    "Last Name": "perez",
    "First Name": "james",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751817": {
    "id": "item_13358",
    "Last Name": "Mejia",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751849": {
    "id": "item_13357",
    "Last Name": "Towson",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753709": {
    "id": "item_28330",
    "Last Name": "Pointon",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753952": {
    "id": "item_5442",
    "Last Name": "Thiele",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754277": {
    "id": "item_5439",
    "Last Name": "Leondakis",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754351": {
    "id": "item_896",
    "Last Name": "grove",
    "First Name": "grace",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754423": {
    "id": "item_30380",
    "Last Name": "McGee",
    "First Name": "Tatiana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754471": {
    "id": "item_28327",
    "Last Name": "Norton",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754623": {
    "id": "item_17810",
    "Last Name": "Qian",
    "First Name": "Evelyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754710": {
    "id": "item_30379",
    "Last Name": "Long",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754972": {
    "id": "item_28326",
    "Last Name": "Haughey",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755019": {
    "id": "item_5436",
    "Last Name": "Molinari",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755040": {
    "id": "item_5435",
    "Last Name": "Chow",
    "First Name": "Wing Kan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755059": {
    "id": "item_17807",
    "Last Name": "Yapalparvi",
    "First Name": "Sudhindra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755169": {
    "id": "item_17805",
    "Last Name": "Dehne",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755243": {
    "id": "item_30378",
    "Last Name": "Shutt",
    "First Name": "Molly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755407": {
    "id": "item_891",
    "Last Name": "Logan",
    "First Name": "Katharine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755522": {
    "id": "item_17802",
    "Last Name": "Kerin",
    "First Name": "Paige",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755613": {
    "id": "item_5430",
    "Last Name": "Meshcherskij",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755803": {
    "id": "item_30375",
    "Last Name": "Wu",
    "First Name": "Yuan-Fa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755828": {
    "id": "item_28321",
    "Last Name": "Arsella",
    "First Name": "Maretta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755836": {
    "id": "item_17799",
    "Last Name": "Lewis",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755948": {
    "id": "item_13348",
    "Last Name": "Chen",
    "First Name": "Jie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755965": {
    "id": "item_13347",
    "Last Name": "Rice",
    "First Name": "Daisy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756180": {
    "id": "item_17793",
    "Last Name": "Lindsay",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756498": {
    "id": "item_5426",
    "Last Name": "Gaynor",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756579": {
    "id": "item_5423",
    "Last Name": "Poudel",
    "First Name": "Kul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756632": {
    "id": "item_16079",
    "Last Name": "Tang",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756859": {
    "id": "item_5421",
    "Last Name": "Glover",
    "First Name": "Jacques",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756979": {
    "id": "item_30370",
    "Last Name": "Koranne",
    "First Name": "Sonali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757094": {
    "id": "item_30369",
    "Last Name": "KIM",
    "First Name": "JUNG HWA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757194": {
    "id": "item_5418",
    "Last Name": "Zhang",
    "First Name": "Jianxiang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757219": {
    "id": "item_16078",
    "Last Name": "DONG",
    "First Name": "JIANGMING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757285": {
    "id": "item_13342",
    "Last Name": "Burnett",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757561": {
    "id": "item_17783",
    "Last Name": "Furtado",
    "First Name": "Ansel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757673": {
    "id": "item_5414",
    "Last Name": "Gallery",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757719": {
    "id": "item_885",
    "Last Name": "Deeming",
    "First Name": "Linus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37760357": {
    "id": "item_17779",
    "Last Name": "Jenvey",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37760366": {
    "id": "item_30366",
    "Last Name": "Wang",
    "First Name": "Jeannie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37760446": {
    "id": "item_13338",
    "Last Name": "Weber",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37763002": {
    "id": "item_30362",
    "Last Name": "Macale",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37763014": {
    "id": "item_882",
    "Last Name": "Jeavons",
    "First Name": "Roxanne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37763037": {
    "id": "item_5404",
    "Last Name": "Olsen",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37763183": {
    "id": "item_17771",
    "Last Name": "Fitzpatrick",
    "First Name": "Lilian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37768122": {
    "id": "item_30360",
    "Last Name": "Ansell",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37774732": {
    "id": "item_28309",
    "Last Name": "Anderson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37774845": {
    "id": "item_5400",
    "Last Name": "Olsen",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37774995": {
    "id": "item_878",
    "Last Name": "Fraser",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775029": {
    "id": "item_5398",
    "Last Name": "Blunt",
    "First Name": "Elouise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775056": {
    "id": "item_28307",
    "Last Name": "Watts",
    "First Name": "Prudence",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775217": {
    "id": "item_26459",
    "Last Name": "Villa",
    "First Name": "Elisabetta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775263": {
    "id": "item_30358",
    "Last Name": "Sonnlechner",
    "First Name": "Marlis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775291": {
    "id": "item_16074",
    "Last Name": "Finlayson",
    "First Name": "Matilda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775352": {
    "id": "item_17764",
    "Last Name": "shetty",
    "First Name": "vasudeva",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775393": {
    "id": "item_17763",
    "Last Name": "Steer",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775434": {
    "id": "item_5393",
    "Last Name": "Butler",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775479": {
    "id": "item_28303",
    "Last Name": "Moody",
    "First Name": "Anastasia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775503": {
    "id": "item_13328",
    "Last Name": "Lowe",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775537": {
    "id": "item_17754",
    "Last Name": "Venkataraman",
    "First Name": "Vivek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775593": {
    "id": "item_5387",
    "Last Name": "Johnson",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775617": {
    "id": "item_14011",
    "Last Name": "Yap",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775668": {
    "id": "item_5386",
    "Last Name": "Yang",
    "First Name": "Mingjiu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775766": {
    "id": "item_13324",
    "Last Name": "Burden",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775778": {
    "id": "item_30355",
    "Last Name": "O'Sullivan",
    "First Name": "Colin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775859": {
    "id": "item_17749",
    "Last Name": "Billson",
    "First Name": "Saskia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775895": {
    "id": "item_30353",
    "Last Name": "May",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775901": {
    "id": "item_28299",
    "Last Name": "Crossley",
    "First Name": "Debra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776128": {
    "id": "item_17743",
    "Last Name": "HUANG",
    "First Name": "WEI JUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776163": {
    "id": "item_2796",
    "Last Name": "Carr",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776206": {
    "id": "item_17741",
    "Last Name": "Khan",
    "First Name": "Tariq",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776235": {
    "id": "item_28815",
    "Last Name": "Chow",
    "First Name": "Chun Man",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776283": {
    "id": "item_13322",
    "Last Name": "Gregg",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776420": {
    "id": "item_17740",
    "Last Name": "Chawaldit",
    "First Name": "Kitpong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776558": {
    "id": "item_872",
    "Last Name": "Sordyl",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776593": {
    "id": "item_13319",
    "Last Name": "Auld",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776748": {
    "id": "item_28294",
    "Last Name": "Cardoza",
    "First Name": "Emy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776847": {
    "id": "item_28293",
    "Last Name": "Boey",
    "First Name": "Yan Yee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776979": {
    "id": "item_30347",
    "Last Name": "chen",
    "First Name": "ivy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777193": {
    "id": "item_30346",
    "Last Name": "Swavley",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777381": {
    "id": "item_2792",
    "Last Name": "Manrique",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777512": {
    "id": "item_5375",
    "Last Name": "CHAN",
    "First Name": "YUNG-YUAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777544": {
    "id": "item_13317",
    "Last Name": "de Russis",
    "First Name": "Cosimo Michele",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777717": {
    "id": "item_2791",
    "Last Name": "Romero",
    "First Name": "Jordi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777892": {
    "id": "item_869",
    "Last Name": "Zhu",
    "First Name": "Zhengdong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777902": {
    "id": "item_17733",
    "Last Name": "Slinn",
    "First Name": "Melina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37778220": {
    "id": "item_28291",
    "Last Name": "Chen",
    "First Name": "Quan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37778566": {
    "id": "item_17726",
    "Last Name": "Lam",
    "First Name": "Yuen Man Julysa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37778577": {
    "id": "item_17730",
    "Last Name": "Arana Rivera",
    "First Name": "Paloma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37779051": {
    "id": "item_2790",
    "Last Name": "Rudian",
    "First Name": "Tommaso",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37779212": {
    "id": "item_30343",
    "Last Name": "Jones",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37779381": {
    "id": "item_28290",
    "Last Name": "Blonski",
    "First Name": "Carly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37779495": {
    "id": "item_2789",
    "Last Name": "MacIntyre",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37779826": {
    "id": "item_5371",
    "Last Name": "Patel",
    "First Name": "Sunish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37779830": {
    "id": "item_2788",
    "Last Name": "Guffey",
    "First Name": "Cary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37780162": {
    "id": "item_30342",
    "Last Name": "Griffiths",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37780443": {
    "id": "item_866",
    "Last Name": "Evangelou",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37781235": {
    "id": "item_5368",
    "Last Name": "Schmidt",
    "First Name": "Leonard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37781661": {
    "id": "item_2787",
    "Last Name": "Jensen",
    "First Name": "Lyndsay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37781767": {
    "id": "item_13313",
    "Last Name": "Griffiths",
    "First Name": "Huw",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37781834": {
    "id": "item_17719",
    "Last Name": "Mullins",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782042": {
    "id": "item_30340",
    "Last Name": "Curtin",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782077": {
    "id": "item_17718",
    "Last Name": "Larsen",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782325": {
    "id": "item_17715",
    "Last Name": "Burley",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782457": {
    "id": "item_17713",
    "Last Name": "Gurung",
    "First Name": "Surya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782507": {
    "id": "item_5363",
    "Last Name": "Jacobs",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782616": {
    "id": "item_16069",
    "Last Name": "Huebertz",
    "First Name": "Petra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782652": {
    "id": "item_28287",
    "Last Name": "FISH",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782870": {
    "id": "item_17708",
    "Last Name": "Whitehouse",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783078": {
    "id": "item_13305",
    "Last Name": "Harvey",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783218": {
    "id": "item_5362",
    "Last Name": "Abouelnasr",
    "First Name": "Youssef",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783280": {
    "id": "item_17706",
    "Last Name": "Lawrence",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783292": {
    "id": "item_30336",
    "Last Name": "Man",
    "First Name": "Tat Leung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783352": {
    "id": "item_5361",
    "Last Name": "Giannakis",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783361": {
    "id": "item_14010",
    "Last Name": "O'Brien",
    "First Name": "Rylee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783473": {
    "id": "item_17705",
    "Last Name": "Zuo",
    "First Name": "Yue",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783485": {
    "id": "item_5359",
    "Last Name": "Lopez",
    "First Name": "Juan Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783489": {
    "id": "item_17704",
    "Last Name": "Caldow",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783504": {
    "id": "item_17703",
    "Last Name": "Nassivera",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783726": {
    "id": "item_17701",
    "Last Name": "Zhao",
    "First Name": "Xinwei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783856": {
    "id": "item_17698",
    "Last Name": "Zhou",
    "First Name": "Jianhua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783858": {
    "id": "item_13300",
    "Last Name": "Bailey",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783878": {
    "id": "item_28285",
    "Last Name": "Singleton-Fookes",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783975": {
    "id": "item_13299",
    "Last Name": "Penglis",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784042": {
    "id": "item_28284",
    "Last Name": "Irene",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784076": {
    "id": "item_13297",
    "Last Name": "Hains",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784102": {
    "id": "item_13296",
    "Last Name": "Masters",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784883": {
    "id": "item_13292",
    "Last Name": "Mielniczak",
    "First Name": "Mikolaj",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785218": {
    "id": "item_13291",
    "Last Name": "Egbers",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785259": {
    "id": "item_28282",
    "Last Name": "Davies",
    "First Name": "Priscilla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785444": {
    "id": "item_17686",
    "Last Name": "Clarke",
    "First Name": "Leandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785489": {
    "id": "item_5347",
    "Last Name": "Rae",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785517": {
    "id": "item_17684",
    "Last Name": "Bartels",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785584": {
    "id": "item_2781",
    "Last Name": "Purcell",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785636": {
    "id": "item_28280",
    "Last Name": "Murphy",
    "First Name": "Penelope",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785642": {
    "id": "item_30322",
    "Last Name": "Vien",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785981": {
    "id": "item_13289",
    "Last Name": "WANG",
    "First Name": "XIAO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785996": {
    "id": "item_5340",
    "Last Name": "Sproule",
    "First Name": "Ed",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786087": {
    "id": "item_28278",
    "Last Name": "Fuller",
    "First Name": "Reg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786151": {
    "id": "item_17676",
    "Last Name": "YAO",
    "First Name": "XI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786245": {
    "id": "item_17677",
    "Last Name": "Pattenden",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786500": {
    "id": "item_26404",
    "Last Name": "Low",
    "First Name": "Kiang Khai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786703": {
    "id": "item_30319",
    "Last Name": "Daglish",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786704": {
    "id": "item_13287",
    "Last Name": "McLeod",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786722": {
    "id": "item_17675",
    "Last Name": "Mulvenna",
    "First Name": "Conor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786766": {
    "id": "item_5338",
    "Last Name": "Zerbe",
    "First Name": "Mario",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787080": {
    "id": "item_853",
    "Last Name": "DIAMOND",
    "First Name": "PETER",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787136": {
    "id": "item_13286",
    "Last Name": "VIVANCO",
    "First Name": "GUILMAR",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787144": {
    "id": "item_17670",
    "Last Name": "Lee",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787211": {
    "id": "item_28849",
    "Last Name": "Latif",
    "First Name": "Ahmad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787449": {
    "id": "item_17664",
    "Last Name": "Callen",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787547": {
    "id": "item_30318",
    "Last Name": "SUN",
    "First Name": "LIJUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787590": {
    "id": "item_2776",
    "Last Name": "Kidman",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787676": {
    "id": "item_13282",
    "Last Name": "BIN ZAINAL",
    "First Name": "MOHAMAD FIRDAUS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787692": {
    "id": "item_17660",
    "Last Name": "Lieu",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788205": {
    "id": "item_30315",
    "Last Name": "Passey",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788316": {
    "id": "item_16064",
    "Last Name": "Campos",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788344": {
    "id": "item_849",
    "Last Name": "Retallack",
    "First Name": "Spencer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788424": {
    "id": "item_17654",
    "Last Name": "Cuta",
    "First Name": "Ildebrando",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788748": {
    "id": "item_2772",
    "Last Name": "Hollis",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788801": {
    "id": "item_28275",
    "Last Name": "Watkinson",
    "First Name": "Owen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789348": {
    "id": "item_3236",
    "Last Name": "Gashi",
    "First Name": "Skender",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789457": {
    "id": "item_5324",
    "Last Name": "Gaynor",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789458": {
    "id": "item_30310",
    "Last Name": "Gay",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789488": {
    "id": "item_13278",
    "Last Name": "Hsieh",
    "First Name": "Chi-Wen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789567": {
    "id": "item_16059",
    "Last Name": "Phan",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789572": {
    "id": "item_17648",
    "Last Name": "Lin",
    "First Name": "Chen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789720": {
    "id": "item_17647",
    "Last Name": "Christoffelsz",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789741": {
    "id": "item_30306",
    "Last Name": "Feeney",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789835": {
    "id": "item_30304",
    "Last Name": "Whitworth",
    "First Name": "Anne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789961": {
    "id": "item_17639",
    "Last Name": "wang",
    "First Name": "haoquan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789995": {
    "id": "item_30303",
    "Last Name": "Hugill",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790037": {
    "id": "item_28267",
    "Last Name": "Iopu",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790038": {
    "id": "item_17636",
    "Last Name": "Mannix",
    "First Name": "Grant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790094": {
    "id": "item_5311",
    "Last Name": "Davies",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790115": {
    "id": "item_17633",
    "Last Name": "Stuart",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790196": {
    "id": "item_3213",
    "Last Name": "Goros",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790214": {
    "id": "item_17630",
    "Last Name": "White",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790296": {
    "id": "item_17628",
    "Last Name": "Lillis",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790351": {
    "id": "item_5307",
    "Last Name": "Gomez Perez",
    "First Name": "Pedro Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790438": {
    "id": "item_17627",
    "Last Name": "McMahon",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790540": {
    "id": "item_16055",
    "Last Name": "TRAPPOLINI",
    "First Name": "DANIELE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790580": {
    "id": "item_17622",
    "Last Name": "Baseby",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790591": {
    "id": "item_30298",
    "Last Name": "Sutton-Smith",
    "First Name": "Ella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790714": {
    "id": "item_30293",
    "Last Name": "Sopala",
    "First Name": "Eoghan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790726": {
    "id": "item_13266",
    "Last Name": "Harrison",
    "First Name": "Louis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790846": {
    "id": "item_13264",
    "Last Name": "Ford",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790914": {
    "id": "item_2764",
    "Last Name": "Lampitoc",
    "First Name": "Zac",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790990": {
    "id": "item_30291",
    "Last Name": "Parcero",
    "First Name": "Myrna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790995": {
    "id": "item_5300",
    "Last Name": "Pegorari",
    "First Name": "Federica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791029": {
    "id": "item_17615",
    "Last Name": "Zapata Posada",
    "First Name": "Doris Seleny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791034": {
    "id": "item_836",
    "Last Name": "Augustinus",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791073": {
    "id": "item_16054",
    "Last Name": "Schwertner",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791097": {
    "id": "item_17611",
    "Last Name": "Fersando",
    "First Name": "Jovan Felix",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791182": {
    "id": "item_28257",
    "Last Name": "Salas",
    "First Name": "Kent June",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791203": {
    "id": "item_17608",
    "Last Name": "Cheung",
    "First Name": "Shu Wai Walter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791269": {
    "id": "item_5296",
    "Last Name": "Locque",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791650": {
    "id": "item_5295",
    "Last Name": "Reitz",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791799": {
    "id": "item_28255",
    "Last Name": "Sort",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791960": {
    "id": "item_5293",
    "Last Name": "Beltran",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37792120": {
    "id": "item_3212",
    "Last Name": "TSAI",
    "First Name": "YAO-YI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37792296": {
    "id": "item_835",
    "Last Name": "NGAI",
    "First Name": "WING HANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37792773": {
    "id": "item_16052",
    "Last Name": "Oyler",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37792799": {
    "id": "item_13259",
    "Last Name": "Valcarcel Castro",
    "First Name": "Juan Antonio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37802142": {
    "id": "item_2762",
    "Last Name": "Bayanov",
    "First Name": "Darkhan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37803470": {
    "id": "item_28252",
    "Last Name": "MAK",
    "First Name": "KIT SHU JENNIFER",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37806442": {
    "id": "item_5290",
    "Last Name": "Martes Martinez",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37817349": {
    "id": "item_5288",
    "Last Name": "Howard",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37824465": {
    "id": "item_17600",
    "Last Name": "Onyiego",
    "First Name": "Leonid",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37838368": {
    "id": "item_17599",
    "Last Name": "Brucker",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37838501": {
    "id": "item_832",
    "Last Name": "Kolkenbeck-Ruh",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37838502": {
    "id": "item_13254",
    "Last Name": "Constable",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37838565": {
    "id": "item_28248",
    "Last Name": "Ruddock-Ward",
    "First Name": "Kara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839122": {
    "id": "item_17597",
    "Last Name": "Liptak",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839352": {
    "id": "item_17596",
    "Last Name": "Masters",
    "First Name": "Ciaran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839447": {
    "id": "item_17591",
    "Last Name": "Goldsmith",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839498": {
    "id": "item_2758",
    "Last Name": "Turner",
    "First Name": "Bobby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839499": {
    "id": "item_5285",
    "Last Name": "Cahill",
    "First Name": "Trudy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839516": {
    "id": "item_17588",
    "Last Name": "Dalaguit",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839534": {
    "id": "item_14009",
    "Last Name": "Bourke",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839551": {
    "id": "item_17584",
    "Last Name": "Hewryk",
    "First Name": "Oresta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839624": {
    "id": "item_13249",
    "Last Name": "Malan",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839642": {
    "id": "item_825",
    "Last Name": "Brookland",
    "First Name": "Taine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839654": {
    "id": "item_5283",
    "Last Name": "Penzkofer",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839658": {
    "id": "item_28241",
    "Last Name": "Snedden",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839662": {
    "id": "item_17579",
    "Last Name": "Griffiths",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839664": {
    "id": "item_17578",
    "Last Name": "Cato",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839678": {
    "id": "item_17575",
    "Last Name": "Quinones",
    "First Name": "Andres",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839688": {
    "id": "item_5278",
    "Last Name": "Broer",
    "First Name": "Ernst Jan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839742": {
    "id": "item_30274",
    "Last Name": "Rookes",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839749": {
    "id": "item_30273",
    "Last Name": "Bittar",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839756": {
    "id": "item_13242",
    "Last Name": "Grover",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839786": {
    "id": "item_5277",
    "Last Name": "Van Loenen",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839806": {
    "id": "item_5274",
    "Last Name": "St David Jones",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839815": {
    "id": "item_5276",
    "Last Name": "Aerdeman",
    "First Name": "Philippe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839820": {
    "id": "item_30270",
    "Last Name": "Phillips",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839821": {
    "id": "item_5273",
    "Last Name": "Butko",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839829": {
    "id": "item_28237",
    "Last Name": "Shields",
    "First Name": "Jenna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839830": {
    "id": "item_13240",
    "Last Name": "Ashford",
    "First Name": "Deanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839857": {
    "id": "item_17566",
    "Last Name": "Martin",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839883": {
    "id": "item_17564",
    "Last Name": "Guo",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839902": {
    "id": "item_28236",
    "Last Name": "Melgar",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839911": {
    "id": "item_30265",
    "Last Name": "Seitanidou",
    "First Name": "Joy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839959": {
    "id": "item_17563",
    "Last Name": "Green",
    "First Name": "Les",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839977": {
    "id": "item_5272",
    "Last Name": "Peres",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840038": {
    "id": "item_5269",
    "Last Name": "Mizuno",
    "First Name": "Gustavo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840084": {
    "id": "item_17553",
    "Last Name": "Durfey",
    "First Name": "Casandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840148": {
    "id": "item_17559",
    "Last Name": "Harman",
    "First Name": "Rich",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840159": {
    "id": "item_28235",
    "Last Name": "sidaoui",
    "First Name": "omar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840194": {
    "id": "item_13233",
    "Last Name": "Holdsworth",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840204": {
    "id": "item_28234",
    "Last Name": "Barrowcliffe",
    "First Name": "Rose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840216": {
    "id": "item_5258",
    "Last Name": "Blake",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840288": {
    "id": "item_17549",
    "Last Name": "Sako",
    "First Name": "Aminata",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840303": {
    "id": "item_5256",
    "Last Name": "Bortz",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840317": {
    "id": "item_28231",
    "Last Name": "Graham",
    "First Name": "Janine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840328": {
    "id": "item_30261",
    "Last Name": "Espedido",
    "First Name": "Rosei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840380": {
    "id": "item_5254",
    "Last Name": "Bragg",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840395": {
    "id": "item_5253",
    "Last Name": "Ford",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840396": {
    "id": "item_3235",
    "Last Name": "Cohn",
    "First Name": "Molly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840433": {
    "id": "item_13225",
    "Last Name": "Caro",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840436": {
    "id": "item_17539",
    "Last Name": "Lum",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840450": {
    "id": "item_17540",
    "Last Name": "Cartisano",
    "First Name": "Dannielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840451": {
    "id": "item_30258",
    "Last Name": "Lawson",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840480": {
    "id": "item_17535",
    "Last Name": "Smith",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840487": {
    "id": "item_30257",
    "Last Name": "Melhuish",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840490": {
    "id": "item_5250",
    "Last Name": "Munso",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840544": {
    "id": "item_17531",
    "Last Name": "Browne",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840556": {
    "id": "item_17532",
    "Last Name": "Smith",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840665": {
    "id": "item_17528",
    "Last Name": "Bennett",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840692": {
    "id": "item_13214",
    "Last Name": "Walker",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840701": {
    "id": "item_13213",
    "Last Name": "Thirlwell",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840706": {
    "id": "item_30254",
    "Last Name": "Weir",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840714": {
    "id": "item_5245",
    "Last Name": "Lill",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840738": {
    "id": "item_28223",
    "Last Name": "Fisher",
    "First Name": "Emmeline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840821": {
    "id": "item_30250",
    "Last Name": "Pengilley",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840822": {
    "id": "item_28220",
    "Last Name": "Byrne",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840829": {
    "id": "item_30249",
    "Last Name": "Robson",
    "First Name": "Maureen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840843": {
    "id": "item_2738",
    "Last Name": "Virgona",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840955": {
    "id": "item_2735",
    "Last Name": "King",
    "First Name": "Helen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840960": {
    "id": "item_17518",
    "Last Name": "Tamayo",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841049": {
    "id": "item_17515",
    "Last Name": "Huynh",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841073": {
    "id": "item_17514",
    "Last Name": "Brown",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841086": {
    "id": "item_5238",
    "Last Name": "Brill",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841115": {
    "id": "item_5236",
    "Last Name": "Chen",
    "First Name": "Wyman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841166": {
    "id": "item_810",
    "Last Name": "Wong",
    "First Name": "Francis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841200": {
    "id": "item_30243",
    "Last Name": "Yeo",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841201": {
    "id": "item_17510",
    "Last Name": "Nield",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841216": {
    "id": "item_13206",
    "Last Name": "Perna",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841254": {
    "id": "item_30241",
    "Last Name": "Kilian",
    "First Name": "Lu-Inge",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841318": {
    "id": "item_31063",
    "Last Name": "Schottlandt",
    "First Name": "Dawn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841362": {
    "id": "item_17508",
    "Last Name": "Thomas",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841366": {
    "id": "item_28215",
    "Last Name": "Tiernan",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841371": {
    "id": "item_13205",
    "Last Name": "Roberts",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841400": {
    "id": "item_30239",
    "Last Name": "Morgan",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841423": {
    "id": "item_13204",
    "Last Name": "Herzfeld",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841452": {
    "id": "item_17499",
    "Last Name": "Titov",
    "First Name": "Genevieve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841478": {
    "id": "item_17498",
    "Last Name": "Pace",
    "First Name": "Antonino",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841492": {
    "id": "item_799",
    "Last Name": "Bowron",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841572": {
    "id": "item_5225",
    "Last Name": "Hibbert",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841597": {
    "id": "item_16040",
    "Last Name": "OÕBrien",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841615": {
    "id": "item_30235",
    "Last Name": "Perron",
    "First Name": "Jean-Francois",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841701": {
    "id": "item_13200",
    "Last Name": "Campbell",
    "First Name": "Grant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841702": {
    "id": "item_30234",
    "Last Name": "Wilde",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841738": {
    "id": "item_13199",
    "Last Name": "Wyers",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841806": {
    "id": "item_5219",
    "Last Name": "Drew",
    "First Name": "Derryn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841817": {
    "id": "item_5217",
    "Last Name": "Rootes",
    "First Name": "Damon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841849": {
    "id": "item_797",
    "Last Name": "Langtry",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841854": {
    "id": "item_17488",
    "Last Name": "Yee",
    "First Name": "Adele J",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841897": {
    "id": "item_13195",
    "Last Name": "Johnson",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841902": {
    "id": "item_17484",
    "Last Name": "Ackarie",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841940": {
    "id": "item_796",
    "Last Name": "Cipriano",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841981": {
    "id": "item_795",
    "Last Name": "Garcia Calpena Cerda",
    "First Name": "Joan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841992": {
    "id": "item_13194",
    "Last Name": "Searles",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842000": {
    "id": "item_30227",
    "Last Name": "Spittle",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842013": {
    "id": "item_5209",
    "Last Name": "Armstrong",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842043": {
    "id": "item_5208",
    "Last Name": "Stewart",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842060": {
    "id": "item_794",
    "Last Name": "Dufresne",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842084": {
    "id": "item_28205",
    "Last Name": "Cooper",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842101": {
    "id": "item_5207",
    "Last Name": "Cowper",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842127": {
    "id": "item_17474",
    "Last Name": "Cameron",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842158": {
    "id": "item_17473",
    "Last Name": "Heywood",
    "First Name": "Patrice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842205": {
    "id": "item_16039",
    "Last Name": "Lloyd",
    "First Name": "Bec",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842237": {
    "id": "item_17467",
    "Last Name": "Wong",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842277": {
    "id": "item_2725",
    "Last Name": "Paredes juarez",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842322": {
    "id": "item_2723",
    "Last Name": "Taranov",
    "First Name": "Valentin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842347": {
    "id": "item_5197",
    "Last Name": "Hamill",
    "First Name": "Cian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842386": {
    "id": "item_28200",
    "Last Name": "Walker",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842441": {
    "id": "item_5195",
    "Last Name": "Ogilvie",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842522": {
    "id": "item_2722",
    "Last Name": "Davey",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842575": {
    "id": "item_17462",
    "Last Name": "Brenner",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842589": {
    "id": "item_30216",
    "Last Name": "Tilly",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842606": {
    "id": "item_5193",
    "Last Name": "Barnett",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842627": {
    "id": "item_17461",
    "Last Name": "Ishisei",
    "First Name": "Takaaki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842649": {
    "id": "item_5192",
    "Last Name": "Grzeskowiak",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842695": {
    "id": "item_28198",
    "Last Name": "Bajada",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842743": {
    "id": "item_28196",
    "Last Name": "Blin",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842776": {
    "id": "item_5189",
    "Last Name": "Rice",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842817": {
    "id": "item_1393",
    "Last Name": "Pedroza",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842901": {
    "id": "item_5188",
    "Last Name": "Guiducci",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842994": {
    "id": "item_16033",
    "Last Name": "Sammy",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843052": {
    "id": "item_28194",
    "Last Name": "Barlis",
    "First Name": "Alain",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843107": {
    "id": "item_13179",
    "Last Name": "Kuo",
    "First Name": "Judy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843183": {
    "id": "item_5183",
    "Last Name": "Campbell",
    "First Name": "Glen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843208": {
    "id": "item_17450",
    "Last Name": "Patel",
    "First Name": "Jesal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843212": {
    "id": "item_30211",
    "Last Name": "Lee",
    "First Name": "Kai Yuen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843234": {
    "id": "item_17452",
    "Last Name": "Hewitt",
    "First Name": "Harrisen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843417": {
    "id": "item_28192",
    "Last Name": "Amanonce",
    "First Name": "Celso",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843485": {
    "id": "item_17448",
    "Last Name": "Kim",
    "First Name": "Samuel Suweon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843514": {
    "id": "item_5181",
    "Last Name": "Tyack",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843590": {
    "id": "item_781",
    "Last Name": "Wilson",
    "First Name": "Niall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843617": {
    "id": "item_5178",
    "Last Name": "BONSER",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843672": {
    "id": "item_30209",
    "Last Name": "Hillier",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843684": {
    "id": "item_5176",
    "Last Name": "Barnes",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843821": {
    "id": "item_30207",
    "Last Name": "Forte",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843828": {
    "id": "item_773",
    "Last Name": "Vasquez",
    "First Name": "Demis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843833": {
    "id": "item_17438",
    "Last Name": "Perrie",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843866": {
    "id": "item_30206",
    "Last Name": "Dean",
    "First Name": "Haidee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843943": {
    "id": "item_767",
    "Last Name": "Murphy",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844024": {
    "id": "item_5170",
    "Last Name": "Ellens",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844030": {
    "id": "item_13169",
    "Last Name": "Montgomery",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844069": {
    "id": "item_17435",
    "Last Name": "Romero",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844155": {
    "id": "item_5168",
    "Last Name": "Mangion",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844156": {
    "id": "item_13167",
    "Last Name": "Mcleary",
    "First Name": "Brock",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844163": {
    "id": "item_17432",
    "Last Name": "Lim",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844173": {
    "id": "item_13166",
    "Last Name": "Harrington",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844190": {
    "id": "item_13163",
    "Last Name": "Jacob",
    "First Name": "Sunil",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844224": {
    "id": "item_17429",
    "Last Name": "Ross",
    "First Name": "Ariarna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844285": {
    "id": "item_5167",
    "Last Name": "Eccles",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844325": {
    "id": "item_2711",
    "Last Name": "Leonhard",
    "First Name": "Tori",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844338": {
    "id": "item_5165",
    "Last Name": "May",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844369": {
    "id": "item_16319",
    "Last Name": "Black",
    "First Name": "Sinclair",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844436": {
    "id": "item_2709",
    "Last Name": "Douglas",
    "First Name": "Garrett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844451": {
    "id": "item_30200",
    "Last Name": "Quigley",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844603": {
    "id": "item_17419",
    "Last Name": "Acosta lopez",
    "First Name": "Paola leticia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844650": {
    "id": "item_13159",
    "Last Name": "Ainscow",
    "First Name": "Nic",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844660": {
    "id": "item_28187",
    "Last Name": "Archer",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844690": {
    "id": "item_28186",
    "Last Name": "Millen",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844716": {
    "id": "item_17421",
    "Last Name": "OTAKE",
    "First Name": "YUKI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844745": {
    "id": "item_5156",
    "Last Name": "McMullan",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844843": {
    "id": "item_17417",
    "Last Name": "Cho",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844855": {
    "id": "item_5154",
    "Last Name": "Sullivan",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844913": {
    "id": "item_30194",
    "Last Name": "Lipkiewicz",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844935": {
    "id": "item_17416",
    "Last Name": "McLellan",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844963": {
    "id": "item_17414",
    "Last Name": "carver",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845073": {
    "id": "item_30192",
    "Last Name": "Bangcong",
    "First Name": "Bernice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845138": {
    "id": "item_30191",
    "Last Name": "Small",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845159": {
    "id": "item_17411",
    "Last Name": "Bell",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845174": {
    "id": "item_30190",
    "Last Name": "Tran",
    "First Name": "Bobby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845176": {
    "id": "item_28182",
    "Last Name": "Foard",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845185": {
    "id": "item_17408",
    "Last Name": "Kirby",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845232": {
    "id": "item_28181",
    "Last Name": "Noble",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845256": {
    "id": "item_17406",
    "Last Name": "Fetherstonhaugh",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845351": {
    "id": "item_28179",
    "Last Name": "Kantaris",
    "First Name": "Georgios",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845378": {
    "id": "item_17404",
    "Last Name": "Rautenbach",
    "First Name": "Arno",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845466": {
    "id": "item_28178",
    "Last Name": "Whiting",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845475": {
    "id": "item_761",
    "Last Name": "Hall",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845542": {
    "id": "item_758",
    "Last Name": "DAVALOS DAVALOS",
    "First Name": "ANDRES",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845592": {
    "id": "item_17399",
    "Last Name": "Crawford",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845604": {
    "id": "item_5147",
    "Last Name": "zhang",
    "First Name": "xiaogang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845633": {
    "id": "item_17398",
    "Last Name": "Milton",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845659": {
    "id": "item_17397",
    "Last Name": "Osborn",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845663": {
    "id": "item_17396",
    "Last Name": "Choi",
    "First Name": "Jeong Won",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845784": {
    "id": "item_756",
    "Last Name": "Wilson",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845796": {
    "id": "item_14008",
    "Last Name": "LIN",
    "First Name": "YIN-TING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845816": {
    "id": "item_13153",
    "Last Name": "Mulherin",
    "First Name": "Jordyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845828": {
    "id": "item_5145",
    "Last Name": "Brotherson-Clarke",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845905": {
    "id": "item_30185",
    "Last Name": "Woodward",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845989": {
    "id": "item_28174",
    "Last Name": "Rubincam",
    "First Name": "Meghan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846011": {
    "id": "item_5142",
    "Last Name": "Lorenzo",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846020": {
    "id": "item_17392",
    "Last Name": "Espino",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846028": {
    "id": "item_17393",
    "Last Name": "Osier",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846038": {
    "id": "item_28173",
    "Last Name": "Watkins",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846144": {
    "id": "item_2696",
    "Last Name": "Lau",
    "First Name": "Kwok Chu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846194": {
    "id": "item_752",
    "Last Name": "Mylonas",
    "First Name": "Taso",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846264": {
    "id": "item_5139",
    "Last Name": "Quinn",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846271": {
    "id": "item_13152",
    "Last Name": "Gascoigne",
    "First Name": "Derek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846317": {
    "id": "item_2694",
    "Last Name": "Tulett",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846407": {
    "id": "item_750",
    "Last Name": "Patatoukos",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846450": {
    "id": "item_5137",
    "Last Name": "Cooper",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846462": {
    "id": "item_17383",
    "Last Name": "Forrester",
    "First Name": "Mackenzy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846583": {
    "id": "item_5134",
    "Last Name": "Galloway",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846621": {
    "id": "item_5133",
    "Last Name": "Jenkins",
    "First Name": "Ry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846641": {
    "id": "item_30178",
    "Last Name": "Slavtcheva",
    "First Name": "Magdalena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846649": {
    "id": "item_1392",
    "Last Name": "TSUBONE",
    "First Name": "ORII",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846772": {
    "id": "item_30177",
    "Last Name": "Schaber",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846867": {
    "id": "item_13150",
    "Last Name": "Hayes",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846900": {
    "id": "item_5129",
    "Last Name": "Blanco",
    "First Name": "Enrique",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846926": {
    "id": "item_30175",
    "Last Name": "Watsing",
    "First Name": "Wichayaporn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847024": {
    "id": "item_17375",
    "Last Name": "Plowright",
    "First Name": "Lydia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847079": {
    "id": "item_17374",
    "Last Name": "Moody",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847106": {
    "id": "item_5125",
    "Last Name": "Cafra",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847115": {
    "id": "item_17372",
    "Last Name": "Spielbuechler",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847119": {
    "id": "item_17371",
    "Last Name": "Rossouw",
    "First Name": "Clyde",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847148": {
    "id": "item_30173",
    "Last Name": "Long",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847210": {
    "id": "item_17370",
    "Last Name": "Chang",
    "First Name": "Hsuen Wen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847220": {
    "id": "item_30170",
    "Last Name": "Long",
    "First Name": "Punthip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847323": {
    "id": "item_30167",
    "Last Name": "Fitzgerald",
    "First Name": "TAYLOR",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847372": {
    "id": "item_30166",
    "Last Name": "Amog",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847479": {
    "id": "item_17367",
    "Last Name": "Roediger",
    "First Name": "Amelie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847499": {
    "id": "item_17366",
    "Last Name": "Elgood",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847541": {
    "id": "item_743",
    "Last Name": "Mahon",
    "First Name": "Kirk",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847557": {
    "id": "item_16017",
    "Last Name": "Mitchell-Bathgate",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847559": {
    "id": "item_17360",
    "Last Name": "Garrelts",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847633": {
    "id": "item_17359",
    "Last Name": "Beattie",
    "First Name": "Carrie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847635": {
    "id": "item_5118",
    "Last Name": "Matthews",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847752": {
    "id": "item_30162",
    "Last Name": "Simon",
    "First Name": "Ariella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847803": {
    "id": "item_5116",
    "Last Name": "Pearce",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847936": {
    "id": "item_2680",
    "Last Name": "Hollingworth",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847968": {
    "id": "item_17349",
    "Last Name": "Ryan",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848111": {
    "id": "item_2678",
    "Last Name": "Le",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848125": {
    "id": "item_16015",
    "Last Name": "James",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848190": {
    "id": "item_30159",
    "Last Name": "Alexander",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848211": {
    "id": "item_17345",
    "Last Name": "GONG",
    "First Name": "JIEMING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848219": {
    "id": "item_5109",
    "Last Name": "Grove",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848242": {
    "id": "item_17344",
    "Last Name": "Potter",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848252": {
    "id": "item_733",
    "Last Name": "Tani",
    "First Name": "Masakazu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848255": {
    "id": "item_17341",
    "Last Name": "McGregor",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848280": {
    "id": "item_1391",
    "Last Name": "webber",
    "First Name": "jane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848284": {
    "id": "item_5107",
    "Last Name": "McCarthy",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848311": {
    "id": "item_17337",
    "Last Name": "Hartingdon",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848331": {
    "id": "item_13147",
    "Last Name": "MacKellin",
    "First Name": "Glen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848373": {
    "id": "item_16013",
    "Last Name": "McDonald",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848398": {
    "id": "item_5104",
    "Last Name": "Ancelin",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848414": {
    "id": "item_17335",
    "Last Name": "Perrin",
    "First Name": "Carly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848415": {
    "id": "item_17334",
    "Last Name": "Go",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848433": {
    "id": "item_5100",
    "Last Name": "Marriott",
    "First Name": "Shayne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848455": {
    "id": "item_28153",
    "Last Name": "Quiocho",
    "First Name": "Ruben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848473": {
    "id": "item_5098",
    "Last Name": "Moore",
    "First Name": "Lachy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848522": {
    "id": "item_16012",
    "Last Name": "Lew",
    "First Name": "Keith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848531": {
    "id": "item_2673",
    "Last Name": "YUFEI",
    "First Name": "WU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848535": {
    "id": "item_16011",
    "Last Name": "Schaefer",
    "First Name": "Matthias",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848566": {
    "id": "item_28152",
    "Last Name": "Wembridge",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848614": {
    "id": "item_30153",
    "Last Name": "French",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848662": {
    "id": "item_728",
    "Last Name": "Mildren",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848664": {
    "id": "item_17324",
    "Last Name": "McCracken",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848667": {
    "id": "item_5096",
    "Last Name": "West",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848684": {
    "id": "item_727",
    "Last Name": "Schafer",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848695": {
    "id": "item_17322",
    "Last Name": "Jones",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848735": {
    "id": "item_17318",
    "Last Name": "Lawrence",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848746": {
    "id": "item_30152",
    "Last Name": "Said",
    "First Name": "Ivo Chumainiah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848798": {
    "id": "item_17315",
    "Last Name": "GONG",
    "First Name": "WEIPING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848824": {
    "id": "item_725",
    "Last Name": "Giraldo",
    "First Name": "Gustavo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848867": {
    "id": "item_17312",
    "Last Name": "Murphy",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848871": {
    "id": "item_25643",
    "Last Name": "Smith",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848906": {
    "id": "item_16008",
    "Last Name": "Parkhouse",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848910": {
    "id": "item_17309",
    "Last Name": "Boulton",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848935": {
    "id": "item_17308",
    "Last Name": "Rose",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848937": {
    "id": "item_5089",
    "Last Name": "Pearson",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848968": {
    "id": "item_723",
    "Last Name": "Pidgeon",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848988": {
    "id": "item_30148",
    "Last Name": "Betonio",
    "First Name": "William Kristopherson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849012": {
    "id": "item_5088",
    "Last Name": "Prior",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849028": {
    "id": "item_30147",
    "Last Name": "Bock",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849057": {
    "id": "item_17300",
    "Last Name": "Wong",
    "First Name": "Wilson Wai Chung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849135": {
    "id": "item_5085",
    "Last Name": "Clifton-Smith",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849138": {
    "id": "item_5084",
    "Last Name": "Miller",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849182": {
    "id": "item_13141",
    "Last Name": "Foord",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849341": {
    "id": "item_720",
    "Last Name": "Matthews",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849345": {
    "id": "item_26458",
    "Last Name": "MAILLOT",
    "First Name": "StŽphanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849392": {
    "id": "item_28139",
    "Last Name": "Gesilva",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849415": {
    "id": "item_28138",
    "Last Name": "Perumal",
    "First Name": "Sunita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849451": {
    "id": "item_13139",
    "Last Name": "Qiu",
    "First Name": "Yang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849464": {
    "id": "item_17288",
    "Last Name": "Korogi",
    "First Name": "Taku",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849469": {
    "id": "item_17290",
    "Last Name": "Rizaldi",
    "First Name": "Adrian Rexy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849507": {
    "id": "item_17287",
    "Last Name": "Dalla Rosa",
    "First Name": "Eleonora",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849512": {
    "id": "item_17286",
    "Last Name": "Nicol",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849567": {
    "id": "item_30138",
    "Last Name": "Rebudal III",
    "First Name": "Ernesto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849611": {
    "id": "item_2665",
    "Last Name": "Yu",
    "First Name": "Hui mei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849679": {
    "id": "item_28136",
    "Last Name": "KIM",
    "First Name": "GUIJUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849739": {
    "id": "item_3234",
    "Last Name": "MŸller",
    "First Name": "Markus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849743": {
    "id": "item_5077",
    "Last Name": "Rae",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849757": {
    "id": "item_2664",
    "Last Name": "Razeto Caceres",
    "First Name": "Hector",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849791": {
    "id": "item_30137",
    "Last Name": "Tonuri",
    "First Name": "Callum",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849801": {
    "id": "item_15999",
    "Last Name": "Silvino",
    "First Name": "Rechilo II",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849903": {
    "id": "item_28132",
    "Last Name": "Zhang",
    "First Name": "Lei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849920": {
    "id": "item_5074",
    "Last Name": "Barbalich",
    "First Name": "Florence",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850036": {
    "id": "item_17280",
    "Last Name": "Whitehead",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850108": {
    "id": "item_26457",
    "Last Name": "ITO",
    "First Name": "HITOSHI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850289": {
    "id": "item_17277",
    "Last Name": "Dewey",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850304": {
    "id": "item_28126",
    "Last Name": "Meli",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850464": {
    "id": "item_5070",
    "Last Name": "Hsieh",
    "First Name": "Ming-Hsun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850684": {
    "id": "item_13136",
    "Last Name": "Upton",
    "First Name": "Carole-Anne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850832": {
    "id": "item_5065",
    "Last Name": "Agalawatta",
    "First Name": "Leon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851008": {
    "id": "item_30131",
    "Last Name": "Crew",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851045": {
    "id": "item_15998",
    "Last Name": "IP",
    "First Name": "CHI KIT",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851071": {
    "id": "item_5064",
    "Last Name": "Cunningham",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851106": {
    "id": "item_17274",
    "Last Name": "Buttiglione",
    "First Name": "Leonardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851630": {
    "id": "item_17271",
    "Last Name": "Albien",
    "First Name": "Jan-Dennis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851749": {
    "id": "item_28124",
    "Last Name": "Lai",
    "First Name": "Tuck Yong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851769": {
    "id": "item_17270",
    "Last Name": "Blume",
    "First Name": "Till",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851827": {
    "id": "item_30129",
    "Last Name": "Cho",
    "First Name": "Hok Yan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851940": {
    "id": "item_5061",
    "Last Name": "Rabago",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851952": {
    "id": "item_17268",
    "Last Name": "Chiu",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851966": {
    "id": "item_17267",
    "Last Name": "Fung",
    "First Name": "Billy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851994": {
    "id": "item_17266",
    "Last Name": "van Son",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852040": {
    "id": "item_28123",
    "Last Name": "Clarke",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852170": {
    "id": "item_5059",
    "Last Name": "Gekonge",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852336": {
    "id": "item_1371",
    "Last Name": "McHugh",
    "First Name": "Haley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852678": {
    "id": "item_28121",
    "Last Name": "Ng",
    "First Name": "Doris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852692": {
    "id": "item_714",
    "Last Name": "Reaume",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852693": {
    "id": "item_2658",
    "Last Name": "Cianciotto",
    "First Name": "Domenico",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852890": {
    "id": "item_5058",
    "Last Name": "Gallagher",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852980": {
    "id": "item_713",
    "Last Name": "Plotnikov",
    "First Name": "Viktor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853004": {
    "id": "item_28119",
    "Last Name": "Diaz",
    "First Name": "Jose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853461": {
    "id": "item_28848",
    "Last Name": "Mart’nez Mar",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853512": {
    "id": "item_17263",
    "Last Name": "Crespo",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853544": {
    "id": "item_2655",
    "Last Name": "Anderson",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853661": {
    "id": "item_17259",
    "Last Name": "Kindseth",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853671": {
    "id": "item_30122",
    "Last Name": "Cayanong",
    "First Name": "Rafael Santino",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853672": {
    "id": "item_17258",
    "Last Name": "Mann",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853710": {
    "id": "item_2654",
    "Last Name": "Ferguson",
    "First Name": "Gordon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854072": {
    "id": "item_30121",
    "Last Name": "Lutz",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854266": {
    "id": "item_28118",
    "Last Name": "Podhajska",
    "First Name": "Agata",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854383": {
    "id": "item_30120",
    "Last Name": "Johns",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854384": {
    "id": "item_17253",
    "Last Name": "Jansen",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854503": {
    "id": "item_28117",
    "Last Name": "paul",
    "First Name": "adrian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854582": {
    "id": "item_5054",
    "Last Name": "Zhao",
    "First Name": "Yong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854681": {
    "id": "item_17249",
    "Last Name": "Alonso",
    "First Name": "Alfredo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854687": {
    "id": "item_15994",
    "Last Name": "Tuffy",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854725": {
    "id": "item_30119",
    "Last Name": "Hawyes",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854756": {
    "id": "item_711",
    "Last Name": "Boyd",
    "First Name": "Salem",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854807": {
    "id": "item_28115",
    "Last Name": "Lyon",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854876": {
    "id": "item_2652",
    "Last Name": "Felgner",
    "First Name": "Camden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854886": {
    "id": "item_17246",
    "Last Name": "Tjipto",
    "First Name": "Alwie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854904": {
    "id": "item_17245",
    "Last Name": "OÕDnnell",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854937": {
    "id": "item_5050",
    "Last Name": "Sadler",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855000": {
    "id": "item_706",
    "Last Name": "Fox",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855137": {
    "id": "item_28112",
    "Last Name": "CHU",
    "First Name": "JUI-CHIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855208": {
    "id": "item_2651",
    "Last Name": "Rodriguez Maldonado",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855267": {
    "id": "item_5046",
    "Last Name": "Sprowles",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855391": {
    "id": "item_17235",
    "Last Name": "Van",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855946": {
    "id": "item_2650",
    "Last Name": "Shi",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856015": {
    "id": "item_30112",
    "Last Name": "San",
    "First Name": "Xuan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856024": {
    "id": "item_2649",
    "Last Name": "Yuan",
    "First Name": "Roger",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856099": {
    "id": "item_5042",
    "Last Name": "Baumgarten",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856179": {
    "id": "item_17227",
    "Last Name": "Hunt",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856261": {
    "id": "item_17223",
    "Last Name": "Ponduri",
    "First Name": "Kavitha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856407": {
    "id": "item_28106",
    "Last Name": "Ham",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856415": {
    "id": "item_15990",
    "Last Name": "Jones",
    "First Name": "Dee Dee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856511": {
    "id": "item_30106",
    "Last Name": "Fonseca",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856512": {
    "id": "item_17217",
    "Last Name": "Duthie",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856513": {
    "id": "item_13123",
    "Last Name": "Orman",
    "First Name": "Frances",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856625": {
    "id": "item_17215",
    "Last Name": "Joy",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856845": {
    "id": "item_17214",
    "Last Name": "Moreton",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856932": {
    "id": "item_695",
    "Last Name": "Rasmussen",
    "First Name": "RenŽ Randrup",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857168": {
    "id": "item_17211",
    "Last Name": "Yu",
    "First Name": "Jin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857262": {
    "id": "item_15988",
    "Last Name": "Gonzalez",
    "First Name": "Alejandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857298": {
    "id": "item_30103",
    "Last Name": "CARDWELL",
    "First Name": "BELINDA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857386": {
    "id": "item_17208",
    "Last Name": "Dayah",
    "First Name": "Jaymal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857456": {
    "id": "item_5027",
    "Last Name": "O Brien",
    "First Name": "Kilian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857485": {
    "id": "item_5025",
    "Last Name": "Canini",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857609": {
    "id": "item_17205",
    "Last Name": "Bodine",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857715": {
    "id": "item_13121",
    "Last Name": "Soma",
    "First Name": "Kentaro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857716": {
    "id": "item_15986",
    "Last Name": "Poptie",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857726": {
    "id": "item_13120",
    "Last Name": "Sadler",
    "First Name": "Jenny Paola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857770": {
    "id": "item_5019",
    "Last Name": "Mcgill",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857777": {
    "id": "item_17199",
    "Last Name": "Kavanagh",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857792": {
    "id": "item_17198",
    "Last Name": "Birch",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857868": {
    "id": "item_17196",
    "Last Name": "Almond-Drummond",
    "First Name": "Penni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857878": {
    "id": "item_15984",
    "Last Name": "Makunike",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857943": {
    "id": "item_17191",
    "Last Name": "Maher Allan",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858046": {
    "id": "item_30096",
    "Last Name": "Syed",
    "First Name": "Farhan ahmed",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858096": {
    "id": "item_17188",
    "Last Name": "Sujatmoko",
    "First Name": "Hanura Ilham",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858378": {
    "id": "item_2636",
    "Last Name": "Gonzalez",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858414": {
    "id": "item_5013",
    "Last Name": "Kaur",
    "First Name": "Nataliegh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858584": {
    "id": "item_30095",
    "Last Name": "Lajim",
    "First Name": "Zalindah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858635": {
    "id": "item_17183",
    "Last Name": "Davis",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858678": {
    "id": "item_5011",
    "Last Name": "McMillan",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858701": {
    "id": "item_17181",
    "Last Name": "Lewis",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858754": {
    "id": "item_17180",
    "Last Name": "McNeill",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858767": {
    "id": "item_5008",
    "Last Name": "Ives",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858880": {
    "id": "item_30091",
    "Last Name": "Thalib",
    "First Name": "Rayan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858932": {
    "id": "item_28088",
    "Last Name": "Susanti",
    "First Name": "Sri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858933": {
    "id": "item_15982",
    "Last Name": "CHAN",
    "First Name": "PUI YEE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859062": {
    "id": "item_30088",
    "Last Name": "Soares",
    "First Name": "Genevieve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859130": {
    "id": "item_5005",
    "Last Name": "Teng",
    "First Name": "Tsunghan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859134": {
    "id": "item_28087",
    "Last Name": "Qiu",
    "First Name": "Hongrun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859152": {
    "id": "item_13115",
    "Last Name": "Guarte",
    "First Name": "Peter paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859273": {
    "id": "item_5004",
    "Last Name": "Parkins",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859358": {
    "id": "item_17173",
    "Last Name": "Dreyer",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859514": {
    "id": "item_17172",
    "Last Name": "Gunnar",
    "First Name": "Libby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859541": {
    "id": "item_5002",
    "Last Name": "Camuglia",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859542": {
    "id": "item_17170",
    "Last Name": "Chang Gonzalez",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859639": {
    "id": "item_30085",
    "Last Name": "Umesh Prasad",
    "First Name": "Raj",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859669": {
    "id": "item_30083",
    "Last Name": "Zhang",
    "First Name": "Yi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859763": {
    "id": "item_2632",
    "Last Name": "McLeod",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859849": {
    "id": "item_30082",
    "Last Name": "Moreland",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859887": {
    "id": "item_28080",
    "Last Name": "Knight",
    "First Name": "Jeanette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859923": {
    "id": "item_30079",
    "Last Name": "Carrillo",
    "First Name": "Juan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859969": {
    "id": "item_30078",
    "Last Name": "Pook",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859993": {
    "id": "item_17160",
    "Last Name": "Treloar",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859995": {
    "id": "item_681",
    "Last Name": "Bankes",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860045": {
    "id": "item_17157",
    "Last Name": "Wheatland",
    "First Name": "Bede",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860102": {
    "id": "item_30075",
    "Last Name": "HUANG",
    "First Name": "HSIN CHU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860149": {
    "id": "item_30074",
    "Last Name": "Gilles",
    "First Name": "Christian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860172": {
    "id": "item_17155",
    "Last Name": "Homer",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860276": {
    "id": "item_17152",
    "Last Name": "Wathen",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860309": {
    "id": "item_13112",
    "Last Name": "Most",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860310": {
    "id": "item_4997",
    "Last Name": "Marateo",
    "First Name": "Luca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860314": {
    "id": "item_30073",
    "Last Name": "Petrovski",
    "First Name": "Zoran",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860358": {
    "id": "item_4996",
    "Last Name": "Egan",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860374": {
    "id": "item_17150",
    "Last Name": "White",
    "First Name": "4068",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860424": {
    "id": "item_17149",
    "Last Name": "Yabut",
    "First Name": "Ludwig Alain",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860569": {
    "id": "item_28078",
    "Last Name": "Qin",
    "First Name": "Yuyuan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860665": {
    "id": "item_28076",
    "Last Name": "Perry",
    "First Name": "Nick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860695": {
    "id": "item_13111",
    "Last Name": "Vidal Navarro",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860761": {
    "id": "item_30068",
    "Last Name": "Martin",
    "First Name": "Jose Alfredo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860773": {
    "id": "item_30069",
    "Last Name": "Bloss",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860918": {
    "id": "item_13110",
    "Last Name": "Thomas",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860958": {
    "id": "item_17140",
    "Last Name": "Devara",
    "First Name": "Afis Herman Reza",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860962": {
    "id": "item_17139",
    "Last Name": "May",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861106": {
    "id": "item_17134",
    "Last Name": "Cummins",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861185": {
    "id": "item_2623",
    "Last Name": "Coplestone",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861213": {
    "id": "item_2621",
    "Last Name": "HSU",
    "First Name": "HUI LIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861256": {
    "id": "item_28074",
    "Last Name": "Verrell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861471": {
    "id": "item_4990",
    "Last Name": "Bailey",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861573": {
    "id": "item_28072",
    "Last Name": "Felgate",
    "First Name": "Roisin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861761": {
    "id": "item_28069",
    "Last Name": "Viuya",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861775": {
    "id": "item_17121",
    "Last Name": "Ronseria",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861805": {
    "id": "item_25642",
    "Last Name": "Hewish",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861929": {
    "id": "item_17119",
    "Last Name": "Souter-Robertson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861945": {
    "id": "item_4985",
    "Last Name": "Brown",
    "First Name": "Nisha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861973": {
    "id": "item_30057",
    "Last Name": "Maharjan",
    "First Name": "Bikash",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862000": {
    "id": "item_25641",
    "Last Name": "Hewish",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862045": {
    "id": "item_30056",
    "Last Name": "Stoughton",
    "First Name": "Eli",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862073": {
    "id": "item_17115",
    "Last Name": "Ong",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862120": {
    "id": "item_30054",
    "Last Name": "Wilson",
    "First Name": "Haylee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862162": {
    "id": "item_28065",
    "Last Name": "Ross",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862164": {
    "id": "item_28063",
    "Last Name": "Gebhart",
    "First Name": "Judy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862167": {
    "id": "item_2615",
    "Last Name": "Boba",
    "First Name": "Enri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862183": {
    "id": "item_13105",
    "Last Name": "Grant",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862266": {
    "id": "item_2613",
    "Last Name": "O'Brien",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862311": {
    "id": "item_26456",
    "Last Name": "Murrell",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862331": {
    "id": "item_2611",
    "Last Name": "Fitzpatrick",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862440": {
    "id": "item_28062",
    "Last Name": "Edson",
    "First Name": "Kane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862532": {
    "id": "item_672",
    "Last Name": "Koest",
    "First Name": "Geordie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862558": {
    "id": "item_671",
    "Last Name": "Terry",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862597": {
    "id": "item_2610",
    "Last Name": "Teo",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862600": {
    "id": "item_17105",
    "Last Name": "Eykamp",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862604": {
    "id": "item_28060",
    "Last Name": "Leung",
    "First Name": "Denise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862677": {
    "id": "item_17101",
    "Last Name": "Germino",
    "First Name": "Rosario",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862712": {
    "id": "item_30050",
    "Last Name": "Dostal",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862715": {
    "id": "item_4978",
    "Last Name": "CHEN",
    "First Name": "HUNG JU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862740": {
    "id": "item_4976",
    "Last Name": "Go",
    "First Name": "Mar Benedict",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862744": {
    "id": "item_2609",
    "Last Name": "Manchester",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862808": {
    "id": "item_667",
    "Last Name": "Rose",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862844": {
    "id": "item_30047",
    "Last Name": "Inns",
    "First Name": "Darryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862923": {
    "id": "item_17096",
    "Last Name": "Fieldstead",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863076": {
    "id": "item_665",
    "Last Name": "Lane",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863087": {
    "id": "item_4971",
    "Last Name": "Bryant",
    "First Name": "Rielly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863102": {
    "id": "item_663",
    "Last Name": "Pemberton",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863155": {
    "id": "item_17090",
    "Last Name": "Hart",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863164": {
    "id": "item_17088",
    "Last Name": "Murray",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863166": {
    "id": "item_17087",
    "Last Name": "Bogle",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863179": {
    "id": "item_17086",
    "Last Name": "Spence",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863195": {
    "id": "item_30043",
    "Last Name": "McIver",
    "First Name": "Ally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863197": {
    "id": "item_30042",
    "Last Name": "Hart",
    "First Name": "Anya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863271": {
    "id": "item_17080",
    "Last Name": "McFadden",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863274": {
    "id": "item_28052",
    "Last Name": "Khorsun",
    "First Name": "Ilya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863279": {
    "id": "item_28051",
    "Last Name": "Khorsun",
    "First Name": "Alisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863352": {
    "id": "item_17078",
    "Last Name": "Singleton",
    "First Name": "Darcy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863389": {
    "id": "item_2601",
    "Last Name": "Luscombe",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863394": {
    "id": "item_4963",
    "Last Name": "Berjaoui",
    "First Name": "Ziad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863401": {
    "id": "item_28047",
    "Last Name": "Gillam",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863450": {
    "id": "item_17075",
    "Last Name": "Valencia",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863454": {
    "id": "item_17074",
    "Last Name": "Fok",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863470": {
    "id": "item_13101",
    "Last Name": "LEE",
    "First Name": "KAUNHUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863506": {
    "id": "item_13100",
    "Last Name": "AHN",
    "First Name": "EUNJUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863526": {
    "id": "item_30036",
    "Last Name": "Willard-Franz",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863544": {
    "id": "item_2599",
    "Last Name": "Sturmann",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863545": {
    "id": "item_2598",
    "Last Name": "Israel",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863554": {
    "id": "item_14007",
    "Last Name": "Li",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863636": {
    "id": "item_30034",
    "Last Name": "Clayton",
    "First Name": "Shona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863645": {
    "id": "item_2596",
    "Last Name": "Wood",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863648": {
    "id": "item_28042",
    "Last Name": "Goode",
    "First Name": "Adrienne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863662": {
    "id": "item_28044",
    "Last Name": "Carey",
    "First Name": "Louisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863683": {
    "id": "item_17067",
    "Last Name": "YANG",
    "First Name": "HAN-CHUAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863744": {
    "id": "item_4955",
    "Last Name": "Zanardo",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863756": {
    "id": "item_13098",
    "Last Name": "Graffen",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863783": {
    "id": "item_30031",
    "Last Name": "V",
    "First Name": "Ashwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863785": {
    "id": "item_17062",
    "Last Name": "Howarth",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863841": {
    "id": "item_30028",
    "Last Name": "Damen",
    "First Name": "Rikki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863843": {
    "id": "item_30027",
    "Last Name": "wonhee",
    "First Name": "jo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863941": {
    "id": "item_2594",
    "Last Name": "Montvilaite",
    "First Name": "Diana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864025": {
    "id": "item_4953",
    "Last Name": "Gauder",
    "First Name": "Maurice",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864027": {
    "id": "item_4952",
    "Last Name": "Driscoll",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864076": {
    "id": "item_17059",
    "Last Name": "Gwynne",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864111": {
    "id": "item_2593",
    "Last Name": "Deasy",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864126": {
    "id": "item_17056",
    "Last Name": "Wain",
    "First Name": "Louis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864137": {
    "id": "item_4948",
    "Last Name": "Wieliczko",
    "First Name": "Guillaume",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864146": {
    "id": "item_653",
    "Last Name": "Arthurs",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864148": {
    "id": "item_28037",
    "Last Name": "Cauchi",
    "First Name": "Noah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864178": {
    "id": "item_4947",
    "Last Name": "PEDREIRA TABOADA",
    "First Name": "CARLOS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864181": {
    "id": "item_4946",
    "Last Name": "Talty",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864209": {
    "id": "item_650",
    "Last Name": "clarke",
    "First Name": "jason",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864221": {
    "id": "item_17054",
    "Last Name": "Bacovic",
    "First Name": "Tara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864280": {
    "id": "item_4945",
    "Last Name": "Mildrum",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864314": {
    "id": "item_28035",
    "Last Name": "Shnitnikova",
    "First Name": "Nataliia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864368": {
    "id": "item_649",
    "Last Name": "Hyer",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864460": {
    "id": "item_4942",
    "Last Name": "Villacorte",
    "First Name": "Virgil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864492": {
    "id": "item_28031",
    "Last Name": "Song",
    "First Name": "Yung-wei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864524": {
    "id": "item_4938",
    "Last Name": "Ding",
    "First Name": "Yu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864528": {
    "id": "item_17047",
    "Last Name": "Shahzad",
    "First Name": "Faisal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864545": {
    "id": "item_17049",
    "Last Name": "Mukhambetova",
    "First Name": "Aiganym",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864572": {
    "id": "item_17048",
    "Last Name": "Dodds",
    "First Name": "Zo‘",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864626": {
    "id": "item_28028",
    "Last Name": "Flanagan",
    "First Name": "Chrissy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864639": {
    "id": "item_13096",
    "Last Name": "WENG",
    "First Name": "MAO-CHUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864641": {
    "id": "item_13095",
    "Last Name": "Tien",
    "First Name": "Hui-Lun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864642": {
    "id": "item_2588",
    "Last Name": "Leung",
    "First Name": "Wing Lam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864649": {
    "id": "item_15962",
    "Last Name": "Aoki",
    "First Name": "Mayumi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864665": {
    "id": "item_17043",
    "Last Name": "OYAMA",
    "First Name": "YUTO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864675": {
    "id": "item_30018",
    "Last Name": "Octafiani",
    "First Name": "Fanny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864712": {
    "id": "item_17042",
    "Last Name": "Ale",
    "First Name": "Ailao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864733": {
    "id": "item_13094",
    "Last Name": "Byrne",
    "First Name": "Andres",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864775": {
    "id": "item_17040",
    "Last Name": "Bowyer",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864779": {
    "id": "item_2586",
    "Last Name": "Malinowski",
    "First Name": "Pawel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864822": {
    "id": "item_2584",
    "Last Name": "Zuill",
    "First Name": "Zorica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864824": {
    "id": "item_30015",
    "Last Name": "McDowell",
    "First Name": "Taylah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864849": {
    "id": "item_17037",
    "Last Name": "Senia",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864850": {
    "id": "item_17038",
    "Last Name": "Webb",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864860": {
    "id": "item_30014",
    "Last Name": "Thalib",
    "First Name": "Razeen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864869": {
    "id": "item_17035",
    "Last Name": "Chan",
    "First Name": "Chi Hang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864902": {
    "id": "item_30013",
    "Last Name": "Shichijo",
    "First Name": "Miki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864936": {
    "id": "item_2580",
    "Last Name": "Basto Moreno",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864963": {
    "id": "item_28021",
    "Last Name": "Catlin",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865044": {
    "id": "item_17034",
    "Last Name": "Herbst",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865065": {
    "id": "item_17033",
    "Last Name": "Morris",
    "First Name": "Jock",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865067": {
    "id": "item_2579",
    "Last Name": "Carr",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865076": {
    "id": "item_17032",
    "Last Name": "Ardila Forero",
    "First Name": "Paola Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865116": {
    "id": "item_17031",
    "Last Name": "Fyfe",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865130": {
    "id": "item_13091",
    "Last Name": "Aliaga",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865135": {
    "id": "item_30009",
    "Last Name": "Fajar",
    "First Name": "Septian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865138": {
    "id": "item_17030",
    "Last Name": "Baddeley",
    "First Name": "MacIntyre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865256": {
    "id": "item_17026",
    "Last Name": "Machicao",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865297": {
    "id": "item_637",
    "Last Name": "PIFFOUX",
    "First Name": "ARTHUR",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865300": {
    "id": "item_2576",
    "Last Name": "Horan",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865344": {
    "id": "item_4932",
    "Last Name": "Eby",
    "First Name": "Afrael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865362": {
    "id": "item_15957",
    "Last Name": "Pairat",
    "First Name": "Kiattisak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865560": {
    "id": "item_28016",
    "Last Name": "LEE",
    "First Name": "PEI HAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865724": {
    "id": "item_30005",
    "Last Name": "Hasslacher",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865792": {
    "id": "item_4926",
    "Last Name": "Reuben",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865893": {
    "id": "item_15956",
    "Last Name": "Yap",
    "First Name": "Yoke Moi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865897": {
    "id": "item_634",
    "Last Name": "Patel",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866024": {
    "id": "item_2571",
    "Last Name": "Valdivia",
    "First Name": "Giovanna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866078": {
    "id": "item_3233",
    "Last Name": "Gomez",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866194": {
    "id": "item_4924",
    "Last Name": "Kim",
    "First Name": "Jusam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866274": {
    "id": "item_17015",
    "Last Name": "Gibzalez",
    "First Name": "Mariangela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866286": {
    "id": "item_17014",
    "Last Name": "Robinson",
    "First Name": "Manon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866324": {
    "id": "item_2569",
    "Last Name": "HO",
    "First Name": "CHUN HANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866474": {
    "id": "item_17010",
    "Last Name": "TSAO",
    "First Name": "YI-TING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866693": {
    "id": "item_26455",
    "Last Name": "LI",
    "First Name": "YING CHIEH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866739": {
    "id": "item_28009",
    "Last Name": "Kim",
    "First Name": "Seohyun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866872": {
    "id": "item_17005",
    "Last Name": "KIM",
    "First Name": "KYUNGMIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867102": {
    "id": "item_2567",
    "Last Name": "Vadhirajan",
    "First Name": "Pranesh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867130": {
    "id": "item_14006",
    "Last Name": "Tarter",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867202": {
    "id": "item_29997",
    "Last Name": "Piercy",
    "First Name": "Melita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867380": {
    "id": "item_2565",
    "Last Name": "XU",
    "First Name": "ZHENGFENG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867447": {
    "id": "item_15954",
    "Last Name": "Lin",
    "First Name": "Hang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867722": {
    "id": "item_29994",
    "Last Name": "Jones",
    "First Name": "Anna Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867845": {
    "id": "item_17001",
    "Last Name": "Tan",
    "First Name": "Jayson King Pajarillo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867852": {
    "id": "item_29992",
    "Last Name": "Marpaung",
    "First Name": "Daswar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37868008": {
    "id": "item_2560",
    "Last Name": "WANG",
    "First Name": "CHENG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37868441": {
    "id": "item_13086",
    "Last Name": "Westhoven",
    "First Name": "Katlyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37869192": {
    "id": "item_623",
    "Last Name": "Lopez Amigo",
    "First Name": "Eduard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37869356": {
    "id": "item_28000",
    "Last Name": "Duda",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37869686": {
    "id": "item_622",
    "Last Name": "Abraham",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37869796": {
    "id": "item_4917",
    "Last Name": "Gibson",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37869926": {
    "id": "item_16995",
    "Last Name": "Bertoli",
    "First Name": "Beau",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870134": {
    "id": "item_16994",
    "Last Name": "Hynoski",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870245": {
    "id": "item_29984",
    "Last Name": "Li",
    "First Name": "zhizheng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870446": {
    "id": "item_29983",
    "Last Name": "Shetty",
    "First Name": "Anudeex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870848": {
    "id": "item_16987",
    "Last Name": "Queja",
    "First Name": "Eizer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870857": {
    "id": "item_29980",
    "Last Name": "Orton",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870887": {
    "id": "item_619",
    "Last Name": "Grabkowski",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870901": {
    "id": "item_16985",
    "Last Name": "Kibblewhite",
    "First Name": "Felix",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871236": {
    "id": "item_617",
    "Last Name": "Soars",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871358": {
    "id": "item_616",
    "Last Name": "Dilonardo",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871401": {
    "id": "item_16981",
    "Last Name": "Collie",
    "First Name": "Grant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871604": {
    "id": "item_29974",
    "Last Name": "Rogers",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871690": {
    "id": "item_26454",
    "Last Name": "Wang",
    "First Name": "Xizhen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871777": {
    "id": "item_29973",
    "Last Name": "McDonall",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871950": {
    "id": "item_16975",
    "Last Name": "Van Den Brink",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872136": {
    "id": "item_29972",
    "Last Name": "Keen",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872186": {
    "id": "item_16974",
    "Last Name": "Laurie",
    "First Name": "Stu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872325": {
    "id": "item_16971",
    "Last Name": "Inalves",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872403": {
    "id": "item_2547",
    "Last Name": "Eda",
    "First Name": "Masaichi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872419": {
    "id": "item_2548",
    "Last Name": "Fokina",
    "First Name": "Anastasiia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872593": {
    "id": "item_29969",
    "Last Name": "Fyles",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872602": {
    "id": "item_613",
    "Last Name": "phillips",
    "First Name": "polly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872675": {
    "id": "item_16967",
    "Last Name": "Mitchell",
    "First Name": "Lizzie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872692": {
    "id": "item_29968",
    "Last Name": "Walters",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872773": {
    "id": "item_610",
    "Last Name": "Leerson",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872798": {
    "id": "item_29966",
    "Last Name": "Douglas",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872800": {
    "id": "item_29965",
    "Last Name": "Wills",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872894": {
    "id": "item_16965",
    "Last Name": "Bevan",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872903": {
    "id": "item_2544",
    "Last Name": "Keegan",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872921": {
    "id": "item_16964",
    "Last Name": "Ludick",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872941": {
    "id": "item_2543",
    "Last Name": "Cain",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873068": {
    "id": "item_4892",
    "Last Name": "Webb",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873233": {
    "id": "item_16961",
    "Last Name": "Mason",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873291": {
    "id": "item_4890",
    "Last Name": "Horan",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873313": {
    "id": "item_16958",
    "Last Name": "Baxter",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873322": {
    "id": "item_16955",
    "Last Name": "Knight",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873325": {
    "id": "item_3232",
    "Last Name": "Wright",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873430": {
    "id": "item_13077",
    "Last Name": "Ak Seliong",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873560": {
    "id": "item_2540",
    "Last Name": "Nicotra",
    "First Name": "Antonino",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873601": {
    "id": "item_4882",
    "Last Name": "Hillary",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873861": {
    "id": "item_13076",
    "Last Name": "Bernstein",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873870": {
    "id": "item_607",
    "Last Name": "Wilson",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873979": {
    "id": "item_27984",
    "Last Name": "Macancela",
    "First Name": "Gloria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874014": {
    "id": "item_16944",
    "Last Name": "Reid",
    "First Name": "Lochlan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874123": {
    "id": "item_4880",
    "Last Name": "Tu",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874152": {
    "id": "item_15946",
    "Last Name": "Zuo",
    "First Name": "Hongfei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874226": {
    "id": "item_16943",
    "Last Name": "Wang",
    "First Name": "QiaoRan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874300": {
    "id": "item_2538",
    "Last Name": "Garland",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874383": {
    "id": "item_29957",
    "Last Name": "Beaton",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874413": {
    "id": "item_16939",
    "Last Name": "Perkins",
    "First Name": "Eloise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874419": {
    "id": "item_4876",
    "Last Name": "Fataah",
    "First Name": "Mohamed-Amin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874497": {
    "id": "item_16935",
    "Last Name": "Davis",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874739": {
    "id": "item_604",
    "Last Name": "Kettle",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874984": {
    "id": "item_29955",
    "Last Name": "Korrapati",
    "First Name": "Mohan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875137": {
    "id": "item_4874",
    "Last Name": "Tang",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875167": {
    "id": "item_27982",
    "Last Name": "Petrov",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875257": {
    "id": "item_16928",
    "Last Name": "Fitzgerald",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875290": {
    "id": "item_16927",
    "Last Name": "Chow",
    "First Name": "Wallace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875355": {
    "id": "item_16926",
    "Last Name": "Zhang",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875690": {
    "id": "item_16924",
    "Last Name": "Min",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875834": {
    "id": "item_29950",
    "Last Name": "Lowe",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876037": {
    "id": "item_27980",
    "Last Name": "Klaben",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876235": {
    "id": "item_599",
    "Last Name": "Baart",
    "First Name": "Kyal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876315": {
    "id": "item_16917",
    "Last Name": "Lew",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876336": {
    "id": "item_16916",
    "Last Name": "Hamilton",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876605": {
    "id": "item_2533",
    "Last Name": "CAUSERO",
    "First Name": "KELLY",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876697": {
    "id": "item_14005",
    "Last Name": "Worthy",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876737": {
    "id": "item_29948",
    "Last Name": "McMahon",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876837": {
    "id": "item_16911",
    "Last Name": "Kennedy",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877041": {
    "id": "item_16910",
    "Last Name": "Patwary",
    "First Name": "Noore",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877119": {
    "id": "item_16909",
    "Last Name": "Fortune",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877235": {
    "id": "item_29945",
    "Last Name": "Gorman",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877245": {
    "id": "item_4867",
    "Last Name": "Hehir",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877297": {
    "id": "item_2532",
    "Last Name": "dr. Bogn‡r",
    "First Name": "Csaba",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877385": {
    "id": "item_16908",
    "Last Name": "Quick",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877667": {
    "id": "item_29942",
    "Last Name": "Gamis",
    "First Name": "Jerrico",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877732": {
    "id": "item_16905",
    "Last Name": "Allen",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877777": {
    "id": "item_4863",
    "Last Name": "Williams",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878097": {
    "id": "item_16900",
    "Last Name": "Teare",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878154": {
    "id": "item_16899",
    "Last Name": "Parkinson",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878240": {
    "id": "item_13970",
    "Last Name": "Oh",
    "First Name": "Moonseok",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878273": {
    "id": "item_16897",
    "Last Name": "Skinner",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878536": {
    "id": "item_2529",
    "Last Name": "McLaren",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878610": {
    "id": "item_4861",
    "Last Name": "Brankaer",
    "First Name": "Jan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878781": {
    "id": "item_4859",
    "Last Name": "Groves",
    "First Name": "Darryl",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878826": {
    "id": "item_2528",
    "Last Name": "Black",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878844": {
    "id": "item_4857",
    "Last Name": "Swanton",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879150": {
    "id": "item_4851",
    "Last Name": "McCann",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879170": {
    "id": "item_29933",
    "Last Name": "Luo",
    "First Name": "Ying",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879180": {
    "id": "item_16891",
    "Last Name": "Jollye",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879206": {
    "id": "item_16886",
    "Last Name": "Jayakumar",
    "First Name": "Nagendra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879215": {
    "id": "item_2526",
    "Last Name": "Chan",
    "First Name": "Hok Tin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879244": {
    "id": "item_4850",
    "Last Name": "Watts",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879343": {
    "id": "item_13068",
    "Last Name": "Villanueva",
    "First Name": "Meshelle Araceli",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879359": {
    "id": "item_16884",
    "Last Name": "Kim",
    "First Name": "Sophi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879406": {
    "id": "item_16883",
    "Last Name": "Limansyah",
    "First Name": "Rhesa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879472": {
    "id": "item_29931",
    "Last Name": "Maratas",
    "First Name": "June",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879490": {
    "id": "item_27967",
    "Last Name": "Pinner",
    "First Name": "Isis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879567": {
    "id": "item_16880",
    "Last Name": "Lever",
    "First Name": "Jeffery",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879787": {
    "id": "item_16877",
    "Last Name": "Roche",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879875": {
    "id": "item_27964",
    "Last Name": "Quilty",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879886": {
    "id": "item_27963",
    "Last Name": "Loke",
    "First Name": "Hon Wah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879986": {
    "id": "item_29924",
    "Last Name": "Liou",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880020": {
    "id": "item_26453",
    "Last Name": "YOKE FUN",
    "First Name": "FOONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880112": {
    "id": "item_16872",
    "Last Name": "Li",
    "First Name": "Keri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880120": {
    "id": "item_29921",
    "Last Name": "DiBiasio",
    "First Name": "Ariana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880139": {
    "id": "item_16871",
    "Last Name": "Francis",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880154": {
    "id": "item_16869",
    "Last Name": "Trinh",
    "First Name": "Linh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880244": {
    "id": "item_4845",
    "Last Name": "Thomadakis",
    "First Name": "Stratos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880327": {
    "id": "item_4844",
    "Last Name": "Luna",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880362": {
    "id": "item_27960",
    "Last Name": "Clarke",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880376": {
    "id": "item_27959",
    "Last Name": "Puente Rojas",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880412": {
    "id": "item_29919",
    "Last Name": "Ferrier",
    "First Name": "Elliot",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880423": {
    "id": "item_29918",
    "Last Name": "Man",
    "First Name": "Melody",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880719": {
    "id": "item_588",
    "Last Name": "Sharrad",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880724": {
    "id": "item_13066",
    "Last Name": "Pequeno",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880725": {
    "id": "item_16860",
    "Last Name": "Gladigau",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880726": {
    "id": "item_16857",
    "Last Name": "Van Bergen",
    "First Name": "Penny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880750": {
    "id": "item_29912",
    "Last Name": "Koh",
    "First Name": "Ji",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880772": {
    "id": "item_4838",
    "Last Name": "Webb",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880783": {
    "id": "item_4837",
    "Last Name": "Mcglynn",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880815": {
    "id": "item_16850",
    "Last Name": "Yegorova-Lee",
    "First Name": "Sonya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880953": {
    "id": "item_29911",
    "Last Name": "Casey",
    "First Name": "Maggie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881256": {
    "id": "item_586",
    "Last Name": "Patel",
    "First Name": "Nishith",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881260": {
    "id": "item_27956",
    "Last Name": "Nelson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881283": {
    "id": "item_16844",
    "Last Name": "Suyanto",
    "First Name": "Budi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881371": {
    "id": "item_29908",
    "Last Name": "Suomi",
    "First Name": "Aino",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881405": {
    "id": "item_4829",
    "Last Name": "Thame",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881417": {
    "id": "item_29907",
    "Last Name": "Shyne",
    "First Name": "Bernard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881442": {
    "id": "item_16840",
    "Last Name": "Hilder",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881515": {
    "id": "item_2515",
    "Last Name": "Dell",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881572": {
    "id": "item_27954",
    "Last Name": "zollo",
    "First Name": "adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881610": {
    "id": "item_27953",
    "Last Name": "Smith",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881626": {
    "id": "item_29904",
    "Last Name": "Park",
    "First Name": "I Myoung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881666": {
    "id": "item_582",
    "Last Name": "Pira",
    "First Name": "Lorenzo Angelo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881731": {
    "id": "item_2514",
    "Last Name": "Cai",
    "First Name": "Zebang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881799": {
    "id": "item_2513",
    "Last Name": "Blanchfield",
    "First Name": "Niall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881800": {
    "id": "item_580",
    "Last Name": "Dahlstrom",
    "First Name": "Marty",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881911": {
    "id": "item_16826",
    "Last Name": "Scorgie",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881961": {
    "id": "item_16823",
    "Last Name": "WANG",
    "First Name": "BAOSEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881998": {
    "id": "item_4820",
    "Last Name": "Flanagan",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882001": {
    "id": "item_16820",
    "Last Name": "Coimbra Zica",
    "First Name": "Guilherme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882217": {
    "id": "item_16817",
    "Last Name": "Salsabila",
    "First Name": "Anaquita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882233": {
    "id": "item_15936",
    "Last Name": "Taranto",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882262": {
    "id": "item_577",
    "Last Name": "Furio",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882304": {
    "id": "item_3231",
    "Last Name": "Thomas",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882332": {
    "id": "item_2512",
    "Last Name": "Foley",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882370": {
    "id": "item_4813",
    "Last Name": "Jong",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882412": {
    "id": "item_29897",
    "Last Name": "Yang",
    "First Name": "Hsin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882440": {
    "id": "item_4810",
    "Last Name": "Courtney",
    "First Name": "Anth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882464": {
    "id": "item_27948",
    "Last Name": "Padilla",
    "First Name": "Gem",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882481": {
    "id": "item_27947",
    "Last Name": "gurung",
    "First Name": "deepak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882486": {
    "id": "item_16808",
    "Last Name": "Wardleworth",
    "First Name": "Lillian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882516": {
    "id": "item_13060",
    "Last Name": "Raveendran",
    "First Name": "Myron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882532": {
    "id": "item_29896",
    "Last Name": "Cheung",
    "First Name": "Wing Ka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882606": {
    "id": "item_15934",
    "Last Name": "Chaves",
    "First Name": "Susano Tiburcio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882609": {
    "id": "item_27943",
    "Last Name": "Wong",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882646": {
    "id": "item_16804",
    "Last Name": "Seow",
    "First Name": "Derek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882708": {
    "id": "item_15933",
    "Last Name": "Elango",
    "First Name": "Bathusan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882715": {
    "id": "item_4803",
    "Last Name": "Hagon",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882722": {
    "id": "item_27940",
    "Last Name": "huang",
    "First Name": "xing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882734": {
    "id": "item_27942",
    "Last Name": "Bista",
    "First Name": "Reman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882737": {
    "id": "item_29891",
    "Last Name": "Kelly",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882764": {
    "id": "item_13058",
    "Last Name": "Baird",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882768": {
    "id": "item_13057",
    "Last Name": "KWAN",
    "First Name": "MAN TING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882787": {
    "id": "item_2507",
    "Last Name": "Huberts",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882835": {
    "id": "item_4795",
    "Last Name": "Rowland",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882869": {
    "id": "item_29886",
    "Last Name": "Maeda",
    "First Name": "Shiori",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882877": {
    "id": "item_27935",
    "Last Name": "Onchan",
    "First Name": "Jaruwan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882926": {
    "id": "item_27934",
    "Last Name": "Phaungmaiming",
    "First Name": "Waiphot",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882933": {
    "id": "item_29885",
    "Last Name": "BINTE RAHMAT",
    "First Name": "AZRINDA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882940": {
    "id": "item_29884",
    "Last Name": "Duval",
    "First Name": "Natacha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882978": {
    "id": "item_15932",
    "Last Name": "Prendergast",
    "First Name": "Sharn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883036": {
    "id": "item_4791",
    "Last Name": "Holtham",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883058": {
    "id": "item_566",
    "Last Name": "Fan",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883076": {
    "id": "item_2502",
    "Last Name": "Frost",
    "First Name": "Sheldon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883129": {
    "id": "item_4790",
    "Last Name": "Pradel",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883138": {
    "id": "item_16794",
    "Last Name": "Graham",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883176": {
    "id": "item_29882",
    "Last Name": "Karevska",
    "First Name": "Simona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883205": {
    "id": "item_4788",
    "Last Name": "Brouff",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883209": {
    "id": "item_4786",
    "Last Name": "Ables",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883269": {
    "id": "item_565",
    "Last Name": "Wildes",
    "First Name": "Kate",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883278": {
    "id": "item_27929",
    "Last Name": "Christen",
    "First Name": "Veronika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883298": {
    "id": "item_4783",
    "Last Name": "Sanders",
    "First Name": "Ollie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883299": {
    "id": "item_29881",
    "Last Name": "Tiller",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883311": {
    "id": "item_16786",
    "Last Name": "Marks",
    "First Name": "Carmel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883313": {
    "id": "item_29880",
    "Last Name": "Anderson",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883343": {
    "id": "item_16785",
    "Last Name": "Hill-Smith",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883344": {
    "id": "item_29876",
    "Last Name": "McGurty",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883360": {
    "id": "item_29874",
    "Last Name": "Bugler",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883369": {
    "id": "item_16782",
    "Last Name": "Hyde",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883379": {
    "id": "item_15927",
    "Last Name": "Antolin",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883438": {
    "id": "item_557",
    "Last Name": "Woodward",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883444": {
    "id": "item_16779",
    "Last Name": "Ferris",
    "First Name": "Felix",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883455": {
    "id": "item_4778",
    "Last Name": "Pleming",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883475": {
    "id": "item_16778",
    "Last Name": "Park",
    "First Name": "Sunhan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883513": {
    "id": "item_16775",
    "Last Name": "Lopes Morato",
    "First Name": "Rui",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883535": {
    "id": "item_16774",
    "Last Name": "Pandey",
    "First Name": "Rajib",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883542": {
    "id": "item_27926",
    "Last Name": "Kowaki",
    "First Name": "Yukako",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883599": {
    "id": "item_554",
    "Last Name": "Sexton",
    "First Name": "Micarla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883683": {
    "id": "item_16771",
    "Last Name": "Grove",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883759": {
    "id": "item_16768",
    "Last Name": "Brooks",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883767": {
    "id": "item_15923",
    "Last Name": "Lee",
    "First Name": "Graham",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883775": {
    "id": "item_550",
    "Last Name": "Korolkov",
    "First Name": "Dmitrii",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883820": {
    "id": "item_29870",
    "Last Name": "Munoz Defilippi",
    "First Name": "Andres",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883859": {
    "id": "item_4769",
    "Last Name": "Calvet",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883904": {
    "id": "item_29869",
    "Last Name": "Ong",
    "First Name": "Rui Ti",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883930": {
    "id": "item_15921",
    "Last Name": "CLEARY",
    "First Name": "LISA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883931": {
    "id": "item_4765",
    "Last Name": "Hounsell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883949": {
    "id": "item_16759",
    "Last Name": "Mitchell",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883955": {
    "id": "item_4767",
    "Last Name": "Sinclair",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883983": {
    "id": "item_27920",
    "Last Name": "Jares",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883996": {
    "id": "item_29867",
    "Last Name": "Kenny",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884032": {
    "id": "item_16756",
    "Last Name": "Knowles",
    "First Name": "Broderick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884035": {
    "id": "item_16754",
    "Last Name": "Lonchampt",
    "First Name": "Elina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884088": {
    "id": "item_29864",
    "Last Name": "Joseph",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884125": {
    "id": "item_4758",
    "Last Name": "Foster",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884136": {
    "id": "item_29863",
    "Last Name": "Kaura",
    "First Name": "Pratibha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884157": {
    "id": "item_16752",
    "Last Name": "Pek",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884243": {
    "id": "item_29860",
    "Last Name": "Peng",
    "First Name": "Michelle Gia yuen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884261": {
    "id": "item_27918",
    "Last Name": "Wu",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884263": {
    "id": "item_16748",
    "Last Name": "Ward",
    "First Name": "Becky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884273": {
    "id": "item_16743",
    "Last Name": "Ferreira",
    "First Name": "Hector",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884274": {
    "id": "item_29858",
    "Last Name": "Basir",
    "First Name": "Salehin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884293": {
    "id": "item_16744",
    "Last Name": "Martin",
    "First Name": "Bernice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884316": {
    "id": "item_29856",
    "Last Name": "Bouhmad",
    "First Name": "Kamel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884407": {
    "id": "item_16740",
    "Last Name": "Eckersley",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884411": {
    "id": "item_29855",
    "Last Name": "Yung",
    "First Name": "Canaan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884420": {
    "id": "item_2482",
    "Last Name": "Peel",
    "First Name": "Brent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884429": {
    "id": "item_2481",
    "Last Name": "Takagi",
    "First Name": "Masateru",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38143348": {
    "id": "item_27913",
    "Last Name": "Lees",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38209822": {
    "id": "item_26208",
    "Last Name": "Ly",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38209881": {
    "id": "item_30891",
    "Last Name": "Chong",
    "First Name": "Yen Kurr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38210531": {
    "id": "item_13862",
    "Last Name": "Coleman",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211297": {
    "id": "item_30892",
    "Last Name": "Wong",
    "First Name": "Linus Wei Lun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211299": {
    "id": "item_1299",
    "Last Name": "Javier",
    "First Name": "Mariel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211597": {
    "id": "item_3154",
    "Last Name": "Ewart",
    "First Name": "Imogen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211600": {
    "id": "item_28710",
    "Last Name": "Virgo",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211603": {
    "id": "item_28709",
    "Last Name": "seed",
    "First Name": "niall",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211611": {
    "id": "item_13863",
    "Last Name": "Sawney",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211618": {
    "id": "item_28712",
    "Last Name": "Roberts",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211637": {
    "id": "item_26209",
    "Last Name": "budgen",
    "First Name": "andy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211659": {
    "id": "item_1301",
    "Last Name": "Johnston",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211661": {
    "id": "item_13877",
    "Last Name": "Damery",
    "First Name": "Orlaith",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211662": {
    "id": "item_13869",
    "Last Name": "Nguyen",
    "First Name": "Thanh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211664": {
    "id": "item_13865",
    "Last Name": "Onoon",
    "First Name": "Val Irvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211677": {
    "id": "item_26210",
    "Last Name": "Cordova",
    "First Name": "Angelo Sam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211678": {
    "id": "item_26211",
    "Last Name": "Kerr",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211686": {
    "id": "item_30895",
    "Last Name": "Panchal",
    "First Name": "Hemanshu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211698": {
    "id": "item_13866",
    "Last Name": "Henshall",
    "First Name": "Bryony",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211699": {
    "id": "item_13868",
    "Last Name": "Garcia Leal",
    "First Name": "Mateo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211703": {
    "id": "item_13864",
    "Last Name": "Hawkins",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211705": {
    "id": "item_13872",
    "Last Name": "Vo",
    "First Name": "Sang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211708": {
    "id": "item_1300",
    "Last Name": "Flint",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211712": {
    "id": "item_30894",
    "Last Name": "McBain",
    "First Name": "Ryleigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211714": {
    "id": "item_30893",
    "Last Name": "Hayes",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211720": {
    "id": "item_1302",
    "Last Name": "Standish",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211730": {
    "id": "item_13873",
    "Last Name": "Teja",
    "First Name": "Grant",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211731": {
    "id": "item_13867",
    "Last Name": "Ashworth",
    "First Name": "Meg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211740": {
    "id": "item_3157",
    "Last Name": "Cho",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211746": {
    "id": "item_26218",
    "Last Name": "Mendez",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211751": {
    "id": "item_26225",
    "Last Name": "Arnold",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211753": {
    "id": "item_13870",
    "Last Name": "Cuya",
    "First Name": "Digna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211756": {
    "id": "item_26215",
    "Last Name": "Gomez Nino",
    "First Name": "Diana Carolina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211763": {
    "id": "item_3155",
    "Last Name": "Achterhof",
    "First Name": "Iris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211764": {
    "id": "item_16260",
    "Last Name": "Aitken",
    "First Name": "Tahnee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211768": {
    "id": "item_26216",
    "Last Name": "Goodes",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211769": {
    "id": "item_30904",
    "Last Name": "Buckley",
    "First Name": "Zara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211775": {
    "id": "item_26214",
    "Last Name": "Dzeladini",
    "First Name": "Fezulla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211777": {
    "id": "item_26220",
    "Last Name": "Maniago",
    "First Name": "Ezekiel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211784": {
    "id": "item_26212",
    "Last Name": "McNamara",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211795": {
    "id": "item_26213",
    "Last Name": "Nguyen",
    "First Name": "Hai Ha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211812": {
    "id": "item_26224",
    "Last Name": "van der Linde",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211814": {
    "id": "item_13871",
    "Last Name": "Redoblado",
    "First Name": "Godofredo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211816": {
    "id": "item_28711",
    "Last Name": "Hutchinson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211821": {
    "id": "item_1303",
    "Last Name": "Fazal",
    "First Name": "Imran",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211826": {
    "id": "item_30898",
    "Last Name": "Lee",
    "First Name": "Ree Rang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211828": {
    "id": "item_30896",
    "Last Name": "Gambrill",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211831": {
    "id": "item_1306",
    "Last Name": "Lavin",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211833": {
    "id": "item_28717",
    "Last Name": "Dithachot",
    "First Name": "Sorasart",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211835": {
    "id": "item_16259",
    "Last Name": "Kennedy",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211836": {
    "id": "item_26223",
    "Last Name": "Margerison",
    "First Name": "Rick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211838": {
    "id": "item_26219",
    "Last Name": "Pilmore",
    "First Name": "Lindi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211840": {
    "id": "item_28714",
    "Last Name": "Astier",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211846": {
    "id": "item_26217",
    "Last Name": "Graney",
    "First Name": "Nick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211847": {
    "id": "item_1305",
    "Last Name": "Marinelli",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211857": {
    "id": "item_30902",
    "Last Name": "Lim",
    "First Name": "Joe Jean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211861": {
    "id": "item_30900",
    "Last Name": "Nguyen",
    "First Name": "Leo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211863": {
    "id": "item_28713",
    "Last Name": "Kitson",
    "First Name": "Valerie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211866": {
    "id": "item_1304",
    "Last Name": "Hurley",
    "First Name": "Tara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211867": {
    "id": "item_26228",
    "Last Name": "Diamante",
    "First Name": "Karlo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211869": {
    "id": "item_26221",
    "Last Name": "Koerner",
    "First Name": "Marni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211870": {
    "id": "item_26226",
    "Last Name": "Croke",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211875": {
    "id": "item_30897",
    "Last Name": "Chapman",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211880": {
    "id": "item_26222",
    "Last Name": "Trickey",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211881": {
    "id": "item_30899",
    "Last Name": "Hunter",
    "First Name": "Adele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211893": {
    "id": "item_30901",
    "Last Name": "CHA",
    "First Name": "HAOTIAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211903": {
    "id": "item_30905",
    "Last Name": "Guzman",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211910": {
    "id": "item_13876",
    "Last Name": "Winkel",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211911": {
    "id": "item_28715",
    "Last Name": "Meng",
    "First Name": "Jialu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211912": {
    "id": "item_26227",
    "Last Name": "MACEDO",
    "First Name": "AYRA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211913": {
    "id": "item_30903",
    "Last Name": "Manahan",
    "First Name": "Amie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211914": {
    "id": "item_28719",
    "Last Name": "zhang",
    "First Name": "honglin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211915": {
    "id": "item_30915",
    "Last Name": "Crust",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211919": {
    "id": "item_1308",
    "Last Name": "Sia",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211924": {
    "id": "item_16263",
    "Last Name": "Medina Cejudo",
    "First Name": "Diana Guadalupe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211929": {
    "id": "item_13874",
    "Last Name": "Mahoney",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211931": {
    "id": "item_1307",
    "Last Name": "Tran",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211938": {
    "id": "item_30907",
    "Last Name": "Samiano",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211950": {
    "id": "item_28716",
    "Last Name": "Darlene",
    "First Name": "Danica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211959": {
    "id": "item_30908",
    "Last Name": "Robertson",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211962": {
    "id": "item_3156",
    "Last Name": "Gorrie",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211963": {
    "id": "item_13875",
    "Last Name": "Mata",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211968": {
    "id": "item_16262",
    "Last Name": "Khoo",
    "First Name": "Weijian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211972": {
    "id": "item_16261",
    "Last Name": "Clinton-Hayward",
    "First Name": "Lola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211975": {
    "id": "item_30906",
    "Last Name": "Khan",
    "First Name": "Faisal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211981": {
    "id": "item_30909",
    "Last Name": "Kazi",
    "First Name": "Aubanty Nafisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211990": {
    "id": "item_30910",
    "Last Name": "Bin Talib",
    "First Name": "Muhammad Hakim Bin Mohsin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211996": {
    "id": "item_28718",
    "Last Name": "Ferguson",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212004": {
    "id": "item_3158",
    "Last Name": "MAN YIU",
    "First Name": "LEE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212010": {
    "id": "item_30911",
    "Last Name": "Pereira",
    "First Name": "Sherman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212016": {
    "id": "item_26231",
    "Last Name": "Wang",
    "First Name": "Shanshan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212019": {
    "id": "item_28720",
    "Last Name": "Phan",
    "First Name": "Huu Cho",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212035": {
    "id": "item_30913",
    "Last Name": "Abogado",
    "First Name": "Janey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212036": {
    "id": "item_13878",
    "Last Name": "Reyes",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212041": {
    "id": "item_26230",
    "Last Name": "Wong",
    "First Name": "Janice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212044": {
    "id": "item_26229",
    "Last Name": "Bratton",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212049": {
    "id": "item_13879",
    "Last Name": "WANG",
    "First Name": "KAIBU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212055": {
    "id": "item_28722",
    "Last Name": "preez",
    "First Name": "Rick Du",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212058": {
    "id": "item_30914",
    "Last Name": "Davison",
    "First Name": "Eloise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212065": {
    "id": "item_13880",
    "Last Name": "Fern‡ndez",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212073": {
    "id": "item_30912",
    "Last Name": "Parnell",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212077": {
    "id": "item_26233",
    "Last Name": "Cheong",
    "First Name": "Shon Lin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212082": {
    "id": "item_26238",
    "Last Name": "McLean",
    "First Name": "Aria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212086": {
    "id": "item_28721",
    "Last Name": "Mendoza",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212089": {
    "id": "item_13882",
    "Last Name": "Williams",
    "First Name": "Owen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212093": {
    "id": "item_16264",
    "Last Name": "liu",
    "First Name": "yiao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212099": {
    "id": "item_26232",
    "Last Name": "Bennett-Woodger",
    "First Name": "Katya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212105": {
    "id": "item_13881",
    "Last Name": "Gorman",
    "First Name": "Cian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212108": {
    "id": "item_26234",
    "Last Name": "Ardiansyah",
    "First Name": "Ikhsan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212120": {
    "id": "item_3159",
    "Last Name": "McCormack",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212132": {
    "id": "item_30917",
    "Last Name": "Jones",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212138": {
    "id": "item_26235",
    "Last Name": "BASTIDAS",
    "First Name": "IVETTE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212140": {
    "id": "item_26236",
    "Last Name": "McPhee",
    "First Name": "Sian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212146": {
    "id": "item_3160",
    "Last Name": "Kang",
    "First Name": "Jarrett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212147": {
    "id": "item_28724",
    "Last Name": "Scott",
    "First Name": "Alannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212150": {
    "id": "item_1311",
    "Last Name": "Gamboa",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212154": {
    "id": "item_13884",
    "Last Name": "Blucher",
    "First Name": "Guy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212160": {
    "id": "item_30916",
    "Last Name": "Kulchak",
    "First Name": "Anastasiia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212168": {
    "id": "item_1309",
    "Last Name": "Branzuela",
    "First Name": "Gabe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212176": {
    "id": "item_30918",
    "Last Name": "Graham",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212185": {
    "id": "item_28726",
    "Last Name": "Piper-Green",
    "First Name": "Toni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212186": {
    "id": "item_16265",
    "Last Name": "Tonkin",
    "First Name": "Willow",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212190": {
    "id": "item_13883",
    "Last Name": "Van",
    "First Name": "Dinh Anh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212191": {
    "id": "item_3161",
    "Last Name": "Mabbs",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212193": {
    "id": "item_5745",
    "Last Name": "Symons",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212198": {
    "id": "item_26237",
    "Last Name": "Woodward",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212204": {
    "id": "item_30919",
    "Last Name": "Hipwell",
    "First Name": "Belle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212214": {
    "id": "item_28723",
    "Last Name": "TRAC",
    "First Name": "WILLIAM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212216": {
    "id": "item_28727",
    "Last Name": "Parra Lopez",
    "First Name": "Cristian David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212220": {
    "id": "item_28725",
    "Last Name": "Coffield",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212221": {
    "id": "item_3162",
    "Last Name": "Hammond",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212236": {
    "id": "item_1310",
    "Last Name": "Reyburn",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212237": {
    "id": "item_30921",
    "Last Name": "ABRAO JANA",
    "First Name": "TATIANA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212240": {
    "id": "item_26242",
    "Last Name": "CHIU",
    "First Name": "YIFU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212241": {
    "id": "item_26241",
    "Last Name": "Thohari",
    "First Name": "Khamim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212249": {
    "id": "item_30920",
    "Last Name": "Heller-Wagner",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212256": {
    "id": "item_26239",
    "Last Name": "Kitching",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212264": {
    "id": "item_26243",
    "Last Name": "Panettiere",
    "First Name": "Mario",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212286": {
    "id": "item_26240",
    "Last Name": "Tan",
    "First Name": "Pauline Myra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212290": {
    "id": "item_26248",
    "Last Name": "Williams",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212317": {
    "id": "item_3163",
    "Last Name": "Cranney",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212341": {
    "id": "item_13885",
    "Last Name": "Hinson",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212355": {
    "id": "item_30922",
    "Last Name": "obrero",
    "First Name": "seann",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212371": {
    "id": "item_26244",
    "Last Name": "Frean",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212400": {
    "id": "item_30923",
    "Last Name": "Renwick",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212407": {
    "id": "item_13886",
    "Last Name": "Kenny",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212414": {
    "id": "item_1312",
    "Last Name": "Walker",
    "First Name": "Caedan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212418": {
    "id": "item_13889",
    "Last Name": "Gill",
    "First Name": "Lucie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212424": {
    "id": "item_26245",
    "Last Name": "O'Leary",
    "First Name": "Jenson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212429": {
    "id": "item_1313",
    "Last Name": "TOTHILL",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212438": {
    "id": "item_26246",
    "Last Name": "Odria",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212444": {
    "id": "item_30924",
    "Last Name": "Padilla",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212455": {
    "id": "item_26253",
    "Last Name": "Johnston",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212462": {
    "id": "item_26247",
    "Last Name": "Wilson",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212469": {
    "id": "item_3164",
    "Last Name": "Fortune",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212472": {
    "id": "item_28729",
    "Last Name": "Saputra",
    "First Name": "Mohammad Bayu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212476": {
    "id": "item_28728",
    "Last Name": "O'Kane",
    "First Name": "Annie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212507": {
    "id": "item_13891",
    "Last Name": "Moon",
    "First Name": "Jaewon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212519": {
    "id": "item_3165",
    "Last Name": "Adler",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212520": {
    "id": "item_26249",
    "Last Name": "Holmes",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212528": {
    "id": "item_28730",
    "Last Name": "Robson",
    "First Name": "Apannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212535": {
    "id": "item_26250",
    "Last Name": "Rossouw",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212540": {
    "id": "item_28733",
    "Last Name": "Henery",
    "First Name": "Blair",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212541": {
    "id": "item_26252",
    "Last Name": "Sykes",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212551": {
    "id": "item_26251",
    "Last Name": "Ho",
    "First Name": "Man Lim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212558": {
    "id": "item_13887",
    "Last Name": "Quach",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212560": {
    "id": "item_28731",
    "Last Name": "Hyde",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212578": {
    "id": "item_28732",
    "Last Name": "Ricketts",
    "First Name": "Veronica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212598": {
    "id": "item_16267",
    "Last Name": "PRATAMA",
    "First Name": "IVAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212601": {
    "id": "item_13888",
    "Last Name": "La Bouchardiere",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212602": {
    "id": "item_16266",
    "Last Name": "Willsher",
    "First Name": "Maddy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212603": {
    "id": "item_3166",
    "Last Name": "Fullwood",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212604": {
    "id": "item_30925",
    "Last Name": "Tuballa",
    "First Name": "Alana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212607": {
    "id": "item_26254",
    "Last Name": "Rizky",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212616": {
    "id": "item_13890",
    "Last Name": "Kim",
    "First Name": "Ha Yeong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212619": {
    "id": "item_1314",
    "Last Name": "Martini",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212625": {
    "id": "item_30926",
    "Last Name": "LIAM LOW",
    "First Name": "YONG GING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212627": {
    "id": "item_1316",
    "Last Name": "Lockyer",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212645": {
    "id": "item_13892",
    "Last Name": "Schliefert",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212650": {
    "id": "item_1315",
    "Last Name": "Joseph",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212680": {
    "id": "item_13893",
    "Last Name": "Nguyen",
    "First Name": "Dom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212685": {
    "id": "item_26255",
    "Last Name": "Dodd",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212688": {
    "id": "item_30927",
    "Last Name": "Navarro",
    "First Name": "Natalia Soledad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212697": {
    "id": "item_13897",
    "Last Name": "Birks",
    "First Name": "Levi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212700": {
    "id": "item_1317",
    "Last Name": "Mastertoun",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212710": {
    "id": "item_26259",
    "Last Name": "Groborsch",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212724": {
    "id": "item_30930",
    "Last Name": "Kong",
    "First Name": "Daeyoon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212731": {
    "id": "item_26257",
    "Last Name": "Chai",
    "First Name": "Kar Mun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212754": {
    "id": "item_26256",
    "Last Name": "Melegrito",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212770": {
    "id": "item_26266",
    "Last Name": "Masapequena",
    "First Name": "Janice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212786": {
    "id": "item_13894",
    "Last Name": "Janeke",
    "First Name": "Evadne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212794": {
    "id": "item_26258",
    "Last Name": "Huang",
    "First Name": "May Shen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212800": {
    "id": "item_26262",
    "Last Name": "Bozanic",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212804": {
    "id": "item_3167",
    "Last Name": "Wells",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212813": {
    "id": "item_16268",
    "Last Name": "Dowie",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212823": {
    "id": "item_30928",
    "Last Name": "Moore",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212828": {
    "id": "item_3168",
    "Last Name": "Hallam",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212833": {
    "id": "item_30931",
    "Last Name": "Roberts",
    "First Name": "Rosemary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212840": {
    "id": "item_26269",
    "Last Name": "Paske",
    "First Name": "Dave",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213002": {
    "id": "item_28734",
    "Last Name": "Lam",
    "First Name": "Duc Hoa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213027": {
    "id": "item_13895",
    "Last Name": "Sager",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213048": {
    "id": "item_26261",
    "Last Name": "Reiff",
    "First Name": "Carmen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213055": {
    "id": "item_26260",
    "Last Name": "Westo",
    "First Name": "Shona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213063": {
    "id": "item_30932",
    "Last Name": "Phillips",
    "First Name": "Dixie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213068": {
    "id": "item_30929",
    "Last Name": "Chiou",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213071": {
    "id": "item_13896",
    "Last Name": "Lopes",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213079": {
    "id": "item_28735",
    "Last Name": "Marjati",
    "First Name": "Lindawati",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213085": {
    "id": "item_26263",
    "Last Name": "Belfrage",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213086": {
    "id": "item_28736",
    "Last Name": "Tito Ferreira de Deus",
    "First Name": "Fagner",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213122": {
    "id": "item_1318",
    "Last Name": "Swinny",
    "First Name": "Irwin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213123": {
    "id": "item_26264",
    "Last Name": "Sahin",
    "First Name": "Murat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213133": {
    "id": "item_26267",
    "Last Name": "Choi",
    "First Name": "Miyoung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213142": {
    "id": "item_1319",
    "Last Name": "Carter",
    "First Name": "Brogan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213169": {
    "id": "item_26265",
    "Last Name": "Aston",
    "First Name": "Eveline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213170": {
    "id": "item_28737",
    "Last Name": "Weir",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213182": {
    "id": "item_28738",
    "Last Name": "TORRES",
    "First Name": "LORENZO RENAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213192": {
    "id": "item_1320",
    "Last Name": "Mutiso",
    "First Name": "Bernice",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213200": {
    "id": "item_30933",
    "Last Name": "Lewis",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213207": {
    "id": "item_28739",
    "Last Name": "Collins",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213214": {
    "id": "item_30934",
    "Last Name": "TAKAAZE",
    "First Name": "HIROSHI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213217": {
    "id": "item_3169",
    "Last Name": "Brady",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213242": {
    "id": "item_26268",
    "Last Name": "Harris",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213302": {
    "id": "item_30935",
    "Last Name": "Mendham",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213305": {
    "id": "item_28742",
    "Last Name": "Mauwa",
    "First Name": "Florence",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213307": {
    "id": "item_13898",
    "Last Name": "Cahill",
    "First Name": "Layne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213316": {
    "id": "item_26270",
    "Last Name": "Thomson",
    "First Name": "Isla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213318": {
    "id": "item_3170",
    "Last Name": "Sunakawa",
    "First Name": "Takeki",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213321": {
    "id": "item_26271",
    "Last Name": "RosaÕs",
    "First Name": "Luis Alejandro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213323": {
    "id": "item_13900",
    "Last Name": "Murphy",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213348": {
    "id": "item_13899",
    "Last Name": "Rowe",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213352": {
    "id": "item_28740",
    "Last Name": "Espejo",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213489": {
    "id": "item_3171",
    "Last Name": "Hennessy",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213541": {
    "id": "item_26272",
    "Last Name": "Damalerio",
    "First Name": "Louie Jay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213565": {
    "id": "item_26273",
    "Last Name": "YANG",
    "First Name": "MUHAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213584": {
    "id": "item_3172",
    "Last Name": "Newton",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213598": {
    "id": "item_28741",
    "Last Name": "Samanga",
    "First Name": "Tafadzwa Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213626": {
    "id": "item_26274",
    "Last Name": "Hodges",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213637": {
    "id": "item_30936",
    "Last Name": "Herwindrajaya",
    "First Name": "Charis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213649": {
    "id": "item_26275",
    "Last Name": "Pengelly",
    "First Name": "Liv",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213662": {
    "id": "item_26276",
    "Last Name": "Timms",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213671": {
    "id": "item_30937",
    "Last Name": "Livingston",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213699": {
    "id": "item_28743",
    "Last Name": "Jenny",
    "First Name": "Ade",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213705": {
    "id": "item_26277",
    "Last Name": "Balcazar de Wasseige",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213706": {
    "id": "item_28744",
    "Last Name": "Taylor",
    "First Name": "Kirstyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213734": {
    "id": "item_26278",
    "Last Name": "Rattanapong",
    "First Name": "Yuthasak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213752": {
    "id": "item_26279",
    "Last Name": "Chan",
    "First Name": "Kai Wing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213762": {
    "id": "item_1321",
    "Last Name": "Coomer",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213765": {
    "id": "item_30938",
    "Last Name": "Derham",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213778": {
    "id": "item_1322",
    "Last Name": "Phelps",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213836": {
    "id": "item_26280",
    "Last Name": "Kearns",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213837": {
    "id": "item_26281",
    "Last Name": "Forte",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213845": {
    "id": "item_13901",
    "Last Name": "Kearney",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213862": {
    "id": "item_30939",
    "Last Name": "Reilly",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213871": {
    "id": "item_3173",
    "Last Name": "Garcia",
    "First Name": "Jose A.",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213884": {
    "id": "item_1323",
    "Last Name": "Hailes",
    "First Name": "Kris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213898": {
    "id": "item_16269",
    "Last Name": "Delatorre",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213924": {
    "id": "item_28745",
    "Last Name": "Frewen",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213926": {
    "id": "item_13902",
    "Last Name": "Ross",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213934": {
    "id": "item_26282",
    "Last Name": "Leung",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213938": {
    "id": "item_30940",
    "Last Name": "pwa",
    "First Name": "chong chin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213955": {
    "id": "item_26283",
    "Last Name": "Bennett",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213972": {
    "id": "item_16270",
    "Last Name": "Cichonczyk",
    "First Name": "Kira",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213974": {
    "id": "item_13903",
    "Last Name": "O'CALLAGHAN",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213988": {
    "id": "item_26284",
    "Last Name": "Espinoza",
    "First Name": "Evelyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214013": {
    "id": "item_26285",
    "Last Name": "Smith",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214031": {
    "id": "item_28746",
    "Last Name": "Tran",
    "First Name": "Trung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214033": {
    "id": "item_28747",
    "Last Name": "Wilson",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214049": {
    "id": "item_3174",
    "Last Name": "Head",
    "First Name": "Regan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214054": {
    "id": "item_16271",
    "Last Name": "Buhrer",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214059": {
    "id": "item_30941",
    "Last Name": "Sylvester",
    "First Name": "Jake",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214077": {
    "id": "item_26288",
    "Last Name": "Muhamad Yunus",
    "First Name": "Hairudin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214081": {
    "id": "item_30944",
    "Last Name": "Hwang",
    "First Name": "Minji",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214083": {
    "id": "item_30942",
    "Last Name": "Lee",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214087": {
    "id": "item_13904",
    "Last Name": "Reppert",
    "First Name": "Haley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214099": {
    "id": "item_30943",
    "Last Name": "Webb",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214115": {
    "id": "item_26287",
    "Last Name": "Avery",
    "First Name": "Cara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214121": {
    "id": "item_26286",
    "Last Name": "Thomas",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214123": {
    "id": "item_30945",
    "Last Name": "Taylor",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214154": {
    "id": "item_13905",
    "Last Name": "Rafliansyah",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214176": {
    "id": "item_16272",
    "Last Name": "Yan",
    "First Name": "Ka Kit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214200": {
    "id": "item_30946",
    "Last Name": "Catipon",
    "First Name": "Jose Maria Lorenzo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214214": {
    "id": "item_3175",
    "Last Name": "Faria",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214227": {
    "id": "item_28749",
    "Last Name": "Manandhar",
    "First Name": "Amogh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214235": {
    "id": "item_13906",
    "Last Name": "mccoll",
    "First Name": "daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214238": {
    "id": "item_28748",
    "Last Name": "Elsegood",
    "First Name": "Jana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214256": {
    "id": "item_13909",
    "Last Name": "Ennis",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214265": {
    "id": "item_26289",
    "Last Name": "Shaw",
    "First Name": "Alison Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214266": {
    "id": "item_13907",
    "Last Name": "McDonnell",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214273": {
    "id": "item_13908",
    "Last Name": "Kennedy",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214274": {
    "id": "item_13910",
    "Last Name": "Goodier",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214284": {
    "id": "item_30948",
    "Last Name": "Burgess",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214286": {
    "id": "item_1324",
    "Last Name": "Villalba",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214295": {
    "id": "item_30947",
    "Last Name": "Burke",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214314": {
    "id": "item_3176",
    "Last Name": "Sykes",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214323": {
    "id": "item_13911",
    "Last Name": "Lim",
    "First Name": "Jerome",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214338": {
    "id": "item_26290",
    "Last Name": "Kolbaeva",
    "First Name": "Aisuluu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214356": {
    "id": "item_1325",
    "Last Name": "De Silva",
    "First Name": "Prishan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214368": {
    "id": "item_26291",
    "Last Name": "Doherty",
    "First Name": "Grant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214372": {
    "id": "item_30949",
    "Last Name": "yanto",
    "First Name": "peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214378": {
    "id": "item_26292",
    "Last Name": "Stephanie",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214379": {
    "id": "item_30950",
    "Last Name": "Butler",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214393": {
    "id": "item_30951",
    "Last Name": "JUN",
    "First Name": "MISUK",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214399": {
    "id": "item_3177",
    "Last Name": "Baillie",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214407": {
    "id": "item_30952",
    "Last Name": "Gonzalez",
    "First Name": "Azalea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214411": {
    "id": "item_13912",
    "Last Name": "Monaghan",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214418": {
    "id": "item_13913",
    "Last Name": "Singh",
    "First Name": "Popinder",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214442": {
    "id": "item_26293",
    "Last Name": "Gill",
    "First Name": "Arshdeep",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214456": {
    "id": "item_26294",
    "Last Name": "Jenkins-Fowler",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214497": {
    "id": "item_3178",
    "Last Name": "Ghita",
    "First Name": "Maulana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214513": {
    "id": "item_28750",
    "Last Name": "Rowe",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214550": {
    "id": "item_26295",
    "Last Name": "James",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214554": {
    "id": "item_28751",
    "Last Name": "Rainforth",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214562": {
    "id": "item_16273",
    "Last Name": "COUSINS",
    "First Name": "RACHEAL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214565": {
    "id": "item_26296",
    "Last Name": "Woods",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214578": {
    "id": "item_30953",
    "Last Name": "Hames",
    "First Name": "Roslyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214610": {
    "id": "item_13914",
    "Last Name": "Salazar",
    "First Name": "Paola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214622": {
    "id": "item_28752",
    "Last Name": "Koh",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214624": {
    "id": "item_30954",
    "Last Name": "Houston",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214630": {
    "id": "item_30955",
    "Last Name": "Chivers",
    "First Name": "Will",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214634": {
    "id": "item_30957",
    "Last Name": "Makary",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214640": {
    "id": "item_16274",
    "Last Name": "Larkin",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214673": {
    "id": "item_3179",
    "Last Name": "Da Cunha",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214674": {
    "id": "item_30956",
    "Last Name": "Platzek",
    "First Name": "Anja",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214704": {
    "id": "item_28753",
    "Last Name": "Franklin",
    "First Name": "Therese",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214712": {
    "id": "item_13915",
    "Last Name": "Lee",
    "First Name": "Gaeon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214747": {
    "id": "item_26300",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214841": {
    "id": "item_26297",
    "Last Name": "Scott",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214858": {
    "id": "item_30958",
    "Last Name": "Kumar",
    "First Name": "Akhil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214876": {
    "id": "item_26299",
    "Last Name": "TANAKA",
    "First Name": "TSUTOMU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214896": {
    "id": "item_26298",
    "Last Name": "Walker",
    "First Name": "Beth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214906": {
    "id": "item_28754",
    "Last Name": "Toogood",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214930": {
    "id": "item_13916",
    "Last Name": "Carvajal R",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214939": {
    "id": "item_16275",
    "Last Name": "Black",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214943": {
    "id": "item_26301",
    "Last Name": "Roberge",
    "First Name": "Brhiannon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214964": {
    "id": "item_1326",
    "Last Name": "Bedding",
    "First Name": "Maddy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214968": {
    "id": "item_28755",
    "Last Name": "Briggs",
    "First Name": "Lily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215011": {
    "id": "item_30959",
    "Last Name": "Anuchiracheeva",
    "First Name": "Salinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215028": {
    "id": "item_28756",
    "Last Name": "Jung",
    "First Name": "Jaeeun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215039": {
    "id": "item_26302",
    "Last Name": "Shaunessy",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215040": {
    "id": "item_30961",
    "Last Name": "Li",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215042": {
    "id": "item_30960",
    "Last Name": "Ward",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215064": {
    "id": "item_13917",
    "Last Name": "Bayne",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215066": {
    "id": "item_26303",
    "Last Name": "Howard",
    "First Name": "Bronte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215134": {
    "id": "item_28757",
    "Last Name": "samsudin",
    "First Name": "Norazmi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215174": {
    "id": "item_30962",
    "Last Name": "Reyes",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215183": {
    "id": "item_28758",
    "Last Name": "Smallacombe",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215206": {
    "id": "item_13918",
    "Last Name": "Flood",
    "First Name": "Darcy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215211": {
    "id": "item_3180",
    "Last Name": "MAO",
    "First Name": "YANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215229": {
    "id": "item_30964",
    "Last Name": "Hemachandra",
    "First Name": "Hithi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215236": {
    "id": "item_13919",
    "Last Name": "Quevedo",
    "First Name": "Ali",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215246": {
    "id": "item_30963",
    "Last Name": "Johns",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215251": {
    "id": "item_26305",
    "Last Name": "Sanelli",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215253": {
    "id": "item_26304",
    "Last Name": "Chia",
    "First Name": "Jovina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215258": {
    "id": "item_1327",
    "Last Name": "Elliott",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215259": {
    "id": "item_3181",
    "Last Name": "Blanco",
    "First Name": "Giselle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215287": {
    "id": "item_26306",
    "Last Name": "Gale",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215293": {
    "id": "item_30965",
    "Last Name": "Dellaqua",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215298": {
    "id": "item_13920",
    "Last Name": "Cheung",
    "First Name": "Hang tak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215339": {
    "id": "item_30966",
    "Last Name": "Mahoney",
    "First Name": "Taryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215343": {
    "id": "item_13921",
    "Last Name": "ZHOU",
    "First Name": "YI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215393": {
    "id": "item_26307",
    "Last Name": "Hodge",
    "First Name": "Jeau",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215407": {
    "id": "item_26310",
    "Last Name": "LIN",
    "First Name": "HSIN CHIEH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215460": {
    "id": "item_26308",
    "Last Name": "Hiebert",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215461": {
    "id": "item_13922",
    "Last Name": "Brito Tinoco",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215490": {
    "id": "item_13923",
    "Last Name": "Cahill",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215516": {
    "id": "item_13924",
    "Last Name": "Adams",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215522": {
    "id": "item_1328",
    "Last Name": "Hernandez",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215525": {
    "id": "item_3182",
    "Last Name": "Ng",
    "First Name": "Ka Fung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215528": {
    "id": "item_30967",
    "Last Name": "Lacnit",
    "First Name": "Irwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215552": {
    "id": "item_26309",
    "Last Name": "Donnachie",
    "First Name": "Charles",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215580": {
    "id": "item_1329",
    "Last Name": "Thang",
    "First Name": "Paz",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215607": {
    "id": "item_13925",
    "Last Name": "Browne",
    "First Name": "Mackenzie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215619": {
    "id": "item_13926",
    "Last Name": "Tsang",
    "First Name": "sai fung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215629": {
    "id": "item_16276",
    "Last Name": "CHOI",
    "First Name": "PO YAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215656": {
    "id": "item_28759",
    "Last Name": "Byrne",
    "First Name": "Pyper",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215673": {
    "id": "item_1330",
    "Last Name": "BARRETO VILLA",
    "First Name": "YISSEL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215728": {
    "id": "item_28760",
    "Last Name": "Maninjwa",
    "First Name": "Sandisiwe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215738": {
    "id": "item_26311",
    "Last Name": "Kotowski-Chang",
    "First Name": "Jan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215745": {
    "id": "item_1331",
    "Last Name": "PAO",
    "First Name": "KA SHING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215805": {
    "id": "item_3183",
    "Last Name": "Smith",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215833": {
    "id": "item_30968",
    "Last Name": "mehta",
    "First Name": "Aditi Dushyant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215853": {
    "id": "item_28761",
    "Last Name": "MONJARAZ BRAVO",
    "First Name": "JAZMIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215931": {
    "id": "item_26312",
    "Last Name": "Guarascio",
    "First Name": "Haylee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215933": {
    "id": "item_26313",
    "Last Name": "Lim",
    "First Name": "Timothy Yu Li",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215943": {
    "id": "item_13927",
    "Last Name": "Wright",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215954": {
    "id": "item_16277",
    "Last Name": "NARKVICHIAN",
    "First Name": "RATAPON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215995": {
    "id": "item_26314",
    "Last Name": "Chou",
    "First Name": "Chia Hsien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216053": {
    "id": "item_1332",
    "Last Name": "Tian",
    "First Name": "Changsheng",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216074": {
    "id": "item_16278",
    "Last Name": "Bienemann",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216087": {
    "id": "item_3184",
    "Last Name": "White",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216111": {
    "id": "item_26315",
    "Last Name": "Yu",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216137": {
    "id": "item_13928",
    "Last Name": "CASTILLA BELLO",
    "First Name": "JOSE LUIS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216285": {
    "id": "item_28764",
    "Last Name": "AHMAD",
    "First Name": "RAFIDAH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216290": {
    "id": "item_30969",
    "Last Name": "Liu",
    "First Name": "Xinyu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216328": {
    "id": "item_28762",
    "Last Name": "Humphrey",
    "First Name": "Mia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216372": {
    "id": "item_30970",
    "Last Name": "Jeon",
    "First Name": "Youngtae",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216380": {
    "id": "item_16279",
    "Last Name": "Scuderi",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216385": {
    "id": "item_13931",
    "Last Name": "Grogan",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216483": {
    "id": "item_28763",
    "Last Name": "Lee",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216501": {
    "id": "item_13929",
    "Last Name": "JOSHI",
    "First Name": "KALPESHKUMAR",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216529": {
    "id": "item_1333",
    "Last Name": "Bassett",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216548": {
    "id": "item_26316",
    "Last Name": "Chataway",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216596": {
    "id": "item_13930",
    "Last Name": "Wang",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216597": {
    "id": "item_28765",
    "Last Name": "Boaden",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216602": {
    "id": "item_28766",
    "Last Name": "Geteria",
    "First Name": "Gitonga",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216720": {
    "id": "item_26317",
    "Last Name": "McIver",
    "First Name": "Brad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216758": {
    "id": "item_28767",
    "Last Name": "Vassos",
    "First Name": "Larissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216878": {
    "id": "item_13932",
    "Last Name": "Punwong",
    "First Name": "Anawin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216889": {
    "id": "item_26318",
    "Last Name": "Akatsuka",
    "First Name": "Kaori",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216890": {
    "id": "item_13933",
    "Last Name": "Natividad",
    "First Name": "Hubert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216917": {
    "id": "item_1334",
    "Last Name": "Rogan",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216948": {
    "id": "item_26319",
    "Last Name": "Gallo Castillo",
    "First Name": "Juan Sebastian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216970": {
    "id": "item_1335",
    "Last Name": "Turner",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217011": {
    "id": "item_26320",
    "Last Name": "Tuamprasert",
    "First Name": "Suwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217135": {
    "id": "item_1336",
    "Last Name": "Poojary",
    "First Name": "Ashok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217142": {
    "id": "item_26321",
    "Last Name": "rolfe",
    "First Name": "jasmine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217153": {
    "id": "item_28769",
    "Last Name": "Imer",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217154": {
    "id": "item_28768",
    "Last Name": "Ly",
    "First Name": "Canh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217177": {
    "id": "item_26323",
    "Last Name": "Sin Yi",
    "First Name": "Pey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217185": {
    "id": "item_13934",
    "Last Name": "Mobbs",
    "First Name": "Jamieson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217238": {
    "id": "item_26322",
    "Last Name": "Cameron",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217242": {
    "id": "item_28770",
    "Last Name": "Khadka",
    "First Name": "Monika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217301": {
    "id": "item_16280",
    "Last Name": "Villamor",
    "First Name": "Jules",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217344": {
    "id": "item_30971",
    "Last Name": "Rayar",
    "First Name": "Jagruti",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217399": {
    "id": "item_13935",
    "Last Name": "Marshall",
    "First Name": "Meg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217434": {
    "id": "item_26324",
    "Last Name": "Lee",
    "First Name": "Chun Wai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217445": {
    "id": "item_30972",
    "Last Name": "walters",
    "First Name": "allen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217457": {
    "id": "item_26325",
    "Last Name": "murray",
    "First Name": "charlotte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217515": {
    "id": "item_30973",
    "Last Name": "Hirna",
    "First Name": "Orysya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217559": {
    "id": "item_30974",
    "Last Name": "Velasco",
    "First Name": "Hanna Girly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217586": {
    "id": "item_3185",
    "Last Name": "Smith",
    "First Name": "Brock",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217601": {
    "id": "item_30975",
    "Last Name": "carlous",
    "First Name": "david",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217734": {
    "id": "item_28771",
    "Last Name": "Enks",
    "First Name": "Trudie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217847": {
    "id": "item_26327",
    "Last Name": "Overbosch",
    "First Name": "Willem",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217876": {
    "id": "item_30976",
    "Last Name": "McKeown",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217877": {
    "id": "item_26326",
    "Last Name": "Affandy",
    "First Name": "Mirza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217886": {
    "id": "item_13936",
    "Last Name": "Muzumdar",
    "First Name": "Abhijeet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217899": {
    "id": "item_26328",
    "Last Name": "Farmer",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218130": {
    "id": "item_13937",
    "Last Name": "Kartsounis",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218176": {
    "id": "item_26329",
    "Last Name": "Iyal Hendrawan",
    "First Name": "Rudi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218210": {
    "id": "item_28772",
    "Last Name": "Wu",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218223": {
    "id": "item_3186",
    "Last Name": "Carmona Toloza",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218287": {
    "id": "item_13938",
    "Last Name": "Allin",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218332": {
    "id": "item_1337",
    "Last Name": "Kalachov",
    "First Name": "Valentyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218415": {
    "id": "item_28773",
    "Last Name": "swift",
    "First Name": "leigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218433": {
    "id": "item_13939",
    "Last Name": "LOPEZ",
    "First Name": "FRANCISCO JAVIER",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218511": {
    "id": "item_13940",
    "Last Name": "Lyne",
    "First Name": "Ashton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218572": {
    "id": "item_26330",
    "Last Name": "Bee",
    "First Name": "Jess",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218743": {
    "id": "item_30977",
    "Last Name": "Choi",
    "First Name": "Jenny Aejung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218808": {
    "id": "item_28774",
    "Last Name": "Nefiodovas",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218826": {
    "id": "item_30978",
    "Last Name": "Trist",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218914": {
    "id": "item_30979",
    "Last Name": "Newcombe",
    "First Name": "Charlisse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218975": {
    "id": "item_13941",
    "Last Name": "Putra",
    "First Name": "Haqni Alghoitsa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218993": {
    "id": "item_30980",
    "Last Name": "Diao",
    "First Name": "Qihang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219023": {
    "id": "item_13942",
    "Last Name": "Seymour",
    "First Name": "Tazmin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219059": {
    "id": "item_3187",
    "Last Name": "Newton",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219138": {
    "id": "item_16281",
    "Last Name": "Sribunruang",
    "First Name": "Yuttakorn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219199": {
    "id": "item_26331",
    "Last Name": "Jacobs",
    "First Name": "Roxane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219247": {
    "id": "item_30981",
    "Last Name": "Taneja-Young",
    "First Name": "April",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219272": {
    "id": "item_3188",
    "Last Name": "Mangunay",
    "First Name": "Clark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219299": {
    "id": "item_13943",
    "Last Name": "Staal",
    "First Name": "Bekka",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219330": {
    "id": "item_26332",
    "Last Name": "Askew",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219332": {
    "id": "item_16282",
    "Last Name": "Turner",
    "First Name": "Sophee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219397": {
    "id": "item_13944",
    "Last Name": "chen",
    "First Name": "Yi Ze",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219471": {
    "id": "item_30982",
    "Last Name": "Baulch",
    "First Name": "Madison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219604": {
    "id": "item_26333",
    "Last Name": "Magdalera",
    "First Name": "Lloyd",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219648": {
    "id": "item_30983",
    "Last Name": "Baven",
    "First Name": "Anish Mathew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219705": {
    "id": "item_26334",
    "Last Name": "Bernadus",
    "First Name": "Nathanael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219737": {
    "id": "item_26335",
    "Last Name": "Akiatan",
    "First Name": "Karla Alaiza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219799": {
    "id": "item_26336",
    "Last Name": "White",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219823": {
    "id": "item_26337",
    "Last Name": "santana",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219945": {
    "id": "item_16283",
    "Last Name": "Harvey",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219988": {
    "id": "item_30984",
    "Last Name": "Goralski",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220003": {
    "id": "item_13945",
    "Last Name": "Zehner",
    "First Name": "Lukasz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220026": {
    "id": "item_3189",
    "Last Name": "Melegrito",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220067": {
    "id": "item_26338",
    "Last Name": "Gonzalez",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220076": {
    "id": "item_30985",
    "Last Name": "Tam",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220160": {
    "id": "item_13946",
    "Last Name": "Dains",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220258": {
    "id": "item_1338",
    "Last Name": "Dowsett",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220302": {
    "id": "item_3190",
    "Last Name": "Newitt",
    "First Name": "Tara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220331": {
    "id": "item_30986",
    "Last Name": "Kuliukas",
    "First Name": "Zemyna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220347": {
    "id": "item_26339",
    "Last Name": "Black",
    "First Name": "Eli",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220353": {
    "id": "item_30987",
    "Last Name": "Zhang",
    "First Name": "Xiayang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220441": {
    "id": "item_26340",
    "Last Name": "Shim",
    "First Name": "Aggie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220482": {
    "id": "item_28775",
    "Last Name": "williams",
    "First Name": "telverne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220509": {
    "id": "item_28776",
    "Last Name": "O'Kane",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220529": {
    "id": "item_1339",
    "Last Name": "Muhammad",
    "First Name": "Junaid",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220539": {
    "id": "item_28777",
    "Last Name": "Kimbel",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220544": {
    "id": "item_26341",
    "Last Name": "Burias",
    "First Name": "Allan-Arvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220551": {
    "id": "item_26342",
    "Last Name": "Wang",
    "First Name": "Chengzhi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220564": {
    "id": "item_30988",
    "Last Name": "Hansen",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220593": {
    "id": "item_26343",
    "Last Name": "Shah",
    "First Name": "Darshil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220605": {
    "id": "item_26344",
    "Last Name": "SU",
    "First Name": "HUAIZHEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220614": {
    "id": "item_1340",
    "Last Name": "Bean",
    "First Name": "Jemima",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220663": {
    "id": "item_13947",
    "Last Name": "Juanir",
    "First Name": "Robina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220684": {
    "id": "item_26345",
    "Last Name": "Kennedy",
    "First Name": "Annamay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220713": {
    "id": "item_13948",
    "Last Name": "Enacles Ortega Maia",
    "First Name": "Tainah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220786": {
    "id": "item_3191",
    "Last Name": "Nigmetov",
    "First Name": "Artur",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220802": {
    "id": "item_28778",
    "Last Name": "Ahmad",
    "First Name": "Indah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220809": {
    "id": "item_3192",
    "Last Name": "Kennedy",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220853": {
    "id": "item_28779",
    "Last Name": "Holandez",
    "First Name": "Danilo Jr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220884": {
    "id": "item_30989",
    "Last Name": "Roe",
    "First Name": "Yvette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220962": {
    "id": "item_13950",
    "Last Name": "Dasio",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220967": {
    "id": "item_28780",
    "Last Name": "Adams",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220978": {
    "id": "item_13949",
    "Last Name": "Sandoval",
    "First Name": "Isidora",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220994": {
    "id": "item_1341",
    "Last Name": "Kuiters",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221021": {
    "id": "item_26346",
    "Last Name": "Whatmough",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221041": {
    "id": "item_26347",
    "Last Name": "Compans",
    "First Name": "Alix",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221116": {
    "id": "item_30990",
    "Last Name": "Nielsen",
    "First Name": "Anne Sofie Cornelius",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221171": {
    "id": "item_26348",
    "Last Name": "Brunet",
    "First Name": "ThŽo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221178": {
    "id": "item_13951",
    "Last Name": "Davis",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221215": {
    "id": "item_30991",
    "Last Name": "Gan",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221219": {
    "id": "item_26349",
    "Last Name": "Clarke",
    "First Name": "Lily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221394": {
    "id": "item_30993",
    "Last Name": "Formosa",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221395": {
    "id": "item_30992",
    "Last Name": "Moss",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221401": {
    "id": "item_16284",
    "Last Name": "PEROLINO",
    "First Name": "AILENE GAY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221408": {
    "id": "item_28781",
    "Last Name": "Nakhwa",
    "First Name": "Dheeraj",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221412": {
    "id": "item_13952",
    "Last Name": "Nolan",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221413": {
    "id": "item_1342",
    "Last Name": "Rickard",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221428": {
    "id": "item_1343",
    "Last Name": "Ricalde",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221502": {
    "id": "item_30994",
    "Last Name": "Cheng",
    "First Name": "Quanxi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221551": {
    "id": "item_16285",
    "Last Name": "Del Pino Romero",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221561": {
    "id": "item_26350",
    "Last Name": "Luna",
    "First Name": "Stanley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221581": {
    "id": "item_26351",
    "Last Name": "Capuno",
    "First Name": "Jose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221640": {
    "id": "item_26352",
    "Last Name": "Farrand",
    "First Name": "Becky",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221684": {
    "id": "item_30995",
    "Last Name": "Butler",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221688": {
    "id": "item_30996",
    "Last Name": "Roberts",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221696": {
    "id": "item_26353",
    "Last Name": "elder",
    "First Name": "callum",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221698": {
    "id": "item_28782",
    "Last Name": "Barchalk",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221708": {
    "id": "item_30997",
    "Last Name": "Renton",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221718": {
    "id": "item_16286",
    "Last Name": "CHENG",
    "First Name": "LETIAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221723": {
    "id": "item_28783",
    "Last Name": "House",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221743": {
    "id": "item_30999",
    "Last Name": "Wood",
    "First Name": "Zara Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221749": {
    "id": "item_1344",
    "Last Name": "Viscione",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221751": {
    "id": "item_30998",
    "Last Name": "Ma",
    "First Name": "Thuan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221764": {
    "id": "item_26354",
    "Last Name": "Pham",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221765": {
    "id": "item_31000",
    "Last Name": "yusuf",
    "First Name": "muhammad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221777": {
    "id": "item_26355",
    "Last Name": "Marshall",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221833": {
    "id": "item_31001",
    "Last Name": "Joll",
    "First Name": "Candice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221837": {
    "id": "item_31002",
    "Last Name": "Chan",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221846": {
    "id": "item_1345",
    "Last Name": "Rankin",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221874": {
    "id": "item_31003",
    "Last Name": "Chong",
    "First Name": "Maddi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221882": {
    "id": "item_26356",
    "Last Name": "Rueng-uttamanan",
    "First Name": "Onjira",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221963": {
    "id": "item_26357",
    "Last Name": "Recio",
    "First Name": "Gerard Luis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221982": {
    "id": "item_26358",
    "Last Name": "Lau",
    "First Name": "Terence",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222036": {
    "id": "item_1346",
    "Last Name": "griffith",
    "First Name": "christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222048": {
    "id": "item_31004",
    "Last Name": "Tagade",
    "First Name": "Vidyadhar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222105": {
    "id": "item_1347",
    "Last Name": "Carlisle",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222115": {
    "id": "item_31005",
    "Last Name": "O'Dolan",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222195": {
    "id": "item_1348",
    "Last Name": "O'Donnell",
    "First Name": "Breeana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222201": {
    "id": "item_28784",
    "Last Name": "Gilmore",
    "First Name": "Danni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222208": {
    "id": "item_16287",
    "Last Name": "Flores",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222209": {
    "id": "item_28785",
    "Last Name": "Hartanto",
    "First Name": "Catur",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222293": {
    "id": "item_26359",
    "Last Name": "Yang",
    "First Name": "Zanlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222318": {
    "id": "item_26360",
    "Last Name": "Cochrane",
    "First Name": "Louisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222351": {
    "id": "item_26361",
    "Last Name": "Freeman",
    "First Name": "April",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222383": {
    "id": "item_31006",
    "Last Name": "Diederichsen",
    "First Name": "Allanah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222407": {
    "id": "item_28786",
    "Last Name": "Few",
    "First Name": "Meg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222431": {
    "id": "item_26362",
    "Last Name": "Aviano Haznam",
    "First Name": "Rinaldo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222486": {
    "id": "item_31007",
    "Last Name": "Jeong",
    "First Name": "Haneul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222498": {
    "id": "item_26363",
    "Last Name": "Wood",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222547": {
    "id": "item_3193",
    "Last Name": "Pincus",
    "First Name": "Gavi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222584": {
    "id": "item_1349",
    "Last Name": "Marshall",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222606": {
    "id": "item_16288",
    "Last Name": "Cameron",
    "First Name": "Holly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222628": {
    "id": "item_31008",
    "Last Name": "Gong",
    "First Name": "Liping",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222637": {
    "id": "item_26364",
    "Last Name": "MADERS",
    "First Name": "JUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222665": {
    "id": "item_28787",
    "Last Name": "Mussilimov",
    "First Name": "Aziz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222730": {
    "id": "item_31009",
    "Last Name": "WU",
    "First Name": "CHENG-HAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222816": {
    "id": "item_26365",
    "Last Name": "Basham",
    "First Name": "Ebony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222827": {
    "id": "item_26366",
    "Last Name": "Rocca",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222845": {
    "id": "item_1350",
    "Last Name": "Knibbs",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222870": {
    "id": "item_28788",
    "Last Name": "Whitton",
    "First Name": "Morwenna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222904": {
    "id": "item_3194",
    "Last Name": "Gummer",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222925": {
    "id": "item_26367",
    "Last Name": "Djanardono",
    "First Name": "Aris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222927": {
    "id": "item_28789",
    "Last Name": "guo",
    "First Name": "xiaoyi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222954": {
    "id": "item_31010",
    "Last Name": "Azmi",
    "First Name": "Rizza Maulana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223016": {
    "id": "item_26368",
    "Last Name": "Bukhari",
    "First Name": "Syed Waqas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223049": {
    "id": "item_31011",
    "Last Name": "Drohan",
    "First Name": "Naoise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223058": {
    "id": "item_1351",
    "Last Name": "Cheung",
    "First Name": "Kin Long Cooby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223108": {
    "id": "item_1352",
    "Last Name": "Koutsoukou",
    "First Name": "Iman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223115": {
    "id": "item_28790",
    "Last Name": "Mackay",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223208": {
    "id": "item_28791",
    "Last Name": "Degamo",
    "First Name": "Naovy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223210": {
    "id": "item_1353",
    "Last Name": "Larson",
    "First Name": "Mikel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223233": {
    "id": "item_3195",
    "Last Name": "Stewart",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223241": {
    "id": "item_31012",
    "Last Name": "Muros",
    "First Name": "Ni–o",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223270": {
    "id": "item_26369",
    "Last Name": "Price",
    "First Name": "Riley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223400": {
    "id": "item_3196",
    "Last Name": "Vasko",
    "First Name": "Yana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223403": {
    "id": "item_28792",
    "Last Name": "Salama",
    "First Name": "Vitor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223442": {
    "id": "item_3197",
    "Last Name": "Kothari",
    "First Name": "Alok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223480": {
    "id": "item_16289",
    "Last Name": "Nurgaliyeva",
    "First Name": "Anara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223544": {
    "id": "item_31013",
    "Last Name": "Pillai",
    "First Name": "Aishwarya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223576": {
    "id": "item_31014",
    "Last Name": "Harrower",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223580": {
    "id": "item_3198",
    "Last Name": "Hicks",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223599": {
    "id": "item_31015",
    "Last Name": "Park",
    "First Name": "Jungeun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223691": {
    "id": "item_28793",
    "Last Name": "Kelly",
    "First Name": "Paula",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223701": {
    "id": "item_3199",
    "Last Name": "PASCOE",
    "First Name": "ELISHA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223737": {
    "id": "item_13953",
    "Last Name": "Oliveros",
    "First Name": "Camila",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223746": {
    "id": "item_26370",
    "Last Name": "Contreras Ubric",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223775": {
    "id": "item_31016",
    "Last Name": "Bartlem",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223789": {
    "id": "item_26371",
    "Last Name": "Connell",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223791": {
    "id": "item_16290",
    "Last Name": "LEE",
    "First Name": "LANYIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223821": {
    "id": "item_26372",
    "Last Name": "McCorry",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223856": {
    "id": "item_31017",
    "Last Name": "Tamulyte",
    "First Name": "Gelija",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223875": {
    "id": "item_28794",
    "Last Name": "Smith",
    "First Name": "Danica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223896": {
    "id": "item_1354",
    "Last Name": "Williams",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223939": {
    "id": "item_26373",
    "Last Name": "Corso",
    "First Name": "Tahlesha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223944": {
    "id": "item_26374",
    "Last Name": "sakoff",
    "First Name": "ian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223968": {
    "id": "item_28795",
    "Last Name": "Arzal",
    "First Name": "Arzal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223995": {
    "id": "item_31019",
    "Last Name": "Karamanolakis",
    "First Name": "Paris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224030": {
    "id": "item_31018",
    "Last Name": "Park",
    "First Name": "Yujin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224053": {
    "id": "item_13954",
    "Last Name": "Clemens",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224294": {
    "id": "item_26375",
    "Last Name": "Davies",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224312": {
    "id": "item_31021",
    "Last Name": "Nguyen",
    "First Name": "Duyen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224320": {
    "id": "item_31020",
    "Last Name": "Nairn",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224385": {
    "id": "item_31022",
    "Last Name": "BYEON",
    "First Name": "HWANGYU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224405": {
    "id": "item_28796",
    "Last Name": "Ali",
    "First Name": "Mohamed",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224420": {
    "id": "item_16291",
    "Last Name": "Bunten",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224460": {
    "id": "item_31023",
    "Last Name": "Boyd",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224473": {
    "id": "item_28797",
    "Last Name": "Zapata",
    "First Name": "Juan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224582": {
    "id": "item_31024",
    "Last Name": "Piccin",
    "First Name": "Tina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224632": {
    "id": "item_26377",
    "Last Name": "Harris",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224634": {
    "id": "item_26376",
    "Last Name": "Larter",
    "First Name": "Hazel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224662": {
    "id": "item_13955",
    "Last Name": "Rivera",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224719": {
    "id": "item_3200",
    "Last Name": "Erwin",
    "First Name": "Mel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224733": {
    "id": "item_31025",
    "Last Name": "Chan",
    "First Name": "Hiu Yan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224792": {
    "id": "item_31026",
    "Last Name": "Wong",
    "First Name": "Wai hang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224828": {
    "id": "item_31027",
    "Last Name": "Sunglao",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224839": {
    "id": "item_31028",
    "Last Name": "Jittrailert",
    "First Name": "Wissuda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224927": {
    "id": "item_1355",
    "Last Name": "Honda",
    "First Name": "Hirokazu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225027": {
    "id": "item_28798",
    "Last Name": "Haryanto",
    "First Name": "Haryanto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225088": {
    "id": "item_16292",
    "Last Name": "Turbak",
    "First Name": "Katarzyna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225138": {
    "id": "item_13956",
    "Last Name": "Currea",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225231": {
    "id": "item_13957",
    "Last Name": "Naumovski",
    "First Name": "Simone",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225599": {
    "id": "item_28799",
    "Last Name": "Jawiyah",
    "First Name": "Isma Nabila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225645": {
    "id": "item_13958",
    "Last Name": "Lopez",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225673": {
    "id": "item_26378",
    "Last Name": "Srumenganti",
    "First Name": "Widuri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225705": {
    "id": "item_28800",
    "Last Name": "Villena",
    "First Name": "Vlademir Roy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225829": {
    "id": "item_3201",
    "Last Name": "Gidaszewski",
    "First Name": "Wojciech",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225855": {
    "id": "item_28801",
    "Last Name": "Wright",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38226160": {
    "id": "item_16293",
    "Last Name": "Sitharthan",
    "First Name": "Archita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38226370": {
    "id": "item_1356",
    "Last Name": "Mahne",
    "First Name": "Spencer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38226717": {
    "id": "item_16294",
    "Last Name": "TAPIA",
    "First Name": "KAREM",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38228087": {
    "id": "item_31029",
    "Last Name": "Tai",
    "First Name": "Chong Ling",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38228150": {
    "id": "item_31030",
    "Last Name": "Lucke",
    "First Name": "Nola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38229487": {
    "id": "item_26379",
    "Last Name": "Fung",
    "First Name": "Billie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38229713": {
    "id": "item_31031",
    "Last Name": "Panama Tirado",
    "First Name": "Julio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38230034": {
    "id": "item_16295",
    "Last Name": "Hughes",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38230780": {
    "id": "item_1357",
    "Last Name": "Hummer",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38231392": {
    "id": "item_3202",
    "Last Name": "VILLALOBOS",
    "First Name": "ALEJANDRO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38231457": {
    "id": "item_13959",
    "Last Name": "Oyarzo Hernandez",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38232952": {
    "id": "item_3203",
    "Last Name": "Cribbes",
    "First Name": "Wilbur",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38233055": {
    "id": "item_26380",
    "Last Name": "Ribeiro",
    "First Name": "Andreia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38233142": {
    "id": "item_13960",
    "Last Name": "Annese",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38233518": {
    "id": "item_31032",
    "Last Name": "Bradford",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38233772": {
    "id": "item_13961",
    "Last Name": "Holder",
    "First Name": "Shakira",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38233965": {
    "id": "item_1358",
    "Last Name": "Thurman",
    "First Name": "Terralance ÒShonÓ",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38233990": {
    "id": "item_31033",
    "Last Name": "Gurrie",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38234053": {
    "id": "item_26381",
    "Last Name": "Kostiuk",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38234530": {
    "id": "item_31034",
    "Last Name": "Ng",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38234587": {
    "id": "item_26382",
    "Last Name": "Ferguson",
    "First Name": "Charmaine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38234663": {
    "id": "item_28802",
    "Last Name": "Misdale",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38235188": {
    "id": "item_3204",
    "Last Name": "Brown",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38235348": {
    "id": "item_26383",
    "Last Name": "Robson",
    "First Name": "Ty",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38235433": {
    "id": "item_1359",
    "Last Name": "Collado Caballero",
    "First Name": "Dar’o",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38235516": {
    "id": "item_1360",
    "Last Name": "Milross-rose",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38235823": {
    "id": "item_16296",
    "Last Name": "Hanley",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38243501": {
    "id": "item_26384",
    "Last Name": "Docherty",
    "First Name": "Amante",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38243555": {
    "id": "item_13962",
    "Last Name": "Farthing",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38245694": {
    "id": "item_16297",
    "Last Name": "Hotchin",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38247909": {
    "id": "item_13963",
    "Last Name": "Staude",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248065": {
    "id": "item_3205",
    "Last Name": "roughan",
    "First Name": "madeleine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248104": {
    "id": "item_26385",
    "Last Name": "Black",
    "First Name": "Marissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248182": {
    "id": "item_16298",
    "Last Name": "Morrison",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248257": {
    "id": "item_1361",
    "Last Name": "Milillo",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248486": {
    "id": "item_28803",
    "Last Name": "Lightfoot",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38249040": {
    "id": "item_28804",
    "Last Name": "Cameirao",
    "First Name": "Tahlia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38249070": {
    "id": "item_1362",
    "Last Name": "Petherick",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38249376": {
    "id": "item_28805",
    "Last Name": "Manton",
    "First Name": "Dakota",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250023": {
    "id": "item_28806",
    "Last Name": "Omar",
    "First Name": "Zaid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250278": {
    "id": "item_31035",
    "Last Name": "Waters",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250319": {
    "id": "item_16299",
    "Last Name": "Lee",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250415": {
    "id": "item_26386",
    "Last Name": "Narciso",
    "First Name": "Amor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250570": {
    "id": "item_26387",
    "Last Name": "Jarrett",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250607": {
    "id": "item_26388",
    "Last Name": "Becker",
    "First Name": "Mimi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250720": {
    "id": "item_31036",
    "Last Name": "Sameeh",
    "First Name": "Ali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38251233": {
    "id": "item_26389",
    "Last Name": "Seow",
    "First Name": "Yu Heng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38251309": {
    "id": "item_26390",
    "Last Name": "Symes",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38251899": {
    "id": "item_3206",
    "Last Name": "Xie",
    "First Name": "Junping Jacky",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38252090": {
    "id": "item_13964",
    "Last Name": "Norris",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38252115": {
    "id": "item_26391",
    "Last Name": "Shewry",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38252681": {
    "id": "item_26392",
    "Last Name": "Hamzah",
    "First Name": "Amrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38252866": {
    "id": "item_1363",
    "Last Name": "Wood",
    "First Name": "Thomson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38252961": {
    "id": "item_26393",
    "Last Name": "Ward",
    "First Name": "Roisin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38253324": {
    "id": "item_26394",
    "Last Name": "Loschiavo",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38253885": {
    "id": "item_26395",
    "Last Name": "SAADI",
    "First Name": "AFDAL HAFIZ",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38253919": {
    "id": "item_31037",
    "Last Name": "Rangel",
    "First Name": "CHRISTIAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38253938": {
    "id": "item_28807",
    "Last Name": "Dorjjantsan",
    "First Name": "Munkhchimeg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38253968": {
    "id": "item_26396",
    "Last Name": "Petersen",
    "First Name": "Keshia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38254727": {
    "id": "item_1364",
    "Last Name": "KIM",
    "First Name": "SOL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255039": {
    "id": "item_31038",
    "Last Name": "West",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255300": {
    "id": "item_28808",
    "Last Name": "Dunsmuir",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255514": {
    "id": "item_31039",
    "Last Name": "Cong",
    "First Name": "Handika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255622": {
    "id": "item_26397",
    "Last Name": "Gonzalez Martin",
    "First Name": "Felix",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255807": {
    "id": "item_1365",
    "Last Name": "sanyoto",
    "First Name": "jenny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255892": {
    "id": "item_16300",
    "Last Name": "Behr",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255913": {
    "id": "item_28809",
    "Last Name": "Fajardo",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255942": {
    "id": "item_3207",
    "Last Name": "R K",
    "First Name": "Murthy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256015": {
    "id": "item_28810",
    "Last Name": "Barnes",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256088": {
    "id": "item_26398",
    "Last Name": "Loh",
    "First Name": "Sabrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256104": {
    "id": "item_31040",
    "Last Name": "Lyons",
    "First Name": "Leonie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256129": {
    "id": "item_13965",
    "Last Name": "Schaeffer",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256246": {
    "id": "item_31041",
    "Last Name": "Bootle",
    "First Name": "Lara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256685": {
    "id": "item_31042",
    "Last Name": "Foce",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256713": {
    "id": "item_1366",
    "Last Name": "Andrews",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256889": {
    "id": "item_31043",
    "Last Name": "Daly",
    "First Name": "Caoimhe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256916": {
    "id": "item_13966",
    "Last Name": "YERMAK",
    "First Name": "VOLODYMYR",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257279": {
    "id": "item_1367",
    "Last Name": "Pallone",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257313": {
    "id": "item_31044",
    "Last Name": "Barbera",
    "First Name": "Beau",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257424": {
    "id": "item_28811",
    "Last Name": "Higgins",
    "First Name": "Millie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257487": {
    "id": "item_26399",
    "Last Name": "Yuan",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257549": {
    "id": "item_16301",
    "Last Name": "Lawrence",
    "First Name": "Mat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257611": {
    "id": "item_28812",
    "Last Name": "Harris",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257790": {
    "id": "item_13967",
    "Last Name": "Amador Pinto",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258212": {
    "id": "item_1368",
    "Last Name": "Vearing",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258340": {
    "id": "item_31045",
    "Last Name": "Krait",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258485": {
    "id": "item_13968",
    "Last Name": "Draper",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258498": {
    "id": "item_31046",
    "Last Name": "Goldsworthy",
    "First Name": "Kent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258601": {
    "id": "item_3208",
    "Last Name": "Dawes",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258628": {
    "id": "item_28813",
    "Last Name": "Evett",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258749": {
    "id": "item_31047",
    "Last Name": "McLeod",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258754": {
    "id": "item_31048",
    "Last Name": "Pratt",
    "First Name": "Grant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258770": {
    "id": "item_16302",
    "Last Name": "Mao",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258810": {
    "id": "item_3209",
    "Last Name": "Fraser",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258843": {
    "id": "item_1369",
    "Last Name": "Simes",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258886": {
    "id": "item_28814",
    "Last Name": "SHAH",
    "First Name": "MIT",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38259157": {
    "id": "item_3210",
    "Last Name": "Pham",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38259225": {
    "id": "item_26400",
    "Last Name": "Kuek",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38259677": {
    "id": "item_3211",
    "Last Name": "Cook",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38259717": {
    "id": "item_1370",
    "Last Name": "Patroo",
    "First Name": "Kavi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38259818": {
    "id": "item_16303",
    "Last Name": "Neilhatar",
    "First Name": "Stevano",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38259846": {
    "id": "item_26401",
    "Last Name": "Major",
    "First Name": "Bobby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38260135": {
    "id": "item_31049",
    "Last Name": "Deguilmo",
    "First Name": "Karel Adelbert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38260251": {
    "id": "item_13969",
    "Last Name": "Zuluaga",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38260642": {
    "id": "item_31050",
    "Last Name": "BIN AHMAD MAHADI",
    "First Name": "AHMAD ADIB",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38261259": {
    "id": "item_31051",
    "Last Name": "Aquino",
    "First Name": "Czarina Bianca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38262474": {
    "id": "item_26402",
    "Last Name": "Karim",
    "First Name": "Muhamad Yasir",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38264120": {
    "id": "item_26403",
    "Last Name": "Allsop",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38265483": {
    "id": "item_31052",
    "Last Name": "Lim",
    "First Name": "Wei Ni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38269597": {
    "id": "item_26414",
    "Last Name": "Wagner",
    "First Name": "Shady",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38270662": {
    "id": "item_16310",
    "Last Name": "McWhirter",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38271096": {
    "id": "item_13983",
    "Last Name": "Nguyen",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38281974": {
    "id": "item_26415",
    "Last Name": "Plummer",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38287518": {
    "id": "item_1379",
    "Last Name": "Butalion",
    "First Name": "Thamsanqa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38293065": {
    "id": "item_13984",
    "Last Name": "Petherbridge",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38293695": {
    "id": "item_31058",
    "Last Name": "Berryman",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38294102": {
    "id": "item_28831",
    "Last Name": "Atkin",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38295290": {
    "id": "item_16311",
    "Last Name": "Byron",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38295339": {
    "id": "item_13985",
    "Last Name": "Mike",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38295813": {
    "id": "item_31059",
    "Last Name": "Gruppetta",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38296079": {
    "id": "item_13986",
    "Last Name": "Mackie",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38296120": {
    "id": "item_26416",
    "Last Name": "Wilson",
    "First Name": "Loryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38296704": {
    "id": "item_26417",
    "Last Name": "Hoare",
    "First Name": "Trinity",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38296952": {
    "id": "item_26418",
    "Last Name": "Bey",
    "First Name": "Leyla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38300170": {
    "id": "item_13987",
    "Last Name": "Eleuterio",
    "First Name": "Chester Dave",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38301136": {
    "id": "item_26419",
    "Last Name": "Escobar Eslava",
    "First Name": "Jesus Agust’n",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38301390": {
    "id": "item_3220",
    "Last Name": "Zhakizhanov",
    "First Name": "Bakhtiyar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38301400": {
    "id": "item_13988",
    "Last Name": "SONG",
    "First Name": "xuxiang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302431": {
    "id": "item_13989",
    "Last Name": "Beck",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302443": {
    "id": "item_28832",
    "Last Name": "VICENTE",
    "First Name": "MARCIO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302538": {
    "id": "item_13990",
    "Last Name": "McCabe",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302569": {
    "id": "item_13991",
    "Last Name": "Kemp",
    "First Name": "Mary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302572": {
    "id": "item_26420",
    "Last Name": "Barker",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302588": {
    "id": "item_26421",
    "Last Name": "Bishop",
    "First Name": "Kiani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302629": {
    "id": "item_28833",
    "Last Name": "Wong",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302633": {
    "id": "item_3221",
    "Last Name": "Peacock",
    "First Name": "Malcolm",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302674": {
    "id": "item_26422",
    "Last Name": "Leitb",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302704": {
    "id": "item_28834",
    "Last Name": "Trickett",
    "First Name": "Debbie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302733": {
    "id": "item_3222",
    "Last Name": "Crowther",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302818": {
    "id": "item_1380",
    "Last Name": "Dossanov",
    "First Name": "Assylbek",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302853": {
    "id": "item_28835",
    "Last Name": "Lee",
    "First Name": "Joo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302972": {
    "id": "item_26423",
    "Last Name": "Farhan",
    "First Name": "Dimas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303161": {
    "id": "item_13992",
    "Last Name": "Ortiz",
    "First Name": "Dayal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303234": {
    "id": "item_1382",
    "Last Name": "Gumangan",
    "First Name": "Kevin Ray",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303241": {
    "id": "item_1381",
    "Last Name": "Niethammer",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303342": {
    "id": "item_26424",
    "Last Name": "Aquilo",
    "First Name": "Jhune Harvie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303430": {
    "id": "item_13993",
    "Last Name": "Dhliwayo",
    "First Name": "Munyaradzi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303444": {
    "id": "item_1383",
    "Last Name": "Caceres",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303626": {
    "id": "item_28836",
    "Last Name": "Rendon",
    "First Name": "Juan pablo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303698": {
    "id": "item_26425",
    "Last Name": "Sorych",
    "First Name": "Svetlana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303730": {
    "id": "item_31060",
    "Last Name": "Rowley",
    "First Name": "Glyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303783": {
    "id": "item_28837",
    "Last Name": "Hannan Smith",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303813": {
    "id": "item_16312",
    "Last Name": "Garg",
    "First Name": "Karan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303889": {
    "id": "item_26426",
    "Last Name": "Resco",
    "First Name": "Brix",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303894": {
    "id": "item_26427",
    "Last Name": "Sung",
    "First Name": "Hojin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304012": {
    "id": "item_26428",
    "Last Name": "Huynh",
    "First Name": "Phi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304045": {
    "id": "item_28839",
    "Last Name": "Kumarasamy",
    "First Name": "Shania",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304046": {
    "id": "item_28838",
    "Last Name": "Richards",
    "First Name": "Kori",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304194": {
    "id": "item_13994",
    "Last Name": "Kim",
    "First Name": "Tae",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304252": {
    "id": "item_3223",
    "Last Name": "Musgrove",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304273": {
    "id": "item_16313",
    "Last Name": "Bin Abdul Rahim",
    "First Name": "Muhammad NurulHaq",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304443": {
    "id": "item_28840",
    "Last Name": "Ford",
    "First Name": "Isobel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304506": {
    "id": "item_26429",
    "Last Name": "Bucur",
    "First Name": "Cristina-Iulia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304522": {
    "id": "item_3224",
    "Last Name": "Wesson",
    "First Name": "Murray",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304564": {
    "id": "item_13995",
    "Last Name": "Moosa",
    "First Name": "Hassan Fayaz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304577": {
    "id": "item_28841",
    "Last Name": "Srisailam",
    "First Name": "Ashwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304584": {
    "id": "item_13996",
    "Last Name": "Liston",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304719": {
    "id": "item_26430",
    "Last Name": "Mai",
    "First Name": "Khang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304780": {
    "id": "item_13997",
    "Last Name": "Martin",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304788": {
    "id": "item_16314",
    "Last Name": "Dumael",
    "First Name": "Cedrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304913": {
    "id": "item_26431",
    "Last Name": "Walker",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305029": {
    "id": "item_3225",
    "Last Name": "Mc donald",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305036": {
    "id": "item_26432",
    "Last Name": "Armstrong",
    "First Name": "Justine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305043": {
    "id": "item_16315",
    "Last Name": "Bogdanovic",
    "First Name": "Aleksandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305136": {
    "id": "item_26433",
    "Last Name": "Barker",
    "First Name": "Shanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305159": {
    "id": "item_16316",
    "Last Name": "Kim",
    "First Name": "Bohyun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305256": {
    "id": "item_13998",
    "Last Name": "Scravaglieri",
    "First Name": "Gustavo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305347": {
    "id": "item_1384",
    "Last Name": "Whyte",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305368": {
    "id": "item_13999",
    "Last Name": "Casellas Jr",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305428": {
    "id": "item_26434",
    "Last Name": "ZHUO",
    "First Name": "MING XUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305464": {
    "id": "item_3226",
    "Last Name": "Oberto",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305797": {
    "id": "item_1385",
    "Last Name": "Redondo",
    "First Name": "Stella Maris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38306125": {
    "id": "item_26435",
    "Last Name": "Andromeda Hafiz R",
    "First Name": "Chandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38306172": {
    "id": "item_26436",
    "Last Name": "Osuna",
    "First Name": "Alejandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38306325": {
    "id": "item_26437",
    "Last Name": "Pelongco",
    "First Name": "Neil Angelo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38306596": {
    "id": "item_16317",
    "Last Name": "Dmello",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38308660": {
    "id": "item_28842",
    "Last Name": "Tri Sakti",
    "First Name": "Riyan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38309195": {
    "id": "item_28843",
    "Last Name": "Shetty",
    "First Name": "Adithya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38311995": {
    "id": "item_14000",
    "Last Name": "Martin Moreira Marques",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38314178": {
    "id": "item_14001",
    "Last Name": "Collins",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38320109": {
    "id": "item_1386",
    "Last Name": "Christensen",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38324091": {
    "id": "item_14002",
    "Last Name": "Bryce",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38324210": {
    "id": "item_31061",
    "Last Name": "Gachang0",
    "First Name": "Florence",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38326652": {
    "id": "item_26438",
    "Last Name": "Hoy",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38331332": {
    "id": "item_26439",
    "Last Name": "O'Brien",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38336621": {
    "id": "item_26440",
    "Last Name": "Rigby",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338332": {
    "id": "item_3227",
    "Last Name": "de La Masse-Homsy",
    "First Name": "Xavier-Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338447": {
    "id": "item_1387",
    "Last Name": "Rankin",
    "First Name": "Mack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338454": {
    "id": "item_16318",
    "Last Name": "Cooper",
    "First Name": "Elle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338494": {
    "id": "item_26441",
    "Last Name": "Gray",
    "First Name": "Madison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338664": {
    "id": "item_3228",
    "Last Name": "SALCIDO MARQUEZ",
    "First Name": "JOSE MIGUEL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338737": {
    "id": "item_26442",
    "Last Name": "Schwarz",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338876": {
    "id": "item_26443",
    "Last Name": "Harvey",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38339095": {
    "id": "item_28844",
    "Last Name": "Ghazali",
    "First Name": "Mohammad Firdaus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38339334": {
    "id": "item_1388",
    "Last Name": "Powers",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38339384": {
    "id": "item_26444",
    "Last Name": "tildsley",
    "First Name": "bradley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38339400": {
    "id": "item_28845",
    "Last Name": "Ok",
    "First Name": "Bo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38339722": {
    "id": "item_1389",
    "Last Name": "Ferreira",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340116": {
    "id": "item_3229",
    "Last Name": "Kah Loon",
    "First Name": "Choong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340259": {
    "id": "item_26445",
    "Last Name": "Eldridge",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340316": {
    "id": "item_26446",
    "Last Name": "Rajesh",
    "First Name": "Kausthubram",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340378": {
    "id": "item_26447",
    "Last Name": "Cho",
    "First Name": "Myunggwan (Khan)",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340534": {
    "id": "item_26448",
    "Last Name": "SONG",
    "First Name": "JI HEE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340631": {
    "id": "item_26449",
    "Last Name": "Morales",
    "First Name": "Jude Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340928": {
    "id": "item_3230",
    "Last Name": "Maganaka",
    "First Name": "Almer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38341039": {
    "id": "item_28846",
    "Last Name": "Maher",
    "First Name": "Owen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38341041": {
    "id": "item_14003",
    "Last Name": "Gabor",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38341218": {
    "id": "item_28847",
    "Last Name": "Nugent",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38406717": {
    "id": "item_14004",
    "Last Name": "Frew",
    "First Name": "Stef",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38450421": {
    "id": "item_1390",
    "Last Name": "Sullivan",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38451117": {
    "id": "item_31062",
    "Last Name": "Dasgupta",
    "First Name": "Protip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38452997": {
    "id": "item_26450",
    "Last Name": "Ibe",
    "First Name": "Christian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38461405": {
    "id": "item_26451",
    "Last Name": "Gray",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38462484": {
    "id": "item_26452",
    "Last Name": "Gwambe",
    "First Name": "Yolanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38488706": {
    "id": "item_28881",
    "Last Name": "Khourn",
    "First Name": "Vicheka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38523690": {
    "id": "item_26510",
    "Last Name": "Forlin",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38527842": {
    "id": "item_26511",
    "Last Name": "Cu–a",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38528122": {
    "id": "item_28882",
    "Last Name": "Riadhi",
    "First Name": "Muhammad Rivi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38529563": {
    "id": "item_28883",
    "Last Name": "Santoso",
    "First Name": "Gunawan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38531331": {
    "id": "item_26512",
    "Last Name": "BANEZ",
    "First Name": "JONATHAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38531549": {
    "id": "item_26513",
    "Last Name": "Ganesh",
    "First Name": "Athalanallur Raman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38531834": {
    "id": "item_1435",
    "Last Name": "Nev‡rez",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532163": {
    "id": "item_16336",
    "Last Name": "Fu",
    "First Name": "Li-fan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532272": {
    "id": "item_14056",
    "Last Name": "Kabylov",
    "First Name": "Baurzhan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532321": {
    "id": "item_28884",
    "Last Name": "Coghlan",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532368": {
    "id": "item_28885",
    "Last Name": "Ekins-Daukes",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532387": {
    "id": "item_14055",
    "Last Name": "Bell",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532415": {
    "id": "item_26514",
    "Last Name": "Woods",
    "First Name": "Greg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532419": {
    "id": "item_26515",
    "Last Name": "Tziavaras",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532421": {
    "id": "item_1436",
    "Last Name": "Sutton",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533055": {
    "id": "item_28886",
    "Last Name": "Hyde",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533348": {
    "id": "item_26516",
    "Last Name": "Cauilan",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533405": {
    "id": "item_14057",
    "Last Name": "Champness",
    "First Name": "Barton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533575": {
    "id": "item_26517",
    "Last Name": "Erwin",
    "First Name": "Cale",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533666": {
    "id": "item_26518",
    "Last Name": "Leckie-Hefford",
    "First Name": "Kayla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533943": {
    "id": "item_1437",
    "Last Name": "Kunanbayev",
    "First Name": "Timur",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533969": {
    "id": "item_26519",
    "Last Name": "Mulla",
    "First Name": "Suleman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38534516": {
    "id": "item_14058",
    "Last Name": "Uppal",
    "First Name": "Jaspreet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38534522": {
    "id": "item_26520",
    "Last Name": "Sokolova",
    "First Name": "Oxana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536011": {
    "id": "item_14059",
    "Last Name": "Duda",
    "First Name": "Maxim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536299": {
    "id": "item_26521",
    "Last Name": "IWATAKE",
    "First Name": "YUTO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536424": {
    "id": "item_1438",
    "Last Name": "Fisher",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536520": {
    "id": "item_3265",
    "Last Name": "Day",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536624": {
    "id": "item_1439",
    "Last Name": "Bustamante Teran",
    "First Name": "Raul Alejandro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536759": {
    "id": "item_1440",
    "Last Name": "Skipper",
    "First Name": "Rose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536855": {
    "id": "item_26522",
    "Last Name": "Fong",
    "First Name": "Chui shan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38537747": {
    "id": "item_28887",
    "Last Name": "Xue",
    "First Name": "Jingheng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38537862": {
    "id": "item_1441",
    "Last Name": "Weightman",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38537941": {
    "id": "item_26523",
    "Last Name": "SEAH",
    "First Name": "KWEE PENG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38538570": {
    "id": "item_1442",
    "Last Name": "Fernandes",
    "First Name": "Eduardo D ambrosio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38538852": {
    "id": "item_26524",
    "Last Name": "Miyamoto",
    "First Name": "Simone",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38539280": {
    "id": "item_14060",
    "Last Name": "dempsey",
    "First Name": "martin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38539453": {
    "id": "item_26525",
    "Last Name": "Wilson",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38539653": {
    "id": "item_28888",
    "Last Name": "Ruge",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38540249": {
    "id": "item_26526",
    "Last Name": "Zapata Riveros",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38542514": {
    "id": "item_14061",
    "Last Name": "Mathurin",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38544211": {
    "id": "item_14062",
    "Last Name": "Hsu",
    "First Name": "JoYun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38547651": {
    "id": "item_14063",
    "Last Name": "Bett",
    "First Name": "Benard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38547912": {
    "id": "item_28889",
    "Last Name": "San Narciso Sosa",
    "First Name": "Ana Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38553827": {
    "id": "item_14064",
    "Last Name": "Stefanova",
    "First Name": "Velislava",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38554238": {
    "id": "item_3266",
    "Last Name": "Ng",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38559226": {
    "id": "item_1443",
    "Last Name": "WANG",
    "First Name": "XIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38560006": {
    "id": "item_14065",
    "Last Name": "Pearson",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38561431": {
    "id": "item_26527",
    "Last Name": "Morris",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38561819": {
    "id": "item_26528",
    "Last Name": "Robbins",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38565101": {
    "id": "item_31072",
    "Last Name": "CHAE",
    "First Name": "GYURIM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38565742": {
    "id": "item_14066",
    "Last Name": "Yang",
    "First Name": "An-Hue",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38588505": {
    "id": "item_16337",
    "Last Name": "Makhija",
    "First Name": "Mahek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38592852": {
    "id": "item_28890",
    "Last Name": "Longbottom",
    "First Name": "Margo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38593573": {
    "id": "item_3267",
    "Last Name": "Wyatt",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38594351": {
    "id": "item_26529",
    "Last Name": "Insall",
    "First Name": "Lochlan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38595128": {
    "id": "item_28891",
    "Last Name": "Gremmel",
    "First Name": "Suhela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38595463": {
    "id": "item_26530",
    "Last Name": "Yazawa",
    "First Name": "Jose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38596150": {
    "id": "item_3268",
    "Last Name": "Kong",
    "First Name": "Hongting",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38638541": {
    "id": "item_28892",
    "Last Name": "Beesley",
    "First Name": "Annika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38642994": {
    "id": "item_3269",
    "Last Name": "Lloyd",
    "First Name": "Kendall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38659275": {
    "id": "item_26531",
    "Last Name": "Pileggi",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38659655": {
    "id": "item_26532",
    "Last Name": "Newman",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38659820": {
    "id": "item_28893",
    "Last Name": "Gould",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38660462": {
    "id": "item_1444",
    "Last Name": "Trang",
    "First Name": "Minh Dat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38660514": {
    "id": "item_28894",
    "Last Name": "MacDonald",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38661649": {
    "id": "item_14067",
    "Last Name": "Doyle",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38662318": {
    "id": "item_26533",
    "Last Name": "Birch",
    "First Name": "Toby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38662597": {
    "id": "item_28895",
    "Last Name": "Zou",
    "First Name": "Hao Xian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38663484": {
    "id": "item_3270",
    "Last Name": "Browne",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38681235": {
    "id": "item_26534",
    "Last Name": "Robertson",
    "First Name": "Dean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38681352": {
    "id": "item_28896",
    "Last Name": "Haines",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38681684": {
    "id": "item_16338",
    "Last Name": "safari",
    "First Name": "remmy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38728673": {
    "id": "item_3272",
    "Last Name": "LUNDQUIST",
    "First Name": "LETTY",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38836072": {
    "id": "item_14068",
    "Last Name": "Hawthorne",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38853608": {
    "id": "item_14069",
    "Last Name": "Scofield",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38857464": {
    "id": "item_1445",
    "Last Name": "MENG",
    "First Name": "JIAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38859887": {
    "id": "item_26535",
    "Last Name": "Leverich",
    "First Name": "Ann",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38904536": {
    "id": "item_14070",
    "Last Name": "O'Brien",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38909565": {
    "id": "item_14071",
    "Last Name": "Taylor",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38910791": {
    "id": "item_26536",
    "Last Name": "Gilligan",
    "First Name": "Molly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38952658": {
    "id": "item_28897",
    "Last Name": "Sandritter",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39008335": {
    "id": "item_14072",
    "Last Name": "Exeni",
    "First Name": "Mario Jesus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39022979": {
    "id": "item_16339",
    "Last Name": "Dunlop",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39071807": {
    "id": "item_3273",
    "Last Name": "McGrath",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39073582": {
    "id": "item_26537",
    "Last Name": "Caruso",
    "First Name": "Daniela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39075111": {
    "id": "item_26538",
    "Last Name": "Hamilton-Smith",
    "First Name": "Nick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39075170": {
    "id": "item_16340",
    "Last Name": "Williams",
    "First Name": "Renee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39077219": {
    "id": "item_3274",
    "Last Name": "Vidoli",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39095966": {
    "id": "item_16341",
    "Last Name": "Martin",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39115259": {
    "id": "item_14073",
    "Last Name": "Brandt",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39124213": {
    "id": "item_28898",
    "Last Name": "Von Appen",
    "First Name": "Chantelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39124226": {
    "id": "item_3275",
    "Last Name": "Kuryla",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39124321": {
    "id": "item_1446",
    "Last Name": "Brands",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39125175": {
    "id": "item_31073",
    "Last Name": "Bhonagiri",
    "First Name": "Deepak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39127919": {
    "id": "item_1447",
    "Last Name": "Zofrea",
    "First Name": "Vincenzo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39130722": {
    "id": "item_26539",
    "Last Name": "Bontaites",
    "First Name": "AnneMette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39133754": {
    "id": "item_31074",
    "Last Name": "Saliba",
    "First Name": "Maryanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39134862": {
    "id": "item_28899",
    "Last Name": "ROJAS",
    "First Name": "Tatiana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39164236": {
    "id": "item_31075",
    "Last Name": "Geyer",
    "First Name": "Hendrik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39164266": {
    "id": "item_28900",
    "Last Name": "Burgess",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39168756": {
    "id": "item_16342",
    "Last Name": "Martin",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39172173": {
    "id": "item_26540",
    "Last Name": "Williams",
    "First Name": "Adrienne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39245921": {
    "id": "item_26541",
    "Last Name": "Power",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39248647": {
    "id": "item_14074",
    "Last Name": "Cross",
    "First Name": "Alexi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39267941": {
    "id": "item_3276",
    "Last Name": "Baldassari",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39277149": {
    "id": "item_1448",
    "Last Name": "Wright",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39296433": {
    "id": "item_3277",
    "Last Name": "Nguyen",
    "First Name": "Tommy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39305313": {
    "id": "item_31076",
    "Last Name": "Threm",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39341340": {
    "id": "item_28901",
    "Last Name": "Boston",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39343625": {
    "id": "item_28902",
    "Last Name": "Shelley",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39358604": {
    "id": "item_26542",
    "Last Name": "Bartzoulianos",
    "First Name": "Nikolaos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39359248": {
    "id": "item_26543",
    "Last Name": "Devine",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39362064": {
    "id": "item_28903",
    "Last Name": "Kamath",
    "First Name": "Rama",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39402218": {
    "id": "item_28904",
    "Last Name": "Jones",
    "First Name": "Peta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39402663": {
    "id": "item_26544",
    "Last Name": "Stricher",
    "First Name": "Fanny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39405000": {
    "id": "item_16343",
    "Last Name": "Gilfillan",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39406698": {
    "id": "item_3278",
    "Last Name": "Bembrick",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39406906": {
    "id": "item_26545",
    "Last Name": "Mathers",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39441853": {
    "id": "item_14075",
    "Last Name": "Umana",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39483114": {
    "id": "item_3279",
    "Last Name": "Lee",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39483633": {
    "id": "item_14076",
    "Last Name": "Gerber",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39484245": {
    "id": "item_28905",
    "Last Name": "Antico",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39484542": {
    "id": "item_16344",
    "Last Name": "Crofoot",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39484917": {
    "id": "item_3280",
    "Last Name": "Tretheway",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39486690": {
    "id": "item_1449",
    "Last Name": "Thomas",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39487552": {
    "id": "item_1450",
    "Last Name": "Dawes",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39487908": {
    "id": "item_14077",
    "Last Name": "Coelho",
    "First Name": "Julien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39489489": {
    "id": "item_3281",
    "Last Name": "Stallard",
    "First Name": "Jaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39515153": {
    "id": "item_14078",
    "Last Name": "Ryan",
    "First Name": "Kerrie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39516360": {
    "id": "item_14079",
    "Last Name": "Froelich",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39524189": {
    "id": "item_31077",
    "Last Name": "Ryan",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39525696": {
    "id": "item_28906",
    "Last Name": "Nichols",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39570009": {
    "id": "item_14080",
    "Last Name": "Scott",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39572025": {
    "id": "item_1451",
    "Last Name": "Yeleswarapu",
    "First Name": "Abhishek",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39579539": {
    "id": "item_26546",
    "Last Name": "HUANG",
    "First Name": "YIPEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39583392": {
    "id": "item_26547",
    "Last Name": "Fatemi",
    "First Name": "Fariba",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39588036": {
    "id": "item_14081",
    "Last Name": "Murphy",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39591134": {
    "id": "item_26548",
    "Last Name": "Novakovic",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39591615": {
    "id": "item_1452",
    "Last Name": "Hyde",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39616623": {
    "id": "item_1453",
    "Last Name": "Pinillos Villaescusa",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39668221": {
    "id": "item_16345",
    "Last Name": "Stachowiak",
    "First Name": "Kasia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39671368": {
    "id": "item_28907",
    "Last Name": "Singh",
    "First Name": "Harmander",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39673094": {
    "id": "item_28908",
    "Last Name": "Talewar",
    "First Name": "Ghanaya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39674455": {
    "id": "item_26549",
    "Last Name": "Kaur",
    "First Name": "Gursharan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39675208": {
    "id": "item_26550",
    "Last Name": "Kaur",
    "First Name": "Umandeep",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39687943": {
    "id": "item_14082",
    "Last Name": "Aryal",
    "First Name": "Saurav",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39688785": {
    "id": "item_1454",
    "Last Name": "Regmi Sigdel",
    "First Name": "Tej Maya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39697694": {
    "id": "item_28909",
    "Last Name": "Gurung",
    "First Name": "Sony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39707785": {
    "id": "item_26551",
    "Last Name": "Murray",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39718323": {
    "id": "item_1455",
    "Last Name": "Zaidi",
    "First Name": "Aylia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39718369": {
    "id": "item_3282",
    "Last Name": "Khan",
    "First Name": "Jamal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39719666": {
    "id": "item_1456",
    "Last Name": "Atef",
    "First Name": "Mohammad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39720520": {
    "id": "item_14083",
    "Last Name": "Zaffar",
    "First Name": "Imran",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39722435": {
    "id": "item_1457",
    "Last Name": "Ebrahim",
    "First Name": "Raees",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39729225": {
    "id": "item_28910",
    "Last Name": "Saeed",
    "First Name": "Sadaf",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39732076": {
    "id": "item_1458",
    "Last Name": "Qureshi",
    "First Name": "Fahad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39784378": {
    "id": "item_16346",
    "Last Name": "O'Brien",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39785420": {
    "id": "item_3283",
    "Last Name": "Mumtaz",
    "First Name": "Ammar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39789746": {
    "id": "item_14084",
    "Last Name": "Karim",
    "First Name": "Omar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39790688": {
    "id": "item_3284",
    "Last Name": "Azhar",
    "First Name": "Rehman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39797740": {
    "id": "item_31078",
    "Last Name": "Miah",
    "First Name": "Shakil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39801076": {
    "id": "item_26552",
    "Last Name": "Standish",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39801627": {
    "id": "item_26553",
    "Last Name": "Cai",
    "First Name": "Jiaqi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39808931": {
    "id": "item_1459",
    "Last Name": "Goldsmith",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39810131": {
    "id": "item_1460",
    "Last Name": "Ehsan",
    "First Name": "Bilal",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39912038": {
    "id": "item_26554",
    "Last Name": "Richards",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39933453": {
    "id": "item_26555",
    "Last Name": "Davis",
    "First Name": "Scot",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39933477": {
    "id": "item_14085",
    "Last Name": "Taber",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39941272": {
    "id": "item_31079",
    "Last Name": "Maher",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39960276": {
    "id": "item_14086",
    "Last Name": "Rafferty",
    "First Name": "Lily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39969790": {
    "id": "item_31080",
    "Last Name": "Najjarine",
    "First Name": "Hassan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39972988": {
    "id": "item_26556",
    "Last Name": "Smith",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39973783": {
    "id": "item_28911",
    "Last Name": "Martelino",
    "First Name": "Raymund",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39974011": {
    "id": "item_16347",
    "Last Name": "Olonan",
    "First Name": "Erick Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39974059": {
    "id": "item_14087",
    "Last Name": "Chew",
    "First Name": "Yung Chai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39976413": {
    "id": "item_26557",
    "Last Name": "Gorriceta",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40010024": {
    "id": "item_1461",
    "Last Name": "Bell",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40010772": {
    "id": "item_26558",
    "Last Name": "Kaadan",
    "First Name": "Nasreen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40010982": {
    "id": "item_26559",
    "Last Name": "Kassoua",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40021808": {
    "id": "item_26560",
    "Last Name": "Corry",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40023604": {
    "id": "item_16348",
    "Last Name": "Norrington",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40028456": {
    "id": "item_26561",
    "Last Name": "Henson",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40039409": {
    "id": "item_26562",
    "Last Name": "Daking",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40056597": {
    "id": "item_28912",
    "Last Name": "Matthews",
    "First Name": "Ayenza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40073598": {
    "id": "item_1462",
    "Last Name": "Schoon",
    "First Name": "Amaury",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40074962": {
    "id": "item_14088",
    "Last Name": "Kumar",
    "First Name": "Akash",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40103594": {
    "id": "item_14089",
    "Last Name": "James",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40105883": {
    "id": "item_28913",
    "Last Name": "Joyan",
    "First Name": "Summer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40120031": {
    "id": "item_26563",
    "Last Name": "Samandar",
    "First Name": "Samer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40129820": {
    "id": "item_1463",
    "Last Name": "Cadena Santillana",
    "First Name": "Armando",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40151854": {
    "id": "item_3285",
    "Last Name": "Wheeler",
    "First Name": "Dwayne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40160259": {
    "id": "item_28914",
    "Last Name": "ADDISON",
    "First Name": "SUZANNE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40168889": {
    "id": "item_28915",
    "Last Name": "Thio",
    "First Name": "Fredy Eriady",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40200164": {
    "id": "item_14090",
    "Last Name": "Saliba",
    "First Name": "Anton",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40201948": {
    "id": "item_28916",
    "Last Name": "McCormack",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40204275": {
    "id": "item_28917",
    "Last Name": "Trew",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40210074": {
    "id": "item_31081",
    "Last Name": "Burke",
    "First Name": "Allysa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40211248": {
    "id": "item_3286",
    "Last Name": "Uddin",
    "First Name": "Maeen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40216660": {
    "id": "item_1464",
    "Last Name": "Gupta",
    "First Name": "Mary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40238283": {
    "id": "item_26564",
    "Last Name": "Williams",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40240656": {
    "id": "item_28918",
    "Last Name": "Graham",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40242614": {
    "id": "item_14091",
    "Last Name": "Bierman",
    "First Name": "Brock",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40323399": {
    "id": "item_26565",
    "Last Name": "Rajagopalan",
    "First Name": "Suresh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40328843": {
    "id": "item_3287",
    "Last Name": "Rawls",
    "First Name": "Asia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40329565": {
    "id": "item_31082",
    "Last Name": "Huvaere",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40331101": {
    "id": "item_16349",
    "Last Name": "Smith",
    "First Name": "Tenia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40331589": {
    "id": "item_26566",
    "Last Name": "McAtee-Papineni",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40337931": {
    "id": "item_28919",
    "Last Name": "Moran",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40340053": {
    "id": "item_14092",
    "Last Name": "Collins",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40410997": {
    "id": "item_3288",
    "Last Name": "Fox-Williams",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40450684": {
    "id": "item_26567",
    "Last Name": "Norbury",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40456920": {
    "id": "item_14093",
    "Last Name": "Chung",
    "First Name": "Chengchin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40460393": {
    "id": "item_28920",
    "Last Name": "Craven",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40491613": {
    "id": "item_14094",
    "Last Name": "Alvarez",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40501644": {
    "id": "item_14095",
    "Last Name": "LePinske",
    "First Name": "Jerry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40501797": {
    "id": "item_28921",
    "Last Name": "Waite",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40516797": {
    "id": "item_16350",
    "Last Name": "Webster",
    "First Name": "Nguyen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40538689": {
    "id": "item_26568",
    "Last Name": "Rey",
    "First Name": "Wilson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40540536": {
    "id": "item_26569",
    "Last Name": "Hanrahan",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40560660": {
    "id": "item_28922",
    "Last Name": "McAvoy",
    "First Name": "Ross",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40589117": {
    "id": "item_1465",
    "Last Name": "Hester",
    "First Name": "Lily Grace",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40693368": {
    "id": "item_26570",
    "Last Name": "Younas",
    "First Name": "Zain",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40712436": {
    "id": "item_26571",
    "Last Name": "Johnson",
    "First Name": "Margaret \"Peggy\"",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40728704": {
    "id": "item_3289",
    "Last Name": "Greenberg",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40742309": {
    "id": "item_26572",
    "Last Name": "Thompson",
    "First Name": "Carly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40850680": {
    "id": "item_3290",
    "Last Name": "Martinez",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40858761": {
    "id": "item_28923",
    "Last Name": "Lai",
    "First Name": "Evan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40874358": {
    "id": "item_26573",
    "Last Name": "Hoey",
    "First Name": "Nora",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40907444": {
    "id": "item_26574",
    "Last Name": "Karandrews",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40909258": {
    "id": "item_16351",
    "Last Name": "Holmes",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40909397": {
    "id": "item_14096",
    "Last Name": "Robinson",
    "First Name": "Caoimhe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40909659": {
    "id": "item_3291",
    "Last Name": "Nethery",
    "First Name": "Alec",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40909728": {
    "id": "item_14097",
    "Last Name": "Hoccom",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40910269": {
    "id": "item_14098",
    "Last Name": "Murchie",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40911259": {
    "id": "item_14099",
    "Last Name": "Ourabi",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40911626": {
    "id": "item_18563",
    "Last Name": "Green",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40913885": {
    "id": "item_14100",
    "Last Name": "Kapetas",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40914555": {
    "id": "item_14101",
    "Last Name": "Cullen",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40915076": {
    "id": "item_28924",
    "Last Name": "mcsorley",
    "First Name": "sinead",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40922452": {
    "id": "item_3292",
    "Last Name": "Tadros",
    "First Name": "Bishoy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40922716": {
    "id": "item_14102",
    "Last Name": "Tuttle",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40923390": {
    "id": "item_14103",
    "Last Name": "Lux",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40924869": {
    "id": "item_28925",
    "Last Name": "moryl",
    "First Name": "george",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40947835": {
    "id": "item_1466",
    "Last Name": "Ribeiro",
    "First Name": "Ana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40951008": {
    "id": "item_28926",
    "Last Name": "Hlywa",
    "First Name": "Brett",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40951592": {
    "id": "item_26575",
    "Last Name": "Ragon",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40952366": {
    "id": "item_14104",
    "Last Name": "Greenwood",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40954161": {
    "id": "item_1467",
    "Last Name": "Zhang",
    "First Name": "Yu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40955539": {
    "id": "item_14105",
    "Last Name": "Lambino",
    "First Name": "Miko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40955820": {
    "id": "item_28927",
    "Last Name": "Kruh",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40957187": {
    "id": "item_3293",
    "Last Name": "Byrne",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40959732": {
    "id": "item_3294",
    "Last Name": "Loo",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40988785": {
    "id": "item_1468",
    "Last Name": "Smith",
    "First Name": "Cian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40993489": {
    "id": "item_3295",
    "Last Name": "Martin",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41001174": {
    "id": "item_1469",
    "Last Name": "Cook",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41004308": {
    "id": "item_3296",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41004551": {
    "id": "item_1470",
    "Last Name": "Ballantine",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41004842": {
    "id": "item_26576",
    "Last Name": "Douse",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41039917": {
    "id": "item_16352",
    "Last Name": "Stepanoff",
    "First Name": "Theodore",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41070554": {
    "id": "item_16353",
    "Last Name": "Marchiori",
    "First Name": "Rosalia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41082393": {
    "id": "item_26577",
    "Last Name": "Panagiotopoulos",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41083610": {
    "id": "item_26578",
    "Last Name": "Halili",
    "First Name": "Emerson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41085812": {
    "id": "item_3297",
    "Last Name": "Fedirchuk",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41085862": {
    "id": "item_16354",
    "Last Name": "Wilson",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41092711": {
    "id": "item_28928",
    "Last Name": "Richards-Kamara",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41095248": {
    "id": "item_26579",
    "Last Name": "Long",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41157250": {
    "id": "item_16355",
    "Last Name": "Suero",
    "First Name": "Israel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41161260": {
    "id": "item_1471",
    "Last Name": "reda",
    "First Name": "kimberly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41163908": {
    "id": "item_31083",
    "Last Name": "Almir",
    "First Name": "Jana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41164013": {
    "id": "item_26580",
    "Last Name": "Rafferty",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41166939": {
    "id": "item_1472",
    "Last Name": "Reilly",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41167161": {
    "id": "item_14106",
    "Last Name": "Armstrong",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41167328": {
    "id": "item_28929",
    "Last Name": "Cowan",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41168143": {
    "id": "item_28930",
    "Last Name": "Sutton",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41171965": {
    "id": "item_26581",
    "Last Name": "Scelzo",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41172820": {
    "id": "item_26582",
    "Last Name": "Reen",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41175734": {
    "id": "item_31084",
    "Last Name": "Hoffman",
    "First Name": "Lindsey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41194504": {
    "id": "item_16356",
    "Last Name": "Kiefer",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41205845": {
    "id": "item_14107",
    "Last Name": "Hannaford",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41205902": {
    "id": "item_28931",
    "Last Name": "Joyce",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41207044": {
    "id": "item_14108",
    "Last Name": "Han",
    "First Name": "Haihua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41209925": {
    "id": "item_26583",
    "Last Name": "Cahill",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41213247": {
    "id": "item_14109",
    "Last Name": "Carrick",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41213863": {
    "id": "item_1473",
    "Last Name": "Kaijser",
    "First Name": "Jens Olof Rolf",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41214876": {
    "id": "item_28932",
    "Last Name": "Perez",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41216413": {
    "id": "item_14110",
    "Last Name": "Spoczynski",
    "First Name": "Michal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41216801": {
    "id": "item_1474",
    "Last Name": "Pylypchuk",
    "First Name": "Iurii",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41217351": {
    "id": "item_1475",
    "Last Name": "Tytianevych",
    "First Name": "Liubov",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41237887": {
    "id": "item_3298",
    "Last Name": "Murphy-Kusins",
    "First Name": "Mara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41252126": {
    "id": "item_3299",
    "Last Name": "Kreter",
    "First Name": "Molly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41257940": {
    "id": "item_26584",
    "Last Name": "Nugent",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41258758": {
    "id": "item_14111",
    "Last Name": "Green",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41261702": {
    "id": "item_26585",
    "Last Name": "Kenney",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41323988": {
    "id": "item_14112",
    "Last Name": "Vaschetti",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41364337": {
    "id": "item_3300",
    "Last Name": "Wilson",
    "First Name": "Rebekah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41365158": {
    "id": "item_14113",
    "Last Name": "Redenius",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41365183": {
    "id": "item_26586",
    "Last Name": "Kelso",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41365612": {
    "id": "item_28933",
    "Last Name": "Arroyo",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41471582": {
    "id": "item_1476",
    "Last Name": "Martin",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41486590": {
    "id": "item_26587",
    "Last Name": "d'Hemecourt",
    "First Name": "Pierre",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41496744": {
    "id": "item_14114",
    "Last Name": "Meister",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41502467": {
    "id": "item_31085",
    "Last Name": "Kinsella",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41503093": {
    "id": "item_14115",
    "Last Name": "Vaughan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41510500": {
    "id": "item_26588",
    "Last Name": "Samuels",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41511883": {
    "id": "item_3301",
    "Last Name": "Baird Walsh",
    "First Name": "Jess",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41513069": {
    "id": "item_3302",
    "Last Name": "Katris",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41513301": {
    "id": "item_1477",
    "Last Name": "Dunlop",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41515275": {
    "id": "item_28934",
    "Last Name": "Katris",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41523196": {
    "id": "item_14116",
    "Last Name": "LEE",
    "First Name": "YUE HON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41524723": {
    "id": "item_26589",
    "Last Name": "Gurung",
    "First Name": "Wongma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41541306": {
    "id": "item_14117",
    "Last Name": "Jacques",
    "First Name": "Imogen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41543077": {
    "id": "item_26590",
    "Last Name": "LI",
    "First Name": "OI SHUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41555971": {
    "id": "item_14118",
    "Last Name": "Inocencio",
    "First Name": "Krisha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41558509": {
    "id": "item_26591",
    "Last Name": "Meriden",
    "First Name": "Ala Aldin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41599291": {
    "id": "item_28935",
    "Last Name": "Bernasor-Bautista",
    "First Name": "Maila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41631523": {
    "id": "item_26592",
    "Last Name": "McBryde",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41635906": {
    "id": "item_14119",
    "Last Name": "Natalia",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41637409": {
    "id": "item_14120",
    "Last Name": "Kochanowicz",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41637829": {
    "id": "item_14121",
    "Last Name": "Corriveau",
    "First Name": "Larissa Catherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41638479": {
    "id": "item_14122",
    "Last Name": "Coburn",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41648514": {
    "id": "item_26593",
    "Last Name": "MCLAUGHLIN",
    "First Name": "KAYLA JANE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41652053": {
    "id": "item_26594",
    "Last Name": "Golson",
    "First Name": "Kelly Jo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41672549": {
    "id": "item_26595",
    "Last Name": "Lee",
    "First Name": "Dru",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41680207": {
    "id": "item_14123",
    "Last Name": "Warren",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41687850": {
    "id": "item_26596",
    "Last Name": "Perin",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41688820": {
    "id": "item_26597",
    "Last Name": "PADILLA PRATT",
    "First Name": "GUSTAVO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41692522": {
    "id": "item_26598",
    "Last Name": "Gooch",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41693066": {
    "id": "item_31086",
    "Last Name": "Holmes",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41693195": {
    "id": "item_26599",
    "Last Name": "Christy",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41694182": {
    "id": "item_26600",
    "Last Name": "Powell",
    "First Name": "Sue",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41695478": {
    "id": "item_26601",
    "Last Name": "Holmes",
    "First Name": "Fred",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41717142": {
    "id": "item_26602",
    "Last Name": "Moser",
    "First Name": "Alyssa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41727263": {
    "id": "item_1478",
    "Last Name": "Newling",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41743253": {
    "id": "item_14124",
    "Last Name": "Ryan",
    "First Name": "Annemarie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41753468": {
    "id": "item_3303",
    "Last Name": "Tornaros",
    "First Name": "Peta",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41763535": {
    "id": "item_1479",
    "Last Name": "McKinnon",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41781104": {
    "id": "item_14125",
    "Last Name": "Taylor",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41781223": {
    "id": "item_14126",
    "Last Name": "Taylor",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41786770": {
    "id": "item_14127",
    "Last Name": "McNutt",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41787064": {
    "id": "item_16357",
    "Last Name": "Escude",
    "First Name": "Clay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41788261": {
    "id": "item_26603",
    "Last Name": "Blackwell",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41789051": {
    "id": "item_26604",
    "Last Name": "Villar",
    "First Name": "Carol",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41789129": {
    "id": "item_28936",
    "Last Name": "Begonja",
    "First Name": "Lucija",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41790725": {
    "id": "item_1480",
    "Last Name": "Cadigan",
    "First Name": "Christen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41791828": {
    "id": "item_28937",
    "Last Name": "Gill",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41791996": {
    "id": "item_14128",
    "Last Name": "Pick",
    "First Name": "Myles",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41796369": {
    "id": "item_3304",
    "Last Name": "Mullen",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41796561": {
    "id": "item_26605",
    "Last Name": "Deng",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41796650": {
    "id": "item_14129",
    "Last Name": "Sargent",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41796668": {
    "id": "item_26606",
    "Last Name": "Collum",
    "First Name": "Murray",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41796991": {
    "id": "item_28938",
    "Last Name": "Johnson",
    "First Name": "Troy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41797043": {
    "id": "item_1481",
    "Last Name": "Michelmore",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41797481": {
    "id": "item_14130",
    "Last Name": "Carloss",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41798953": {
    "id": "item_3305",
    "Last Name": "Bennett",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41825983": {
    "id": "item_26607",
    "Last Name": "Stevens",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41827364": {
    "id": "item_28939",
    "Last Name": "Costandi",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41831624": {
    "id": "item_26608",
    "Last Name": "Mitschke",
    "First Name": "Susanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41846480": {
    "id": "item_28940",
    "Last Name": "Husby",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41872785": {
    "id": "item_28941",
    "Last Name": "Estevez",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41882278": {
    "id": "item_26609",
    "Last Name": "Nillo",
    "First Name": "Anna Katrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41885929": {
    "id": "item_16358",
    "Last Name": "Li",
    "First Name": "Debbie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41888600": {
    "id": "item_1482",
    "Last Name": "Burley",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41889557": {
    "id": "item_28942",
    "Last Name": "Hampton",
    "First Name": "Renee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41890559": {
    "id": "item_1483",
    "Last Name": "Chebl",
    "First Name": "Rana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41892202": {
    "id": "item_1484",
    "Last Name": "Cunningham",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41893106": {
    "id": "item_14131",
    "Last Name": "Klukas",
    "First Name": "Henri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41893625": {
    "id": "item_16359",
    "Last Name": "Wax",
    "First Name": "Becky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41914243": {
    "id": "item_16360",
    "Last Name": "Paukner",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41925526": {
    "id": "item_26610",
    "Last Name": "Riley",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41931013": {
    "id": "item_26611",
    "Last Name": "Wang",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41946670": {
    "id": "item_1485",
    "Last Name": "Silverman",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41949710": {
    "id": "item_31087",
    "Last Name": "Rowley",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41964762": {
    "id": "item_26612",
    "Last Name": "Tai",
    "First Name": "Kuangkai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41974946": {
    "id": "item_28943",
    "Last Name": "See",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41975770": {
    "id": "item_14132",
    "Last Name": "Khatu",
    "First Name": "Devesh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41975895": {
    "id": "item_16361",
    "Last Name": "Hounslow",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41982045": {
    "id": "item_16362",
    "Last Name": "Kozlowski",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41991443": {
    "id": "item_26613",
    "Last Name": "buckley",
    "First Name": "karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41995688": {
    "id": "item_1486",
    "Last Name": "RO",
    "First Name": "SEAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41996080": {
    "id": "item_3306",
    "Last Name": "Wu",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41999977": {
    "id": "item_1487",
    "Last Name": "Ulloa",
    "First Name": "Amado",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42009029": {
    "id": "item_16363",
    "Last Name": "Baker",
    "First Name": "Elisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42024573": {
    "id": "item_3307",
    "Last Name": "Mulcahy",
    "First Name": "Pete",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42050632": {
    "id": "item_3308",
    "Last Name": "Dominish",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42051097": {
    "id": "item_1488",
    "Last Name": "Parker",
    "First Name": "Sameer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42051400": {
    "id": "item_1489",
    "Last Name": "Constable",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42052998": {
    "id": "item_26614",
    "Last Name": "Gourani",
    "First Name": "Eman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42057631": {
    "id": "item_26615",
    "Last Name": "Patacsil",
    "First Name": "Charissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42059166": {
    "id": "item_1490",
    "Last Name": "Sugiyanto",
    "First Name": "Andi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42072961": {
    "id": "item_26616",
    "Last Name": "Zhang",
    "First Name": "Gang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42074229": {
    "id": "item_26617",
    "Last Name": "Regan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42075593": {
    "id": "item_26618",
    "Last Name": "Armstrong",
    "First Name": "Chantelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42077918": {
    "id": "item_3309",
    "Last Name": "Haldane",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42079831": {
    "id": "item_14133",
    "Last Name": "Chippendale",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42080278": {
    "id": "item_3310",
    "Last Name": "LIANG",
    "First Name": "HAN YUAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42081821": {
    "id": "item_14134",
    "Last Name": "Robinson",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42085545": {
    "id": "item_1491",
    "Last Name": "Breuche",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42088934": {
    "id": "item_26619",
    "Last Name": "Carnes",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42090057": {
    "id": "item_3311",
    "Last Name": "Walker",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42091761": {
    "id": "item_3312",
    "Last Name": "pier",
    "First Name": "dana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42092334": {
    "id": "item_14135",
    "Last Name": "Thomas",
    "First Name": "Christan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42128822": {
    "id": "item_26620",
    "Last Name": "Ferguson",
    "First Name": "Kay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42135614": {
    "id": "item_14136",
    "Last Name": "Vorster",
    "First Name": "Wesley Shaun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42137406": {
    "id": "item_3313",
    "Last Name": "Michael",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42153449": {
    "id": "item_26621",
    "Last Name": "Abossedgh",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42158446": {
    "id": "item_26622",
    "Last Name": "Ranson",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42165203": {
    "id": "item_28944",
    "Last Name": "CHALMERS",
    "First Name": "ROBERT",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181519": {
    "id": "item_14137",
    "Last Name": "Clarke Noble",
    "First Name": "Desiree",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181520": {
    "id": "item_14138",
    "Last Name": "Strasser",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181521": {
    "id": "item_14139",
    "Last Name": "Nunan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181524": {
    "id": "item_14140",
    "Last Name": "Campbell",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181525": {
    "id": "item_14141",
    "Last Name": "Keegan",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181529": {
    "id": "item_26623",
    "Last Name": "Tuwera",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181530": {
    "id": "item_14142",
    "Last Name": "Masson",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181532": {
    "id": "item_26624",
    "Last Name": "Wheeler",
    "First Name": "Dean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42190900": {
    "id": "item_28945",
    "Last Name": "Arellano",
    "First Name": "Albie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42192751": {
    "id": "item_28946",
    "Last Name": "Walters",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42204761": {
    "id": "item_1492",
    "Last Name": "Hemmings",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42212008": {
    "id": "item_16364",
    "Last Name": "van Baalen",
    "First Name": "Lucille",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42214544": {
    "id": "item_26625",
    "Last Name": "Watts",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42224454": {
    "id": "item_3314",
    "Last Name": "Lew",
    "First Name": "Albert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42236591": {
    "id": "item_28947",
    "Last Name": "Payne",
    "First Name": "Les",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42239494": {
    "id": "item_1493",
    "Last Name": "Newton",
    "First Name": "Libby",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42240880": {
    "id": "item_3315",
    "Last Name": "Chan",
    "First Name": "Aiden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42241953": {
    "id": "item_26626",
    "Last Name": "Parker",
    "First Name": "Ebrahim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42253551": {
    "id": "item_14143",
    "Last Name": "Ure–a Vega",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42260048": {
    "id": "item_3316",
    "Last Name": "Haile",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42261446": {
    "id": "item_26627",
    "Last Name": "Noori",
    "First Name": "Pashtana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42281069": {
    "id": "item_26628",
    "Last Name": "Mansueto",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42281207": {
    "id": "item_1494",
    "Last Name": "Everett",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42284634": {
    "id": "item_14144",
    "Last Name": "Munoz",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42289225": {
    "id": "item_26629",
    "Last Name": "walker",
    "First Name": "matt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42303472": {
    "id": "item_26630",
    "Last Name": "Woodward",
    "First Name": "Allison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42305011": {
    "id": "item_28948",
    "Last Name": "Fitzgerald",
    "First Name": "Tenley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42308732": {
    "id": "item_28949",
    "Last Name": "Sun",
    "First Name": "Xiao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42310872": {
    "id": "item_26631",
    "Last Name": "Cvetko",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42310983": {
    "id": "item_26632",
    "Last Name": "Thevenot",
    "First Name": "Nolwenn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42311596": {
    "id": "item_16365",
    "Last Name": "Gomez",
    "First Name": "Vicky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42316266": {
    "id": "item_26633",
    "Last Name": "Rahal",
    "First Name": "Fatima",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42316430": {
    "id": "item_26634",
    "Last Name": "Davis",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42318594": {
    "id": "item_1495",
    "Last Name": "Duriez",
    "First Name": "Claude Henri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42319077": {
    "id": "item_1496",
    "Last Name": "Kabesa",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42319806": {
    "id": "item_3317",
    "Last Name": "Norris",
    "First Name": "Karen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42320609": {
    "id": "item_26635",
    "Last Name": "Akbar",
    "First Name": "Noman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42327642": {
    "id": "item_26636",
    "Last Name": "Hartman",
    "First Name": "Valerie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42333437": {
    "id": "item_1497",
    "Last Name": "Lamond",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42339324": {
    "id": "item_26637",
    "Last Name": "Manning",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42343238": {
    "id": "item_26638",
    "Last Name": "Ladmore",
    "First Name": "Harley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42344746": {
    "id": "item_1498",
    "Last Name": "Lehmann",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42346319": {
    "id": "item_26639",
    "Last Name": "Weir",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42348953": {
    "id": "item_26640",
    "Last Name": "Pattie",
    "First Name": "Summer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42349264": {
    "id": "item_14145",
    "Last Name": "Martin",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42351891": {
    "id": "item_28950",
    "Last Name": "Jeffreys",
    "First Name": "Sylvia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42352062": {
    "id": "item_26641",
    "Last Name": "Jeffreys",
    "First Name": "Akina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42355614": {
    "id": "item_1499",
    "Last Name": "Carvalho",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42387728": {
    "id": "item_26642",
    "Last Name": "Visscher",
    "First Name": "Ariane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42389324": {
    "id": "item_26643",
    "Last Name": "McNeill",
    "First Name": "Abby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42398981": {
    "id": "item_26644",
    "Last Name": "Bilala",
    "First Name": "Abdellah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42400260": {
    "id": "item_26645",
    "Last Name": "Wallis",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42400381": {
    "id": "item_26646",
    "Last Name": "Wallis",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42410739": {
    "id": "item_28951",
    "Last Name": "KOLLENGODE GOPALAKRISHNAN",
    "First Name": "RAMAKRISHNAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42411600": {
    "id": "item_26647",
    "Last Name": "Strubreiter",
    "First Name": "Kerstin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42417692": {
    "id": "item_1500",
    "Last Name": "Dasi Chisbert",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42425342": {
    "id": "item_26648",
    "Last Name": "faller",
    "First Name": "ronald anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42426315": {
    "id": "item_14146",
    "Last Name": "Tran",
    "First Name": "Ngoc Duy An",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42429776": {
    "id": "item_26649",
    "Last Name": "Chua",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42430837": {
    "id": "item_26650",
    "Last Name": "Margabandu",
    "First Name": "Karthik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42430977": {
    "id": "item_26651",
    "Last Name": "Price",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42433327": {
    "id": "item_1501",
    "Last Name": "Saunders",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42434063": {
    "id": "item_1502",
    "Last Name": "LI",
    "First Name": "ZHIHONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42434785": {
    "id": "item_3318",
    "Last Name": "Butler",
    "First Name": "Dustyn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42436885": {
    "id": "item_3319",
    "Last Name": "Cuschieri",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42437844": {
    "id": "item_26652",
    "Last Name": "Xu",
    "First Name": "Meifeng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42438235": {
    "id": "item_28952",
    "Last Name": "lade",
    "First Name": "sunil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42438390": {
    "id": "item_26653",
    "Last Name": "Mehmet",
    "First Name": "Halil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42438440": {
    "id": "item_26654",
    "Last Name": "Yip",
    "First Name": "Soo Wei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42438606": {
    "id": "item_31088",
    "Last Name": "Batubara",
    "First Name": "Artur Dewata",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439293": {
    "id": "item_16366",
    "Last Name": "NOGUCHI",
    "First Name": "RYOICHI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439455": {
    "id": "item_26655",
    "Last Name": "Johns",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439507": {
    "id": "item_26656",
    "Last Name": "Salim",
    "First Name": "Hindra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439542": {
    "id": "item_28953",
    "Last Name": "PRANOTO",
    "First Name": "SAMUEL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439651": {
    "id": "item_1503",
    "Last Name": "Velazquez Bastida",
    "First Name": "Edgar Jair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439738": {
    "id": "item_26657",
    "Last Name": "Debra",
    "First Name": "Tenesse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439782": {
    "id": "item_14147",
    "Last Name": "Wunady",
    "First Name": "Jeffery",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439889": {
    "id": "item_28954",
    "Last Name": "Karyanto",
    "First Name": "Arthur Widjaja",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439964": {
    "id": "item_16367",
    "Last Name": "Singh",
    "First Name": "Gurpreet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439965": {
    "id": "item_26659",
    "Last Name": "Taylor",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439966": {
    "id": "item_26658",
    "Last Name": "Sutanto",
    "First Name": "Venantius Ivan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42440054": {
    "id": "item_26660",
    "Last Name": "LIM",
    "First Name": "AH BAY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42440157": {
    "id": "item_26661",
    "Last Name": "Lee",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42440205": {
    "id": "item_28955",
    "Last Name": "AYUNINGTIAS",
    "First Name": "ASTRI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42440685": {
    "id": "item_26662",
    "Last Name": "JIN",
    "First Name": "XUN HUA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42440710": {
    "id": "item_28956",
    "Last Name": "ng",
    "First Name": "chiew ro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42441147": {
    "id": "item_26663",
    "Last Name": "Lombardo",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42441785": {
    "id": "item_28957",
    "Last Name": "Nemati",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42441808": {
    "id": "item_3320",
    "Last Name": "Lam",
    "First Name": "Ka Ho",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42442020": {
    "id": "item_26664",
    "Last Name": "Toh",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42442593": {
    "id": "item_28958",
    "Last Name": "Tan",
    "First Name": "Wee Wah Kenneth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42442738": {
    "id": "item_14148",
    "Last Name": "Octavian",
    "First Name": "Irvan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42443606": {
    "id": "item_3321",
    "Last Name": "Tan",
    "First Name": "HooiYi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42443819": {
    "id": "item_3322",
    "Last Name": "Seng",
    "First Name": "WeiHong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42445072": {
    "id": "item_16368",
    "Last Name": "Wong",
    "First Name": "Sue May",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42445269": {
    "id": "item_26665",
    "Last Name": "Saisrithong",
    "First Name": "Permsak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42445600": {
    "id": "item_28959",
    "Last Name": "Budiman",
    "First Name": "Arif",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42447732": {
    "id": "item_14149",
    "Last Name": "Prasoppokakorn",
    "First Name": "Thanit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42448413": {
    "id": "item_26666",
    "Last Name": "James",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42448417": {
    "id": "item_26667",
    "Last Name": "Felix",
    "First Name": "Felix",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42450583": {
    "id": "item_28960",
    "Last Name": "Alcayde",
    "First Name": "Nymee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42450977": {
    "id": "item_31089",
    "Last Name": "Sugoto",
    "First Name": "Hana Eureka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42451651": {
    "id": "item_26668",
    "Last Name": "Moeikunmak",
    "First Name": "Cherdsak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42451858": {
    "id": "item_28961",
    "Last Name": "Agpalo",
    "First Name": "Norijane",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42451861": {
    "id": "item_14150",
    "Last Name": "Lee",
    "First Name": "Thania",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42452980": {
    "id": "item_14151",
    "Last Name": "Amador",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42453576": {
    "id": "item_28962",
    "Last Name": "Castro",
    "First Name": "Iliak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42453785": {
    "id": "item_1504",
    "Last Name": "Salazar Paz",
    "First Name": "Delma Isis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42455350": {
    "id": "item_26669",
    "Last Name": "Morris",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42458184": {
    "id": "item_3323",
    "Last Name": "Ashton",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42458217": {
    "id": "item_1505",
    "Last Name": "Ashton",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42459101": {
    "id": "item_26670",
    "Last Name": "Wanless",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42459176": {
    "id": "item_14152",
    "Last Name": "sararuch",
    "First Name": "vorakit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42459522": {
    "id": "item_3324",
    "Last Name": "Wittbecker",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42460556": {
    "id": "item_14153",
    "Last Name": "Puripanyavanit",
    "First Name": "Chawanat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42460844": {
    "id": "item_26671",
    "Last Name": "Musshorn",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42461621": {
    "id": "item_31090",
    "Last Name": "Mak",
    "First Name": "Al Kah Wai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42462239": {
    "id": "item_28963",
    "Last Name": "Bilbao",
    "First Name": "Ron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42462496": {
    "id": "item_16369",
    "Last Name": "Sim",
    "First Name": "Ban leng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42462895": {
    "id": "item_16370",
    "Last Name": "Gonsalves",
    "First Name": "Fabian Clement",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42463039": {
    "id": "item_28964",
    "Last Name": "yufan",
    "First Name": "andy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42464160": {
    "id": "item_26672",
    "Last Name": "Yuan",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42464441": {
    "id": "item_26673",
    "Last Name": "STAMATATOU",
    "First Name": "ADA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42464786": {
    "id": "item_26674",
    "Last Name": "Boonsiri",
    "First Name": "Kasidit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42464904": {
    "id": "item_26675",
    "Last Name": "Sharma",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42464939": {
    "id": "item_1506",
    "Last Name": "Soriano",
    "First Name": "Richard Elep",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42465268": {
    "id": "item_26676",
    "Last Name": "Tait",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42466099": {
    "id": "item_26677",
    "Last Name": "Yenphinyo",
    "First Name": "Kanlaya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42466324": {
    "id": "item_26678",
    "Last Name": "Casanova",
    "First Name": "Caesar Jr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42466606": {
    "id": "item_1507",
    "Last Name": "de Dios",
    "First Name": "Glenn Rene",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42467341": {
    "id": "item_28965",
    "Last Name": "LIM",
    "First Name": "Tonghai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42469222": {
    "id": "item_28966",
    "Last Name": "Karam",
    "First Name": "Camila",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42469663": {
    "id": "item_14154",
    "Last Name": "Banthiya",
    "First Name": "Sid",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42473499": {
    "id": "item_26679",
    "Last Name": "Sosa",
    "First Name": "Maria Elena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42474059": {
    "id": "item_14155",
    "Last Name": "Li",
    "First Name": "Zhanzhe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42475742": {
    "id": "item_26680",
    "Last Name": "Ontoy",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42475951": {
    "id": "item_14156",
    "Last Name": "PŽrez Ixcoy",
    "First Name": "Patricia Lorena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42478896": {
    "id": "item_26681",
    "Last Name": "Campa Gutierrez",
    "First Name": "Guadalupe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42482099": {
    "id": "item_1508",
    "Last Name": "LEDESMA MENA",
    "First Name": "ANA LAURA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42483450": {
    "id": "item_3325",
    "Last Name": "Flecker",
    "First Name": "Ella",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42484537": {
    "id": "item_26682",
    "Last Name": "Somaya",
    "First Name": "Priti Bhavesh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42485066": {
    "id": "item_14157",
    "Last Name": "Suesirisawad",
    "First Name": "Salinporn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42486039": {
    "id": "item_3326",
    "Last Name": "Tagafi",
    "First Name": "Habib Asolih",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42486524": {
    "id": "item_1509",
    "Last Name": "Sarasuk",
    "First Name": "Kanapon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42486706": {
    "id": "item_3327",
    "Last Name": "Hu",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42488054": {
    "id": "item_14158",
    "Last Name": "Tesprasit",
    "First Name": "Bordin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42488931": {
    "id": "item_31091",
    "Last Name": "OU",
    "First Name": "LEEKAI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42489177": {
    "id": "item_28967",
    "Last Name": "Seetoh",
    "First Name": "Pak Lian Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42489376": {
    "id": "item_26683",
    "Last Name": "Tiu",
    "First Name": "St Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42489690": {
    "id": "item_14159",
    "Last Name": "Meliska",
    "First Name": "Naida",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42489861": {
    "id": "item_14160",
    "Last Name": "Suradilaya",
    "First Name": "Ignatius Eka Prima",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42490073": {
    "id": "item_26684",
    "Last Name": "Martoyo",
    "First Name": "Sutomo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42491269": {
    "id": "item_26685",
    "Last Name": "Khoo",
    "First Name": "Kay Seong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42492280": {
    "id": "item_26686",
    "Last Name": "Dokjampa",
    "First Name": "Sarawut",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42492316": {
    "id": "item_14161",
    "Last Name": "Karyadi",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42495399": {
    "id": "item_3328",
    "Last Name": "Wu",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42496590": {
    "id": "item_16371",
    "Last Name": "jaisai",
    "First Name": "Sutdhicha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42497457": {
    "id": "item_28968",
    "Last Name": "Power",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42509698": {
    "id": "item_26687",
    "Last Name": "Hughes",
    "First Name": "Imogen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42511479": {
    "id": "item_26688",
    "Last Name": "Mori",
    "First Name": "Yurie Christina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42511825": {
    "id": "item_26689",
    "Last Name": "ANTORO",
    "First Name": "BAGUS TRI BUDI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42513263": {
    "id": "item_1510",
    "Last Name": "Chapman",
    "First Name": "Nicola Anne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42514298": {
    "id": "item_26690",
    "Last Name": "Friedman",
    "First Name": "Sivan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42514359": {
    "id": "item_14162",
    "Last Name": "Al-Zoubi",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42515452": {
    "id": "item_3329",
    "Last Name": "Kristiono",
    "First Name": "Gani",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42516284": {
    "id": "item_26691",
    "Last Name": "Wahyuliyanto",
    "First Name": "Wahyuliyanto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42516592": {
    "id": "item_16372",
    "Last Name": "Widjaja",
    "First Name": "Benny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42517225": {
    "id": "item_28969",
    "Last Name": "Laihad",
    "First Name": "Mordekhai Leopold",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42517376": {
    "id": "item_3330",
    "Last Name": "CHEN HOW",
    "First Name": "YEE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42517792": {
    "id": "item_14163",
    "Last Name": "Wu",
    "First Name": "Yaqiong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42517841": {
    "id": "item_31092",
    "Last Name": "SIN HONG",
    "First Name": "CHOH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42517853": {
    "id": "item_14164",
    "Last Name": "Koda",
    "First Name": "Ritsubun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518340": {
    "id": "item_26692",
    "Last Name": "HIGASHIDE",
    "First Name": "AKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518344": {
    "id": "item_14165",
    "Last Name": "Nanayakkara",
    "First Name": "Sanduni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518443": {
    "id": "item_26693",
    "Last Name": "Chua",
    "First Name": "Phey Nee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518636": {
    "id": "item_3331",
    "Last Name": "Tanjung",
    "First Name": "Syukrinov",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518715": {
    "id": "item_14166",
    "Last Name": "Andrianez Tan",
    "First Name": "Jordie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518755": {
    "id": "item_14167",
    "Last Name": "Schalkwijk",
    "First Name": "Benoit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518806": {
    "id": "item_16373",
    "Last Name": "Ichii",
    "First Name": "Hideki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518879": {
    "id": "item_28970",
    "Last Name": "irawan",
    "First Name": "adi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518977": {
    "id": "item_31093",
    "Last Name": "AIKAWA",
    "First Name": "TOMOYUKI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42519005": {
    "id": "item_26694",
    "Last Name": "Moore",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42519308": {
    "id": "item_3332",
    "Last Name": "CAHYA NEGARA",
    "First Name": "AL RIDLA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42519328": {
    "id": "item_26695",
    "Last Name": "Chandra",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42519422": {
    "id": "item_1511",
    "Last Name": "Kempeneers",
    "First Name": "Pascal Didier C.",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42519754": {
    "id": "item_14168",
    "Last Name": "Xu",
    "First Name": "Yunqing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42520144": {
    "id": "item_14169",
    "Last Name": "Pangaribowo",
    "First Name": "Evita Hanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42520875": {
    "id": "item_3333",
    "Last Name": "Klein",
    "First Name": "Dieter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42521486": {
    "id": "item_1512",
    "Last Name": "Roberts",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42521648": {
    "id": "item_28971",
    "Last Name": "Mohammad",
    "First Name": "Noor Azman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42523261": {
    "id": "item_14170",
    "Last Name": "SUKSAWASDI",
    "First Name": "NAVAPORN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42523546": {
    "id": "item_16374",
    "Last Name": "Halim",
    "First Name": "Handayani",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42523892": {
    "id": "item_3334",
    "Last Name": "Andrianto",
    "First Name": "Tomi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42524936": {
    "id": "item_26696",
    "Last Name": "Harun",
    "First Name": "Wahyu Afandi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42525801": {
    "id": "item_28972",
    "Last Name": "Mok",
    "First Name": "Hermandy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42528155": {
    "id": "item_26697",
    "Last Name": "DITRUNGROJ",
    "First Name": "PRAPON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42528573": {
    "id": "item_28973",
    "Last Name": "Wisapa",
    "First Name": "Kasem",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42528723": {
    "id": "item_1513",
    "Last Name": "Dillon",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42529333": {
    "id": "item_3335",
    "Last Name": "Miradjaja",
    "First Name": "Memie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42531052": {
    "id": "item_1514",
    "Last Name": "Bruckner",
    "First Name": "Reinhard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42531785": {
    "id": "item_16375",
    "Last Name": "Helbling",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42532682": {
    "id": "item_28974",
    "Last Name": "tamin",
    "First Name": "suradi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42534673": {
    "id": "item_3336",
    "Last Name": "de Boer",
    "First Name": "Paulus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42536041": {
    "id": "item_3337",
    "Last Name": "Bergovoy",
    "First Name": "Yosef",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42536090": {
    "id": "item_28975",
    "Last Name": "Calderon",
    "First Name": "Alejandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42536434": {
    "id": "item_31094",
    "Last Name": "SAHAISOOK",
    "First Name": "KEERATI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42536596": {
    "id": "item_1515",
    "Last Name": "Lyesin",
    "First Name": "Yan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42536682": {
    "id": "item_28976",
    "Last Name": "Ng",
    "First Name": "Kar Hung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42536865": {
    "id": "item_3338",
    "Last Name": "Catlin",
    "First Name": "Tanguy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42536906": {
    "id": "item_14171",
    "Last Name": "Hart",
    "First Name": "Mary Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42537534": {
    "id": "item_1516",
    "Last Name": "Manole",
    "First Name": "Gino",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42538037": {
    "id": "item_26698",
    "Last Name": "Faucher Bernard",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42539260": {
    "id": "item_26699",
    "Last Name": "Bilbao",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42540085": {
    "id": "item_3339",
    "Last Name": "Maitrot",
    "First Name": "Jeanfrancois",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42540254": {
    "id": "item_28977",
    "Last Name": "munoz",
    "First Name": "jesus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42540311": {
    "id": "item_3340",
    "Last Name": "Bley Filho",
    "First Name": "Ubirajara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42541229": {
    "id": "item_5746",
    "Last Name": "Gross",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42542147": {
    "id": "item_1517",
    "Last Name": "Sakiyama",
    "First Name": "Ro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42543382": {
    "id": "item_14172",
    "Last Name": "RI",
    "First Name": "KOKUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42543908": {
    "id": "item_3341",
    "Last Name": "Munoz",
    "First Name": "Ramiro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42544091": {
    "id": "item_3342",
    "Last Name": "Frankel",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42544243": {
    "id": "item_1518",
    "Last Name": "MORIYAMA",
    "First Name": "MACHIKO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42544416": {
    "id": "item_1519",
    "Last Name": "Raimbach",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42545113": {
    "id": "item_3343",
    "Last Name": "SAITO",
    "First Name": "HIROTO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42545636": {
    "id": "item_3344",
    "Last Name": "KATO",
    "First Name": "NAOMI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42546092": {
    "id": "item_3345",
    "Last Name": "Moreno mohar",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42547049": {
    "id": "item_26701",
    "Last Name": "Nitopi",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42547100": {
    "id": "item_26700",
    "Last Name": "Gartman",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42548357": {
    "id": "item_1520",
    "Last Name": "Waldron",
    "First Name": "Simeon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42548792": {
    "id": "item_28978",
    "Last Name": "JIN",
    "First Name": "ZITIAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42548984": {
    "id": "item_14173",
    "Last Name": "Santosa",
    "First Name": "Agus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42551045": {
    "id": "item_26702",
    "Last Name": "Daeng Kuma",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42551503": {
    "id": "item_26703",
    "Last Name": "Choi",
    "First Name": "Hwa Kyung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42551918": {
    "id": "item_26704",
    "Last Name": "Handayani",
    "First Name": "Santi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552092": {
    "id": "item_1521",
    "Last Name": "Tsang",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552149": {
    "id": "item_3346",
    "Last Name": "Kurniawan",
    "First Name": "Alexander Fadjar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552268": {
    "id": "item_1522",
    "Last Name": "TIAN",
    "First Name": "SHIXIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552698": {
    "id": "item_1523",
    "Last Name": "YEUNG",
    "First Name": "CHUN YUEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552732": {
    "id": "item_28979",
    "Last Name": "Lee",
    "First Name": "Wai Kwong Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552786": {
    "id": "item_28980",
    "Last Name": "Chen",
    "First Name": "Yinnien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552881": {
    "id": "item_28982",
    "Last Name": "Watthanayontkit",
    "First Name": "Surasak",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552901": {
    "id": "item_28981",
    "Last Name": "Yannamani",
    "First Name": "Veera Venkata Satyanarayana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552914": {
    "id": "item_31095",
    "Last Name": "Yu",
    "First Name": "Hoi Man Vanessa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552949": {
    "id": "item_28983",
    "Last Name": "GU",
    "First Name": "WENJUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552981": {
    "id": "item_16376",
    "Last Name": "Kam",
    "First Name": "Yiu Kwok",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552993": {
    "id": "item_14174",
    "Last Name": "PAN",
    "First Name": "QING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553136": {
    "id": "item_3347",
    "Last Name": "CHEN",
    "First Name": "YI JIA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553231": {
    "id": "item_26705",
    "Last Name": "KOW",
    "First Name": "REN YI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553315": {
    "id": "item_31096",
    "Last Name": "wongpimonporn",
    "First Name": "jirawat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553342": {
    "id": "item_14175",
    "Last Name": "YEH",
    "First Name": "CHENG-NAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553352": {
    "id": "item_3348",
    "Last Name": "SHI",
    "First Name": "YAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553399": {
    "id": "item_28984",
    "Last Name": "Hashim",
    "First Name": "Ainun Mardziah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553434": {
    "id": "item_14176",
    "Last Name": "LIN",
    "First Name": "HSIAO-PENG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553593": {
    "id": "item_14177",
    "Last Name": "Intifadhah",
    "First Name": "Nuraulia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553598": {
    "id": "item_14178",
    "Last Name": "Lam",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553665": {
    "id": "item_14179",
    "Last Name": "Darbha",
    "First Name": "Sriram",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553893": {
    "id": "item_14180",
    "Last Name": "Chan",
    "First Name": "Kwok Hung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553914": {
    "id": "item_26706",
    "Last Name": "KASIM",
    "First Name": "HOCKY BENNY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554199": {
    "id": "item_26707",
    "Last Name": "Yang",
    "First Name": "Yu Ching",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554335": {
    "id": "item_26708",
    "Last Name": "Chan",
    "First Name": "Yun Cheong Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554408": {
    "id": "item_3349",
    "Last Name": "Rosa Loro",
    "First Name": "Anielly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554503": {
    "id": "item_3350",
    "Last Name": "Grobler",
    "First Name": "Enrique",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554528": {
    "id": "item_26709",
    "Last Name": "Chan",
    "First Name": "Ying Hoi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554535": {
    "id": "item_16377",
    "Last Name": "Bernard",
    "First Name": "Jean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554557": {
    "id": "item_16378",
    "Last Name": "Hong da Conceicao",
    "First Name": "Miguel Nuno",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554673": {
    "id": "item_28985",
    "Last Name": "Mundada",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554897": {
    "id": "item_28986",
    "Last Name": "CHANG",
    "First Name": "TZUYANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554914": {
    "id": "item_3351",
    "Last Name": "SHI",
    "First Name": "LINRONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42555155": {
    "id": "item_26710",
    "Last Name": "D'Souza",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42555176": {
    "id": "item_1524",
    "Last Name": "Wilhelm",
    "First Name": "Maike Natascha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42560724": {
    "id": "item_3352",
    "Last Name": "Campos",
    "First Name": "Giordania",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42561402": {
    "id": "item_14181",
    "Last Name": "Kulwedchakit",
    "First Name": "Warawut",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42565445": {
    "id": "item_1525",
    "Last Name": "marsito",
    "First Name": "marsito",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42567172": {
    "id": "item_28987",
    "Last Name": "Rinella",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42567982": {
    "id": "item_14182",
    "Last Name": "So",
    "First Name": "Chi Keung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42568707": {
    "id": "item_1526",
    "Last Name": "Kan",
    "First Name": "Kwai Yung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42568956": {
    "id": "item_28988",
    "Last Name": "KUNO",
    "First Name": "KUMIKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42570304": {
    "id": "item_1527",
    "Last Name": "Oliveira Junior",
    "First Name": "Joaquim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572090": {
    "id": "item_28989",
    "Last Name": "Jain",
    "First Name": "Abhishek",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572179": {
    "id": "item_26711",
    "Last Name": "HAU",
    "First Name": "KYM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572295": {
    "id": "item_26713",
    "Last Name": "Saringkareekul",
    "First Name": "Thada",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572310": {
    "id": "item_28990",
    "Last Name": "AGGARWAL",
    "First Name": "SHEEL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572394": {
    "id": "item_28991",
    "Last Name": "Santos Shibao",
    "First Name": "Jaciguara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572420": {
    "id": "item_26712",
    "Last Name": "WANG",
    "First Name": "XIANGCHUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572428": {
    "id": "item_1528",
    "Last Name": "Soler",
    "First Name": "Darin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572649": {
    "id": "item_1529",
    "Last Name": "de Moura",
    "First Name": "Jean Mary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572653": {
    "id": "item_16379",
    "Last Name": "HANASHIRO",
    "First Name": "NORIYUKI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42573991": {
    "id": "item_26714",
    "Last Name": "Wong",
    "First Name": "Tung Mui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42575742": {
    "id": "item_14183",
    "Last Name": "Chaimattayompol",
    "First Name": "Prapan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42581590": {
    "id": "item_3353",
    "Last Name": "Thammaiah",
    "First Name": "Narayan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42582764": {
    "id": "item_26715",
    "Last Name": "Guimar‹es da Silva",
    "First Name": "Nilza Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42588749": {
    "id": "item_1530",
    "Last Name": "ZENG",
    "First Name": "ZHIYONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42594452": {
    "id": "item_26716",
    "Last Name": "K C",
    "First Name": "KOTHANDAPANI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42594947": {
    "id": "item_14184",
    "Last Name": "Chan",
    "First Name": "Kar Yue Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42594984": {
    "id": "item_28992",
    "Last Name": "Suryawanshi",
    "First Name": "Nitija",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42595464": {
    "id": "item_26717",
    "Last Name": "BORRAS",
    "First Name": "ALEXANDER",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42595927": {
    "id": "item_3354",
    "Last Name": "Justino",
    "First Name": "DENER",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42596043": {
    "id": "item_16380",
    "Last Name": "Tiraswasdichai",
    "First Name": "Tuangbhat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42596337": {
    "id": "item_1531",
    "Last Name": "RODRIGUEZ TORRES",
    "First Name": "ARGEME",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42596352": {
    "id": "item_3355",
    "Last Name": "Rocha Lacerda",
    "First Name": "Paulo Anselmo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42596492": {
    "id": "item_14185",
    "Last Name": "BAI",
    "First Name": "XUESONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42596753": {
    "id": "item_3356",
    "Last Name": "Sol",
    "First Name": "Joan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42597783": {
    "id": "item_26718",
    "Last Name": "Abraham",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42597864": {
    "id": "item_3357",
    "Last Name": "Ding",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42598099": {
    "id": "item_3358",
    "Last Name": "SUN",
    "First Name": "YINGJIE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42599197": {
    "id": "item_14186",
    "Last Name": "Oura",
    "First Name": "Mara Litsuco",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42599545": {
    "id": "item_14187",
    "Last Name": "Wanderley Pereira",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42599699": {
    "id": "item_26719",
    "Last Name": "Ferguson",
    "First Name": "Milan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42600908": {
    "id": "item_28993",
    "Last Name": "Przyludzki",
    "First Name": "Janusz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42602982": {
    "id": "item_1532",
    "Last Name": "Podzeckas",
    "First Name": "Andrius",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42604114": {
    "id": "item_16381",
    "Last Name": "Rousseau",
    "First Name": "Paula",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42604449": {
    "id": "item_1533",
    "Last Name": "Afonso",
    "First Name": "Jo‹o",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42604479": {
    "id": "item_14188",
    "Last Name": "Lucio",
    "First Name": "Jose Erasmo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42604948": {
    "id": "item_14189",
    "Last Name": "Nieto",
    "First Name": "Leo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42604971": {
    "id": "item_28994",
    "Last Name": "HU",
    "First Name": "LI-CHUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42605108": {
    "id": "item_26720",
    "Last Name": "Zavalin",
    "First Name": "Aleksei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42605176": {
    "id": "item_1535",
    "Last Name": "SANCHEZ PEDREGOSA",
    "First Name": "JESUS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42605199": {
    "id": "item_1534",
    "Last Name": "Cesar",
    "First Name": "Altamirano Alcocer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42606041": {
    "id": "item_3359",
    "Last Name": "Altamirano Alcocer",
    "First Name": "Francisco Javier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42606240": {
    "id": "item_26722",
    "Last Name": "Juidetch",
    "First Name": "Kunlarat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42606271": {
    "id": "item_26721",
    "Last Name": "chang",
    "First Name": "cheng hao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42607192": {
    "id": "item_14190",
    "Last Name": "PINOL",
    "First Name": "FLAVIO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42607610": {
    "id": "item_16382",
    "Last Name": "Giorgi",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42608326": {
    "id": "item_28995",
    "Last Name": "Drucker",
    "First Name": "Lorena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42609156": {
    "id": "item_28996",
    "Last Name": "Lau",
    "First Name": "Chak Leung",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42612314": {
    "id": "item_14191",
    "Last Name": "Gibbs",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42612563": {
    "id": "item_26723",
    "Last Name": "WEI",
    "First Name": "CHING-MOU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42612759": {
    "id": "item_26724",
    "Last Name": "Hunt",
    "First Name": "Anneta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42612999": {
    "id": "item_14192",
    "Last Name": "RUENROM",
    "First Name": "KANJANA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42613226": {
    "id": "item_3360",
    "Last Name": "Puentes Matamala",
    "First Name": "Juan Hernan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42614115": {
    "id": "item_31097",
    "Last Name": "HASHIMOTO",
    "First Name": "YUKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42615180": {
    "id": "item_26725",
    "Last Name": "Austin",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42615901": {
    "id": "item_3361",
    "Last Name": "Saavedra",
    "First Name": "Pavel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42616141": {
    "id": "item_26726",
    "Last Name": "Toogood",
    "First Name": "Grant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42616414": {
    "id": "item_3362",
    "Last Name": "Lin",
    "First Name": "Shunwang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42616636": {
    "id": "item_26727",
    "Last Name": "Doi",
    "First Name": "Nazuki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42616896": {
    "id": "item_1536",
    "Last Name": "Garcia",
    "First Name": "Ronnel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617248": {
    "id": "item_26728",
    "Last Name": "Keokarn",
    "First Name": "THAKOLRAT",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617754": {
    "id": "item_3363",
    "Last Name": "Dong",
    "First Name": "Jun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617860": {
    "id": "item_26729",
    "Last Name": "ding",
    "First Name": "Yi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618055": {
    "id": "item_28997",
    "Last Name": "HUNG",
    "First Name": "TO YEUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618140": {
    "id": "item_28998",
    "Last Name": "CHAN",
    "First Name": "CHOI YUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618217": {
    "id": "item_26730",
    "Last Name": "Rusmanto",
    "First Name": "Moris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618238": {
    "id": "item_28999",
    "Last Name": "CHAN",
    "First Name": "CHOI CHUN WENDY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618293": {
    "id": "item_16383",
    "Last Name": "Wu",
    "First Name": "Bing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618306": {
    "id": "item_14193",
    "Last Name": "Kwek",
    "First Name": "Su Arn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618311": {
    "id": "item_1537",
    "Last Name": "Tudjman",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618326": {
    "id": "item_29000",
    "Last Name": "WU",
    "First Name": "CAIEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618397": {
    "id": "item_29001",
    "Last Name": "Koetruen",
    "First Name": "Wantana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618466": {
    "id": "item_14194",
    "Last Name": "Wrede",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618547": {
    "id": "item_14195",
    "Last Name": "SUTANTO",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618595": {
    "id": "item_26731",
    "Last Name": "XING",
    "First Name": "HUAI XIANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42619735": {
    "id": "item_26732",
    "Last Name": "Kwan",
    "First Name": "Bryan Hon Ming",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42619800": {
    "id": "item_3364",
    "Last Name": "Sebastian",
    "First Name": "Angganata",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42620375": {
    "id": "item_3365",
    "Last Name": "FU",
    "First Name": "YIJIA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42626479": {
    "id": "item_16384",
    "Last Name": "Sanghavi",
    "First Name": "Nikunj",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42627174": {
    "id": "item_3366",
    "Last Name": "LI",
    "First Name": "HONGLONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42629123": {
    "id": "item_3367",
    "Last Name": "CHEN",
    "First Name": "QIHUA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42629232": {
    "id": "item_31098",
    "Last Name": "Anindita",
    "First Name": "Ida Ayu Kade Windi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631033": {
    "id": "item_26733",
    "Last Name": "Feng",
    "First Name": "Wenyou",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631035": {
    "id": "item_26734",
    "Last Name": "Sitompul",
    "First Name": "Putra Mikita Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631155": {
    "id": "item_26735",
    "Last Name": "Gao",
    "First Name": "LiLi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631168": {
    "id": "item_29002",
    "Last Name": "ZHANG",
    "First Name": "WEIGUO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631187": {
    "id": "item_29004",
    "Last Name": "Wei",
    "First Name": "Lihua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631188": {
    "id": "item_29003",
    "Last Name": "Mengko",
    "First Name": "Allova herling",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631214": {
    "id": "item_3368",
    "Last Name": "WANG",
    "First Name": "WEIYANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631235": {
    "id": "item_26736",
    "Last Name": "FENG",
    "First Name": "WEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631276": {
    "id": "item_26737",
    "Last Name": "XU",
    "First Name": "HUI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631336": {
    "id": "item_3369",
    "Last Name": "SHA",
    "First Name": "YANHONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631358": {
    "id": "item_14196",
    "Last Name": "SOENJOTO",
    "First Name": "IVONNE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631374": {
    "id": "item_26738",
    "Last Name": "Widansyah",
    "First Name": "Gempur",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631391": {
    "id": "item_1538",
    "Last Name": "ALOBAIDLI",
    "First Name": "IBRAHIM",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631457": {
    "id": "item_26739",
    "Last Name": "Sokolov",
    "First Name": "Anton",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631486": {
    "id": "item_31099",
    "Last Name": "Arunwattanakul",
    "First Name": "Thiranun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631529": {
    "id": "item_16385",
    "Last Name": "yuwono",
    "First Name": "Yusuf yongky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631564": {
    "id": "item_14197",
    "Last Name": "Kudriashov",
    "First Name": "Aleksei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631700": {
    "id": "item_26740",
    "Last Name": "Falak",
    "First Name": "Rizta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631723": {
    "id": "item_16386",
    "Last Name": "YONG",
    "First Name": "YOKE HIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631769": {
    "id": "item_16387",
    "Last Name": "Chen",
    "First Name": "Thaddeus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631831": {
    "id": "item_1539",
    "Last Name": "Storti",
    "First Name": "Ralph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631881": {
    "id": "item_1540",
    "Last Name": "Pettersson",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631915": {
    "id": "item_29005",
    "Last Name": "Virolainen",
    "First Name": "Wongrit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631944": {
    "id": "item_3370",
    "Last Name": "Bernhardt",
    "First Name": "Birte",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631956": {
    "id": "item_3371",
    "Last Name": "Tiberio",
    "First Name": "Franco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631963": {
    "id": "item_14198",
    "Last Name": "Fleming",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631985": {
    "id": "item_1541",
    "Last Name": "MU„OZ ROCA",
    "First Name": "PEDRO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632162": {
    "id": "item_26741",
    "Last Name": "Liang",
    "First Name": "jie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632193": {
    "id": "item_29006",
    "Last Name": "Kusuma",
    "First Name": "Shirley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632214": {
    "id": "item_26742",
    "Last Name": "chaiworasin",
    "First Name": "chalermkwan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632570": {
    "id": "item_1542",
    "Last Name": "Zhang",
    "First Name": "jianhua",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42640160": {
    "id": "item_26743",
    "Last Name": "SONG",
    "First Name": "AILING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42640344": {
    "id": "item_26744",
    "Last Name": "TAVANAPPANAVAR SRIKANT",
    "First Name": "VIKRAM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42643479": {
    "id": "item_3372",
    "Last Name": "Chen",
    "First Name": "ling",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645240": {
    "id": "item_16388",
    "Last Name": "CHEN",
    "First Name": "YANPING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645353": {
    "id": "item_16389",
    "Last Name": "Sama",
    "First Name": "Sameer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645672": {
    "id": "item_26745",
    "Last Name": "YAN",
    "First Name": "JIAJUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645860": {
    "id": "item_26746",
    "Last Name": "Tan",
    "First Name": "Eng Soon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646049": {
    "id": "item_31100",
    "Last Name": "Kristijono",
    "First Name": "Natali Hasto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646187": {
    "id": "item_29007",
    "Last Name": "Chen",
    "First Name": "Shunteng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646285": {
    "id": "item_14199",
    "Last Name": "Che",
    "First Name": "Dan Ying",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646291": {
    "id": "item_1543",
    "Last Name": "Johari",
    "First Name": "Andi Iswandi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646359": {
    "id": "item_26747",
    "Last Name": "CHEN",
    "First Name": "JUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646637": {
    "id": "item_1544",
    "Last Name": "ZHANG",
    "First Name": "YANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646675": {
    "id": "item_14200",
    "Last Name": "Zhang",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646801": {
    "id": "item_14201",
    "Last Name": "MARTIN GARCIA",
    "First Name": "oscar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646824": {
    "id": "item_1545",
    "Last Name": "YE",
    "First Name": "CHAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647000": {
    "id": "item_1546",
    "Last Name": "KRIEGER",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647191": {
    "id": "item_14202",
    "Last Name": "Faruqi",
    "First Name": "Abraham Risyad Al",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647319": {
    "id": "item_1547",
    "Last Name": "LIU",
    "First Name": "YI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647607": {
    "id": "item_1548",
    "Last Name": "van Klooster",
    "First Name": "Niels",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647724": {
    "id": "item_31101",
    "Last Name": "Kreps",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647733": {
    "id": "item_14203",
    "Last Name": "LEUNG",
    "First Name": "PAU WAI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647838": {
    "id": "item_26748",
    "Last Name": "Yang",
    "First Name": "Daquan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647992": {
    "id": "item_14204",
    "Last Name": "KONG",
    "First Name": "WEIHUA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42648157": {
    "id": "item_14205",
    "Last Name": "LEE",
    "First Name": "KIN MING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42648267": {
    "id": "item_1549",
    "Last Name": "Arora",
    "First Name": "Vandana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42648268": {
    "id": "item_26749",
    "Last Name": "WATANABE",
    "First Name": "SAYAKA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42648288": {
    "id": "item_14206",
    "Last Name": "ACHARRYA",
    "First Name": "LAXMINARAYAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42648298": {
    "id": "item_26750",
    "Last Name": "Siok Heang",
    "First Name": "Tang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42648684": {
    "id": "item_1550",
    "Last Name": "Diaz Hernandez",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42649396": {
    "id": "item_26751",
    "Last Name": "ALVES MARREIRA",
    "First Name": "LUIZ",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42649518": {
    "id": "item_29008",
    "Last Name": "TANG",
    "First Name": "TIEHNAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42649580": {
    "id": "item_14207",
    "Last Name": "NAMBISAN",
    "First Name": "RAJESH KESAVAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42649880": {
    "id": "item_14208",
    "Last Name": "Tao",
    "First Name": "Haiyan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42650018": {
    "id": "item_26752",
    "Last Name": "DOS REIS CONCEICAO",
    "First Name": "KEDNA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42650716": {
    "id": "item_26753",
    "Last Name": "Ditrungroj",
    "First Name": "Kobkarn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42650967": {
    "id": "item_16390",
    "Last Name": "Sama",
    "First Name": "Rakhee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42651460": {
    "id": "item_14209",
    "Last Name": "Suyoto",
    "First Name": "Suyoto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42651909": {
    "id": "item_14210",
    "Last Name": "Andrade",
    "First Name": "Fanny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42653434": {
    "id": "item_29009",
    "Last Name": "Martinez",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42654719": {
    "id": "item_16391",
    "Last Name": "Thomas-Dick",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42655536": {
    "id": "item_29010",
    "Last Name": "Joschko",
    "First Name": "Terry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42655697": {
    "id": "item_26754",
    "Last Name": "Thomas",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42657731": {
    "id": "item_1551",
    "Last Name": "RAMIREZ PICHARDO",
    "First Name": "LINDA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42657790": {
    "id": "item_1552",
    "Last Name": "Fran�a",
    "First Name": "Vanderlei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42658825": {
    "id": "item_26755",
    "Last Name": "Stout",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42659588": {
    "id": "item_16392",
    "Last Name": "saez",
    "First Name": "pablo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42660582": {
    "id": "item_14211",
    "Last Name": "ORNELAS CRAVIOTO",
    "First Name": "ANDRES",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42661782": {
    "id": "item_26756",
    "Last Name": "Hampton",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42662162": {
    "id": "item_29011",
    "Last Name": "Surya",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42662179": {
    "id": "item_16393",
    "Last Name": "Obenaus",
    "First Name": "Ava",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42662730": {
    "id": "item_3373",
    "Last Name": "Narimatsu",
    "First Name": "Dayana Mayuri",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42662747": {
    "id": "item_26757",
    "Last Name": "Nachiappan",
    "First Name": "Muthukumar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42663085": {
    "id": "item_3374",
    "Last Name": "Macri Bogaz",
    "First Name": "Tito",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42663126": {
    "id": "item_1553",
    "Last Name": "Ost Oleinski",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42663531": {
    "id": "item_14212",
    "Last Name": "GARCIA GONZçLEZ",
    "First Name": "ANA SOFIA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42663860": {
    "id": "item_14213",
    "Last Name": "SHIDARA",
    "First Name": "AKIRA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42663886": {
    "id": "item_1554",
    "Last Name": "Fantinel",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42664093": {
    "id": "item_1555",
    "Last Name": "Wong",
    "First Name": "Evan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42664482": {
    "id": "item_26758",
    "Last Name": "Muhammad",
    "First Name": "Shan Arby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42665464": {
    "id": "item_14214",
    "Last Name": "Mitchell",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42665857": {
    "id": "item_14215",
    "Last Name": "HU",
    "First Name": "YUNQIAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42667562": {
    "id": "item_26759",
    "Last Name": "WU",
    "First Name": "DE JUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42668091": {
    "id": "item_31102",
    "Last Name": "Pozzi",
    "First Name": "Karla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42668476": {
    "id": "item_1556",
    "Last Name": "Tsai",
    "First Name": "Yun-Fu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42668689": {
    "id": "item_29012",
    "Last Name": "Loke",
    "First Name": "Siew Ken",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42668778": {
    "id": "item_26760",
    "Last Name": "Handajani",
    "First Name": "Ester",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42668803": {
    "id": "item_26761",
    "Last Name": "Tan",
    "First Name": "Ser Chiao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42669521": {
    "id": "item_31103",
    "Last Name": "Kola",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42669729": {
    "id": "item_1557",
    "Last Name": "Scott",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42669876": {
    "id": "item_29013",
    "Last Name": "Yuquico",
    "First Name": "Christaliza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42671303": {
    "id": "item_29014",
    "Last Name": "Ubesie",
    "First Name": "Kanenechukwu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42672127": {
    "id": "item_26762",
    "Last Name": "Tucker",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42672184": {
    "id": "item_16394",
    "Last Name": "Hermawan",
    "First Name": "Crescento",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42672987": {
    "id": "item_26763",
    "Last Name": "LUO",
    "First Name": "HUABING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673143": {
    "id": "item_14216",
    "Last Name": "TANG",
    "First Name": "ZI JUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673166": {
    "id": "item_26764",
    "Last Name": "XU",
    "First Name": "XIHUA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673282": {
    "id": "item_26765",
    "Last Name": "Liang",
    "First Name": "yingying",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673360": {
    "id": "item_1558",
    "Last Name": "Bhanushali",
    "First Name": "Rajesh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673744": {
    "id": "item_29015",
    "Last Name": "Murray",
    "First Name": "Mere",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673795": {
    "id": "item_3375",
    "Last Name": "FUNG",
    "First Name": "HING LOK SIMON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673818": {
    "id": "item_29016",
    "Last Name": "Laliasa",
    "First Name": "Ikraam pradana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674004": {
    "id": "item_26766",
    "Last Name": "LI",
    "First Name": "FEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674038": {
    "id": "item_3376",
    "Last Name": "Nath",
    "First Name": "Ashok",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674070": {
    "id": "item_3377",
    "Last Name": "SONIMINDE",
    "First Name": "ANAND",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674072": {
    "id": "item_26767",
    "Last Name": "Luo",
    "First Name": "WanFeng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674088": {
    "id": "item_1559",
    "Last Name": "zhang",
    "First Name": "chang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674165": {
    "id": "item_26768",
    "Last Name": "HARDIAN",
    "First Name": "RICO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674203": {
    "id": "item_29017",
    "Last Name": "Gollapalli",
    "First Name": "Jagannatha Kumar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674369": {
    "id": "item_29018",
    "Last Name": "WANG",
    "First Name": "XUYANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674412": {
    "id": "item_26769",
    "Last Name": "Khater",
    "First Name": "Elias",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674459": {
    "id": "item_26770",
    "Last Name": "Yu",
    "First Name": "Pak Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674567": {
    "id": "item_31104",
    "Last Name": "Saxena",
    "First Name": "Vineet Kumar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674797": {
    "id": "item_1560",
    "Last Name": "HUSSAIN",
    "First Name": "BACHA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674876": {
    "id": "item_16395",
    "Last Name": "FAN",
    "First Name": "JIANXIU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674940": {
    "id": "item_3378",
    "Last Name": "Mussad",
    "First Name": "Aymen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674980": {
    "id": "item_26772",
    "Last Name": "Annapantula",
    "First Name": "Gayatri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674994": {
    "id": "item_26771",
    "Last Name": "GE",
    "First Name": "TANYI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675017": {
    "id": "item_1561",
    "Last Name": "Bennie",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675075": {
    "id": "item_31105",
    "Last Name": "Motyl-Szary",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675203": {
    "id": "item_1562",
    "Last Name": "zhang",
    "First Name": "jianshe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675348": {
    "id": "item_26773",
    "Last Name": "chen",
    "First Name": "xueying",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675471": {
    "id": "item_14217",
    "Last Name": "Tan",
    "First Name": "May Yee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675489": {
    "id": "item_16396",
    "Last Name": "Tan",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675582": {
    "id": "item_29019",
    "Last Name": "GUPTA",
    "First Name": "SAURABH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675736": {
    "id": "item_26774",
    "Last Name": "Tian",
    "First Name": "Xiao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675823": {
    "id": "item_26775",
    "Last Name": "Thong",
    "First Name": "POH GEOK",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675843": {
    "id": "item_26776",
    "Last Name": "Tee",
    "First Name": "Yongnan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675880": {
    "id": "item_26777",
    "Last Name": "Rahmasari",
    "First Name": "Ari",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675948": {
    "id": "item_16397",
    "Last Name": "Harris",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675959": {
    "id": "item_14218",
    "Last Name": "YINTI",
    "First Name": "DEEPAK",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675992": {
    "id": "item_1563",
    "Last Name": "Rungwongsakul",
    "First Name": "Purided",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676024": {
    "id": "item_1564",
    "Last Name": "LŠmmlein",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676210": {
    "id": "item_1565",
    "Last Name": "Wu",
    "First Name": "chiachi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676244": {
    "id": "item_29020",
    "Last Name": "LŠmmlein",
    "First Name": "Veronika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676355": {
    "id": "item_29021",
    "Last Name": "KWOK",
    "First Name": "TAN SUM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42677083": {
    "id": "item_14219",
    "Last Name": "Susanto",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42677292": {
    "id": "item_29022",
    "Last Name": "MANTHA",
    "First Name": "UDAY KIRAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42679886": {
    "id": "item_29023",
    "Last Name": "wang",
    "First Name": "zhibin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42680904": {
    "id": "item_29024",
    "Last Name": "Vemulapalli",
    "First Name": "Srinivas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42682764": {
    "id": "item_14220",
    "Last Name": "LIN",
    "First Name": "TSUNG YUAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42684546": {
    "id": "item_29025",
    "Last Name": "BILLIAU",
    "First Name": "Pascale",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42684789": {
    "id": "item_26778",
    "Last Name": "Wisedchanwet",
    "First Name": "Yada",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42685387": {
    "id": "item_26779",
    "Last Name": "Seljak Varga",
    "First Name": "Katja",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42686374": {
    "id": "item_3379",
    "Last Name": "Perme Densa",
    "First Name": "Natalija",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42686551": {
    "id": "item_26780",
    "Last Name": "Chinnappan",
    "First Name": "Satheesh Kumar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42686911": {
    "id": "item_3380",
    "Last Name": "Pavlenko",
    "First Name": "Andrei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42687453": {
    "id": "item_1566",
    "Last Name": "COSTA",
    "First Name": "GUSTAVO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42690428": {
    "id": "item_26781",
    "Last Name": "dos Santos Cardoso",
    "First Name": "Elizandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42690615": {
    "id": "item_3381",
    "Last Name": "ARAUJO",
    "First Name": "SAMUEL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42691246": {
    "id": "item_1567",
    "Last Name": "BIEHL",
    "First Name": "FABIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42692068": {
    "id": "item_14221",
    "Last Name": "Moniz",
    "First Name": "Nalin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42693549": {
    "id": "item_29026",
    "Last Name": "Orlinski",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42693710": {
    "id": "item_29027",
    "Last Name": "escobar",
    "First Name": "fernando",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42694062": {
    "id": "item_14222",
    "Last Name": "Ewing",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42694267": {
    "id": "item_26782",
    "Last Name": "leus",
    "First Name": "vincent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42694598": {
    "id": "item_14223",
    "Last Name": "Majumder",
    "First Name": "Subhasis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42695564": {
    "id": "item_14224",
    "Last Name": "GOMEZ MARTINEZ",
    "First Name": "JESUS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42695622": {
    "id": "item_1568",
    "Last Name": "Mikuz",
    "First Name": "Patrik",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42697361": {
    "id": "item_3382",
    "Last Name": "Zuidgeest",
    "First Name": "Michel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42697496": {
    "id": "item_26783",
    "Last Name": "Fujiwara",
    "First Name": "kiran",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42697582": {
    "id": "item_3383",
    "Last Name": "Ferreira",
    "First Name": "Nuno",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42697942": {
    "id": "item_14225",
    "Last Name": "Chen",
    "First Name": "Yanfeng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42698407": {
    "id": "item_26784",
    "Last Name": "Parikh",
    "First Name": "Devansh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42700781": {
    "id": "item_29028",
    "Last Name": "REZENDE",
    "First Name": "ADRIANA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42701422": {
    "id": "item_26785",
    "Last Name": "TSUCHIYA",
    "First Name": "KENTARO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42702300": {
    "id": "item_29029",
    "Last Name": "Gallia",
    "First Name": "Nimfa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42702995": {
    "id": "item_26786",
    "Last Name": "Rimari",
    "First Name": "Jose Carlos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42703266": {
    "id": "item_26787",
    "Last Name": "Batey",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42703900": {
    "id": "item_29030",
    "Last Name": "Teves Cruz",
    "First Name": "Shiela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42704378": {
    "id": "item_3384",
    "Last Name": "Zobler",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42705104": {
    "id": "item_26788",
    "Last Name": "Vargas Hernandez",
    "First Name": "Jazmin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42706803": {
    "id": "item_1569",
    "Last Name": "Cheng",
    "First Name": "Hsin Jung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42707020": {
    "id": "item_1570",
    "Last Name": "Palacio Suarez",
    "First Name": "Gustavo Enrique",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42707951": {
    "id": "item_14226",
    "Last Name": "Syron",
    "First Name": "Dayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42708676": {
    "id": "item_1571",
    "Last Name": "CARNICER",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42708764": {
    "id": "item_14227",
    "Last Name": "Bhargava",
    "First Name": "Vivek",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42708858": {
    "id": "item_29031",
    "Last Name": "Pudgar",
    "First Name": "Erna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42708915": {
    "id": "item_26789",
    "Last Name": "Thammavongsa",
    "First Name": "Jean-Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709242": {
    "id": "item_1572",
    "Last Name": "Putna",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709640": {
    "id": "item_14228",
    "Last Name": "Putra Sinatrya",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709649": {
    "id": "item_14229",
    "Last Name": "HSU",
    "First Name": "TIEN CHENG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709799": {
    "id": "item_1573",
    "Last Name": "Gong",
    "First Name": "Dubin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710084": {
    "id": "item_29032",
    "Last Name": "Cooper",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710338": {
    "id": "item_26790",
    "Last Name": "Bautista",
    "First Name": "Ralph Recto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710366": {
    "id": "item_26791",
    "Last Name": "Tee-Bautista",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710371": {
    "id": "item_14230",
    "Last Name": "Alcoreza",
    "First Name": "Eliezer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710425": {
    "id": "item_1574",
    "Last Name": "Lopez Camblor",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710663": {
    "id": "item_16398",
    "Last Name": "Daya",
    "First Name": "Ma Gracielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710735": {
    "id": "item_14231",
    "Last Name": "Gadler",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42711140": {
    "id": "item_31106",
    "Last Name": "VILLARROEL",
    "First Name": "CLAUDIA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42711159": {
    "id": "item_14232",
    "Last Name": "chen",
    "First Name": "zhengyun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42711271": {
    "id": "item_29033",
    "Last Name": "SHAH",
    "First Name": "NEERAV",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42711305": {
    "id": "item_29034",
    "Last Name": "LIANG",
    "First Name": "GUANGBIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42711649": {
    "id": "item_16399",
    "Last Name": "Tan",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42712665": {
    "id": "item_1575",
    "Last Name": "Almarzooqi",
    "First Name": "Abdulla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42712892": {
    "id": "item_3385",
    "Last Name": "Heintz",
    "First Name": "Maria",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42713476": {
    "id": "item_29035",
    "Last Name": "Chiang",
    "First Name": "Mun Kit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42714469": {
    "id": "item_16400",
    "Last Name": "Lin",
    "First Name": "Guanting Clifford",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42714675": {
    "id": "item_26792",
    "Last Name": "Kumar",
    "First Name": "Krishna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42715480": {
    "id": "item_3386",
    "Last Name": "LI",
    "First Name": "JUAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42715711": {
    "id": "item_16401",
    "Last Name": "YANG",
    "First Name": "XIAOYING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42715773": {
    "id": "item_16402",
    "Last Name": "Cui",
    "First Name": "Yi Cheng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42715854": {
    "id": "item_26793",
    "Last Name": "LI",
    "First Name": "BEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716030": {
    "id": "item_14233",
    "Last Name": "ZHANG",
    "First Name": "LUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716180": {
    "id": "item_3387",
    "Last Name": "SMITH",
    "First Name": "PAUL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716345": {
    "id": "item_3388",
    "Last Name": "Cen",
    "First Name": "Ying",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716488": {
    "id": "item_29036",
    "Last Name": "Benoza",
    "First Name": "Iris",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716654": {
    "id": "item_3389",
    "Last Name": "Sojer",
    "First Name": "Mitja",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42717320": {
    "id": "item_3390",
    "Last Name": "Kraljevic",
    "First Name": "Ferdo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42717553": {
    "id": "item_1576",
    "Last Name": "Ces",
    "First Name": "Josip",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42717648": {
    "id": "item_16403",
    "Last Name": "IP",
    "First Name": "CHI KWOK",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42718543": {
    "id": "item_26794",
    "Last Name": "Paul",
    "First Name": "Souma Kanti",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42718594": {
    "id": "item_3391",
    "Last Name": "Padgitt",
    "First Name": "Marshall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42718600": {
    "id": "item_16404",
    "Last Name": "Lewis",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42718719": {
    "id": "item_3392",
    "Last Name": "Yip",
    "First Name": "Man Ching",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42718860": {
    "id": "item_3393",
    "Last Name": "Prekodravac",
    "First Name": "Predrag",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42719205": {
    "id": "item_26795",
    "Last Name": "Vasickova",
    "First Name": "Lenka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42719330": {
    "id": "item_26796",
    "Last Name": "Knopp",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42719494": {
    "id": "item_29037",
    "Last Name": "Jian Ju",
    "First Name": "Lu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42720511": {
    "id": "item_26797",
    "Last Name": "Mendoza",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42721154": {
    "id": "item_26798",
    "Last Name": "Shiao",
    "First Name": "Che-Jen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42722111": {
    "id": "item_14234",
    "Last Name": "de Rosnay",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42722353": {
    "id": "item_26799",
    "Last Name": "DOMINGUEZ ALVAREZ",
    "First Name": "JAIME",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42722473": {
    "id": "item_26800",
    "Last Name": "Boscio Vargas",
    "First Name": "Nahir",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42722739": {
    "id": "item_14235",
    "Last Name": "Masaro",
    "First Name": "Loretta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42722960": {
    "id": "item_1577",
    "Last Name": "Rivera Mejia",
    "First Name": "Luis Fernando",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42723705": {
    "id": "item_26801",
    "Last Name": "Heinrich",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42724266": {
    "id": "item_29038",
    "Last Name": "Reddie",
    "First Name": "Alexandria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42724539": {
    "id": "item_31107",
    "Last Name": "Smith",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42724990": {
    "id": "item_29039",
    "Last Name": "SERING",
    "First Name": "HANZEL GRACE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42726826": {
    "id": "item_29040",
    "Last Name": "McInnis",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42727002": {
    "id": "item_1578",
    "Last Name": "Bray",
    "First Name": "Freddie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42727573": {
    "id": "item_3394",
    "Last Name": "cristobal",
    "First Name": "michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42728340": {
    "id": "item_14236",
    "Last Name": "Medina",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42728618": {
    "id": "item_26802",
    "Last Name": "Davey",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42728939": {
    "id": "item_14237",
    "Last Name": "Gaucher",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42729080": {
    "id": "item_26803",
    "Last Name": "Keenan",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42729826": {
    "id": "item_26804",
    "Last Name": "Dai",
    "First Name": "Qian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42730132": {
    "id": "item_29041",
    "Last Name": "UPADHYAYULA",
    "First Name": "NARESH KUMAR",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42730499": {
    "id": "item_1579",
    "Last Name": "BUTTERFIELD",
    "First Name": "KEVIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42731500": {
    "id": "item_3395",
    "Last Name": "Sahota",
    "First Name": "Harjinder",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42732219": {
    "id": "item_26805",
    "Last Name": "Power",
    "First Name": "Desmond",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42732603": {
    "id": "item_14238",
    "Last Name": "Tseng",
    "First Name": "Ming Kuei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42732897": {
    "id": "item_29042",
    "Last Name": "BERG",
    "First Name": "JORDANIA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42733619": {
    "id": "item_29043",
    "Last Name": "ROSAS GUZMAN",
    "First Name": "HUGO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42733743": {
    "id": "item_29044",
    "Last Name": "Aldridge",
    "First Name": "Phillipa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42734886": {
    "id": "item_26806",
    "Last Name": "Rocha",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42735049": {
    "id": "item_26807",
    "Last Name": "SHUM",
    "First Name": "TONG WA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42735830": {
    "id": "item_26808",
    "Last Name": "Brooks",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42735895": {
    "id": "item_26809",
    "Last Name": "Lumanauw",
    "First Name": "Liliane Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736111": {
    "id": "item_14239",
    "Last Name": "jia",
    "First Name": "rongtao",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736223": {
    "id": "item_26810",
    "Last Name": "cheng",
    "First Name": "yang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736459": {
    "id": "item_31108",
    "Last Name": "song",
    "First Name": "yahong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736496": {
    "id": "item_26811",
    "Last Name": "LU",
    "First Name": "LE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736636": {
    "id": "item_16405",
    "Last Name": "Yu",
    "First Name": "Zhizhe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736781": {
    "id": "item_14240",
    "Last Name": "Chao",
    "First Name": "Wenqing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736959": {
    "id": "item_26812",
    "Last Name": "KADOIKE",
    "First Name": "AI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737064": {
    "id": "item_16406",
    "Last Name": "YAMAGUCHI",
    "First Name": "SHINOBU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737201": {
    "id": "item_31109",
    "Last Name": "YAMAGUCHI",
    "First Name": "MASAYO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737296": {
    "id": "item_29045",
    "Last Name": "Leung",
    "First Name": "Kwai Sze",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737366": {
    "id": "item_31110",
    "Last Name": "van der Hoek",
    "First Name": "Joyce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737545": {
    "id": "item_1580",
    "Last Name": "Bongertman",
    "First Name": "Amber",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737558": {
    "id": "item_3396",
    "Last Name": "Bongertman",
    "First Name": "Arinka",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737559": {
    "id": "item_29046",
    "Last Name": "ZHANG",
    "First Name": "WEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737634": {
    "id": "item_16407",
    "Last Name": "SAISAI",
    "First Name": "LIU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737798": {
    "id": "item_26813",
    "Last Name": "CHEW",
    "First Name": "TEE YONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42738430": {
    "id": "item_14241",
    "Last Name": "Winter",
    "First Name": "Bob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42738458": {
    "id": "item_1581",
    "Last Name": "Ferreira",
    "First Name": "Artur",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42739474": {
    "id": "item_14242",
    "Last Name": "CHEUNG",
    "First Name": "SZE YING JENNIFER",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42740124": {
    "id": "item_26814",
    "Last Name": "SILVA",
    "First Name": "IVANILDO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42741064": {
    "id": "item_26815",
    "Last Name": "Putra",
    "First Name": "Agung Andika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42741106": {
    "id": "item_14243",
    "Last Name": "de Miguel Salanova",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42741798": {
    "id": "item_26816",
    "Last Name": "Schultz",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42743129": {
    "id": "item_3397",
    "Last Name": "Steukers",
    "First Name": "Jan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42743488": {
    "id": "item_29047",
    "Last Name": "PULLURU",
    "First Name": "NARESH",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42743625": {
    "id": "item_26817",
    "Last Name": "Schultz",
    "First Name": "Christian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42743695": {
    "id": "item_14244",
    "Last Name": "LIN",
    "First Name": "YEN CHEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42744170": {
    "id": "item_29048",
    "Last Name": "Flores Ch‡vez",
    "First Name": "Adan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42745911": {
    "id": "item_29049",
    "Last Name": "Krishnamaraja",
    "First Name": "Sadhana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42746760": {
    "id": "item_29050",
    "Last Name": "FLORES RAMIREZ",
    "First Name": "PAULINA ANAI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42746952": {
    "id": "item_29051",
    "Last Name": "VILLAFUERTE RODRIGUEZ",
    "First Name": "JHANN PAUL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42747186": {
    "id": "item_3398",
    "Last Name": "Menell",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42748081": {
    "id": "item_26818",
    "Last Name": "Santos",
    "First Name": "Lourdes",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42748591": {
    "id": "item_29052",
    "Last Name": "Vuji_",
    "First Name": "Cvetka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42752086": {
    "id": "item_1582",
    "Last Name": "Haimed",
    "First Name": "Abraham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42752918": {
    "id": "item_3399",
    "Last Name": "Brown",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42754682": {
    "id": "item_14245",
    "Last Name": "Garg",
    "First Name": "Amit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42755021": {
    "id": "item_1583",
    "Last Name": "Saputra",
    "First Name": "Muhammad Hadi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42755626": {
    "id": "item_3400",
    "Last Name": "GUO",
    "First Name": "WEIMIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42756898": {
    "id": "item_14246",
    "Last Name": "MA",
    "First Name": "JUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42757122": {
    "id": "item_1584",
    "Last Name": "MENDOZA GARCIA",
    "First Name": "LUIS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42757895": {
    "id": "item_26819",
    "Last Name": "KLOBUCAR",
    "First Name": "DARKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758077": {
    "id": "item_3401",
    "Last Name": "HUANG",
    "First Name": "ZE XIANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758404": {
    "id": "item_26820",
    "Last Name": "LIN",
    "First Name": "YU-CHU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758419": {
    "id": "item_26821",
    "Last Name": "Wee Hwa",
    "First Name": "Seow",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758742": {
    "id": "item_3402",
    "Last Name": "BŠcker",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758823": {
    "id": "item_26822",
    "Last Name": "LI",
    "First Name": "XI FEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758848": {
    "id": "item_31111",
    "Last Name": "ROY",
    "First Name": "JAYEETA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758879": {
    "id": "item_26823",
    "Last Name": "PENG",
    "First Name": "SHIH-TING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759049": {
    "id": "item_16408",
    "Last Name": "YU",
    "First Name": "CHIN-LUAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759458": {
    "id": "item_1585",
    "Last Name": "HUNG",
    "First Name": "FUNG-YUAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759577": {
    "id": "item_3403",
    "Last Name": "CHANG",
    "First Name": "MING-YI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759726": {
    "id": "item_14247",
    "Last Name": "Raval",
    "First Name": "Tushar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759787": {
    "id": "item_26824",
    "Last Name": "CHEN",
    "First Name": "I-AN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759812": {
    "id": "item_1586",
    "Last Name": "SHA",
    "First Name": "SHA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42760055": {
    "id": "item_14248",
    "Last Name": "Ahmad",
    "First Name": "Muhammad Izwan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42760195": {
    "id": "item_26825",
    "Last Name": "SHEN",
    "First Name": "CHUNG-SUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42760700": {
    "id": "item_14249",
    "Last Name": "Paras",
    "First Name": "Cydea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42761164": {
    "id": "item_3404",
    "Last Name": "SOELTL",
    "First Name": "ROGERIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42761237": {
    "id": "item_3405",
    "Last Name": "TAVARES",
    "First Name": "VERONICA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42761680": {
    "id": "item_26826",
    "Last Name": "Zinner-Wanggo",
    "First Name": "Brigitte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42762894": {
    "id": "item_3406",
    "Last Name": "flanery",
    "First Name": "haley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42762976": {
    "id": "item_26827",
    "Last Name": "Klobucar",
    "First Name": "Anita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42763224": {
    "id": "item_3408",
    "Last Name": "Wong",
    "First Name": "Yuen Yee Shirley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42763226": {
    "id": "item_3407",
    "Last Name": "Chan",
    "First Name": "Wan Yan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42763321": {
    "id": "item_14250",
    "Last Name": "Steukers",
    "First Name": "Bart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42764226": {
    "id": "item_26828",
    "Last Name": "Teixeira",
    "First Name": "Renata",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42764402": {
    "id": "item_3409",
    "Last Name": "Wang",
    "First Name": "Chen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42764414": {
    "id": "item_26829",
    "Last Name": "Cavalcante",
    "First Name": "Naje",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42764688": {
    "id": "item_16409",
    "Last Name": "Pulido Velasco",
    "First Name": "Sara Valentina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42765138": {
    "id": "item_1587",
    "Last Name": "Lemmens",
    "First Name": "Roger",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42765196": {
    "id": "item_26830",
    "Last Name": "ravindran",
    "First Name": "sanjeev",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42767074": {
    "id": "item_26831",
    "Last Name": "Hirsman",
    "First Name": "Alenka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42767120": {
    "id": "item_14251",
    "Last Name": "Kim",
    "First Name": "Chong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42767704": {
    "id": "item_3410",
    "Last Name": "Jamnik",
    "First Name": "Masa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42769103": {
    "id": "item_31112",
    "Last Name": "Biggs",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42769365": {
    "id": "item_1588",
    "Last Name": "Chan",
    "First Name": "Chee Wah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42770994": {
    "id": "item_26832",
    "Last Name": "Luthra",
    "First Name": "Monish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42772095": {
    "id": "item_26833",
    "Last Name": "McAlarey",
    "First Name": "June",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42772198": {
    "id": "item_14252",
    "Last Name": "Herkenhoff",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42776872": {
    "id": "item_26834",
    "Last Name": "Santiago",
    "First Name": "Robert Gabriel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42776994": {
    "id": "item_3411",
    "Last Name": "XU",
    "First Name": "JIANJIANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42778168": {
    "id": "item_14253",
    "Last Name": "Xiaomin",
    "First Name": "Zhang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42778745": {
    "id": "item_29053",
    "Last Name": "Femc",
    "First Name": "Tina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42779142": {
    "id": "item_29054",
    "Last Name": "LIU",
    "First Name": "XIANYA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780219": {
    "id": "item_26835",
    "Last Name": "Abascal Diaz",
    "First Name": "Alvaro Javier",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780247": {
    "id": "item_26836",
    "Last Name": "Abascal de Vicente",
    "First Name": "Alvaro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780268": {
    "id": "item_26837",
    "Last Name": "Abascal de Vicente",
    "First Name": "Victor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780621": {
    "id": "item_1589",
    "Last Name": "Kralj",
    "First Name": "Uros Joze",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780804": {
    "id": "item_26838",
    "Last Name": "Ally",
    "First Name": "Geert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781010": {
    "id": "item_31113",
    "Last Name": "Fauzan",
    "First Name": "Rozan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781049": {
    "id": "item_1590",
    "Last Name": "Sethi",
    "First Name": "Hitesh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781109": {
    "id": "item_3412",
    "Last Name": "Nijboer",
    "First Name": "Jan Roelof",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781133": {
    "id": "item_14254",
    "Last Name": "van Benthem",
    "First Name": "Bart",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781236": {
    "id": "item_3413",
    "Last Name": "de Groot",
    "First Name": "Eelco Jan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781346": {
    "id": "item_26839",
    "Last Name": "Niesen",
    "First Name": "Susanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781477": {
    "id": "item_26840",
    "Last Name": "Platon",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781621": {
    "id": "item_3414",
    "Last Name": "Oetomo",
    "First Name": "Teddy Nuryanto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781722": {
    "id": "item_16410",
    "Last Name": "Boelens",
    "First Name": "Pieter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781755": {
    "id": "item_31114",
    "Last Name": "Mulder",
    "First Name": "Petrus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781812": {
    "id": "item_29055",
    "Last Name": "ZHOU",
    "First Name": "CONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781865": {
    "id": "item_16411",
    "Last Name": "Folye",
    "First Name": "Fanny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782039": {
    "id": "item_26841",
    "Last Name": "Scott",
    "First Name": "Ainslie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782083": {
    "id": "item_16412",
    "Last Name": "Elderenbosch",
    "First Name": "Olaf",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782559": {
    "id": "item_3415",
    "Last Name": "Adam",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782858": {
    "id": "item_29056",
    "Last Name": "Champion",
    "First Name": "Tabitha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782891": {
    "id": "item_26842",
    "Last Name": "Musolino",
    "First Name": "Fabien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782968": {
    "id": "item_29057",
    "Last Name": "Kos",
    "First Name": "Willem Jan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42783059": {
    "id": "item_29058",
    "Last Name": "Fahner e/v Dijk",
    "First Name": "Anna Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42783433": {
    "id": "item_18564",
    "Last Name": "Hayes",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42784086": {
    "id": "item_3416",
    "Last Name": "SACOTO SILVA",
    "First Name": "ANA CRISTINA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42785099": {
    "id": "item_3417",
    "Last Name": "Minon",
    "First Name": "Gael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42785446": {
    "id": "item_16413",
    "Last Name": "Rovan",
    "First Name": "Andrej",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42785571": {
    "id": "item_14255",
    "Last Name": "Lu",
    "First Name": "Ning",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42786593": {
    "id": "item_26843",
    "Last Name": "Platon",
    "First Name": "Marinela Cornelia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42786738": {
    "id": "item_29059",
    "Last Name": "Mahajan",
    "First Name": "DEEPAK",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42787179": {
    "id": "item_29060",
    "Last Name": "Mc Carty",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42787470": {
    "id": "item_16414",
    "Last Name": "Gouws",
    "First Name": "Gert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42787718": {
    "id": "item_14256",
    "Last Name": "Wils",
    "First Name": "Erik",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42787893": {
    "id": "item_14257",
    "Last Name": "Nemes",
    "First Name": "Zsuzsanna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42789402": {
    "id": "item_3418",
    "Last Name": "Pajkic",
    "First Name": "Marija",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42789511": {
    "id": "item_3419",
    "Last Name": "Snel",
    "First Name": "Melvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42789885": {
    "id": "item_29061",
    "Last Name": "Morgan",
    "First Name": "Rory",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42791268": {
    "id": "item_16415",
    "Last Name": "Avila Fernandez",
    "First Name": "Rosa Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42791487": {
    "id": "item_16416",
    "Last Name": "Firme",
    "First Name": "Nicolo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42791661": {
    "id": "item_14258",
    "Last Name": "hoppenbrouwers",
    "First Name": "mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42792462": {
    "id": "item_16417",
    "Last Name": "Koval",
    "First Name": "Juraj",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42792506": {
    "id": "item_14259",
    "Last Name": "Timmer",
    "First Name": "Harald",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42793292": {
    "id": "item_14260",
    "Last Name": "Malecki",
    "First Name": "Tomasz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42793416": {
    "id": "item_14261",
    "Last Name": "Malecka",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42794175": {
    "id": "item_3420",
    "Last Name": "Sankaranarayanan",
    "First Name": "Sathya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42794280": {
    "id": "item_26844",
    "Last Name": "Flores Ramirez",
    "First Name": "Luisa Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42794310": {
    "id": "item_1591",
    "Last Name": "Rijk",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42795022": {
    "id": "item_26845",
    "Last Name": "Puttananjaiah",
    "First Name": "Praveen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42796600": {
    "id": "item_26846",
    "Last Name": "Powers",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42796877": {
    "id": "item_1592",
    "Last Name": "Costa",
    "First Name": "Newton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42797611": {
    "id": "item_3421",
    "Last Name": "Tay",
    "First Name": "Derek",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42797938": {
    "id": "item_29062",
    "Last Name": "Gopaul",
    "First Name": "Julissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42798725": {
    "id": "item_1593",
    "Last Name": "Sharma",
    "First Name": "Ashoke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42799291": {
    "id": "item_26847",
    "Last Name": "Carrasco",
    "First Name": "Jose Antionio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42799885": {
    "id": "item_31115",
    "Last Name": "Mahamad",
    "First Name": "Intiaz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42799990": {
    "id": "item_14262",
    "Last Name": "Gortan",
    "First Name": "Jean-Pierre",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42800659": {
    "id": "item_3422",
    "Last Name": "Honglin",
    "First Name": "ZHANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42800772": {
    "id": "item_29063",
    "Last Name": "Janoff",
    "First Name": "Sybil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42800900": {
    "id": "item_3423",
    "Last Name": "Zhiyong",
    "First Name": "He",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42800955": {
    "id": "item_26848",
    "Last Name": "Diez",
    "First Name": "Fermin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42800980": {
    "id": "item_14263",
    "Last Name": "CORREA",
    "First Name": "ANDREA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42801191": {
    "id": "item_14264",
    "Last Name": "ALMONACID",
    "First Name": "ANA CAROLINA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42801198": {
    "id": "item_26849",
    "Last Name": "Mandat",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42801762": {
    "id": "item_26850",
    "Last Name": "Trav’a",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42801865": {
    "id": "item_29064",
    "Last Name": "Munoz Pena",
    "First Name": "Linda Mireya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42802270": {
    "id": "item_3424",
    "Last Name": "Widjaja",
    "First Name": "Silvia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42802502": {
    "id": "item_26851",
    "Last Name": "jeffers",
    "First Name": "kenneth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42803698": {
    "id": "item_16418",
    "Last Name": "wu",
    "First Name": "liang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42803907": {
    "id": "item_14265",
    "Last Name": "Rivera",
    "First Name": "Juan Jaime",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42804237": {
    "id": "item_3425",
    "Last Name": "Li",
    "First Name": "Yinuo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805200": {
    "id": "item_3426",
    "Last Name": "Topanyarueang",
    "First Name": "Thanaphon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805363": {
    "id": "item_1594",
    "Last Name": "Banas",
    "First Name": "Joseph Andre",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805417": {
    "id": "item_31116",
    "Last Name": "Gonzalez",
    "First Name": "Dionisio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805454": {
    "id": "item_14266",
    "Last Name": "Ngaoprasert",
    "First Name": "Surajade",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805495": {
    "id": "item_31117",
    "Last Name": "GONZALEZ",
    "First Name": "MARIA DOLORES",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805690": {
    "id": "item_14267",
    "Last Name": "Gevers",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805797": {
    "id": "item_26852",
    "Last Name": "Keesmaat",
    "First Name": "Lloyd",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805867": {
    "id": "item_16419",
    "Last Name": "Wenjing",
    "First Name": "Li",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805949": {
    "id": "item_26853",
    "Last Name": "LUO",
    "First Name": "LING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806443": {
    "id": "item_1595",
    "Last Name": "CHEN",
    "First Name": "YINGNAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806484": {
    "id": "item_14268",
    "Last Name": "KYRIAKIDOU",
    "First Name": "RACHIL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806526": {
    "id": "item_26854",
    "Last Name": "Tuck",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806604": {
    "id": "item_3427",
    "Last Name": "Amega",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806696": {
    "id": "item_14269",
    "Last Name": "Ma",
    "First Name": "Shuang Shuang",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807175": {
    "id": "item_16420",
    "Last Name": "Sekhula",
    "First Name": "Masilo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807839": {
    "id": "item_16421",
    "Last Name": "Mogale",
    "First Name": "Lerato Dorothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807885": {
    "id": "item_29065",
    "Last Name": "Marupen",
    "First Name": "Fergus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807944": {
    "id": "item_16422",
    "Last Name": "van Beek",
    "First Name": "Gerrit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42808031": {
    "id": "item_3428",
    "Last Name": "Matimba",
    "First Name": "Abongile",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42808052": {
    "id": "item_3429",
    "Last Name": "LEE",
    "First Name": "EUNHEE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42808195": {
    "id": "item_16423",
    "Last Name": "Siwele",
    "First Name": "Soul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42808359": {
    "id": "item_29066",
    "Last Name": "Yano",
    "First Name": "Tadashi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809005": {
    "id": "item_1596",
    "Last Name": "GUPTA",
    "First Name": "MANOJ",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809014": {
    "id": "item_3430",
    "Last Name": "havlin",
    "First Name": "Edna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809314": {
    "id": "item_16424",
    "Last Name": "Prestifilippo",
    "First Name": "Silvio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809422": {
    "id": "item_1597",
    "Last Name": "KANYIKE",
    "First Name": "RONALD",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809445": {
    "id": "item_16425",
    "Last Name": "Hutter",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809486": {
    "id": "item_29067",
    "Last Name": "Davaa",
    "First Name": "Amarjargal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809892": {
    "id": "item_3431",
    "Last Name": "Reichel",
    "First Name": "Ann-Catrin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42810861": {
    "id": "item_26855",
    "Last Name": "Romadhan",
    "First Name": "Meddy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42811980": {
    "id": "item_3432",
    "Last Name": "pan",
    "First Name": "tao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42812207": {
    "id": "item_14270",
    "Last Name": "Verstegen",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42812627": {
    "id": "item_14271",
    "Last Name": "Khilla",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42813933": {
    "id": "item_29068",
    "Last Name": "ZAMORA MONTESINOS",
    "First Name": "JOSE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42814236": {
    "id": "item_26856",
    "Last Name": "Leihbecher",
    "First Name": "Jens",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42814247": {
    "id": "item_31118",
    "Last Name": "Brown",
    "First Name": "Marilyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42814357": {
    "id": "item_16426",
    "Last Name": "Hubmann",
    "First Name": "Astrid Franziska",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42814375": {
    "id": "item_26857",
    "Last Name": "Tyala",
    "First Name": "Khanyisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42814389": {
    "id": "item_14272",
    "Last Name": "Webb",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42814647": {
    "id": "item_29069",
    "Last Name": "Fasold",
    "First Name": "Frank",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42815431": {
    "id": "item_26858",
    "Last Name": "Gadhoke",
    "First Name": "Navjeet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42815897": {
    "id": "item_3433",
    "Last Name": "Ten Wolde",
    "First Name": "Lisette",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42816319": {
    "id": "item_26859",
    "Last Name": "Vacariu",
    "First Name": "Simona Dana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42817605": {
    "id": "item_16427",
    "Last Name": "Sithole",
    "First Name": "Silindile Marcia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42817724": {
    "id": "item_26860",
    "Last Name": "Yengwa",
    "First Name": "Uslindile",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42817792": {
    "id": "item_14273",
    "Last Name": "Langier",
    "First Name": "Daniel Juan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42822469": {
    "id": "item_29070",
    "Last Name": "Kalra",
    "First Name": "Monisha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42824418": {
    "id": "item_14274",
    "Last Name": "Walterhouse",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42824514": {
    "id": "item_14275",
    "Last Name": "Kotrady",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42824754": {
    "id": "item_14276",
    "Last Name": "MONTILLA",
    "First Name": "CASILDA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42827223": {
    "id": "item_1598",
    "Last Name": "Paz",
    "First Name": "Lester",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42827273": {
    "id": "item_16428",
    "Last Name": "van Brakel",
    "First Name": "Paulus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42828330": {
    "id": "item_31119",
    "Last Name": "Jerman",
    "First Name": "Karin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42829383": {
    "id": "item_3434",
    "Last Name": "Armbrust",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42829713": {
    "id": "item_26861",
    "Last Name": "Young",
    "First Name": "Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42830216": {
    "id": "item_14277",
    "Last Name": "Mesa",
    "First Name": "Roberto felipe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833019": {
    "id": "item_26862",
    "Last Name": "OBREGON HERNANDEZ",
    "First Name": "OMAR",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833246": {
    "id": "item_26863",
    "Last Name": "Hartley",
    "First Name": "Cassie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833427": {
    "id": "item_3435",
    "Last Name": "Banton",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833492": {
    "id": "item_16429",
    "Last Name": "Melancon",
    "First Name": "Sylvain",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833606": {
    "id": "item_26864",
    "Last Name": "Loaney",
    "First Name": "Blake",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834064": {
    "id": "item_29071",
    "Last Name": "Cheung",
    "First Name": "Ying Man Serena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834075": {
    "id": "item_26865",
    "Last Name": "Hebbard",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834117": {
    "id": "item_1599",
    "Last Name": "Collea",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834146": {
    "id": "item_31120",
    "Last Name": "KALPattu",
    "First Name": "Ganesan Srinivasan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834170": {
    "id": "item_26866",
    "Last Name": "Myers",
    "First Name": "Nuria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834932": {
    "id": "item_1600",
    "Last Name": "Lin",
    "First Name": "Yiru",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834942": {
    "id": "item_3436",
    "Last Name": "Bernardino",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42835028": {
    "id": "item_1601",
    "Last Name": "Lin",
    "First Name": "Powei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42835741": {
    "id": "item_14278",
    "Last Name": "Pongsak",
    "First Name": "Kongtawat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42835968": {
    "id": "item_14279",
    "Last Name": "Tran",
    "First Name": "Hong Hanh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836074": {
    "id": "item_26867",
    "Last Name": "Srivichai",
    "First Name": "Chunlatid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836119": {
    "id": "item_26868",
    "Last Name": "Yongvanichakorn",
    "First Name": "Thongchai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836356": {
    "id": "item_1602",
    "Last Name": "Pasillas",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836481": {
    "id": "item_26869",
    "Last Name": "Kiatikajornthada",
    "First Name": "Ratakorn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836598": {
    "id": "item_3437",
    "Last Name": "Macartney",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836640": {
    "id": "item_16430",
    "Last Name": "Schwartz",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836717": {
    "id": "item_26870",
    "Last Name": "JAMALUDIN",
    "First Name": "MAZHAIRUL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836732": {
    "id": "item_26871",
    "Last Name": "Griffiths",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837051": {
    "id": "item_1603",
    "Last Name": "Pothikamjorn",
    "First Name": "Tana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837092": {
    "id": "item_26872",
    "Last Name": "Srisanguansakul",
    "First Name": "Sittichai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837113": {
    "id": "item_26873",
    "Last Name": "Eammongkolchai",
    "First Name": "Pichitpon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837117": {
    "id": "item_3438",
    "Last Name": "Law",
    "First Name": "Kam Leung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837119": {
    "id": "item_3439",
    "Last Name": "Jazon",
    "First Name": "Enrique II",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837240": {
    "id": "item_29072",
    "Last Name": "Pearson",
    "First Name": "Coralie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837349": {
    "id": "item_26874",
    "Last Name": "Cui",
    "First Name": "Shuaiguan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837412": {
    "id": "item_29073",
    "Last Name": "Abdullah",
    "First Name": "Fahrin arifinsyah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837511": {
    "id": "item_26875",
    "Last Name": "Moore",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837714": {
    "id": "item_26876",
    "Last Name": "Liu",
    "First Name": "Su",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837784": {
    "id": "item_1604",
    "Last Name": "GUPTA",
    "First Name": "SANGITA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837936": {
    "id": "item_3440",
    "Last Name": "Kwan",
    "First Name": "Tat Shing",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837950": {
    "id": "item_26877",
    "Last Name": "Kumala Sari",
    "First Name": "Carissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838007": {
    "id": "item_16431",
    "Last Name": "de Guzman",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838225": {
    "id": "item_26878",
    "Last Name": "Tangsunawan",
    "First Name": "Porntip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838336": {
    "id": "item_31121",
    "Last Name": "Schmaman",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838400": {
    "id": "item_1605",
    "Last Name": "Kanchanasevee",
    "First Name": "Charinya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838699": {
    "id": "item_16432",
    "Last Name": "Dentham",
    "First Name": "Purikorn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838729": {
    "id": "item_16433",
    "Last Name": "van Echelpoel",
    "First Name": "Alexander Josef",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838792": {
    "id": "item_1606",
    "Last Name": "Turner",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838838": {
    "id": "item_3441",
    "Last Name": "Pearson",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839044": {
    "id": "item_1607",
    "Last Name": "Rischbieth",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839087": {
    "id": "item_3442",
    "Last Name": "Verma",
    "First Name": "Rajeev",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839222": {
    "id": "item_26879",
    "Last Name": "Kookla",
    "First Name": "Eero",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839230": {
    "id": "item_29074",
    "Last Name": "Bernardo",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839251": {
    "id": "item_29075",
    "Last Name": "Sizer",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839347": {
    "id": "item_14280",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839356": {
    "id": "item_1608",
    "Last Name": "BUTT",
    "First Name": "HAMID",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839445": {
    "id": "item_26880",
    "Last Name": "Dionisio",
    "First Name": "Rowell Ace",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839457": {
    "id": "item_26881",
    "Last Name": "Wu",
    "First Name": "Xiaohua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839573": {
    "id": "item_1609",
    "Last Name": "Zargari",
    "First Name": "Nissim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839637": {
    "id": "item_26882",
    "Last Name": "Lien",
    "First Name": "Hsiao-I",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839759": {
    "id": "item_14281",
    "Last Name": "Chang",
    "First Name": "Shao Ning",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839791": {
    "id": "item_3443",
    "Last Name": "Sutera Sardo",
    "First Name": "Manlio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839792": {
    "id": "item_14282",
    "Last Name": "CHAN",
    "First Name": "CHENG WEI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839896": {
    "id": "item_26883",
    "Last Name": "Rongavilla",
    "First Name": "Paula Katherina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840063": {
    "id": "item_14283",
    "Last Name": "CHANG",
    "First Name": "CHENG WEI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840068": {
    "id": "item_14284",
    "Last Name": "Stabile",
    "First Name": "Carlo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840117": {
    "id": "item_14285",
    "Last Name": "Reyes",
    "First Name": "Dino",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840138": {
    "id": "item_29076",
    "Last Name": "Fazio",
    "First Name": "Nicolino",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840161": {
    "id": "item_14286",
    "Last Name": "PENG",
    "First Name": "KUEI CHEN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840195": {
    "id": "item_14287",
    "Last Name": "Rondat",
    "First Name": "Olivier",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840214": {
    "id": "item_26884",
    "Last Name": "Chanpaibool",
    "First Name": "Unnop",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840246": {
    "id": "item_29077",
    "Last Name": "GAN",
    "First Name": "REYNOLD",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840406": {
    "id": "item_14288",
    "Last Name": "Heine",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840423": {
    "id": "item_29078",
    "Last Name": "Tan",
    "First Name": "Jenny Lyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840457": {
    "id": "item_16434",
    "Last Name": "Abele",
    "First Name": "Bettina Julia Verena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840490": {
    "id": "item_3444",
    "Last Name": "Wong",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840537": {
    "id": "item_26885",
    "Last Name": "KUBOTA",
    "First Name": "TAKASHI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840573": {
    "id": "item_26886",
    "Last Name": "Sirisuwalak",
    "First Name": "Jedsada",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840592": {
    "id": "item_29079",
    "Last Name": "Soenario",
    "First Name": "Sri Hartanti",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840605": {
    "id": "item_31122",
    "Last Name": "Tononi",
    "First Name": "Aldo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840613": {
    "id": "item_14289",
    "Last Name": "Inocencio",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840684": {
    "id": "item_16435",
    "Last Name": "pisano",
    "First Name": "giovanni",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840721": {
    "id": "item_3445",
    "Last Name": "Alvarez",
    "First Name": "Uziel Ganotice",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840932": {
    "id": "item_1610",
    "Last Name": "Lee",
    "First Name": "Jungil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840978": {
    "id": "item_26887",
    "Last Name": "Soni",
    "First Name": "Vikal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841231": {
    "id": "item_3446",
    "Last Name": "Forassiepi",
    "First Name": "Enrico",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841350": {
    "id": "item_26888",
    "Last Name": "Castro",
    "First Name": "Jose Lorenzo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841357": {
    "id": "item_3447",
    "Last Name": "Lee",
    "First Name": "Hong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841395": {
    "id": "item_26889",
    "Last Name": "Zabko",
    "First Name": "Jaroslaw",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841411": {
    "id": "item_29080",
    "Last Name": "Zhang",
    "First Name": "MingLei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841501": {
    "id": "item_14290",
    "Last Name": "Drygas",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841573": {
    "id": "item_29081",
    "Last Name": "Yap",
    "First Name": "Sierra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841658": {
    "id": "item_16436",
    "Last Name": "Sadek",
    "First Name": "Ismail",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841793": {
    "id": "item_16437",
    "Last Name": "Vandebergh",
    "First Name": "Morgane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841888": {
    "id": "item_26890",
    "Last Name": "zanone",
    "First Name": "massimo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842361": {
    "id": "item_3448",
    "Last Name": "GUIDI",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842387": {
    "id": "item_14291",
    "Last Name": "Conti",
    "First Name": "Samuele",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842485": {
    "id": "item_29082",
    "Last Name": "Adisuryo",
    "First Name": "Danisworo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842565": {
    "id": "item_29083",
    "Last Name": "Moslund",
    "First Name": "Ronnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842623": {
    "id": "item_31123",
    "Last Name": "Digito",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842794": {
    "id": "item_3449",
    "Last Name": "Moser",
    "First Name": "Wolfgang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842871": {
    "id": "item_26891",
    "Last Name": "Kuek",
    "First Name": "Chrystle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842980": {
    "id": "item_26892",
    "Last Name": "Usman",
    "First Name": "Jamasali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843093": {
    "id": "item_3450",
    "Last Name": "Walker",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843413": {
    "id": "item_29084",
    "Last Name": "Child",
    "First Name": "Kaaryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843561": {
    "id": "item_29085",
    "Last Name": "Siddique",
    "First Name": "Zareen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843703": {
    "id": "item_1611",
    "Last Name": "VçZQUEZ OREJAS",
    "First Name": "JAVIER ANGEL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843882": {
    "id": "item_29086",
    "Last Name": "Masuda-Duttlinger",
    "First Name": "Horst",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42844229": {
    "id": "item_26893",
    "Last Name": "Marzoli",
    "First Name": "Daniela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42844534": {
    "id": "item_1612",
    "Last Name": "Bšhmer",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42844925": {
    "id": "item_14292",
    "Last Name": "L—pez Hern‡ndez",
    "First Name": "Daniela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42845448": {
    "id": "item_29087",
    "Last Name": "Visram",
    "First Name": "Amyna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42846343": {
    "id": "item_3451",
    "Last Name": "Hepburn",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42846457": {
    "id": "item_14293",
    "Last Name": "Kitsahawong",
    "First Name": "Somsak",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42846521": {
    "id": "item_29088",
    "Last Name": "Palladino",
    "First Name": "Jillian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42846550": {
    "id": "item_3452",
    "Last Name": "kancharla",
    "First Name": "Venkata sandeep",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847166": {
    "id": "item_26894",
    "Last Name": "Zahari",
    "First Name": "Mimiwati",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847510": {
    "id": "item_14294",
    "Last Name": "Tarantik",
    "First Name": "Josef",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847608": {
    "id": "item_31124",
    "Last Name": "Syling",
    "First Name": "Tyrone",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847672": {
    "id": "item_29089",
    "Last Name": "Conway",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847779": {
    "id": "item_1613",
    "Last Name": "Tirziu",
    "First Name": "Catalin Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42848294": {
    "id": "item_1614",
    "Last Name": "Hyde",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42848402": {
    "id": "item_14295",
    "Last Name": "Panaput",
    "First Name": "Thanachai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42848507": {
    "id": "item_26895",
    "Last Name": "Putra",
    "First Name": "Nurdana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42848945": {
    "id": "item_29090",
    "Last Name": "Oliva",
    "First Name": "Nestor Hugo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849213": {
    "id": "item_16438",
    "Last Name": "Hoey",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849301": {
    "id": "item_26896",
    "Last Name": "Chan",
    "First Name": "Zhi Hui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849562": {
    "id": "item_14296",
    "Last Name": "Jager",
    "First Name": "Hieke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849600": {
    "id": "item_29091",
    "Last Name": "NG",
    "First Name": "Gino",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849701": {
    "id": "item_16439",
    "Last Name": "Sah",
    "First Name": "Sudha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849856": {
    "id": "item_14297",
    "Last Name": "TORRES",
    "First Name": "ADELIO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42850037": {
    "id": "item_26897",
    "Last Name": "BURATTIN",
    "First Name": "DARIO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42850340": {
    "id": "item_26898",
    "Last Name": "Pecoroni",
    "First Name": "Susanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42850693": {
    "id": "item_16440",
    "Last Name": "Kopij",
    "First Name": "Maciej",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42851408": {
    "id": "item_26900",
    "Last Name": "CHIOCCOLA",
    "First Name": "FRANCESCA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42851409": {
    "id": "item_26899",
    "Last Name": "Robertson",
    "First Name": "Colin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42851482": {
    "id": "item_29092",
    "Last Name": "Joseph",
    "First Name": "Marva C.",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42851618": {
    "id": "item_14298",
    "Last Name": "PORRICELLI",
    "First Name": "MASSIMO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42851711": {
    "id": "item_29093",
    "Last Name": "mwiche",
    "First Name": "veronica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42851950": {
    "id": "item_3453",
    "Last Name": "Noy",
    "First Name": "Gaddy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852081": {
    "id": "item_1615",
    "Last Name": "Rei§inger",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852146": {
    "id": "item_16441",
    "Last Name": "Hill",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852151": {
    "id": "item_14299",
    "Last Name": "Diaz Jouanen",
    "First Name": "Luis Humberto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852519": {
    "id": "item_26901",
    "Last Name": "Sjoholm",
    "First Name": "Mikael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852741": {
    "id": "item_29094",
    "Last Name": "Brink",
    "First Name": "Brigitte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42853104": {
    "id": "item_26902",
    "Last Name": "Brandt",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42853673": {
    "id": "item_29095",
    "Last Name": "Nunez Gary",
    "First Name": "Joyce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42854971": {
    "id": "item_16442",
    "Last Name": "Erichsen",
    "First Name": "Nicolai Frisch",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42855464": {
    "id": "item_16443",
    "Last Name": "Erichsen",
    "First Name": "Sidse Frisch",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42860111": {
    "id": "item_1616",
    "Last Name": "LACHARRIERE",
    "First Name": "FRANCOIS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42860533": {
    "id": "item_14300",
    "Last Name": "Longstaffe",
    "First Name": "Colette",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42865920": {
    "id": "item_29096",
    "Last Name": "Torkington",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42866815": {
    "id": "item_29097",
    "Last Name": "Evans",
    "First Name": "Gretchen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42870383": {
    "id": "item_3454",
    "Last Name": "Zaleckas",
    "First Name": "Gintautas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42872155": {
    "id": "item_1617",
    "Last Name": "Connolly",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42874927": {
    "id": "item_29098",
    "Last Name": "Zaman",
    "First Name": "Shari",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42875262": {
    "id": "item_29099",
    "Last Name": "Scially",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42875595": {
    "id": "item_16444",
    "Last Name": "NICASTRI",
    "First Name": "FRANCESCO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42875884": {
    "id": "item_31125",
    "Last Name": "Silk",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876007": {
    "id": "item_14301",
    "Last Name": "Little",
    "First Name": "L'Kel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876077": {
    "id": "item_16445",
    "Last Name": "Woditsch",
    "First Name": "Philipp",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876196": {
    "id": "item_14302",
    "Last Name": "BAE",
    "First Name": "JONGSEUK",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876322": {
    "id": "item_29100",
    "Last Name": "Rabun",
    "First Name": "Madison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876358": {
    "id": "item_14303",
    "Last Name": "Diaz Osuna",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876373": {
    "id": "item_16446",
    "Last Name": "Zes",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876397": {
    "id": "item_3455",
    "Last Name": "Krewer",
    "First Name": "Brenden",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876491": {
    "id": "item_3456",
    "Last Name": "Baggett",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876720": {
    "id": "item_1618",
    "Last Name": "Verdin dorantes",
    "First Name": "Georgina isabel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876781": {
    "id": "item_1619",
    "Last Name": "del Rio",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876972": {
    "id": "item_26903",
    "Last Name": "Wong",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42877140": {
    "id": "item_1620",
    "Last Name": "Polley",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42877373": {
    "id": "item_3457",
    "Last Name": "Adcock",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42877489": {
    "id": "item_26904",
    "Last Name": "indriyati",
    "First Name": "sri rahayu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42877586": {
    "id": "item_26905",
    "Last Name": "Emblin",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42877768": {
    "id": "item_29101",
    "Last Name": "Jolly",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42878141": {
    "id": "item_14304",
    "Last Name": "Chong",
    "First Name": "Chi Kong Adwan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42878640": {
    "id": "item_1621",
    "Last Name": "Leonard",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42879385": {
    "id": "item_29102",
    "Last Name": "Sabourin",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42880137": {
    "id": "item_1622",
    "Last Name": "Ewing",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42880288": {
    "id": "item_29103",
    "Last Name": "Sylvia",
    "First Name": "Angellia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42880427": {
    "id": "item_31126",
    "Last Name": "Hummel",
    "First Name": "Barry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42881339": {
    "id": "item_26906",
    "Last Name": "WU",
    "First Name": "SIT HUNG TERRY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42881455": {
    "id": "item_16447",
    "Last Name": "Sanchez",
    "First Name": "Luisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42881569": {
    "id": "item_29104",
    "Last Name": "Hau",
    "First Name": "Chi Wing",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42881795": {
    "id": "item_16448",
    "Last Name": "Olsen",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42881902": {
    "id": "item_26907",
    "Last Name": "BIGELOW",
    "First Name": "BRIAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42881909": {
    "id": "item_26908",
    "Last Name": "Langsdorf",
    "First Name": "Sonya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42882087": {
    "id": "item_26909",
    "Last Name": "Thompson",
    "First Name": "Millie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42885191": {
    "id": "item_14305",
    "Last Name": "Jones",
    "First Name": "Lara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42885473": {
    "id": "item_26910",
    "Last Name": "Mauricio",
    "First Name": "Mark Jerome",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886037": {
    "id": "item_3458",
    "Last Name": "JANG",
    "First Name": "BYUNGHYEON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886244": {
    "id": "item_3459",
    "Last Name": "HSUEH",
    "First Name": "JEN HAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886264": {
    "id": "item_1623",
    "Last Name": "Ling",
    "First Name": "Pei Shurn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886740": {
    "id": "item_29105",
    "Last Name": "ALIMCHANDAN",
    "First Name": "LATA GULOO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886746": {
    "id": "item_1624",
    "Last Name": "Chiu",
    "First Name": "Chih Hsien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886987": {
    "id": "item_14306",
    "Last Name": "Sever",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887198": {
    "id": "item_26911",
    "Last Name": "Almario",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888104": {
    "id": "item_1625",
    "Last Name": "FUNG",
    "First Name": "WING KWONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888290": {
    "id": "item_16449",
    "Last Name": "KELDERER",
    "First Name": "DOROTHEA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888392": {
    "id": "item_29106",
    "Last Name": "Gotama",
    "First Name": "Andrie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888569": {
    "id": "item_16450",
    "Last Name": "Aikman",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888615": {
    "id": "item_1626",
    "Last Name": "van Leipsig",
    "First Name": "Cees",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888661": {
    "id": "item_26912",
    "Last Name": "Swanepoel",
    "First Name": "Magdeleen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888726": {
    "id": "item_16451",
    "Last Name": "Roberts",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888904": {
    "id": "item_14307",
    "Last Name": "Yeung",
    "First Name": "Nelson Kam Hin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888908": {
    "id": "item_3460",
    "Last Name": "Fagandini",
    "First Name": "Davide",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888997": {
    "id": "item_16452",
    "Last Name": "Truelsen",
    "First Name": "S¿ren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889099": {
    "id": "item_3461",
    "Last Name": "Ahuja",
    "First Name": "Rajiv",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889311": {
    "id": "item_14308",
    "Last Name": "CHEN",
    "First Name": "LI SZU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889345": {
    "id": "item_14309",
    "Last Name": "KU",
    "First Name": "HSIAO LING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889378": {
    "id": "item_16453",
    "Last Name": "Chui",
    "First Name": "Wai Shing",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889462": {
    "id": "item_26913",
    "Last Name": "Chandra",
    "First Name": "Johan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889481": {
    "id": "item_1627",
    "Last Name": "Richter",
    "First Name": "Christoph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889540": {
    "id": "item_16454",
    "Last Name": "Luo",
    "First Name": "Yu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889682": {
    "id": "item_14310",
    "Last Name": "van Eijkelenburg",
    "First Name": "Kjelt",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889734": {
    "id": "item_26914",
    "Last Name": "Kloth-Henkel",
    "First Name": "Gerhard Otto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890239": {
    "id": "item_14311",
    "Last Name": "Guehrs",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890292": {
    "id": "item_29107",
    "Last Name": "Blom",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890729": {
    "id": "item_3462",
    "Last Name": "Anoih",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890735": {
    "id": "item_29108",
    "Last Name": "Karmoy",
    "First Name": "Rendyika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890791": {
    "id": "item_31127",
    "Last Name": "Hendrawan",
    "First Name": "Cahya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890806": {
    "id": "item_26915",
    "Last Name": "Nadurata",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42891233": {
    "id": "item_31128",
    "Last Name": "Mattadjong",
    "First Name": "Irna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42891767": {
    "id": "item_26916",
    "Last Name": "Carnahan",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42891972": {
    "id": "item_3463",
    "Last Name": "Luo",
    "First Name": "Binbin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892105": {
    "id": "item_31129",
    "Last Name": "Mohd Yusof",
    "First Name": "Mohd Akhmal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892305": {
    "id": "item_14312",
    "Last Name": "Kooij",
    "First Name": "Marjet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892822": {
    "id": "item_26917",
    "Last Name": "Yusuf",
    "First Name": "Ari Wibawa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892871": {
    "id": "item_29109",
    "Last Name": "DE LUCA",
    "First Name": "PAOLO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42893189": {
    "id": "item_26918",
    "Last Name": "Vanichjakvong",
    "First Name": "Sukanya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42893803": {
    "id": "item_26919",
    "Last Name": "Pichetpongsa",
    "First Name": "Anant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42893999": {
    "id": "item_26920",
    "Last Name": "Persinger",
    "First Name": "Ryanne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42894154": {
    "id": "item_26921",
    "Last Name": "Quilendrino",
    "First Name": "Josser Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42894242": {
    "id": "item_26922",
    "Last Name": "Montejo",
    "First Name": "Ralph Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42894768": {
    "id": "item_14313",
    "Last Name": "FARACE",
    "First Name": "CARLO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42895164": {
    "id": "item_26923",
    "Last Name": "Kurniawan Hasudungan",
    "First Name": "Teguh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42895170": {
    "id": "item_1628",
    "Last Name": "LIM",
    "First Name": "KIAN WEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42895254": {
    "id": "item_1629",
    "Last Name": "BŸnermann",
    "First Name": "Bjšrn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42895606": {
    "id": "item_26924",
    "Last Name": "Spanjer",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42896235": {
    "id": "item_16455",
    "Last Name": "Mwape",
    "First Name": "Thandie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42898009": {
    "id": "item_26925",
    "Last Name": "Loaiza Blanco",
    "First Name": "Danish",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42900327": {
    "id": "item_29110",
    "Last Name": "Larsen",
    "First Name": "Morten Ousted",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42905599": {
    "id": "item_3464",
    "Last Name": "Chinchilla Vargas",
    "First Name": "Celso",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42906249": {
    "id": "item_26926",
    "Last Name": "garcia",
    "First Name": "maria aurora",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42907286": {
    "id": "item_16456",
    "Last Name": "Vats",
    "First Name": "Sudhanshu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42908065": {
    "id": "item_14314",
    "Last Name": "Wambua",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42908178": {
    "id": "item_26927",
    "Last Name": "Castro",
    "First Name": "Luis Miguel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42911704": {
    "id": "item_1630",
    "Last Name": "Klaus",
    "First Name": "Luca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42921826": {
    "id": "item_14315",
    "Last Name": "Pinto",
    "First Name": "Luna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42922402": {
    "id": "item_26928",
    "Last Name": "Buhler",
    "First Name": "Joan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42926671": {
    "id": "item_14316",
    "Last Name": "Akdemir",
    "First Name": "Muzaffer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42929250": {
    "id": "item_3465",
    "Last Name": "Brock",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42929901": {
    "id": "item_14317",
    "Last Name": "van Pomp",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42934780": {
    "id": "item_31130",
    "Last Name": "Long",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42934829": {
    "id": "item_29111",
    "Last Name": "Laconich",
    "First Name": "Andrea Josefina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42935219": {
    "id": "item_29112",
    "Last Name": "Hetzel",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42935543": {
    "id": "item_16457",
    "Last Name": "Stuhldreier-Christ",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42935600": {
    "id": "item_26929",
    "Last Name": "Hale",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42936862": {
    "id": "item_26930",
    "Last Name": "Altavilla",
    "First Name": "Salvatore",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42936888": {
    "id": "item_29113",
    "Last Name": "CEBALLOS",
    "First Name": "MARCO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42937364": {
    "id": "item_29114",
    "Last Name": "Miyachi",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42939910": {
    "id": "item_26931",
    "Last Name": "Fung",
    "First Name": "Zena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42940861": {
    "id": "item_1631",
    "Last Name": "Loh",
    "First Name": "Guo pei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42941825": {
    "id": "item_14318",
    "Last Name": "Grinnell",
    "First Name": "Benjamin Geoffrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42943070": {
    "id": "item_26932",
    "Last Name": "Dixon",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42943430": {
    "id": "item_29115",
    "Last Name": "Daengkul",
    "First Name": "Petcharat",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42943623": {
    "id": "item_26933",
    "Last Name": "Santana",
    "First Name": "Luz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42945725": {
    "id": "item_3466",
    "Last Name": "Law",
    "First Name": "Sau Ting",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42946125": {
    "id": "item_26934",
    "Last Name": "SIM",
    "First Name": "GUEK AI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42946909": {
    "id": "item_29116",
    "Last Name": "Cheung",
    "First Name": "Mun Yee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42948923": {
    "id": "item_3467",
    "Last Name": "Fenton",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42949093": {
    "id": "item_26935",
    "Last Name": "Aerni",
    "First Name": "Hans Rudolf",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42949279": {
    "id": "item_26936",
    "Last Name": "Byrne",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42949796": {
    "id": "item_3468",
    "Last Name": "EUN",
    "First Name": "YOO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950028": {
    "id": "item_16458",
    "Last Name": "IDRUS",
    "First Name": "CHRISTIAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950044": {
    "id": "item_3469",
    "Last Name": "PANUNZIO",
    "First Name": "GAETANO MARIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950066": {
    "id": "item_14319",
    "Last Name": "Kappenberg",
    "First Name": "Lars",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950098": {
    "id": "item_16459",
    "Last Name": "Donald",
    "First Name": "Mandy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950131": {
    "id": "item_16460",
    "Last Name": "Donald",
    "First Name": "Wesley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950166": {
    "id": "item_29117",
    "Last Name": "Widjaja",
    "First Name": "Herman",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950181": {
    "id": "item_29118",
    "Last Name": "Du Plooy",
    "First Name": "Cornelius W C",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950214": {
    "id": "item_3470",
    "Last Name": "CONSOLI",
    "First Name": "GIACOMO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950270": {
    "id": "item_26937",
    "Last Name": "Rota",
    "First Name": "Bruno Luigi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950281": {
    "id": "item_26938",
    "Last Name": "AMBROSINI",
    "First Name": "ORLANDO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950354": {
    "id": "item_16461",
    "Last Name": "Leung",
    "First Name": "Hung Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950395": {
    "id": "item_26940",
    "Last Name": "Tecchia",
    "First Name": "Fernando Maurizio Enrico",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950401": {
    "id": "item_26939",
    "Last Name": "Petersen",
    "First Name": "Karin Kirke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950409": {
    "id": "item_29119",
    "Last Name": "giacchino",
    "First Name": "Elda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950555": {
    "id": "item_26941",
    "Last Name": "Iacona",
    "First Name": "Giacomo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950628": {
    "id": "item_3471",
    "Last Name": "Lorandi",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950821": {
    "id": "item_29120",
    "Last Name": "TOBOSO GOMEZ",
    "First Name": "JOSE DAMIAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950889": {
    "id": "item_16462",
    "Last Name": "DE ALMEIDA LIMA",
    "First Name": "MILTON CARLOS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950892": {
    "id": "item_29121",
    "Last Name": "Seno Aldi",
    "First Name": "Muhammad Reza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950922": {
    "id": "item_3472",
    "Last Name": "FECCHIO",
    "First Name": "ILARIA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950953": {
    "id": "item_14320",
    "Last Name": "GERARCHINI",
    "First Name": "ALESSIO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42951005": {
    "id": "item_29122",
    "Last Name": "Kusuma",
    "First Name": "Dewi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952024": {
    "id": "item_26942",
    "Last Name": "Withagen",
    "First Name": "Hubertus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952314": {
    "id": "item_16463",
    "Last Name": "Andringa",
    "First Name": "Simon Petrus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952420": {
    "id": "item_1632",
    "Last Name": "Fong",
    "First Name": "Ka Lon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952760": {
    "id": "item_26943",
    "Last Name": "Chan",
    "First Name": "Kwai Fong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952791": {
    "id": "item_14321",
    "Last Name": "Getman",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952920": {
    "id": "item_16464",
    "Last Name": "CAPACCI",
    "First Name": "CRISTINA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42953021": {
    "id": "item_29123",
    "Last Name": "Fenny",
    "First Name": "Fenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42953147": {
    "id": "item_3473",
    "Last Name": "Fell",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42953349": {
    "id": "item_3474",
    "Last Name": "Korsing",
    "First Name": "Karsten",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42953793": {
    "id": "item_26944",
    "Last Name": "Rosell",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42953971": {
    "id": "item_26945",
    "Last Name": "Yakobus",
    "First Name": "Sutoto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954224": {
    "id": "item_26946",
    "Last Name": "van Wijnen",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954248": {
    "id": "item_14322",
    "Last Name": "Georgiou",
    "First Name": "Georgios Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954303": {
    "id": "item_14323",
    "Last Name": "Leong",
    "First Name": "Man Ieng",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954417": {
    "id": "item_26947",
    "Last Name": "Cangco",
    "First Name": "Lorraine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954872": {
    "id": "item_26948",
    "Last Name": "Bowers",
    "First Name": "Travis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954926": {
    "id": "item_3475",
    "Last Name": "Quintanilla Valles",
    "First Name": "Victor Manuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42955125": {
    "id": "item_16465",
    "Last Name": "de Graaf",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42955136": {
    "id": "item_3476",
    "Last Name": "Biagi",
    "First Name": "Cristiano",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42955349": {
    "id": "item_26949",
    "Last Name": "Saputra",
    "First Name": "Andi Satya Adi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42955535": {
    "id": "item_1633",
    "Last Name": "SEASTROM",
    "First Name": "KRISTOFOR",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42955830": {
    "id": "item_16466",
    "Last Name": "Schnell",
    "First Name": "Klaus Juergen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42955856": {
    "id": "item_1634",
    "Last Name": "Miranda Bittencourt",
    "First Name": "Romulo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42956514": {
    "id": "item_29124",
    "Last Name": "Schisler",
    "First Name": "Kody",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42956541": {
    "id": "item_26950",
    "Last Name": "Adsule",
    "First Name": "Pushkar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42956819": {
    "id": "item_14324",
    "Last Name": "Newton",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42957280": {
    "id": "item_26951",
    "Last Name": "Paternostro",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42958048": {
    "id": "item_3477",
    "Last Name": "Umarov",
    "First Name": "Maxim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42958898": {
    "id": "item_14325",
    "Last Name": "Simmelink",
    "First Name": "Wim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42959685": {
    "id": "item_14326",
    "Last Name": "Tang",
    "First Name": "Paul Pui Tien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42960673": {
    "id": "item_14327",
    "Last Name": "Roelfsema",
    "First Name": "Martijn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42960942": {
    "id": "item_3478",
    "Last Name": "SCHEIBLHOFER",
    "First Name": "PETER",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42961391": {
    "id": "item_16467",
    "Last Name": "Hoff",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42961755": {
    "id": "item_14328",
    "Last Name": "de Vries",
    "First Name": "Alwin Xander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42962133": {
    "id": "item_3479",
    "Last Name": "Cappelli",
    "First Name": "Leonardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42963274": {
    "id": "item_29125",
    "Last Name": "Panajkar",
    "First Name": "Charu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42963635": {
    "id": "item_26952",
    "Last Name": "Riordan",
    "First Name": "MaryKate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42963704": {
    "id": "item_29126",
    "Last Name": "Ogunlesi",
    "First Name": "Bunmi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42963827": {
    "id": "item_29127",
    "Last Name": "golabek",
    "First Name": "carola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42963862": {
    "id": "item_3480",
    "Last Name": "FERREIRA DO AMARAL",
    "First Name": "DENISE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42964036": {
    "id": "item_3481",
    "Last Name": "MOREIRA FERNANDES",
    "First Name": "LUIZ ANTONIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42965837": {
    "id": "item_14329",
    "Last Name": "Wang",
    "First Name": "Hung-Jen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42967982": {
    "id": "item_29128",
    "Last Name": "AUPAVET",
    "First Name": "NIPHA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42968725": {
    "id": "item_29129",
    "Last Name": "Ibuado",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42968981": {
    "id": "item_26953",
    "Last Name": "Tong",
    "First Name": "Man",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42969098": {
    "id": "item_16468",
    "Last Name": "Haugley",
    "First Name": "Junel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42969599": {
    "id": "item_26954",
    "Last Name": "OKA",
    "First Name": "HIROTO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42971783": {
    "id": "item_3482",
    "Last Name": "CHAU",
    "First Name": "Wan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42972024": {
    "id": "item_29130",
    "Last Name": "Pados",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42972198": {
    "id": "item_26955",
    "Last Name": "Soto",
    "First Name": "Lucia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42972741": {
    "id": "item_29131",
    "Last Name": "Handayan",
    "First Name": "Hillary Stacey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42972981": {
    "id": "item_16469",
    "Last Name": "Dr Berrisch",
    "First Name": "Hans Stefan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42973053": {
    "id": "item_1635",
    "Last Name": "MORAIS",
    "First Name": "MANUEL XAVIER VERNON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42973070": {
    "id": "item_26956",
    "Last Name": "Sukhramani",
    "First Name": "Sumit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42973218": {
    "id": "item_29132",
    "Last Name": "Safiro",
    "First Name": "Andrio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42973452": {
    "id": "item_14330",
    "Last Name": "Jeeninga",
    "First Name": "Marit Eline",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42973597": {
    "id": "item_1636",
    "Last Name": "So",
    "First Name": "Sin On",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42973748": {
    "id": "item_3483",
    "Last Name": "Cocchi",
    "First Name": "Leonardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42974390": {
    "id": "item_26957",
    "Last Name": "Chui",
    "First Name": "Chun kit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42974401": {
    "id": "item_29133",
    "Last Name": "Chia",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42974478": {
    "id": "item_31131",
    "Last Name": "Ho",
    "First Name": "Siew Thai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42975133": {
    "id": "item_26958",
    "Last Name": "SchŠtz",
    "First Name": "Saskia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42975252": {
    "id": "item_26959",
    "Last Name": "Jansen",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42976304": {
    "id": "item_14331",
    "Last Name": "Viviani",
    "First Name": "Raffaele",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42976322": {
    "id": "item_26960",
    "Last Name": "Reddy",
    "First Name": "Krupali",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42976823": {
    "id": "item_3484",
    "Last Name": "Raith Nilsson",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42977034": {
    "id": "item_14332",
    "Last Name": "Ortica",
    "First Name": "Ylenia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42977743": {
    "id": "item_29134",
    "Last Name": "millarelli",
    "First Name": "stefano",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42978283": {
    "id": "item_14333",
    "Last Name": "scarabelli",
    "First Name": "roberto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42978692": {
    "id": "item_1637",
    "Last Name": "Cervone",
    "First Name": "Ermanno",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42981583": {
    "id": "item_26961",
    "Last Name": "Marx",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42981792": {
    "id": "item_1638",
    "Last Name": "Todd",
    "First Name": "Ingrid Marcela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42984790": {
    "id": "item_29135",
    "Last Name": "Rejlis",
    "First Name": "Natalio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42985265": {
    "id": "item_26962",
    "Last Name": "Kim",
    "First Name": "Paggie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42987381": {
    "id": "item_14334",
    "Last Name": "DEWI",
    "First Name": "CHANDRA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42987895": {
    "id": "item_3485",
    "Last Name": "Wang",
    "First Name": "Yibo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42988236": {
    "id": "item_1639",
    "Last Name": "WONG",
    "First Name": "YUET CHI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42989134": {
    "id": "item_29136",
    "Last Name": "Burton",
    "First Name": "Nyree C",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42989296": {
    "id": "item_16470",
    "Last Name": "Saputra",
    "First Name": "Nathalia dewi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42990893": {
    "id": "item_26963",
    "Last Name": "Ittes",
    "First Name": "Marlyssa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42991298": {
    "id": "item_26964",
    "Last Name": "Carrington",
    "First Name": "Yolanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42991587": {
    "id": "item_26965",
    "Last Name": "Heagney",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42991667": {
    "id": "item_26966",
    "Last Name": "Kawase",
    "First Name": "Mariko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42992207": {
    "id": "item_29137",
    "Last Name": "MINARTO",
    "First Name": "MINARTO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42992693": {
    "id": "item_26967",
    "Last Name": "Leung",
    "First Name": "Pui San",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42992980": {
    "id": "item_3486",
    "Last Name": "Glasner",
    "First Name": "Michael Berthold",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42993421": {
    "id": "item_3487",
    "Last Name": "Gunawan",
    "First Name": "Firman",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42993873": {
    "id": "item_16471",
    "Last Name": "van der Sleen",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42994343": {
    "id": "item_26968",
    "Last Name": "ABOIM",
    "First Name": "Joy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42994444": {
    "id": "item_18565",
    "Last Name": "Polgar",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42994669": {
    "id": "item_31132",
    "Last Name": "Todzey",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42994717": {
    "id": "item_18566",
    "Last Name": "Holtheuer",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42994817": {
    "id": "item_26969",
    "Last Name": "Sullivan",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42995588": {
    "id": "item_14335",
    "Last Name": "Tawaf",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42995706": {
    "id": "item_16472",
    "Last Name": "Waning-Slag",
    "First Name": "Monique",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42995757": {
    "id": "item_16473",
    "Last Name": "Waning",
    "First Name": "Theo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42996125": {
    "id": "item_3488",
    "Last Name": "Nielsen",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42996622": {
    "id": "item_31133",
    "Last Name": "Chunchuwar",
    "First Name": "Prashant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42996738": {
    "id": "item_1640",
    "Last Name": "Klein",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42996860": {
    "id": "item_14336",
    "Last Name": "Wijaya",
    "First Name": "Budiadji",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42997556": {
    "id": "item_1641",
    "Last Name": "Ng",
    "First Name": "Kung Chit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42997601": {
    "id": "item_26970",
    "Last Name": "HANDY SULISTIO",
    "First Name": "DJONIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42998197": {
    "id": "item_3489",
    "Last Name": "amoretti",
    "First Name": "cristiano",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43000269": {
    "id": "item_26971",
    "Last Name": "Garg",
    "First Name": "Smita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43000855": {
    "id": "item_29138",
    "Last Name": "Olaechea",
    "First Name": "Evelyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43001300": {
    "id": "item_3490",
    "Last Name": "SçEZ MARTêNEZ",
    "First Name": "JESUS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43001465": {
    "id": "item_31134",
    "Last Name": "SchŸtz",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43001467": {
    "id": "item_16474",
    "Last Name": "SOARES MAGALHAES",
    "First Name": "CARLOS AUGUSTO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43001641": {
    "id": "item_29139",
    "Last Name": "Nkala",
    "First Name": "Mirriam Kgatile",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43001699": {
    "id": "item_14337",
    "Last Name": "Tresin",
    "First Name": "Catia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43002533": {
    "id": "item_29140",
    "Last Name": "SOLINAS",
    "First Name": "FEDERICA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43002560": {
    "id": "item_3491",
    "Last Name": "Van Hemert",
    "First Name": "Willem",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43004189": {
    "id": "item_14338",
    "Last Name": "GOMEZ BOHN",
    "First Name": "CLAUDIA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43004869": {
    "id": "item_16475",
    "Last Name": "Mu–oz Soto",
    "First Name": "Claudio Andres",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43004877": {
    "id": "item_14339",
    "Last Name": "Fernandez Klose",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43005090": {
    "id": "item_1642",
    "Last Name": "Cowperthwaite",
    "First Name": "Sutton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43005270": {
    "id": "item_29141",
    "Last Name": "McCloskey",
    "First Name": "Selina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43005325": {
    "id": "item_3492",
    "Last Name": "Martinez Teutle",
    "First Name": "Abraham Ronel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43005557": {
    "id": "item_14340",
    "Last Name": "Ruiz",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43006327": {
    "id": "item_14341",
    "Last Name": "ONO",
    "First Name": "KATSUSHI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43007209": {
    "id": "item_18567",
    "Last Name": "Piper",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43007244": {
    "id": "item_26972",
    "Last Name": "Sandi Loria",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43007778": {
    "id": "item_26973",
    "Last Name": "Farrell",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43009282": {
    "id": "item_26974",
    "Last Name": "Chonstkowsky Meyohas",
    "First Name": "Salomon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43009521": {
    "id": "item_1643",
    "Last Name": "Mussini",
    "First Name": "German Dario",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43009535": {
    "id": "item_16476",
    "Last Name": "Triwahyudi",
    "First Name": "Wahyu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43009695": {
    "id": "item_26975",
    "Last Name": "Groth",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43010694": {
    "id": "item_1644",
    "Last Name": "CHENG",
    "First Name": "Chin Tai",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43011333": {
    "id": "item_26976",
    "Last Name": "Groth",
    "First Name": "Casey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43011437": {
    "id": "item_26977",
    "Last Name": "Phornprapha",
    "First Name": "Prapol",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43011736": {
    "id": "item_31135",
    "Last Name": "Casalme",
    "First Name": "Lara Angelica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43012506": {
    "id": "item_26978",
    "Last Name": "MATUNDA",
    "First Name": "DISMAS AMANI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43012993": {
    "id": "item_26979",
    "Last Name": "Nifos“",
    "First Name": "Maria Antonella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43013206": {
    "id": "item_3493",
    "Last Name": "Putra",
    "First Name": "Imam Kurnia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43013222": {
    "id": "item_14342",
    "Last Name": "Hobbs",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43013376": {
    "id": "item_1645",
    "Last Name": "Arunrat",
    "First Name": "Worrawit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43013428": {
    "id": "item_1646",
    "Last Name": "Arunrat",
    "First Name": "Khanittha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43013476": {
    "id": "item_1647",
    "Last Name": "Soongcharoensiri",
    "First Name": "Somsak",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43013554": {
    "id": "item_14343",
    "Last Name": "Soegiman",
    "First Name": "Lidia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43013592": {
    "id": "item_1648",
    "Last Name": "Battilana",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014042": {
    "id": "item_29142",
    "Last Name": "Firme",
    "First Name": "Anna Crista",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014138": {
    "id": "item_26980",
    "Last Name": "wang",
    "First Name": "huiying",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014199": {
    "id": "item_14344",
    "Last Name": "Polglaze",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014246": {
    "id": "item_26981",
    "Last Name": "huang",
    "First Name": "huifei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014285": {
    "id": "item_31136",
    "Last Name": "Setiawan",
    "First Name": "Saleh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014359": {
    "id": "item_3494",
    "Last Name": "Devloo",
    "First Name": "Pieter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014538": {
    "id": "item_14345",
    "Last Name": "Rattanakhemakorn",
    "First Name": "Jintana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014556": {
    "id": "item_14346",
    "Last Name": "SIRITHANACHAI",
    "First Name": "AMORNRAT",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014634": {
    "id": "item_3495",
    "Last Name": "NTULI",
    "First Name": "SIPHO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014777": {
    "id": "item_3496",
    "Last Name": "Pasquini",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014861": {
    "id": "item_14347",
    "Last Name": "Breytenbach",
    "First Name": "Chantelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015042": {
    "id": "item_16477",
    "Last Name": "Winstead",
    "First Name": "Marta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015439": {
    "id": "item_26982",
    "Last Name": "Gordijn",
    "First Name": "Robertus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015709": {
    "id": "item_3497",
    "Last Name": "Teixeira",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015935": {
    "id": "item_29143",
    "Last Name": "Esmeralda",
    "First Name": "Amarilia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016017": {
    "id": "item_26983",
    "Last Name": "Vanichjakvong",
    "First Name": "Tharnkasem",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016345": {
    "id": "item_16478",
    "Last Name": "Jansen",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016557": {
    "id": "item_14348",
    "Last Name": "Szilard",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016570": {
    "id": "item_26984",
    "Last Name": "Hughes",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016694": {
    "id": "item_14349",
    "Last Name": "Rainaldy",
    "First Name": "Rainaldy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43017289": {
    "id": "item_14350",
    "Last Name": "Harahap",
    "First Name": "Mohammad Ramadhan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43017291": {
    "id": "item_14351",
    "Last Name": "Ruksujarit",
    "First Name": "Tanaporn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43017429": {
    "id": "item_26985",
    "Last Name": "Senjaya",
    "First Name": "Janice Levina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43017794": {
    "id": "item_1649",
    "Last Name": "Fikri",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43018323": {
    "id": "item_14352",
    "Last Name": "DiCarrado",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43019815": {
    "id": "item_26986",
    "Last Name": "Tow",
    "First Name": "Joon Han",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43019879": {
    "id": "item_26987",
    "Last Name": "Tow",
    "First Name": "Joon Guan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43019932": {
    "id": "item_26988",
    "Last Name": "Hozak",
    "First Name": "Regan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43020118": {
    "id": "item_16479",
    "Last Name": "Van Veldhuizen",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43020354": {
    "id": "item_26989",
    "Last Name": "de Kroon",
    "First Name": "Pascalle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43020925": {
    "id": "item_5747",
    "Last Name": "Franko",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43021206": {
    "id": "item_14353",
    "Last Name": "Bergman",
    "First Name": "Job",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43021740": {
    "id": "item_1650",
    "Last Name": "Boettcher",
    "First Name": "Dirk",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43022513": {
    "id": "item_26990",
    "Last Name": "Duffy",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43022554": {
    "id": "item_1651",
    "Last Name": "Pope",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43022583": {
    "id": "item_16480",
    "Last Name": "LLAMAS GONZALEZ",
    "First Name": "OSCAR EDUARDO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43023084": {
    "id": "item_14354",
    "Last Name": "Alvira-Martinez",
    "First Name": "Victor Ramon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43023325": {
    "id": "item_29144",
    "Last Name": "Brandenburg",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43023680": {
    "id": "item_14355",
    "Last Name": "Asbury",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43024317": {
    "id": "item_16481",
    "Last Name": "Luswata",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43024369": {
    "id": "item_1652",
    "Last Name": "EVANGELISTI",
    "First Name": "MATTEO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43024457": {
    "id": "item_3498",
    "Last Name": "Biskopst¿",
    "First Name": "Borgar Juliusson",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43024616": {
    "id": "item_1653",
    "Last Name": "De Sio",
    "First Name": "Michele",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43024884": {
    "id": "item_14356",
    "Last Name": "Klunder",
    "First Name": "Ernst",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43025171": {
    "id": "item_14357",
    "Last Name": "Pelt",
    "First Name": "Marieke",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43025223": {
    "id": "item_26991",
    "Last Name": "Patton",
    "First Name": "Una",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43025843": {
    "id": "item_29145",
    "Last Name": "Ricci",
    "First Name": "Mario",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43026895": {
    "id": "item_31137",
    "Last Name": "Marcelino",
    "First Name": "Rebeck Karinny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43029064": {
    "id": "item_3499",
    "Last Name": "Roldao",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43029292": {
    "id": "item_26992",
    "Last Name": "Rudnianyn",
    "First Name": "Todd",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43029851": {
    "id": "item_14358",
    "Last Name": "CHEN",
    "First Name": "HSI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43029931": {
    "id": "item_3500",
    "Last Name": "Mago",
    "First Name": "Alonso",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43029951": {
    "id": "item_16482",
    "Last Name": "Lee",
    "First Name": "Ming-Chou",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43029953": {
    "id": "item_3501",
    "Last Name": "Irvine",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43030440": {
    "id": "item_29146",
    "Last Name": "Wang",
    "First Name": "Wen Lin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43030711": {
    "id": "item_14359",
    "Last Name": "Xu",
    "First Name": "Yun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43030798": {
    "id": "item_29147",
    "Last Name": "HSIEH",
    "First Name": "YU JEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43031311": {
    "id": "item_29148",
    "Last Name": "Bailey",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43031659": {
    "id": "item_26993",
    "Last Name": "bai",
    "First Name": "Jiarui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43031921": {
    "id": "item_29149",
    "Last Name": "Lin",
    "First Name": "Tsing-Hwei",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43031964": {
    "id": "item_26994",
    "Last Name": "Subkhan",
    "First Name": "Mohamad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43032709": {
    "id": "item_14360",
    "Last Name": "Roux",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43032891": {
    "id": "item_26995",
    "Last Name": "RUBBANY",
    "First Name": "CHAIRINA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43032976": {
    "id": "item_26996",
    "Last Name": "Capuano",
    "First Name": "Gina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033349": {
    "id": "item_14361",
    "Last Name": "Liao",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033428": {
    "id": "item_26997",
    "Last Name": "CHIN",
    "First Name": "TZUCHIANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033573": {
    "id": "item_26998",
    "Last Name": "Ratkovic",
    "First Name": "Teodor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033654": {
    "id": "item_29150",
    "Last Name": "Darby",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033764": {
    "id": "item_16483",
    "Last Name": "Moritani",
    "First Name": "Hiroko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033796": {
    "id": "item_3502",
    "Last Name": "Martin",
    "First Name": "Monet",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033919": {
    "id": "item_31138",
    "Last Name": "Virangga",
    "First Name": "Vanny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033997": {
    "id": "item_26999",
    "Last Name": "Tay",
    "First Name": "Cheng You",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43034018": {
    "id": "item_3503",
    "Last Name": "Grimes",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43034148": {
    "id": "item_1654",
    "Last Name": "Bereski II",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43034335": {
    "id": "item_27000",
    "Last Name": "Nurinadara",
    "First Name": "Vintha Tozy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43034391": {
    "id": "item_3504",
    "Last Name": "Chan",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43034738": {
    "id": "item_27001",
    "Last Name": "Bolitho",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43034895": {
    "id": "item_29151",
    "Last Name": "De La Cruz Povolo",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035302": {
    "id": "item_27002",
    "Last Name": "ZHAO",
    "First Name": "WEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035303": {
    "id": "item_3505",
    "Last Name": "Galimov",
    "First Name": "Rustem",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035442": {
    "id": "item_16484",
    "Last Name": "VALDIFIORI",
    "First Name": "SUSI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035658": {
    "id": "item_31139",
    "Last Name": "WU",
    "First Name": "TSUNG LUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035689": {
    "id": "item_27003",
    "Last Name": "KIM",
    "First Name": "DONG JAE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035756": {
    "id": "item_27004",
    "Last Name": "YEOM",
    "First Name": "HEAJIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035882": {
    "id": "item_27005",
    "Last Name": "Suttle",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035912": {
    "id": "item_3506",
    "Last Name": "LU",
    "First Name": "XIAOWEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035975": {
    "id": "item_1655",
    "Last Name": "WANG",
    "First Name": "CHI-HSIANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036008": {
    "id": "item_1656",
    "Last Name": "Cavelti",
    "First Name": "Roland",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036100": {
    "id": "item_27006",
    "Last Name": "WANG",
    "First Name": "KAI-CHIEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036110": {
    "id": "item_14362",
    "Last Name": "Cheng",
    "First Name": "Yuching",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036552": {
    "id": "item_16485",
    "Last Name": "HSU",
    "First Name": "YUTASI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036575": {
    "id": "item_14363",
    "Last Name": "Postoaca",
    "First Name": "Andrei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036615": {
    "id": "item_16486",
    "Last Name": "WANG",
    "First Name": "XIAOHONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036705": {
    "id": "item_1657",
    "Last Name": "Reza",
    "First Name": "Mohammad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036942": {
    "id": "item_14364",
    "Last Name": "PUTRA",
    "First Name": "WAHYU KRISTAPA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43037248": {
    "id": "item_14365",
    "Last Name": "Rini",
    "First Name": "Yulia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43037528": {
    "id": "item_14366",
    "Last Name": "Nogueira",
    "First Name": "Marjorie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43037865": {
    "id": "item_1658",
    "Last Name": "Chu",
    "First Name": "Jamson Chi-Hay Yin Hock",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43038545": {
    "id": "item_16487",
    "Last Name": "Philippe",
    "First Name": "BASSAND",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43038752": {
    "id": "item_27007",
    "Last Name": "Walton",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43038854": {
    "id": "item_27008",
    "Last Name": "Robino",
    "First Name": "Gregorio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43039027": {
    "id": "item_27009",
    "Last Name": "CHALOT",
    "First Name": "Sabrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43039249": {
    "id": "item_27010",
    "Last Name": "TSZ HIN",
    "First Name": "LAU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43039390": {
    "id": "item_3507",
    "Last Name": "Priadriyanto",
    "First Name": "Agung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040157": {
    "id": "item_27011",
    "Last Name": "Schnell",
    "First Name": "Kenzo Josef Konstantin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040475": {
    "id": "item_3508",
    "Last Name": "Gibson",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040519": {
    "id": "item_27012",
    "Last Name": "Heskett",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040539": {
    "id": "item_27013",
    "Last Name": "Pham",
    "First Name": "Kim Anh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040663": {
    "id": "item_29152",
    "Last Name": "Zhang",
    "First Name": "Li",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040672": {
    "id": "item_31140",
    "Last Name": "Alex-Schrammen",
    "First Name": "Catrin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040898": {
    "id": "item_14367",
    "Last Name": "BRATCH",
    "First Name": "BALBIR",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040957": {
    "id": "item_27014",
    "Last Name": "McDonnell",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43041142": {
    "id": "item_16488",
    "Last Name": "GOTO",
    "First Name": "HIDEKI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43041400": {
    "id": "item_3509",
    "Last Name": "Song",
    "First Name": "Gang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43041641": {
    "id": "item_3510",
    "Last Name": "MŸller",
    "First Name": "Alexander Augustin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43042042": {
    "id": "item_27015",
    "Last Name": "Carrasco",
    "First Name": "Rolando",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43042588": {
    "id": "item_27016",
    "Last Name": "Pavanetto",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43043553": {
    "id": "item_29153",
    "Last Name": "Chen",
    "First Name": "Pohsun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43043828": {
    "id": "item_3511",
    "Last Name": "Gonzalez",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43044148": {
    "id": "item_14368",
    "Last Name": "Evers",
    "First Name": "Jan Johan (Jos)",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43044549": {
    "id": "item_14369",
    "Last Name": "FONTANA",
    "First Name": "GILLES",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43046274": {
    "id": "item_16489",
    "Last Name": "MATSUDA",
    "First Name": "KIMIKO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43047210": {
    "id": "item_27017",
    "Last Name": "Napasab",
    "First Name": "Hasanand",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43047514": {
    "id": "item_16490",
    "Last Name": "Neville",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43047541": {
    "id": "item_16491",
    "Last Name": "Jones",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048282": {
    "id": "item_29154",
    "Last Name": "Dawson",
    "First Name": "Meredith",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048308": {
    "id": "item_27018",
    "Last Name": "Nguyen",
    "First Name": "Voi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048328": {
    "id": "item_3512",
    "Last Name": "Kubala",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048366": {
    "id": "item_14370",
    "Last Name": "DAHOUN",
    "First Name": "mustapha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048384": {
    "id": "item_27019",
    "Last Name": "Ramos",
    "First Name": "Liza",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048387": {
    "id": "item_3513",
    "Last Name": "Baur",
    "First Name": "Bobbi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048392": {
    "id": "item_14371",
    "Last Name": "Pietsch",
    "First Name": "Janina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048429": {
    "id": "item_14372",
    "Last Name": "LeBlanc",
    "First Name": "Darlene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048438": {
    "id": "item_14373",
    "Last Name": "SASAKI",
    "First Name": "YOSHIAKI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048441": {
    "id": "item_14374",
    "Last Name": "Ford",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048497": {
    "id": "item_29155",
    "Last Name": "Frieder",
    "First Name": "Anne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048525": {
    "id": "item_3514",
    "Last Name": "Nelson",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048529": {
    "id": "item_29156",
    "Last Name": "Shinall",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048579": {
    "id": "item_27020",
    "Last Name": "Rodriguez",
    "First Name": "Carla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048588": {
    "id": "item_3515",
    "Last Name": "Villanueva",
    "First Name": "Karla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048611": {
    "id": "item_14375",
    "Last Name": "Han",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048641": {
    "id": "item_29157",
    "Last Name": "Eisenberg",
    "First Name": "Harley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048647": {
    "id": "item_1659",
    "Last Name": "TAFFET",
    "First Name": "RICHARD",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048697": {
    "id": "item_27021",
    "Last Name": "Chen",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048705": {
    "id": "item_27022",
    "Last Name": "Caruso",
    "First Name": "Marni",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048720": {
    "id": "item_1660",
    "Last Name": "Infante",
    "First Name": "Michael Edward",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048725": {
    "id": "item_16492",
    "Last Name": "Hoch",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048728": {
    "id": "item_1661",
    "Last Name": "Del Vacchio",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048748": {
    "id": "item_16493",
    "Last Name": "Fortney",
    "First Name": "Jonathan David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048760": {
    "id": "item_27023",
    "Last Name": "Alcock",
    "First Name": "Cathy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048808": {
    "id": "item_27024",
    "Last Name": "Rogers",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048824": {
    "id": "item_31141",
    "Last Name": "Zamora",
    "First Name": "Ricardo Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048850": {
    "id": "item_1662",
    "Last Name": "Fontes",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048906": {
    "id": "item_3516",
    "Last Name": "Hollenbach",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048933": {
    "id": "item_14376",
    "Last Name": "Call",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048973": {
    "id": "item_27025",
    "Last Name": "Perry",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049035": {
    "id": "item_14377",
    "Last Name": "FIORE",
    "First Name": "LUIGI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049050": {
    "id": "item_27026",
    "Last Name": "olegario",
    "First Name": "arnold",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049110": {
    "id": "item_29158",
    "Last Name": "Davis",
    "First Name": "Starr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049224": {
    "id": "item_1663",
    "Last Name": "Moen",
    "First Name": "Hendrik",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049280": {
    "id": "item_3517",
    "Last Name": "Zelaya",
    "First Name": "Ada",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049459": {
    "id": "item_31142",
    "Last Name": "Sangsurasak",
    "First Name": "Sumalee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049543": {
    "id": "item_27027",
    "Last Name": "Vickerman",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049702": {
    "id": "item_27028",
    "Last Name": "Teitelbaum",
    "First Name": "Javier",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049813": {
    "id": "item_1664",
    "Last Name": "Prunty",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049843": {
    "id": "item_14378",
    "Last Name": "Cleto Machado",
    "First Name": "Tiago",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049997": {
    "id": "item_29159",
    "Last Name": "Toczylowski",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050036": {
    "id": "item_1665",
    "Last Name": "Williams",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050165": {
    "id": "item_16494",
    "Last Name": "MARTINEZ",
    "First Name": "REYNA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050279": {
    "id": "item_3518",
    "Last Name": "Coira Gonzalez",
    "First Name": "Carla Karissa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050387": {
    "id": "item_27029",
    "Last Name": "Beattie",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050422": {
    "id": "item_14379",
    "Last Name": "Kavanaugh",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050439": {
    "id": "item_14380",
    "Last Name": "Petrovic",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050556": {
    "id": "item_31143",
    "Last Name": "Hile",
    "First Name": "RAYLENE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050611": {
    "id": "item_27030",
    "Last Name": "Giry",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051176": {
    "id": "item_14381",
    "Last Name": "Van Kampen",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051217": {
    "id": "item_14382",
    "Last Name": "Alanis",
    "First Name": "Andres",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051311": {
    "id": "item_27031",
    "Last Name": "Wiafe",
    "First Name": "Nana Serwa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051318": {
    "id": "item_3519",
    "Last Name": "Perry",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051337": {
    "id": "item_27032",
    "Last Name": "Russell",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051601": {
    "id": "item_3520",
    "Last Name": "Llaguno Carranco",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052051": {
    "id": "item_16495",
    "Last Name": "Brazell",
    "First Name": "Carl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052192": {
    "id": "item_1666",
    "Last Name": "Anderson",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052225": {
    "id": "item_27033",
    "Last Name": "Tengco",
    "First Name": "Jose Francisco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052317": {
    "id": "item_16496",
    "Last Name": "Conceicao Rocha",
    "First Name": "Sara Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052367": {
    "id": "item_27034",
    "Last Name": "Solano Aguilar",
    "First Name": "Jorge Isaac",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052683": {
    "id": "item_27035",
    "Last Name": "Yi",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052741": {
    "id": "item_14383",
    "Last Name": "Nelson",
    "First Name": "Jody",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052860": {
    "id": "item_27036",
    "Last Name": "Camigla",
    "First Name": "German",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052908": {
    "id": "item_27037",
    "Last Name": "Cyr",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052914": {
    "id": "item_27038",
    "Last Name": "Carlson",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052935": {
    "id": "item_14384",
    "Last Name": "Dyer",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052983": {
    "id": "item_14385",
    "Last Name": "Punturiero",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43053100": {
    "id": "item_27039",
    "Last Name": "Arrojado",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43053163": {
    "id": "item_27040",
    "Last Name": "Rudakov",
    "First Name": "Sasha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43053307": {
    "id": "item_27041",
    "Last Name": "Aliling",
    "First Name": "Jose-Antonio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43053546": {
    "id": "item_27042",
    "Last Name": "Hohertz-Jacobs",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43053756": {
    "id": "item_31144",
    "Last Name": "Nowak",
    "First Name": "Timothy Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43053851": {
    "id": "item_27043",
    "Last Name": "Denize-Niha",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43054130": {
    "id": "item_1667",
    "Last Name": "Hong",
    "First Name": "Sung-Min",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43054220": {
    "id": "item_3521",
    "Last Name": "Huang",
    "First Name": "Sharrie Jade",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43054478": {
    "id": "item_27044",
    "Last Name": "Ledesma",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43054598": {
    "id": "item_29160",
    "Last Name": "Ambriz Carrillo",
    "First Name": "Martha Guadalupe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43055253": {
    "id": "item_18568",
    "Last Name": "Hinton",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43055346": {
    "id": "item_18569",
    "Last Name": "Hinton",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43055845": {
    "id": "item_27045",
    "Last Name": "Amanda",
    "First Name": "Natasha Dewi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056300": {
    "id": "item_14386",
    "Last Name": "Ramaswamy",
    "First Name": "Saranathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056381": {
    "id": "item_14387",
    "Last Name": "Buckley",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056408": {
    "id": "item_29161",
    "Last Name": "WU",
    "First Name": "YEH LAP",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056513": {
    "id": "item_14388",
    "Last Name": "LIN",
    "First Name": "SHIH TEH",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056785": {
    "id": "item_29162",
    "Last Name": "CHANG",
    "First Name": "CHEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056797": {
    "id": "item_14389",
    "Last Name": "Call",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43057668": {
    "id": "item_1668",
    "Last Name": "Bennett",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43057693": {
    "id": "item_27046",
    "Last Name": "Torres",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43057805": {
    "id": "item_27047",
    "Last Name": "Tiu Torres",
    "First Name": "Lalaine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058011": {
    "id": "item_16497",
    "Last Name": "NAU",
    "First Name": "HIU YAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058035": {
    "id": "item_29163",
    "Last Name": "Srinivasan",
    "First Name": "Karthik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058204": {
    "id": "item_27048",
    "Last Name": "FANG",
    "First Name": "HUEY HSIANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058340": {
    "id": "item_14390",
    "Last Name": "Thomas",
    "First Name": "Treva",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058652": {
    "id": "item_1669",
    "Last Name": "LIN",
    "First Name": "MENGCHIAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058677": {
    "id": "item_29164",
    "Last Name": "KIM",
    "First Name": "YOUNGJAI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058772": {
    "id": "item_31145",
    "Last Name": "Bailey",
    "First Name": "Anne Lord",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058893": {
    "id": "item_14391",
    "Last Name": "CHOO",
    "First Name": "JONGHOON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058909": {
    "id": "item_27049",
    "Last Name": "CHOU TSAI",
    "First Name": "HSIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059002": {
    "id": "item_27050",
    "Last Name": "PEGUERO",
    "First Name": "JALEM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059080": {
    "id": "item_16498",
    "Last Name": "YOON",
    "First Name": "JONG KIL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059171": {
    "id": "item_27051",
    "Last Name": "CHAN",
    "First Name": "WAI HUNG MORRIS",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059761": {
    "id": "item_14392",
    "Last Name": "Douy",
    "First Name": "Fleur",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059779": {
    "id": "item_27052",
    "Last Name": "Qiu",
    "First Name": "Jiehao Ivan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059880": {
    "id": "item_1670",
    "Last Name": "Sakavutanudej",
    "First Name": "Chittapol",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059882": {
    "id": "item_14393",
    "Last Name": "Wardhana",
    "First Name": "Daffa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059957": {
    "id": "item_29165",
    "Last Name": "Lueoend",
    "First Name": "Martin Anton",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059972": {
    "id": "item_16499",
    "Last Name": "Sardinha",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060041": {
    "id": "item_29166",
    "Last Name": "Lueoend",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060063": {
    "id": "item_3522",
    "Last Name": "Ma",
    "First Name": "Ti Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060109": {
    "id": "item_27053",
    "Last Name": "Pozzi",
    "First Name": "Federico",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060239": {
    "id": "item_27054",
    "Last Name": "ZHOU",
    "First Name": "BO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060412": {
    "id": "item_27055",
    "Last Name": "Tran",
    "First Name": "Quynh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060561": {
    "id": "item_29167",
    "Last Name": "TO",
    "First Name": "ManhHai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060750": {
    "id": "item_14394",
    "Last Name": "Carruthers",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060843": {
    "id": "item_27056",
    "Last Name": "Cooper",
    "First Name": "Meagan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061020": {
    "id": "item_27057",
    "Last Name": "Blair",
    "First Name": "Eirinn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061026": {
    "id": "item_29168",
    "Last Name": "Tom",
    "First Name": "Roslyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061164": {
    "id": "item_29169",
    "Last Name": "Oertle",
    "First Name": "Roger Heinrich",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061353": {
    "id": "item_27058",
    "Last Name": "Bowie",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061357": {
    "id": "item_3523",
    "Last Name": "Lapin",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061453": {
    "id": "item_14395",
    "Last Name": "Chen",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061526": {
    "id": "item_14396",
    "Last Name": "Edwards",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061547": {
    "id": "item_1671",
    "Last Name": "Meakins",
    "First Name": "Tara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061626": {
    "id": "item_14397",
    "Last Name": "Hooper-Stanley",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061895": {
    "id": "item_27059",
    "Last Name": "Tauli",
    "First Name": "Lorda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061952": {
    "id": "item_27060",
    "Last Name": "Villanueva",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43062110": {
    "id": "item_3524",
    "Last Name": "Lu",
    "First Name": "Elisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43063377": {
    "id": "item_29170",
    "Last Name": "van der Moezel",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43063537": {
    "id": "item_3525",
    "Last Name": "Malai",
    "First Name": "Andrii",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43063585": {
    "id": "item_3526",
    "Last Name": "Hasmin",
    "First Name": "Zasiliah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43063680": {
    "id": "item_14398",
    "Last Name": "Shellman",
    "First Name": "Walter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43063846": {
    "id": "item_29171",
    "Last Name": "Duarte Ambriz",
    "First Name": "Maria Regina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43064400": {
    "id": "item_29172",
    "Last Name": "Mbha",
    "First Name": "Boissie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43064878": {
    "id": "item_29173",
    "Last Name": "Mejia",
    "First Name": "Sandra Suyapa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43064896": {
    "id": "item_29174",
    "Last Name": "Li",
    "First Name": "Chaohua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065138": {
    "id": "item_29175",
    "Last Name": "Weeks",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065205": {
    "id": "item_16500",
    "Last Name": "Scio",
    "First Name": "Enrico",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065296": {
    "id": "item_29176",
    "Last Name": "Little",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065502": {
    "id": "item_27061",
    "Last Name": "Hanna",
    "First Name": "Saleem",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066008": {
    "id": "item_27062",
    "Last Name": "Fancy",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066134": {
    "id": "item_1672",
    "Last Name": "Hernandez",
    "First Name": "Jose Faustino",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066682": {
    "id": "item_14399",
    "Last Name": "ONODERA",
    "First Name": "MIKA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066815": {
    "id": "item_29177",
    "Last Name": "Ticsay",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066841": {
    "id": "item_14400",
    "Last Name": "Smiley",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43067899": {
    "id": "item_27063",
    "Last Name": "Weiss",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43068434": {
    "id": "item_27064",
    "Last Name": "GARCIA EP COUFFINHAL",
    "First Name": "FREDERIQUE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43068612": {
    "id": "item_14401",
    "Last Name": "Yamazaki",
    "First Name": "Kazue",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43068737": {
    "id": "item_16501",
    "Last Name": "DION",
    "First Name": "Christophe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43069147": {
    "id": "item_14402",
    "Last Name": "Munk",
    "First Name": "Anders Troels",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43069197": {
    "id": "item_29178",
    "Last Name": "Malaspina",
    "First Name": "Jean louis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43069500": {
    "id": "item_1673",
    "Last Name": "Chaudhari",
    "First Name": "Maheshwar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43070296": {
    "id": "item_29179",
    "Last Name": "Phillips",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43070564": {
    "id": "item_29180",
    "Last Name": "Adams",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43070873": {
    "id": "item_27065",
    "Last Name": "Bolina",
    "First Name": "Jasmeet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071027": {
    "id": "item_14403",
    "Last Name": "RECHIMON",
    "First Name": "MARIO ERNESTO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071629": {
    "id": "item_1674",
    "Last Name": "Moreira",
    "First Name": "Janio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071837": {
    "id": "item_1675",
    "Last Name": "Smith III",
    "First Name": "Robert Jay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43072829": {
    "id": "item_27066",
    "Last Name": "Benton",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43072946": {
    "id": "item_29181",
    "Last Name": "MOHANIRAJ",
    "First Name": "SACHIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43073579": {
    "id": "item_3527",
    "Last Name": "olhausen",
    "First Name": "troy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43074149": {
    "id": "item_29182",
    "Last Name": "Rocke",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43074167": {
    "id": "item_3528",
    "Last Name": "Martinez Maristany",
    "First Name": "Maria Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43075043": {
    "id": "item_14404",
    "Last Name": "Wirta",
    "First Name": "Linda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43075131": {
    "id": "item_14405",
    "Last Name": "Fassi Fihri",
    "First Name": "Oussama",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43075589": {
    "id": "item_3529",
    "Last Name": "Fuenzalida",
    "First Name": "Andres",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43075636": {
    "id": "item_3530",
    "Last Name": "Katiyar",
    "First Name": "Gaurav",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43075846": {
    "id": "item_29183",
    "Last Name": "Egan",
    "First Name": "Neil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43076706": {
    "id": "item_3531",
    "Last Name": "CHEN",
    "First Name": "WEN-HUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43076890": {
    "id": "item_14406",
    "Last Name": "Jang",
    "First Name": "Sun gue",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43077028": {
    "id": "item_14407",
    "Last Name": "Dickson",
    "First Name": "Suzanne Leigh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43077148": {
    "id": "item_14408",
    "Last Name": "Jang",
    "First Name": "Michelle Jhong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43077694": {
    "id": "item_3532",
    "Last Name": "Dahneke",
    "First Name": "Marshall",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43077705": {
    "id": "item_29184",
    "Last Name": "Samuels",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43077793": {
    "id": "item_29185",
    "Last Name": "Velez Melendez",
    "First Name": "Freddy Luis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43077941": {
    "id": "item_16502",
    "Last Name": "Caluya",
    "First Name": "Gay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43078405": {
    "id": "item_29186",
    "Last Name": "Samuels",
    "First Name": "Sheldon Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43080826": {
    "id": "item_31146",
    "Last Name": "Nisi",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43081209": {
    "id": "item_27067",
    "Last Name": "Leung",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43082063": {
    "id": "item_3533",
    "Last Name": "Leung",
    "First Name": "Kwong Ming",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43082458": {
    "id": "item_27068",
    "Last Name": "TUNG",
    "First Name": "WEI-CHI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43082743": {
    "id": "item_1676",
    "Last Name": "Navarro",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43082839": {
    "id": "item_14409",
    "Last Name": "HWANG",
    "First Name": "EUIHYUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43083139": {
    "id": "item_14410",
    "Last Name": "WOO",
    "First Name": "ILNAM",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43083187": {
    "id": "item_1677",
    "Last Name": "SONG",
    "First Name": "JAEHO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43083288": {
    "id": "item_27069",
    "Last Name": "Chan",
    "First Name": "Po Ming",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43083320": {
    "id": "item_3534",
    "Last Name": "GIBBONS",
    "First Name": "Christine",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43083399": {
    "id": "item_14411",
    "Last Name": "Mahfouz",
    "First Name": "Judy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43083643": {
    "id": "item_16503",
    "Last Name": "Iacopini",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43083654": {
    "id": "item_29187",
    "Last Name": "Choi",
    "First Name": "Pauline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084146": {
    "id": "item_27070",
    "Last Name": "Xu",
    "First Name": "Lan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084219": {
    "id": "item_29188",
    "Last Name": "LEE",
    "First Name": "HAEHO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084349": {
    "id": "item_14412",
    "Last Name": "Van Nuffelen",
    "First Name": "Werner",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084464": {
    "id": "item_14413",
    "Last Name": "PARK",
    "First Name": "JONGYUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084481": {
    "id": "item_14414",
    "Last Name": "Eigenmann",
    "First Name": "Aluizio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084513": {
    "id": "item_3535",
    "Last Name": "CARBALLO CUADRADO",
    "First Name": "ARGIMIRO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084566": {
    "id": "item_27071",
    "Last Name": "REGI LOPEZ",
    "First Name": "IRENE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084716": {
    "id": "item_31147",
    "Last Name": "HAMANI",
    "First Name": "JOSEF",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084733": {
    "id": "item_5748",
    "Last Name": "Grillo",
    "First Name": "Giacomo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084768": {
    "id": "item_31148",
    "Last Name": "HAMANI",
    "First Name": "HAYA ZVIYA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084924": {
    "id": "item_29189",
    "Last Name": "CHOI",
    "First Name": "BYEONGKIL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084932": {
    "id": "item_29190",
    "Last Name": "PADILLA MONTOLIU",
    "First Name": "MARTA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084962": {
    "id": "item_29191",
    "Last Name": "VINAS ALCON",
    "First Name": "ROGER",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43085131": {
    "id": "item_1678",
    "Last Name": "Chong",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43085136": {
    "id": "item_1679",
    "Last Name": "Li",
    "First Name": "Jinghong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43085229": {
    "id": "item_1680",
    "Last Name": "Robbins",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43085703": {
    "id": "item_27072",
    "Last Name": "Pile",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43085780": {
    "id": "item_3536",
    "Last Name": "van den Brule",
    "First Name": "Judith",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43087131": {
    "id": "item_27073",
    "Last Name": "Koekkoek",
    "First Name": "Sabine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43087161": {
    "id": "item_1681",
    "Last Name": "Wongvenai",
    "First Name": "Rakphong",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43092550": {
    "id": "item_14415",
    "Last Name": "Jeeninga",
    "First Name": "Pieter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43092661": {
    "id": "item_1682",
    "Last Name": "Mundt",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43093506": {
    "id": "item_27074",
    "Last Name": "SUN",
    "First Name": "CHUNSHENG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43093739": {
    "id": "item_27075",
    "Last Name": "Papa",
    "First Name": "Fabrizio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43093745": {
    "id": "item_14416",
    "Last Name": "Zimmermann",
    "First Name": "Janet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43093932": {
    "id": "item_3537",
    "Last Name": "MARCHET",
    "First Name": "Gilles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43094542": {
    "id": "item_1683",
    "Last Name": "Pingaro",
    "First Name": "Rosario",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43095050": {
    "id": "item_29192",
    "Last Name": "Di Lorenzo",
    "First Name": "Marilena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43095636": {
    "id": "item_27076",
    "Last Name": "carrera",
    "First Name": "manuela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43095768": {
    "id": "item_31149",
    "Last Name": "Wong",
    "First Name": "Leona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43096144": {
    "id": "item_29193",
    "Last Name": "Lopez Rodriguez",
    "First Name": "Wilma Ivelisse",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43096722": {
    "id": "item_31150",
    "Last Name": "LAURENT",
    "First Name": "Jean-Michel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43097048": {
    "id": "item_1684",
    "Last Name": "PAREDES SANCHEZ",
    "First Name": "LUIS EDUARDO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43097825": {
    "id": "item_16504",
    "Last Name": "Ayala Gonzalez",
    "First Name": "Karem",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43098203": {
    "id": "item_27077",
    "Last Name": "ANDENA",
    "First Name": "GIANLUCA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43098523": {
    "id": "item_27078",
    "Last Name": "Rane",
    "First Name": "Shashikant",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43098634": {
    "id": "item_3538",
    "Last Name": "Tio German",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43099328": {
    "id": "item_3539",
    "Last Name": "Tode",
    "First Name": "Michel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43099421": {
    "id": "item_27079",
    "Last Name": "HERNANDEZ",
    "First Name": "JUAN CARLOS",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43099610": {
    "id": "item_16505",
    "Last Name": "Inga Sigurta",
    "First Name": "Giuseppe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43099694": {
    "id": "item_31151",
    "Last Name": "Britain",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43099802": {
    "id": "item_27080",
    "Last Name": "Langlois",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43100737": {
    "id": "item_14417",
    "Last Name": "Coppinger",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43100920": {
    "id": "item_27081",
    "Last Name": "Khanom",
    "First Name": "Nazrin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43101081": {
    "id": "item_27082",
    "Last Name": "Van Thienen",
    "First Name": "Kid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43101091": {
    "id": "item_31152",
    "Last Name": "Petersen",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43101367": {
    "id": "item_3540",
    "Last Name": "Hills",
    "First Name": "Chavet",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43101455": {
    "id": "item_27083",
    "Last Name": "DeVries",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43102257": {
    "id": "item_29194",
    "Last Name": "Wills",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43102994": {
    "id": "item_14418",
    "Last Name": "Zoller",
    "First Name": "Allyson",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43103321": {
    "id": "item_29195",
    "Last Name": "Gonzalez",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43103752": {
    "id": "item_1685",
    "Last Name": "Samara",
    "First Name": "Karim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43105531": {
    "id": "item_29196",
    "Last Name": "Kassim",
    "First Name": "Mohamad Hafiz Bin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43108200": {
    "id": "item_27084",
    "Last Name": "ZHU",
    "First Name": "XUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43108314": {
    "id": "item_27085",
    "Last Name": "HU",
    "First Name": "JIAHUI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43108411": {
    "id": "item_16506",
    "Last Name": "Bustamante Cerecer",
    "First Name": "Juan German",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43108524": {
    "id": "item_3541",
    "Last Name": "Regusen",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43109343": {
    "id": "item_3542",
    "Last Name": "Roker",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43109374": {
    "id": "item_3543",
    "Last Name": "Armstrong",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43109710": {
    "id": "item_14419",
    "Last Name": "Phillips",
    "First Name": "Issy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43109937": {
    "id": "item_27086",
    "Last Name": "Shiomi",
    "First Name": "Tamaka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43109939": {
    "id": "item_27087",
    "Last Name": "Ohara",
    "First Name": "Yuri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43110153": {
    "id": "item_1686",
    "Last Name": "Monasterio",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43110216": {
    "id": "item_14420",
    "Last Name": "Nitichawin",
    "First Name": "Teerit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43110328": {
    "id": "item_3544",
    "Last Name": "Cincin",
    "First Name": "Burcu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43110375": {
    "id": "item_14421",
    "Last Name": "Wang",
    "First Name": "Xiaodan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43111095": {
    "id": "item_14422",
    "Last Name": "Ballisager",
    "First Name": "Anders",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43111172": {
    "id": "item_3545",
    "Last Name": "ZHANG",
    "First Name": "XIAOXIA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43111649": {
    "id": "item_27088",
    "Last Name": "bjoernermark",
    "First Name": "thomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43111695": {
    "id": "item_27089",
    "Last Name": "Samson",
    "First Name": "Carelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43111809": {
    "id": "item_16507",
    "Last Name": "Timmermans",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43111810": {
    "id": "item_16508",
    "Last Name": "ZHONG",
    "First Name": "SHAN TOMMY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43112175": {
    "id": "item_16509",
    "Last Name": "BUGANZA",
    "First Name": "ERICA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43112330": {
    "id": "item_27090",
    "Last Name": "SAULE",
    "First Name": "PHILIPPE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43112468": {
    "id": "item_27091",
    "Last Name": "HENRION",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43112676": {
    "id": "item_27092",
    "Last Name": "BALESTRIERI",
    "First Name": "ERMANNO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43112866": {
    "id": "item_29197",
    "Last Name": "Germa",
    "First Name": "Chantal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43112910": {
    "id": "item_27093",
    "Last Name": "AVIAT",
    "First Name": "CHRISTOPHE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43113031": {
    "id": "item_14423",
    "Last Name": "Vinciguerra",
    "First Name": "Giuseppe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43114012": {
    "id": "item_27094",
    "Last Name": "MOMART PERRON",
    "First Name": "isabelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43115402": {
    "id": "item_29198",
    "Last Name": "Stevens",
    "First Name": "Yolanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43116003": {
    "id": "item_27095",
    "Last Name": "Carcel",
    "First Name": "Sydney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43116068": {
    "id": "item_14424",
    "Last Name": "forster",
    "First Name": "rowan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43116491": {
    "id": "item_1687",
    "Last Name": "Fergeau",
    "First Name": "Denis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43118173": {
    "id": "item_29199",
    "Last Name": "Montgomery",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43119784": {
    "id": "item_27096",
    "Last Name": "Monterotti",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43120270": {
    "id": "item_27097",
    "Last Name": "Wright",
    "First Name": "Ana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43120279": {
    "id": "item_1688",
    "Last Name": "BADDA",
    "First Name": "OMAR",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43120479": {
    "id": "item_14425",
    "Last Name": "Engels",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43126294": {
    "id": "item_3546",
    "Last Name": "BEGUIN",
    "First Name": "Mathias",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43126329": {
    "id": "item_29200",
    "Last Name": "Pincombe",
    "First Name": "Donald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43127389": {
    "id": "item_3547",
    "Last Name": "COLLINS",
    "First Name": "KERI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43127937": {
    "id": "item_14426",
    "Last Name": "Bravata",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43128275": {
    "id": "item_14427",
    "Last Name": "Fernandez",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43128940": {
    "id": "item_31153",
    "Last Name": "GAILLOT",
    "First Name": "GREGOIRE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43129601": {
    "id": "item_3548",
    "Last Name": "G—mez",
    "First Name": "Gerardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43130244": {
    "id": "item_16510",
    "Last Name": "De la Cruz Talavera",
    "First Name": "Arturo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43130371": {
    "id": "item_27098",
    "Last Name": "Alvarez G.",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43130992": {
    "id": "item_1689",
    "Last Name": "Vannini",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43131488": {
    "id": "item_27099",
    "Last Name": "Davenport-Ezell",
    "First Name": "Letitia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43132525": {
    "id": "item_3549",
    "Last Name": "Saavedra Pazos",
    "First Name": "JosŽ Antonio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43132963": {
    "id": "item_27100",
    "Last Name": "Ling",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43133659": {
    "id": "item_27101",
    "Last Name": "OLIVARES SOTO",
    "First Name": "VICTOR MANUEL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43133754": {
    "id": "item_31154",
    "Last Name": "Leduc",
    "First Name": "Astrid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43134305": {
    "id": "item_29201",
    "Last Name": "Franceschi",
    "First Name": "Yanira",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43135700": {
    "id": "item_16511",
    "Last Name": "Wynne",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43137277": {
    "id": "item_3550",
    "Last Name": "MO",
    "First Name": "TAK SING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43138606": {
    "id": "item_14428",
    "Last Name": "HSU",
    "First Name": "CHING-HUI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43139572": {
    "id": "item_27102",
    "Last Name": "PERRON",
    "First Name": "STEPHANE HENRI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43139652": {
    "id": "item_16512",
    "Last Name": "Beqiri",
    "First Name": "Bledjana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43140084": {
    "id": "item_31155",
    "Last Name": "WADA",
    "First Name": "NAOAKI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43140108": {
    "id": "item_31156",
    "Last Name": "WADA",
    "First Name": "KAZUKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43140843": {
    "id": "item_29202",
    "Last Name": "Dearden",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43143518": {
    "id": "item_1690",
    "Last Name": "Williams",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43144248": {
    "id": "item_14429",
    "Last Name": "Bastioni",
    "First Name": "Cesare Ettore",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43144348": {
    "id": "item_27103",
    "Last Name": "Talarico",
    "First Name": "Giuseppina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43144396": {
    "id": "item_29203",
    "Last Name": "HENRY",
    "First Name": "Philippe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43144583": {
    "id": "item_3551",
    "Last Name": "Chang",
    "First Name": "Jeng-Ying",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43144779": {
    "id": "item_16513",
    "Last Name": "Born",
    "First Name": "Pier Paolo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43144888": {
    "id": "item_14430",
    "Last Name": "Pera",
    "First Name": "Paolo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43148380": {
    "id": "item_29204",
    "Last Name": "BATTAGLIA",
    "First Name": "FRANCESCA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43148523": {
    "id": "item_29205",
    "Last Name": "AGUINALDO",
    "First Name": "JENEFER",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43151298": {
    "id": "item_14431",
    "Last Name": "Raabe",
    "First Name": "Willard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43152576": {
    "id": "item_29206",
    "Last Name": "Kobayashi",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43152737": {
    "id": "item_1691",
    "Last Name": "Bird",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43153276": {
    "id": "item_29207",
    "Last Name": "Sigala",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43153279": {
    "id": "item_27104",
    "Last Name": "Bravo Sigala",
    "First Name": "Guadalupe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43153320": {
    "id": "item_29208",
    "Last Name": "Fleming",
    "First Name": "Regina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43154122": {
    "id": "item_29209",
    "Last Name": "Annesley",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43154331": {
    "id": "item_29210",
    "Last Name": "Pagan",
    "First Name": "Lizbeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43154689": {
    "id": "item_29211",
    "Last Name": "Al-Hussayen",
    "First Name": "Anas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43155545": {
    "id": "item_14432",
    "Last Name": "Kuhn",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43156815": {
    "id": "item_27105",
    "Last Name": "Zhou",
    "First Name": "Xijin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43156862": {
    "id": "item_27106",
    "Last Name": "Rossi",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43157646": {
    "id": "item_1692",
    "Last Name": "BEDIER",
    "First Name": "ARNAUD",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43157816": {
    "id": "item_3552",
    "Last Name": "Krupica",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43158352": {
    "id": "item_27107",
    "Last Name": "COUFFINHAL",
    "First Name": "BENOIT",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43159730": {
    "id": "item_14433",
    "Last Name": "Miller Levin",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43159830": {
    "id": "item_16514",
    "Last Name": "Sannes",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43161512": {
    "id": "item_29212",
    "Last Name": "KAO",
    "First Name": "JUNG HUI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43162149": {
    "id": "item_14434",
    "Last Name": "Crowell",
    "First Name": "Ragan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43162169": {
    "id": "item_29213",
    "Last Name": "Gordon",
    "First Name": "Nikisha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43162345": {
    "id": "item_1693",
    "Last Name": "Lucke",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43165184": {
    "id": "item_29214",
    "Last Name": "HENRY",
    "First Name": "Marine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43166090": {
    "id": "item_27108",
    "Last Name": "De Lee",
    "First Name": "Johan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43166461": {
    "id": "item_27109",
    "Last Name": "Kuick",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43166841": {
    "id": "item_27110",
    "Last Name": "Zanella",
    "First Name": "Marco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43167550": {
    "id": "item_31157",
    "Last Name": "Noverraz",
    "First Name": "Jacques-Daniel Marcel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43167820": {
    "id": "item_14435",
    "Last Name": "Cooper",
    "First Name": "Hilary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43169478": {
    "id": "item_3553",
    "Last Name": "Gillings",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43170724": {
    "id": "item_3554",
    "Last Name": "Milhuisen",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43173054": {
    "id": "item_1694",
    "Last Name": "O'Neill",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43174509": {
    "id": "item_27111",
    "Last Name": "Christodoulou",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43175552": {
    "id": "item_27112",
    "Last Name": "Hung",
    "First Name": "Gina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43176783": {
    "id": "item_1695",
    "Last Name": "Grayer",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43177042": {
    "id": "item_16515",
    "Last Name": "Gibson",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43177140": {
    "id": "item_1696",
    "Last Name": "Avisado",
    "First Name": "Maria Christina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43177208": {
    "id": "item_3555",
    "Last Name": "An",
    "First Name": "Fengfa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43177229": {
    "id": "item_16516",
    "Last Name": "CHEN",
    "First Name": "RUIPING",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43177409": {
    "id": "item_14436",
    "Last Name": "Demery",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43178507": {
    "id": "item_14437",
    "Last Name": "Augustyns",
    "First Name": "Jozef",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43178595": {
    "id": "item_14438",
    "Last Name": "VILLAR PAREDES",
    "First Name": "ARAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43178597": {
    "id": "item_27113",
    "Last Name": "Casali",
    "First Name": "Carlo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43178905": {
    "id": "item_27114",
    "Last Name": "Drobinski",
    "First Name": "LUDOVIC",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43178951": {
    "id": "item_27115",
    "Last Name": "Maples",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43178998": {
    "id": "item_3556",
    "Last Name": "SOBKOWIAK",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179119": {
    "id": "item_1697",
    "Last Name": "Locatelli",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179242": {
    "id": "item_29215",
    "Last Name": "Jacquemin",
    "First Name": "Jean-Luc",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179454": {
    "id": "item_27116",
    "Last Name": "Sinton",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179466": {
    "id": "item_3557",
    "Last Name": "de Gier",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179495": {
    "id": "item_27117",
    "Last Name": "Leepipattanawit",
    "First Name": "kittipon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179577": {
    "id": "item_27118",
    "Last Name": "Leepipattanawit",
    "First Name": "Varisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179812": {
    "id": "item_3558",
    "Last Name": "Gadaleta",
    "First Name": "Sebastiano",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179875": {
    "id": "item_27119",
    "Last Name": "LEE",
    "First Name": "YIN YI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180062": {
    "id": "item_16517",
    "Last Name": "Black",
    "First Name": "Milla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180133": {
    "id": "item_14439",
    "Last Name": "VLACHOS",
    "First Name": "GEORGIOS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180170": {
    "id": "item_27120",
    "Last Name": "Jitmaitreejaroen",
    "First Name": "Narumol",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180428": {
    "id": "item_29216",
    "Last Name": "Motta",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180481": {
    "id": "item_16518",
    "Last Name": "leawpairote",
    "First Name": "kosin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180853": {
    "id": "item_31158",
    "Last Name": "STELLAN",
    "First Name": "JOHN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180925": {
    "id": "item_27121",
    "Last Name": "SOGGIU",
    "First Name": "ROBERTO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43181057": {
    "id": "item_16519",
    "Last Name": "Chubthaisong",
    "First Name": "Chutima",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43181115": {
    "id": "item_14440",
    "Last Name": "Hengwattanaarpaa",
    "First Name": "Naruechit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43181359": {
    "id": "item_27122",
    "Last Name": "Iamsakul",
    "First Name": "Chirawadee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43181788": {
    "id": "item_27123",
    "Last Name": "Iamsakul",
    "First Name": "Jeerisuda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43181846": {
    "id": "item_27124",
    "Last Name": "De Solda",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43182303": {
    "id": "item_14441",
    "Last Name": "OTSETSUI",
    "First Name": "Ninon Diane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43184938": {
    "id": "item_16520",
    "Last Name": "Kupiec",
    "First Name": "Danuta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43185348": {
    "id": "item_1698",
    "Last Name": "Kruszewski",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43185441": {
    "id": "item_29217",
    "Last Name": "MARTINEZ GARZA",
    "First Name": "SAMANTHA MELISSA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43185674": {
    "id": "item_3559",
    "Last Name": "KATINIOTIS",
    "First Name": "GEORGIOS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43185861": {
    "id": "item_14442",
    "Last Name": "MADANI",
    "First Name": "SAFAA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43186346": {
    "id": "item_14443",
    "Last Name": "Staples",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43186493": {
    "id": "item_29218",
    "Last Name": "Schoenaerts",
    "First Name": "Karolien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43186732": {
    "id": "item_14444",
    "Last Name": "COLAZZO",
    "First Name": "ROBERTO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43186740": {
    "id": "item_27125",
    "Last Name": "Castellanos losoya",
    "First Name": "Blanca Estela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43186851": {
    "id": "item_27126",
    "Last Name": "Fraser",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43187223": {
    "id": "item_29219",
    "Last Name": "O'Brien",
    "First Name": "Mary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43188340": {
    "id": "item_16521",
    "Last Name": "Schmid",
    "First Name": "Reto Gaudenz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43188452": {
    "id": "item_27127",
    "Last Name": "Fraser Jr",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43189243": {
    "id": "item_14445",
    "Last Name": "Bashar",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43189528": {
    "id": "item_1699",
    "Last Name": "Goriunov",
    "First Name": "Andrei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43189605": {
    "id": "item_1700",
    "Last Name": "GORIUNOV",
    "First Name": "Andrei",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43190010": {
    "id": "item_14446",
    "Last Name": "Sharma",
    "First Name": "Nitin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43190579": {
    "id": "item_1701",
    "Last Name": "Fischer",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43190818": {
    "id": "item_31159",
    "Last Name": "Rodriguez Rivera",
    "First Name": "Dante",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43198407": {
    "id": "item_29220",
    "Last Name": "Luton",
    "First Name": "Missy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43198690": {
    "id": "item_27128",
    "Last Name": "Hurst",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43199173": {
    "id": "item_27129",
    "Last Name": "Esm Zad",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43199361": {
    "id": "item_3560",
    "Last Name": "Chandra",
    "First Name": "Stevanus hadi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43200352": {
    "id": "item_27130",
    "Last Name": "SHIMAMUNE",
    "First Name": "TAKASHI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43201951": {
    "id": "item_3561",
    "Last Name": "Papadopoulou",
    "First Name": "Eleftheria",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43202073": {
    "id": "item_14447",
    "Last Name": "MATIS",
    "First Name": "ALEXANDROS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43202298": {
    "id": "item_27131",
    "Last Name": "Kengmana",
    "First Name": "Juthatip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43202934": {
    "id": "item_31160",
    "Last Name": "Spiteri",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43203452": {
    "id": "item_3562",
    "Last Name": "Gorbachov",
    "First Name": "Mykola",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43203910": {
    "id": "item_16522",
    "Last Name": "Seliang",
    "First Name": "Charley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43204405": {
    "id": "item_27132",
    "Last Name": "Sonne",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43204559": {
    "id": "item_1702",
    "Last Name": "Cheng",
    "First Name": "Ah Ping",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43204602": {
    "id": "item_16523",
    "Last Name": "TSAI",
    "First Name": "YULUNG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43205324": {
    "id": "item_1703",
    "Last Name": "Maraniello",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43205467": {
    "id": "item_16524",
    "Last Name": "Blomholm Kvamme",
    "First Name": "Anita",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43205574": {
    "id": "item_14448",
    "Last Name": "Telen",
    "First Name": "Frank Steinhauer",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43205765": {
    "id": "item_29221",
    "Last Name": "Blackburn",
    "First Name": "Howard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43205954": {
    "id": "item_1704",
    "Last Name": "perianez",
    "First Name": "manuel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206502": {
    "id": "item_27133",
    "Last Name": "Sangalli",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206538": {
    "id": "item_31161",
    "Last Name": "Slotte",
    "First Name": "Clas-Eirik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206864": {
    "id": "item_27134",
    "Last Name": "Utama",
    "First Name": "Suta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206875": {
    "id": "item_3563",
    "Last Name": "Al-Hajri",
    "First Name": "Rashid",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43207436": {
    "id": "item_16525",
    "Last Name": "Tejero Garcia",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43207859": {
    "id": "item_27135",
    "Last Name": "Bauders",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43208158": {
    "id": "item_27136",
    "Last Name": "McClymont",
    "First Name": "Wendy Lynne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43208332": {
    "id": "item_14449",
    "Last Name": "Bond",
    "First Name": "CAREN-ANNE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43208783": {
    "id": "item_3564",
    "Last Name": "Wagner",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43209160": {
    "id": "item_14450",
    "Last Name": "Andersson",
    "First Name": "Lars-Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43212879": {
    "id": "item_1705",
    "Last Name": "Jorge Arellano",
    "First Name": "Maria del Rocio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43213008": {
    "id": "item_3565",
    "Last Name": "Armoa",
    "First Name": "Maria Florencia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43215782": {
    "id": "item_3566",
    "Last Name": "Valencia",
    "First Name": "Leandro oscar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43217210": {
    "id": "item_14451",
    "Last Name": "Hanes",
    "First Name": "Seth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43218817": {
    "id": "item_14452",
    "Last Name": "Paersson",
    "First Name": "Stefan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43218912": {
    "id": "item_14453",
    "Last Name": "Paersson",
    "First Name": "Hampus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43219635": {
    "id": "item_3567",
    "Last Name": "Sucasas Delgado Santos",
    "First Name": "Valqu’ria",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43221512": {
    "id": "item_27137",
    "Last Name": "Butler",
    "First Name": "Ebony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43221829": {
    "id": "item_3568",
    "Last Name": "Mathis Jr",
    "First Name": "William Sanders",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43221838": {
    "id": "item_1706",
    "Last Name": "MORA",
    "First Name": "FERNANDO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43222809": {
    "id": "item_29222",
    "Last Name": "VIDAL RAMIREZ",
    "First Name": "MERCEDES",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43223109": {
    "id": "item_27138",
    "Last Name": "Delgado",
    "First Name": "Narvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43223148": {
    "id": "item_14454",
    "Last Name": "rubio urria",
    "First Name": "marcela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43223378": {
    "id": "item_16526",
    "Last Name": "JIMENEZ",
    "First Name": "GIUSSEPPE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43223480": {
    "id": "item_3569",
    "Last Name": "LAGRUE",
    "First Name": "Benoit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43223607": {
    "id": "item_29223",
    "Last Name": "Critchley",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224040": {
    "id": "item_1707",
    "Last Name": "Haugen",
    "First Name": "Bj¿rn Ivar",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224101": {
    "id": "item_27139",
    "Last Name": "Koch",
    "First Name": "Elise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224417": {
    "id": "item_29224",
    "Last Name": "ROA NONIDE",
    "First Name": "ALEJANDRO MARêA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224418": {
    "id": "item_29225",
    "Last Name": "Roa Reyes",
    "First Name": "Mart’n",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224521": {
    "id": "item_27140",
    "Last Name": "BlommŽ",
    "First Name": "Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224599": {
    "id": "item_1708",
    "Last Name": "Peralvo",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224685": {
    "id": "item_1709",
    "Last Name": "PALENCIA FERNANDEZ",
    "First Name": "JORGE ALEJANDRO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224729": {
    "id": "item_1710",
    "Last Name": "Albaugh",
    "First Name": "Megan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43224731": {
    "id": "item_1711",
    "Last Name": "Fields",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43225228": {
    "id": "item_16527",
    "Last Name": "Ratkai",
    "First Name": "Tamas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43225258": {
    "id": "item_29226",
    "Last Name": "Marcinkevicz",
    "First Name": "JŸri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43225733": {
    "id": "item_3570",
    "Last Name": "VELASQUEZ LARIOS",
    "First Name": "CESAR OCTAVIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43225840": {
    "id": "item_14455",
    "Last Name": "CHATZIKOSTAS",
    "First Name": "TZOULIANO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43226129": {
    "id": "item_31162",
    "Last Name": "Cole",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43226210": {
    "id": "item_1712",
    "Last Name": "Brucetta QUESADA",
    "First Name": "Cristian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43226763": {
    "id": "item_1713",
    "Last Name": "Basile",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43227081": {
    "id": "item_14456",
    "Last Name": "Stampa",
    "First Name": "Evelina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43227644": {
    "id": "item_14457",
    "Last Name": "Christophersen",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43228159": {
    "id": "item_3571",
    "Last Name": "RIVADENEYRA USURIN",
    "First Name": "JULIO ANTONIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43228513": {
    "id": "item_3572",
    "Last Name": "TENORIO GONZALES",
    "First Name": "MARIA GIOVANNA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229469": {
    "id": "item_27141",
    "Last Name": "Satwilkar",
    "First Name": "Nihar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229632": {
    "id": "item_27142",
    "Last Name": "Ryoo",
    "First Name": "Kyung Hee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229701": {
    "id": "item_1714",
    "Last Name": "Henriquez",
    "First Name": "Humberto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229778": {
    "id": "item_27143",
    "Last Name": "Hauser",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229897": {
    "id": "item_1715",
    "Last Name": "Henriquez",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43231476": {
    "id": "item_27144",
    "Last Name": "Vallarta",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43231998": {
    "id": "item_27145",
    "Last Name": "Yeung",
    "First Name": "Wing Pui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43234015": {
    "id": "item_14458",
    "Last Name": "GONZALEZ",
    "First Name": "PERLA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43234570": {
    "id": "item_1716",
    "Last Name": "jauregui",
    "First Name": "romina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43235092": {
    "id": "item_14459",
    "Last Name": "Larranaga Espinosa",
    "First Name": "Liliana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43235903": {
    "id": "item_31163",
    "Last Name": "Moor",
    "First Name": "Giselle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43236668": {
    "id": "item_14460",
    "Last Name": "WU",
    "First Name": "HUANG JU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43237201": {
    "id": "item_27146",
    "Last Name": "McGill",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43237998": {
    "id": "item_14461",
    "Last Name": "Cruz",
    "First Name": "Ser Lester",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43238945": {
    "id": "item_29227",
    "Last Name": "YU",
    "First Name": "ZHAOXIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43239541": {
    "id": "item_14462",
    "Last Name": "Sigalas",
    "First Name": "Dimitrios",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43240138": {
    "id": "item_27147",
    "Last Name": "Dybvad",
    "First Name": "Tove Elisabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43240360": {
    "id": "item_14463",
    "Last Name": "JOHANSSON",
    "First Name": "PATRIK DANIEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43240362": {
    "id": "item_1717",
    "Last Name": "WU",
    "First Name": "WAN-TING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43241052": {
    "id": "item_14465",
    "Last Name": "MARTINEZ ORTEGA",
    "First Name": "JOSE ANGEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43241055": {
    "id": "item_14464",
    "Last Name": "Friedlander",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43241408": {
    "id": "item_16528",
    "Last Name": "Wicker",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43241657": {
    "id": "item_14466",
    "Last Name": "Dorn",
    "First Name": "Johannes Fritz Cornelius",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43242566": {
    "id": "item_29228",
    "Last Name": "LEE",
    "First Name": "TIEN YU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43242971": {
    "id": "item_27148",
    "Last Name": "Lee",
    "First Name": "Brogan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43243684": {
    "id": "item_3573",
    "Last Name": "Sutowo",
    "First Name": "Maulana Indraguna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43243718": {
    "id": "item_27149",
    "Last Name": "Arshad",
    "First Name": "Tashfeen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43243771": {
    "id": "item_29229",
    "Last Name": "Meer",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43243792": {
    "id": "item_16529",
    "Last Name": "Forsland",
    "First Name": "Carl ¯ivind Hill",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43244372": {
    "id": "item_14467",
    "Last Name": "Crummett",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43244894": {
    "id": "item_31164",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43245413": {
    "id": "item_31165",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43245648": {
    "id": "item_14468",
    "Last Name": "kramer-wimmer",
    "First Name": "Anne-Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43245699": {
    "id": "item_3574",
    "Last Name": "Rosasco",
    "First Name": "Luciano",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43247900": {
    "id": "item_1718",
    "Last Name": "Malik",
    "First Name": "Hinna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43247953": {
    "id": "item_1719",
    "Last Name": "noel",
    "First Name": "jonah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43249007": {
    "id": "item_1720",
    "Last Name": "Tsui",
    "First Name": "Man Chun",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43249400": {
    "id": "item_27150",
    "Last Name": "PALMA",
    "First Name": "JUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43249496": {
    "id": "item_29230",
    "Last Name": "Nsubuga",
    "First Name": "Jean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43249820": {
    "id": "item_16530",
    "Last Name": "Elshanshory",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43250370": {
    "id": "item_14469",
    "Last Name": "PUCH MAESE",
    "First Name": "DAVID RAMON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43250466": {
    "id": "item_1721",
    "Last Name": "HUANG",
    "First Name": "KUEIHANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43250467": {
    "id": "item_29231",
    "Last Name": "Pilloud",
    "First Name": "Jeannine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43251442": {
    "id": "item_27151",
    "Last Name": "Baselli",
    "First Name": "Mario",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43251866": {
    "id": "item_3575",
    "Last Name": "hsu",
    "First Name": "ming hung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43251871": {
    "id": "item_29232",
    "Last Name": "Gage",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43251873": {
    "id": "item_14470",
    "Last Name": "Lama Capellan",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43252454": {
    "id": "item_14471",
    "Last Name": "Sahakian",
    "First Name": "Ruben Ricardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43252542": {
    "id": "item_29233",
    "Last Name": "Farestveit",
    "First Name": "unni grete",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43252699": {
    "id": "item_3576",
    "Last Name": "Prince",
    "First Name": "Akiko",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43253014": {
    "id": "item_14472",
    "Last Name": "Casta–",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43253077": {
    "id": "item_14473",
    "Last Name": "VARGAS",
    "First Name": "JAQUELINE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43253383": {
    "id": "item_1722",
    "Last Name": "Aubut",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43254561": {
    "id": "item_3577",
    "Last Name": "Ramos Varela",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43255393": {
    "id": "item_27152",
    "Last Name": "rancourt",
    "First Name": "benoit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43255703": {
    "id": "item_27153",
    "Last Name": "rancourt",
    "First Name": "roland",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256157": {
    "id": "item_31166",
    "Last Name": "Forrest",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256424": {
    "id": "item_5749",
    "Last Name": "Jurczak",
    "First Name": "Jakub",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256584": {
    "id": "item_5750",
    "Last Name": "Jurczak",
    "First Name": "Przemys_aw",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256911": {
    "id": "item_14474",
    "Last Name": "Carranza",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256936": {
    "id": "item_29234",
    "Last Name": "Pearce",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256937": {
    "id": "item_31167",
    "Last Name": "Bursie",
    "First Name": "Petrina D",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256969": {
    "id": "item_14475",
    "Last Name": "Ceballos",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257110": {
    "id": "item_29235",
    "Last Name": "Porto",
    "First Name": "Simone",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257126": {
    "id": "item_27155",
    "Last Name": "Pascal",
    "First Name": "Thea-Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257130": {
    "id": "item_27154",
    "Last Name": "Bachmann Weiss",
    "First Name": "Mikaela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257404": {
    "id": "item_1723",
    "Last Name": "Goulet",
    "First Name": "Dany",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257781": {
    "id": "item_29236",
    "Last Name": "Gladden",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257782": {
    "id": "item_29237",
    "Last Name": "Gladden",
    "First Name": "Hillery",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258569": {
    "id": "item_14476",
    "Last Name": "Pitts",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258599": {
    "id": "item_3578",
    "Last Name": "Handler",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258725": {
    "id": "item_29238",
    "Last Name": "Ross",
    "First Name": "Paula",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258778": {
    "id": "item_27156",
    "Last Name": "Sedchaicharn",
    "First Name": "Boonchu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43259391": {
    "id": "item_27157",
    "Last Name": "Staricco",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43260108": {
    "id": "item_1724",
    "Last Name": "Fu",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43260615": {
    "id": "item_27158",
    "Last Name": "JUNG",
    "First Name": "NAM GWI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43260749": {
    "id": "item_27159",
    "Last Name": "OH",
    "First Name": "GILJA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43261149": {
    "id": "item_27160",
    "Last Name": "PARK",
    "First Name": "CHEON GYU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43261300": {
    "id": "item_27161",
    "Last Name": "torrents",
    "First Name": "jose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43261401": {
    "id": "item_1725",
    "Last Name": "Ulloa",
    "First Name": "Gerardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43261760": {
    "id": "item_29239",
    "Last Name": "Roberts",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43262082": {
    "id": "item_16531",
    "Last Name": "Kwong",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43262248": {
    "id": "item_14477",
    "Last Name": "Pullela",
    "First Name": "Suresh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43264439": {
    "id": "item_14478",
    "Last Name": "Sadler",
    "First Name": "Jenny Paola",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43265011": {
    "id": "item_31168",
    "Last Name": "CAI",
    "First Name": "MENG JIA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43265545": {
    "id": "item_27162",
    "Last Name": "CHANG",
    "First Name": "HONG YU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43266569": {
    "id": "item_3579",
    "Last Name": "Leishman",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43267238": {
    "id": "item_27163",
    "Last Name": "Swift",
    "First Name": "Phil",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43268687": {
    "id": "item_1726",
    "Last Name": "Fuller",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43269207": {
    "id": "item_27164",
    "Last Name": "Polubotko",
    "First Name": "Marina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43269221": {
    "id": "item_1727",
    "Last Name": "Colvin",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43269442": {
    "id": "item_29240",
    "Last Name": "YANG",
    "First Name": "SHU-CHEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43269803": {
    "id": "item_27165",
    "Last Name": "Montero",
    "First Name": "Mar’a Alexandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43269911": {
    "id": "item_27166",
    "Last Name": "Paradise",
    "First Name": "Rosalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270022": {
    "id": "item_27167",
    "Last Name": "KIM",
    "First Name": "JUNEHWAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270055": {
    "id": "item_14479",
    "Last Name": "KWEON",
    "First Name": "SUNYAK",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270206": {
    "id": "item_27168",
    "Last Name": "IM",
    "First Name": "TAE GYOO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270308": {
    "id": "item_3580",
    "Last Name": "Kelly",
    "First Name": "Louise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270322": {
    "id": "item_14480",
    "Last Name": "LEE",
    "First Name": "JONG CHUL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270660": {
    "id": "item_27169",
    "Last Name": "Ong",
    "First Name": "Chu Hui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270723": {
    "id": "item_14481",
    "Last Name": "Ausenda",
    "First Name": "Marcello",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270725": {
    "id": "item_1728",
    "Last Name": "Aoun",
    "First Name": "Maria Teresa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270781": {
    "id": "item_27170",
    "Last Name": "LEE",
    "First Name": "CHUL SOO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270811": {
    "id": "item_3581",
    "Last Name": "KWON",
    "First Name": "JUNGHOON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270834": {
    "id": "item_27171",
    "Last Name": "KIM",
    "First Name": "GUNOK",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270844": {
    "id": "item_27172",
    "Last Name": "Nilsson",
    "First Name": "Birgitta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270911": {
    "id": "item_27173",
    "Last Name": "KANG",
    "First Name": "SEONGBONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271048": {
    "id": "item_18570",
    "Last Name": "HONG",
    "First Name": "EUNNYEO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271074": {
    "id": "item_18571",
    "Last Name": "LEE",
    "First Name": "MINKYU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271232": {
    "id": "item_27174",
    "Last Name": "Richardson",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271749": {
    "id": "item_31169",
    "Last Name": "Wong",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271939": {
    "id": "item_3582",
    "Last Name": "Frauhiger",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43272147": {
    "id": "item_27175",
    "Last Name": "Cai",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43272229": {
    "id": "item_31170",
    "Last Name": "Bucklew",
    "First Name": "Bill",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43272277": {
    "id": "item_29241",
    "Last Name": "Hard af Segerstad",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43272537": {
    "id": "item_1729",
    "Last Name": "Simpson",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43274348": {
    "id": "item_16532",
    "Last Name": "Coughlin",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43274739": {
    "id": "item_1730",
    "Last Name": "Sepulveda",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43274900": {
    "id": "item_14482",
    "Last Name": "Phillips",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43274926": {
    "id": "item_14483",
    "Last Name": "Goodson",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43275448": {
    "id": "item_31171",
    "Last Name": "Doyle",
    "First Name": "Rose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43275826": {
    "id": "item_1731",
    "Last Name": "Conduit",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276032": {
    "id": "item_16533",
    "Last Name": "Vermeulen",
    "First Name": "Hein",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276198": {
    "id": "item_3583",
    "Last Name": "Ferrando Aparicio",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276263": {
    "id": "item_14484",
    "Last Name": "Papathanasiou",
    "First Name": "Petros",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276282": {
    "id": "item_29242",
    "Last Name": "ARUTYUNOV",
    "First Name": "Dmitry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276524": {
    "id": "item_3584",
    "Last Name": "Lattanzio",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276645": {
    "id": "item_3585",
    "Last Name": "Leung",
    "First Name": "Wai Yin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276943": {
    "id": "item_27176",
    "Last Name": "Spaeni",
    "First Name": "Christian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43277393": {
    "id": "item_27177",
    "Last Name": "Tulagan",
    "First Name": "Rowena Santos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43277397": {
    "id": "item_14485",
    "Last Name": "Vasilatos",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43277623": {
    "id": "item_16534",
    "Last Name": "Aguirre",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43278299": {
    "id": "item_3586",
    "Last Name": "Graham",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43279246": {
    "id": "item_14486",
    "Last Name": "Delahaye",
    "First Name": "Fabienne",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43279389": {
    "id": "item_27178",
    "Last Name": "Rochel",
    "First Name": "Jessi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43279535": {
    "id": "item_16535",
    "Last Name": "Chiu",
    "First Name": "Ming Yan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43279678": {
    "id": "item_3587",
    "Last Name": "Anglen",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43280128": {
    "id": "item_14487",
    "Last Name": "Selby",
    "First Name": "May",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43280347": {
    "id": "item_14488",
    "Last Name": "olea covarrubias",
    "First Name": "esmeralda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43280552": {
    "id": "item_14489",
    "Last Name": "Bleau",
    "First Name": "Damon",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43281207": {
    "id": "item_14490",
    "Last Name": "Misirlioglu",
    "First Name": "Ismet",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43282702": {
    "id": "item_29243",
    "Last Name": "ALVAREZ",
    "First Name": "GABRIELA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43282835": {
    "id": "item_16536",
    "Last Name": "Kammerlander",
    "First Name": "Nadine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43282871": {
    "id": "item_14491",
    "Last Name": "Wei",
    "First Name": "Leilani",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43282908": {
    "id": "item_1732",
    "Last Name": "Grainger",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43282920": {
    "id": "item_14492",
    "Last Name": "Grainger",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283145": {
    "id": "item_3588",
    "Last Name": "Bhattacharya",
    "First Name": "Subhasish",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283223": {
    "id": "item_16537",
    "Last Name": "Kammerlander",
    "First Name": "Friedrich",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283276": {
    "id": "item_29244",
    "Last Name": "Fraser-Bell",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283462": {
    "id": "item_1733",
    "Last Name": "Lahjou",
    "First Name": "Mustapha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283546": {
    "id": "item_3589",
    "Last Name": "BERTRAND",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284255": {
    "id": "item_1734",
    "Last Name": "Lombana",
    "First Name": "Andres",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284368": {
    "id": "item_31172",
    "Last Name": "Docking",
    "First Name": "Annette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284597": {
    "id": "item_27179",
    "Last Name": "Wilkins",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284825": {
    "id": "item_14493",
    "Last Name": "Vickerman",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284905": {
    "id": "item_14494",
    "Last Name": "Doody",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43285282": {
    "id": "item_14495",
    "Last Name": "Lahoz Garcia",
    "First Name": "JosŽ Antonio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43286538": {
    "id": "item_16538",
    "Last Name": "Torres",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43287234": {
    "id": "item_1735",
    "Last Name": "Larsen",
    "First Name": "Jonhard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43287774": {
    "id": "item_16539",
    "Last Name": "Parra",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43288277": {
    "id": "item_3590",
    "Last Name": "Salinas",
    "First Name": "Paula",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43288634": {
    "id": "item_14496",
    "Last Name": "Mainsah",
    "First Name": "Evaristus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43288672": {
    "id": "item_3591",
    "Last Name": "Mardones",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43288852": {
    "id": "item_27180",
    "Last Name": "Gaughran",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43289038": {
    "id": "item_14497",
    "Last Name": "Lau",
    "First Name": "Ka Hei",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43289520": {
    "id": "item_14498",
    "Last Name": "Kalampakorn",
    "First Name": "Danukrit",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43291247": {
    "id": "item_3592",
    "Last Name": "Drogemuller",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43291531": {
    "id": "item_1736",
    "Last Name": "Kastor",
    "First Name": "Deena",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43293163": {
    "id": "item_16540",
    "Last Name": "Vinter",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43293662": {
    "id": "item_3593",
    "Last Name": "Gonzalez",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43293731": {
    "id": "item_1737",
    "Last Name": "chen",
    "First Name": "chien-hung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43293839": {
    "id": "item_16541",
    "Last Name": "chen",
    "First Name": "kailun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43294094": {
    "id": "item_27181",
    "Last Name": "Jusuf",
    "First Name": "Sumady",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43294367": {
    "id": "item_27182",
    "Last Name": "Sutanto",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43295107": {
    "id": "item_27183",
    "Last Name": "MABILLE",
    "First Name": "Didier",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43295487": {
    "id": "item_3594",
    "Last Name": "Swartz",
    "First Name": "Hilton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43295589": {
    "id": "item_3595",
    "Last Name": "Cohen",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43295677": {
    "id": "item_29245",
    "Last Name": "Janaway",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43296069": {
    "id": "item_14499",
    "Last Name": "Sedl‡kova Knotkova",
    "First Name": "Jana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43297416": {
    "id": "item_14500",
    "Last Name": "Buch",
    "First Name": "Tommy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43297831": {
    "id": "item_14501",
    "Last Name": "Easton",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43298645": {
    "id": "item_27184",
    "Last Name": "LEE",
    "First Name": "MUNYEOUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43298734": {
    "id": "item_27185",
    "Last Name": "Maher",
    "First Name": "Kim Davies",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43299307": {
    "id": "item_14502",
    "Last Name": "Mateo",
    "First Name": "Jose",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43299750": {
    "id": "item_27186",
    "Last Name": "van Veldhoven",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43299771": {
    "id": "item_1738",
    "Last Name": "Subotenko",
    "First Name": "Ihor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43300344": {
    "id": "item_1739",
    "Last Name": "Nikitin",
    "First Name": "Oleksandr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43300361": {
    "id": "item_1740",
    "Last Name": "Blasioli",
    "First Name": "Giacomo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43300367": {
    "id": "item_16542",
    "Last Name": "Russo",
    "First Name": "Marcelo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43301115": {
    "id": "item_29246",
    "Last Name": "Talerico",
    "First Name": "Ana Paula",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43301309": {
    "id": "item_14503",
    "Last Name": "Sedl‡k",
    "First Name": "Jozef",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43301495": {
    "id": "item_29247",
    "Last Name": "Adamczyk",
    "First Name": "Beata Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43301989": {
    "id": "item_14504",
    "Last Name": "Mortier",
    "First Name": "Jan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43302195": {
    "id": "item_27187",
    "Last Name": "Calvo",
    "First Name": "Maria Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43303325": {
    "id": "item_27188",
    "Last Name": "Calvo",
    "First Name": "Silvana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43304087": {
    "id": "item_27189",
    "Last Name": "Mapaisarnsin",
    "First Name": "Kritsada",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43304124": {
    "id": "item_27190",
    "Last Name": "Borg",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43304619": {
    "id": "item_27191",
    "Last Name": "Borg",
    "First Name": "Hedvig Margareta Elisabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43305595": {
    "id": "item_27192",
    "Last Name": "BŽlanger",
    "First Name": "Marcelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43305873": {
    "id": "item_16543",
    "Last Name": "Paz",
    "First Name": "Dora",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43306335": {
    "id": "item_27193",
    "Last Name": "Lastari",
    "First Name": "Riana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43306437": {
    "id": "item_14505",
    "Last Name": "Peeters",
    "First Name": "Lindsey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43306719": {
    "id": "item_14506",
    "Last Name": "Jumaa",
    "First Name": "Sawsan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43309676": {
    "id": "item_1741",
    "Last Name": "Garlapati",
    "First Name": "Murali Mohan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43310423": {
    "id": "item_1742",
    "Last Name": "Savard",
    "First Name": "Nathalie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43313409": {
    "id": "item_3596",
    "Last Name": "Thibeault",
    "First Name": "Luc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43314721": {
    "id": "item_14507",
    "Last Name": "Di Gennaro",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43315903": {
    "id": "item_3597",
    "Last Name": "YAYA NARVAEZ",
    "First Name": "LEON DAVID",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43316234": {
    "id": "item_14508",
    "Last Name": "Brezniak",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43317206": {
    "id": "item_27194",
    "Last Name": "Pascua",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43321138": {
    "id": "item_27195",
    "Last Name": "Curtin",
    "First Name": "Hollie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43321266": {
    "id": "item_1743",
    "Last Name": "NAGASHIMA",
    "First Name": "MAIKO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43324680": {
    "id": "item_27196",
    "Last Name": "Cassidy",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43325028": {
    "id": "item_3598",
    "Last Name": "Pimenta",
    "First Name": "Frances",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43327994": {
    "id": "item_1744",
    "Last Name": "abourizk",
    "First Name": "hicham",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43330435": {
    "id": "item_27197",
    "Last Name": "Rabe",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43331076": {
    "id": "item_1745",
    "Last Name": "Rodo",
    "First Name": "Josefa Sofia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43331376": {
    "id": "item_27198",
    "Last Name": "FIKA",
    "First Name": "ZOI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43331552": {
    "id": "item_29248",
    "Last Name": "Pathak",
    "First Name": "Priscilla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43332298": {
    "id": "item_27199",
    "Last Name": "Papaioannou",
    "First Name": "Xristos",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43334542": {
    "id": "item_1746",
    "Last Name": "Silos",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43336722": {
    "id": "item_3599",
    "Last Name": "Fleming",
    "First Name": "Margot",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43337151": {
    "id": "item_27200",
    "Last Name": "FORTIN",
    "First Name": "DANY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43337506": {
    "id": "item_27201",
    "Last Name": "Henry",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43343005": {
    "id": "item_16544",
    "Last Name": "MATOS FLORES GUERRA",
    "First Name": "BENJAMIN TOMAS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43349100": {
    "id": "item_3600",
    "Last Name": "GUNAWAN",
    "First Name": "ANTONIUS PAUL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43349271": {
    "id": "item_3601",
    "Last Name": "SUTANTO",
    "First Name": "JONI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43350108": {
    "id": "item_27202",
    "Last Name": "Del Valle",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43350625": {
    "id": "item_27203",
    "Last Name": "V‡gsgar_",
    "First Name": "Elisabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43352179": {
    "id": "item_1747",
    "Last Name": "Lewis",
    "First Name": "Heath",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43352932": {
    "id": "item_29249",
    "Last Name": "Kineavy",
    "First Name": "Kelda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43353344": {
    "id": "item_27204",
    "Last Name": "Croes",
    "First Name": "Nancy Jeanne J.",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43356460": {
    "id": "item_1748",
    "Last Name": "BRINDLEY",
    "First Name": "William Rupert George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43357144": {
    "id": "item_1749",
    "Last Name": "Kibsgaard-Petersen",
    "First Name": "Dag",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43357944": {
    "id": "item_16545",
    "Last Name": "Opris",
    "First Name": "Ioana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43357970": {
    "id": "item_3602",
    "Last Name": "Chung",
    "First Name": "Estela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43358471": {
    "id": "item_27205",
    "Last Name": "Tibe",
    "First Name": "Adam Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43360868": {
    "id": "item_1750",
    "Last Name": "Cruz Garcia Villa",
    "First Name": "Patricio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43363429": {
    "id": "item_29250",
    "Last Name": "Whitfield",
    "First Name": "Yvelyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43369037": {
    "id": "item_3603",
    "Last Name": "Clancy",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43369193": {
    "id": "item_3604",
    "Last Name": "Gibson",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370159": {
    "id": "item_27206",
    "Last Name": "Scanlon",
    "First Name": "Jacinta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370187": {
    "id": "item_29251",
    "Last Name": "May",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370342": {
    "id": "item_27207",
    "Last Name": "Ellis",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370545": {
    "id": "item_27208",
    "Last Name": "Ellis",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370647": {
    "id": "item_29252",
    "Last Name": "Fitzgerald",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370923": {
    "id": "item_29253",
    "Last Name": "Prosser",
    "First Name": "Harold Larry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43371165": {
    "id": "item_29254",
    "Last Name": "Yuen",
    "First Name": "Sau Ming",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43372324": {
    "id": "item_14509",
    "Last Name": "Niwa",
    "First Name": "Kenji",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43372615": {
    "id": "item_14510",
    "Last Name": "PARK",
    "First Name": "HEUM CHEOL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43372708": {
    "id": "item_27209",
    "Last Name": "LEE",
    "First Name": "YOU MI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43372838": {
    "id": "item_14511",
    "Last Name": "Niwa",
    "First Name": "Hideko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43372961": {
    "id": "item_29255",
    "Last Name": "nash",
    "First Name": "paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43373037": {
    "id": "item_29256",
    "Last Name": "KIM",
    "First Name": "SEA JONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43373724": {
    "id": "item_27210",
    "Last Name": "Boyle",
    "First Name": "Roisin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43373725": {
    "id": "item_29257",
    "Last Name": "IMAIZUMI",
    "First Name": "MASAKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43373729": {
    "id": "item_3605",
    "Last Name": "LIU",
    "First Name": "HSIU-CHIUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43373831": {
    "id": "item_1751",
    "Last Name": "Hartanto",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43373996": {
    "id": "item_27211",
    "Last Name": "Boe",
    "First Name": "Robin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374012": {
    "id": "item_27212",
    "Last Name": "Wallace",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374477": {
    "id": "item_16546",
    "Last Name": "Liman",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374495": {
    "id": "item_27213",
    "Last Name": "Tantono",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374510": {
    "id": "item_27214",
    "Last Name": "Valentine Gouw",
    "First Name": "Fenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374599": {
    "id": "item_3606",
    "Last Name": "Kumar",
    "First Name": "Ambuj",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374791": {
    "id": "item_3607",
    "Last Name": "UCHIMAKI",
    "First Name": "NAOYUKI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374844": {
    "id": "item_29258",
    "Last Name": "Engelsing",
    "First Name": "Lutz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374929": {
    "id": "item_14512",
    "Last Name": "Mertens",
    "First Name": "Rene",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375043": {
    "id": "item_16547",
    "Last Name": "Thiere",
    "First Name": "Stefan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375190": {
    "id": "item_1752",
    "Last Name": "Rothe",
    "First Name": "Carsten Kurt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375289": {
    "id": "item_29259",
    "Last Name": "Sultani",
    "First Name": "Asif",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375316": {
    "id": "item_1753",
    "Last Name": "Dredge",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375405": {
    "id": "item_3608",
    "Last Name": "Lšschner",
    "First Name": "Ralf",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375437": {
    "id": "item_27215",
    "Last Name": "Johannesen",
    "First Name": "Kristmar E.",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375499": {
    "id": "item_3609",
    "Last Name": "Angelo Amaral Lourenco de Castro",
    "First Name": "Pedro Paulo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43376159": {
    "id": "item_29260",
    "Last Name": "Neugebauer",
    "First Name": "Sven",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43376912": {
    "id": "item_31173",
    "Last Name": "Milsted",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43377069": {
    "id": "item_29261",
    "Last Name": "Nishimura",
    "First Name": "Rinka",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43377829": {
    "id": "item_27216",
    "Last Name": "Roes",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43378181": {
    "id": "item_1754",
    "Last Name": "Winkler",
    "First Name": "Roland Gerhard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43378726": {
    "id": "item_27217",
    "Last Name": "Ewer",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43379010": {
    "id": "item_31174",
    "Last Name": "Luda",
    "First Name": "Bernd",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43379417": {
    "id": "item_3610",
    "Last Name": "Castro",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43379840": {
    "id": "item_27218",
    "Last Name": "Berrum",
    "First Name": "Marianne Cecilie D",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43380312": {
    "id": "item_14513",
    "Last Name": "PIET",
    "First Name": "ERIC",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43380336": {
    "id": "item_16548",
    "Last Name": "Amegashie",
    "First Name": "Carolin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43380338": {
    "id": "item_1755",
    "Last Name": "FouquŽ",
    "First Name": "StŽphane",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43380708": {
    "id": "item_29262",
    "Last Name": "Rocheta",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43380731": {
    "id": "item_3611",
    "Last Name": "Schiller",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43381149": {
    "id": "item_27219",
    "Last Name": "Taha",
    "First Name": "Wafaa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43382307": {
    "id": "item_1756",
    "Last Name": "Gerhardts",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43382760": {
    "id": "item_27220",
    "Last Name": "Belusica",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43382951": {
    "id": "item_29263",
    "Last Name": "Singula",
    "First Name": "Dana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43383244": {
    "id": "item_3612",
    "Last Name": "Lanfranchi",
    "First Name": "Luca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43383459": {
    "id": "item_29264",
    "Last Name": "Neugebauer",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43383776": {
    "id": "item_1757",
    "Last Name": "Fikus",
    "First Name": "Hans Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43383800": {
    "id": "item_27221",
    "Last Name": "Parekh",
    "First Name": "Mayank",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43385712": {
    "id": "item_29265",
    "Last Name": "Van Langendonck",
    "First Name": "Frank",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43386133": {
    "id": "item_1758",
    "Last Name": "Zaragoza Campos",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43386587": {
    "id": "item_14514",
    "Last Name": "Fernandez Maquieira",
    "First Name": "Rafael Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43386942": {
    "id": "item_16549",
    "Last Name": "Marszalek",
    "First Name": "Monika",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387019": {
    "id": "item_3613",
    "Last Name": "Fryczkowski",
    "First Name": "Radoslaw",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387374": {
    "id": "item_27222",
    "Last Name": "Iwkiewicz",
    "First Name": "Tomasz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387450": {
    "id": "item_1759",
    "Last Name": "Staniszewski",
    "First Name": "Micha_",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387880": {
    "id": "item_1760",
    "Last Name": "Tait",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43389677": {
    "id": "item_3614",
    "Last Name": "Kielbinski",
    "First Name": "Bartosz",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43389885": {
    "id": "item_1761",
    "Last Name": "Jorge Filho",
    "First Name": "Paulo SŽrgio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43389997": {
    "id": "item_3615",
    "Last Name": "Martins",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43390015": {
    "id": "item_3616",
    "Last Name": "Martins",
    "First Name": "Rubens",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43391024": {
    "id": "item_3617",
    "Last Name": "Spaini",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43391288": {
    "id": "item_14515",
    "Last Name": "Palominos",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43392949": {
    "id": "item_31175",
    "Last Name": "Prior",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43396134": {
    "id": "item_27223",
    "Last Name": "Pereira",
    "First Name": "Geniomar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43397697": {
    "id": "item_27224",
    "Last Name": "Denetro",
    "First Name": "Jose",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43397879": {
    "id": "item_29266",
    "Last Name": "Str__kov‡",
    "First Name": "M‡ria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43397927": {
    "id": "item_31176",
    "Last Name": "Bradshaw",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43398020": {
    "id": "item_27225",
    "Last Name": "Bayfield",
    "First Name": "Anna-Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43398645": {
    "id": "item_31177",
    "Last Name": "Brill",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43423594": {
    "id": "item_29267",
    "Last Name": "Fellner",
    "First Name": "Reena",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43431209": {
    "id": "item_31178",
    "Last Name": "Brown",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43431712": {
    "id": "item_29268",
    "Last Name": "ROSALIN",
    "First Name": "RIRIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43431770": {
    "id": "item_3618",
    "Last Name": "PEREZ GOMEZ",
    "First Name": "EDSEL RENE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43431903": {
    "id": "item_31179",
    "Last Name": "Stuart",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43432308": {
    "id": "item_29269",
    "Last Name": "SŸ§",
    "First Name": "Jean",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43433374": {
    "id": "item_14516",
    "Last Name": "Choo",
    "First Name": "Yan Qi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43434103": {
    "id": "item_14517",
    "Last Name": "Lumbis",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43434435": {
    "id": "item_27226",
    "Last Name": "Zilly",
    "First Name": "Udo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43434507": {
    "id": "item_14518",
    "Last Name": "Kosewski",
    "First Name": "Cezary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43434856": {
    "id": "item_14519",
    "Last Name": "Westerlind",
    "First Name": "Erik",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435041": {
    "id": "item_27227",
    "Last Name": "Roth",
    "First Name": "Manfred Gerd",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435129": {
    "id": "item_14520",
    "Last Name": "James",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435180": {
    "id": "item_27228",
    "Last Name": "Cheang",
    "First Name": "Reuben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435329": {
    "id": "item_31180",
    "Last Name": "HIRATA",
    "First Name": "KEISUKE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435476": {
    "id": "item_14521",
    "Last Name": "BONILLA BUENO",
    "First Name": "MIGUEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435662": {
    "id": "item_16550",
    "Last Name": "Klink",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435690": {
    "id": "item_14522",
    "Last Name": "Dr. Rau",
    "First Name": "Dietmar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435714": {
    "id": "item_1762",
    "Last Name": "Musik",
    "First Name": "Urszula",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435767": {
    "id": "item_29270",
    "Last Name": "Vetter",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436098": {
    "id": "item_16551",
    "Last Name": "BIN JEDIN",
    "First Name": "JOHAN EFFENDY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436179": {
    "id": "item_1763",
    "Last Name": "Dr Gilg",
    "First Name": "Hubert Wolfgang",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436182": {
    "id": "item_3619",
    "Last Name": "Klšpper",
    "First Name": "Ralf",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436448": {
    "id": "item_27229",
    "Last Name": "GARCIA-CORDERO CELIS",
    "First Name": "ANGEL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436485": {
    "id": "item_16552",
    "Last Name": "Olds",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436540": {
    "id": "item_3620",
    "Last Name": "Biolla",
    "First Name": "Gianluca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436560": {
    "id": "item_14523",
    "Last Name": "Tsui",
    "First Name": "Yan Wai Terence",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436609": {
    "id": "item_14524",
    "Last Name": "Chan",
    "First Name": "Miu Wah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436682": {
    "id": "item_3621",
    "Last Name": "Nys",
    "First Name": "Vincent Emiel L.",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436718": {
    "id": "item_27230",
    "Last Name": "Garcia Esparza",
    "First Name": "Araceli",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436792": {
    "id": "item_3622",
    "Last Name": "Pennati",
    "First Name": "Davide",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436799": {
    "id": "item_16553",
    "Last Name": "De Iulio",
    "First Name": "Attilio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437327": {
    "id": "item_27231",
    "Last Name": "CENCIONI",
    "First Name": "PAOLO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437349": {
    "id": "item_3623",
    "Last Name": "gallozzi",
    "First Name": "emanuele",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437516": {
    "id": "item_27232",
    "Last Name": "Dunstan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437568": {
    "id": "item_27233",
    "Last Name": "Nakano",
    "First Name": "Aiji",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437957": {
    "id": "item_3624",
    "Last Name": "Golos",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43438331": {
    "id": "item_29271",
    "Last Name": "Nakanishi",
    "First Name": "Toshiyasu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43438740": {
    "id": "item_16554",
    "Last Name": "Fabius",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43438991": {
    "id": "item_29272",
    "Last Name": "Jonsson",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43439022": {
    "id": "item_14525",
    "Last Name": "Soerensen",
    "First Name": "Lars",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43439968": {
    "id": "item_27234",
    "Last Name": "RODRIGUES DOS SANTOS",
    "First Name": "JOAO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440306": {
    "id": "item_14526",
    "Last Name": "Fabri",
    "First Name": "Fabrizio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440445": {
    "id": "item_27235",
    "Last Name": "KAKANWA",
    "First Name": "CHILELU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440521": {
    "id": "item_3625",
    "Last Name": "Santini",
    "First Name": "Christophe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440665": {
    "id": "item_27236",
    "Last Name": "Vennberg",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440691": {
    "id": "item_16555",
    "Last Name": "Bragaglia Filho",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440797": {
    "id": "item_14527",
    "Last Name": "Vola",
    "First Name": "Renato",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43441077": {
    "id": "item_27237",
    "Last Name": "Preissler",
    "First Name": "Udo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43441157": {
    "id": "item_14528",
    "Last Name": "Sorensen",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43441455": {
    "id": "item_27238",
    "Last Name": "Pizzinini",
    "First Name": "Giuseppe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43441596": {
    "id": "item_29273",
    "Last Name": "Campagnolo",
    "First Name": "Paola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43442474": {
    "id": "item_29274",
    "Last Name": "Cavalcante",
    "First Name": "Shirley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43443234": {
    "id": "item_29275",
    "Last Name": "Bartkiewicz",
    "First Name": "Pawel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43443740": {
    "id": "item_1764",
    "Last Name": "Borghi",
    "First Name": "Paolo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43443798": {
    "id": "item_3626",
    "Last Name": "Marques",
    "First Name": "Albert",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43443844": {
    "id": "item_3627",
    "Last Name": "Magri",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43444060": {
    "id": "item_3628",
    "Last Name": "CZUBINSKI",
    "First Name": "JOSE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43444160": {
    "id": "item_16556",
    "Last Name": "Ferguson",
    "First Name": "Lori",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43444219": {
    "id": "item_3629",
    "Last Name": "Hinzmann",
    "First Name": "Holger",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43444410": {
    "id": "item_3630",
    "Last Name": "Kšnig",
    "First Name": "Stephan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43444694": {
    "id": "item_31181",
    "Last Name": "Hong",
    "First Name": "Kien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43444864": {
    "id": "item_16557",
    "Last Name": "FUKUI",
    "First Name": "KOJI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43445044": {
    "id": "item_27239",
    "Last Name": "Foster",
    "First Name": "Whitney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43445298": {
    "id": "item_3631",
    "Last Name": "Raszka",
    "First Name": "Krzysztof",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43445371": {
    "id": "item_27240",
    "Last Name": "Jacobsen",
    "First Name": "Petra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43445624": {
    "id": "item_16558",
    "Last Name": "Zorn",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43445668": {
    "id": "item_1765",
    "Last Name": "Kovalskyy",
    "First Name": "Oleksandr",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43448053": {
    "id": "item_3632",
    "Last Name": "Mai",
    "First Name": "Truc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43448094": {
    "id": "item_14529",
    "Last Name": "Ricci",
    "First Name": "Federico",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43448103": {
    "id": "item_14530",
    "Last Name": "Fung",
    "First Name": "Shun Chun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43449472": {
    "id": "item_27241",
    "Last Name": "Lovett",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43449578": {
    "id": "item_1766",
    "Last Name": "Lakatos",
    "First Name": "Erik",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43449605": {
    "id": "item_16559",
    "Last Name": "Battaglia",
    "First Name": "Eleonora",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43450347": {
    "id": "item_3633",
    "Last Name": "Carlsson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43452454": {
    "id": "item_3634",
    "Last Name": "RAMIREZ GARCIA",
    "First Name": "Luis Hernando",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43453706": {
    "id": "item_3635",
    "Last Name": "Goebel-Hansen",
    "First Name": "Thorben Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43464509": {
    "id": "item_14531",
    "Last Name": "Petersen",
    "First Name": "Fara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43481513": {
    "id": "item_27242",
    "Last Name": "Elliott",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43482481": {
    "id": "item_1767",
    "Last Name": "TABATA",
    "First Name": "SATOSHI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43482622": {
    "id": "item_14532",
    "Last Name": "Loy",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43483161": {
    "id": "item_1768",
    "Last Name": "Freeman",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43483585": {
    "id": "item_3636",
    "Last Name": "Turnbull",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43484050": {
    "id": "item_14533",
    "Last Name": "Smith",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43485090": {
    "id": "item_27243",
    "Last Name": "Cubacub",
    "First Name": "Arvin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43485354": {
    "id": "item_29276",
    "Last Name": "Tsilinikos",
    "First Name": "Harry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43486899": {
    "id": "item_29277",
    "Last Name": "SASO",
    "First Name": "YOSHIO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43488742": {
    "id": "item_29278",
    "Last Name": "Nurintani",
    "First Name": "Desynta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43488821": {
    "id": "item_16560",
    "Last Name": "Durkin",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43488840": {
    "id": "item_16561",
    "Last Name": "Rabbitte",
    "First Name": "Mary",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43489015": {
    "id": "item_16562",
    "Last Name": "Cremin",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43489511": {
    "id": "item_29279",
    "Last Name": "Setiawan",
    "First Name": "Cliff Jordan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490224": {
    "id": "item_1769",
    "Last Name": "WADA",
    "First Name": "AKIRA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490335": {
    "id": "item_3637",
    "Last Name": "Raya Demidoff",
    "First Name": "Andreu",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490646": {
    "id": "item_3638",
    "Last Name": "Corradi Rolla",
    "First Name": "Nicol˜",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490797": {
    "id": "item_3639",
    "Last Name": "LOIZA",
    "First Name": "ELISSA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490864": {
    "id": "item_16563",
    "Last Name": "vandepitte",
    "First Name": "jan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490902": {
    "id": "item_16564",
    "Last Name": "Nikolakopoulos",
    "First Name": "Aristotelis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490939": {
    "id": "item_14534",
    "Last Name": "Grafe",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491040": {
    "id": "item_3640",
    "Last Name": "SERRANO PUCHE",
    "First Name": "RAFAEL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491061": {
    "id": "item_3641",
    "Last Name": "gacoin",
    "First Name": "jerome",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491162": {
    "id": "item_1770",
    "Last Name": "Wittrock",
    "First Name": "Arndt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491197": {
    "id": "item_27244",
    "Last Name": "flez",
    "First Name": "jean-francois",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491246": {
    "id": "item_16565",
    "Last Name": "porter",
    "First Name": "mark",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491439": {
    "id": "item_27245",
    "Last Name": "Szczerba",
    "First Name": "Grzegorz",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491719": {
    "id": "item_31182",
    "Last Name": "Knebel",
    "First Name": "Christof",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492028": {
    "id": "item_1771",
    "Last Name": "Ettorre",
    "First Name": "Biagio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492109": {
    "id": "item_27246",
    "Last Name": "Poernomo",
    "First Name": "Arnold",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492146": {
    "id": "item_3642",
    "Last Name": "Kell",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492163": {
    "id": "item_1772",
    "Last Name": "Mullier",
    "First Name": "Emilie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492231": {
    "id": "item_14535",
    "Last Name": "Zhailybekov",
    "First Name": "Duman",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492242": {
    "id": "item_1773",
    "Last Name": "Field",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492565": {
    "id": "item_27247",
    "Last Name": "Liu",
    "First Name": "Haojun",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492624": {
    "id": "item_14536",
    "Last Name": "Molloy",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43493148": {
    "id": "item_16566",
    "Last Name": "McClenaghan",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43493643": {
    "id": "item_29280",
    "Last Name": "OUENSANGA",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43493666": {
    "id": "item_14537",
    "Last Name": "Sutantya",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494364": {
    "id": "item_1774",
    "Last Name": "Gray",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494776": {
    "id": "item_3643",
    "Last Name": "Abdin",
    "First Name": "Mohamed",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494845": {
    "id": "item_3644",
    "Last Name": "Hudgell",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494906": {
    "id": "item_3645",
    "Last Name": "Dass",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494956": {
    "id": "item_14538",
    "Last Name": "Hellinger",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494981": {
    "id": "item_3646",
    "Last Name": "Hammoud",
    "First Name": "Ahmad",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43495268": {
    "id": "item_1775",
    "Last Name": "Rogers",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43497333": {
    "id": "item_27248",
    "Last Name": "GIRARDI",
    "First Name": "GIANCARLO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43498397": {
    "id": "item_3647",
    "Last Name": "Allen",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43498701": {
    "id": "item_27249",
    "Last Name": "South",
    "First Name": "Anna Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43498876": {
    "id": "item_16567",
    "Last Name": "Debersaques",
    "First Name": "Nathalie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43498903": {
    "id": "item_27250",
    "Last Name": "edmondson",
    "First Name": "andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43499075": {
    "id": "item_3648",
    "Last Name": "Lecae",
    "First Name": "Yann",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43499438": {
    "id": "item_27251",
    "Last Name": "Hawkins",
    "First Name": "Amyleigh",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43499524": {
    "id": "item_1776",
    "Last Name": "Critchley",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43499928": {
    "id": "item_31183",
    "Last Name": "Vashisht",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43500229": {
    "id": "item_14539",
    "Last Name": "Roeblitz",
    "First Name": "Holger",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43500245": {
    "id": "item_14540",
    "Last Name": "Franklin",
    "First Name": "Janine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43500388": {
    "id": "item_27252",
    "Last Name": "BOURBON",
    "First Name": "damien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43500865": {
    "id": "item_27253",
    "Last Name": "Kelly",
    "First Name": "Jim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43500923": {
    "id": "item_3649",
    "Last Name": "Spence",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43501521": {
    "id": "item_14541",
    "Last Name": "McCoist",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43502193": {
    "id": "item_29281",
    "Last Name": "Bonilla",
    "First Name": "Hanoy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43502797": {
    "id": "item_27254",
    "Last Name": "Spielhagen",
    "First Name": "Bernard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43503159": {
    "id": "item_29282",
    "Last Name": "Guerra",
    "First Name": "Gianellie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43503559": {
    "id": "item_27255",
    "Last Name": "Hammond",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43503816": {
    "id": "item_16568",
    "Last Name": "Tobar",
    "First Name": "Leonardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43504014": {
    "id": "item_1777",
    "Last Name": "Graham",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43504072": {
    "id": "item_1778",
    "Last Name": "Repton",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43505172": {
    "id": "item_27256",
    "Last Name": "Ongeri",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43506806": {
    "id": "item_27257",
    "Last Name": "Jaeger",
    "First Name": "Kati",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43507338": {
    "id": "item_3650",
    "Last Name": "Beeching",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43507627": {
    "id": "item_14542",
    "Last Name": "Corrigan",
    "First Name": "Aileen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43507836": {
    "id": "item_27258",
    "Last Name": "Spinella",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43508164": {
    "id": "item_31184",
    "Last Name": "Davies",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43508181": {
    "id": "item_3651",
    "Last Name": "Guevara",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43508379": {
    "id": "item_14543",
    "Last Name": "Potapkov",
    "First Name": "Oleksandr",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43509083": {
    "id": "item_14544",
    "Last Name": "Kammin",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43509187": {
    "id": "item_3652",
    "Last Name": "MANCA",
    "First Name": "Baptiste",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43509241": {
    "id": "item_3653",
    "Last Name": "Robins",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43509544": {
    "id": "item_3654",
    "Last Name": "Horn",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43509813": {
    "id": "item_3655",
    "Last Name": "Quijada",
    "First Name": "Salomon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43510570": {
    "id": "item_1779",
    "Last Name": "Dabideen",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43510606": {
    "id": "item_14545",
    "Last Name": "Walters",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43511272": {
    "id": "item_3656",
    "Last Name": "Cherkab",
    "First Name": "Lamyaa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43511790": {
    "id": "item_14546",
    "Last Name": "Suarez",
    "First Name": "Ernesto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43512568": {
    "id": "item_14547",
    "Last Name": "Doss",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43512739": {
    "id": "item_1780",
    "Last Name": "Ali",
    "First Name": "Shahib",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43514379": {
    "id": "item_14548",
    "Last Name": "Jen",
    "First Name": "Norman",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43516124": {
    "id": "item_29283",
    "Last Name": "Lam",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43516809": {
    "id": "item_3657",
    "Last Name": "Ng",
    "First Name": "Simen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43518870": {
    "id": "item_29284",
    "Last Name": "SALGADO BORJAS",
    "First Name": "VICTORIA ALEJANDRA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43519107": {
    "id": "item_27259",
    "Last Name": "Sedeno Manjarrez",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43521688": {
    "id": "item_1781",
    "Last Name": "KOUNNOUSIIS",
    "First Name": "MICHALAKIS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43521848": {
    "id": "item_27260",
    "Last Name": "Ishii",
    "First Name": "Satoru",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43522719": {
    "id": "item_16569",
    "Last Name": "MORAITI",
    "First Name": "Zoi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43522860": {
    "id": "item_29285",
    "Last Name": "Miller",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523137": {
    "id": "item_31185",
    "Last Name": "creuso",
    "First Name": "cathia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523192": {
    "id": "item_29286",
    "Last Name": "Fowler",
    "First Name": "Shirley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523238": {
    "id": "item_1782",
    "Last Name": "Gon",
    "First Name": "Saito",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523693": {
    "id": "item_3658",
    "Last Name": "CATALFAMO",
    "First Name": "MAURIZIO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523806": {
    "id": "item_14549",
    "Last Name": "COLUSSI",
    "First Name": "ANDREA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523920": {
    "id": "item_27261",
    "Last Name": "CHAN",
    "First Name": "PUI PUI SAMANTHA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43524090": {
    "id": "item_31186",
    "Last Name": "Madan",
    "First Name": "Kanika",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43524157": {
    "id": "item_14550",
    "Last Name": "Cox",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43524499": {
    "id": "item_3659",
    "Last Name": "Turgumbayev",
    "First Name": "Zhanat",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43524828": {
    "id": "item_1783",
    "Last Name": "Finlay",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43524996": {
    "id": "item_3660",
    "Last Name": "Page",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43525271": {
    "id": "item_29287",
    "Last Name": "Oestreicher",
    "First Name": "Sibylle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43525455": {
    "id": "item_31187",
    "Last Name": "Ferrett",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43525469": {
    "id": "item_14551",
    "Last Name": "ENGER",
    "First Name": "KRISTIAN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43526121": {
    "id": "item_14552",
    "Last Name": "Street",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43526925": {
    "id": "item_1784",
    "Last Name": "Ridgwell",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43527412": {
    "id": "item_31188",
    "Last Name": "Gaveau",
    "First Name": "Antonin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43527676": {
    "id": "item_27262",
    "Last Name": "Dahlen",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43528387": {
    "id": "item_14553",
    "Last Name": "MACIEL LUNA",
    "First Name": "MIGUEL ANGEL",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43529240": {
    "id": "item_27263",
    "Last Name": "TSE",
    "First Name": "SAU WAI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43529292": {
    "id": "item_29288",
    "Last Name": "Fagan",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43529507": {
    "id": "item_14554",
    "Last Name": "DE GRUYTER",
    "First Name": "GREGORY",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43529733": {
    "id": "item_29289",
    "Last Name": "Patel",
    "First Name": "Rajeshwari",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43530385": {
    "id": "item_27264",
    "Last Name": "Hara",
    "First Name": "Kaoru",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43530459": {
    "id": "item_14555",
    "Last Name": "Carulla",
    "First Name": "Arnau",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43530649": {
    "id": "item_14556",
    "Last Name": "Espinal",
    "First Name": "Leticia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43531068": {
    "id": "item_27265",
    "Last Name": "wroe",
    "First Name": "stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43531158": {
    "id": "item_27266",
    "Last Name": "Kalle",
    "First Name": "Triinu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43531243": {
    "id": "item_14557",
    "Last Name": "Heid",
    "First Name": "Bernd",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43531498": {
    "id": "item_3661",
    "Last Name": "Sweeney",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43531844": {
    "id": "item_1785",
    "Last Name": "Yearsley",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43531893": {
    "id": "item_29290",
    "Last Name": "Villarreal Valdes",
    "First Name": "Roberto Martin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43531911": {
    "id": "item_27267",
    "Last Name": "Round",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43532352": {
    "id": "item_31189",
    "Last Name": "Wilding",
    "First Name": "marion",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43532538": {
    "id": "item_27268",
    "Last Name": "Amante",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43532736": {
    "id": "item_29291",
    "Last Name": "Thierstein",
    "First Name": "Brigitte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43532916": {
    "id": "item_14558",
    "Last Name": "Yderberg",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43532984": {
    "id": "item_29292",
    "Last Name": "Call",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43533228": {
    "id": "item_27269",
    "Last Name": "Doss",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43533380": {
    "id": "item_27270",
    "Last Name": "Gunning",
    "First Name": "Ronnie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43533843": {
    "id": "item_27271",
    "Last Name": "Reinemund",
    "First Name": "Lianne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43533854": {
    "id": "item_14559",
    "Last Name": "Freeman",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43533863": {
    "id": "item_29293",
    "Last Name": "Hao",
    "First Name": "Liangen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43533898": {
    "id": "item_27272",
    "Last Name": "Herrera",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43533953": {
    "id": "item_29294",
    "Last Name": "Heerdegen",
    "First Name": "Andreas Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43534050": {
    "id": "item_14560",
    "Last Name": "Klecha",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43534920": {
    "id": "item_27273",
    "Last Name": "Tulley",
    "First Name": "Ken",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535165": {
    "id": "item_3662",
    "Last Name": "Senesac",
    "First Name": "Reid",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535410": {
    "id": "item_16570",
    "Last Name": "Moore",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535546": {
    "id": "item_29295",
    "Last Name": "Cummings",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535637": {
    "id": "item_3663",
    "Last Name": "Ledsham",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535689": {
    "id": "item_14561",
    "Last Name": "Marpu",
    "First Name": "Raj",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535785": {
    "id": "item_29296",
    "Last Name": "Genteman",
    "First Name": "Kian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535823": {
    "id": "item_31190",
    "Last Name": "Smith",
    "First Name": "Denise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535891": {
    "id": "item_14562",
    "Last Name": "Dobson",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535993": {
    "id": "item_1786",
    "Last Name": "Smith",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536129": {
    "id": "item_14563",
    "Last Name": "Kendall",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536142": {
    "id": "item_1787",
    "Last Name": "Chu",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536199": {
    "id": "item_14564",
    "Last Name": "Bowers",
    "First Name": "Lidia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536559": {
    "id": "item_14565",
    "Last Name": "Harris",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536770": {
    "id": "item_1788",
    "Last Name": "Fleming",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536839": {
    "id": "item_31191",
    "Last Name": "Morrison",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536972": {
    "id": "item_1789",
    "Last Name": "Bachelart",
    "First Name": "Jean-Luc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536977": {
    "id": "item_29297",
    "Last Name": "Bender",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43537136": {
    "id": "item_27274",
    "Last Name": "Walker",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43537334": {
    "id": "item_29298",
    "Last Name": "Rattanachompoo",
    "First Name": "Naiyasit",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43537395": {
    "id": "item_27275",
    "Last Name": "Ras",
    "First Name": "Wilfred",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43537984": {
    "id": "item_16571",
    "Last Name": "CHAN",
    "First Name": "TAI WAI DAVID",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43538756": {
    "id": "item_27276",
    "Last Name": "Santos",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43540086": {
    "id": "item_1790",
    "Last Name": "Marquette",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43540263": {
    "id": "item_3664",
    "Last Name": "Mendez Bernal",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43541187": {
    "id": "item_29299",
    "Last Name": "Dugdale",
    "First Name": "Sonia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43541393": {
    "id": "item_29300",
    "Last Name": "Hamis",
    "First Name": "Al-Mussreen Bin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43542221": {
    "id": "item_16572",
    "Last Name": "Lohachitranont",
    "First Name": "Kiatichai",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43543369": {
    "id": "item_14566",
    "Last Name": "Yutthawaraporn",
    "First Name": "Sittipong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43543597": {
    "id": "item_27277",
    "Last Name": "Lozano",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43543711": {
    "id": "item_29301",
    "Last Name": "JUMIARTHA",
    "First Name": "I Made",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43543786": {
    "id": "item_1791",
    "Last Name": "IKEGAMI",
    "First Name": "KOJI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544125": {
    "id": "item_1792",
    "Last Name": "Yu",
    "First Name": "Chih Hao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544284": {
    "id": "item_14567",
    "Last Name": "McClellan",
    "First Name": "Kennard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544851": {
    "id": "item_3665",
    "Last Name": "Bailey",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544853": {
    "id": "item_31192",
    "Last Name": "Bailey",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544912": {
    "id": "item_29302",
    "Last Name": "SILAPANONT",
    "First Name": "KRITTAPAS",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544938": {
    "id": "item_29303",
    "Last Name": "THANARITHIPORN",
    "First Name": "SITHIPOOM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545115": {
    "id": "item_29304",
    "Last Name": "Davies",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545241": {
    "id": "item_3666",
    "Last Name": "Dunleavy",
    "First Name": "Maia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545256": {
    "id": "item_27278",
    "Last Name": "Lowry",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545314": {
    "id": "item_27279",
    "Last Name": "Bradford",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545433": {
    "id": "item_27280",
    "Last Name": "PLAISANT",
    "First Name": "LISIANE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545618": {
    "id": "item_29305",
    "Last Name": "JEGU",
    "First Name": "Brieuc",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545884": {
    "id": "item_16573",
    "Last Name": "Safranko",
    "First Name": "Edvin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545929": {
    "id": "item_14568",
    "Last Name": "Byrne",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545991": {
    "id": "item_1793",
    "Last Name": "Styles",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546047": {
    "id": "item_29306",
    "Last Name": "SHI",
    "First Name": "XUEMEI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546110": {
    "id": "item_29307",
    "Last Name": "Lukasewitz",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546342": {
    "id": "item_16574",
    "Last Name": "POULAIN",
    "First Name": "CATHERINE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546368": {
    "id": "item_3667",
    "Last Name": "Kyriacou",
    "First Name": "Panayiotis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546638": {
    "id": "item_3668",
    "Last Name": "Cheung",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43547225": {
    "id": "item_27281",
    "Last Name": "Kelly",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43547476": {
    "id": "item_27282",
    "Last Name": "Joseph",
    "First Name": "Russell",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43550636": {
    "id": "item_27283",
    "Last Name": "Cossey",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43551113": {
    "id": "item_29308",
    "Last Name": "Szendey",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43552659": {
    "id": "item_3669",
    "Last Name": "Lister",
    "First Name": "Jonny",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43553143": {
    "id": "item_14569",
    "Last Name": "Knez",
    "First Name": "Carol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43553303": {
    "id": "item_1794",
    "Last Name": "Jones",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43553471": {
    "id": "item_31193",
    "Last Name": "Trevino",
    "First Name": "Ruben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43553805": {
    "id": "item_3670",
    "Last Name": "Cashin",
    "First Name": "Eamonn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43553862": {
    "id": "item_14570",
    "Last Name": "Peterlongo",
    "First Name": "Giulia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43554085": {
    "id": "item_3671",
    "Last Name": "Kiehne",
    "First Name": "Markus Thorsten",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43554886": {
    "id": "item_29309",
    "Last Name": "ESSIEN",
    "First Name": "BASSEY",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43554938": {
    "id": "item_3672",
    "Last Name": "Rice",
    "First Name": "Jeannie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43554942": {
    "id": "item_31194",
    "Last Name": "parreau",
    "First Name": "guy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43554998": {
    "id": "item_1795",
    "Last Name": "McInnes",
    "First Name": "Tara",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43555825": {
    "id": "item_3673",
    "Last Name": "Rodell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43555827": {
    "id": "item_3674",
    "Last Name": "Rodell",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43556201": {
    "id": "item_29310",
    "Last Name": "Morales Gil",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43556447": {
    "id": "item_3675",
    "Last Name": "Benzinci",
    "First Name": "Serkan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43556722": {
    "id": "item_14571",
    "Last Name": "Norton",
    "First Name": "Philip",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43557296": {
    "id": "item_31195",
    "Last Name": "Chowdary",
    "First Name": "Bhanu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43557307": {
    "id": "item_1796",
    "Last Name": "Steevens",
    "First Name": "Stefan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43557719": {
    "id": "item_3676",
    "Last Name": "Villavicencio",
    "First Name": "Luis Arturo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43558360": {
    "id": "item_14572",
    "Last Name": "GOMEZ SANCHEZ",
    "First Name": "BIRSAVITH",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43558609": {
    "id": "item_29311",
    "Last Name": "Aquino",
    "First Name": "Hazel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43559615": {
    "id": "item_16575",
    "Last Name": "Byrne",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43560587": {
    "id": "item_14573",
    "Last Name": "Sarkissian",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43562476": {
    "id": "item_27284",
    "Last Name": "shimada",
    "First Name": "shigueo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43563081": {
    "id": "item_27285",
    "Last Name": "McKay",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43563235": {
    "id": "item_27286",
    "Last Name": "McKay",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43564840": {
    "id": "item_27287",
    "Last Name": "Grantham",
    "First Name": "Lee Anna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43565227": {
    "id": "item_16576",
    "Last Name": "Armato",
    "First Name": "Emily Kate",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43565600": {
    "id": "item_14574",
    "Last Name": "kato",
    "First Name": "hirofumi",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43566726": {
    "id": "item_1797",
    "Last Name": "CASTANEDA TOPETE",
    "First Name": "VICTOR MANUEL",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43566771": {
    "id": "item_29312",
    "Last Name": "Platon",
    "First Name": "Gilbert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43567240": {
    "id": "item_14575",
    "Last Name": "Spillner",
    "First Name": "Jšrg",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43567296": {
    "id": "item_29313",
    "Last Name": "Berther",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43569777": {
    "id": "item_27288",
    "Last Name": "Bradford",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43569793": {
    "id": "item_3677",
    "Last Name": "Stamey",
    "First Name": "Kenton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43571768": {
    "id": "item_16577",
    "Last Name": "Wong",
    "First Name": "Chiu Lun Christopher",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43571838": {
    "id": "item_29314",
    "Last Name": "Hauch",
    "First Name": "Rosa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43573635": {
    "id": "item_16578",
    "Last Name": "Siu",
    "First Name": "Kin Bong Bonny",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43573890": {
    "id": "item_16579",
    "Last Name": "Luk",
    "First Name": "Kin Hong",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43575075": {
    "id": "item_29315",
    "Last Name": "Chu",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43575215": {
    "id": "item_27289",
    "Last Name": "Yancey",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43576593": {
    "id": "item_1798",
    "Last Name": "Garces Pinzon",
    "First Name": "Jose Mauricio",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43577860": {
    "id": "item_27290",
    "Last Name": "Akula",
    "First Name": "Dheeraj Kumar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43578451": {
    "id": "item_29316",
    "Last Name": "OÕHara-Smith",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43579737": {
    "id": "item_14576",
    "Last Name": "Ojeda",
    "First Name": "NICOLAS",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43580062": {
    "id": "item_3678",
    "Last Name": "Francois",
    "First Name": "Juny Emerante",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43580887": {
    "id": "item_3679",
    "Last Name": "Martir",
    "First Name": "ephraim",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43582452": {
    "id": "item_31196",
    "Last Name": "Janda",
    "First Name": "Rhijina Haroldene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43583685": {
    "id": "item_27291",
    "Last Name": "KATAYAMA",
    "First Name": "KATSUNORI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43585202": {
    "id": "item_1799",
    "Last Name": "Cadena Padilla",
    "First Name": "Maricarmen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43585383": {
    "id": "item_29317",
    "Last Name": "Wijanto",
    "First Name": "Herry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43585493": {
    "id": "item_27292",
    "Last Name": "Kriesche",
    "First Name": "Wolfgang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43585496": {
    "id": "item_27293",
    "Last Name": "Cacacciola-Ketter",
    "First Name": "Maria Lucia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43586805": {
    "id": "item_1800",
    "Last Name": "Chu",
    "First Name": "Derrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43587836": {
    "id": "item_29318",
    "Last Name": "Camia",
    "First Name": "Pascal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43587915": {
    "id": "item_1801",
    "Last Name": "pinner",
    "First Name": "ian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43588013": {
    "id": "item_29319",
    "Last Name": "Richards",
    "First Name": "Neil martin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43591205": {
    "id": "item_1802",
    "Last Name": "saldias olivares",
    "First Name": "pablo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43591361": {
    "id": "item_14577",
    "Last Name": "Sparks",
    "First Name": "Ivy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43592025": {
    "id": "item_3680",
    "Last Name": "Veerman",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43593496": {
    "id": "item_27294",
    "Last Name": "Frison",
    "First Name": "Tyra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43595076": {
    "id": "item_3681",
    "Last Name": "GutiŽrrez Sabbagh",
    "First Name": "Luis Alberto",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43595669": {
    "id": "item_29320",
    "Last Name": "Cordero Diaz",
    "First Name": "Claudio Israel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43596885": {
    "id": "item_14578",
    "Last Name": "Costa",
    "First Name": "Maria Fernanda",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43597116": {
    "id": "item_29321",
    "Last Name": "Shi",
    "First Name": "Dongsheng",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43597167": {
    "id": "item_27295",
    "Last Name": "Smith",
    "First Name": "Brannon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43598065": {
    "id": "item_3682",
    "Last Name": "HONG",
    "First Name": "CHANGYU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43598230": {
    "id": "item_27296",
    "Last Name": "SHIN",
    "First Name": "HYO KYUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43598375": {
    "id": "item_14579",
    "Last Name": "KIM",
    "First Name": "HAEIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43598466": {
    "id": "item_3683",
    "Last Name": "KIM",
    "First Name": "CHEONHO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43598970": {
    "id": "item_29322",
    "Last Name": "Fagan",
    "First Name": "Sorrel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43599141": {
    "id": "item_14580",
    "Last Name": "Stevenson",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43599258": {
    "id": "item_29323",
    "Last Name": "Fuller",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43599791": {
    "id": "item_27297",
    "Last Name": "Clarke",
    "First Name": "Fred",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600166": {
    "id": "item_16580",
    "Last Name": "Welsch",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600248": {
    "id": "item_16581",
    "Last Name": "Welsch",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600281": {
    "id": "item_29324",
    "Last Name": "Jackson",
    "First Name": "Keri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600440": {
    "id": "item_14581",
    "Last Name": "Kerr",
    "First Name": "Patrina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600524": {
    "id": "item_27298",
    "Last Name": "Kollias",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600635": {
    "id": "item_27299",
    "Last Name": "Pill",
    "First Name": "Warrick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600716": {
    "id": "item_14582",
    "Last Name": "Derhan",
    "First Name": "Pascal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600737": {
    "id": "item_27300",
    "Last Name": "De La Cruz",
    "First Name": "Edinson",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600851": {
    "id": "item_14583",
    "Last Name": "Liu",
    "First Name": "Zhenhua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600974": {
    "id": "item_1803",
    "Last Name": "Mornington",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43601321": {
    "id": "item_1804",
    "Last Name": "Finikov",
    "First Name": "Dmitry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43601549": {
    "id": "item_3684",
    "Last Name": "KIM",
    "First Name": "HWANMOK",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43601793": {
    "id": "item_27301",
    "Last Name": "McKenna",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43602032": {
    "id": "item_29325",
    "Last Name": "Sevel",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43602194": {
    "id": "item_27302",
    "Last Name": "Khatis",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43602587": {
    "id": "item_27303",
    "Last Name": "Wakaida",
    "First Name": "Kenta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43603815": {
    "id": "item_16582",
    "Last Name": "Gray",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43605000": {
    "id": "item_16583",
    "Last Name": "MANASILP",
    "First Name": "PAITOON",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43605801": {
    "id": "item_3685",
    "Last Name": "Reich",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43605969": {
    "id": "item_3686",
    "Last Name": "Giordanengo",
    "First Name": "Eduardo ariel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43606865": {
    "id": "item_29326",
    "Last Name": "Alvarado",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43606915": {
    "id": "item_31197",
    "Last Name": "Alvarado",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43608250": {
    "id": "item_16584",
    "Last Name": "Kliushkov",
    "First Name": "Artem",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43608989": {
    "id": "item_1805",
    "Last Name": "Morales",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43609372": {
    "id": "item_27304",
    "Last Name": "Ikbarieh",
    "First Name": "Bashar",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43610979": {
    "id": "item_16585",
    "Last Name": "Palacios",
    "First Name": "Priscilla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43611278": {
    "id": "item_31198",
    "Last Name": "Puentes",
    "First Name": "Yvette",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43611387": {
    "id": "item_27305",
    "Last Name": "Kolupoti",
    "First Name": "Kishore",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43611867": {
    "id": "item_27306",
    "Last Name": "Littlefield",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43611970": {
    "id": "item_27307",
    "Last Name": "Ketter",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43612375": {
    "id": "item_3687",
    "Last Name": "Pinnock",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43613242": {
    "id": "item_27308",
    "Last Name": "Schuermann",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43613288": {
    "id": "item_14584",
    "Last Name": "Damiano",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43614087": {
    "id": "item_16586",
    "Last Name": "Douillet",
    "First Name": "Christelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43615332": {
    "id": "item_29327",
    "Last Name": "Castro",
    "First Name": "Minor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43615801": {
    "id": "item_27309",
    "Last Name": "Sial",
    "First Name": "Sabah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43616568": {
    "id": "item_27310",
    "Last Name": "NIELSEN",
    "First Name": "ERIK PREBEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43617357": {
    "id": "item_27311",
    "Last Name": "CHANLOT",
    "First Name": "YANN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43618942": {
    "id": "item_1806",
    "Last Name": "Jensen",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43619271": {
    "id": "item_14585",
    "Last Name": "Hirano",
    "First Name": "Kirk",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43619698": {
    "id": "item_3688",
    "Last Name": "Ota",
    "First Name": "Kazuhiko",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43620585": {
    "id": "item_27312",
    "Last Name": "Gurgens",
    "First Name": "Shannon Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43620903": {
    "id": "item_27313",
    "Last Name": "McGrath",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43621546": {
    "id": "item_27314",
    "Last Name": "Recaido",
    "First Name": "Geraldine Faye",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43621674": {
    "id": "item_14586",
    "Last Name": "Adekanmbi",
    "First Name": "Abisoye",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43621751": {
    "id": "item_27315",
    "Last Name": "KIM",
    "First Name": "KYUNGROK",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43622132": {
    "id": "item_27316",
    "Last Name": "MOON",
    "First Name": "HYUNWOO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43622779": {
    "id": "item_27317",
    "Last Name": "Matos",
    "First Name": "Clara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43623494": {
    "id": "item_27318",
    "Last Name": "Larsen",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43623626": {
    "id": "item_14587",
    "Last Name": "Flynn",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43624092": {
    "id": "item_27319",
    "Last Name": "Overton",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43624207": {
    "id": "item_16587",
    "Last Name": "Villanueva",
    "First Name": "Jerome",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43624348": {
    "id": "item_14588",
    "Last Name": "asano",
    "First Name": "katsuya",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43624642": {
    "id": "item_27320",
    "Last Name": "Marcellana",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43624820": {
    "id": "item_3689",
    "Last Name": "Blanchard",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43625008": {
    "id": "item_16588",
    "Last Name": "hawke",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43625767": {
    "id": "item_27321",
    "Last Name": "TANAHASHI",
    "First Name": "MIYUKI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43625990": {
    "id": "item_31199",
    "Last Name": "Hamache",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43626568": {
    "id": "item_29328",
    "Last Name": "Fleischner",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43627568": {
    "id": "item_3690",
    "Last Name": "barrow",
    "First Name": "Owen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43628334": {
    "id": "item_27322",
    "Last Name": "Davies",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43629362": {
    "id": "item_27323",
    "Last Name": "Ho",
    "First Name": "Kwok Ming",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43629500": {
    "id": "item_27324",
    "Last Name": "Ho",
    "First Name": "Sheung Lam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43629663": {
    "id": "item_14589",
    "Last Name": "CHEN",
    "First Name": "WENTAO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43631876": {
    "id": "item_14590",
    "Last Name": "Toby",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43632743": {
    "id": "item_27325",
    "Last Name": "Marlow",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43632744": {
    "id": "item_29329",
    "Last Name": "Seibel",
    "First Name": "Sigrid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43634863": {
    "id": "item_1807",
    "Last Name": "Ramsay",
    "First Name": "Lee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43636326": {
    "id": "item_3691",
    "Last Name": "Grimison",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43637962": {
    "id": "item_27326",
    "Last Name": "__",
    "First Name": "YUKIHIKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43640570": {
    "id": "item_29330",
    "Last Name": "Duong",
    "First Name": "Thi Bao Ngoc Vivian Brenda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43642345": {
    "id": "item_27327",
    "Last Name": "Gillies",
    "First Name": "Madison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43642346": {
    "id": "item_29331",
    "Last Name": "Parore",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43643009": {
    "id": "item_14591",
    "Last Name": "Luks",
    "First Name": "Meeme",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43643340": {
    "id": "item_14592",
    "Last Name": "Law",
    "First Name": "Clement",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43643380": {
    "id": "item_14593",
    "Last Name": "Pang",
    "First Name": "Jinzan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43643673": {
    "id": "item_3692",
    "Last Name": "Gardner",
    "First Name": "Clark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43644235": {
    "id": "item_14594",
    "Last Name": "YOSHII",
    "First Name": "HIRONOBU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43644472": {
    "id": "item_27328",
    "Last Name": "Gloria",
    "First Name": "Anthony Miguel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43644575": {
    "id": "item_27329",
    "Last Name": "CAMILLERI",
    "First Name": "BRANDON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43644601": {
    "id": "item_29332",
    "Last Name": "Forward",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645333": {
    "id": "item_27330",
    "Last Name": "Laniwaty",
    "First Name": "Devi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645335": {
    "id": "item_31200",
    "Last Name": "Pennells",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645436": {
    "id": "item_31201",
    "Last Name": "Sanders",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645753": {
    "id": "item_14595",
    "Last Name": "Cobis Sanchez",
    "First Name": "Maria Jose",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645758": {
    "id": "item_27331",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645770": {
    "id": "item_1808",
    "Last Name": "Wolnizer",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645929": {
    "id": "item_16589",
    "Last Name": "Granziera",
    "First Name": "Helena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646033": {
    "id": "item_27332",
    "Last Name": "Miller",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646273": {
    "id": "item_1809",
    "Last Name": "Arthur",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646454": {
    "id": "item_14596",
    "Last Name": "Ortiz",
    "First Name": "Marie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646467": {
    "id": "item_27333",
    "Last Name": "Suman",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646542": {
    "id": "item_29333",
    "Last Name": "Robinson",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646738": {
    "id": "item_16590",
    "Last Name": "Kusui",
    "First Name": "Ayako",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646743": {
    "id": "item_14597",
    "Last Name": "Thomas",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646831": {
    "id": "item_14598",
    "Last Name": "Rasmussen",
    "First Name": "J—n",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43647542": {
    "id": "item_27334",
    "Last Name": "Allmang",
    "First Name": "Kerstin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43647617": {
    "id": "item_1810",
    "Last Name": "Pavlov",
    "First Name": "Dmitry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43648567": {
    "id": "item_27335",
    "Last Name": "Paksi",
    "First Name": "Bhuwana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43649692": {
    "id": "item_29334",
    "Last Name": "Hu",
    "First Name": "Ceelsan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43650399": {
    "id": "item_29335",
    "Last Name": "Seher",
    "First Name": "sabrina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43650467": {
    "id": "item_3693",
    "Last Name": "Memmelaar",
    "First Name": "Jenna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43651465": {
    "id": "item_1811",
    "Last Name": "S‡nchez Guex",
    "First Name": "Gast—n",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43652066": {
    "id": "item_31202",
    "Last Name": "Cullen",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43654921": {
    "id": "item_14599",
    "Last Name": "Mostaccio",
    "First Name": "Julio Gabriel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43655451": {
    "id": "item_29336",
    "Last Name": "Rš§ler",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43656424": {
    "id": "item_31203",
    "Last Name": "Brown",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43656554": {
    "id": "item_5751",
    "Last Name": "Wood",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43657683": {
    "id": "item_31204",
    "Last Name": "Cuddeback",
    "First Name": "Ronda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43658247": {
    "id": "item_14600",
    "Last Name": "Santos",
    "First Name": "Denise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43659920": {
    "id": "item_1812",
    "Last Name": "weisheit",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43660747": {
    "id": "item_29337",
    "Last Name": "Chen",
    "First Name": "Tzee Loong",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43660865": {
    "id": "item_14601",
    "Last Name": "Lear",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43661015": {
    "id": "item_1813",
    "Last Name": "Deppeler",
    "First Name": "Devon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43661191": {
    "id": "item_1814",
    "Last Name": "Wein",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43662412": {
    "id": "item_27336",
    "Last Name": "Ramos",
    "First Name": "Ryan Albert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43662510": {
    "id": "item_14602",
    "Last Name": "Tabata",
    "First Name": "Hiroko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43663391": {
    "id": "item_1815",
    "Last Name": "Turner",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43663567": {
    "id": "item_29338",
    "Last Name": "Ganda",
    "First Name": "Raju",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43663806": {
    "id": "item_1816",
    "Last Name": "Foran",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43663911": {
    "id": "item_31205",
    "Last Name": "Ito",
    "First Name": "Masahiko",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43664359": {
    "id": "item_3694",
    "Last Name": "Zakrzewski",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43664433": {
    "id": "item_18572",
    "Last Name": "Barwick",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43664519": {
    "id": "item_27337",
    "Last Name": "Cheung",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43664534": {
    "id": "item_29339",
    "Last Name": "Schulz-Symon",
    "First Name": "Lydiah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43665703": {
    "id": "item_18573",
    "Last Name": "Roberts",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43669575": {
    "id": "item_14603",
    "Last Name": "Trung Tuan",
    "First Name": "Dung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43670128": {
    "id": "item_29340",
    "Last Name": "SROCZYNSKI",
    "First Name": "ANDRZEJ",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43672238": {
    "id": "item_1817",
    "Last Name": "Smithson",
    "First Name": "Alasdair",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43672371": {
    "id": "item_14604",
    "Last Name": "TANAKA",
    "First Name": "MITSUE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43672399": {
    "id": "item_27338",
    "Last Name": "LESZCZY_SKA",
    "First Name": "MA_GORZATA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43672819": {
    "id": "item_18574",
    "Last Name": "Martz",
    "First Name": "Marissa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43674607": {
    "id": "item_14605",
    "Last Name": "Lara",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43675054": {
    "id": "item_16591",
    "Last Name": "Rodriguez Vargas",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43675722": {
    "id": "item_29341",
    "Last Name": "houyet",
    "First Name": "jean-paul charles J",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43678053": {
    "id": "item_27339",
    "Last Name": "Kriesche",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43678236": {
    "id": "item_29342",
    "Last Name": "Ganzi",
    "First Name": "Rick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43678907": {
    "id": "item_14606",
    "Last Name": "Robie",
    "First Name": "Tammie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43679795": {
    "id": "item_27340",
    "Last Name": "Miller",
    "First Name": "Carrie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43680026": {
    "id": "item_16592",
    "Last Name": "MORENO",
    "First Name": "ENRIQUE",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43680306": {
    "id": "item_29343",
    "Last Name": "Akere",
    "First Name": "Olufunso",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43680364": {
    "id": "item_27341",
    "Last Name": "Castillo Lozano",
    "First Name": "Karla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43681247": {
    "id": "item_27342",
    "Last Name": "Yim",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43682389": {
    "id": "item_3695",
    "Last Name": "Maione",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43682416": {
    "id": "item_18575",
    "Last Name": "He",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43683184": {
    "id": "item_14607",
    "Last Name": "Teyler-Crowder",
    "First Name": "Holly",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43683552": {
    "id": "item_27343",
    "Last Name": "Hernandez",
    "First Name": "Martin Jr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43685384": {
    "id": "item_29344",
    "Last Name": "Green",
    "First Name": "Randall",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43685418": {
    "id": "item_29345",
    "Last Name": "Escalante",
    "First Name": "Gina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43685487": {
    "id": "item_29346",
    "Last Name": "Sherman-Green",
    "First Name": "Melani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43685763": {
    "id": "item_27344",
    "Last Name": "Plummer",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43685882": {
    "id": "item_27345",
    "Last Name": "Coyle",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43686031": {
    "id": "item_5752",
    "Last Name": "Barr",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43686284": {
    "id": "item_16593",
    "Last Name": "Siregar",
    "First Name": "Muhammad Adri",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43686356": {
    "id": "item_3696",
    "Last Name": "WIRA REKA WAHANA",
    "First Name": "ARWAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43687216": {
    "id": "item_3697",
    "Last Name": "Twardokes",
    "First Name": "Maciej",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43687368": {
    "id": "item_16594",
    "Last Name": "Simbolon",
    "First Name": "Franki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43687518": {
    "id": "item_16595",
    "Last Name": "Tazaki",
    "First Name": "Yuko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43687706": {
    "id": "item_14608",
    "Last Name": "Hendrawan",
    "First Name": "Shinta Christiana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43687827": {
    "id": "item_14609",
    "Last Name": "Utomo",
    "First Name": "Handoko",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43687841": {
    "id": "item_29347",
    "Last Name": "MIYOSHI",
    "First Name": "AIJI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43687863": {
    "id": "item_14610",
    "Last Name": "Austin",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43688252": {
    "id": "item_14611",
    "Last Name": "Rypina-Ga__zka",
    "First Name": "Dorota",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43689592": {
    "id": "item_16596",
    "Last Name": "Charleston",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43689970": {
    "id": "item_27346",
    "Last Name": "Mendez Gonzalez",
    "First Name": "Jose Francisco",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43690092": {
    "id": "item_14612",
    "Last Name": "Smart",
    "First Name": "Eddy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43690626": {
    "id": "item_16597",
    "Last Name": "O'Connor",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43690713": {
    "id": "item_14613",
    "Last Name": "Lucas",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43694940": {
    "id": "item_27347",
    "Last Name": "Calabrese",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43694969": {
    "id": "item_29348",
    "Last Name": "Ozkaptan",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43698632": {
    "id": "item_29349",
    "Last Name": "HITA HITA",
    "First Name": "LUIS MARIANO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43699323": {
    "id": "item_27348",
    "Last Name": "Solorzano Atencio",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43699910": {
    "id": "item_29350",
    "Last Name": "Rose-Louder",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43700259": {
    "id": "item_14614",
    "Last Name": "Carlson",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43700916": {
    "id": "item_27349",
    "Last Name": "Strickland",
    "First Name": "Allison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43705773": {
    "id": "item_16598",
    "Last Name": "Vaughn",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43707016": {
    "id": "item_31206",
    "Last Name": "FUKUSHIMA",
    "First Name": "KOICHI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43712426": {
    "id": "item_14615",
    "Last Name": "Rocha",
    "First Name": "Vera",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43712619": {
    "id": "item_3698",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43712677": {
    "id": "item_3699",
    "Last Name": "Greenwood",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43713229": {
    "id": "item_3700",
    "Last Name": "Matsubara",
    "First Name": "Sally",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43713327": {
    "id": "item_3701",
    "Last Name": "Freihoff",
    "First Name": "Maximilian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43713393": {
    "id": "item_27350",
    "Last Name": "Haidas",
    "First Name": "Dimitri Harri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43713421": {
    "id": "item_27351",
    "Last Name": "Haidas",
    "First Name": "Marina Elisabeth",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43713583": {
    "id": "item_1818",
    "Last Name": "Dzierzkowska",
    "First Name": "Aleksandra",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43715525": {
    "id": "item_1819",
    "Last Name": "Marti Benedicto",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43716755": {
    "id": "item_14616",
    "Last Name": "Aranda Rivillo",
    "First Name": "Dagoberto Eduardo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43721692": {
    "id": "item_14617",
    "Last Name": "Moran",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43728510": {
    "id": "item_27352",
    "Last Name": "SAITO",
    "First Name": "AYAKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43729958": {
    "id": "item_16599",
    "Last Name": "Kšhler",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43730653": {
    "id": "item_14618",
    "Last Name": "Borowczyk",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43730703": {
    "id": "item_29351",
    "Last Name": "Nguyen",
    "First Name": "Quang Hieu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43730873": {
    "id": "item_27353",
    "Last Name": "Thornton",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43730972": {
    "id": "item_29352",
    "Last Name": "Gillingham",
    "First Name": "Michaela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43731108": {
    "id": "item_29353",
    "Last Name": "Fauver",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43731528": {
    "id": "item_14619",
    "Last Name": "Gomes",
    "First Name": "JosŽ",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43735359": {
    "id": "item_27354",
    "Last Name": "Steinhilber",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43738308": {
    "id": "item_14620",
    "Last Name": "Radford",
    "First Name": "Tara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43740044": {
    "id": "item_1820",
    "Last Name": "Jones",
    "First Name": "Anne Louise",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43741902": {
    "id": "item_14621",
    "Last Name": "Villalobos",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43746943": {
    "id": "item_27355",
    "Last Name": "zhou",
    "First Name": "zixuan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43747440": {
    "id": "item_3702",
    "Last Name": "Slater",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43747509": {
    "id": "item_14622",
    "Last Name": "Beattie",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43747608": {
    "id": "item_3703",
    "Last Name": "Andrade Mena",
    "First Name": "Daniela",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43747806": {
    "id": "item_27356",
    "Last Name": "Challis",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43748915": {
    "id": "item_27357",
    "Last Name": "Jeffrey",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43748921": {
    "id": "item_29354",
    "Last Name": "Frisby",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43749109": {
    "id": "item_27358",
    "Last Name": "Canlas",
    "First Name": "Ma. Theresa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43749191": {
    "id": "item_14623",
    "Last Name": "Byrne",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43749665": {
    "id": "item_27359",
    "Last Name": "Zhao",
    "First Name": "Bin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43749739": {
    "id": "item_1821",
    "Last Name": "Wellavize",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43750615": {
    "id": "item_29355",
    "Last Name": "Iwakiri",
    "First Name": "Toshiteru",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43750648": {
    "id": "item_3704",
    "Last Name": "Dresler",
    "First Name": "Krzysztof",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43750661": {
    "id": "item_14624",
    "Last Name": "Carty",
    "First Name": "Fidelma",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43750690": {
    "id": "item_29356",
    "Last Name": "Boschan",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43750698": {
    "id": "item_14625",
    "Last Name": "Lersakrasamee",
    "First Name": "Thanaphol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43750891": {
    "id": "item_27360",
    "Last Name": "Kohlstrunk",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43751676": {
    "id": "item_1822",
    "Last Name": "Ageev",
    "First Name": "Vladimir",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43751905": {
    "id": "item_14626",
    "Last Name": "Mangcararangsi",
    "First Name": "Rathee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43752630": {
    "id": "item_31207",
    "Last Name": "Hoffman",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43754175": {
    "id": "item_1823",
    "Last Name": "Steer",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43754584": {
    "id": "item_1824",
    "Last Name": "Shukshunov",
    "First Name": "Denis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43757321": {
    "id": "item_27361",
    "Last Name": "Fr_szczak",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43757424": {
    "id": "item_16600",
    "Last Name": "MOTOMURA",
    "First Name": "SHIGENORI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43761532": {
    "id": "item_27362",
    "Last Name": "Appleby",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43762289": {
    "id": "item_14627",
    "Last Name": "Edzards",
    "First Name": "Gesa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43762996": {
    "id": "item_27363",
    "Last Name": "Gunnarsson",
    "First Name": "Helgi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43764085": {
    "id": "item_3705",
    "Last Name": "Zavala arciga",
    "First Name": "David eduardo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43764861": {
    "id": "item_3706",
    "Last Name": "Georgiev",
    "First Name": "Emil",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43765097": {
    "id": "item_14628",
    "Last Name": "Kearney",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43768243": {
    "id": "item_29357",
    "Last Name": "Moritz",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43768663": {
    "id": "item_14629",
    "Last Name": "Jackson",
    "First Name": "Honor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43769534": {
    "id": "item_27364",
    "Last Name": "Walker",
    "First Name": "Yvonne",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43769668": {
    "id": "item_5753",
    "Last Name": "Olsen",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43770489": {
    "id": "item_3707",
    "Last Name": "AlShehhi",
    "First Name": "Abdulla",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43772340": {
    "id": "item_1825",
    "Last Name": "Kam",
    "First Name": "Ivan Hiu To",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43772363": {
    "id": "item_27365",
    "Last Name": "Bock",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43772477": {
    "id": "item_14630",
    "Last Name": "Morgan",
    "First Name": "Bjorn",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43773271": {
    "id": "item_29358",
    "Last Name": "Walker",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43773711": {
    "id": "item_27366",
    "Last Name": "EL FEDIL",
    "First Name": "Kamel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774458": {
    "id": "item_27367",
    "Last Name": "LEE",
    "First Name": "JUNGHA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774603": {
    "id": "item_27368",
    "Last Name": "JUN",
    "First Name": "HOCHANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774648": {
    "id": "item_29359",
    "Last Name": "Tedjojuwono",
    "First Name": "Octavianus",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774724": {
    "id": "item_29360",
    "Last Name": "Frois",
    "First Name": "Joao",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774777": {
    "id": "item_27369",
    "Last Name": "KIM",
    "First Name": "SUNGWOO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774851": {
    "id": "item_1826",
    "Last Name": "Schnell",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774882": {
    "id": "item_14631",
    "Last Name": "Mujanovic",
    "First Name": "Erol",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774965": {
    "id": "item_1827",
    "Last Name": "Ball",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43775163": {
    "id": "item_29361",
    "Last Name": "Jankowski",
    "First Name": "Jacek",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43775302": {
    "id": "item_14632",
    "Last Name": "Felton",
    "First Name": "Niki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43775922": {
    "id": "item_3708",
    "Last Name": "van Dijk",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43776080": {
    "id": "item_1828",
    "Last Name": "Kukarin",
    "First Name": "Leonid",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43776186": {
    "id": "item_29362",
    "Last Name": "Hufana",
    "First Name": "Maria Cecilia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43776223": {
    "id": "item_27370",
    "Last Name": "Hazell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43776957": {
    "id": "item_27371",
    "Last Name": "RORIMPANDEY",
    "First Name": "Ray Ashvin F",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43777295": {
    "id": "item_1829",
    "Last Name": "Miakishev",
    "First Name": "Stanislav",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43779027": {
    "id": "item_29363",
    "Last Name": "_ab_dzka-Bugaj",
    "First Name": "Alicja",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43779226": {
    "id": "item_1830",
    "Last Name": "Ngo",
    "First Name": "Quoc binh",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43780480": {
    "id": "item_3709",
    "Last Name": "Meir",
    "First Name": "Amir",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43780833": {
    "id": "item_16601",
    "Last Name": "Luo",
    "First Name": "Nicholas K S",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43780911": {
    "id": "item_14633",
    "Last Name": "Patermann-Cornick",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43780928": {
    "id": "item_29364",
    "Last Name": "Kupcho",
    "First Name": "Kassandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43781153": {
    "id": "item_29365",
    "Last Name": "Bokhari",
    "First Name": "Yusra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43782760": {
    "id": "item_3710",
    "Last Name": "Buzaglo",
    "First Name": "Dvir",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43783101": {
    "id": "item_27372",
    "Last Name": "SADE",
    "First Name": "YONATAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43783496": {
    "id": "item_5754",
    "Last Name": "BARZILAY",
    "First Name": "NERIA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43785580": {
    "id": "item_27373",
    "Last Name": "Steer",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43786587": {
    "id": "item_3711",
    "Last Name": "Cote",
    "First Name": "Diana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43787515": {
    "id": "item_27374",
    "Last Name": "Chavez",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43787856": {
    "id": "item_3712",
    "Last Name": "Stollings",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43788565": {
    "id": "item_27375",
    "Last Name": "McAuliffe",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43789058": {
    "id": "item_16602",
    "Last Name": "Turnbull-Roberts",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43789309": {
    "id": "item_31208",
    "Last Name": "Quezada",
    "First Name": "Aura",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43789775": {
    "id": "item_27376",
    "Last Name": "KIM",
    "First Name": "YESOL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43789897": {
    "id": "item_3713",
    "Last Name": "KIM",
    "First Name": "UIJUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790036": {
    "id": "item_27377",
    "Last Name": "KIM",
    "First Name": "TAEKYUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790125": {
    "id": "item_27378",
    "Last Name": "KIM",
    "First Name": "HYEJU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790245": {
    "id": "item_27379",
    "Last Name": "PARK",
    "First Name": "INKYU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790373": {
    "id": "item_27380",
    "Last Name": "BAEK",
    "First Name": "SAEBYEOL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790469": {
    "id": "item_3714",
    "Last Name": "SONG",
    "First Name": "MINJAE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790576": {
    "id": "item_27381",
    "Last Name": "SHIN",
    "First Name": "MOOHWAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790712": {
    "id": "item_27382",
    "Last Name": "YOON",
    "First Name": "SEOKBAE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790831": {
    "id": "item_14634",
    "Last Name": "LEE",
    "First Name": "DONGGYU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43790922": {
    "id": "item_27383",
    "Last Name": "LEE",
    "First Name": "JAEYOUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43791121": {
    "id": "item_14635",
    "Last Name": "LIM",
    "First Name": "SUKHO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43791218": {
    "id": "item_27384",
    "Last Name": "SHIM",
    "First Name": "SANG EUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43791456": {
    "id": "item_27385",
    "Last Name": "JANG",
    "First Name": "SOO IL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43791907": {
    "id": "item_27386",
    "Last Name": "HWANG",
    "First Name": "SOONIL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43791999": {
    "id": "item_27387",
    "Last Name": "HWANG",
    "First Name": "CHANYUK",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792121": {
    "id": "item_27388",
    "Last Name": "LIM",
    "First Name": "JISEON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792191": {
    "id": "item_27389",
    "Last Name": "LEE",
    "First Name": "MIJI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792269": {
    "id": "item_27390",
    "Last Name": "YANG",
    "First Name": "GYUYEOP",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792425": {
    "id": "item_16603",
    "Last Name": "CHO",
    "First Name": "SEUNGHYUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792593": {
    "id": "item_3715",
    "Last Name": "LEE",
    "First Name": "YOUNGSOO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792899": {
    "id": "item_27391",
    "Last Name": "PARK",
    "First Name": "KYUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43793024": {
    "id": "item_27392",
    "Last Name": "LEE",
    "First Name": "JUNGHYUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43793094": {
    "id": "item_27393",
    "Last Name": "Isarabhakdi",
    "First Name": "Teeradech",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43793337": {
    "id": "item_27394",
    "Last Name": "Reyes",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43793639": {
    "id": "item_14636",
    "Last Name": "Rodriguez-Cazares",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43793947": {
    "id": "item_29366",
    "Last Name": "Milligan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43794182": {
    "id": "item_1831",
    "Last Name": "Foley",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43794617": {
    "id": "item_27395",
    "Last Name": "Combo",
    "First Name": "Izaya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43794785": {
    "id": "item_27396",
    "Last Name": "Cundiff",
    "First Name": "Lexie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43794825": {
    "id": "item_29367",
    "Last Name": "Soerjani",
    "First Name": "Lili",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43794893": {
    "id": "item_3716",
    "Last Name": "PARK",
    "First Name": "JUNGHO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43794954": {
    "id": "item_27397",
    "Last Name": "JI",
    "First Name": "JEHYUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795040": {
    "id": "item_27398",
    "Last Name": "KANG",
    "First Name": "TAEHOON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795121": {
    "id": "item_27399",
    "Last Name": "LEE",
    "First Name": "DAYOUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795161": {
    "id": "item_29368",
    "Last Name": "MORISAWA",
    "First Name": "MISAKO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795220": {
    "id": "item_27400",
    "Last Name": "LEE",
    "First Name": "JI EUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795223": {
    "id": "item_29369",
    "Last Name": "NAKANO",
    "First Name": "MIWA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795261": {
    "id": "item_27401",
    "Last Name": "JEONG",
    "First Name": "DEOGIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795492": {
    "id": "item_29370",
    "Last Name": "Thoegersen",
    "First Name": "Marlene",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795709": {
    "id": "item_27402",
    "Last Name": "LEE",
    "First Name": "HYOJOO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795750": {
    "id": "item_27403",
    "Last Name": "KIM",
    "First Name": "SEHONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795773": {
    "id": "item_27404",
    "Last Name": "Kaplan",
    "First Name": "Jocelyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795855": {
    "id": "item_27405",
    "Last Name": "YANG",
    "First Name": "HYOEUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795868": {
    "id": "item_27406",
    "Last Name": "WANG",
    "First Name": "XIAOQI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795889": {
    "id": "item_27407",
    "Last Name": "SIM",
    "First Name": "MINWOO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795909": {
    "id": "item_27408",
    "Last Name": "KONG",
    "First Name": "SUNYOUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795987": {
    "id": "item_3717",
    "Last Name": "KE",
    "First Name": "XIAOHUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796061": {
    "id": "item_27409",
    "Last Name": "BYUN",
    "First Name": "SURYUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796088": {
    "id": "item_27410",
    "Last Name": "LEE",
    "First Name": "MYUNG HWA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796129": {
    "id": "item_27411",
    "Last Name": "HEO",
    "First Name": "JI WON",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796146": {
    "id": "item_27412",
    "Last Name": "NAM",
    "First Name": "YOUNG MIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796609": {
    "id": "item_27413",
    "Last Name": "Darmoyo",
    "First Name": "Adrianto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796681": {
    "id": "item_27414",
    "Last Name": "Kameniar",
    "First Name": "Narelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796752": {
    "id": "item_27415",
    "Last Name": "LI",
    "First Name": "YONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796985": {
    "id": "item_29371",
    "Last Name": "Wall",
    "First Name": "Noel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43797122": {
    "id": "item_27416",
    "Last Name": "Eather",
    "First Name": "Greg",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43797143": {
    "id": "item_27417",
    "Last Name": "Tan",
    "First Name": "Charina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43797214": {
    "id": "item_27418",
    "Last Name": "MONOZCA",
    "First Name": "MARIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43797228": {
    "id": "item_29372",
    "Last Name": "Pisuk",
    "First Name": "Krzysztof",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43797309": {
    "id": "item_31209",
    "Last Name": "Ludwell",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43797630": {
    "id": "item_1832",
    "Last Name": "Hayon",
    "First Name": "Ram",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43798287": {
    "id": "item_1833",
    "Last Name": "Philotheou",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43799104": {
    "id": "item_3718",
    "Last Name": "FENG",
    "First Name": "SHIYIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43799588": {
    "id": "item_1834",
    "Last Name": "Wong",
    "First Name": "Chi Shan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43799971": {
    "id": "item_3719",
    "Last Name": "Tso",
    "First Name": "Wah Hin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43801053": {
    "id": "item_27419",
    "Last Name": "Barrett",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43801396": {
    "id": "item_14637",
    "Last Name": "Salinas Aguilar",
    "First Name": "Ada Priscila",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43802031": {
    "id": "item_16604",
    "Last Name": "Cobb",
    "First Name": "Sonja",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43802587": {
    "id": "item_1835",
    "Last Name": "A Shay",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43802874": {
    "id": "item_1836",
    "Last Name": "Lloyd",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43803299": {
    "id": "item_3720",
    "Last Name": "Schranz",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43805178": {
    "id": "item_3721",
    "Last Name": "Fernandez",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43805819": {
    "id": "item_27420",
    "Last Name": "Charcon",
    "First Name": "Ilan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43805820": {
    "id": "item_31210",
    "Last Name": "Medicinebird",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43807302": {
    "id": "item_29373",
    "Last Name": "Rozas",
    "First Name": "Trisha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43807471": {
    "id": "item_1837",
    "Last Name": "Korbini",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43807663": {
    "id": "item_27421",
    "Last Name": "Kiehborth",
    "First Name": "Krista",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43807884": {
    "id": "item_1838",
    "Last Name": "FLEMING",
    "First Name": "TYRONE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43808567": {
    "id": "item_14638",
    "Last Name": "Paulin",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43808730": {
    "id": "item_14639",
    "Last Name": "Frost",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43810499": {
    "id": "item_14640",
    "Last Name": "Cueto Rivas",
    "First Name": "Dana",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43810966": {
    "id": "item_14641",
    "Last Name": "Carrillo Nolazco",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43813022": {
    "id": "item_27422",
    "Last Name": "LEE",
    "First Name": "SUNGGUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43813216": {
    "id": "item_29374",
    "Last Name": "DENG",
    "First Name": "HONGJIAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43814552": {
    "id": "item_3722",
    "Last Name": "KIM",
    "First Name": "JAEYOON",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43814739": {
    "id": "item_27423",
    "Last Name": "KIM",
    "First Name": "KEUNA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43814782": {
    "id": "item_1839",
    "Last Name": "YANG",
    "First Name": "XIAOQIN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43814791": {
    "id": "item_27424",
    "Last Name": "JO",
    "First Name": "SANG RAE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43814895": {
    "id": "item_27425",
    "Last Name": "YUN",
    "First Name": "HEE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43814953": {
    "id": "item_3723",
    "Last Name": "JUNG",
    "First Name": "JIYOUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43814977": {
    "id": "item_29375",
    "Last Name": "WANG",
    "First Name": "HONGYAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43815063": {
    "id": "item_27426",
    "Last Name": "JEONG",
    "First Name": "SO I",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43815170": {
    "id": "item_27427",
    "Last Name": "SHIN",
    "First Name": "CHEOLKYU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43815216": {
    "id": "item_27428",
    "Last Name": "LEE",
    "First Name": "JUEUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43815356": {
    "id": "item_27429",
    "Last Name": "JUN",
    "First Name": "MIN CHEL",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43815683": {
    "id": "item_27430",
    "Last Name": "HONG",
    "First Name": "SUN-A",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43816264": {
    "id": "item_27431",
    "Last Name": "YANG",
    "First Name": "XIAOBIAO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43816488": {
    "id": "item_29376",
    "Last Name": "DING",
    "First Name": "GUAN XU",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43816690": {
    "id": "item_14642",
    "Last Name": "PAN",
    "First Name": "JUN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817060": {
    "id": "item_27432",
    "Last Name": "CHENG",
    "First Name": "SHIH YING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817223": {
    "id": "item_29377",
    "Last Name": "GAO",
    "First Name": "GUANGZHI",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817404": {
    "id": "item_3724",
    "Last Name": "Ashton",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817453": {
    "id": "item_14643",
    "Last Name": "CAO",
    "First Name": "KENT BIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817633": {
    "id": "item_29378",
    "Last Name": "LI",
    "First Name": "HAIYING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817685": {
    "id": "item_14644",
    "Last Name": "Hallis",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817908": {
    "id": "item_14645",
    "Last Name": "Rahim",
    "First Name": "Ziyad Tariq",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818020": {
    "id": "item_3725",
    "Last Name": "Bergamin",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818028": {
    "id": "item_29379",
    "Last Name": "YE",
    "First Name": "JIANBIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818069": {
    "id": "item_27433",
    "Last Name": "Ng",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818093": {
    "id": "item_27434",
    "Last Name": "DING",
    "First Name": "YAQUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818142": {
    "id": "item_3726",
    "Last Name": "LI",
    "First Name": "QIANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818167": {
    "id": "item_27435",
    "Last Name": "XU",
    "First Name": "WENLONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818233": {
    "id": "item_29380",
    "Last Name": "TAN",
    "First Name": "XIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818436": {
    "id": "item_29381",
    "Last Name": "XU",
    "First Name": "XIAOYING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818462": {
    "id": "item_3727",
    "Last Name": "LIN",
    "First Name": "XIANZHONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818487": {
    "id": "item_27436",
    "Last Name": "ZHANG",
    "First Name": "HongYu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818505": {
    "id": "item_3728",
    "Last Name": "HUANG",
    "First Name": "LIQIANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818579": {
    "id": "item_29382",
    "Last Name": "MOU",
    "First Name": "YANPING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818587": {
    "id": "item_27437",
    "Last Name": "ZHANG",
    "First Name": "GUICHAO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818610": {
    "id": "item_27438",
    "Last Name": "Polanecka - Prior",
    "First Name": "Marta",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818717": {
    "id": "item_27439",
    "Last Name": "Chung",
    "First Name": "Ching Wen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818844": {
    "id": "item_27440",
    "Last Name": "Cheng",
    "First Name": "I Ju",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43819184": {
    "id": "item_29383",
    "Last Name": "Robatel",
    "First Name": "Sebastien",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43819559": {
    "id": "item_14646",
    "Last Name": "Valtue–a Rincon",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43820002": {
    "id": "item_14647",
    "Last Name": "Cortes",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43820226": {
    "id": "item_29384",
    "Last Name": "BERNARD",
    "First Name": "GUY-ALBERT",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43822085": {
    "id": "item_14648",
    "Last Name": "Wang",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43823415": {
    "id": "item_3729",
    "Last Name": "Grossman",
    "First Name": "Bracha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43825310": {
    "id": "item_14649",
    "Last Name": "Peris-Felipo",
    "First Name": "Francisco Javier",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43825768": {
    "id": "item_29385",
    "Last Name": "Woolnough",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43825843": {
    "id": "item_27441",
    "Last Name": "Hoover",
    "First Name": "Mariah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43826201": {
    "id": "item_27442",
    "Last Name": "BEN HEMO",
    "First Name": "SHILO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43827967": {
    "id": "item_27443",
    "Last Name": "Busby",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43828627": {
    "id": "item_14650",
    "Last Name": "Nguyen",
    "First Name": "Dorothy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43828828": {
    "id": "item_3730",
    "Last Name": "Lawther",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43829135": {
    "id": "item_27444",
    "Last Name": "Busby",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43830170": {
    "id": "item_14651",
    "Last Name": "Dessureault",
    "First Name": "Jean",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43833447": {
    "id": "item_16605",
    "Last Name": "UCHIDA",
    "First Name": "MASANOBU",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43835268": {
    "id": "item_3731",
    "Last Name": "Johnson",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43836134": {
    "id": "item_16606",
    "Last Name": "Deeb",
    "First Name": "Omar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43836700": {
    "id": "item_16607",
    "Last Name": "Schulman",
    "First Name": "Jonah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43838653": {
    "id": "item_27445",
    "Last Name": "TASHIRO",
    "First Name": "TETSUHISA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43839388": {
    "id": "item_27446",
    "Last Name": "Kanda",
    "First Name": "Toshimitsu",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43839458": {
    "id": "item_3732",
    "Last Name": "Corbett",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43839501": {
    "id": "item_27447",
    "Last Name": "Hasebe",
    "First Name": "Toru",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43839554": {
    "id": "item_29386",
    "Last Name": "Rashid",
    "First Name": "Haroon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43840013": {
    "id": "item_14652",
    "Last Name": "Guthrie",
    "First Name": "Ralph",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43840014": {
    "id": "item_27448",
    "Last Name": "Nightingale",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43840671": {
    "id": "item_1840",
    "Last Name": "SORENSEN",
    "First Name": "ROBERT",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43841116": {
    "id": "item_14653",
    "Last Name": "Sukhbaatar",
    "First Name": "ALTANCHIMEG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43841294": {
    "id": "item_16608",
    "Last Name": "bin Abd Rashit",
    "First Name": "Abdul Qawiy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43842611": {
    "id": "item_27449",
    "Last Name": "Chin",
    "First Name": "Bryan Sing Lik",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43843509": {
    "id": "item_3733",
    "Last Name": "Joiner Gonzalez",
    "First Name": "Diana Jocelynn",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43845476": {
    "id": "item_16609",
    "Last Name": "Madsen",
    "First Name": "Stephanie Ann Marie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43847421": {
    "id": "item_29387",
    "Last Name": "LEE",
    "First Name": "BO-RUNG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43849820": {
    "id": "item_27450",
    "Last Name": "Abad",
    "First Name": "Ana Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43856109": {
    "id": "item_1841",
    "Last Name": "McGarvie",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43857265": {
    "id": "item_29388",
    "Last Name": "Aguilar Gutierrez",
    "First Name": "Maribel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43865677": {
    "id": "item_27451",
    "Last Name": "De Dios",
    "First Name": "Miguel Angel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43868174": {
    "id": "item_27452",
    "Last Name": "Scott",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43869060": {
    "id": "item_27453",
    "Last Name": "Duran Casas",
    "First Name": "Mariona",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43869589": {
    "id": "item_27454",
    "Last Name": "Brett",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43870211": {
    "id": "item_16610",
    "Last Name": "Mongkolsuthree",
    "First Name": "Jutiphan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43870562": {
    "id": "item_1842",
    "Last Name": "Guerrini",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43872057": {
    "id": "item_27455",
    "Last Name": "O'Brien-Smith",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43872110": {
    "id": "item_27456",
    "Last Name": "Yamazaki",
    "First Name": "Tomoki",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43874262": {
    "id": "item_29389",
    "Last Name": "Phayonrat",
    "First Name": "Ruedinan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43879134": {
    "id": "item_3734",
    "Last Name": "Oxford",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43879881": {
    "id": "item_14654",
    "Last Name": "Carrillo Nolazco",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43881096": {
    "id": "item_16611",
    "Last Name": "Ahmad Sabri",
    "First Name": "Ahmad Ezzrin Loy Bin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43882413": {
    "id": "item_1843",
    "Last Name": "Le",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43882462": {
    "id": "item_14655",
    "Last Name": "Wang",
    "First Name": "James Kai Chun",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43882502": {
    "id": "item_3735",
    "Last Name": "Wong",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43883422": {
    "id": "item_1844",
    "Last Name": "de Leeuw",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43884355": {
    "id": "item_27457",
    "Last Name": "Wang",
    "First Name": "RongFen",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43885429": {
    "id": "item_1845",
    "Last Name": "Lowe",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43885818": {
    "id": "item_3736",
    "Last Name": "Conway",
    "First Name": "Oisin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43886242": {
    "id": "item_27458",
    "Last Name": "Daef",
    "First Name": "Mohamad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43888578": {
    "id": "item_29390",
    "Last Name": "Obleada",
    "First Name": "Prince RJ",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43888586": {
    "id": "item_1846",
    "Last Name": "Parish",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43888675": {
    "id": "item_27459",
    "Last Name": "Sylvester",
    "First Name": "Faye",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43890630": {
    "id": "item_27460",
    "Last Name": "WEN",
    "First Name": "NAI YING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43891109": {
    "id": "item_27461",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43891667": {
    "id": "item_27462",
    "Last Name": "Tangmanowutthikul",
    "First Name": "Kittichai",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43892434": {
    "id": "item_27463",
    "Last Name": "Biggins",
    "First Name": "Mary Sharon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43893373": {
    "id": "item_1847",
    "Last Name": "McCormack",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43894336": {
    "id": "item_29391",
    "Last Name": "CI",
    "First Name": "CHENGYUN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43895547": {
    "id": "item_3737",
    "Last Name": "Rodas",
    "First Name": "Harald",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43895814": {
    "id": "item_27464",
    "Last Name": "GONZALEZ",
    "First Name": "ALVARO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43895958": {
    "id": "item_27465",
    "Last Name": "De Paz",
    "First Name": "Josue",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43896055": {
    "id": "item_27466",
    "Last Name": "GARRONE",
    "First Name": "SANDRA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43896621": {
    "id": "item_27467",
    "Last Name": "ANDREU",
    "First Name": "GRACIELA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43897739": {
    "id": "item_29392",
    "Last Name": "CONTRERAS NAVARRETE",
    "First Name": "PABLO ANTONIO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43898254": {
    "id": "item_3738",
    "Last Name": "Anderson",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43898682": {
    "id": "item_14656",
    "Last Name": "Avenis",
    "First Name": "Diodita C",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43898693": {
    "id": "item_27468",
    "Last Name": "Hamilton",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43900031": {
    "id": "item_3739",
    "Last Name": "Sanasi",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43900236": {
    "id": "item_27469",
    "Last Name": "Robles",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43901702": {
    "id": "item_1848",
    "Last Name": "Higginbotham",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43901758": {
    "id": "item_1849",
    "Last Name": "Berntsen",
    "First Name": "Marley",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43901818": {
    "id": "item_29393",
    "Last Name": "McInnes",
    "First Name": "Carrie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43901929": {
    "id": "item_14657",
    "Last Name": "Harper",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43903573": {
    "id": "item_14658",
    "Last Name": "Prowse",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43904172": {
    "id": "item_1850",
    "Last Name": "Sung",
    "First Name": "Nayoung",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43904435": {
    "id": "item_27470",
    "Last Name": "Stoltzfus",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43904454": {
    "id": "item_14659",
    "Last Name": "Lavan",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43904562": {
    "id": "item_3740",
    "Last Name": "KIM",
    "First Name": "HYONSUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43904897": {
    "id": "item_27471",
    "Last Name": "Richards",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43905518": {
    "id": "item_29394",
    "Last Name": "Smith",
    "First Name": "Brad",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43906989": {
    "id": "item_29395",
    "Last Name": "Feng",
    "First Name": "Jue",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43907224": {
    "id": "item_1851",
    "Last Name": "HIJIKATA",
    "First Name": "SHINSUKE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43908474": {
    "id": "item_14660",
    "Last Name": "Hung",
    "First Name": "Tien",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43908715": {
    "id": "item_3741",
    "Last Name": "WONG",
    "First Name": "GERALD G",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43908897": {
    "id": "item_29396",
    "Last Name": "Kashyap",
    "First Name": "Pavan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43908955": {
    "id": "item_3742",
    "Last Name": "Williamson",
    "First Name": "Carolee",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43909693": {
    "id": "item_16612",
    "Last Name": "NOVIANTI",
    "First Name": "HILDA",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43909735": {
    "id": "item_27472",
    "Last Name": "Djokosoetono",
    "First Name": "Adrianto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43911009": {
    "id": "item_14661",
    "Last Name": "Caudle",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43912779": {
    "id": "item_3743",
    "Last Name": "Brosnan",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43913668": {
    "id": "item_3744",
    "Last Name": "Olivero",
    "First Name": "Guillermo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43913696": {
    "id": "item_3745",
    "Last Name": "Olivero",
    "First Name": "Justo",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43913782": {
    "id": "item_27473",
    "Last Name": "Bowens",
    "First Name": "Tyrone",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43915643": {
    "id": "item_29397",
    "Last Name": "Mwango",
    "First Name": "Berry",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43917295": {
    "id": "item_1852",
    "Last Name": "Impey",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43917695": {
    "id": "item_14662",
    "Last Name": "Shultz",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43920887": {
    "id": "item_29398",
    "Last Name": "Ruiz",
    "First Name": "Lorenzo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43922402": {
    "id": "item_3746",
    "Last Name": "Do",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43925340": {
    "id": "item_3747",
    "Last Name": "WU",
    "First Name": "JUNWEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43925836": {
    "id": "item_3748",
    "Last Name": "HE",
    "First Name": "TENGYUAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43926021": {
    "id": "item_3749",
    "Last Name": "ZHANG",
    "First Name": "FENG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43926342": {
    "id": "item_3750",
    "Last Name": "WANG",
    "First Name": "QIAO ZHEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43926383": {
    "id": "item_14663",
    "Last Name": "ZHOU",
    "First Name": "WEI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43926620": {
    "id": "item_27474",
    "Last Name": "Winikerei",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43926819": {
    "id": "item_1853",
    "Last Name": "Guo",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927049": {
    "id": "item_3751",
    "Last Name": "WANG",
    "First Name": "QIAN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927254": {
    "id": "item_27475",
    "Last Name": "KO",
    "First Name": "SUM",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927271": {
    "id": "item_1854",
    "Last Name": "ZHAO",
    "First Name": "LEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927362": {
    "id": "item_1855",
    "Last Name": "Cheng",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927408": {
    "id": "item_1856",
    "Last Name": "YANG",
    "First Name": "JIANKANG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927611": {
    "id": "item_27476",
    "Last Name": "Westwood",
    "First Name": "Tyrone",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927669": {
    "id": "item_3752",
    "Last Name": "CHIU",
    "First Name": "CHE-YUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927716": {
    "id": "item_1857",
    "Last Name": "SU",
    "First Name": "TAO",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927876": {
    "id": "item_3753",
    "Last Name": "GAO",
    "First Name": "FEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927959": {
    "id": "item_3754",
    "Last Name": "WONG",
    "First Name": "MAY",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927999": {
    "id": "item_27477",
    "Last Name": "Viljoen",
    "First Name": "Sonja",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928165": {
    "id": "item_3755",
    "Last Name": "CHEN",
    "First Name": "DONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928300": {
    "id": "item_3756",
    "Last Name": "XU",
    "First Name": "YAOZHONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928328": {
    "id": "item_14664",
    "Last Name": "Salvador",
    "First Name": "Danwin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928475": {
    "id": "item_31211",
    "Last Name": "Huet",
    "First Name": "Michel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928492": {
    "id": "item_14665",
    "Last Name": "Andersen",
    "First Name": "Mette Soegaard",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928512": {
    "id": "item_27478",
    "Last Name": "Kelly",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928702": {
    "id": "item_1858",
    "Last Name": "LU",
    "First Name": "JIE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928729": {
    "id": "item_29399",
    "Last Name": "Brown",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928782": {
    "id": "item_1859",
    "Last Name": "LI",
    "First Name": "YING",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43929036": {
    "id": "item_29400",
    "Last Name": "YU",
    "First Name": "LIMIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43929196": {
    "id": "item_29401",
    "Last Name": "XIAOJUAN",
    "First Name": "GUO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43929551": {
    "id": "item_1860",
    "Last Name": "Majchrzak",
    "First Name": "Larysa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43929953": {
    "id": "item_1861",
    "Last Name": "Widjaja",
    "First Name": "Eddy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43930467": {
    "id": "item_27479",
    "Last Name": "Moravek",
    "First Name": "Milan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43930472": {
    "id": "item_27480",
    "Last Name": "Fung",
    "First Name": "Mei Fung Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43931045": {
    "id": "item_27481",
    "Last Name": "Macfarlane",
    "First Name": "Ross",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43932023": {
    "id": "item_1862",
    "Last Name": "Ko",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43932960": {
    "id": "item_1863",
    "Last Name": "Lauder",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43933191": {
    "id": "item_3757",
    "Last Name": "Quiroga",
    "First Name": "Monica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43933883": {
    "id": "item_29402",
    "Last Name": "NAWAZ",
    "First Name": "SHAZIA",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43933958": {
    "id": "item_31212",
    "Last Name": "LIRANZO",
    "First Name": "JUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43934229": {
    "id": "item_29403",
    "Last Name": "ueno",
    "First Name": "koichiro",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43934974": {
    "id": "item_14666",
    "Last Name": "Whitfield",
    "First Name": "Josiah",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43935885": {
    "id": "item_29404",
    "Last Name": "Cano",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43935991": {
    "id": "item_14667",
    "Last Name": "Quevedo",
    "First Name": "Alejandra",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43936149": {
    "id": "item_14668",
    "Last Name": "Dahl",
    "First Name": "Mads",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43937188": {
    "id": "item_1864",
    "Last Name": "Mukhtar",
    "First Name": "Fahd",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43940922": {
    "id": "item_3758",
    "Last Name": "FUJIHARA",
    "First Name": "YUTAKA",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43941076": {
    "id": "item_14669",
    "Last Name": "Rosales",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43943915": {
    "id": "item_3759",
    "Last Name": "GAI",
    "First Name": "JIYU",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43944119": {
    "id": "item_1865",
    "Last Name": "HU",
    "First Name": "RUI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43944160": {
    "id": "item_1866",
    "Last Name": "SONG",
    "First Name": "DONGMEI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43944963": {
    "id": "item_27482",
    "Last Name": "Lavia",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43945150": {
    "id": "item_3760",
    "Last Name": "YANG",
    "First Name": "WANXIONG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43945375": {
    "id": "item_14670",
    "Last Name": "Howes",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43945676": {
    "id": "item_29405",
    "Last Name": "Bara-Jimenez",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43945800": {
    "id": "item_27483",
    "Last Name": "Evans",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43945872": {
    "id": "item_29406",
    "Last Name": "Stephens",
    "First Name": "Crystal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43945975": {
    "id": "item_27484",
    "Last Name": "SUN",
    "First Name": "WEIJIE",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947381": {
    "id": "item_1867",
    "Last Name": "Jaggar",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947460": {
    "id": "item_27485",
    "Last Name": "Michaelis",
    "First Name": "Karsten",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947671": {
    "id": "item_14671",
    "Last Name": "Madsen",
    "First Name": "Lars Kristian",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947693": {
    "id": "item_14672",
    "Last Name": "Rodins",
    "First Name": "Karl",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947760": {
    "id": "item_3761",
    "Last Name": "MAEDA",
    "First Name": "ATSUTOSHI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43948334": {
    "id": "item_1868",
    "Last Name": "Deng",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43948535": {
    "id": "item_3762",
    "Last Name": "LOPEZ GENDE",
    "First Name": "LUIS",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43948596": {
    "id": "item_29407",
    "Last Name": "Ryan Rose",
    "First Name": "Dave",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43949394": {
    "id": "item_14673",
    "Last Name": "De Varona Oti",
    "First Name": "Marisel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43949408": {
    "id": "item_1869",
    "Last Name": "Rivera",
    "First Name": "Enrique",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43949466": {
    "id": "item_1870",
    "Last Name": "Milu",
    "First Name": "Alexandru",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43949679": {
    "id": "item_3763",
    "Last Name": "Galvez",
    "First Name": "Rebeca",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43950525": {
    "id": "item_16613",
    "Last Name": "Morales III",
    "First Name": "Ernest",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43950712": {
    "id": "item_14674",
    "Last Name": "Nmezi",
    "First Name": "Murphy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43952253": {
    "id": "item_1871",
    "Last Name": "Le",
    "First Name": "Thao",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43952302": {
    "id": "item_3764",
    "Last Name": "Ercolino",
    "First Name": "Simone",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43953070": {
    "id": "item_1872",
    "Last Name": "Rodriguez Villalobos",
    "First Name": "Fabiola Guadalupe",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43953391": {
    "id": "item_29408",
    "Last Name": "Ibuado",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43953470": {
    "id": "item_31213",
    "Last Name": "Krish",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43955014": {
    "id": "item_29409",
    "Last Name": "Keszei",
    "First Name": "Stacy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43956330": {
    "id": "item_14675",
    "Last Name": "Mei",
    "First Name": "Qiongxiu",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43957096": {
    "id": "item_27486",
    "Last Name": "Alexiou",
    "First Name": "Ioanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43962030": {
    "id": "item_3765",
    "Last Name": "Spilka",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43962666": {
    "id": "item_14676",
    "Last Name": "Brown",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43964977": {
    "id": "item_27487",
    "Last Name": "Rennie",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43965803": {
    "id": "item_3766",
    "Last Name": "Loftus",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43965900": {
    "id": "item_27488",
    "Last Name": "higgins",
    "First Name": "patricia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43965933": {
    "id": "item_27489",
    "Last Name": "higgins",
    "First Name": "brenton",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43966128": {
    "id": "item_29410",
    "Last Name": "YANG",
    "First Name": "XING",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43967291": {
    "id": "item_27490",
    "Last Name": "Dieng",
    "First Name": "Arame",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43967371": {
    "id": "item_27491",
    "Last Name": "Kaveh",
    "First Name": "Keri",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43967471": {
    "id": "item_29411",
    "Last Name": "Wilson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43967481": {
    "id": "item_29412",
    "Last Name": "San Diego",
    "First Name": "Teresa Marie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43967520": {
    "id": "item_3767",
    "Last Name": "Yabuka",
    "First Name": "Clint",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43969334": {
    "id": "item_27492",
    "Last Name": "Totterdell",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43969447": {
    "id": "item_29413",
    "Last Name": "Rigby",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43970970": {
    "id": "item_29414",
    "Last Name": "Loftus",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43971538": {
    "id": "item_3768",
    "Last Name": "Carmona",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43972347": {
    "id": "item_16614",
    "Last Name": "Koller",
    "First Name": "Markus",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43975830": {
    "id": "item_16615",
    "Last Name": "Gonz‡lez",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43977791": {
    "id": "item_16616",
    "Last Name": "DIAZ MUCHARRAZ",
    "First Name": "ENRIQUE A",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43979498": {
    "id": "item_14677",
    "Last Name": "Ilowiecki",
    "First Name": "Mariusz",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43981414": {
    "id": "item_5755",
    "Last Name": "Pehota",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43984475": {
    "id": "item_29415",
    "Last Name": "Gardner",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43984700": {
    "id": "item_31214",
    "Last Name": "Ibuado",
    "First Name": "Ana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43984817": {
    "id": "item_29416",
    "Last Name": "Samuels",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43986042": {
    "id": "item_1873",
    "Last Name": "Staunton",
    "First Name": "Bill",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43986077": {
    "id": "item_16617",
    "Last Name": "S¿rensen",
    "First Name": "Per Langballe",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43988789": {
    "id": "item_27493",
    "Last Name": "Sangha",
    "First Name": "Jagpal",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43991160": {
    "id": "item_14678",
    "Last Name": "Usandizaga Carulla",
    "First Name": "Claudi Artur",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44000043": {
    "id": "item_16618",
    "Last Name": "Lastimosa",
    "First Name": "Caesar",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44001075": {
    "id": "item_29417",
    "Last Name": "Fordham",
    "First Name": "Nick",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44004187": {
    "id": "item_27494",
    "Last Name": "Mills",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44004419": {
    "id": "item_29418",
    "Last Name": "Hampson",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44011267": {
    "id": "item_27495",
    "Last Name": "Tokiwa",
    "First Name": "Makoto",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44015528": {
    "id": "item_27496",
    "Last Name": "Burgess",
    "First Name": "Avril",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44023106": {
    "id": "item_14679",
    "Last Name": "Browne",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44023766": {
    "id": "item_1874",
    "Last Name": "Orakzai",
    "First Name": "Sami",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44025161": {
    "id": "item_27497",
    "Last Name": "Yingvararuk",
    "First Name": "Parichard",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44025494": {
    "id": "item_14680",
    "Last Name": "Moll Bosch",
    "First Name": "Ariadna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44027661": {
    "id": "item_16619",
    "Last Name": "Hernandez Cruz",
    "First Name": "Antonio F",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44028244": {
    "id": "item_31215",
    "Last Name": "Nasution",
    "First Name": "Indri aisyah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44028275": {
    "id": "item_14681",
    "Last Name": "Garcia Soria",
    "First Name": "Pere Josep",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44028317": {
    "id": "item_31216",
    "Last Name": "Yahya",
    "First Name": "Dhani",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44030410": {
    "id": "item_3769",
    "Last Name": "TRUONG KHOI",
    "First Name": "NGUYEN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44030623": {
    "id": "item_1875",
    "Last Name": "Lyons",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44032308": {
    "id": "item_27498",
    "Last Name": "Wyper",
    "First Name": "Brent",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44033340": {
    "id": "item_29419",
    "Last Name": "Thompson",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44033674": {
    "id": "item_27499",
    "Last Name": "Miller",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44033772": {
    "id": "item_3770",
    "Last Name": "Umlah",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44038637": {
    "id": "item_3771",
    "Last Name": "Truax",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44040266": {
    "id": "item_29420",
    "Last Name": "Miller",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44041317": {
    "id": "item_14682",
    "Last Name": "Cosco",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44042158": {
    "id": "item_14683",
    "Last Name": "Kumar",
    "First Name": "Gajal",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44043011": {
    "id": "item_3772",
    "Last Name": "Gilbert",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44047203": {
    "id": "item_3773",
    "Last Name": "KIM",
    "First Name": "YOOSUNG",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44047220": {
    "id": "item_14684",
    "Last Name": "Hally",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44047542": {
    "id": "item_27500",
    "Last Name": "McMahon",
    "First Name": "Bettina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44049110": {
    "id": "item_14685",
    "Last Name": "CHANG",
    "First Name": "CHIN MIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44049855": {
    "id": "item_1876",
    "Last Name": "Djula",
    "First Name": "Zefanya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44050952": {
    "id": "item_27501",
    "Last Name": "Sahid",
    "First Name": "Galih",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44052424": {
    "id": "item_3774",
    "Last Name": "KIM",
    "First Name": "SUNGKYUN",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44053174": {
    "id": "item_1877",
    "Last Name": "Shimahata",
    "First Name": "Kenji",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44053352": {
    "id": "item_14686",
    "Last Name": "Bell",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44053846": {
    "id": "item_3775",
    "Last Name": "Luck",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44053928": {
    "id": "item_3776",
    "Last Name": "Reilly",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44054378": {
    "id": "item_3777",
    "Last Name": "Strickley",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44055250": {
    "id": "item_3778",
    "Last Name": "Crawley",
    "First Name": "Ty",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44055503": {
    "id": "item_1878",
    "Last Name": "Hazell",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44056921": {
    "id": "item_16620",
    "Last Name": "Echeverria",
    "First Name": "Jose Antonio",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44058494": {
    "id": "item_16621",
    "Last Name": "Francisco",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44059792": {
    "id": "item_27502",
    "Last Name": "France",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44059837": {
    "id": "item_3779",
    "Last Name": "Winthrop",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44063019": {
    "id": "item_31217",
    "Last Name": "DiSalvo",
    "First Name": "Deanna",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44065038": {
    "id": "item_29421",
    "Last Name": "Munoz",
    "First Name": "Benesape Maria Therese",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44065537": {
    "id": "item_27503",
    "Last Name": "Sampaio",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44066902": {
    "id": "item_1879",
    "Last Name": "Watson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44068253": {
    "id": "item_14687",
    "Last Name": "Gil",
    "First Name": "Harvest",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44068264": {
    "id": "item_14688",
    "Last Name": "Tomlinson",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44068639": {
    "id": "item_29422",
    "Last Name": "Grossman",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44068684": {
    "id": "item_27504",
    "Last Name": "Rivera",
    "First Name": "Felix",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44068692": {
    "id": "item_3780",
    "Last Name": "Whelan",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44069172": {
    "id": "item_14689",
    "Last Name": "Walsg",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44071298": {
    "id": "item_1880",
    "Last Name": "Frank",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44071994": {
    "id": "item_27505",
    "Last Name": "Kelly",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44072001": {
    "id": "item_27506",
    "Last Name": "DUAN",
    "First Name": "YULONG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44074652": {
    "id": "item_29423",
    "Last Name": "Godber",
    "First Name": "Kath",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44076251": {
    "id": "item_14690",
    "Last Name": "BECKETT",
    "First Name": "ALEXANDER",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44076955": {
    "id": "item_16622",
    "Last Name": "Thompson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44078522": {
    "id": "item_16623",
    "Last Name": "Bagge",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44086760": {
    "id": "item_14691",
    "Last Name": "Schlosser",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44088702": {
    "id": "item_14692",
    "Last Name": "van Blerk",
    "First Name": "Brenden",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44088815": {
    "id": "item_3781",
    "Last Name": "Wharton",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44089935": {
    "id": "item_1881",
    "Last Name": "Meil",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44090079": {
    "id": "item_29424",
    "Last Name": "Osborn",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44091434": {
    "id": "item_14693",
    "Last Name": "Lofthouse",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44091507": {
    "id": "item_29425",
    "Last Name": "West",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44092648": {
    "id": "item_27507",
    "Last Name": "Hernandez-Bobrow",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44094659": {
    "id": "item_14694",
    "Last Name": "Conway",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44095668": {
    "id": "item_1882",
    "Last Name": "Murray",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44095686": {
    "id": "item_14695",
    "Last Name": "Pimsiripanich",
    "First Name": "Sopha",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44095710": {
    "id": "item_3782",
    "Last Name": "Romania",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44097781": {
    "id": "item_16624",
    "Last Name": "Pizarro",
    "First Name": "Lorena",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44099474": {
    "id": "item_27508",
    "Last Name": "Durr",
    "First Name": "Lakeshi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44099650": {
    "id": "item_16625",
    "Last Name": "Carracedo",
    "First Name": "Ines",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44100455": {
    "id": "item_14696",
    "Last Name": "Odiakosa",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44101543": {
    "id": "item_29426",
    "Last Name": "Kyaw",
    "First Name": "Marla",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44103532": {
    "id": "item_1883",
    "Last Name": "oleary",
    "First Name": "kenneth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44106354": {
    "id": "item_29427",
    "Last Name": "Miller",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44108039": {
    "id": "item_29428",
    "Last Name": "Simpson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44110169": {
    "id": "item_3783",
    "Last Name": "karmadi",
    "First Name": "triyaningsih saderi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44111708": {
    "id": "item_27509",
    "Last Name": "Crebert",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44114604": {
    "id": "item_29429",
    "Last Name": "Allen",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44115540": {
    "id": "item_27510",
    "Last Name": "MacMurchy",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44116443": {
    "id": "item_29430",
    "Last Name": "Brower",
    "First Name": "Nadine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44119771": {
    "id": "item_1884",
    "Last Name": "McKenzie",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44120449": {
    "id": "item_29431",
    "Last Name": "Blaisdell",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44122536": {
    "id": "item_3784",
    "Last Name": "Bidwill",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44122672": {
    "id": "item_14697",
    "Last Name": "URAOKA",
    "First Name": "NOBUYUKI",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44124423": {
    "id": "item_14698",
    "Last Name": "Kong",
    "First Name": "Michele",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44125799": {
    "id": "item_14699",
    "Last Name": "Porteous",
    "First Name": "Leyla",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44127703": {
    "id": "item_29432",
    "Last Name": "MARI",
    "First Name": "MARCO",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44130245": {
    "id": "item_29433",
    "Last Name": "Putra",
    "First Name": "Oktianda Yudi",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44135109": {
    "id": "item_27511",
    "Last Name": "Gonzalez Alanis",
    "First Name": "Arturo",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44138483": {
    "id": "item_27512",
    "Last Name": "Ayuningtyas",
    "First Name": "Andhina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44140877": {
    "id": "item_1885",
    "Last Name": "Birkill",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44143230": {
    "id": "item_1886",
    "Last Name": "Stevens",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44164647": {
    "id": "item_1887",
    "Last Name": "Armstrong",
    "First Name": "Wylie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44171378": {
    "id": "item_1888",
    "Last Name": "Hargrove",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44172474": {
    "id": "item_29434",
    "Last Name": "Mountford",
    "First Name": "Amara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44175626": {
    "id": "item_27513",
    "Last Name": "Mirza",
    "First Name": "Sabba",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44177878": {
    "id": "item_27514",
    "Last Name": "Gendelman",
    "First Name": "Eada",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44178164": {
    "id": "item_3785",
    "Last Name": "Brandinger",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44184868": {
    "id": "item_1889",
    "Last Name": "Yatco",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44184958": {
    "id": "item_1890",
    "Last Name": "Enriquez",
    "First Name": "Erika",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44188917": {
    "id": "item_29435",
    "Last Name": "OÕKeefe",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44189910": {
    "id": "item_14700",
    "Last Name": "Champ",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44190026": {
    "id": "item_14701",
    "Last Name": "Lavender",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44191302": {
    "id": "item_14702",
    "Last Name": "Lavender",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44204592": {
    "id": "item_1891",
    "Last Name": "Davis",
    "First Name": "Madison",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44209838": {
    "id": "item_29436",
    "Last Name": "Powers",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44210271": {
    "id": "item_29437",
    "Last Name": "Socol",
    "First Name": "Carey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44210306": {
    "id": "item_27515",
    "Last Name": "Spells",
    "First Name": "Brianca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44215886": {
    "id": "item_16626",
    "Last Name": "Riveros",
    "First Name": "Raul",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44216388": {
    "id": "item_27516",
    "Last Name": "Patel",
    "First Name": "Meet",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44218013": {
    "id": "item_27517",
    "Last Name": "NATALI",
    "First Name": "MARIA BELEN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44220593": {
    "id": "item_27518",
    "Last Name": "vascello",
    "First Name": "andrea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44222574": {
    "id": "item_1892",
    "Last Name": "Schmidlin",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44245725": {
    "id": "item_3786",
    "Last Name": "Gilbert",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44271289": {
    "id": "item_29438",
    "Last Name": "Gibbons",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44276204": {
    "id": "item_3787",
    "Last Name": "Carvalho",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44276547": {
    "id": "item_14703",
    "Last Name": "Woodward",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44276872": {
    "id": "item_27519",
    "Last Name": "Aguilan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44276927": {
    "id": "item_31218",
    "Last Name": "Darby",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44277153": {
    "id": "item_29439",
    "Last Name": "Cantre",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44277225": {
    "id": "item_27520",
    "Last Name": "Boon",
    "First Name": "June",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44277908": {
    "id": "item_29440",
    "Last Name": "Eustace",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44278374": {
    "id": "item_29441",
    "Last Name": "Wills",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44278906": {
    "id": "item_27521",
    "Last Name": "Dunworth",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44279138": {
    "id": "item_27522",
    "Last Name": "Vu",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44279500": {
    "id": "item_27523",
    "Last Name": "Zhao",
    "First Name": "Naike",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44279589": {
    "id": "item_31219",
    "Last Name": "Smith",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44282322": {
    "id": "item_29442",
    "Last Name": "Bruhn",
    "First Name": "Malte",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44283234": {
    "id": "item_27524",
    "Last Name": "Wang",
    "First Name": "Chunchiang",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44284660": {
    "id": "item_27525",
    "Last Name": "Guadalupe",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44285488": {
    "id": "item_3788",
    "Last Name": "Palmer",
    "First Name": "Logan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44307782": {
    "id": "item_27526",
    "Last Name": "Abhyankar",
    "First Name": "Ishan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44340248": {
    "id": "item_29443",
    "Last Name": "Ramanan",
    "First Name": "Uruthiramoorthy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44341537": {
    "id": "item_14704",
    "Last Name": "McKittrick",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44342053": {
    "id": "item_16627",
    "Last Name": "Mckenzie",
    "First Name": "Paige",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44342329": {
    "id": "item_31220",
    "Last Name": "Fulwood",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44345525": {
    "id": "item_14705",
    "Last Name": "URAOKA",
    "First Name": "Nobuyuki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44345634": {
    "id": "item_14706",
    "Last Name": "URAOKA",
    "First Name": "Chiaki",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44346177": {
    "id": "item_1893",
    "Last Name": "Muxworthy",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44347696": {
    "id": "item_3789",
    "Last Name": "Grifiths",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44354513": {
    "id": "item_27527",
    "Last Name": "Joseph",
    "First Name": "Nashin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44380401": {
    "id": "item_3790",
    "Last Name": "Westermann",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44387087": {
    "id": "item_14707",
    "Last Name": "Capelin",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44388604": {
    "id": "item_27528",
    "Last Name": "Douglas",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44388704": {
    "id": "item_29444",
    "Last Name": "Hornecker",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44388773": {
    "id": "item_16628",
    "Last Name": "Ognibene",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44394893": {
    "id": "item_27529",
    "Last Name": "Helbig",
    "First Name": "Karl Joakim",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44397917": {
    "id": "item_29445",
    "Last Name": "Weir",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44402854": {
    "id": "item_1894",
    "Last Name": "Suzuki",
    "First Name": "Kohta",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44404202": {
    "id": "item_29446",
    "Last Name": "Sugiyanto",
    "First Name": "Zaid",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44404416": {
    "id": "item_29447",
    "Last Name": "Stuart",
    "First Name": "Kerwin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44409400": {
    "id": "item_1895",
    "Last Name": "Lerma",
    "First Name": "Milton",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44430838": {
    "id": "item_29448",
    "Last Name": "Baker",
    "First Name": "Ana",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44431029": {
    "id": "item_1896",
    "Last Name": "Donovan",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44431133": {
    "id": "item_27530",
    "Last Name": "Heather",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44434864": {
    "id": "item_16629",
    "Last Name": "Weiszberger",
    "First Name": "Avraham",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44435177": {
    "id": "item_16630",
    "Last Name": "budiman",
    "First Name": "budiman",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44435518": {
    "id": "item_29449",
    "Last Name": "Tardo",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44435816": {
    "id": "item_3791",
    "Last Name": "Sultana",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44437787": {
    "id": "item_1897",
    "Last Name": "Shimp",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44438239": {
    "id": "item_1898",
    "Last Name": "Borangali",
    "First Name": "Aibek",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44443431": {
    "id": "item_16631",
    "Last Name": "LoRusso",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44445282": {
    "id": "item_16632",
    "Last Name": "Martinez",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44450092": {
    "id": "item_3792",
    "Last Name": "Szenics",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44459670": {
    "id": "item_27531",
    "Last Name": "Smith",
    "First Name": "Dawn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44459808": {
    "id": "item_27532",
    "Last Name": "Rowe",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44461804": {
    "id": "item_14708",
    "Last Name": "Onaeva",
    "First Name": "Adina",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44462083": {
    "id": "item_16633",
    "Last Name": "Trinh",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44462640": {
    "id": "item_27533",
    "Last Name": "Mohamed",
    "First Name": "Abdul",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44463512": {
    "id": "item_29450",
    "Last Name": "Silva",
    "First Name": "Talita",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44464337": {
    "id": "item_3793",
    "Last Name": "Ho",
    "First Name": "Franklin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44471292": {
    "id": "item_14709",
    "Last Name": "Rondla",
    "First Name": "Pradeep",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44472878": {
    "id": "item_1899",
    "Last Name": "Palmer",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44474890": {
    "id": "item_3794",
    "Last Name": "Ennis",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44480971": {
    "id": "item_29451",
    "Last Name": "Pond",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44481219": {
    "id": "item_27534",
    "Last Name": "Webster",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44482509": {
    "id": "item_3795",
    "Last Name": "Tack",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44483939": {
    "id": "item_27535",
    "Last Name": "Signorelli",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44483968": {
    "id": "item_27536",
    "Last Name": "Signorelli",
    "First Name": "Awhina",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44484449": {
    "id": "item_3796",
    "Last Name": "Lundbek",
    "First Name": "Jakob",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44486916": {
    "id": "item_29452",
    "Last Name": "Cansell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44488487": {
    "id": "item_27537",
    "Last Name": "Pillay",
    "First Name": "Kriya",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44496237": {
    "id": "item_29453",
    "Last Name": "Kovy",
    "First Name": "Norbert Sandor",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44497667": {
    "id": "item_27538",
    "Last Name": "Burgess",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44506812": {
    "id": "item_27539",
    "Last Name": "LIN",
    "First Name": "YI HSUAN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44506819": {
    "id": "item_3797",
    "Last Name": "Stowell",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44507516": {
    "id": "item_29454",
    "Last Name": "Romero",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44509232": {
    "id": "item_3798",
    "Last Name": "Halim",
    "First Name": "Budi",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44510121": {
    "id": "item_14710",
    "Last Name": "Winter",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44510847": {
    "id": "item_27540",
    "Last Name": "ward",
    "First Name": "james",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44511140": {
    "id": "item_1900",
    "Last Name": "Brunner",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44511903": {
    "id": "item_31221",
    "Last Name": "Keshmiri",
    "First Name": "Becky",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44512122": {
    "id": "item_1901",
    "Last Name": "Preston",
    "First Name": "Cerys",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44514078": {
    "id": "item_3799",
    "Last Name": "Tanzawa",
    "First Name": "Toshihiro",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44517151": {
    "id": "item_29455",
    "Last Name": "Morrison",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44519508": {
    "id": "item_1902",
    "Last Name": "Watters",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44519668": {
    "id": "item_29456",
    "Last Name": "Hernandez",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44520359": {
    "id": "item_1903",
    "Last Name": "Hansra",
    "First Name": "Harpreet",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44527419": {
    "id": "item_1904",
    "Last Name": "Streur",
    "First Name": "Devin",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44528563": {
    "id": "item_3800",
    "Last Name": "McLaughlin",
    "First Name": "Mary",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44529848": {
    "id": "item_29457",
    "Last Name": "Dunphy",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44532674": {
    "id": "item_14711",
    "Last Name": "Turgumbayev",
    "First Name": "Zhanat",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44534264": {
    "id": "item_29458",
    "Last Name": "Norris",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44534911": {
    "id": "item_29459",
    "Last Name": "Laudet",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44535205": {
    "id": "item_31222",
    "Last Name": "Couture",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44535753": {
    "id": "item_27541",
    "Last Name": "Elrify",
    "First Name": "Fatima",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44562604": {
    "id": "item_1905",
    "Last Name": "Richardson",
    "First Name": "Lydia",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44566283": {
    "id": "item_3801",
    "Last Name": "Hu",
    "First Name": "Yiye",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44573711": {
    "id": "item_27542",
    "Last Name": "Malhi",
    "First Name": "Shera",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44574437": {
    "id": "item_1906",
    "Last Name": "Bermingham",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44576523": {
    "id": "item_1907",
    "Last Name": "Rohan",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44578630": {
    "id": "item_14712",
    "Last Name": "Moya",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44579610": {
    "id": "item_31223",
    "Last Name": "Morris",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44581768": {
    "id": "item_14713",
    "Last Name": "Gennadiy",
    "First Name": "Chyzhykov",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44618412": {
    "id": "item_14714",
    "Last Name": "Fisher",
    "First Name": "Sydney",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44619220": {
    "id": "item_14715",
    "Last Name": "Maldonado",
    "First Name": "Ana Paula",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44619637": {
    "id": "item_3802",
    "Last Name": "Sinclair",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44622461": {
    "id": "item_3803",
    "Last Name": "Tan",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44622605": {
    "id": "item_16634",
    "Last Name": "Van Oijen",
    "First Name": "Sebastiaan",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44623234": {
    "id": "item_27543",
    "Last Name": "Horo",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44626805": {
    "id": "item_1908",
    "Last Name": "Staite",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44640081": {
    "id": "item_1909",
    "Last Name": "Ahmed",
    "First Name": "Maan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44646661": {
    "id": "item_29460",
    "Last Name": "Scarborough",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44648566": {
    "id": "item_27544",
    "Last Name": "Kennedy",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44649903": {
    "id": "item_3804",
    "Last Name": "Moskowitz",
    "First Name": "Ram",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44650060": {
    "id": "item_1910",
    "Last Name": "lang",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44651541": {
    "id": "item_27545",
    "Last Name": "Palmer",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44651863": {
    "id": "item_27546",
    "Last Name": "CHUN",
    "First Name": "HYUNG MIN",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44652885": {
    "id": "item_14716",
    "Last Name": "McCarthy",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44653507": {
    "id": "item_29461",
    "Last Name": "Davey",
    "First Name": "Jay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44653556": {
    "id": "item_16635",
    "Last Name": "Marshall",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44653557": {
    "id": "item_16636",
    "Last Name": "Marshall",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44654189": {
    "id": "item_27547",
    "Last Name": "Wyllie",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44654251": {
    "id": "item_27548",
    "Last Name": "Catubig",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44655363": {
    "id": "item_3805",
    "Last Name": "Jisam",
    "First Name": "Moon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44655738": {
    "id": "item_16637",
    "Last Name": "CHO",
    "First Name": "HAEYEONG",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44656166": {
    "id": "item_14717",
    "Last Name": "O'Leary",
    "First Name": "Shanae",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44657857": {
    "id": "item_3806",
    "Last Name": "JEONG",
    "First Name": "MINGI",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44658175": {
    "id": "item_27549",
    "Last Name": "Song",
    "First Name": "Jae Joon",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44660181": {
    "id": "item_14718",
    "Last Name": "Gray",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44688524": {
    "id": "item_3807",
    "Last Name": "Haughey",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44689338": {
    "id": "item_14719",
    "Last Name": "Barrett",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44692648": {
    "id": "item_27550",
    "Last Name": "Goland",
    "First Name": "Adele",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44718108": {
    "id": "item_27551",
    "Last Name": "Restar",
    "First Name": "Arjee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44722452": {
    "id": "item_27552",
    "Last Name": "Hobson",
    "First Name": "Heather",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44802561": {
    "id": "item_29462",
    "Last Name": "Beekharry",
    "First Name": "Desiree",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44803485": {
    "id": "item_29463",
    "Last Name": "Perry",
    "First Name": "Floyd",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44804080": {
    "id": "item_1911",
    "Last Name": "Louis",
    "First Name": "Kendrick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44804809": {
    "id": "item_14720",
    "Last Name": "Bronson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44806036": {
    "id": "item_14721",
    "Last Name": "Byrne",
    "First Name": "Job Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44807661": {
    "id": "item_27553",
    "Last Name": "MILLER",
    "First Name": "ZHEN ZHANG",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44808346": {
    "id": "item_29464",
    "Last Name": "Hunter",
    "First Name": "Ally",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44810856": {
    "id": "item_27554",
    "Last Name": "Amedeo",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44811139": {
    "id": "item_16638",
    "Last Name": "Jaramillo",
    "First Name": "Tannia",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44811233": {
    "id": "item_1912",
    "Last Name": "Schaeffer",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44821949": {
    "id": "item_29465",
    "Last Name": "Sennett",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44893081": {
    "id": "item_14722",
    "Last Name": "Park",
    "First Name": "Eunkyung",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44951509": {
    "id": "item_3808",
    "Last Name": "Chan",
    "First Name": "Tyconor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44963407": {
    "id": "item_16639",
    "Last Name": "Fu",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44963483": {
    "id": "item_29466",
    "Last Name": "Black",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44965487": {
    "id": "item_16640",
    "Last Name": "Nicholls",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44965888": {
    "id": "item_16641",
    "Last Name": "Syahputra",
    "First Name": "Firman",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44966235": {
    "id": "item_16642",
    "Last Name": "CHU",
    "First Name": "Yuen Man Lisa",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44967040": {
    "id": "item_1913",
    "Last Name": "Jones",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45010183": {
    "id": "item_27555",
    "Last Name": "Miller",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45042265": {
    "id": "item_14723",
    "Last Name": "Cavey",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45118945": {
    "id": "item_1914",
    "Last Name": "Andreasen",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45121252": {
    "id": "item_3809",
    "Last Name": "Torda",
    "First Name": "Adrienne",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45131296": {
    "id": "item_29467",
    "Last Name": "Wallace",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45131333": {
    "id": "item_29468",
    "Last Name": "Hunt",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45131631": {
    "id": "item_14724",
    "Last Name": "Howse",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45132228": {
    "id": "item_3810",
    "Last Name": "Cunningham-Reid",
    "First Name": "Kit",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45132317": {
    "id": "item_1915",
    "Last Name": "Cripps",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45132922": {
    "id": "item_27556",
    "Last Name": "Langridge",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45133873": {
    "id": "item_14725",
    "Last Name": "van Strien",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45134624": {
    "id": "item_18576",
    "Last Name": "CHOI",
    "First Name": "SEUNG HO",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45134774": {
    "id": "item_18577",
    "Last Name": "IM",
    "First Name": "SUNG BIN",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45157353": {
    "id": "item_14726",
    "Last Name": "Raynard",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45205235": {
    "id": "item_3811",
    "Last Name": "Maeder",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45205496": {
    "id": "item_3812",
    "Last Name": "Shultz",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45205755": {
    "id": "item_3813",
    "Last Name": "Cavey",
    "First Name": "Kali",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45207773": {
    "id": "item_27557",
    "Last Name": "Miller",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45207877": {
    "id": "item_27558",
    "Last Name": "Leonard",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45208123": {
    "id": "item_1916",
    "Last Name": "Wing-Evans",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45208391": {
    "id": "item_14727",
    "Last Name": "Sayoc",
    "First Name": "Addison",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45208595": {
    "id": "item_1917",
    "Last Name": "Frame",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45209419": {
    "id": "item_3814",
    "Last Name": "Scotland",
    "First Name": "Scarlett",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45209568": {
    "id": "item_3815",
    "Last Name": "Scott",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45209741": {
    "id": "item_16643",
    "Last Name": "Cieply",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45212626": {
    "id": "item_3816",
    "Last Name": "Whiteley",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45213877": {
    "id": "item_27559",
    "Last Name": "Hewitt",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45214477": {
    "id": "item_14728",
    "Last Name": "Krawitz",
    "First Name": "Lilli",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45214606": {
    "id": "item_27560",
    "Last Name": "Clark",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45214609": {
    "id": "item_27561",
    "Last Name": "Endo",
    "First Name": "Yui",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45214927": {
    "id": "item_27562",
    "Last Name": "Hemers",
    "First Name": "Sherilee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45217808": {
    "id": "item_29469",
    "Last Name": "Hodgson",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45217837": {
    "id": "item_3817",
    "Last Name": "Wood",
    "First Name": "Adelle",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45217938": {
    "id": "item_27563",
    "Last Name": "Mathias",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45217998": {
    "id": "item_3818",
    "Last Name": "Dempsey",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45219782": {
    "id": "item_27564",
    "Last Name": "Koch",
    "First Name": "Julius",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45220014": {
    "id": "item_3819",
    "Last Name": "Wood",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45220316": {
    "id": "item_29470",
    "Last Name": "Wood",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45220502": {
    "id": "item_3820",
    "Last Name": "Scully",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45220749": {
    "id": "item_3821",
    "Last Name": "Behan",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45221718": {
    "id": "item_29471",
    "Last Name": "Fielding",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45222001": {
    "id": "item_3822",
    "Last Name": "Gunn",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45222434": {
    "id": "item_3823",
    "Last Name": "Schmidt",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45258897": {
    "id": "item_27565",
    "Last Name": "Gould",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45259055": {
    "id": "item_27566",
    "Last Name": "Stevenson",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45259780": {
    "id": "item_29472",
    "Last Name": "Potorti",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45285173": {
    "id": "item_29473",
    "Last Name": "Abraham",
    "First Name": "Zola",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45286402": {
    "id": "item_1918",
    "Last Name": "Chaffey",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45286476": {
    "id": "item_16644",
    "Last Name": "Hateley",
    "First Name": "Delta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45286502": {
    "id": "item_14729",
    "Last Name": "Van Wettering",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45287650": {
    "id": "item_29474",
    "Last Name": "Colquitt",
    "First Name": "Vaughn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45287889": {
    "id": "item_1919",
    "Last Name": "kettley",
    "First Name": "stephen",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45292966": {
    "id": "item_31224",
    "Last Name": "Hodder",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45293075": {
    "id": "item_3824",
    "Last Name": "Wilson",
    "First Name": "Ewan",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294073": {
    "id": "item_14730",
    "Last Name": "Doherty",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294710": {
    "id": "item_14731",
    "Last Name": "McGrath",
    "First Name": "Fionna",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294741": {
    "id": "item_29475",
    "Last Name": "Barnes",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294799": {
    "id": "item_29476",
    "Last Name": "Switzer",
    "First Name": "Renee",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294871": {
    "id": "item_29477",
    "Last Name": "Simms",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45296097": {
    "id": "item_1920",
    "Last Name": "Christie",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45296139": {
    "id": "item_3825",
    "Last Name": "SCHEEPERS",
    "First Name": "ANN-LOUISE",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45296472": {
    "id": "item_14732",
    "Last Name": "Kaur",
    "First Name": "Amreeta",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45297225": {
    "id": "item_14733",
    "Last Name": "Mead",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45299639": {
    "id": "item_1921",
    "Last Name": "Crean",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45327803": {
    "id": "item_29478",
    "Last Name": "Mckenzie",
    "First Name": "Zea",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45339863": {
    "id": "item_29479",
    "Last Name": "Brescianini",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45340719": {
    "id": "item_29480",
    "Last Name": "Curukovski",
    "First Name": "Filip",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45344523": {
    "id": "item_3826",
    "Last Name": "Blundell",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45345168": {
    "id": "item_31225",
    "Last Name": "Stevens",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute E",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45389907": {
    "id": "item_3827",
    "Last Name": "Randazzo",
    "First Name": "Francis",
    "Marathon Waves": "Start group 1 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45399139": {
    "id": "item_14734",
    "Last Name": "Krok",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Green Assembly - Entry Chute C",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "5:45 AM",
    "ENTRY CHUTE TIME": "6:40 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45403091": {
    "id": "item_29481",
    "Last Name": "Perry",
    "First Name": "Ashlyn",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45404635": {
    "id": "item_29482",
    "Last Name": "Benham-Gestal",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Green Assembly - Entry Chute D",
    "assemblyPoint": "Green Assembly",
    "startingPoint": "Crows Nest Station",
    "routeStartCoordinates": [
      -33.8252778,
      151.1994444
    ],
    "TRAIN STATION": "Change from Train to Metro",
    "TRAIN STATION Coordinates": null,
    "assemblyCoordinates": [
      -33.8291667,
      151.2094444
    ],
    "assemblyCoordinates_2": null,
    "ARRIVAL Time": "6:40 AM",
    "ENTRY CHUTE TIME": "7:15 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  }
};